webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(800);
	__webpack_require__(726);
	module.exports = __webpack_require__(787);


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CycleFetch = exports.api = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _session = __webpack_require__(30);
	
	var session = _interopRequireWildcard(_session);
	
	var _telematics = __webpack_require__(782);
	
	var telematics = _interopRequireWildcard(_telematics);
	
	var _organizational_units = __webpack_require__(777);
	
	var organizational_units = _interopRequireWildcard(_organizational_units);
	
	var _portal = __webpack_require__(778);
	
	var portal = _interopRequireWildcard(_portal);
	
	var _geo = __webpack_require__(774);
	
	var geo = _interopRequireWildcard(_geo);
	
	var _vehicles = __webpack_require__(783);
	
	var vehicles = _interopRequireWildcard(_vehicles);
	
	var _routing = __webpack_require__(780);
	
	var routing = _interopRequireWildcard(_routing);
	
	var _storage = __webpack_require__(781);
	
	var storage = _interopRequireWildcard(_storage);
	
	var _mobile = __webpack_require__(776);
	
	var mobile = _interopRequireWildcard(_mobile);
	
	var _dictionary = __webpack_require__(772);
	
	var dictionary = _interopRequireWildcard(_dictionary);
	
	var _garbage = __webpack_require__(773);
	
	var garbage = _interopRequireWildcard(_garbage);
	
	var _reports = __webpack_require__(779);
	
	var reports = _interopRequireWildcard(_reports);
	
	var _kurs = __webpack_require__(775);
	
	var kurs = _interopRequireWildcard(_kurs);
	
	var _auth = __webpack_require__(771);
	
	var auth = _interopRequireWildcard(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var api = exports.api = {
	    auth: {
	        getGuestToken: auth.getGuestToken
	    },
	    dictionary: {
	        getDictionaryList: dictionary.getDictionaryList,
	        getDictionaryLists: dictionary.getDictionaryLists
	    },
	    wsrpc: {
	        connectionLost: session.connectionLost,
	        connectionEstablished: session.connectionEstablished
	    },
	    reports: {
	        getTabletWorkSummary: reports.getTabletWorkSummary
	    },
	    kurs: {
	        getTasks: kurs.getTasks,
	        getTasksGuests: kurs.getTasksGuests,
	        getGeometryFromContract: kurs.getGeometryFromContract
	    },
	    telematics: {
	        getTelematicsWithDevices: telematics.getTelematicsWithDevices,
	        getTelematics: telematics.getTelematics,
	        getTelematicsTotalCount: telematics.getTelematicsTotalCount,
	        telematicsUpdateSubscribe: telematics.telematicsUpdateSubscribe,
	        telematicsUpdateUnsubscribe: telematics.telematicsUpdateUnsubscribe,
	        filtersUpdate: telematics.filtersUpdate
	    },
	    organizational_units: {
	        getCarriers: organizational_units.getCarriers,
	        getUnit: organizational_units.getUnit
	    },
	    geo: {
	        routing: geo.routing,
	        getClosestStopPoint: geo.getClosestStopPoint,
	        geocode: geo.geocode,
	        searchAddress: geo.searchAddress,
	        reverseGeocode: geo.reverseGeocode,
	        listLayers: geo.listLayers,
	        listUserGeoObjectsByLayers: geo.listUserGeoObjectsByLayers,
	        getStopPoints: geo.getStopPoints,
	        getStopPointRoutes: geo.getStopPointRoutes,
	        getStopPointRouteRuns: geo.getStopPointRouteRuns,
	        listUserGeoObjectsMO: geo.listUserGeoObjectsMO,
	        portalSchedule: geo.portalSchedule,
	        portalScheduleExtended: geo.portalScheduleExtended,
	        portalScheduleRoute: geo.portalScheduleRoute
	    },
	    vehicles: {
	        getVehicleList: vehicles.getVehicleList,
	        getVehicleListGuest: vehicles.getVehicleListGuest
	    },
	    portal: {
	        getNews: portal.getNews,
	        getNewsItem: portal.getNewsItem,
	        getFaq: portal.getFaq,
	        getPage: portal.getPage,
	        sendFeedback: portal.sendFeedback,
	        getCaptcha: portal.getCaptcha,
	        checkRegisterRequestCreate: portal.checkRegisterRequestCreate,
	        createRegisterRequest: portal.createRegisterRequest,
	        getRegisterRequest: portal.getRegisterRequest,
	        updateRegisterRequest: portal.updateRegisterRequest,
	        loginRegisterRequest: portal.loginRegisterRequest,
	        getTags: portal.getTags
	    },
	    routing: {
	        find: routing.find
	    },
	    storage: {
	        getUploadToken: storage.getUploadToken,
	        uploadFile: storage.uploadFile
	    },
	    mobile: {
	        confirmEmailCheck: mobile.confirmEmailCheck,
	        confirmEmailChangeCheck: mobile.confirmEmailChangeCheck
	    },
	    garbage: {
	        getObjects: garbage.getObjects
	    }
	};
	
	var CycleFetch = exports.CycleFetch = function () {
	    function CycleFetch(fetchResult, cb) {
	        var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
	
	        _classCallCheck(this, CycleFetch);
	
	        this._fetch = fetchResult;
	        this._onFetched = cb;
	        this._delay = delay;
	        this._runned = true;
	        this._timeout = null;
	    }
	
	    _createClass(CycleFetch, [{
	        key: 'run',
	        value: function run() {
	            this._fetchOne();
	        }
	    }, {
	        key: 'forceNext',
	        value: function forceNext() {
	            if (this._timeout) this._timeout = clearTimeout(this._timeout);
	
	            this._fetchOne();
	        }
	    }, {
	        key: 'forceNextWithDelay',
	        value: function forceNextWithDelay(delay) {
	            if (this._timeout) this._timeout = clearTimeout(this._timeout);
	
	            this._next(delay);
	        }
	    }, {
	        key: '_fetchOne',
	        value: function _fetchOne() {
	            var _this = this;
	
	            if (!this._runned) return;
	
	            var fetchResult = this._fetch();
	            if (fetchResult === null) {
	                this.forceNextWithDelay(200);
	            } else {
	                fetchResult.then(function (result) {
	                    if (!_this._runned) return;
	
	                    _this._onFetched(result);
	                    _this._next();
	                }).catch(function () {
	                    if (_this._runned) _this._next();
	                });
	            }
	        }
	    }, {
	        key: '_next',
	        value: function _next() {
	            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (this._timeout) this._timeout = clearTimeout(this._timeout);
	
	            this._timeout = setTimeout(this._fetchOne.bind(this), delay || this._delay);
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this._runned = false;
	            if (this._timeout) this._timeout = clearTimeout(this._timeout);
	        }
	    }]);

	    return CycleFetch;
	}();

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    DATE: 'DD.MM.YYYY',
	    DATETIME: 'DD.MM.YYYY HH:mm:ss',
	    DATETIME_SHORT: 'DD.MM.YYYY HH:mm',
	    DATE_API: 'YYYY-MM-DDT00:00:00Z',
	    DATETIME_API: 'YYYY-MM-DDTHH:mm:ssZ',
	    TIME: 'HH:mm'
	};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeResponse = exports.error = exports.success = undefined;
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var makeResponse = exports.makeResponse = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callback) {
	        var response;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return callback();
	
	                    case 3:
	                        response = _context.sent;
	                        return _context.abrupt('return', success(response));
	
	                    case 7:
	                        _context.prev = 7;
	                        _context.t0 = _context['catch'](0);
	                        return _context.abrupt('return', error(_context.t0));
	
	                    case 10:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[0, 7]]);
	    }));
	
	    return function makeResponse(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _errors = __webpack_require__(784);
	
	var _validation = __webpack_require__(785);
	
	var validation = _interopRequireWildcard(_validation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Response = function () {
	    function Response(response) {
	        _classCallCheck(this, Response);
	
	        this.__response = response;
	    }
	
	    /**
	     * @return {Object}
	     */
	
	
	    _createClass(Response, [{
	        key: 'get',
	
	
	        /**
	         * @param {string} key
	         */
	        value: function get(key) {
	            return (0, _get3.default)(this.__response, key);
	        }
	
	        /**
	         * @return {string}
	         */
	
	    }, {
	        key: 'showErrors',
	        value: function showErrors() {}
	    }, {
	        key: 'data',
	        get: function get() {
	            return this.__response;
	        }
	
	        /**
	         * @return {Object}
	         */
	
	    }, {
	        key: 'payload',
	        get: function get() {
	            return this.data.payload;
	        }
	
	        /**
	         * @return {Object}
	         */
	
	    }, {
	        key: 'headers',
	        get: function get() {
	            return this.data.headers;
	        }
	    }, {
	        key: 'status',
	        get: function get() {
	            return 'ok';
	        }
	
	        /**
	         * @return {boolean}
	         */
	
	    }, {
	        key: 'isOk',
	        get: function get() {
	            return true;
	        }
	
	        /**
	         * @return {boolean}
	         */
	
	    }, {
	        key: 'hasErrors',
	        get: function get() {
	            return false;
	        }
	    }]);
	
	    return Response;
	}();
	
	var ErrorResponse = function (_Response) {
	    _inherits(ErrorResponse, _Response);
	
	    function ErrorResponse(response) {
	        _classCallCheck(this, ErrorResponse);
	
	        return _possibleConstructorReturn(this, (ErrorResponse.__proto__ || Object.getPrototypeOf(ErrorResponse)).call(this, response));
	    }
	
	    /**
	     * @return {boolean}
	     */
	
	
	    _createClass(ErrorResponse, [{
	        key: 'hasErrorWithCode',
	
	
	        /**
	         * @param {string} code
	         * @return {boolean}
	         */
	        value: function hasErrorWithCode(code) {
	            return (0, _filter3.default)(this.errors, function (error) {
	                return error.code === code;
	            }).length > 0;
	        }
	
	        /**
	         * Показать ошибки
	         */
	
	    }, {
	        key: 'showErrors',
	        value: function showErrors() {
	            (0, _errors.showError)(this);
	        }
	    }, {
	        key: 'isOk',
	        get: function get() {
	            return false;
	        }
	
	        /**
	         * @return {string}
	         */
	
	    }, {
	        key: 'status',
	        get: function get() {
	            return 'error';
	        }
	
	        /**
	         * @return {boolean}
	         */
	
	    }, {
	        key: 'hasErrors',
	        get: function get() {
	            return true;
	        }
	
	        /**
	         * @return {Array}
	         */
	
	    }, {
	        key: 'errors',
	        get: function get() {
	            return this.__response.errors;
	        }
	    }, {
	        key: 'validationErrors',
	        get: function get() {
	            return validation.getErrors(this);
	        }
	    }]);
	
	    return ErrorResponse;
	}(Response);
	
	var success = exports.success = function success(data) {
	    return new Response(data);
	};
	var error = exports.error = function error(_error) {
	    return new ErrorResponse(_error);
	};
	
	;
	
	// const success = response => ({status: 'ok', data: response});
	// const error = error => ({status: 'error', error: error});

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _loader = __webpack_require__(371);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1093);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GlobalLoaderComponent = (_dec = (0, _reactPropsDecorators.propTypes)({
	    style: _propTypes2.default.object,
	    block: _propTypes2.default.bool
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    block: true
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(GlobalLoaderComponent, _Component);
	
	    function GlobalLoaderComponent() {
	        _classCallCheck(this, GlobalLoaderComponent);
	
	        return _possibleConstructorReturn(this, (GlobalLoaderComponent.__proto__ || Object.getPrototypeOf(GlobalLoaderComponent)).apply(this, arguments));
	    }
	
	    _createClass(GlobalLoaderComponent, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('GlobalLoader', this.props.block ? 'blocked' : 'not-blocked');
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, style: this.props.style },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_loader2.default, { color: 'red', size: 64 })
	                )
	            );
	        }
	    }]);
	
	    return GlobalLoaderComponent;
	}(_react.Component)) || _class) || _class);
	exports.default = GlobalLoaderComponent;

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.postData = exports.request = exports.connectionEstablished = exports.connectionLost = exports.connect = exports.rpc = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var connect = exports.connect = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        return _context.abrupt("return", rpc.connect());
	
	                    case 1:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function connect() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var connectionLost = exports.connectionLost = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(callback) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return rpc.onLost(callback);
	
	                    case 2:
	                    case "end":
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function connectionLost(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var connectionEstablished = exports.connectionEstablished = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(callback) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.next = 2;
	                        return rpc.onEstablished(callback);
	
	                    case 2:
	                    case "end":
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function connectionEstablished(_x2) {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	var request = exports.request = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(method) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	        }
	
	        var response;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        _context4.next = 2;
	                        return (0, _response.makeResponse)(function () {
	                            return rpc.request.apply(rpc, [method].concat(args));
	                        });
	
	                    case 2:
	                        response = _context4.sent;
	                        return _context4.abrupt("return", response);
	
	                    case 4:
	                    case "end":
	                        return _context4.stop();
	                }
	            }
	        }, _callee4, this);
	    }));
	
	    return function request(_x3) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var postData = exports.postData = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        var token = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	        var basicUrl, response;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	                        basicUrl = window.RNIS_SETTINGS.isHTTP ? "http://" + (0, _wsrpc.getHostName)('ajax') + "/request?" : "https://" + (0, _wsrpc.getHostName)('ajax') + "/request?";
	                        _context5.next = 3;
	                        return fetch("" + basicUrl + url, {
	                            method: 'POST',
	                            body: JSON.stringify(_extends({ headers: {
	                                    'meta': meta,
	                                    'token': token
	                                } }, data))
	                        });
	
	                    case 3:
	                        response = _context5.sent;
	                        _context5.next = 6;
	                        return response.json();
	
	                    case 6:
	                        return _context5.abrupt("return", _context5.sent);
	
	                    case 7:
	                    case "end":
	                        return _context5.stop();
	                }
	            }
	        }, _callee5, this);
	    }));
	
	    return function postData() {
	        return _ref5.apply(this, arguments);
	    };
	}();
	
	var _storage = __webpack_require__(392);
	
	var storage = _interopRequireWildcard(_storage);
	
	var _wsrpc = __webpack_require__(786);
	
	var _response = __webpack_require__(23);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var credits = storage.get('user');
	
	var token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJSTklTIiwiYXVkIjoiaHR0cDpcL1wvcm5pcy5jb20iLCJpYXQiOjE2MDkyNTYyOTgsIm5iZiI6MTYwOTE2OTg5OCwiaW5mbyI6IntcInVzZXJcIjp7XCJ1dWlkXCI6XCIxMjQ2ZDFiOC0yYjM3LTExZWItYmY2Zi0wMjUyZTc4ZDkwZDlcIixcImxvZ2luXCI6XCJiYXNoa2F0b3ZhXCIsXCJjb21wb25lbnRcIjpcIm9wZXJhdG9yXCIsXCJpc19zeXN0ZW1cIjpmYWxzZSxcImlzX3N1cGVydmlzb3JcIjpmYWxzZSxcImlzX3NlbWlfY29uZmlybWVkXCI6ZmFsc2UsXCJpc19ub3RpZmljYXRlZFwiOmZhbHNlLFwiaW5mb1wiOnt9fX0ifQ.ko2FdInAWl9-JZyxOO7yFARvL_z9JsMdF4YjiaUr9rU';
	
	if (!window.RNIS_SETTINGS) {
	    _jquery2.default.ajax({
	        dataType: 'json',
	        url: window.location.origin + "/static/settings/settings.json",
	        async: false,
	        success: function success(data) {
	            window.RNIS_SETTINGS = data;
	        }
	    });
	}
	
	if (!window.RNIS_SETTINGS.CITY_MURMANSK && !window.RNIS_SETTINGS.CITY_OMSK) {
	    token = '';
	}
	
	if (credits && credits.token) {
	    token = credits.token;
	}
	
	var rpc = exports.rpc = (0, _wsrpc.createConnection)(token);

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _leftSide = __webpack_require__(754);
	
	var _leftSide2 = _interopRequireDefault(_leftSide);
	
	var _pageHeader = __webpack_require__(378);
	
	var _pageHeader2 = _interopRequireDefault(_pageHeader);
	
	__webpack_require__(1119);
	
	__webpack_require__(1118);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _functions = __webpack_require__(189);
	
	__webpack_require__(1109);
	
	var _feedback = __webpack_require__(368);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageComponent = (_dec = (0, _reactPropsDecorators.propTypes)({
	    pageId: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    title: _propTypes2.default.string.isRequired,
	    headerActions: _propTypes2.default.array,
	    headerContents: _propTypes2.default.array,
	    showHeader: _propTypes2.default.bool
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    pageId: 'Main',
	    className: '',
	    headerActions: [],
	    headerContents: [],
	    showHeader: true
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(PageComponent, _Component);
	
	    function PageComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PageComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageComponent.__proto__ || Object.getPrototypeOf(PageComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showFeedback: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PageComponent, [{
	        key: 'render',
	        value: function render() {
	            var menu = [];
	            if (window.RNIS_SETTINGS.CUSTOMMENU === false || window.RNIS_SETTINGS.CUSTOMMENU === undefined || window.RNIS_SETTINGS.CUSTOMMENU === "undefined") {
	                menu = [{
	                    text: 'Новости',
	                    class: 'news',
	                    route: '/'
	                }, {
	                    text: 'Пассажирские перевозки',
	                    class: 'passenger',
	                    key: 'passenger',
	                    submenu: [{
	                        text: 'Забытые вещи',
	                        class: 'forgotten-things',
	                        route: '/page/forgotten'
	                    }, {
	                        text: 'Информация',
	                        class: 'information',
	                        route: '/page/info'
	                    }, {
	                        text: 'Перевозчики',
	                        class: 'carrier',
	                        route: '/carriers'
	                    }, {
	                        text: 'Расписания',
	                        class: 'schedule',
	                        route: '/schedule'
	                    }]
	                }, {
	                    text: 'Обслуживание дорог',
	                    class: 'road',
	                    route: '/map/road'
	                }, {
	                    text: 'Вывоз мусора',
	                    class: 'waste',
	                    route: '/map/garbage'
	                }, {
	                    text: 'Вопрос-ответ',
	                    class: 'faq',
	                    route: '/faq'
	                }, {
	                    text: 'Подключение к РНИС МО',
	                    class: 'connection',
	                    key: 'connection',
	                    submenu: [{
	                        text: 'Подключение к РНИС МО',
	                        class: 'connection',
	                        route: '/page/connection'
	                    }, {
	                        text: 'Нормативная и справочная информация',
	                        class: 'nsi',
	                        route: '/page/nsi'
	                    }, {
	                        text: 'Контакты',
	                        class: 'phone',
	                        route: '/page/contacts'
	                    }]
	                },
	                /*{
	                    text: 'Скоро',
	                    class: 'soon',
	                    key: 'soon',
	                    submenu: [
	                        {
	                            text: 'Перевозки детей',
	                            class: 'children',
	                            route: '/soon/children',
	                        },
	                    ]
	                },*/
	                {
	                    text: 'Обратная связь',
	                    class: 'contact',
	                    route: '/feedback',
	                    onClick: this.onFeedbackClick.bind(this)
	                }, {
	                    text: 'Добродел',
	                    class: 'dobrodel',
	                    href: 'https://dobrodel.mosreg.ru/'
	                }];
	                if (window.RNIS_SETTINGS.CITY_OMSK) {
	                    menu = menu.map(function (menuItem) {
	                        if (menuItem.key === 'passenger') {
	                            menuItem.submenu.splice(0, 0, {
	                                text: 'Карта',
	                                class: 'map',
	                                route: '/map/bus'
	                            });
	                        }
	                        return menuItem;
	                    });
	                } else {
	                    menu.splice(1, 0, {
	                        text: 'Карта',
	                        class: 'map',
	                        route: '/map/bus'
	                    });
	                }
	            }
	
	            if (window.RNIS_SETTINGS.CUSTOMMENU) {
	                var a = window.RNIS_SETTINGS.CUSTOMMENUSTATE;
	                menu = [(0, _functions.find)(a, ['text', 'Новости']).show ? {
	                    text: 'Новости',
	                    class: 'news',
	                    route: '/'
	                } : null, (0, _functions.find)(a, ['text', 'Карта']).show ? {
	                    text: 'Карта',
	                    class: 'map',
	                    route: '/map/bus'
	                } : null, (0, _functions.find)(a, ['text', 'Пассажирские перевозки']).show ? {
	                    text: 'Пассажирские перевозки',
	                    class: 'passenger',
	                    key: 'passenger',
	                    submenu: [(0, _functions.find)(a, ['text', 'Пассажирские перевозки']).submenu[0].show ? {
	                        text: 'Карта',
	                        class: 'map',
	                        route: '/kiutr/map'
	                    } : null, (0, _functions.find)(a, ['text', 'Пассажирские перевозки']).submenu[1].show ? {
	                        text: 'Забытые вещи',
	                        class: 'forgotten-things',
	                        route: '/page/forgotten'
	                    } : null, (0, _functions.find)(a, ['text', 'Пассажирские перевозки']).submenu[2].show ? {
	                        text: 'Информация',
	                        class: 'information',
	                        route: '/page/info'
	                    } : null, (0, _functions.find)(a, ['text', 'Пассажирские перевозки']).submenu[3].show ? {
	                        text: 'Перевозчики',
	                        class: 'carrier',
	                        route: '/carriers'
	                    } : null, (0, _functions.find)(a, ['text', 'Пассажирские перевозки']).submenu[4].show ? {
	                        text: 'Расписания',
	                        class: 'schedule',
	                        route: '/schedule'
	                    } : null]
	                } : null, (0, _functions.find)(a, ['text', 'Обслуживание дорог']).show ? {
	                    text: 'Обслуживание дорог',
	                    class: 'road',
	                    route: '/map/road'
	                } : null, (0, _functions.find)(a, ['text', 'Вывоз мусора']).show ? {
	                    text: 'Вывоз мусора',
	                    class: 'waste',
	                    route: '/map/garbage'
	                } : null, (0, _functions.find)(a, ['text', 'Коммунальная техника']).show ? {
	                    text: 'Коммунальная техника',
	                    class: 'communal',
	                    route: '/map/communal'
	                } : null, (0, _functions.find)(a, ['text', 'Вопрос-ответ']).show ? {
	                    text: 'Вопрос-ответ',
	                    class: 'faq',
	                    route: '/faq'
	                } : null, (0, _functions.find)(a, ['text', '\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A ' + window.RNIS_SETTINGS.SHORT_TITLE]).show ? {
	                    text: '\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A ' + window.RNIS_SETTINGS.SHORT_TITLE,
	                    class: 'connection',
	                    key: 'connection',
	                    submenu: [(0, _functions.find)(a, ['text', '\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A ' + window.RNIS_SETTINGS.SHORT_TITLE]).submenu[0].show ? {
	                        text: '\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A ' + window.RNIS_SETTINGS.SHORT_TITLE,
	                        class: 'connection',
	                        route: '/page/connection'
	                    } : null, (0, _functions.find)(a, ['text', '\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A ' + window.RNIS_SETTINGS.SHORT_TITLE]).submenu[1].show ? {
	                        text: 'Нормативная и справочная информация',
	                        class: 'nsi',
	                        route: '/page/nsi'
	                    } : null, (0, _functions.find)(a, ['text', '\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A ' + window.RNIS_SETTINGS.SHORT_TITLE]).submenu[2].show ? {
	                        text: 'Контакты',
	                        class: 'phone',
	                        route: '/page/contacts'
	                    } : null]
	                } : null,
	                /*{
	                    text: 'Скоро',
	                    class: 'soon',
	                    key: 'soon',
	                    submenu: [
	                        {
	                            text: 'Перевозки детей',
	                            class: 'children',
	                            route: '/soon/children',
	                        },
	                    ]
	                },*/
	                (0, _functions.find)(a, ['text', 'Обратная связь']).show ? {
	                    text: 'Обратная связь',
	                    class: 'contact',
	                    route: '/feedback',
	                    onClick: this.onFeedbackClick.bind(this)
	                } : null, (0, _functions.find)(a, ['text', 'Добродел']).show ? {
	                    text: 'Добродел',
	                    class: 'dobrodel',
	                    href: 'https://dobrodel.mosreg.ru/'
	                } : null];
	            }
	
	            var header = this.props.showHeader ? _react2.default.createElement(_pageHeader2.default, {
	                ref: 'header',
	                title: this.props.title,
	                actions: this.props.headerActions,
	                contents: this.props.headerContents }) : '';
	
	            var className = (0, _classnames2.default)('page', this.props.showHeader ? 'with-page-header' : '');
	
	            var feedback = this.state.showFeedback ? _react2.default.createElement(_feedback2.default, {
	                onClose: this.feedbackClose.bind(this)
	            }) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: 'container', className: className },
	                header,
	                _react2.default.createElement(_leftSide2.default, { menu: menu }),
	                feedback,
	                _react2.default.createElement(
	                    'div',
	                    { id: this.props.pageId, className: (0, _classnames2.default)('r-block', this.props.className) },
	                    this.props.children
	                )
	            );
	        }
	    }, {
	        key: 'onFeedbackClick',
	        value: function onFeedbackClick(e) {
	            var _this2 = this;
	
	            e && e.preventDefault();
	
	            this.setState({
	                showFeedback: true
	            });
	            (0, _jquery2.default)(document).on('keyup', function (e) {
	                if (e.keyCode === 27) {
	                    _this2.feedbackClose();
	                }
	            });
	        }
	    }, {
	        key: 'feedbackClose',
	        value: function feedbackClose() {
	            this.setState({
	                showFeedback: false
	            });
	            (0, _jquery2.default)(document).off('keyup');
	        }
	    }, {
	        key: 'onDemoClick',
	        value: function onDemoClick(e) {
	            e.preventDefault();
	
	            alerts.alert('Находится в разработке');
	        }
	    }]);
	
	    return PageComponent;
	}(_react.Component)) || _class) || _class);
	exports.default = PageComponent;

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.error = exports.confirm = exports.alert = exports.success = exports.close = exports.prompt = undefined;
	
	var prompt = exports.prompt = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(title, text, callback) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        return _context.abrupt('return', (0, _sweetalert2.default)({
	                            title: title,
	                            text: text,
	                            type: 'warning',
	                            showCancelButton: true,
	                            confirmButtonColor: '#FF5C55',
	                            cancelButtonColor: '#8a8e92',
	                            confirmButtonText: 'Удалить',
	                            cancelButtonText: 'Отменить'
	                        }).then(function () {
	                            callback();
	                        }));
	
	                    case 1:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function prompt(_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var close = exports.close = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        return _context2.abrupt('return', _sweetalert2.default.close());
	
	                    case 1:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function close() {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var success = exports.success = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(title) {
	        var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        return _context3.abrupt('return', (0, _sweetalert2.default)({
	                            title: title,
	                            text: text,
	                            type: 'success',
	                            confirmButtonColor: '#FF5C55',
	                            confirmButtonText: 'ОК'
	                        }).then(function () {
	                            callback && callback();
	                        }));
	
	                    case 1:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function success(_x4) {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	var alert = exports.alert = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(title) {
	        var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        return _context4.abrupt('return', (0, _sweetalert2.default)({
	                            title: title,
	                            text: text,
	                            type: 'info',
	                            confirmButtonColor: '#FF5C55',
	                            confirmButtonText: 'ОК'
	                        }));
	
	                    case 1:
	                    case 'end':
	                        return _context4.stop();
	                }
	            }
	        }, _callee4, this);
	    }));
	
	    return function alert(_x7) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var confirm = exports.confirm = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(title, callback) {
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	                        return _context5.abrupt('return', (0, _sweetalert2.default)({
	                            title: title,
	                            text: '',
	                            type: 'warning',
	                            showCancelButton: true,
	                            cancelButtonText: 'Отменить',
	                            confirmButtonColor: '#FF5C55',
	                            confirmButtonText: 'ОК'
	                        }).then(callback));
	
	                    case 1:
	                    case 'end':
	                        return _context5.stop();
	                }
	            }
	        }, _callee5, this);
	    }));
	
	    return function confirm(_x9, _x10) {
	        return _ref5.apply(this, arguments);
	    };
	}();
	
	var error = exports.error = function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(html) {
	        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Ошибка';
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	            while (1) {
	                switch (_context6.prev = _context6.next) {
	                    case 0:
	                        return _context6.abrupt('return', (0, _sweetalert2.default)({
	                            title: title,
	                            html: html,
	                            type: 'error'
	                        }));
	
	                    case 1:
	                    case 'end':
	                        return _context6.stop();
	                }
	            }
	        }, _callee6, this);
	    }));
	
	    return function error(_x11) {
	        return _ref6.apply(this, arguments);
	    };
	}();
	
	var _sweetalert = __webpack_require__(724);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	__webpack_require__(1123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _isUndefined2 = __webpack_require__(510);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1099);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapVehicleIcon = (_dec = (0, _reactPropsDecorators.propTypes)({
	    device: _propTypes2.default.object.isRequired,
	    direction: _propTypes2.default.number
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(MapVehicleIcon, _Component);
	
	    function MapVehicleIcon() {
	        _classCallCheck(this, MapVehicleIcon);
	
	        return _possibleConstructorReturn(this, (MapVehicleIcon.__proto__ || Object.getPrototypeOf(MapVehicleIcon)).apply(this, arguments));
	    }
	
	    _createClass(MapVehicleIcon, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('marker__icon', 'icon-' + this.props.device.type);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('span', { className: className }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'marker__center' },
	                    !(0, _isUndefined3.default)(this.props.direction) ? _react2.default.createElement('span', { className: 'marker__direction', style: { transform: 'rotate(' + this.props.direction + 'deg)' } }) : null
	                )
	            );
	        }
	    }]);
	
	    return MapVehicleIcon;
	}(_react.Component)) || _class) || _class);
	exports.default = MapVehicleIcon;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectAsync = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelectPlus = __webpack_require__(242);
	
	var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);
	
	__webpack_require__(1121);
	
	__webpack_require__(1120);
	
	__webpack_require__(1112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var translations = {
	    addLabelText: 'Добавить "{label}"?',
	    backspaceToRemoveMessage: 'Нажмите backspace чтобы удалить {label}',
	    clearAllText: 'Очистить всё',
	    clearValueText: 'Удалить',
	    noResultsText: 'Не найдено',
	    placeholder: 'Выбрать...',
	    searchPromptText: 'Начните ввод для поиска',
	    loadingPlaceholder: 'Загрузка...'
	};
	
	// для русификации react-select делаем обертку
	
	var Select = function Select(props) {
	    return _react2.default.createElement(_reactSelectPlus2.default, _extends({}, translations, props));
	};
	Select.Async = function (props) {
	    return _react2.default.createElement(_reactSelectPlus2.default.Async, _extends({}, translations, props));
	};
	
	exports.default = Select;
	
	var SelectAsync = exports.SelectAsync = function (_Component) {
	    _inherits(SelectAsync, _Component);
	
	    function SelectAsync() {
	        _classCallCheck(this, SelectAsync);
	
	        return _possibleConstructorReturn(this, (SelectAsync.__proto__ || Object.getPrototypeOf(SelectAsync)).apply(this, arguments));
	    }
	
	    _createClass(SelectAsync, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reactSelectPlus2.default.Async, _extends({ ref: 'item', cache: false }, translations, this.props, { filterOptions: this.filterOptions.bind(this) }));
	        }
	    }, {
	        key: 'filterOptions',
	        value: function filterOptions(options) {
	            return options;
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.refs.item.focus();
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            this.refs.item.loadOptions('');
	        }
	    }]);
	
	    return SelectAsync;
	}(_react.Component);

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getNewsItem = exports.getTags = exports.getNews = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var getNews = exports.getNews = function getNews() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.portal.getNews(meta);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getTags = exports.getTags = function getTags() {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.portal.getTags();
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x5) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var getNewsItem = exports.getNewsItem = function getNewsItem(uuid) {
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _api.api.portal.getNewsItem(uuid);
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](0);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 128:
447,

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1085);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = (_dec = (0, _reactPropsDecorators.propTypes)({
	    text: _propTypes2.default.string,
	    size: _propTypes2.default.oneOf(['sm', 'md', 'lg']),
	    color: _propTypes2.default.oneOf(['white', 'red', 'green']),
	    shadow: _propTypes2.default.oneOf([null, 'gray', 'red']),
	    width: _propTypes2.default.oneOf([null, 'auto', 'full']),
	    disabled: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    size: 'sm',
	    color: 'red',
	    shadow: null,
	    width: null,
	    disabled: false,
	
	    onClick: function onClick() {}
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Button, _Component);
	
	    function Button() {
	        _classCallCheck(this, Button);
	
	        return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	    }
	
	    _createClass(Button, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('b-button', 'b-button_size_' + this.props.size, 'b-button_' + this.props.color, this.props.shadow ? 'b-button_shadow_' + this.props.shadow : '', this.props.width ? 'b-button_width_' + this.props.width : '', this.props.disabled ? 'b-button_disabled' : '', this.props.className);
	
	            var style = {};
	
	            if (this.props.fixWidth) style.width = this.props.fixWidth;
	
	            return _react2.default.createElement(
	                'a',
	                { className: className, type: 'button', onClick: this.onClick.bind(this) },
	                this.props.text
	            );
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick() {
	            if (!this.props.disabled) {
	                var _props;
	
	                (_props = this.props).onClick.apply(_props, arguments);
	            }
	        }
	    }]);
	
	    return Button;
	}(_react.Component)) || _class) || _class);
	exports.default = Button;

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reverseGeocode = exports.searchAddress = exports.geocode = exports.routing = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	var _user = __webpack_require__(382);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var routing = exports.routing = function routing(data) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.routing.find(data);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var geocode = exports.geocode = function geocode(q, boundingBox, zoom) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.geo.geocode(q, boundingBox, zoom);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var searchAddress = exports.searchAddress = function searchAddress(q, bounding_box, zoom) {
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _api.api.geo.searchAddress(q, bounding_box, zoom);
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](0);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x5) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};
	
	var reverseGeocode = exports.reverseGeocode = function reverseGeocode(coordinates, boundingBox, zoom) {
	    return function () {
	        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	                            _context4.next = 3;
	                            return _api.api.geo.reverseGeocode(coordinates, boundingBox, zoom);
	
	                        case 3:
	                            response = _context4.sent;
	                            return _context4.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context4.prev = 7;
	                            _context4.t0 = _context4['catch'](0);
	                            return _context4.abrupt('return', (0, _response.error)(_context4.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined, [[0, 7]]);
	        }));
	
	        return function (_x6) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getStopPointRouteRuns = exports.getStopPointRoutes = exports.getStopPointsWithBounds = exports.getClosestStopPoint = exports.getStopPoints = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getStopPoints = exports.getStopPoints = function getStopPoints() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, state) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.geo.getStopPoints(meta);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x2, _x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getClosestStopPoint = exports.getClosestStopPoint = function getClosestStopPoint(latitude, longitude) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, state) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.geo.getClosestStopPoint(latitude, longitude);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4, _x5) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var getStopPointsWithBounds = exports.getStopPointsWithBounds = function getStopPointsWithBounds(boundingBox, zoom) {
	    var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'inventarisation_active';
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, state) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _api.api.geo.getStopPoints({
	                                filters: {
	                                    withBoundingBox: boundingBox,
	                                    withZoom: zoom,
	                                    withSource: source
	                                }
	                            });
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](0);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};
	
	var getStopPointRoutes = exports.getStopPointRoutes = function getStopPointRoutes(uuid) {
	    return function () {
	        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, state) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	                            _context4.next = 3;
	                            return _api.api.geo.getStopPointRoutes(uuid);
	
	                        case 3:
	                            response = _context4.sent;
	                            return _context4.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context4.prev = 7;
	                            _context4.t0 = _context4['catch'](0);
	                            return _context4.abrupt('return', (0, _response.error)(_context4.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined, [[0, 7]]);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	};
	
	var getStopPointRouteRuns = exports.getStopPointRouteRuns = function getStopPointRouteRuns(uuid, routeUuid) {
	    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var onlyFirst = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
	    return function () {
	        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, state) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.prev = 0;
	                            _context5.next = 3;
	                            return _api.api.geo.getStopPointRouteRuns(uuid, routeUuid, time, onlyFirst, page);
	
	                        case 3:
	                            response = _context5.sent;
	                            return _context5.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context5.prev = 7;
	                            _context5.t0 = _context5['catch'](0);
	                            return _context5.abrupt('return', (0, _response.error)(_context5.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined, [[0, 7]]);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(128);
	
	var _reactRedux = __webpack_require__(17);
	
	var _news = __webpack_require__(99);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _reactRenderHtml = __webpack_require__(117);
	
	var _reactRenderHtml2 = _interopRequireDefault(_reactRenderHtml);
	
	var _tags = __webpack_require__(184);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsSidebarComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getNews: _news.getNews }), _dec(_class = function (_Component) {
	    _inherits(NewsSidebarComponent, _Component);
	
	    function NewsSidebarComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewsSidebarComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsSidebarComponent.__proto__ || Object.getPrototypeOf(NewsSidebarComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            otherNews: []
	        }, _this.months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewsSidebarComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadOtherNews();
	        }
	    }, {
	        key: 'loadOtherNews',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response, news;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.getNews({
	                                    filters: {
	                                        onlyActive: true,
	                                        withPinned: [false]
	                                    },
	                                    pagination: {
	                                        page: 2,
	                                        limit: 9
	                                    },
	                                    order: {
	                                        column: 'timestamp',
	                                        direction: 'desc'
	                                    }
	                                });
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (response.isOk) {
	                                    news = response.payload.items;
	
	                                    this.setState({
	                                        otherNews: news
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadOtherNews() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadOtherNews;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'sidebar' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sidebar__title' },
	                    '\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438 \u043F\u043E\u0440\u0442\u0430\u043B\u0430'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'sidebar-news-list' },
	                    this.state.otherNews.map(this.renderSidebarNews.bind(this))
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'javascript:void(0)',
	                        className: 'b-button b-button_size_md b-button_white b-button_shadow_gray b-button-more',
	                        onClick: this.showAll.bind(this) },
	                    '\u0412\u0441\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438'
	                ),
	                _react2.default.createElement(_tags2.default, this.props)
	            );
	        }
	    }, {
	        key: 'showAll',
	        value: function showAll() {
	            this.props.router.push('/news/all');
	        }
	    }, {
	        key: 'renderPage',
	        value: function renderPage(page, index) {
	            var className = (0, _classnames2.default)({
	                active: page + 1 === 1 * this.state.page
	            });
	
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                { key: index, to: '/news?page=' + (page + 1), className: className },
	                page + 1
	            );
	        }
	    }, {
	        key: 'renderNews',
	        value: function renderNews(news) {
	            var uuid = news.uuid,
	                title = news.title,
	                timestamp = news.timestamp,
	                image = news.image;
	
	
	            return _react2.default.createElement(
	                'li',
	                { key: uuid, className: 'news-item' },
	                _react2.default.createElement('div', { className: 'news-item__img', style: { backgroundImage: 'url(' + image + ')' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'news-item__content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__title', onClick: this.showFull.bind(this, uuid) },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__date' },
	                        this.formatTimestamp(timestamp)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'formatTimestamp',
	        value: function formatTimestamp(timestamp) {
	            return _react2.default.createElement(
	                'span',
	                null,
	                (0, _moment2.default)(timestamp).format('D'),
	                ' ',
	                this.months[(0, _moment2.default)(timestamp).format('MM') - 1],
	                ' ',
	                (0, _moment2.default)(timestamp).format('YYYY'),
	                ' \u0433.'
	            );
	        }
	    }, {
	        key: 'showFull',
	        value: function showFull(uuid) {
	            this.props.router.push('/news/' + uuid);
	        }
	    }, {
	        key: 'renderSidebarNews',
	        value: function renderSidebarNews(news) {
	            var uuid = news.uuid,
	                title = news.title,
	                timestamp = news.timestamp;
	
	
	            return _react2.default.createElement(
	                'li',
	                { key: uuid, className: 'sidebar-news-item' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sidebar-news-item__title', onClick: this.showFull.bind(this, uuid) },
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sidebar-news-item__date' },
	                    this.formatTimestamp(timestamp)
	                )
	            );
	        }
	    }]);
	
	    return NewsSidebarComponent;
	}(_react.Component)) || _class);
	exports.default = NewsSidebarComponent;

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _orderBy2 = __webpack_require__(1277);
	
	var _orderBy3 = _interopRequireDefault(_orderBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(128);
	
	var _reactRedux = __webpack_require__(17);
	
	var _news = __webpack_require__(99);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _reactRenderHtml = __webpack_require__(117);
	
	var _reactRenderHtml2 = _interopRequireDefault(_reactRenderHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagsComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getTags: _news.getTags }), _dec(_class = function (_Component) {
	    _inherits(TagsComponent, _Component);
	
	    function TagsComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TagsComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagsComponent.__proto__ || Object.getPrototypeOf(TagsComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            tags: []
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TagsComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.loadTags();
	        }
	    }, {
	        key: 'loadTags',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.getTags();
	
	                            case 2:
	                                response = _context.sent;
	
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        tags: (0, _orderBy3.default)(response.payload.items, ['count'], ['desc'])
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadTags() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadTags;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'tags' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sidebar__title' },
	                    '\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u0442\u0435\u0433\u0438'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tag-list' },
	                    this.state.tags.map(this.renderTag.bind(this))
	                )
	            );
	        }
	    }, {
	        key: 'renderTag',
	        value: function renderTag(tag) {
	            var name = tag.name;
	
	
	            return _react2.default.createElement(
	                'a',
	                { key: name, href: 'javascript:void(0)', onClick: this.showTag.bind(this, name), className: 'tag-item b-button b-button_shadow_gray b-button_white b-button_size_md' },
	                name
	            );
	        }
	    }, {
	        key: 'showTag',
	        value: function showTag(tag) {
	            this.props.router.push('/news/tag/' + tag);
	        }
	    }]);
	
	    return TagsComponent;
	}(_react.Component)) || _class);
	exports.default = TagsComponent;

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _clone2 = __webpack_require__(505);
	
	var _clone3 = _interopRequireDefault(_clone2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _DayPickerInput = __webpack_require__(1330);
	
	var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);
	
	__webpack_require__(1115);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(1090);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _select = __webpack_require__(98);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _textFieldMask = __webpack_require__(379);
	
	var _textFieldMask2 = _interopRequireDefault(_textFieldMask);
	
	var _reactInputMask = __webpack_require__(355);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var monthsRU = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
	
	var Datepicker = (_dec = (0, _reactPropsDecorators.propTypes)({
	    value: _propTypes2.default.any,
	    style: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    disabledDays: _propTypes2.default.func,
	    disabled: _propTypes2.default.bool,
	    className: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    style: null,
	    onChange: function onChange() {},
	    disabledDays: function disabledDays() {
	        return false;
	    },
	    disabled: false,
	    className: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Datepicker, _Component);
	
	    function Datepicker() {
	        _classCallCheck(this, Datepicker);
	
	        return _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).apply(this, arguments));
	    }
	
	    _createClass(Datepicker, [{
	        key: 'render',
	        value: function render() {
	            var value = this.props.value ? (0, _moment2.default)(this.props.value).format(_formats2.default.DATE) : '';
	
	            var styleClassName = (0, _classnames2.default)('input__style', this.props.error ? 'input__style_state_wrong' : '');
	
	            var inputClassName = (0, _classnames2.default)('input', this.props.style ? 'input_' + this.props.style : null);
	
	            var classes = (0, _classnames2.default)('datepicker', this.props.className, this.props.disabled ? 'disabled' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: classes },
	                _react2.default.createElement(
	                    'div',
	                    { className: inputClassName },
	                    _react2.default.createElement(_DayPickerInput2.default, {
	                        placeholder: '\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433',
	                        classNames: {
	                            container: 'input__wrapper',
	                            overlayWrapper: 'DayPickerInput-OverlayWrapper',
	                            overlay: 'DayPickerInput-Overlay'
	                        },
	                        component: DatepickerInput,
	                        format: 'DD.MM.YYYY',
	                        value: value,
	                        onDayChange: this.onChange.bind(this),
	                        hideOnDayClick: true,
	                        dayPickerProps: {
	                            months: monthsRU,
	                            disabledDays: this.props.disabledDays,
	                            weekdaysLong: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
	                            weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
	                            firstDayOfWeek: 1,
	                            labels: { nextMonth: 'следующий месяц', previousMonth: 'предыдущий месяц' },
	                            captionElement: _react2.default.createElement(YearMonthForm, { onChange: this.onChange.bind(this) })
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: styleClassName },
	                        this.props.error ? _react2.default.createElement(
	                            'span',
	                            {
	                                className: 'input__style_state_msg input__style_state_msg_wrong' },
	                            this.props.error
	                        ) : null
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(date) {
	            date = date ? (0, _moment2.default)(date).format(_formats2.default.T1DATE) : null;
	
	            this.props.onChange({
	                target: {
	                    value: date
	                }
	            });
	        }
	    }]);
	
	    return Datepicker;
	}(_react.Component)) || _class) || _class);
	exports.default = Datepicker;
	
	
	function YearMonthForm(_ref) {
	    var date = _ref.date,
	        localeUtils = _ref.localeUtils,
	        onChange = _ref.onChange;
	
	    var months = monthsRU;
	
	    var years = [];
	    for (var i = (0, _moment2.default)().subtract(100, 'years').year(); i <= (0, _moment2.default)().add(2, 'years').year(); i += 1) {
	        years.push(i);
	    }
	
	    var handleChangeMonth = function handleChangeMonth(e) {
	        onChange(date.setMonth(e.value));
	    };
	
	    var handleChangeYear = function handleChangeYear(e) {
	        onChange(date.setFullYear(e.value));
	    };
	
	    return _react2.default.createElement(
	        'form',
	        { className: 'DayPicker-Caption clearAfter' },
	        _react2.default.createElement(_select2.default, { onChange: handleChangeMonth, value: date.getMonth(),
	            clearable: false,
	            options: months.map(function (month, i) {
	                return { value: i, label: month };
	            }) }),
	        _react2.default.createElement(_select2.default, { onChange: handleChangeYear, value: date.getFullYear(),
	            clearable: false,
	            options: years.map(function (year) {
	                return { value: year, label: year };
	            }) })
	    );
	}
	
	var DatepickerInput = function (_React$Component) {
	    _inherits(DatepickerInput, _React$Component);
	
	    function DatepickerInput() {
	        var _ref2;
	
	        _classCallCheck(this, DatepickerInput);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var _this2 = _possibleConstructorReturn(this, (_ref2 = DatepickerInput.__proto__ || Object.getPrototypeOf(DatepickerInput)).call.apply(_ref2, [this].concat(args)));
	
	        _this2.state = {
	            opened: false
	        };
	
	
	        _this2.onClickDocument = _this2._onClickDocument.bind(_this2);
	        return _this2;
	    }
	
	    _createClass(DatepickerInput, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                (0, _jquery2.default)(document).on('click', this.onClickDocument);
	
	                            case 1:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            (0, _jquery2.default)(document).off('click', this.onClickDocument);
	        }
	    }, {
	        key: '_onClickDocument',
	        value: function _onClickDocument(e) {
	            if ((0, _jquery2.default)(e.target).closest((0, _jquery2.default)(this.refs.container).closest('.datepicker')).length === 0) {
	                this.props.onBlur();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var props = (0, _clone3.default)(this.props);
	            delete props['onBlur'];
	            //delete props['onFocus'];
	            delete props['onClick'];
	            props.onBlur = function (e) {
	                if ((0, _jquery2.default)(e.relatedTarget).closest('.DayPicker-wrapper').length === 0) {
	                    _this3.props.onBlur();
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { ref: 'container' },
	                _react2.default.createElement(_reactInputMask2.default, _extends({ mask: '99.99.9999', className: 'input__control' }, props)),
	                _react2.default.createElement('a', { className: 'b-icon-link b-icon-link_icon_datepicker datepicker__icon', href: '#',
	                    onClick: this.toggle.bind(this) })
	            );
	        }
	    }, {
	        key: 'toggle',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
	                var opened;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                e.preventDefault();
	
	                                opened = (0, _jquery2.default)(this.refs.container).closest('.datepicker').find('.DayPicker-wrapper').length > 0;
	
	                                if (opened) {
	                                    this.props.onBlur();
	                                } else {
	                                    this.props.onFocus();
	                                }
	
	                            case 3:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function toggle(_x) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return toggle;
	        }()
	    }, {
	        key: 'focus',
	        value: function focus() {}
	    }]);
	
	    return DatepickerInput;
	}(_react2.default.Component);

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _isUndefined2 = __webpack_require__(510);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = (_dec = (0, _reactPropsDecorators.propTypes)({}), _dec2 = (0, _reactPropsDecorators.defaultProps)({}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Input, _Component);
	
	    function Input() {
	        _classCallCheck(this, Input);
	
	        return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	    }
	
	    _createClass(Input, [{
	        key: 'render',
	        value: function render() {
	            var inputProps = {};
	
	            if (this.props.onEnter) inputProps.onKeyPress = this.handleKeyPress.bind(this);
	
	            if (this.props.name) inputProps.name = this.props.name;
	
	            if (!(0, _isUndefined3.default)(this.props.value)) {
	                inputProps.value = this.props.value;
	            }
	
	            inputProps.disabled = this.props.disabled;
	            inputProps.onKeyPress = this.props.onKeyPress;
	
	            if (this.props.positive) {
	                inputProps.min = 0;
	                inputProps.onKeyPress = function (e) {
	                    if (e.charCode < 48 || e.charCode > 57) {
	                        e.preventDefault();
	                    }
	                };
	            }
	
	            var styleClassName = (0, _classnames2.default)('input__style', this.props.error ? 'input__style_state_wrong' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'input' },
	                this.props.wrapper,
	                _react2.default.createElement('input', _extends({
	                    ref: 'input',
	                    className: 'input__control',
	                    defaultValue: this.props.defaultValue,
	                    type: this.props.type,
	                    placeholder: this.props.placeholder,
	                    onChange: this.props.onChange
	                }, inputProps)),
	                _react2.default.createElement(
	                    'div',
	                    { className: styleClassName },
	                    this.props.error ? _react2.default.createElement(
	                        'span',
	                        { className: 'input__style_state_msg input__style_state_msg_wrong' },
	                        this.props.error
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'handleKeyPress',
	        value: function handleKeyPress(e) {
	            if (e.key === 'Enter') {
	                e.preventDefault();
	                this.props.onEnter();
	            }
	        }
	    }]);
	
	    return Input;
	}(_react.Component)) || _class) || _class);
	exports.default = Input;

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _merge2 = __webpack_require__(326);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbstractMapMarker = (_dec = (0, _reactPropsDecorators.propTypes)({
	    map: _propTypes2.default.object.isRequired,
	    leafletMap: _propTypes2.default.object.isRequired,
	    latitude: _propTypes2.default.number.isRequired,
	    longitude: _propTypes2.default.number.isRequired,
	    zIndex: _propTypes2.default.number,
	    options: _propTypes2.default.object,
	    onClick: _propTypes2.default.func,
	    onDblClick: _propTypes2.default.func,
	    onRightClick: _propTypes2.default.func,
	    fast: _propTypes2.default.bool,
	    draggable: _propTypes2.default.bool,
	    onDrag: _propTypes2.default.func,
	    onDragEnd: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    onClick: null,
	    zIndex: 0,
	    onDblClick: function onDblClick() {},
	    onRightClick: function onRightClick() {},
	    options: {},
	    fast: false,
	    draggable: false
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(AbstractMapMarker, _Component);
	
	    function AbstractMapMarker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AbstractMapMarker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractMapMarker.__proto__ || Object.getPrototypeOf(AbstractMapMarker)).call.apply(_ref, [this].concat(args))), _this), _this.animation = false, _this.__marker = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AbstractMapMarker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.init();
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            this.__marker = new _leaflet2.default.Marker([this.props.latitude, this.props.longitude], (0, _merge3.default)(this.getOptions(), this.props.options));
	
	            if (this.props.onClick) {
	                this.getMarker().on('click', this.props.onClick);
	            }
	            this.getMarker().on('contextmenu', this.props.onRightClick);
	            this.getMarker().on('dblclick', this.props.onDblClick);
	
	            if (this.props.draggable) {
	                this.getMarker().on('drag', this.props.onDrag);
	                this.getMarker().on('dragend', this.props.onDragEnd);
	            }
	        }
	    }, {
	        key: 'reinit',
	        value: function reinit() {
	            this.props.leafletMap.removeLayer(this.getMarker());
	            this.init();
	            this.props.leafletMap.addLayer(this.getMarker());
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.leafletMap.addLayer(this.getMarker());
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.leafletMap.removeLayer(this.getMarker());
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.latitude !== this.props.latitude || prevProps.longitude !== this.props.longitude) {
	                if (this.animation) {
	                    this.getMarker().slideTo([this.props.latitude, this.props.longitude], {
	                        duration: this.props.fast ? 300 : 5000
	                    });
	                } else {
	                    this.getMarker().setLatLng([this.props.latitude, this.props.longitude]);
	                }
	            }
	            if (prevProps.options.interactive !== this.props.options.interactive) {
	                this.reinit();
	            }
	            if (prevProps.options.zIndex !== this.props.options.zIndex) {
	                this.reinit();
	            }
	        }
	    }, {
	        key: 'getMarker',
	        value: function getMarker() {
	            return this.__marker;
	        }
	    }, {
	        key: 'getOptions',
	        value: function getOptions() {
	            return {
	                draggable: this.props.draggable,
	                zIndexOffset: this.props.zIndex
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return AbstractMapMarker;
	}(_react.Component)) || _class) || _class);
	exports.default = AbstractMapMarker;

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextField = (_dec = (0, _reactPropsDecorators.propTypes)({
	    placeholder: _propTypes2.default.string,
	    defaultValue: _propTypes2.default.string,
	    withoutWrapper: _propTypes2.default.bool,
	    name: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    type: _propTypes2.default.oneOf(['text', 'password', 'number']),
	    size: _propTypes2.default.oneOf(['sm', 'md', 'lg']),
	    success: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    onChange: _propTypes2.default.func,
	    onEnter: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    value: '',
	    defaultValue: '',
	    withoutWrapper: false,
	    className: '',
	    onChange: function onChange() {},
	    placeholder: '',
	    type: 'text',
	    size: 'sm'
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(TextField, _Component);
	
	    function TextField() {
	        _classCallCheck(this, TextField);
	
	        return _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).apply(this, arguments));
	    }
	
	    _createClass(TextField, [{
	        key: 'render',
	        value: function render() {
	            var textFieldState = this.getCurrentTextfieldState();
	            var className = (0, _classnames2.default)('text-field', 'text-field-' + this.props.size, textFieldState ? 'text-field-' + textFieldState : '', this.props.className);
	
	            var style = {};
	
	            var Hint = this.renderHint();
	
	            var inputProps = {};
	
	            if (this.props.onEnter) inputProps.onKeyPress = this.handleKeyPress.bind(this);
	
	            if (this.props.name) inputProps.name = this.props.name;
	
	            if (this.props.withoutWrapper) {
	                inputProps.className = this.props.className;
	            }
	
	            if (this.props.value) {
	                inputProps.value = this.props.value;
	            }
	
	            var input = _react2.default.createElement('input', _extends({
	                ref: 'input',
	                defaultValue: this.props.defaultValue,
	                type: this.props.type,
	                placeholder: this.props.placeholder,
	                onChange: this.props.onChange
	            }, inputProps));
	
	            return this.props.withoutWrapper ? input : _react2.default.createElement(
	                'div',
	                { className: className, style: style },
	                input,
	                Hint
	            );
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue() {
	            return this.refs.input.value;
	        }
	    }, {
	        key: 'handleKeyPress',
	        value: function handleKeyPress(e) {
	            if (e.key === 'Enter') {
	                e.preventDefault();
	                this.props.onEnter();
	            }
	        }
	    }, {
	        key: 'getCurrentTextfieldState',
	        value: function getCurrentTextfieldState() {
	            if (this.props.success) return 'success';
	
	            if (this.props.error) return 'error';
	
	            return false;
	        }
	    }, {
	        key: 'renderHint',
	        value: function renderHint() {
	            if (this.props.success && this.props.success.length > 0) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'hint' },
	                    this.props.success
	                );
	            } else if (this.props.error && this.props.error.length) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'hint' },
	                    this.props.error
	                );
	            }
	        }
	    }]);
	
	    return TextField;
	}(_react.Component)) || _class) || _class);
	exports.default = TextField;

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _find2 = __webpack_require__(89);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _padStart2 = __webpack_require__(327);
	
	var _padStart3 = _interopRequireDefault(_padStart2);
	
	var _floor2 = __webpack_require__(1260);
	
	var _floor3 = _interopRequireDefault(_floor2);
	
	var _round2 = __webpack_require__(229);
	
	var _round3 = _interopRequireDefault(_round2);
	
	exports.formatDistance = formatDistance;
	exports.formatTime = formatTime;
	exports.find = find;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDistance(meters) {
	    if (meters >= 1000) {
	        return (0, _round3.default)(meters / 1000, 1) + ' \u043A\u043C';
	    }
	
	    return meters + ' \u043C';
	}
	
	function formatTime(minutes) {
	    if (minutes >= 60) {
	        return (0, _floor3.default)(minutes / 60) + ' \u0447 ' + (0, _padStart3.default)(minutes % 60, 2, '0') + ' \u043C\u0438\u043D';
	    }
	
	    return minutes + ' \u043C\u0438\u043D';
	}
	
	function find(object, search) {
	    try {
	        if ((0, _find3.default)(object, search)) {
	            var result = (0, _find3.default)(object, search);
	            var submenu = result.submenu ? result.submenu : [];
	            submenu = new Proxy(submenu, {
	                get: function get(target, prop) {
	                    if (prop in target) {
	                        return target[prop];
	                    } else {
	                        console.warn('submenu by index: ' + prop + ' not found in ' + result.text);
	                        return {
	                            show: false
	                        };
	                    }
	                }
	            });
	            return { text: result.text, show: result.show, submenu: submenu };
	        } else {
	            console.warn('Not find in settings.json ' + search);
	            return {
	                show: false
	            };
	        }
	    } catch (e) {
	        console.warn('Not find in settings.json ' + search);
	        return {
	            show: false
	        };
	    }
	}

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUnit = exports.getCarriers = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var getCarriers = exports.getCarriers = function getCarriers(meta) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.organizational_units.getCarriers(meta);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getUnit = exports.getUnit = function getUnit(inn, ogrn) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.organizational_units.getUnit(inn, ogrn);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(449);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordionItem = (_dec = (0, _reactPropsDecorators.propTypes)({
	    title: _propTypes2.default.any,
	    afterTitle: _propTypes2.default.object,
	    opened: _propTypes2.default.bool,
	    single: _propTypes2.default.bool,
	    collapsable: _propTypes2.default.bool,
	    withoutWrapper: _propTypes2.default.bool,
	    onOpened: _propTypes2.default.func,
	    onClosed: _propTypes2.default.func,
	    className: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    title: '',
	    afterTitle: null,
	    opened: false,
	    single: false,
	    collapsable: true,
	    withoutWrapper: false,
	    onOpened: function onOpened() {},
	    onClosed: function onClosed() {},
	    className: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(AccordionItem, _Component);
	
	    function AccordionItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AccordionItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call.apply(_ref, [this].concat(args))), _this), _this.stateChanged = function (e) {
	            if (e.target.checked) {
	                _this.props.onClosed();
	            } else {
	                _this.props.onOpened();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AccordionItem, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var hasError = (0, _jquery2.default)(this.refs.children).find('.input__style_state_wrong').length > 0;
	            (0, _jquery2.default)(this.refs.container).toggleClass('with_error', hasError);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)({
	                accordion__item: true
	            });
	
	            if (this.props.single) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: className, ref: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'accordion__content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)('accordion__posit accordion__posit_top-bord', this.props.className),
	                                ref: 'children' },
	                            this.props.children
	                        )
	                    )
	                );
	            }
	
	            var content = this.props.withoutWrapper ? this.props.children : _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('accordion__posit accordion__posit_top-bord', this.props.className),
	                    ref: 'children' },
	                this.props.children
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, ref: 'container' },
	                this.props.collapsable ? [_react2.default.createElement('input', { key: 'input', className: 'accordion__open', type: 'checkbox',
	                    defaultChecked: !this.props.opened,
	                    onClick: this.stateChanged
	                }), _react2.default.createElement('i', { key: 'icon', className: 'accordion__arrow' })] : null,
	                this.props.title ? _react2.default.createElement(
	                    'div',
	                    { className: 'accordion__title' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        this.props.title
	                    )
	                ) : null,
	                this.props.afterTitle,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'accordion__content' },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return AccordionItem;
	}(_react.Component)) || _class) || _class);
	exports.default = AccordionItem;

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(449);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Accordion = (_dec = (0, _reactPropsDecorators.propTypes)({
	    className: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    className: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Accordion, _Component);
	
	    function Accordion() {
	        _classCallCheck(this, Accordion);
	
	        return _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).apply(this, arguments));
	    }
	
	    _createClass(Accordion, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('accordion', this.props.className), onKeyUp: this.props.onKeyUp },
	                this.props.children
	            );
	        }
	    }]);
	
	    return Accordion;
	}(_react.Component)) || _class) || _class);
	exports.default = Accordion;

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1088);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Block = (_dec = (0, _reactPropsDecorators.propTypes)({
	    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    border: _propTypes2.default.bool,
	    nowrap: _propTypes2.default.bool,
	    withRightMargin: _propTypes2.default.bool,
	    withBottomMargin: _propTypes2.default.bool,
	    size: _propTypes2.default.oneOf(['sm', 'mdl', 'md', 'lg', 'xl']),
	    className: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    title: '',
	    border: false,
	    nowrap: false,
	    withRightMargin: false,
	    withBottomMargin: false,
	    size: 'md',
	    className: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Block, _Component);
	
	    function Block() {
	        _classCallCheck(this, Block);
	
	        return _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).apply(this, arguments));
	    }
	
	    _createClass(Block, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)({
	                'b-block': true,
	                '_border': this.props.border,
	                '_marg': this.props.withRightMargin
	            }, '_' + this.props.size, this.props.className);
	
	            var content = this.props.nowrap ? this.props.children : _react2.default.createElement(
	                'div',
	                { className: 'b-block__text' },
	                this.props.children
	            );
	
	            var titleClassName = (0, _classnames2.default)({
	                'b-block__title': true,
	                '_bposit': this.props.withBottomMargin
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                this.props.title ? _react2.default.createElement(
	                    'div',
	                    { className: titleClassName },
	                    this.props.title
	                ) : null,
	                content
	            );
	        }
	    }]);
	
	    return Block;
	}(_react.Component)) || _class) || _class);
	exports.default = Block;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1089);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = (_dec = (0, _reactPropsDecorators.propTypes)({
	    checked: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    label: _propTypes2.default.string.isRequired
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    checked: false,
	    label: '',
	    onChange: function onChange() {}
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Checkbox, _Component);
	
	    function Checkbox() {
	        _classCallCheck(this, Checkbox);
	
	        return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	    }
	
	    _createClass(Checkbox, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'b-checkbox login-password', onClick: this.onChange.bind(this) },
	                this.props.children,
	                _react2.default.createElement('input', { type: 'checkbox', className: 'b-checkbox__inner', checked: this.props.checked }),
	                _react2.default.createElement(
	                    'label',
	                    { className: 'b-checkbox__label' },
	                    this.props.label
	                )
	            );
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            this.props.onChange({
	                target: {
	                    value: !this.props.checked
	                }
	            });
	        }
	    }]);
	
	    return Checkbox;
	}(_react.Component)) || _class) || _class);
	exports.default = Checkbox;

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1091);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radio = (_dec = (0, _reactPropsDecorators.propTypes)({
	    checked: _propTypes2.default.bool,
	    label: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.string.isRequired,
	    field: _propTypes2.default.string.isRequired,
	    onChange: _propTypes2.default.func.isRequired
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    checked: false,
	    label: '',
	    value: '',
	    field: '',
	    onChange: function onChange() {}
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Radio, _Component);
	
	    function Radio() {
	        _classCallCheck(this, Radio);
	
	        return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	    }
	
	    _createClass(Radio, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'b-radio' },
	                _react2.default.createElement('input', { type: 'radio', id: this.props.value, className: 'b-radio__inner', name: this.props.field,
	                    checked: this.props.checked, onChange: this.props.onChange, value: this.props.value }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.value, className: 'b-radio__label' },
	                    this.props.label
	                )
	            );
	        }
	    }]);
	
	    return Radio;
	}(_react.Component)) || _class) || _class);
	exports.default = Radio;

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _reactLeafletPopup = __webpack_require__(179);
	
	var _reactLeafletPopup2 = _interopRequireDefault(_reactLeafletPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapGeojson = (_dec = (0, _reactPropsDecorators.propTypes)({
	    map: _propTypes2.default.object.isRequired,
	    leafletMap: _propTypes2.default.object.isRequired,
	    geometry: _propTypes2.default.object.isRequired,
	    tooltip: _propTypes2.default.string,
	    bringToBack: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	    label: _propTypes2.default.string,
	    interactive: _propTypes2.default.bool,
	    permanentTooltip: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func,
	    popup: _propTypes2.default.func,
	    popupOffset: _propTypes2.default.number,
	    popupWidth: _propTypes2.default.number,
	    onMouseOver: _propTypes2.default.func,
	    onMouseOut: _propTypes2.default.func,
	    color: _propTypes2.default.string,
	    weight: _propTypes2.default.number,
	    fillOpacity: _propTypes2.default.number,
	    opacity: _propTypes2.default.number
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    tooltip: null,
	    bringToBack: false,
	    label: null,
	    interactive: true,
	    permanentTooltip: false,
	    onClick: null,
	    popup: null,
	    popupOffset: -250,
	    popupWidth: 350,
	    color: 'blue',
	    weight: 3
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(MapGeojson, _Component);
	
	    function MapGeojson() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MapGeojson);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapGeojson.__proto__ || Object.getPrototypeOf(MapGeojson)).call.apply(_ref, [this].concat(args))), _this), _this.__layer = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MapGeojson, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.__layer = new _leaflet2.default.GeoJSON(this.props.geometry, this.getOptions());
	
	            if (this.props.onClick) {
	                this.getLayer().on('click', this.props.onClick);
	            }
	            if (this.props.onMouseOver) {
	                this.getLayer().on('mouseover', this.props.onMouseOver);
	            }
	            if (this.props.onMouseOut) {
	                this.getLayer().on('mouseout', this.props.onMouseOut);
	            }
	
	            if (this.props.tooltip) {
	                this.getLayer().bindTooltip(this.props.tooltip, {
	                    sticky: true,
	                    permanent: this.props.permanentToolTip,
	                    interactive: !!this.props.onClick
	                });
	            }
	
	            if (this.props.label) {
	                this.getLayer().addLayer(new _leaflet2.default.tooltip({
	                    permanent: true,
	                    direction: 'center',
	                    className: 'leaflet-tooltip-own'
	                }).setContent(this.props.label).setLatLng(this.__layer.getBounds().getCenter()));
	            }
	
	            if (this.props.popup && this.props.onClick === null) {
	                this.getLayer().on('click', this.loadPopup.bind(this));
	            }
	        }
	    }, {
	        key: 'getOptions',
	        value: function getOptions() {
	            return {
	                interactive: this.props.interactive,
	                style: this.getStyle(this.props)
	            };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.leafletMap.addLayer(this.getLayer());
	            if (this.props.bringToBack) {
	                this.getLayer().bringToBack();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.leafletMap.removeLayer(this.getLayer());
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(props) {
	            if (this.props.geometry !== props.geometry) {
	                var layer = this.getLayer();
	                layer.clearLayers();
	                layer.addData(props.geometry);
	            }
	            if (props.onClick !== this.props.onClick) {
	                this.props.onClick && this.getLayer().off('click', this.props.onClick);
	                props.onClick && this.getLayer().on('click', props.onClick);
	            }
	            this.getLayer().setStyle(this.getStyle(props));
	        }
	    }, {
	        key: 'getStyle',
	        value: function getStyle() {
	            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (props.fillOpacity >= 0) {
	                return {
	                    fillOpacity: 0,
	                    color: '#EEDDD9',
	                    opacity: 1,
	                    weight: props.weight
	                };
	            } else {
	                return {
	                    color: this.getColor(props),
	                    opacity: this.props.opacity ? this.props.opacity : 0.6,
	                    weight: props.weight
	                };
	            }
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor(props) {
	            var color = props ? props.color : this.props.color;
	            switch (color) {
	                case 'blue':
	                    return '#0000FF';
	                case 'gray':
	                    return '#333';
	                case 'green':
	                    return '#00FF00';
	                case 'red':
	                    return '#FF0000';
	                default:
	                    return color || '#FF0000';
	            }
	        }
	    }, {
	        key: 'getLayer',
	        value: function getLayer() {
	            return this.__layer;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }, {
	        key: 'loadPopup',
	        value: function loadPopup() {
	            var layer = this.getLayer();
	            layer.unbindPopup();
	            layer.closePopup();
	            layer.bindPopup(this.createPopup(layer.closePopup.bind(layer)));
	            layer.openPopup();
	        }
	    }, {
	        key: 'createPopup',
	        value: function createPopup(onClose) {
	            return new _reactLeafletPopup2.default({
	                reactComponent: Popup,
	                reactComponentProps: _extends({}, this.props, {
	                    onClose: onClose
	                }),
	                minWidth: this.props.popupWidth ? this.props.popupWidth : 434,
	                maxWidth: 434,
	                offset: new _leaflet2.default.Point(3, this.props.popupOffset)
	            });
	        }
	    }]);
	
	    return MapGeojson;
	}(_react.Component)) || _class) || _class);
	exports.default = MapGeojson;
	
	var Popup = function (_Component2) {
	    _inherits(Popup, _Component2);
	
	    function Popup() {
	        _classCallCheck(this, Popup);
	
	        return _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).apply(this, arguments));
	    }
	
	    _createClass(Popup, [{
	        key: 'render',
	        value: function render() {
	            return this.props.popup(this.props.onClose);
	        }
	    }]);
	
	    return Popup;
	}(_react.Component);

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(35);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTopMenuButton = (_dec = (0, _reactPropsDecorators.propTypes)({
	    className: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    tooltip: _propTypes2.default.string,
	    onClick: _propTypes2.default.func.isRequired
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    className: '',
	    title: '',
	    tooltip: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(ModalTopMenuButton, _Component);
	
	    function ModalTopMenuButton() {
	        _classCallCheck(this, ModalTopMenuButton);
	
	        return _possibleConstructorReturn(this, (ModalTopMenuButton.__proto__ || Object.getPrototypeOf(ModalTopMenuButton)).apply(this, arguments));
	    }
	
	    _createClass(ModalTopMenuButton, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('b-modal__header-link', this.props.className, this.props.tooltip ? 'link-tooltip' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, onClick: this.props.onClick },
	                this.props.title
	            );
	        }
	    }]);
	
	    return ModalTopMenuButton;
	}(_react.Component)) || _class) || _class);
	exports.default = ModalTopMenuButton;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	__webpack_require__(451);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTopMenuButtons = (_dec = (0, _reactPropsDecorators.propTypes)({}), _dec2 = (0, _reactPropsDecorators.defaultProps)({}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(ModalTopMenuButtons, _Component);
	
	    function ModalTopMenuButtons() {
	        _classCallCheck(this, ModalTopMenuButtons);
	
	        return _possibleConstructorReturn(this, (ModalTopMenuButtons.__proto__ || Object.getPrototypeOf(ModalTopMenuButtons)).apply(this, arguments));
	    }
	
	    _createClass(ModalTopMenuButtons, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'b-modal__button-block' },
	                this.props.children
	            );
	        }
	    }]);
	
	    return ModalTopMenuButtons;
	}(_react.Component)) || _class) || _class);
	exports.default = ModalTopMenuButtons;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pageHeader = __webpack_require__(378);
	
	var _pageHeader2 = _interopRequireDefault(_pageHeader);
	
	var _iconButton = __webpack_require__(370);
	
	var _iconButton2 = _interopRequireDefault(_iconButton);
	
	__webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageModal = (_dec = (0, _reactPropsDecorators.propTypes)({
	    header: _propTypes2.default.object,
	    closeButton: _propTypes2.default.bool,
	    onClose: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    headerClassName: _propTypes2.default.string,
	    withFade: _propTypes2.default.bool,
	    buttons: _propTypes2.default.array,
	    disabled: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    disableOutsideClick: _propTypes2.default.bool,
	    titleClassName: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    closeButton: true,
	    className: '',
	    headerClassName: '',
	    withFade: true,
	    buttons: [],
	    disabled: false,
	    style: {},
	    disableOutsideClick: false,
	    titleClassName: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(PageModal, _Component);
	
	    function PageModal() {
	        _classCallCheck(this, PageModal);
	
	        return _possibleConstructorReturn(this, (PageModal.__proto__ || Object.getPrototypeOf(PageModal)).apply(this, arguments));
	    }
	
	    _createClass(PageModal, [{
	        key: 'render',
	        value: function render() {
	            var paranjaClassName = (0, _classnames2.default)('b-modal__paranja', {
	                'paranja_fade': this.props.withFade
	            });
	
	            var className = (0, _classnames2.default)('b-modal', this.props.className || 'PageModal', {
	                'disabled': this.props.disabled
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.props.withFade ? _react2.default.createElement('div', { className: paranjaClassName, onClick: this.onClickCloseButton.bind(this) }) : null,
	                _react2.default.createElement(
	                    'div',
	                    { key: 'PageModal', className: className, style: this.props.style },
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('b-modal__header', this.props.headerClassName) },
	                        this.props.header.title ? _react2.default.createElement(
	                            'div',
	                            {
	                                className: (0, _classnames2.default)('b-modal__name', this.props.titleClassName) },
	                            this.props.header.title
	                        ) : null,
	                        this.props.header.titleFull,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-modal__menu' },
	                            this.props.header && this.props.header.buttons
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-modal__body-posit' },
	                            this.props.children
	                        )
	                    ),
	                    this.props.buttons.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__footer' },
	                        this.props.buttons
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'onClickCloseButton',
	        value: function onClickCloseButton() {
	            if (!this.props.disableOutsideClick) {
	                if (this.props.onClose) {
	                    this.props.onClose();
	                }
	            }
	        }
	    }]);
	
	    return PageModal;
	}(_react.Component)) || _class) || _class);
	exports.default = PageModal;

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDictionaryList = undefined;
	
	var _isArray2 = __webpack_require__(19);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getDictionaryList = exports.getDictionaryList = function getDictionaryList(key) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            meta = meta || {
	                                order: {
	                                    column: 'name',
	                                    direction: 'asc'
	                                }
	                            };
	
	                            if (!(0, _isArray3.default)(key)) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            _context.next = 5;
	                            return _api.api.dictionary.getDictionaryLists(key, meta);
	
	                        case 5:
	                            _context.t0 = _context.sent;
	                            _context.next = 11;
	                            break;
	
	                        case 8:
	                            _context.next = 10;
	                            return _api.api.dictionary.getDictionaryList(key, meta);
	
	                        case 10:
	                            _context.t0 = _context.sent;
	
	                        case 11:
	                            response = _context.t0;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 15:
	                            _context.prev = 15;
	                            _context.t1 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t1));
	
	                        case 18:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 15]]);
	        }));
	
	        return function (_x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _set2 = __webpack_require__(230);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	var _api = __webpack_require__(15);
	
	var _reactFileReaderInput = __webpack_require__(691);
	
	var _reactFileReaderInput2 = _interopRequireDefault(_reactFileReaderInput);
	
	var _select = __webpack_require__(98);
	
	var _select2 = _interopRequireDefault(_select);
	
	__webpack_require__(1074);
	
	__webpack_require__(1110);
	
	var _reactRedux = __webpack_require__(17);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _faq = __webpack_require__(384);
	
	var _input = __webpack_require__(186);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _block = __webpack_require__(251);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _checkbox = __webpack_require__(252);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _feedback = __webpack_require__(792);
	
	var _inputMask = __webpack_require__(369);
	
	var _inputMask2 = _interopRequireDefault(_inputMask);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackComponent = (_dec = (0, _reactPropsDecorators.propTypes)({
	    onClose: _propTypes2.default.func.isRequired
	}), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { sendFeedback: _feedback.sendFeedback, getCaptcha: _feedback.getCaptcha }), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(FeedbackComponent, _Component);
	
	    function FeedbackComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FeedbackComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeedbackComponent.__proto__ || Object.getPrototypeOf(FeedbackComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            type_of_treatment: 'Обращение',
	            title: '',
	            body: '',
	            full_name: '',
	            email: '',
	            phone: '',
	            files: [],
	            confirmed: false,
	            errors: {},
	            captcha: null,
	            captcha_value: ''
	        }, _this.types = ['Обращение', 'Жалоба'], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FeedbackComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getCaptcha();
	        }
	    }, {
	        key: 'getCaptcha',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                e && e.preventDefault();
	
	                                _context.next = 3;
	                                return this.props.getCaptcha();
	
	                            case 3:
	                                response = _context.sent;
	
	                                if (response.isOk) {
	                                    this.setState({ captcha: response.payload });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getCaptcha(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return getCaptcha;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { key: 'overlay', className: 'b-modal__paranja b-modal__paranja_outside' }),
	                _react2.default.createElement(
	                    'div',
	                    { key: 'modal', className: 'b-modal b-modal-feedback' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-modal__name' },
	                            '\u041E\u0431\u0440\u0430\u0442\u043D\u0430\u044F \u0441\u0432\u044F\u0437\u044C'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-modal__menu' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'b-modal__button-block' },
	                                _react2.default.createElement('div', { className: 'b-modal__header-separator' }),
	                                _react2.default.createElement('div', { className: 'b-modal__header-link _close link-tooltip', onClick: this.close.bind(this) })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__body' },
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u0422\u0438\u043F \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F' },
	                            _react2.default.createElement(_select2.default, {
	                                options: (0, _map3.default)(this.types, function (type) {
	                                    return { label: type, value: type };
	                                }),
	                                value: this.state.type_of_treatment,
	                                onChange: this.onTypeChange.bind(this),
	                                clearable: false,
	                                error: this.getError('type_of_treatment')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '\u0422\u0435\u043C\u0430 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '*'
	                                    )
	                                ) },
	                            _react2.default.createElement(_input2.default, {
	                                placeholder: '\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0442\u0435\u043C\u0443 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F',
	                                value: this.state.title,
	                                onChange: this.onChange.bind(this, 'title'),
	                                error: this.getError('title')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { size: 'xl', title: _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '\u0422\u0435\u043A\u0441\u0442 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '*'
	                                    )
	                                ) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'textarea' },
	                                _react2.default.createElement('textarea', {
	                                    className: 'textarea__control',
	                                    placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F',
	                                    value: this.state.body,
	                                    onChange: this.onChange.bind(this, 'body')
	                                }),
	                                _react2.default.createElement(
	                                    'div',
	                                    {
	                                        className: (0, _classnames2.default)('textarea__style', this.getError('body') ? 'input__style_state_wrong' : '') },
	                                    this.getError('body') ? _react2.default.createElement(
	                                        'span',
	                                        {
	                                            className: 'input__style_state_msg input__style_state_msg_wrong' },
	                                        this.getError('body')
	                                    ) : null
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'textarea__attach' },
	                                    _react2.default.createElement(
	                                        _reactFileReaderInput2.default,
	                                        { as: 'binary', id: 'my-file-input', onChange: this.uploadFile.bind(this) },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { className: 'attach' },
	                                            '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u0430\u0439\u043B'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'textarea__files' },
	                                        this.state.files.map(function (file, index) {
	                                            return _react2.default.createElement(
	                                                'li',
	                                                { key: index, className: 'textarea__file' },
	                                                file.original_filename,
	                                                ' ',
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    {
	                                                        href: '#',
	                                                        onClick: _this2.deleteFile.bind(_this2, index) },
	                                                    '\xD7'
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'b-block__desc' },
	                                '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0444\u0430\u0439\u043B\u0430 4 \u043C\u0431, \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 10. \u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B: txt, doc, rtf, xls, pps, ppt, png, tif, gif, bmp, jpeg, pdf'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { size: 'xl', title: _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '\u0424.\u0418.\u041E. ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '*'
	                                    )
	                                ) },
	                            _react2.default.createElement(_input2.default, {
	                                placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u043D\u043E\u0435 \u0438\u043C\u044F',
	                                value: this.state.full_name,
	                                onChange: this.onChange.bind(this, 'full_name'),
	                                error: this.getError('full_name')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '\u0412\u0430\u0448 e-mail ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '*'
	                                    )
	                                ) },
	                            _react2.default.createElement(_input2.default, {
	                                placeholder: '\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B',
	                                value: this.state.email,
	                                onChange: this.onChange.bind(this, 'email'),
	                                error: this.getError('email')
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u0412\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D' },
	                            _react2.default.createElement(_inputMask2.default, {
	                                placeholder: '+7 (\u043A\u043E\u0434) \u0445\u0445\u0445-\u0445\u0445-\u0445\u0445',
	                                value: this.state.phone,
	                                onChange: this.onChange.bind(this, 'phone'),
	                                error: this.getError('phone'),
	                                mask: '+7 (999) 999-99-99'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442', nowrap: true },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'b-block__text clearAfter' },
	                                this.state.captcha ? _react2.default.createElement('div', { className: 'captcha', style: {
	                                        background: 'url(data:image/gif;base64,' + this.state.captcha.image + ') no-repeat left center'
	                                    } }) : null,
	                                _react2.default.createElement('a', { href: '#', className: 'captcha-refresh', onClick: this.getCaptcha.bind(this) })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F', nowrap: true },
	                            _react2.default.createElement(_input2.default, {
	                                placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F',
	                                value: this.state.captcha_value,
	                                onChange: this.onChange.bind(this, 'captcha_value'),
	                                error: this.getError('captcha.value')
	                            }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'b-block__comment' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '*'
	                                ),
	                                ' \u041F\u043E\u043B\u044F, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-modal__bottom' },
	                            _react2.default.createElement(
	                                _block2.default,
	                                { size: 'xl' },
	                                _react2.default.createElement(_checkbox2.default, {
	                                    checked: this.state.confirmed,
	                                    onChange: this.onChange.bind(this, 'confirmed'),
	                                    label: '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445'
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-modal__buttons' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: (0, _classnames2.default)('b-button b-button_red b-button_size_md', this.state.confirmed ? 'b-button_shadow_red' : 'b-button_disabled b-button_shadow_gray'),
	                                    onClick: this.submit.bind(this) },
	                                '\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'deleteFile',
	        value: function deleteFile(index, e) {
	            e.preventDefault();
	
	            var files = this.state.files;
	            files.splice(index, 1);
	            this.setState({ files: files });
	        }
	    }, {
	        key: 'submit',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
	                var response;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                e.preventDefault();
	
	                                if (this.state.confirmed) {
	                                    _context2.next = 4;
	                                    break;
	                                }
	
	                                alerts.error('Не подтверждено согласие на обработку персональных данных');
	                                return _context2.abrupt('return');
	
	                            case 4:
	                                _context2.next = 6;
	                                return this.props.sendFeedback({
	                                    type_of_treatment: this.state.type_of_treatment,
	                                    title: this.state.title,
	                                    body: this.state.body,
	                                    full_name: this.state.full_name,
	                                    email: this.state.email,
	                                    phone: this.state.phone,
	                                    files: this.state.files,
	                                    captcha: {
	                                        uuid: this.state.captcha.uuid,
	                                        value: this.state.captcha_value
	                                    }
	                                });
	
	                            case 6:
	                                response = _context2.sent;
	
	                                if (response.isOk) {
	                                    alerts.success('Ваше обращение принято', null, this.props.onClose);
	                                } else {
	                                    this.setState({
	                                        errors: response.validationErrors
	                                    });
	                                    response.showErrors();
	                                }
	
	                            case 8:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function submit(_x2) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return submit;
	        }()
	    }, {
	        key: 'onChange',
	        value: function onChange(field, e) {
	            var value = (0, _get3.default)(e, 'target.value');
	            var state = this.state;
	            (0, _set3.default)(state, field, value);
	            this.setState(state);
	        }
	    }, {
	        key: 'onTypeChange',
	        value: function onTypeChange(e) {
	            var value = e ? e.value : null;
	            this.setState({
	                type_of_treatment: value
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close(e) {
	            e.preventDefault();
	
	            this.props.onClose();
	        }
	    }, {
	        key: 'uploadFile',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e, results) {
	                var tokenInfo, formData, response, files;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.getUploadToken();
	
	                            case 2:
	                                tokenInfo = _context3.sent;
	                                formData = new FormData();
	
	
	                                results.forEach(function (result) {
	                                    var _result = _slicedToArray(result, 2),
	                                        e = _result[0],
	                                        file = _result[1];
	
	                                    formData.append('file', file);
	                                });
	
	                                formData.append('token', tokenInfo.token);
	
	                                _context3.prev = 6;
	                                _context3.next = 9;
	                                return _api.api.storage.uploadFile(tokenInfo.upload_url, formData);
	
	                            case 9:
	                                response = _context3.sent;
	                                files = this.state.files;
	
	                                files.push(response);
	                                this.setState({ files: files });
	                                _context3.next = 18;
	                                break;
	
	                            case 15:
	                                _context3.prev = 15;
	                                _context3.t0 = _context3['catch'](6);
	
	                                alerts.error('Невозможно загрузить данный файл');
	
	                            case 18:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this, [[6, 15]]);
	            }));
	
	            function uploadFile(_x3, _x4) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return uploadFile;
	        }()
	    }, {
	        key: 'getUploadToken',
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.prev = 0;
	                                _context4.next = 3;
	                                return _api.api.storage.getUploadToken();
	
	                            case 3:
	                                response = _context4.sent;
	                                return _context4.abrupt('return', response.payload);
	
	                            case 7:
	                                _context4.prev = 7;
	                                _context4.t0 = _context4['catch'](0);
	
	                                alerts.error('Невозможно загрузить файл');
	
	                            case 10:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this, [[0, 7]]);
	            }));
	
	            function getUploadToken() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return getUploadToken;
	        }()
	    }, {
	        key: 'getError',
	        value: function getError(field) {
	            return (0, _get3.default)(this.state.errors, field);
	        }
	    }]);
	
	    return FeedbackComponent;
	}(_react.Component)) || _class) || _class);
	exports.default = FeedbackComponent;

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(450);
	
	var _reactInputMask = __webpack_require__(355);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputMask = (_dec = (0, _reactPropsDecorators.propTypes)({
	    mask: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(InputMask, _Component);
	
	    function InputMask() {
	        _classCallCheck(this, InputMask);
	
	        return _possibleConstructorReturn(this, (InputMask.__proto__ || Object.getPrototypeOf(InputMask)).apply(this, arguments));
	    }
	
	    _createClass(InputMask, [{
	        key: 'render',
	        value: function render() {
	            var inputProps = {};
	
	            if (this.props.onEnter) inputProps.onKeyPress = this.handleKeyPress.bind(this);
	
	            if (this.props.name) inputProps.name = this.props.name;
	
	            if (this.props.value) {
	                inputProps.value = this.props.value;
	            }
	
	            inputProps.disabled = this.props.disabled;
	            inputProps.onKeyPress = this.props.onKeyPress;
	
	            var styleClassName = (0, _classnames2.default)('input__style', this.props.error ? 'input__style_state_wrong' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('input', this.props.className) },
	                _react2.default.createElement(_reactInputMask2.default, _extends({
	                    ref: 'input',
	                    mask: this.props.mask,
	                    className: 'input__control',
	                    defaultValue: this.props.defaultValue,
	                    type: this.props.type,
	                    placeholder: this.props.placeholder,
	                    onChange: this.props.onChange
	                }, inputProps)),
	                _react2.default.createElement(
	                    'div',
	                    { className: styleClassName },
	                    this.props.error ? _react2.default.createElement(
	                        'span',
	                        { className: 'input__style_state_msg input__style_state_msg_wrong' },
	                        this.props.error
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'handleKeyPress',
	        value: function handleKeyPress(e) {
	            if (e.key === 'Enter') {
	                e.preventDefault();
	                this.props.onEnter();
	            }
	        }
	    }]);
	
	    return InputMask;
	}(_react.Component)) || _class) || _class);
	exports.default = InputMask;

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _colors = __webpack_require__(380);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	__webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconButton = (_dec = (0, _reactPropsDecorators.propTypes)({
	    icon: _propTypes2.default.string.isRequired,
	    size: _propTypes2.default.number,
	    color: _propTypes2.default.oneOf(_colors2.default.All),
	    onClick: _propTypes2.default.func,
	    onDisabledClick: _propTypes2.default.func,
	    disabled: _propTypes2.default.bool,
	    active: _propTypes2.default.bool,
	    className: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    onClick: function onClick() {},
	    onDisabledClick: function onDisabledClick() {},
	    disabled: false,
	    active: false,
	    className: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(IconButton, _Component);
	
	    function IconButton() {
	        _classCallCheck(this, IconButton);
	
	        return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
	    }
	
	    _createClass(IconButton, [{
	        key: 'render',
	        value: function render() {
	            var _context;
	
	            return this.renderIcon({
	                onClick: this.props.disabled ? this.props.onDisabledClick : (_context = this.props).onClick.bind(_context)
	            });
	        }
	    }, {
	        key: 'renderIcon',
	        value: function renderIcon(props) {
	            var wrapperClassName = (0, _classnames2.default)('top-menu__link', 'top-menu__link_icon_' + this.props.icon, this.props.disabled ? 'disabled' : '', this.props.active ? 'active' : '', this.props.className);
	            var tooltipClassName = (0, _classnames2.default)('top-menu__title', 'top-menu__title_' + this.props.icon);
	
	            var styles = {};
	
	            if (this.props.size) styles.fontSize = this.props.size;
	
	            if (this.props.color) styles.color = this.props.color;
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ ref: 'container', className: wrapperClassName }, props),
	                this.props.tooltip ? _react2.default.createElement(
	                    'span',
	                    { className: tooltipClassName, style: styles },
	                    this.props.tooltip
	                ) : ''
	            );
	        }
	    }]);
	
	    return IconButton;
	}(_react.Component)) || _class) || _class);
	exports.default = IconButton;

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _reactLoaders = __webpack_require__(693);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1114);
	
	__webpack_require__(1096);
	
	var _colors = __webpack_require__(380);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoaderComponent = (_dec = (0, _reactPropsDecorators.propTypes)({
	  style: _propTypes2.default.object,
	  size: _propTypes2.default.oneOf([32, 64, 128]),
	  color: _propTypes2.default.oneOf(_colors2.default.AllNames),
	  align: _propTypes2.default.oneOf(['none', 'center', 'top', 'bottom'])
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	  style: {},
	  size: 32,
	  color: 'white',
	  align: 'center'
	}), _dec(_class = _dec2(_class = function (_Component) {
	  _inherits(LoaderComponent, _Component);
	
	  function LoaderComponent() {
	    _classCallCheck(this, LoaderComponent);
	
	    return _possibleConstructorReturn(this, (LoaderComponent.__proto__ || Object.getPrototypeOf(LoaderComponent)).apply(this, arguments));
	  }
	
	  _createClass(LoaderComponent, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)('tail-spin', 'tail-spin-' + this.props.size, 'tail-spin-' + this.props.color, 'tail-spin-' + this.props.align);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Loader', style: this.props.style },
	        _react2.default.createElement('div', { className: className })
	      );
	    }
	  }]);
	
	  return LoaderComponent;
	}(_react.Component)) || _class) || _class);
	exports.default = LoaderComponent;

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapZoomButton = (_dec = (0, _reactPropsDecorators.propTypes)({
	    type: _propTypes2.default.oneOf(['in', 'out', 'locate', 'measure', 'routing', 'closest']).isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    tooltip: _propTypes2.default.string
	}), _dec(_class = function (_Component) {
	    _inherits(MapZoomButton, _Component);
	
	    function MapZoomButton() {
	        _classCallCheck(this, MapZoomButton);
	
	        return _possibleConstructorReturn(this, (MapZoomButton.__proto__ || Object.getPrototypeOf(MapZoomButton)).apply(this, arguments));
	    }
	
	    _createClass(MapZoomButton, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('b-button-zoom ', 'b-button-zoom_' + this.props.type);
	
	            return _react2.default.createElement('a', { className: className, href: '#', title: this.props.tooltip, onClick: this.onClick.bind(this) });
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(e) {
	            e.preventDefault();
	
	            this.props.onClick();
	        }
	    }]);
	
	    return MapZoomButton;
	}(_react.Component)) || _class);
	exports.default = MapZoomButton;

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbstractMapLayer = (_dec = (0, _reactPropsDecorators.propTypes)({
	    map: _propTypes2.default.object.isRequired,
	    leafletMap: _propTypes2.default.object.isRequired
	}), _dec(_class = function (_Component) {
	    _inherits(AbstractMapLayer, _Component);
	
	    function AbstractMapLayer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AbstractMapLayer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractMapLayer.__proto__ || Object.getPrototypeOf(AbstractMapLayer)).call.apply(_ref, [this].concat(args))), _this), _this.__layer = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AbstractMapLayer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.__layer = new _leaflet2.default.layerGroup();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.leafletMap.addLayer(this.__layer);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.leafletMap.removeLayer(this.__layer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return AbstractMapLayer;
	}(_react.Component)) || _class);
	exports.default = AbstractMapLayer;

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _indexOf2 = __webpack_require__(225);
	
	var _indexOf3 = _interopRequireDefault(_indexOf2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _dec3, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _layer = __webpack_require__(373);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	var _reactRedux = __webpack_require__(17);
	
	var _routes = __webpack_require__(151);
	
	var _stopPointMarker = __webpack_require__(375);
	
	var _stopPointMarker2 = _interopRequireDefault(_stopPointMarker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StopPointsMtaLayer = (_dec = (0, _reactPropsDecorators.propTypes)({
	    onStopPointClick: _propTypes2.default.func,
	    onStopPointDblClick: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    onStopPointClick: null,
	    onStopPointDblClick: function onStopPointDblClick() {}
	}), _dec3 = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getStopPointsWithBounds: _routes.getStopPointsWithBounds }), _dec(_class = _dec2(_class = _dec3(_class = function (_AbstractMapLayer) {
	    _inherits(StopPointsMtaLayer, _AbstractMapLayer);
	
	    function StopPointsMtaLayer() {
	        var _ref, _context;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StopPointsMtaLayer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StopPointsMtaLayer.__proto__ || Object.getPrototypeOf(StopPointsMtaLayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            stopPoints: [],
	            editorUuid: null,
	            requestIndex: 0
	        }, _this.loadStopPointsCallback = (_context = _this).loadStopPoints.bind(_context), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(StopPointsMtaLayer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _get(StopPointsMtaLayer.prototype.__proto__ || Object.getPrototypeOf(StopPointsMtaLayer.prototype), 'componentWillMount', this).call(this);
	
	            this.props.leafletMap.on('moveend', this.loadStopPointsCallback);
	
	            this.loadStopPoints();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            _get(StopPointsMtaLayer.prototype.__proto__ || Object.getPrototypeOf(StopPointsMtaLayer.prototype), 'componentWillUnmount', this).call(this);
	
	            this.props.leafletMap.off('moveend', this.loadStopPointsCallback);
	        }
	    }, {
	        key: 'loadStopPoints',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var requestIndex, boundingBox, zoom, response;
	                return regeneratorRuntime.wrap(function _callee$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.setState({
	                                    requestIndex: this.state.requestIndex + 1
	                                });
	
	                            case 2:
	                                requestIndex = this.state.requestIndex;
	                                boundingBox = this.props.map.getBoundingBox();
	                                zoom = this.props.map.getZoom();
	                                _context2.next = 7;
	                                return this.props.getStopPointsWithBounds(boundingBox, zoom);
	
	                            case 7:
	                                response = _context2.sent;
	
	                                if (this.state.requestIndex === requestIndex) {
	                                    if (response.isOk) {
	                                        this.setState({
	                                            stopPoints: response.payload.items
	                                        });
	                                    } else {
	                                        response.showErrors();
	                                    }
	                                }
	
	                            case 9:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadStopPoints() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadStopPoints;
	        }()
	    }, {
	        key: 'onEditClick',
	        value: function onEditClick(uuid) {
	            this.setState({
	                editorUuid: uuid
	            });
	        }
	    }, {
	        key: 'closeEditor',
	        value: function closeEditor() {
	            this.setState({
	                editorUuid: null
	            });
	        }
	    }, {
	        key: 'getEditor',
	        value: function getEditor() {
	            return _react2.default.createElement(StopPointsEditor, {
	                mode: 'edit',
	                uuid: this.state.editorUuid,
	                onSubmit: this.closeEditor.bind(this),
	                onClose: this.closeEditor.bind(this)
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var editor = this.state.editorUuid ? this.getEditor() : null;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                editor,
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' } },
	                    this.state.stopPoints.map(this.renderStopPoint.bind(this))
	                )
	            );
	        }
	    }, {
	        key: 'renderStopPoint',
	        value: function renderStopPoint(stopPoint) {
	            var color = this.getColor(stopPoint);
	
	            return _react2.default.createElement(_stopPointMarker2.default, _extends({
	                key: stopPoint.uuid + ':' + color
	            }, this.props, {
	                latitude: stopPoint.latitude,
	                longitude: stopPoint.longitude,
	                item: stopPoint,
	                permanentTooltip: this.props.selectedStopPoint === stopPoint.uuid,
	                onClick: this.props.onStopPointClick ? this.onClick.bind(this, stopPoint) : null,
	                onDblClick: this.props.onStopPointDblClick.bind(this, stopPoint.uuid, stopPoint.latitude, stopPoint.longitude),
	                onEditClick: this.onEditClick.bind(this, stopPoint.uuid),
	                onScheduleClick: this.onScheduleClick.bind(this, stopPoint),
	                onFromHereClick: this.onFromHereClick.bind(this, stopPoint),
	                onToHereClick: this.onToHereClick.bind(this, stopPoint),
	                color: color
	            }));
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor(stopPoint) {
	            var selectedStopPoints = this.props.selectedStopPoints;
	
	            if ((0, _indexOf3.default)(selectedStopPoints, stopPoint.uuid) !== -1) {
	                return 'red';
	            }
	
	            return null;
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(stopPoint) {
	            this.props.onStopPointClick(stopPoint);
	        }
	    }, {
	        key: 'onScheduleClick',
	        value: function onScheduleClick(stopPoint) {
	            this.props.onStopPointScheduleClick(stopPoint);
	        }
	    }, {
	        key: 'onFromHereClick',
	        value: function onFromHereClick(stopPoint) {
	            this.props.onStopPointFromHereClick(stopPoint);
	        }
	    }, {
	        key: 'onToHereClick',
	        value: function onToHereClick(stopPoint) {
	            this.props.onStopPointToHereClick(stopPoint);
	        }
	    }]);
	
	    return StopPointsMtaLayer;
	}(_layer2.default)) || _class) || _class) || _class);
	exports.default = StopPointsMtaLayer;

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _round2 = __webpack_require__(229);
	
	var _round3 = _interopRequireDefault(_round2);
	
	var _get3 = __webpack_require__(31);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get2 = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _marker = __webpack_require__(187);
	
	var _marker2 = _interopRequireDefault(_marker);
	
	var _stopPointIcon = __webpack_require__(766);
	
	var _stopPointIcon2 = _interopRequireDefault(_stopPointIcon);
	
	var _reactLeafletPopup = __webpack_require__(179);
	
	var _reactLeafletPopup2 = _interopRequireDefault(_reactLeafletPopup);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(1105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StopPointMarker = (_dec = (0, _reactPropsDecorators.propTypes)({
	    item: _propTypes2.default.object,
	    color: _propTypes2.default.oneOf([null, 'red', 'green']),
	    permanentTooltip: _propTypes2.default.bool,
	    withoutPopup: _propTypes2.default.bool,
	    onEditClick: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    color: null,
	    permanentTooltip: false,
	    withoutPopup: false,
	    onEditClick: null
	}), _dec(_class = _dec2(_class = function (_AbstractMapMarker) {
	    _inherits(StopPointMarker, _AbstractMapMarker);
	
	    function StopPointMarker() {
	        _classCallCheck(this, StopPointMarker);
	
	        return _possibleConstructorReturn(this, (StopPointMarker.__proto__ || Object.getPrototypeOf(StopPointMarker)).apply(this, arguments));
	    }
	
	    _createClass(StopPointMarker, [{
	        key: 'getOptions',
	        value: function getOptions() {
	            return {
	                icon: _stopPointIcon2.default.getIcon(this.props.color),
	                riseOnHover: true,
	                zIndexOffset: this.props.zIndex
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _get2(StopPointMarker.prototype.__proto__ || Object.getPrototypeOf(StopPointMarker.prototype), 'componentWillMount', this).call(this);
	
	            if (this.props.onClick === null && !this.props.withoutPopup) {
	                this.getMarker().on('click', this.loadPopup.bind(this));
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _get2(StopPointMarker.prototype.__proto__ || Object.getPrototypeOf(StopPointMarker.prototype), 'componentDidMount', this).call(this);
	
	            this.forceUpdate();
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(props) {
	            var oldItem = this.props.item;
	            var newItem = props.item;
	
	            this.checkTitleUpdate(oldItem, newItem, props);
	        }
	    }, {
	        key: 'checkTitleUpdate',
	        value: function checkTitleUpdate(oldItem, newItem, props) {
	            var marker = this.getMarker();
	            var oldTitle = (0, _get4.default)(oldItem, 'title');
	            var newTitle = (0, _get4.default)(newItem, 'title');
	            var oldPermanentToolTip = this.props.permanentTooltip;
	            var newPermanentToolTip = props.permanentTooltip;
	            if ((oldPermanentToolTip !== newPermanentToolTip || oldTitle !== newTitle || !marker.getTooltip()) && newTitle) {
	                marker.unbindTooltip().bindTooltip(newTitle, {
	                    sticky: true,
	                    permanent: newPermanentToolTip
	                });
	            }
	        }
	    }, {
	        key: 'loadPopup',
	        value: function loadPopup() {
	            if (!this.props.item) {
	                return;
	            }
	
	            var marker = this.getMarker();
	            marker.unbindPopup();
	            marker.closePopup();
	            marker.bindPopup(this.createStopPointPopup(marker.closePopup.bind(marker)));
	            marker.openPopup();
	        }
	    }, {
	        key: 'createStopPointPopup',
	        value: function createStopPointPopup(onClose) {
	            var stopPoint = this.props.item;
	            if (!stopPoint) {
	                return null;
	            }
	
	            return new _reactLeafletPopup2.default({
	                reactComponent: StopPointPopup,
	                reactComponentProps: _extends({}, this.props, {
	                    stopPoint: stopPoint,
	                    onClose: onClose
	                }),
	                minWidth: 434,
	                maxWidth: 434,
	                offset: new _leaflet2.default.Point(3, -250)
	            });
	        }
	    }]);
	
	    return StopPointMarker;
	}(_marker2.default)) || _class) || _class);
	exports.default = StopPointMarker;
	
	var StopPointPopup = function (_Component) {
	    _inherits(StopPointPopup, _Component);
	
	    function StopPointPopup() {
	        _classCallCheck(this, StopPointPopup);
	
	        return _possibleConstructorReturn(this, (StopPointPopup.__proto__ || Object.getPrototypeOf(StopPointPopup)).apply(this, arguments));
	    }
	
	    _createClass(StopPointPopup, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                stopPoint = _props.stopPoint,
	                onScheduleClick = _props.onScheduleClick,
	                onFromHereClick = _props.onFromHereClick,
	                onToHereClick = _props.onToHereClick;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'b-modal b-modal-map map-tooltip-modal tooltip-stop b-modal_stop-point' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__header' },
	                    _react2.default.createElement('a', { href: '#', className: 'b-modal__close', onClick: this.onClose.bind(this) }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__name align-middle' },
	                        stopPoint.title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__body' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            (0, _round3.default)(stopPoint.latitude, 6),
	                            ', ',
	                            (0, _round3.default)(stopPoint.longitude, 6)
	                        )
	                    ),
	                    stopPoint.location ? _react2.default.createElement(
	                        'div',
	                        { className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u041C\u0435\u0441\u0442\u043E \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            stopPoint.location
	                        )
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__footer' },
	                    !window.RNIS_SETTINGS.get_away_button_hide ? _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:void(0)', className: 'b-button b-button_size_md b-button_red b-button_card',
	                            onClick: this.onFromHereClick.bind(this) },
	                        '\u0423\u0435\u0445\u0430\u0442\u044C \u043E\u0442\u0441\u044E\u0434\u0430'
	                    ) : null,
	                    !window.RNIS_SETTINGS.get_away_button_hide ? _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:void(0)', className: 'b-button b-button_size_md b-button_red b-button_card',
	                            onClick: this.onToHereClick.bind(this) },
	                        '\u0423\u0435\u0445\u0430\u0442\u044C \u0441\u044E\u0434\u0430'
	                    ) : null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:void(0)', className: 'b-button b-button_size_md b-button_red b-button_card',
	                            onClick: this.onScheduleClick.bind(this) },
	                        '\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'onFromHereClick',
	        value: function onFromHereClick() {
	            this.props.onFromHereClick();
	            this.props.onClose();
	        }
	    }, {
	        key: 'onToHereClick',
	        value: function onToHereClick() {
	            this.props.onToHereClick();
	            this.props.onClose();
	        }
	    }, {
	        key: 'onScheduleClick',
	        value: function onScheduleClick() {
	            this.props.onScheduleClick();
	            this.props.onClose();
	        }
	    }, {
	        key: 'onClose',
	        value: function onClose(e) {
	            e.preventDefault();
	            this.props.onClose();
	        }
	    }]);
	
	    return StopPointPopup;
	}(_react.Component);

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(35);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTopMenuListItem = (_dec = (0, _reactPropsDecorators.propTypes)({
	    href: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    innerClassName: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    onClick: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    href: '#',
	    className: '',
	    innerClassName: '',
	    title: '',
	    onClick: null
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(ModalTopMenuListItem, _Component);
	
	    function ModalTopMenuListItem() {
	        _classCallCheck(this, ModalTopMenuListItem);
	
	        return _possibleConstructorReturn(this, (ModalTopMenuListItem.__proto__ || Object.getPrototypeOf(ModalTopMenuListItem)).apply(this, arguments));
	    }
	
	    _createClass(ModalTopMenuListItem, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('top-menu_modal__link b-icon-link b-icon-link_params', this.props.className);
	
	            return _react2.default.createElement(
	                'li',
	                { className: 'top-menu_modal__item' },
	                _react2.default.createElement(_reactRouter.Link, { to: this.props.href, className: className, onClick: this.onClick.bind(this) })
	            );
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(e) {
	            if (this.props.onClick) {
	                e.preventDefault();
	
	                this.props.onClick();
	            }
	        }
	    }]);
	
	    return ModalTopMenuListItem;
	}(_react.Component)) || _class) || _class);
	exports.default = ModalTopMenuListItem;

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(451);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTopMenuList = (_dec = (0, _reactPropsDecorators.propTypes)({
	    className: _propTypes2.default.string
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    className: ''
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(ModalTopMenuList, _Component);
	
	    function ModalTopMenuList() {
	        _classCallCheck(this, ModalTopMenuList);
	
	        return _possibleConstructorReturn(this, (ModalTopMenuList.__proto__ || Object.getPrototypeOf(ModalTopMenuList)).apply(this, arguments));
	    }
	
	    _createClass(ModalTopMenuList, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('top-menu_modal clearAfter', this.props.className);
	
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'top-menu_modal__list' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return ModalTopMenuList;
	}(_react.Component)) || _class) || _class);
	exports.default = ModalTopMenuList;

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PageHeaderButton = exports.default = undefined;
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _dec2, _class2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	__webpack_require__(1108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageHeader = (_dec = (0, _reactPropsDecorators.propTypes)({
	    title: _propTypes2.default.string,
	    actions: _propTypes2.default.array,
	    contents: _propTypes2.default.array
	}), _dec(_class = function (_Component) {
	    _inherits(PageHeader, _Component);
	
	    function PageHeader() {
	        _classCallCheck(this, PageHeader);
	
	        return _possibleConstructorReturn(this, (PageHeader.__proto__ || Object.getPrototypeOf(PageHeader)).apply(this, arguments));
	    }
	
	    _createClass(PageHeader, [{
	        key: 'logoImageCondition',
	        value: function logoImageCondition() {
	            /* if (window.RNIS_SETTINGS.CITY_OMSK) {
	                 return '/static/img/logo_portal_omsk.png';
	             }
	             if (window.RNIS_SETTINGS.CITY_MURMANSK) {
	                 return '/static/img/logo_portal_murmansk.png';
	             }
	             return '/static/img/logo_portal_moscow.png';*/
	            return window.RNIS_SETTINGS.LOGOIMAGE;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var list = [];
	
	            (0, _each3.default)(this.props.contents, function (content, i) {
	                list.push(_react2.default.createElement(
	                    'li',
	                    { className: 'top-menu__item', key: 'content' + i },
	                    content
	                ));
	            });
	            if (this.props.contents && this.props.actions && this.props.contents.length && this.props.actions.length) {
	                list.push(_react2.default.createElement(
	                    'li',
	                    { className: 'top-menu__item', key: 'separator' },
	                    _react2.default.createElement('div', { className: 'top-menu__separator' })
	                ));
	            }
	            (0, _each3.default)(this.props.actions, function (action, i) {
	                list.push(_react2.default.createElement(
	                    'li',
	                    { className: 'top-menu__item', key: 'action' + i },
	                    action
	                ));
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'header header_fixed clearAfter' },
	                window.RNIS_SETTINGS.LOGOIMAGE ? _react2.default.createElement(
	                    'div',
	                    { className: 'header__logonobg' },
	                    _react2.default.createElement('img', { src: this.logoImageCondition(), alt: 'logo' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'header__logo-txt' },
	                        window.RNIS_SETTINGS.TITLE
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'header__logo' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'header__logo-txt' },
	                        window.RNIS_SETTINGS.TITLE
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'header__title' },
	                    this.props.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'top-menu clearAfter' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'top-menu__list' },
	                        list
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PageHeader;
	}(_react.Component)) || _class);
	exports.default = PageHeader;
	var PageHeaderButton = exports.PageHeaderButton = (_dec2 = (0, _reactPropsDecorators.propTypes)({
	    text: _propTypes2.default.string,
	    icon: _propTypes2.default.string
	}), _dec2(_class2 = function (_Component2) {
	    _inherits(PageHeaderButton, _Component2);
	
	    function PageHeaderButton() {
	        _classCallCheck(this, PageHeaderButton);
	
	        return _possibleConstructorReturn(this, (PageHeaderButton.__proto__ || Object.getPrototypeOf(PageHeaderButton)).apply(this, arguments));
	    }
	
	    _createClass(PageHeaderButton, [{
	        key: 'render',
	        value: function render() {
	            var Icon = this.props.icon ? _react2.default.createElement('i', { className: ['icon', 'icon-' + this.props.icon, 'icon-16'].join(' ') }) : '';
	
	            var Text = this.props.text ? _react2.default.createElement(
	                'div',
	                { className: 'text' },
	                this.props.text
	            ) : '';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'page-header-button' },
	                Icon,
	                Text
	            );
	        }
	    }]);
	
	    return PageHeaderButton;
	}(_react.Component)) || _class2);

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactInputMask = __webpack_require__(355);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldMask = (_dec = (0, _reactPropsDecorators.propTypes)({
	    placeholder: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    mask: _propTypes2.default.string,
	    size: _propTypes2.default.oneOf(['sm', 'md', 'lg']),
	    success: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	
	    value: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onEnter: _propTypes2.default.func,
	    withTimeIcon: _propTypes2.default.bool
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    value: '',
	    mask: '',
	    onChange: function onChange() {},
	    placeholder: '',
	    type: 'text',
	    size: 'lg',
	    withTimeIcon: false
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(TextFieldMask, _Component);
	
	    function TextFieldMask() {
	        _classCallCheck(this, TextFieldMask);
	
	        return _possibleConstructorReturn(this, (TextFieldMask.__proto__ || Object.getPrototypeOf(TextFieldMask)).apply(this, arguments));
	    }
	
	    _createClass(TextFieldMask, [{
	        key: 'render',
	        value: function render() {
	            var textFieldState = this.getCurrentTextfieldState();
	            var className = (0, _classnames2.default)('text-field', 'text-field-' + this.props.size, textFieldState ? 'text-field-' + textFieldState : '');
	
	            var style = {};
	
	            var Hint = this.renderHint();
	
	            var props = Object.assign({}, this.props);
	            delete props.error;
	            delete props.withTimeIcon;
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, style: style },
	                _react2.default.createElement(_reactInputMask2.default, _extends({ mask: this.props.mask }, props)),
	                this.props.withTimeIcon ? _react2.default.createElement('span', { className: 'b-icon-link b-icon-link_icon_timepicker datepicker__icon' }) : null,
	                Hint
	            );
	        }
	    }, {
	        key: 'handleKeyPress',
	        value: function handleKeyPress(e) {
	            if (e.key === 'Enter') {
	                this.props.onEnter();
	            }
	        }
	    }, {
	        key: 'getCurrentTextfieldState',
	        value: function getCurrentTextfieldState() {
	            if (this.props.success) return 'success';
	
	            if (this.props.error) return 'error';
	
	            return false;
	        }
	    }, {
	        key: 'renderHint',
	        value: function renderHint() {
	            if (this.props.success && this.props.success.length > 0) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'hint' },
	                    this.props.success
	                );
	            } else if (this.props.error && this.props.error.length) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'hint' },
	                    this.props.error
	                );
	            }
	        }
	    }]);
	
	    return TextFieldMask;
	}(_react.Component)) || _class) || _class);
	exports.default = TextFieldMask;

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Colors = {
	  'red': '#FF5C55',
	  'asphalt': '#454C54',
	  'asphalt2': '#373d42',
	  'blue': '#39a1db',
	  'green': '#98c200',
	  'purple': '#b070eb',
	  'orange': '#fb9237',
	  'yellow': '#ffb400',
	  'gray': '#a1a4a6',
	  'grayLight': '#dcdcdc',
	  'white': '#fff',
	  'steel': '#8a8e92'
	};
	
	var getAllColors = function getAllColors() {
	  var names = Object.keys(Colors);
	  return names.concat(names.map(function (c) {
	    return Colors[c];
	  }));
	};
	
	var getColorNames = function getColorNames() {
	  var out = {};
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(Colors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var color = _step.value;
	
	      out[color] = color;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return out;
	};
	
	exports.default = _extends({}, Colors, {
	  All: getAllColors(),
	  AllNames: Object.keys(Colors),
	  Names: getColorNames()
	});

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.printForm = exports.printTable = exports.getTableForPrint = exports.print = undefined;
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var print = exports.print = function print(html, cb, delay) {
	    var iframe = document.createElement('iframe');
	    iframe.setAttribute('sandbox', 'allow-modals allow-same-origin allow-scripts');
	    iframe.setAttribute('src', 'about:blank');
	    iframe.setAttribute('style', 'visibility: hidden;pointer-events:none;border:none;');
	
	    document.body.appendChild(iframe);
	
	    var teardown = function teardown() {
	        // Safari crashes without a timeout.
	        setTimeout(function () {
	            return document.body.removeChild(iframe);
	        }, 0);
	        if (typeof cb === 'function') cb();
	    };
	
	    setTimeout(function () {
	        iframe.contentDocument.write(html);
	
	        setTimeout(function () {
	            iframe.contentWindow.focus();
	            try {
	                iframe.contentWindow.document.execCommand('print', false, null) || iframe.contentWindow.print();
	            } catch (e) {
	                iframe.contentWindow.print();
	            }
	        }, delay || 50);
	    }, 0);
	};
	
	var getTableForPrint = exports.getTableForPrint = function getTableForPrint(headers, rows) {
	    // Construct a table for printing
	    var table = (0, _jquery2.default)('<table cellspacing="0" cellpadding="0"><thead><tr></tr></thead><tbody></tbody></table>');
	
	    var thead = table.find('thead tr');
	    var tbody = table.find('tbody');
	
	    _jquery2.default.each(headers, function (index, header) {
	        if (!(0, _jquery2.default)(header).is(':visible')) {
	            return;
	        }
	        var headerClone = (0, _jquery2.default)(header).clone();
	        headerClone.find('div').remove();
	        thead.append((0, _jquery2.default)('<th style="white-space:nowrap;">').text(headerClone.text()));
	    });
	
	    _jquery2.default.each(rows, function (index, row) {
	        var rowElement = (0, _jquery2.default)('<tr>');
	        tbody.append(rowElement);
	
	        var cells = (0, _jquery2.default)(row).find('td');
	        _jquery2.default.each(cells, function (cellIndex, cell) {
	            var text = (0, _jquery2.default)(cell).html();
	            var el = (0, _jquery2.default)('<td style="border: 1px black solid !important;padding: 5px;">').html(text);
	
	            rowElement.append(el);
	        });
	    });
	
	    var container = (0, _jquery2.default)('<div>');
	    container.append(table);
	    return container.html();
	};
	
	var printTable = exports.printTable = function printTable(headers, rows) {
	    var orientation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'landscape';
	    var pageSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'A4';
	
	    var html = getTableForPrint(headers, rows);
	    var style = '\n        <style>\n            @page {\n                size: ' + pageSize + ' ' + orientation + ';\n            }\n            .entity-deleted {\n                color: #a1a4a6;\n                text-decoration: line-through;\n            }\n            span {\n                display: block;\n            }\n        </style>\n    ';
	    print(style + html);
	};
	
	var addBlockToContainer = function addBlockToContainer(item, container) {
	    (0, _jquery2.default)(item).find('.b-block').each(function (_index, block) {
	        var blockTitle = (0, _jquery2.default)(block).find('.b-block__title').text() || (0, _jquery2.default)(block).find('.b-checkbox__label').text();
	        var input = (0, _jquery2.default)(block).find('input,textarea,.ql-editor');
	        var select = (0, _jquery2.default)(block).find('.Select-value-label');
	        var table = (0, _jquery2.default)(block).find('.Table');
	        var blockValue = '';
	        if (table.length > 0) {
	            var tableClone = table.clone();
	            tableClone.find('input').remove();
	            tableClone.find('.dataTables_filter').remove();
	            blockValue = tableClone.html();
	        } else {
	            if (select.length === 0) {
	                if (input.length === 0) {
	                    blockValue = (0, _jquery2.default)(block).find('.b-block__text').html();
	                } else {
	                    if (input.is('input[type="checkbox"]')) {
	                        (0, _jquery2.default)(block).find('input:checkbox').each(function () {
	                            var checkboxTitle = (0, _jquery2.default)(this).next().text();
	                            blockValue = (0, _jquery2.default)(this).is(':checked') ? '&check;' : '&times;';
	                            container.append('<p><strong>' + checkboxTitle + ':</strong> ' + blockValue + '</p>');
	                        });
	                        return;
	                    } else if (input.is('input[type="radio"]')) {
	                        var checked = (0, _jquery2.default)(block).find('input:radio:checked');
	                        if (checked.length > 0) {
	                            blockValue = checked.next().text();
	                        }
	                    } else {
	                        blockValue = input.val() || input.html();
	                    }
	                }
	            } else {
	                blockValue = (0, _jquery2.default)(select).text();
	            }
	        }
	
	        container.append('<p>' + (blockTitle ? '<strong>' + blockTitle + ':</strong> ' : '') + blockValue + '</p>');
	    });
	};
	
	var printForm = exports.printForm = function printForm(domNode) {
	    var container = (0, _jquery2.default)('<div>');
	
	    var el = (0, _jquery2.default)(domNode);
	    if (el.is('.b-modal__block')) {
	        addBlockToContainer(el, container);
	    }
	    el.find('.accordion__item').each(function (index, item) {
	        var title = (0, _jquery2.default)(item).find('.accordion__title').text();
	        container.append('<h2>' + title + '</h2>');
	
	        addBlockToContainer(item, container);
	    });
	    if (!el.is('.b-modal__block') && el.find('.accordion__item').length === 0) {
	        addBlockToContainer(el, container);
	    }
	    print(container.html());
	};

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.User = undefined;
	
	var _has2 = __webpack_require__(1261);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var User = exports.User = function () {
	    function User(user) {
	        _classCallCheck(this, User);
	
	        this.user = null;
	
	        this.user = user;
	    }
	
	    _createClass(User, [{
	        key: 'getFullName',
	        value: function getFullName() {
	            var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            if (full) {
	                return this.user.info.surname + ' ' + (this.user.info.name ? this.user.info.name : '') + ' ' + (this.user.info.second_name ? this.user.info.second_name : '');
	            } else {
	                return this.user.info.surname + ' ' + (this.user.info.name ? this.user.info.name.substr(0, 1) + '.' : '') + ' ' + (this.user.info.second_name ? this.user.info.second_name.substr(0, 1) + '.' : '');
	            }
	        }
	
	        /**
	         * Получение данных авторизации на Asterisk
	         *
	         * @return {{ext: string, password: string}}
	         */
	
	    }, {
	        key: 'SIPData',
	        get: function get() {
	            return {
	                ext: (0, _get3.default)(this.user, 'info.sip_ext'),
	                password: (0, _get3.default)(this.user, 'info.sip_password')
	            };
	        }
	
	        /**
	         * Проверка на наличие внутреннего SIP номера
	         *
	         * @return {boolean}
	         */
	
	    }, {
	        key: 'hasSipExt',
	        get: function get() {
	            return (0, _has3.default)(this.user, 'info.sip_ext');
	        }
	    }]);

	    return User;
	}();

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getGuestToken = undefined;
	exports.default = reducer;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	var _immutable = __webpack_require__(47);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var getGuestToken = exports.getGuestToken = function getGuestToken() {
	    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var response;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return _api.api.auth.getGuestToken();
	
	                    case 3:
	                        response = _context.sent;
	                        return _context.abrupt('return', (0, _response.success)(response));
	
	                    case 7:
	                        _context.prev = 7;
	                        _context.t0 = _context['catch'](0);
	                        return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                    case 10:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[0, 7]]);
	    }));
	};

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFaq = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var getFaq = exports.getFaq = function getFaq() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.portal.getFaq(meta);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLayers = exports.getObjects = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getObjects = exports.getObjects = function getObjects() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var cancelConditions = arguments[1];
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.garbage.getObjects(meta, cancelConditions);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getLayers = exports.getLayers = function getLayers() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { "items": [window.RNIS_SETTINGS.LAYERS_UUID] };
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.geo.listUserGeoObjectsByLayers(meta);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.connectionEstablished = exports.connectionLost = exports.connectWsRpc = undefined;
	
	var _isFunction2 = __webpack_require__(226);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _session = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({
	    isConnected: false,
	    isWebsocketsActive: false
	});
	
	var RPC_CONNECTED = 'RPC_CONNECTED';
	var RPC_CONNECTION_LOST = 'RPC_CONNECTION_LOST';
	var RPC_CONNECTION_ESTABLISHED = 'RPC_CONNECTION_ESTABLISHED';
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case RPC_CONNECTED:
	            return state.set('isConnected', true);
	        case RPC_CONNECTION_ESTABLISHED:
	            return state.set('isWebsocketsActive', true);
	        case RPC_CONNECTION_LOST:
	            return state.set('isWebsocketsActive', false);
	    }
	    return state;
	}
	
	var connectWsRpc = exports.connectWsRpc = function connectWsRpc() {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return (0, _session.connect)();
	
	                        case 2:
	
	                            dispatch({ type: RPC_CONNECTED });
	
	                        case 3:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var connectionLost = exports.connectionLost = function connectionLost(callback) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.next = 2;
	                            return _api.api.wsrpc.connectionLost(function (reason) {
	                                dispatch({
	                                    type: RPC_CONNECTION_LOST
	                                });
	
	                                (0, _isFunction3.default)(callback) && callback(reason);
	                            });
	
	                        case 2:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var connectionEstablished = exports.connectionEstablished = function connectionEstablished(callback) {
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.next = 2;
	                            return _api.api.wsrpc.connectionEstablished(function () {
	                                dispatch({
	                                    type: RPC_CONNECTION_ESTABLISHED
	                                });
	
	                                (0, _isFunction3.default)(callback) && callback();
	                            });
	
	                        case 2:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined);
	        }));
	
	        return function (_x5) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTelematicsTotalCount = exports.getTelematics = exports.getTelematicsWithDevices = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	    return state;
	}
	
	var getTelematicsWithDevices = exports.getTelematicsWithDevices = function getTelematicsWithDevices(devices, source, boundingBox, mapSize, zoom) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.telematics.getTelematicsWithDevices(devices, source, boundingBox, mapSize, zoom);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getTelematics = exports.getTelematics = function getTelematics(component, source, boundingBox, mapSize, zoom) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.telematics.getTelematics(component, source, boundingBox, mapSize, zoom);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var getTelematicsTotalCount = exports.getTelematicsTotalCount = function getTelematicsTotalCount() {
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _api.api.telematics.getTelematicsTotalCount();
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](0);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x5) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.closeSubmenu = exports.openSubmenu = undefined;
	
	var _clone2 = __webpack_require__(505);
	
	var _clone3 = _interopRequireDefault(_clone2);
	
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var OPEN_SUBMENU = 'OPEN_SUBMENU';
	var CLOSE_SUBMENU = 'CLOSE_SUBMENU';
	
	var initialState = new _immutable.Map({
	    submenu: []
	});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var submenu = void 0;
	    switch (action.type) {
	        case OPEN_SUBMENU:
	            submenu = (0, _clone3.default)(state.get('submenu'));
	            submenu.push(action.payload);
	            return state.set('submenu', submenu);
	        case CLOSE_SUBMENU:
	            submenu = (0, _clone3.default)(state.get('submenu'));
	            submenu.splice(-1, 1);
	            return state.set('submenu', submenu);
	    }
	    return state;
	}
	
	var openSubmenu = exports.openSubmenu = function openSubmenu(submenu) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            dispatch({ type: OPEN_SUBMENU, payload: submenu });
	
	                        case 1:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var closeSubmenu = exports.closeSubmenu = function closeSubmenu(submenu) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            dispatch({ type: CLOSE_SUBMENU });
	
	                        case 1:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.confirmEmailChangeCheck = exports.confirmEmailCheck = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var confirmEmailCheck = exports.confirmEmailCheck = function confirmEmailCheck(data) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.mobile.confirmEmailCheck(data);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var confirmEmailChangeCheck = exports.confirmEmailChangeCheck = function confirmEmailChangeCheck(data) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.mobile.confirmEmailChangeCheck(data);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x2) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPage = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var getPage = exports.getPage = function getPage(key) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.portal.getPage(key);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getVehicleListGuest = exports.getVehicleList = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	var _user = __webpack_require__(382);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var getVehicleList = exports.getVehicleList = function getVehicleList(meta) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.vehicles.getVehicleList(meta);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getVehicleListGuest = exports.getVehicleListGuest = function getVehicleListGuest(meta) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.vehicles.getVehicleListGuest(meta);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.set = set;
	exports.remove = remove;
	exports.save = save;
	exports.get = get;
	function set(key, value) {
	    return save(key, value);
	}
	
	function remove(key) {
	    save(key, null);
	}
	
	function save(key, value) {
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') value = JSON.stringify(value);
	
	    return localStorage.setItem(key, value);
	}
	
	function get(key) {
	    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    var value = localStorage.getItem(key);
	    if (value === null) {
	        return defaultValue;
	    }
	    try {
	        return JSON.parse(value);
	    } catch (e) {}
	    return value;
	}

/***/ }),

/***/ 449:
447,

/***/ 450:
447,

/***/ 451:
447,

/***/ 452:
447,

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(17);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _main = __webpack_require__(386);
	
	__webpack_require__(1071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        isConnected: state.main.get('isConnected')
	    };
	}, { connectWsRpc: _main.connectWsRpc, connectionLost: _main.connectionLost, connectionEstablished: _main.connectionEstablished }), _dec(_class = function (_Component) {
	    _inherits(AppComponent, _Component);
	
	    function AppComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AppComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppComponent.__proto__ || Object.getPrototypeOf(AppComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            websocketsActive: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AppComponent, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            localStorage.removeItem('user');
	            if (!this.props.isConnected) {
	                this.props.connectWsRpc();
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.listenWebsocketEvents();
	
	                            case 1:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return this.props.children;
	        }
	    }, {
	        key: "listenWebsocketEvents",
	        value: function listenWebsocketEvents() {
	            var _this2 = this;
	
	            this.props.connectionLost(function () {
	                _this2.setState({ websocketsActive: false });
	            });
	
	            this.props.connectionEstablished(function () {
	                _this2.setState({ websocketsActive: true });
	            });
	        }
	    }]);
	
	    return AppComponent;
	}(_react.Component)) || _class);
	exports.default = AppComponent;

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.store = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(35);
	
	var _App = __webpack_require__(731);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _reactRedux = __webpack_require__(17);
	
	var _createStore = __webpack_require__(791);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _notFound = __webpack_require__(746);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _map = __webpack_require__(738);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _news = __webpack_require__(745);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _full = __webpack_require__(742);
	
	var _full2 = _interopRequireDefault(_full);
	
	var _page = __webpack_require__(747);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _faq = __webpack_require__(735);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _carriers = __webpack_require__(734);
	
	var _carriers2 = _interopRequireDefault(_carriers);
	
	var _soon = __webpack_require__(750);
	
	var _soon2 = _interopRequireDefault(_soon);
	
	var _index = __webpack_require__(741);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(740);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(748);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _newsAll = __webpack_require__(743);
	
	var _newsAll2 = _interopRequireDefault(_newsAll);
	
	var _newsTag = __webpack_require__(744);
	
	var _newsTag2 = _interopRequireDefault(_newsTag);
	
	var _index7 = __webpack_require__(749);
	
	var _index8 = _interopRequireDefault(_index7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var store = exports.store = (0, _createStore2.default)();
	
	var Root = function (_Component) {
	    _inherits(Root, _Component);
	
	    function Root() {
	        _classCallCheck(this, Root);
	
	        return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
	    }
	
	    _createClass(Root, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (window.location.hostname !== 'localhost' && window.location.protocol === 'http:') {
	                window.location.protocol = 'https:';
	            }
	            if (window.RNIS_SETTINGS.CITY_MURMANSK) {
	                _reactRouter.browserHistory.push('/map/road');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactRedux.Provider,
	                { store: store },
	                _react2.default.createElement(
	                    _reactRouter.Router,
	                    { history: _reactRouter.browserHistory },
	                    _react2.default.createElement(
	                        _reactRouter.Route,
	                        { path: '', component: _App2.default },
	                        _react2.default.createElement(_reactRouter.Route, { path: '/', component: _news2.default }),
	                        _react2.default.createElement(
	                            _reactRouter.Route,
	                            { path: '/register', component: _index6.default },
	                            _react2.default.createElement(_reactRouter.Route, { path: '/register/:type' })
	                        ),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/map/:type', component: _map2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/:component/map', component: _map2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/news', component: _news2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/news/all', component: _newsAll2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/news/tag/:tag', component: _newsTag2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/news/:uuid', component: _full2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/faq', component: _faq2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/carriers', component: _carriers2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/schedule', component: _index8.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/page/:key', component: _page2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/soon/:page', component: _soon2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/mobile/confirm/:email/:code', component: _index2.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '/mobile/confirm_change/:email/:code', component: _index4.default }),
	                        _react2.default.createElement(_reactRouter.Route, { path: '*', component: _notFound2.default })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Root;
	}(_react.Component);
	
	exports.default = Root;

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _findLast2 = __webpack_require__(1258);
	
	var _findLast3 = _interopRequireDefault(_findLast2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _sortBy2 = __webpack_require__(137);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _set2 = __webpack_require__(230);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _checkbox = __webpack_require__(751);
	
	var _formGroup = __webpack_require__(752);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _textFieldMask = __webpack_require__(379);
	
	var _textFieldMask2 = _interopRequireDefault(_textFieldMask);
	
	var _textField = __webpack_require__(188);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _select = __webpack_require__(98);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _input = __webpack_require__(186);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _radio = __webpack_require__(253);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _datepicker = __webpack_require__(185);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _textarea = __webpack_require__(753);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _reactQuill = __webpack_require__(1412);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	__webpack_require__(1117);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseEditorFormComponent = function (_Component) {
	    _inherits(BaseEditorFormComponent, _Component);
	
	    function BaseEditorFormComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BaseEditorFormComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseEditorFormComponent.__proto__ || Object.getPrototypeOf(BaseEditorFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(BaseEditorFormComponent, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.setState(this.props.data);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'getState',
	        value: function getState() {
	            return this.state;
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            return this.state;
	        }
	
	        /**
	         * @param {String} field
	         * @return {String}
	         */
	
	    }, {
	        key: 'getValue',
	        value: function getValue(field) {
	            return (0, _get3.default)(this.getState(), field);
	        }
	
	        /**
	         * @param {String} field
	         * @param {*} value
	         */
	
	    }, {
	        key: 'setValue',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(field, value) {
	                var state;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                state = this.getState();
	
	
	                                (0, _set3.default)(state, field, value);
	
	                                this.setState(state);
	
	                            case 3:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function setValue(_x, _x2) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return setValue;
	        }()
	    }, {
	        key: 'submit',
	        value: function submit() {
	            this.props.onSubmit(this.getState());
	        }
	    }, {
	        key: 'onDeleteClick',
	        value: function onDeleteClick() {
	            var _this2 = this;
	
	            alerts.prompt('Удалить?', '', function () {
	                _this2.props.onDelete(_this2.getValue('uuid'));
	            });
	        }
	    }, {
	        key: 'renderCheckbox',
	        value: function renderCheckbox(fieldName, label) {
	            var _this3 = this;
	
	            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            return _react2.default.createElement(_checkbox.LabeledCheckbox, _extends({
	                checked: this.getValue(fieldName),
	                label: label,
	                onChange: function onChange(value) {
	                    return _this3.onChangeInput(fieldName, { target: { value: value } });
	                }
	            }, props));
	        }
	    }, {
	        key: 'renderDatepicker',
	        value: function renderDatepicker(fieldName, label) {
	            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            var value = this.getValue(fieldName);
	            value = value && (0, _moment2.default)(value).format(_formats2.default.DATE);
	            if (value === 'Invalid date') {
	                value = null;
	            }
	
	            return this.renderInputMask(fieldName, label, '99.99.9999', value ? { value: value } : {});
	        }
	    }, {
	        key: 'renderInputMask',
	        value: function renderInputMask(fieldName, label, mask) {
	            var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            return _react2.default.createElement(
	                _formGroup2.default,
	                { name: fieldName, label: label },
	                _react2.default.createElement(_textFieldMask2.default, _extends({ mask: mask }, this.inputProps(fieldName), props))
	            );
	        }
	    }, {
	        key: 'maskInput',
	        value: function maskInput(fieldName, mask) {
	            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            return _react2.default.createElement(_textFieldMask2.default, _extends({ mask: mask }, this.inputProps(fieldName), props));
	        }
	    }, {
	        key: 'renderNumberField',
	        value: function renderNumberField(fieldName, label) {
	            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            props['type'] = 'number';
	
	            return _react2.default.createElement(
	                _formGroup2.default,
	                { name: fieldName, label: label },
	                _react2.default.createElement(_textField2.default, _extends({}, this.textFieldProps(fieldName), props))
	            );
	        }
	    }, {
	        key: 'renderTextField',
	        value: function renderTextField(fieldName, label) {
	            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            return _react2.default.createElement(
	                _formGroup2.default,
	                { name: fieldName, label: label },
	                _react2.default.createElement(_textField2.default, _extends({}, this.textFieldProps(fieldName), props))
	            );
	        }
	    }, {
	        key: 'textInput',
	        value: function textInput(fieldName) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            return _react2.default.createElement(_input2.default, _extends({}, this.textFieldProps(fieldName), props));
	        }
	    }, {
	        key: 'textarea',
	        value: function textarea(fieldName) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            return _react2.default.createElement(_textarea2.default, _extends({}, this.textFieldProps(fieldName), props));
	        }
	    }, {
	        key: 'wysiwyg',
	        value: function wysiwyg(fieldName) {
	            var _this4 = this;
	
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            props.onChange = function (value) {
	                _this4.onChangeInput(fieldName, { target: { value: value } });
	            };
	            props.formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image', 'align'];
	            props.modules = {
	                toolbar: [[{ 'header': [1, 2, false] }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }], [{ 'align': [] }], ['link'], ['clean']]
	            };
	
	            var error = this.getError(fieldName);
	            if (error) {
	                props.className = 'wrong';
	            }
	
	            var styleClassName = (0, _classnames2.default)(error ? 'input__style_state_wrong' : '');
	
	            var textFieldProps = this.textFieldProps(fieldName);
	            textFieldProps.value = textFieldProps.value || '';
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactQuill2.default, _extends({}, textFieldProps, props)),
	                _react2.default.createElement(
	                    'div',
	                    { className: styleClassName },
	                    error ? _react2.default.createElement(
	                        'span',
	                        { className: 'input__style_state_msg_wrong' },
	                        error
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'select',
	        value: function select(fieldName) {
	            var _this5 = this;
	
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            props.value = this.getValue(fieldName);
	            props.name = fieldName;
	            props.options = props.sort ? (0, _sortBy3.default)(options, 'label') : options;
	            if (!props.onChange) {
	                props.onChange = function (e) {
	                    var value = e ? e.value : null;
	
	                    if (props.multi) {
	                        value = e;
	                        value = (0, _map3.default)(value, 'value');
	                    }
	
	                    _this5.onChangeInput(fieldName, { target: { value: value } });
	                };
	            }
	
	            var error = this.getError(fieldName);
	            if (error) {
	                props.className = 'wrong';
	            }
	
	            var styleClassName = (0, _classnames2.default)(error ? 'input__style_state_wrong' : '');
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_select2.default, props),
	                _react2.default.createElement(
	                    'div',
	                    { className: styleClassName },
	                    error ? _react2.default.createElement(
	                        'span',
	                        { className: 'input__style_state_msg_wrong' },
	                        error
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'selectAsync',
	        value: function selectAsync(fieldName, loadOptions) {
	            var _this6 = this;
	
	            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            props.value = this.getValue(fieldName);
	            props.name = fieldName;
	            props.loadOptions = loadOptions;
	            if (!props.onChange) {
	                props.onChange = function (e) {
	                    var value = e ? e.value : null;
	                    var label = e ? e.label : null;
	
	                    if (props.multi) {
	                        value = e;
	                        value = (0, _map3.default)(value, 'value');
	                    }
	
	                    _this6.onChangeInput(fieldName, { target: { value: value, label: label } });
	                };
	            }
	
	            var error = this.getError(fieldName);
	            if (error) {
	                props.className = 'wrong';
	            }
	
	            var styleClassName = (0, _classnames2.default)(error ? 'input__style_state_wrong' : '');
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_select2.default.Async, props),
	                _react2.default.createElement(
	                    'div',
	                    { className: styleClassName },
	                    error ? _react2.default.createElement(
	                        'span',
	                        { className: 'input__style_state_msg_wrong' },
	                        error
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'radio',
	        value: function radio(fieldName, radioValue, label) {
	            var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            var value = this.getValue(fieldName);
	
	            return _react2.default.createElement(_radio2.default, _extends({
	                checked: value === radioValue,
	                field: fieldName,
	                value: radioValue,
	                label: label,
	                onChange: this.newListener(fieldName)
	            }, props));
	        }
	    }, {
	        key: 'datepicker',
	        value: function datepicker(fieldName) {
	            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            return _react2.default.createElement(_datepicker2.default, _extends({}, props, {
	                value: this.getValue(fieldName),
	                onChange: this.newListener(fieldName),
	                error: this.getError(fieldName)
	            }));
	        }
	    }, {
	        key: 'renderSelectField',
	        value: function renderSelectField(fieldName, label) {
	            var _this7 = this;
	
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	            var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            props['value'] = this.getValue(fieldName);
	            props['name'] = fieldName;
	            props['options'] = options;
	            props['onChange'] = function (e) {
	                var value = e ? e.value : null;
	                _this7.onChangeInput(fieldName, { target: { value: value } });
	            };
	
	            return _react2.default.createElement(
	                _formGroup2.default,
	                { name: fieldName, label: label },
	                _react2.default.createElement(_select2.default, props)
	            );
	        }
	    }, {
	        key: 'textFieldProps',
	        value: function textFieldProps(fieldName) {
	            return _extends({
	                size: 'md'
	            }, this.inputProps(fieldName));
	        }
	    }, {
	        key: 'inputProps',
	        value: function inputProps(fieldName) {
	            return {
	                value: this.getValue(fieldName) || '',
	                onChange: this.newListener(fieldName),
	                name: fieldName,
	                error: this.getError(fieldName)
	            };
	        }
	    }, {
	        key: 'getError',
	        value: function getError(fieldName) {
	            var field = (0, _findLast3.default)(fieldName.split('.'));
	
	            return (0, _get3.default)(this.state.errors, field) || (0, _get3.default)(this.state.errors, fieldName);
	        }
	    }, {
	        key: 'newListener',
	        value: function newListener(fieldName) {
	            return this.onChangeInput.bind(this, fieldName);
	        }
	    }, {
	        key: 'onChangeInput',
	        value: function onChangeInput(field, _ref4) {
	            var value = _ref4.target.value;
	
	            this.setValue(field, value);
	        }
	    }, {
	        key: 'loadDictionaries',
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dictionaries) {
	                var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                var withoutOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	                var meta, response, state;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                meta = {
	                                    filters: {
	                                        withComponent: component
	                                    }
	                                };
	
	                                if (!withoutOrder) {
	                                    meta.order = {
	                                        column: 'name',
	                                        direction: 'asc'
	                                    };
	                                }
	                                _context3.next = 4;
	                                return this.props.getDictionaryList(dictionaries, meta);
	
	                            case 4:
	                                response = _context3.sent;
	
	                                if (response.isOk) {
	                                    state = this.state;
	
	                                    (0, _each3.default)(response.payload.items, function (item) {
	                                        state[item.key] = (0, _map3.default)(item.documents, function (document) {
	                                            return {
	                                                value: document.uuid,
	                                                label: document.short_name || document.name,
	                                                document: document
	                                            };
	                                        });
	                                    });
	                                    this.setState(state);
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function loadDictionaries(_x19) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return loadDictionaries;
	        }()
	    }, {
	        key: 'getDictionary',
	        value: function () {
	            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dictionary) {
	                var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                var withoutOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	                var meta, response;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                meta = {
	                                    filters: {
	                                        withComponent: component
	                                    }
	                                };
	
	                                if (!withoutOrder) {
	                                    meta.order = {
	                                        column: 'name',
	                                        direction: 'asc'
	                                    };
	                                }
	                                _context4.next = 4;
	                                return this.props.getDictionaryList(dictionary, meta);
	
	                            case 4:
	                                response = _context4.sent;
	
	                                if (!response.isOk) {
	                                    _context4.next = 9;
	                                    break;
	                                }
	
	                                return _context4.abrupt('return', (0, _map3.default)(response.payload.documents, function (document) {
	                                    return {
	                                        value: document.uuid,
	                                        label: document.short_name || document.name,
	                                        document: document
	                                    };
	                                }));
	
	                            case 9:
	                                response.showErrors();
	
	                            case 10:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function getDictionary(_x22) {
	                return _ref6.apply(this, arguments);
	            }
	
	            return getDictionary;
	        }()
	    }]);
	
	    return BaseEditorFormComponent;
	}(_react.Component);
	
	exports.default = BaseEditorFormComponent;

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _sortBy2 = __webpack_require__(137);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(1072);
	
	var _reactRedux = __webpack_require__(17);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _select = __webpack_require__(98);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _carriers = __webpack_require__(190);
	
	var _textField = __webpack_require__(188);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _input = __webpack_require__(186);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CarriersComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getCarriers: _carriers.getCarriers }), _dec(_class = function (_Component) {
	    _inherits(CarriersComponent, _Component);
	
	    function CarriersComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CarriersComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CarriersComponent.__proto__ || Object.getPrototypeOf(CarriersComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            items: [],
	            loading: false,
	            selectedCarrier: null,
	            selectedRoute: null,
	            routeSearch: ''
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CarriersComponent, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.setState({ loading: true });
	                                _context.next = 3;
	                                return this.props.getCarriers({
	                                    filters: {
	                                        withComponent: 'kiutr',
	                                        withActive: true,
	                                        withStatus: true,
	                                        active_routes: true
	                                    }
	                                });
	
	                            case 3:
	                                response = _context.sent;
	
	                                this.setState({ loading: false });
	                                if (response.isOk) {
	                                    this.setState({
	                                        items: (0, _sortBy3.default)((0, _filter3.default)(response.payload.items, function (unit) {
	                                            return unit.routes.length > 0;
	                                        }), 'name')
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'routeChange',
	        value: function routeChange(_ref3) {
	            var value = _ref3.target.value;
	
	            this.setState({
	                routeSearch: value
	            });
	            return false;
	        }
	    }, {
	        key: 'keyPress',
	        value: function keyPress(e) {
	            console.log('value', e.target.value);
	            if (e.keyCode == 13) {
	                console.log('value', e.target.value);
	                // put the login here
	                return false;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'Carriers', title: '\u041F\u0435\u0440\u0435\u0432\u043E\u0437\u0447\u0438\u043A\u0438' },
	                loader,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _md' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'f-search f-search_gray f-search_left' },
	                            _react2.default.createElement(
	                                'form',
	                                { action: '' },
	                                _react2.default.createElement(_select2.default, {
	                                    placeholder: '\u041F\u0435\u0440\u0435\u0432\u043E\u0437\u0447\u0438\u043A',
	                                    value: this.state.selectedCarrier,
	                                    options: (0, _map3.default)(this.state.items, function (item) {
	                                        return { value: item.uuid, label: item.name };
	                                    }),
	                                    onChange: this.carrierSelect.bind(this)
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _md' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'f-search f-search_gray f-search_left' },
	                            _react2.default.createElement(
	                                'form',
	                                null,
	                                _react2.default.createElement(_input2.default, { value: this.state.routeSearch, onChange: this.routeChange.bind(this), onKeyPress: function onKeyPress(ev) {
	                                        if (ev.key === 'Enter') {
	                                            ev.preventDefault();
	                                        }
	                                    },
	                                    placeholder: '\u041C\u0430\u0440\u0448\u0440\u0443\u0442' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'carrier-title' },
	                        '\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.items.map(this.renderItem.bind(this))
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'carrierSelect',
	        value: function carrierSelect(e) {
	            var carrier = e ? e.value : null;
	
	            this.setState({
	                selectedCarrier: carrier,
	                selectedRoute: null
	            });
	        }
	    }, {
	        key: 'routeSelect',
	        value: function routeSelect(e) {
	            var route = e ? e.value : null;
	
	            this.setState({
	                selectedRoute: route,
	                selectedCarrier: null
	            });
	        }
	    }, {
	        key: 'renderItem',
	        value: function renderItem(carrier) {
	            var _this2 = this;
	
	            if (this.state.selectedCarrier && this.state.selectedCarrier !== carrier.uuid) {
	                return null;
	            }
	            if (this.state.routeSearch && (0, _filter3.default)(carrier.routes || [], function (route) {
	                return route.number.toLowerCase().indexOf(_this2.state.routeSearch.toLowerCase()) !== -1;
	            }).length === 0) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { key: carrier.uuid, className: 'carrier-item' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'carrier-item__caption' },
	                    carrier.name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'carrier-item__num' },
	                    carrier.routes.map(function (route) {
	                        return route.number;
	                    }).join(', ')
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'carrier-item__info' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bold' },
	                            '\u0410\u0434\u0440\u0435\u0441:'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            (0, _get3.default)(carrier, 'legal_address')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bold' },
	                            '\u0422\u0435\u043B\u0435\u0444\u043E\u043D:'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            (0, _get3.default)(carrier, 'phone')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bold' },
	                            'Email:'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:' + (0, _get3.default)(carrier, 'email') },
	                                (0, _get3.default)(carrier, 'email')
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CarriersComponent;
	}(_react.Component)) || _class);
	exports.default = CarriersComponent;

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(1073);
	
	var _reactRedux = __webpack_require__(17);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _faq = __webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaqComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getFaq: _faq.getFaq }), _dec(_class = function (_Component) {
	    _inherits(FaqComponent, _Component);
	
	    function FaqComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FaqComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FaqComponent.__proto__ || Object.getPrototypeOf(FaqComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            items: [],
	            loading: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FaqComponent, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response, items;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.setState({ loading: true });
	                                _context.next = 3;
	                                return this.props.getFaq({
	                                    filters: {
	                                        onlyActive: true
	                                    },
	                                    pagination: {
	                                        page: 1
	                                    },
	                                    order: {
	                                        column: 'question',
	                                        direction: 'asc'
	                                    }
	                                });
	
	                            case 3:
	                                response = _context.sent;
	
	                                this.setState({ loading: false });
	                                if (response.isOk) {
	                                    items = response.payload.items;
	
	                                    this.setState({ items: items });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'Faq', title: '\u041D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0447\u0430\u0441\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B' },
	                loader,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'full' },
	                    this.state.items.map(this.renderItem.bind(this))
	                )
	            );
	        }
	    }, {
	        key: 'renderItem',
	        value: function renderItem(item, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: index, className: 'faq-block' },
	                _react2.default.createElement(
	                    'strong',
	                    { className: 'question' },
	                    '\u0412\u043E\u043F\u0440\u043E\u0441: ',
	                    item.question
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'answer' },
	                    '\u041E\u0442\u0432\u0435\u0442: ',
	                    item.answer
	                )
	            );
	        }
	    }]);
	
	    return FaqComponent;
	}(_react.Component)) || _class);
	exports.default = FaqComponent;

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1075);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactTooltip = __webpack_require__(1457);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VehicleMarkerPopup = function (_Component) {
	    _inherits(VehicleMarkerPopup, _Component);
	
	    function VehicleMarkerPopup() {
	        _classCallCheck(this, VehicleMarkerPopup);
	
	        return _possibleConstructorReturn(this, (VehicleMarkerPopup.__proto__ || Object.getPrototypeOf(VehicleMarkerPopup)).apply(this, arguments));
	    }
	
	    _createClass(VehicleMarkerPopup, [{
	        key: 'render',
	        value: function render() {
	            var device = this.props.device;
	            var vehicle = this.props.vehicle;
	            var vehicleCarrier = this.props.vehicleCarrier;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'b-modal b-modal-map map-tooltip-modal tooltip-ts' },
	                _react2.default.createElement(_reactTooltip2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__header' },
	                    _react2.default.createElement('a', { href: '#', className: 'b-modal__close', onClick: this.onClose.bind(this) }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'b-modal__name' },
	                        vehicle.state_number,
	                        '\xA0',
	                        vehicle.vehicle_type ? vehicle.vehicle_type : this.props.vehicleMark
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__datetime' },
	                        '\u0414\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B: ',
	                        _moment2.default.unix(device.time).format(_formats2.default.DATETIME)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__datetime b-modal__vehicle-type' },
	                        this.props.vehicleModel || '-'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__body' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            this.getCourseText(),
	                            ' ',
	                            _react2.default.createElement('span', { className: 'b-block__direction',
	                                style: { transform: 'rotate(' + device.course + 'deg)' } })
	                        )
	                    ),
	                    vehicle.route_number ? _react2.default.createElement(
	                        'div',
	                        { className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u041C\u0430\u0440\u0448\u0440\u0443\u0442'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            '\u2116 ',
	                            vehicle.route_number,
	                            ', ',
	                            vehicle.route_name
	                        )
	                    ) : null,
	                    vehicleCarrier ? _react2.default.createElement(
	                        'div',
	                        { className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u041F\u0435\u0440\u0435\u0432\u043E\u0437\u0447\u0438\u043A'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            vehicleCarrier
	                        )
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 ' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'b-modal__footer-list b-modal__footer-list_start ' },
	                                    vehicle.is_cashless_payment ? _react2.default.createElement(
	                                        'li',
	                                        { className: 'b-modal__footer-item ' },
	                                        _react2.default.createElement('span', { 'data-tip': '\u0411\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430',
	                                            className: 'b-modal__footer-icon b-modal__footer-icon-credit-card' })
	                                    ) : null,
	                                    vehicle.is_low_floor_level ? _react2.default.createElement(
	                                        'li',
	                                        { className: 'b-modal__footer-item ' },
	                                        _react2.default.createElement('span', { 'data-tip': '\u041D\u0438\u0437\u043A\u0438\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u043F\u043E\u043B\u0430',
	                                            className: 'b-modal__footer-icon b-modal__footer-icon-download' })
	                                    ) : null,
	                                    vehicle.is_audio_video_fixation ? _react2.default.createElement(
	                                        'li',
	                                        { className: 'b-modal__footer-item ' },
	                                        _react2.default.createElement('span', { 'data-tip': '\u0410\u0443\u0434\u0438\u043E/\u0412\u0438\u0434\u0435\u043E \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044F',
	                                            className: 'b-modal__footer-icon b-modal__footer-icon-camera ' })
	                                    ) : null,
	                                    vehicle.is_passenger_monitoring_system ? _react2.default.createElement(
	                                        'li',
	                                        { className: 'b-modal__footer-item ' },
	                                        _react2.default.createElement('span', { 'data-tip': '\u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433\u0430 \u043F\u0430\u0441\u0441\u0430\u0436\u0438\u0440\u043E\u043F\u043E\u0442\u043E\u043A\u0430',
	                                            className: 'b-modal__footer-icon b-modal__footer-icon-camera-eye ' })
	                                    ) : null,
	                                    vehicle.is_for_disabled ? _react2.default.createElement(
	                                        'li',
	                                        { className: 'b-modal__footer-item ' },
	                                        _react2.default.createElement('span', {
	                                            'data-tip': '\u041E\u0441\u043D\u0430\u0449\u0435\u043D\u043E \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0432\u043E\u0437\u043A\u0438 \u0438\u043D\u0432\u0430\u043B\u0438\u0434\u043E\u0432',
	                                            className: 'b-modal__footer-icon b-modal__footer-icon-people-disabled ' })
	                                    ) : null,
	                                    vehicle.is_air_conditioning_installation ? _react2.default.createElement(
	                                        'li',
	                                        { className: 'b-modal__footer-item ' },
	                                        _react2.default.createElement('span', { 'data-tip': '\u041A\u043B\u0438\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430',
	                                            className: 'b-modal__footer-icon b-modal__footer-icon-climate ' })
	                                    ) : null
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'getCourseText',
	        value: function getCourseText() {
	            var course = this.props.device.course;
	
	            if (course >= 360 - 22.5 || course <= 22.5) {
	                return 'Север';
	            }
	            if (course >= 22.5 && course <= 67.5) {
	                return 'Северо-Восток';
	            }
	            if (course >= 67.5 && course <= 112.5) {
	                return 'Восток';
	            }
	            if (course >= 112.5 && course <= 157.5) {
	                return 'Юго-Восток';
	            }
	            if (course >= 157.5 && course <= 202.5) {
	                return 'Юг';
	            }
	            if (course >= 202.5 && course <= 247.5) {
	                return 'Юго-Запад';
	            }
	            if (course >= 247.5 && course <= 292.5) {
	                return 'Запад';
	            }
	            if (course >= 292.5 && course <= 337.5) {
	                return 'Северо-Запад';
	            }
	        }
	    }, {
	        key: 'onClose',
	        value: function onClose(e) {
	            e && e.preventDefault();
	
	            this.props.onClose();
	        }
	    }]);
	
	    return VehicleMarkerPopup;
	}(_react.Component);
	
	exports.default = VehicleMarkerPopup;

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _find2 = __webpack_require__(89);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _first2 = __webpack_require__(114);
	
	var _first3 = _interopRequireDefault(_first2);
	
	var _toNumber2 = __webpack_require__(231);
	
	var _toNumber3 = _interopRequireDefault(_toNumber2);
	
	var _round2 = __webpack_require__(229);
	
	var _round3 = _interopRequireDefault(_round2);
	
	var _keys2 = __webpack_require__(70);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _difference2 = __webpack_require__(1256);
	
	var _difference3 = _interopRequireDefault(_difference2);
	
	var _isArray2 = __webpack_require__(19);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _reactLeafletPopup = __webpack_require__(179);
	
	var _reactLeafletPopup2 = _interopRequireDefault(_reactLeafletPopup);
	
	var _server = __webpack_require__(94);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(789);
	
	__webpack_require__(464);
	
	__webpack_require__(448);
	
	__webpack_require__(447);
	
	__webpack_require__(1070);
	
	__webpack_require__(1076);
	
	var _map = __webpack_require__(757);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _button = __webpack_require__(149);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _mapVehicleClusterIcon = __webpack_require__(756);
	
	var _mapVehicleClusterIcon2 = _interopRequireDefault(_mapVehicleClusterIcon);
	
	var _mapVehicleIcon = __webpack_require__(97);
	
	var _mapVehicleIcon2 = _interopRequireDefault(_mapVehicleIcon);
	
	var _index = __webpack_require__(736);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _stopPointsMta = __webpack_require__(374);
	
	var _stopPointsMta2 = _interopRequireDefault(_stopPointsMta);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var avatar = '/static/img/avatar.jpg';
	
	var LeafletComponent = (_dec = (0, _reactPropsDecorators.propTypes)({
	    telematics: _propTypes2.default.object,
	    vehicles: _propTypes2.default.object,
	    clusters: _propTypes2.default.array,
	    onClusterRendered: _propTypes2.default.func,
	    onZoom: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    onClusterRendered: function onClusterRendered() {},
	    onZoom: function onZoom() {}
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(LeafletComponent, _Component);
	
	    function LeafletComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LeafletComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeafletComponent.__proto__ || Object.getPrototypeOf(LeafletComponent)).call.apply(_ref, [this].concat(args))), _this), _this.animationForecastSpeed = 1000, _this.slideLimit = 1000, _this.markersLayer = null, _this.markers = null, _this.clustersLayer = null, _this.forecastLayer = null, _this.allMarkers = {}, _this.popup = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LeafletComponent, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var map = this.refs.map.getWrappedInstance().map;
	
	            this.markersLayer = new _leaflet2.default.layerGroup().addTo(map);
	
	            this.markers = new _leaflet2.default.layerGroup();
	            this.markersLayer.addLayer(this.markers);
	
	            this.clustersLayer = new _leaflet2.default.layerGroup();
	            this.markersLayer.addLayer(this.clustersLayer);
	
	            this.forecastLayer = new _leaflet2.default.layerGroup().addTo(map);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(props) {
	            var _this2 = this;
	
	            /*if (props.params.type !== 'bus') {
	                return;
	            }*/
	            this.removeUnusedMarkers(props.telematics.keySeq().toArray());
	
	            this.drawForecast(props);
	            var i = 0;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = props.telematics.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var deviceId = _step.value;
	
	                    var device = new TelematicsDevice(deviceId, props.telematics.get(deviceId));
	
	                    var marker = this.allMarkers[deviceId];
	
	                    if (!marker) {
	                        this.allMarkers[deviceId] = marker = this.makeMarker(device);
	                        this.markers.addLayer(marker);
	                        i++;
	                    } else {
	                        try {
	                            this.moveMarkerToNewPlace(marker, device);
	                            /*marker.on('click', (e) => {
	                                this.loadPopupData(device, e.target)
	                            });*/
	                        } catch (e) {}
	                    }
	                    /*if (!marker.getTooltip() || !marker.isTooltipOpen()) {
	                        marker.unbindTooltip();
	                        const vehicle = this.props.vehicles[device.id];
	                        let tooltip = [];
	                        if (vehicle) {
	                            tooltip.push(`Госномер: ${vehicle.state_number}`);
	                        }
	                        tooltip.push(`Скорость: ${device.speed} км/ч`);
	                        tooltip.push(`Азимут: ${device.course}°`);
	                         marker.bindTooltip(tooltip.join('<br/>'), {sticky: true});
	                    }*/
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.clustersLayer.clearLayers();
	
	            (0, _each3.default)(props.clusters, function (cluster) {
	                var clusterInfo = cluster[2];
	                var marker = new _leaflet2.default.marker([cluster[0], cluster[1]], {
	                    keyboard: false,
	                    interactive: false,
	                    icon: _this2.createClusterIcon(clusterInfo)
	                });
	                _this2.clustersLayer.addLayer(marker);
	            });
	        }
	    }, {
	        key: "drawForecast",
	        value: function drawForecast(props) {
	            if (!this.props.location.query.debug) {
	                return;
	            }
	
	            this.forecastLayer.clearLayers();
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = props.telematics.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var deviceId = _step2.value;
	
	                    var device = new TelematicsDevice(deviceId, props.telematics.get(deviceId));
	
	                    var forecast = device.forecast;
	                    if (!(0, _isArray3.default)(forecast) || forecast.length === 0) {
	                        continue;
	                    }
	
	                    var object = new _leaflet2.default.polyline(forecast, {
	                        color: '#ff0000',
	                        opacity: 0.6
	                    });
	                    this.forecastLayer.addLayer(object);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    }, {
	        key: "createClusterIcon",
	        value: function createClusterIcon(clusterInfo) {
	            var html = _server2.default.renderToStaticMarkup(_react2.default.createElement(_mapVehicleClusterIcon2.default, { info: clusterInfo }));
	
	            return new _leaflet2.default.DivIcon({
	                html: html,
	                className: 'cluster',
	                iconSize: new _leaflet2.default.Point(72, 72),
	                iconAnchor: new _leaflet2.default.Point(36, 36)
	            });
	        }
	    }, {
	        key: "createMarkerIcon",
	        value: function createMarkerIcon(device) {
	            var html = _server2.default.renderToStaticMarkup(_react2.default.createElement(_mapVehicleIcon2.default, { device: device, direction: device.course }));
	
	            var type = 'bus';
	            switch (device.type) {
	                case 'road':
	                    type = 'road';
	                    break;
	                case 'trash':
	                    type = 'trash';
	                    break;
	                case 'control':
	                    type = 'control';
	                    break;
	                case 'school':
	                    type = 'school';
	                    break;
	            }
	
	            var className = "marker marker_type_" + type;
	            return new _leaflet2.default.DivIcon({
	                html: html,
	                className: className,
	                iconSize: new _leaflet2.default.Point(46, 46),
	                iconAnchor: new _leaflet2.default.Point(23, 23)
	            });
	        }
	    }, {
	        key: "removeUnusedMarkers",
	        value: function removeUnusedMarkers(markers) {
	            var _this3 = this;
	
	            var unused = (0, _difference3.default)((0, _keys3.default)(this.allMarkers), markers);
	
	            (0, _each3.default)(unused, function (deviceId) {
	                var marker = _this3.allMarkers[deviceId];
	                _this3.markers.removeLayer(marker);
	                delete _this3.allMarkers[deviceId];
	            });
	        }
	    }, {
	        key: "getBoundingBox",
	        value: function getBoundingBox() {
	            return this.refs.map.getWrappedInstance().getBoundingBox();
	        }
	    }, {
	        key: "getMapSize",
	        value: function getMapSize() {
	            return this.refs.map.getWrappedInstance().getMapSize();
	        }
	    }, {
	        key: "getZoom",
	        value: function getZoom() {
	            return this.refs.map.getWrappedInstance().getZoom();
	        }
	    }, {
	        key: "makeMarker",
	        value: function makeMarker(device) {
	            var _this4 = this;
	
	            var marker = _leaflet2.default.marker([device.lat, device.lng], {
	                icon: this.createMarkerIcon(device),
	                deviceId: device.id,
	                riseOnHover: true
	            });
	
	            marker.position = [device.lat, device.lng];
	            marker.course = device.course;
	
	            marker.on('click', function (e) {
	                _this4.loadPopupData(device.id, e.target);
	            });
	
	            var forecast = device.forecast;
	
	            if ((0, _isArray3.default)(forecast) && forecast.length > 0) {
	                marker.animation = setTimeout(this.animateMarker.bind(this, marker, forecast, device.speed), this.animationForecastSpeed);
	            }
	
	            return marker;
	        }
	    }, {
	        key: "moveMarkerToNewPlace",
	        value: function moveMarkerToNewPlace(marker, device) {
	            var latlng = {
	                lat: marker.position[0],
	                lng: marker.position[1]
	            };
	
	            var precision = 6;
	            // если положение машины изменилось, то плавно передвигаем
	            if (!((0, _round3.default)(latlng.lat, precision) == (0, _round3.default)(device.lat, precision) && (0, _round3.default)(latlng.lng, precision) == (0, _round3.default)(device.lng, precision))) {
	                var icon = marker._icon;
	                if (icon) {
	                    var normalMarkerCourse = marker.course % 360;
	                    if (normalMarkerCourse < 0) {
	                        normalMarkerCourse += 360;
	                    }
	
	                    var diff = (0, _toNumber3.default)(device.course - normalMarkerCourse);
	                    if (diff > 180) {
	                        diff -= 360;
	                    } else if (diff < -180) {
	                        diff += 360;
	                    }
	                    var course = (0, _toNumber3.default)(marker.course) + diff;
	                    (0, _jquery2.default)(icon).find('.marker__direction').css('transform', "rotate(" + course + "deg)");
	                }
	                var forecast = device.forecast;
	
	                marker.slideCancel();
	
	                marker.position = [device.lat, device.lng];
	                if (!(0, _isArray3.default)(forecast) || forecast.length === 0) {
	                    this.slideTo(marker, [device.lat, device.lng], 4000);
	                } else {
	                    marker.animation && clearTimeout(marker.animation);
	
	                    //this.slideTo(marker, [device.lat, device.lng], this.animationForecastSpeed);
	                    marker.animation = setTimeout(this.animateMarker.bind(this, marker, forecast, device.speed), this.animationForecastSpeed);
	                }
	            }
	        }
	    }, {
	        key: "slideTo",
	        value: function slideTo(marker, coordinates, duration) {
	            try {
	                if (marker.getLatLng().distanceTo(coordinates) <= this.slideLimit) {
	                    marker.slideTo(coordinates, { duration: duration });
	                    return;
	                }
	            } catch (e) {}
	
	            marker.setLatLng(coordinates);
	        }
	    }, {
	        key: "animateMarker",
	        value: function animateMarker(marker, forecast, speed) {
	            var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	            var coordinates = forecast[index];
	            if (coordinates) {
	                this.slideTo(marker, coordinates, this.animationForecastSpeed);
	                marker.animation = setTimeout(this.animateMarker.bind(this, marker, forecast, speed, index + 1), this.animationForecastSpeed);
	            } else {
	                marker.animation = null;
	            }
	        }
	    }, {
	        key: "loadPopupData",
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deviceId, marker) {
	                var device, response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                device = new TelematicsDevice(deviceId, this.props.telematics.get(deviceId));
	
	
	                                if (marker._popup !== undefined) {
	                                    marker.unbindPopup();
	                                }
	
	                                marker.closePopup();
	
	                                _context.next = 5;
	                                return (0, _response.makeResponse)(function () {
	                                    return _api.api.vehicles.getVehicleList({
	                                        filters: {
	                                            withCurrentBnsoNumber: [device.id]
	                                        }
	                                    });
	                                });
	
	                            case 5:
	                                response = _context.sent;
	
	
	                                if (response.isOk) {
	                                    if (response.payload.items.length > 0) {
	                                        marker.bindPopup(this.renderPopup(device, (0, _first3.default)(response.payload.items), marker.closePopup.bind(marker)));
	                                        marker.openPopup();
	                                    }
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 7:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadPopupData(_x2, _x3) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadPopupData;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _map2.default,
	                {
	                    ref: "map",
	                    onZoom: this.props.onZoom,
	                    showLayers: false,
	                    showSearch: false,
	                    layers: [{
	                        uuid: 'vehicles',
	                        title: '<img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDM2MS4xMTggMzYxLjExOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzYxLjExOCAzNjEuMTE4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPGcgaWQ9Il94MzJfMzcuX0xvY2tlZCI+CgkJPGc+CgkJCTxwYXRoIGQ9Ik0yNzQuNzY1LDE0MS4zVjk0LjIwNUMyNzQuNzY1LDQyLjE3MiwyMzIuNTgzLDAsMTgwLjU1OSwwYy01Mi4wMzIsMC05NC4yMDUsNDIuMTcyLTk0LjIwNSw5NC4yMDVWMTQxLjMgICAgIGMtMTcuMzQsMC0zMS40LDE0LjA2LTMxLjQsMzEuNHYxNTcuMDE2YzAsMTcuMzQ0LDE0LjA2LDMxLjQwMiwzMS40LDMxLjQwMmgxODguNDExYzE3LjM0MSwwLDMxLjM5OC0xNC4wNTksMzEuMzk4LTMxLjQwMlYxNzIuNyAgICAgQzMwNi4xNjQsMTU1LjM2LDI5Mi4xMDYsMTQxLjMsMjc0Ljc2NSwxNDEuM3ogTTExNy43NTYsOTQuMjA1YzAtMzQuNjksMjguMTItNjIuODAzLDYyLjgwMy02Mi44MDMgICAgIGMzNC42ODUsMCw2Mi44MDUsMjguMTEyLDYyLjgwNSw2Mi44MDNWMTQxLjNIMTE3Ljc1NlY5NC4yMDV6IE0yNzQuNzY1LDMyOS43MTVIODYuMzU0VjE3Mi43MDhoMTg4LjQxMVYzMjkuNzE1eiAgICAgIE0xNjQuODU4LDI2Mi41NTh2MjAuMDU0YzAsOC42NjQsNy4wMzUsMTUuNzAxLDE1LjcwMSwxNS43MDFjOC42NjQsMCwxNS43MDEtNy4wMzcsMTUuNzAxLTE1LjcwMXYtMjAuMDU0ICAgICBjOS4zMzctNS40NDEsMTUuNzAxLTE1LjQ1NiwxNS43MDEtMjcuMDQ2YzAtMTcuMzQ4LTE0LjA2Mi0zMS40MS0zMS40MDItMzEuNDFjLTE3LjM0LDAtMzEuNCwxNC4wNjItMzEuNCwzMS40MSAgICAgQzE0OS4xNTksMjQ3LjEwMiwxNTUuNTE3LDI1Ny4xMTcsMTY0Ljg1OCwyNjIuNTU4eiIgZmlsbD0iI0ZGRkZGRiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" /> ТС',
	                        layer: this.markersLayer
	                    }],
	                    withRouting: this.props.params.type === 'bus',
	                    onStopPointClick: this.props.onStopPointClick,
	                    onStopPointScheduleClick: this.props.onStopPointScheduleClick,
	                    onStopPointFromHereClick: this.props.onStopPointFromHereClick,
	                    onStopPointToHereClick: this.props.onStopPointToHereClick
	                },
	                this.props.children,
	                this.refs.map && this.props.params.type === 'bus' ? _react2.default.createElement(_stopPointsMta2.default, {
	                    map: this.refs.map.getWrappedInstance(),
	                    leafletMap: this.refs.map.getWrappedInstance().map,
	                    selectedStopPoint: this.props.selectedStopPoint,
	                    selectedStopPoints: this.props.selectedStopPoints,
	                    onStopPointClick: this.props.onStopPointClick,
	                    onStopPointScheduleClick: this.props.onStopPointScheduleClick,
	                    onStopPointFromHereClick: this.props.onStopPointFromHereClick,
	                    onStopPointToHereClick: this.props.onStopPointToHereClick
	                }) : null
	            );
	        }
	    }, {
	        key: "renderPopup",
	        value: function renderPopup(device, vehicle, onClose) {
	            if (!vehicle) {
	                return;
	            }
	            var vehicleModel = null;
	
	            if (window.vehicle_types) {
	                vehicle.vehicle_type = (0, _get3.default)((0, _find3.default)(window.vehicle_types, { uuid: vehicle.vehicle_type_uuid }), 'name');
	            }
	
	            if (vehicle.vehicle_model_uuid) {
	                vehicleModel = (0, _get3.default)((0, _find3.default)(this.props.data.vehicle_models, { uuid: vehicle.vehicle_model_uuid }), 'name');
	            }
	            var vehicleMark = null;
	            if (vehicle.vehicle_mark_uuid) {
	                vehicleMark = (0, _get3.default)((0, _find3.default)(this.props.data.vehicle_marks, { uuid: vehicle.vehicle_mark_uuid }), 'name');
	            }
	            var vehicleCarrier = (0, _get3.default)(this.props.data.carriers, vehicle.unit_uuid);
	
	            return new _reactLeafletPopup2.default({
	                reactComponent: _index2.default,
	                reactComponentProps: _extends({}, this.props, {
	                    device: device,
	                    vehicle: vehicle,
	                    vehicleModel: vehicleModel,
	                    vehicleMark: vehicleMark,
	                    vehicleCarrier: vehicleCarrier,
	                    onClose: onClose
	                }),
	                minWidth: 434,
	                maxWidth: 434,
	                offset: new _leaflet2.default.Point(3, -250)
	            });
	        }
	    }]);
	
	    return LeafletComponent;
	}(_react.Component)) || _class) || _class);
	exports.default = LeafletComponent;
	
	var TelematicsDevice = function () {
	
	    /**
	     * @param {String} id
	     * @param {Object} device
	     */
	    function TelematicsDevice(id, device) {
	        _classCallCheck(this, TelematicsDevice);
	
	        this.__id = id;
	        this.__lat = (0, _get3.default)(device, 0);
	        this.__lng = (0, _get3.default)(device, 1);
	        this.__speed = (0, _get3.default)(device, 2);
	        this.__course = (0, _get3.default)(device, 3);
	        this.__type = (0, _get3.default)(device, 4);
	        this.__time = (0, _get3.default)(device, 5);
	        this.__forecast = (0, _get3.default)(device, 6);
	    }
	
	    /**
	     * @return {String}
	     */
	
	
	    _createClass(TelematicsDevice, [{
	        key: "id",
	        get: function get() {
	            return this.__id;
	        }
	
	        /**
	         * @return {Number}
	         */
	
	    }, {
	        key: "lat",
	        get: function get() {
	            return this.__lat;
	        }
	
	        /**
	         * @return {Number}
	         */
	
	    }, {
	        key: "lng",
	        get: function get() {
	            return this.__lng;
	        }
	
	        /**
	         * @return {Number}
	         */
	
	    }, {
	        key: "course",
	        get: function get() {
	            return this.__course;
	        }
	
	        /**
	         * @return {Number}
	         */
	
	    }, {
	        key: "speed",
	        get: function get() {
	            return this.__speed;
	        }
	
	        /**
	         * @return {String}
	         */
	
	    }, {
	        key: "type",
	        get: function get() {
	            return this.__type;
	        }
	
	        /**
	         * @return {String}
	         */
	
	    }, {
	        key: "time",
	        get: function get() {
	            return this.__time;
	        }
	    }, {
	        key: "forecast",
	        get: function get() {
	            return this.__forecast;
	        }
	    }]);

	    return TelematicsDevice;
	}();

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _uniqueId2 = __webpack_require__(1287);
	
	var _uniqueId3 = _interopRequireDefault(_uniqueId2);
	
	var _set2 = __webpack_require__(230);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _first2 = __webpack_require__(114);
	
	var _first3 = _interopRequireDefault(_first2);
	
	var _flatten2 = __webpack_require__(224);
	
	var _flatten3 = _interopRequireDefault(_flatten2);
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _values2 = __webpack_require__(513);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _sortBy2 = __webpack_require__(137);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _find2 = __webpack_require__(89);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _keyBy2 = __webpack_require__(1270);
	
	var _keyBy3 = _interopRequireDefault(_keyBy2);
	
	var _mapValues2 = __webpack_require__(1272);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _uniq2 = __webpack_require__(512);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _round2 = __webpack_require__(229);
	
	var _round3 = _interopRequireDefault(_round2);
	
	var _remove2 = __webpack_require__(1281);
	
	var _remove3 = _interopRequireDefault(_remove2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _cloneDeep2 = __webpack_require__(223);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _api = __webpack_require__(15);
	
	var _immutable = __webpack_require__(47);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _storage = __webpack_require__(392);
	
	var storage = _interopRequireWildcard(_storage);
	
	var _reactRedux = __webpack_require__(17);
	
	var _maps = __webpack_require__(387);
	
	var _leaflet = __webpack_require__(737);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _vehicles = __webpack_require__(391);
	
	var _debounce = __webpack_require__(247);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(452);
	
	__webpack_require__(1077);
	
	var _dictionary = __webpack_require__(258);
	
	var _auth = __webpack_require__(383);
	
	var _userObjects = __webpack_require__(794);
	
	var _geojson = __webpack_require__(254);
	
	var _geojson2 = _interopRequireDefault(_geojson);
	
	var _carriers = __webpack_require__(190);
	
	var _garbageObjects = __webpack_require__(760);
	
	var _garbageObjects2 = _interopRequireDefault(_garbageObjects);
	
	var _stopPointsMta = __webpack_require__(374);
	
	var _stopPointsMta2 = _interopRequireDefault(_stopPointsMta);
	
	var _select = __webpack_require__(98);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _routes = __webpack_require__(151);
	
	var _pageModal = __webpack_require__(257);
	
	var _pageModal2 = _interopRequireDefault(_pageModal);
	
	var _modalTopMenuButtons = __webpack_require__(256);
	
	var _modalTopMenuButtons2 = _interopRequireDefault(_modalTopMenuButtons);
	
	var _modalTopMenuButton = __webpack_require__(255);
	
	var _modalTopMenuButton2 = _interopRequireDefault(_modalTopMenuButton);
	
	var _block = __webpack_require__(251);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _loader = __webpack_require__(371);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _accordion = __webpack_require__(250);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _accordionItem = __webpack_require__(249);
	
	var _accordionItem2 = _interopRequireDefault(_accordionItem);
	
	var _functions = __webpack_require__(189);
	
	var _modalTopMenuListItem = __webpack_require__(376);
	
	var _modalTopMenuListItem2 = _interopRequireDefault(_modalTopMenuListItem);
	
	var _modalTopMenuList = __webpack_require__(377);
	
	var _modalTopMenuList2 = _interopRequireDefault(_modalTopMenuList);
	
	var _print2 = __webpack_require__(381);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(739);
	
	var _leaflet3 = __webpack_require__(28);
	
	var _leaflet4 = _interopRequireDefault(_leaflet3);
	
	var _tablet = __webpack_require__(798);
	
	var _tasks = __webpack_require__(796);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lastWsTimestamp = null;
	
	var MapComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, {
	    getTelematicsWithDevices: _maps.getTelematicsWithDevices,
	    getGeometryFromContract: _tasks.getGeometryFromContract,
	    getTabletWorkSummary: _tablet.getTabletWorkSummary,
	    getTasks: _tasks.getTasks,
	    getTasksGuests: _tasks.getTasksGuests,
	    getVehicleList: _vehicles.getVehicleList,
	    getVehicleListGuest: _vehicles.getVehicleListGuest,
	    getDictionaryList: _dictionary.getDictionaryList,
	    listLayers: _userObjects.listLayers,
	    listUserGeoObjectsByLayers: _userObjects.listUserGeoObjectsByLayers,
	    getCarriers: _carriers.getCarriers,
	    getStopPointRoutes: _routes.getStopPointRoutes,
	    getTelematics: _maps.getTelematics,
	    listUserGeoObjectsMO: _userObjects.listUserGeoObjectsMO,
	    getTelematicsTotalCount: _maps.getTelematicsTotalCount,
	    getStopPointRouteRuns: _routes.getStopPointRouteRuns,
	    getGuestToken: _auth.getGuestToken
	}), _dec(_class = function (_Component) {
	    _inherits(MapComponent, _Component);
	
	    function MapComponent() {
	        var _ref, _context;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MapComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapComponent.__proto__ || Object.getPrototypeOf(MapComponent)).call.apply(_ref, [this].concat(args))), _this), _this.map = null, _this.zoomDebounce = (0, _debounce2.default)(1000, (_context = _this).onZoomLoad.bind(_context)), _this._cycleFetch = null, _this._vehiclesCycleFetch = null, _this.initialState = {
	            loading: false,
	            defaultPolygonStyle: null,
	            telematics: new _immutable.Map({}),
	            clusters: [],
	            sourceType: 't1sync',
	            vehicles: {},
	            vehicle_models: [],
	            vehicle_marks: [],
	            vehicle_types: [],
	            user_geo_objects: [],
	            carriers: {},
	            activeStopPoint: null,
	            routes: [],
	            isRoutesLoading: false,
	            requestIndex: 0,
	            totalCount: null,
	            stopPointTime: null,
	            stopPointRouteRuns: {},
	            stopPointRoutePages: {},
	            mu: null,
	            muTasks: null,
	            muTasksObjects: null,
	            button_goBack: false,
	            faqOpened: true,
	            selected_work_type: 'all',
	            selected_communal_uuid: null,
	            selector_municipalities: [],
	            customDateSelected: 1,
	            computedGeometry: null,
	            filter_work_types: null,
	            bnso_numbers: null,
	            token: null,
	            bluePolygonsRoadPartUuid: null,
	            isLegendShowBlue: false,
	            contracts: null,
	            contractsToRender: [],
	            isNeedContractRender: false
	        }, _this.state = (0, _cloneDeep3.default)(_this.initialState), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MapComponent, [{
	        key: 'componentWillMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (!window.RNIS_SETTINGS.CITY_MURMANSK) {
	                                    _context2.next = 3;
	                                    break;
	                                }
	
	                                _context2.next = 3;
	                                return this.getGuestTokenFirst();
	
	                            case 3:
	                                this.setState({
	                                    type: this.props.params.type
	                                });
	                                this.init();
	
	                            case 5:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: 'init',
	        value: function init() {
	            var _this2 = this;
	
	            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            props = props || this.props;
	
	            this.loadDictionaries(['work_types', 'vehicle_models', 'vehicle_marks', 'vehicle_types'], props.params.type);
	
	            if (props.params.type === 'garbage' || props.params.type === 'road') {
	                this.loadMo(props.params.type);
	            }
	
	            this._countCycleFetch = new _api.CycleFetch(function () {
	                return _this2.loadTelematicsCount();
	            }, function () {}, 30000);
	            this._countCycleFetch.run();
	
	            /*if (this._vehiclesCycleFetch) {
	                this._vehiclesCycleFetch.stop();
	                delete this['_vehiclesCycleFetch'];
	            }
	            this._vehiclesCycleFetch = new CycleFetch(() => {
	                return this.loadVehicles(props.params.type, false);
	            }, () => {
	            }, 10000);
	            this._vehiclesCycleFetch.run();*/
	
	            if (this._cycleFetch) {
	                this._cycleFetch.stop();
	                delete this['_cycleFetch'];
	            }
	            this._cycleFetch = new _api.CycleFetch(function () {
	                if (!_this2.map) {
	                    if (_this2.state.telematics.size > 0 || _this2.state.clusters.length > 0) {
	                        _this2.setState({ telematics: new _immutable.Map({}), clusters: [], loading: false });
	                    }
	                    return null;
	                }
	
	                var type = props.params.type;
	                var deviceAll = false;
	                if (window.RNIS_SETTINGS.CITY_OMSK && type === 'bus') {
	                    deviceAll = true;
	                }
	                var boundingBox = _this2.map.getBoundingBox();
	                var mapSize = _this2.map.getMapSize();
	
	                var promise = void 0;
	                if (location.pathname.includes('map/road')) {
	                    if (_this2.state.bnso_numbers) {
	                        promise = _this2.props.getTelematicsWithDevices(_this2.state.bnso_numbers, _this2.state.sourceType, boundingBox, mapSize, _this2.map.getZoom());
	                    } else {
	                        promise = _this2.props.getTelematics(_this2.logicForDetectDevicesParam(deviceAll), _this2.state.sourceType, boundingBox, mapSize, _this2.map.getZoom());
	                    }
	                } else {
	                    if (!_this2.state.bnso_numbers) {
	                        promise = _this2.props.getTelematics(_this2.logicForDetectDevicesParam(deviceAll), _this2.state.sourceType, boundingBox, mapSize, _this2.map.getZoom());
	                    }
	                }
	                promise.then(function (response) {
	                    if (type !== _this2.props.params.type) {
	                        if (_this2.state.telematics.size > 0 || _this2.state.clusters.length > 0) {
	                            _this2.setState({ telematics: new _immutable.Map({}), clusters: [], loading: false });
	                        }
	                        return new Promise(function (resolve) {
	                            setTimeout(function () {
	                                resolve();
	                            }, 5000);
	                        });
	                    }
	                    var telematics = {};
	                    var clusters = [];
	
	                    (0, _each3.default)((0, _get3.default)(response, 'payload.items', []), function (item) {
	                        var latitude = item[0];
	                        var longitude = item[1];
	                        var type = item[2];
	
	                        if (type === 'cluster') {
	                            var info = item[3];
	                            clusters.push([latitude, longitude, info]);
	                        } else {
	                            var deviceId = item[3];
	                            var course = item[4];
	                            var speed = item[5];
	                            var _type2 = item[6];
	                            var time = item[7];
	
	                            telematics[deviceId] = [latitude, longitude, course, speed, _type2, time];
	                        }
	                    });
	                    _this2.setState({ telematics: new _immutable.Map(telematics), clusters: clusters, loading: false });
	                }, function () {
	                    _this2.setState({ loading: false });
	                });
	                return promise;
	            }, function () {}, 10000);
	
	            this._cycleFetch.run();
	            if (props.params.type === 'road') {
	                if (window.RNIS_SETTINGS.CITY_MURMANSK) {
	                    this.loadMu();
	                    this.loadMuRoadParts();
	                }
	                this.loadRuads();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._countCycleFetch) {
	                this._countCycleFetch.stop();
	                delete this['_countCycleFetch'];
	            }
	            //this._vehiclesCycleFetch.stop();
	            //delete this['_vehiclesCycleFetch'];
	
	            // this._cycleFetch.stop();
	            // delete this['_cycleFetch'];
	        }
	    }, {
	        key: 'logicForDetectDevicesParam',
	        value: function logicForDetectDevicesParam(deviceAll) {
	            if (deviceAll) {
	                return 'all';
	            }
	            if (this.props.params.type === 'bus') {
	                return 'kiutr';
	            }
	            if (this.props.params.component === 'kiutr') {
	                return 'kiutr';
	            }
	            return this.props.params.type;
	        }
	    }, {
	        key: 'loadTelematicsCount',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var response, clusters;
	                return regeneratorRuntime.wrap(function _callee2$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                if (this.map && this.map.getZoom() < 14) {
	                                    this.loadTelematics(false, true);
	                                }
	
	                                if (this.state.bnso_numbers) {
	                                    _context3.next = 9;
	                                    break;
	                                }
	
	                                _context3.next = 4;
	                                return this.props.getTelematicsTotalCount();
	
	                            case 4:
	                                response = _context3.sent;
	
	                                if (!response.isOk) {
	                                    _context3.next = 9;
	                                    break;
	                                }
	
	                                _context3.next = 8;
	                                return this.setState({
	                                    totalCount: response.payload.count
	                                });
	
	                            case 8:
	
	                                if (this.state.clusters.length === 1) {
	                                    clusters = this.state.clusters;
	
	                                    clusters[0][2].bus = response.payload.count;
	                                    this.setState({ clusters: clusters });
	                                }
	
	                            case 9:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function loadTelematicsCount() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return loadTelematicsCount;
	        }()
	    }, {
	        key: 'onTelematicsUpdate',
	        value: function onTelematicsUpdate(_ref4) {
	            var timestamp = _ref4.headers.timestamp,
	                payload = _ref4.payload;
	
	            var time = (0, _moment2.default)(timestamp);
	            if (lastWsTimestamp && time.isBefore(lastWsTimestamp)) {
	                return;
	            }
	
	            lastWsTimestamp = time;
	            var telematics = this.state.telematics.toObject();
	            var clusters = this.state.clusters;
	
	            (0, _each3.default)(payload.data.device.changed, function (item) {
	                var latitude = item[0];
	                var longitude = item[1];
	                var deviceId = item[3];
	                var course = item[4];
	                var speed = item[5];
	                var type = item[6];
	                var time = item[7];
	                var forecast = item[14];
	
	                telematics[deviceId] = [latitude, longitude, course, speed, type, time, forecast];
	            });
	
	            (0, _each3.default)(payload.data.device.deleted, function (data) {
	                delete telematics[data[2]];
	            });
	
	            var length = clusters.length;
	
	            (0, _each3.default)(payload.data.cluster.deleted, function (data) {
	                (0, _remove3.default)(clusters, function (cluster) {
	                    return (0, _round3.default)(cluster[0], 6) === (0, _round3.default)(data[0], 6) && (0, _round3.default)(cluster[1], 6) === (0, _round3.default)(data[1], 6);
	                });
	            });
	
	            (0, _each3.default)(payload.data.cluster.changed, function (item) {
	                var latitude = item[0];
	                var longitude = item[1];
	                var info = item[3];
	
	                clusters.push([latitude, longitude, info]);
	            });
	
	            this.setState({ telematics: new _immutable.Map(telematics), clusters: clusters });
	        }
	    }, {
	        key: 'loadTelematics',
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                var _this3 = this;
	
	                var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	                var withoutWs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	                var requestIndex, type, boundingBox, mapSize, response, deviceAll, telematics, clusters, items;
	                return regeneratorRuntime.wrap(function _callee3$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                if (this.map) {
	                                    _context4.next = 3;
	                                    break;
	                                }
	
	                                if (this.state.telematics.size > 0 || this.state.clusters.length > 0) {
	                                    this.setState({ telematics: new _immutable.Map({}), clusters: [], loading: false });
	                                }
	                                return _context4.abrupt('return');
	
	                            case 3:
	                                requestIndex = this.state.requestIndex + 1;
	
	                                this.setState({
	                                    requestIndex: requestIndex
	                                });
	
	                                type = this.props.params.type;
	                                boundingBox = this.map.getBoundingBox();
	                                mapSize = this.map.getMapSize();
	
	                                if (!withoutWs) {
	                                    _api.api.telematics.telematicsUpdateUnsubscribe();
	                                }
	                                /*api.telematics.telematicsUpdateSubscribe({
	                                    bounding_box: this.map.getBoundingBox(),
	                                }, ::this.onTelematicsUpdate);
	                                api.telematics.filtersUpdate('com.rnis.telematics.action.telematics.portal.update', {
	                                    zoom: this.map.getZoom(),
	                                    //bounding_box: this.map.getBoundingBox(),
	                                });*/
	
	                                response = {
	                                    isOk: true,
	                                    payload: {
	                                        items: []
	                                    }
	                                };
	
	                                if (!withoutWs && this.map.getZoom() >= 14 && this.props.params.type === 'bus') {
	                                    _api.api.telematics.telematicsUpdateSubscribe({
	                                        bounding_box: this.map.getBoundingBox()
	                                    }, this.onTelematicsUpdate.bind(this));
	                                }
	
	                                deviceAll = false;
	
	                                if (window.RNIS_SETTINGS.CITY_OMSK && type === 'bus') {
	                                    deviceAll = true;
	                                }
	
	                                if (!location.pathname.includes('map/road')) {
	                                    _context4.next = 25;
	                                    break;
	                                }
	
	                                if (!this.state.bnso_numbers) {
	                                    _context4.next = 20;
	                                    break;
	                                }
	
	                                _context4.next = 17;
	                                return this.props.getTelematicsWithDevices(this.state.bnso_numbers, this.state.sourceType, boundingBox, mapSize, this.map.getZoom());
	
	                            case 17:
	                                response = _context4.sent;
	                                _context4.next = 23;
	                                break;
	
	                            case 20:
	                                _context4.next = 22;
	                                return this.props.getTelematics(this.logicForDetectDevicesParam(deviceAll), this.state.sourceType, boundingBox, mapSize, this.map.getZoom());
	
	                            case 22:
	                                response = _context4.sent;
	
	                            case 23:
	                                _context4.next = 29;
	                                break;
	
	                            case 25:
	                                if (this.state.bnso_numbers) {
	                                    _context4.next = 29;
	                                    break;
	                                }
	
	                                _context4.next = 28;
	                                return this.props.getTelematics(this.logicForDetectDevicesParam(deviceAll), this.state.sourceType, boundingBox, mapSize, this.map.getZoom());
	
	                            case 28:
	                                response = _context4.sent;
	
	                            case 29:
	                                if (!(this.state.requestIndex !== requestIndex)) {
	                                    _context4.next = 31;
	                                    break;
	                                }
	
	                                return _context4.abrupt('return');
	
	                            case 31:
	                                telematics = {};
	                                clusters = [];
	                                items = (0, _get3.default)(response, 'payload.items', []);
	
	                                (0, _each3.default)(items, function (item) {
	                                    var latitude = item[0];
	                                    var longitude = item[1];
	                                    var type = item[2];
	
	                                    if (type === 'cluster') {
	                                        var info = item[3];
	                                        if (items.length === 1 && _this3.props.params.type === 'bus') {
	                                            info.bus = _this3.state.totalCount;
	                                        }
	                                        clusters.push([latitude, longitude, info]);
	                                    } else {
	                                        var deviceId = item[3];
	                                        var course = item[4];
	                                        var speed = item[5];
	                                        var _type3 = item[6];
	                                        var time = item[7];
	
	                                        telematics[deviceId] = [latitude, longitude, course, speed, _type3, time, item[14]];
	                                    }
	                                });
	                                this.setState({ telematics: new _immutable.Map(telematics), clusters: clusters, loading: false });
	
	                                /*initial && setTimeout(() => {
	                                    this.loadTelematics(initial);
	                                }, 4000);*/
	
	                            case 36:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function loadTelematics() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return loadTelematics;
	        }()
	    }, {
	        key: 'setVehicleType',
	        value: function setVehicleType() {}
	    }, {
	        key: 'componentWillUpdate',
	        value: function () {
	            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(props, state) {
	                return regeneratorRuntime.wrap(function _callee4$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                if (!(props.params.type !== state.type)) {
	                                    _context5.next = 8;
	                                    break;
	                                }
	
	                                this.map = null;
	                                _context5.next = 4;
	                                return this.setState({
	                                    type: props.params.type
	                                });
	
	                            case 4:
	                                _context5.next = 6;
	                                return this.setState(this.initialState);
	
	                            case 6:
	                                this.init(props);
	                                if (window.RNIS_SETTINGS.CITY_OMSK) {
	                                    this.loadVehicles(props.params.component);
	                                } else {
	                                    this.loadVehicles(props.params.type);
	                                }
	
	                            case 8:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function componentWillUpdate(_x4, _x5) {
	                return _ref6.apply(this, arguments);
	            }
	
	            return componentWillUpdate;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function () {
	            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                var bnso_numbers;
	                return regeneratorRuntime.wrap(function _callee5$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                if (!(window.RNIS_SETTINGS.CITY_OMSK && window.RNIS_SETTINGS.telematicsFilterVehicles)) {
	                                    _context6.next = 7;
	                                    break;
	                                }
	
	                                _context6.next = 3;
	                                return this.getActualDevicesForGuestUser();
	
	                            case 3:
	                                bnso_numbers = _context6.sent;
	
	                                if (!bnso_numbers) {
	                                    _context6.next = 7;
	                                    break;
	                                }
	
	                                _context6.next = 7;
	                                return this.setState({
	                                    bnso_numbers: bnso_numbers
	                                });
	
	                            case 7:
	                                this.loadCarriers();
	
	                            case 8:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function componentDidMount() {
	                return _ref7.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'getGuestTokenFirst',
	        value: function () {
	            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	                var responseToken, token;
	                return regeneratorRuntime.wrap(function _callee6$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                _context7.next = 2;
	                                return this.props.getGuestToken();
	
	                            case 2:
	                                responseToken = _context7.sent;
	
	                                if (!responseToken.isOk) {
	                                    _context7.next = 8;
	                                    break;
	                                }
	
	                                token = responseToken.payload.token;
	
	                                storage.set('user', responseToken.payload);
	                                _context7.next = 8;
	                                return this.setState({
	                                    token: token
	                                });
	
	                            case 8:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function getGuestTokenFirst() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return getGuestTokenFirst;
	        }()
	    }, {
	        key: 'getActualDevicesForGuestUser',
	        value: function () {
	            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	                var meta, responseGuestTasks, vehiclesInWork, vehiclesBaseUuid, responseGuestVehicleList;
	                return regeneratorRuntime.wrap(function _callee7$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                if (!storage.get('user').token) {
	                                    _context8.next = 21;
	                                    break;
	                                }
	
	                                meta = {
	                                    filters: { today: true, onlyUuid: true },
	                                    response_data: ['items/uuid', 'items/number', 'items/resources', 'items/status_uuid']
	                                };
	                                _context8.next = 4;
	                                return this.props.getTasksGuests(meta, {}, storage.get('user').token);
	
	                            case 4:
	                                responseGuestTasks = _context8.sent;
	
	                                if (!responseGuestTasks.isOk) {
	                                    _context8.next = 18;
	                                    break;
	                                }
	
	                                vehiclesInWork = responseGuestTasks.payload.items.filter(function (item) {
	                                    return item.status_uuid === 'ef9d7f2a-f45e-11e7-9db9-7d3c938a1130';
	                                });
	                                vehiclesBaseUuid = vehiclesInWork.map(function (item) {
	                                    return item.resources.map(function (item) {
	                                        return item.base_vehicle_uuid;
	                                    });
	                                });
	                                _context8.next = 10;
	                                return this.props.getVehicleListGuest({
	                                    filters: {
	                                        withUuid: (0, _uniq3.default)(vehiclesBaseUuid.flat())
	                                    }
	                                });
	
	                            case 10:
	                                responseGuestVehicleList = _context8.sent;
	
	                                if (!responseGuestVehicleList.isOk) {
	                                    _context8.next = 15;
	                                    break;
	                                }
	
	                                return _context8.abrupt('return', responseGuestVehicleList.payload.items.map(function (item) {
	                                    if (item && item.current_bnso && item.current_bnso.bnso_number) {
	                                        return item.current_bnso.bnso_number;
	                                    } else {
	                                        console.info("Нет bnso_number", item);
	                                    }
	                                }));
	
	                            case 15:
	                                return _context8.abrupt('return', null);
	
	                            case 16:
	                                _context8.next = 19;
	                                break;
	
	                            case 18:
	                                return _context8.abrupt('return', null);
	
	                            case 19:
	                                _context8.next = 22;
	                                break;
	
	                            case 21:
	                                return _context8.abrupt('return', null);
	
	                            case 22:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	
	            function getActualDevicesForGuestUser() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return getActualDevicesForGuestUser;
	        }()
	    }, {
	        key: 'loadCarriers',
	        value: function () {
	            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee8$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                _context9.next = 2;
	                                return this.props.getCarriers({
	                                    filters: {
	                                        withComponent: 'kiutr',
	                                        short: true
	                                    }
	                                });
	
	                            case 2:
	                                response = _context9.sent;
	
	                                this.setState({ loading: false });
	                                if (response.isOk) {
	                                    this.setState({
	                                        carriers: (0, _mapValues3.default)((0, _keyBy3.default)(response.payload.items, 'uuid'), 'name')
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function loadCarriers() {
	                return _ref10.apply(this, arguments);
	            }
	
	            return loadCarriers;
	        }()
	    }, {
	        key: 'loadRuads',
	        value: function () {
	            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	                var response, layer;
	                return regeneratorRuntime.wrap(function _callee9$(_context10) {
	                    while (1) {
	                        switch (_context10.prev = _context10.next) {
	                            case 0:
	                                _context10.next = 2;
	                                return this.props.listLayers();
	
	                            case 2:
	                                response = _context10.sent;
	
	
	                                if (response.isOk) {
	                                    layer = (0, _find3.default)(response.payload.items, { title: 'Региональные управления автомобильными дорогами (РУАД)' });
	
	                                    if (layer) {
	                                        this.loadUserGeoObjects(layer.uuid);
	                                    }
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context10.stop();
	                        }
	                    }
	                }, _callee9, this);
	            }));
	
	            function loadRuads() {
	                return _ref11.apply(this, arguments);
	            }
	
	            return loadRuads;
	        }()
	    }, {
	        key: 'loadUserGeoObjects',
	        value: function () {
	            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(uuid) {
	                var response;
	                return regeneratorRuntime.wrap(function _callee10$(_context11) {
	                    while (1) {
	                        switch (_context11.prev = _context11.next) {
	                            case 0:
	                                _context11.next = 2;
	                                return this.props.listUserGeoObjectsByLayers({
	                                    items: [uuid]
	                                });
	
	                            case 2:
	                                response = _context11.sent;
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        user_geo_objects: response.payload.items
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context11.stop();
	                        }
	                    }
	                }, _callee10, this);
	            }));
	
	            function loadUserGeoObjects(_x6) {
	                return _ref12.apply(this, arguments);
	            }
	
	            return loadUserGeoObjects;
	        }()
	    }, {
	        key: 'getTypes',
	        value: function getTypes(type) {
	            switch (type) {
	                case 'bus':
	                    return ['bus', 'trolleybus', 'tram'];
	                case 'children':
	                    return ['school'];
	                case 'road':
	                    return ['road'];
	                case 'waste':
	                    return ['trash'];
	            }
	        }
	    }, {
	        key: 'loadVehicles',
	        value: function () {
	            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
	                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bus';
	                var forceNext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	                var response, _type;
	
	                return regeneratorRuntime.wrap(function _callee11$(_context12) {
	                    while (1) {
	                        switch (_context12.prev = _context12.next) {
	                            case 0:
	                                if (type === 'bus') {
	                                    type = 'kiutr';
	                                }
	                                _context12.next = 3;
	                                return this.props.getVehicleList({
	                                    pagination: {
	                                        page: 1,
	                                        limit: 10000
	                                    },
	                                    filters: {
	                                        withActiveBnso: true,
	                                        withComponent: type
	                                    }
	                                });
	
	                            case 3:
	                                response = _context12.sent;
	
	                                if (!response.isOk) {
	                                    _context12.next = 14;
	                                    break;
	                                }
	
	                                _type = this.props.params.type;
	
	                                if (_type === 'bus') {
	                                    _type = 'kiutr';
	                                }
	
	                                if (!(_type !== type)) {
	                                    _context12.next = 9;
	                                    break;
	                                }
	
	                                return _context12.abrupt('return');
	
	                            case 9:
	                                _context12.next = 11;
	                                return this.setState({
	                                    vehicles: (0, _keyBy3.default)(response.data.payload.items, 'current_bnso.bnso_number')
	                                });
	
	                            case 11:
	                                //this.loadCarriers(_.uniq(_.filter(_.map(response.data.payload.items, 'unit_uuid'))));
	                                forceNext && this.loadTelematics(); //this._cycleFetch.forceNext();
	                                _context12.next = 16;
	                                break;
	
	                            case 14:
	                                response.showErrors();
	                                this.setState({ loading: false });
	
	                            case 16:
	                            case 'end':
	                                return _context12.stop();
	                        }
	                    }
	                }, _callee11, this);
	            }));
	
	            function loadVehicles() {
	                return _ref13.apply(this, arguments);
	            }
	
	            return loadVehicles;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var loader = this.state.loading === true ? _react2.default.createElement(_globalLoader2.default, { block: false, style: { zIndex: 99999 } }) : '';
	
	            var title = '\u041F\u043E\u0440\u0442\u0430\u043B ' + window.RNIS_SETTINGS.SHORT_TITLE;
	
	            if (this.props.params.type === 'bus') {
	                title = '\u041F\u043E\u0440\u0442\u0430\u043B ' + window.RNIS_SETTINGS.SHORT_TITLE + ' ' + (!window.RNIS_SETTINGS.CITY_OMSK ?  true ? this.state.totalCount : '-' : '');
	            }
	
	            if (this.props.params.type !== 'bus' && window.RNIS_SETTINGS.CITY_OMSK) {
	                title = '\u041F\u043E\u0440\u0442\u0430\u043B ' + window.RNIS_SETTINGS.SHORT_TITLE;
	            }
	
	            if (window.RNIS_SETTINGS.CITY_MURMANSK) {
	                title = 'Работа коммунальной техники сегодня';
	            }
	
	            var focusRoute = this.map && this.map.refs.map ? this.map.refs.map.getWrappedInstance().state.focusRoute : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { key: this.props.params.type, pageId: 'Main', title: title, className: (0, _classnames2.default)('_fullheight', {
	                        'full-schedule-route': this.state.fullScheduleRoute
	                    }) },
	                loader,
	                this.state.telematics.size > 0 || this.state.clusters.length > 0 ? _react2.default.createElement('div', { className: 'has-markers' }) : null,
	                _react2.default.createElement(
	                    _leaflet2.default,
	                    _extends({
	                        ref: function ref(n) {
	                            if (!_this4.map) {
	                                _this4.map = n;
	                                _this4.loadTelematics(true);
	                            }
	                        }
	                    }, this.props, {
	                        telematics: this.state.telematics,
	                        vehicles: this.state.vehicles,
	                        clusters: this.state.clusters,
	                        onClusterRendered: this.onClusterRendered.bind(this),
	                        onZoom: this.onZoomLoad.bind(this),
	                        data: {
	                            vehicle_models: this.state.vehicle_models,
	                            vehicle_marks: this.state.vehicle_marks,
	                            carriers: this.state.carriers
	                        },
	                        onStopPointClick: focusRoute && /transit/.test(focusRoute) ? this.onStopPointClick.bind(this) : null,
	                        onStopPointScheduleClick: this.onStopPointScheduleClick.bind(this),
	                        onStopPointFromHereClick: this.onStopPointFromHereClick.bind(this),
	                        onStopPointToHereClick: this.onStopPointToHereClick.bind(this),
	                        selectedStopPoint: (0, _get3.default)(this.state.activeStopPoint, 'uuid'),
	                        selectedStopPoints: (0, _get3.default)(this.state.fullScheduleRouteRun, 'stop_points', [])
	                    }),
	                    this.props.params.type === 'road' ? this.state.user_geo_objects.map(this.renderUserGeoObject.bind(this)) : null,
	                    this.props.params.type === 'garbage' ? this.renderGarbageObjects() : null,
	                    this.renderMo(),
	                    window.RNIS_SETTINGS.CITY_MURMANSK && this.state.mu && this.renderMu(),
	                    window.RNIS_SETTINGS.CITY_MURMANSK && this.state.muTasks && this.renderMuRoadParts(),
	                    window.RNIS_SETTINGS.CITY_MURMANSK && this.state.isNeedContractRender && this.state.contractsToRender.length && this.renderMuContracts(),
	                    this.renderRoute()
	                ),
	                window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderWorkTypeSelect() : null,
	                window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderMunicipalities() : null,
	                window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderCustomDatePicker() : null,
	                location.pathname.includes('map/road') && window.RNIS_SETTINGS.CITY_MURMANSK ? this.renderLegend() : null,
	                this.renderStopPointModal()
	            );
	        }
	    }, {
	        key: 'onStopPointScheduleClick',
	        value: function () {
	            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(stopPoint) {
	                var stopPointTime;
	                return regeneratorRuntime.wrap(function _callee12$(_context13) {
	                    while (1) {
	                        switch (_context13.prev = _context13.next) {
	                            case 0:
	                                _context13.next = 2;
	                                return this.map.refs.map.getWrappedInstance().closeRouting();
	
	                            case 2:
	                                _context13.next = 4;
	                                return this.closeStopPoint();
	
	                            case 4:
	                                stopPointTime = (0, _moment2.default)();
	                                _context13.next = 7;
	                                return this.setState({
	                                    stopPointTime: stopPointTime,
	                                    activeStopPoint: stopPoint,
	                                    routes: []
	                                });
	
	                            case 7:
	
	                                this.loadRoutes();
	
	                            case 8:
	                            case 'end':
	                                return _context13.stop();
	                        }
	                    }
	                }, _callee12, this);
	            }));
	
	            function onStopPointScheduleClick(_x9) {
	                return _ref14.apply(this, arguments);
	            }
	
	            return onStopPointScheduleClick;
	        }()
	    }, {
	        key: 'onStopPointFromHereClick',
	        value: function () {
	            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(stopPoint) {
	                return regeneratorRuntime.wrap(function _callee13$(_context14) {
	                    while (1) {
	                        switch (_context14.prev = _context14.next) {
	                            case 0:
	                                _context14.next = 2;
	                                return this.closeStopPoint();
	
	                            case 2:
	                                _context14.next = 4;
	                                return this.map.refs.map.getWrappedInstance().closeRouting();
	
	                            case 4:
	                                _context14.next = 6;
	                                return this.map.refs.map.getWrappedInstance().routing();
	
	                            case 6:
	                                this.map.refs.map.getWrappedInstance().reverseGeocode(stopPoint.latitude, stopPoint.longitude, 'from');
	
	                            case 7:
	                            case 'end':
	                                return _context14.stop();
	                        }
	                    }
	                }, _callee13, this);
	            }));
	
	            function onStopPointFromHereClick(_x10) {
	                return _ref15.apply(this, arguments);
	            }
	
	            return onStopPointFromHereClick;
	        }()
	    }, {
	        key: 'onStopPointToHereClick',
	        value: function () {
	            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(stopPoint) {
	                return regeneratorRuntime.wrap(function _callee14$(_context15) {
	                    while (1) {
	                        switch (_context15.prev = _context15.next) {
	                            case 0:
	                                _context15.next = 2;
	                                return this.closeStopPoint();
	
	                            case 2:
	                                _context15.next = 4;
	                                return this.map.refs.map.getWrappedInstance().closeRouting();
	
	                            case 4:
	                                _context15.next = 6;
	                                return this.map.refs.map.getWrappedInstance().routing();
	
	                            case 6:
	                                this.map.refs.map.getWrappedInstance().reverseGeocode(stopPoint.latitude, stopPoint.longitude, 'to');
	
	                            case 7:
	                            case 'end':
	                                return _context15.stop();
	                        }
	                    }
	                }, _callee14, this);
	            }));
	
	            function onStopPointToHereClick(_x11) {
	                return _ref16.apply(this, arguments);
	            }
	
	            return onStopPointToHereClick;
	        }()
	    }, {
	        key: 'onStopPointClick',
	        value: function () {
	            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(stopPoint) {
	                var stopPointTime, focusRoute;
	                return regeneratorRuntime.wrap(function _callee15$(_context16) {
	                    while (1) {
	                        switch (_context16.prev = _context16.next) {
	                            case 0:
	                                stopPointTime = (0, _moment2.default)();
	                                focusRoute = this.map.refs.map.getWrappedInstance().state.focusRoute;
	
	                                if (!(focusRoute && /transit/.test(focusRoute))) {
	                                    _context16.next = 5;
	                                    break;
	                                }
	
	                                this.map.refs.map.getWrappedInstance().onStopPointClick(stopPoint);
	                                return _context16.abrupt('return');
	
	                            case 5:
	                                _context16.next = 7;
	                                return this.setState({
	                                    stopPointTime: stopPointTime,
	                                    activeStopPoint: stopPoint,
	                                    routes: []
	                                });
	
	                            case 7:
	
	                                this.loadRoutes();
	
	                            case 8:
	                            case 'end':
	                                return _context16.stop();
	                        }
	                    }
	                }, _callee15, this);
	            }));
	
	            function onStopPointClick(_x12) {
	                return _ref17.apply(this, arguments);
	            }
	
	            return onStopPointClick;
	        }()
	    }, {
	        key: 'loadRoutes',
	        value: function () {
	            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
	                var _this5 = this;
	
	                var response;
	                return regeneratorRuntime.wrap(function _callee16$(_context17) {
	                    while (1) {
	                        switch (_context17.prev = _context17.next) {
	                            case 0:
	                                this.setState({ isRoutesLoading: true });
	                                _context17.next = 3;
	                                return this.props.getStopPointRoutes(this.state.activeStopPoint.uuid);
	
	                            case 3:
	                                response = _context17.sent;
	
	                                this.setState({ isRoutesLoading: false });
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        routes: (0, _sortBy3.default)(response.payload.items, 'number')
	                                    });
	
	                                    (0, _each3.default)(response.payload.items, function (route) {
	                                        if (route.time !== -1) {
	                                            _this5.loadStopPointRouteRuns(route.uuid);
	                                        }
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context17.stop();
	                        }
	                    }
	                }, _callee16, this);
	            }));
	
	            function loadRoutes() {
	                return _ref18.apply(this, arguments);
	            }
	
	            return loadRoutes;
	        }()
	    }, {
	        key: 'toggleFaq',
	        value: function toggleFaq() {
	            this.setState({
	                faqOpened: !this.state.faqOpened
	            });
	        }
	    }, {
	        key: 'renderMuLegend',
	        value: function renderMuLegend() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'legend' },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('faq', {
	                            'expand': this.state.faqOpened
	                        }) },
	                    _react2.default.createElement('div', { className: (0, _classnames2.default)('faq__btn', {
	                            'faq__btn_opened': this.state.faqOpened
	                        }), onClick: this.toggleFaq.bind(this) }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'faq__inner big' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'faq__title' },
	                            '\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u043E\u0431\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043D\u0430 \u0433\u0440\u0430\u0444\u0438\u043A\u0435'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'faq__content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'faq__row faq__row_short' },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '%'
	                                ),
	                                ' - \u043F\u0440\u043E\u0446\u0435\u043D\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u0434\u0430\u043D\u0438\u0439 \u0437\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F\u0448\u043D\u0438\u0439 \u0434\u0435\u043D\u044C (\u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435  \u0440\u0430\u0431\u043E\u0442 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u043B\u0430\u043D\u0430).'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderLegend',
	        value: function renderLegend() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'legend' },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('faq', {
	                            'expand': this.state.faqOpened
	                        }) },
	                    _react2.default.createElement('div', { className: (0, _classnames2.default)('faq__btn', {
	                            'faq__btn_opened': this.state.faqOpened
	                        }), onClick: this.toggleFaq.bind(this) }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'faq__inner big' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'faq__title' },
	                            '\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u043E\u0431\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043D\u0430 \u0433\u0440\u0430\u0444\u0438\u043A\u0435'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'faq__content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'faq__row' },
	                                '\u0420\u0430\u0431\u043E\u0442\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430',
	                                _react2.default.createElement('div', { className: 'indicators indicators_green2' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'faq__row' },
	                                '\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E',
	                                _react2.default.createElement('div', { className: 'indicators indicators_yellow' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'faq__row' },
	                                '\u0420\u0430\u0431\u043E\u0442\u0430 \u043D\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430',
	                                _react2.default.createElement('div', { className: 'indicators indicators_red2' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'faq__row' },
	                                '\u0420\u0430\u0431\u043E\u0442\u0430 \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0430/\u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F',
	                                _react2.default.createElement('div', { className: 'indicators indicators_gray2' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'faq__row' },
	                                '\u041E\u0431\u044A\u0435\u043A\u0442\u044B \u043F\u043E \u043F\u043E\u0434\u0440\u044F\u0434\u0430\u043C',
	                                _react2.default.createElement('div', { className: 'indicators indicators_blue' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderUserGeoObject',
	        value: function renderUserGeoObject(object) {
	            return _react2.default.createElement(_geojson2.default, {
	                key: object.uuid,
	                map: this.map.refs.map,
	                leafletMap: this.map.refs.map.getWrappedInstance().map,
	                geometry: object.geometry,
	                tooltip: object.title
	            });
	        }
	    }, {
	        key: 'onClusterRendered',
	        value: function onClusterRendered() {
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'onZoomLoad',
	        value: function onZoomLoad() {
	            //this._cycleFetch && this._cycleFetch.forceNextWithDelay(300);
	            this.loadTelematics();
	        }
	    }, {
	        key: 'loadDictionaries',
	        value: function () {
	            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(dictionaries) {
	                var _this6 = this;
	
	                var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                return regeneratorRuntime.wrap(function _callee18$(_context19) {
	                    while (1) {
	                        switch (_context19.prev = _context19.next) {
	                            case 0:
	                                (0, _each3.default)(dictionaries, function () {
	                                    var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(dictionary) {
	                                        var documents, state;
	                                        return regeneratorRuntime.wrap(function _callee17$(_context18) {
	                                            while (1) {
	                                                switch (_context18.prev = _context18.next) {
	                                                    case 0:
	                                                        _context18.next = 2;
	                                                        return _this6.getDictionary(dictionary, component);
	
	                                                    case 2:
	                                                        documents = _context18.sent;
	
	
	                                                        documents = dictionary === 'vehicle_types' ? _this6.filterVehicleTypes(documents) : documents;
	
	                                                        dictionary === 'vehicle_types' ? window.vehicle_types = documents : null;
	
	                                                        state = _this6.state;
	
	                                                        state[dictionary] = documents;
	                                                        _this6.setState(state);
	
	                                                    case 8:
	                                                    case 'end':
	                                                        return _context18.stop();
	                                                }
	                                            }
	                                        }, _callee17, _this6);
	                                    }));
	
	                                    return function (_x15) {
	                                        return _ref20.apply(this, arguments);
	                                    };
	                                }());
	
	                            case 1:
	                            case 'end':
	                                return _context19.stop();
	                        }
	                    }
	                }, _callee18, this);
	            }));
	
	            function loadDictionaries(_x13) {
	                return _ref19.apply(this, arguments);
	            }
	
	            return loadDictionaries;
	        }()
	    }, {
	        key: 'filterVehicleTypes',
	        value: function filterVehicleTypes(documents) {
	            var arr = (0, _values3.default)(documents);
	            return arr.filter(function (item) {
	                return item.component === 'kiutr' && item.name === 'Автобус' || item.name === 'Троллейбус' || item.name === 'Трамвай';
	            });
	        }
	    }, {
	        key: 'getDictionary',
	        value: function () {
	            var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(dictionary) {
	                var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                var response;
	                return regeneratorRuntime.wrap(function _callee19$(_context20) {
	                    while (1) {
	                        switch (_context20.prev = _context20.next) {
	                            case 0:
	                                _context20.next = 2;
	                                return this.props.getDictionaryList(dictionary, {
	                                    order: {
	                                        column: 'name',
	                                        direction: 'asc'
	                                    },
	                                    filters: {
	                                        withComponent: component
	                                    }
	                                });
	
	                            case 2:
	                                response = _context20.sent;
	
	                                if (!response.isOk) {
	                                    _context20.next = 7;
	                                    break;
	                                }
	
	                                return _context20.abrupt('return', (0, _keyBy3.default)(response.payload.documents, 'uuid'));
	
	                            case 7:
	                                response.showErrors();
	
	                            case 8:
	                            case 'end':
	                                return _context20.stop();
	                        }
	                    }
	                }, _callee19, this);
	            }));
	
	            function getDictionary(_x16) {
	                return _ref21.apply(this, arguments);
	            }
	
	            return getDictionary;
	        }()
	    }, {
	        key: 'renderGarbageObjects',
	        value: function renderGarbageObjects() {
	            if (!this.map || !this.map.refs.map) {
	                return null;
	            }
	
	            return [_react2.default.createElement(_garbageObjects2.default, {
	                key: 'kp',
	                type: 'kp',
	                map: this.map.refs.map,
	                leafletMap: this.map.refs.map.getWrappedInstance().map
	            }), _react2.default.createElement(_garbageObjects2.default, {
	                key: 'op',
	                type: 'op',
	                map: this.map.refs.map,
	                leafletMap: this.map.refs.map.getWrappedInstance().map
	            }), _react2.default.createElement(_garbageObjects2.default, {
	                key: 'opp',
	                type: 'opp',
	                map: this.map.refs.map,
	                leafletMap: this.map.refs.map.getWrappedInstance().map
	            }), _react2.default.createElement(_garbageObjects2.default, {
	                key: 'os',
	                type: 'os',
	                map: this.map.refs.map,
	                leafletMap: this.map.refs.map.getWrappedInstance().map
	            })];
	        }
	    }, {
	        key: 'closeStopPoint',
	        value: function () {
	            var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
	                return regeneratorRuntime.wrap(function _callee20$(_context21) {
	                    while (1) {
	                        switch (_context21.prev = _context21.next) {
	                            case 0:
	                                _context21.next = 2;
	                                return this.setState({
	                                    activeStopPoint: null,
	                                    routes: [],
	                                    fullScheduleRoute: null,
	                                    fullScheduleRouteRun: null
	                                });
	
	                            case 2:
	
	                                this.map.refs.map.getWrappedInstance().invalidateSize();
	
	                            case 3:
	                            case 'end':
	                                return _context21.stop();
	                        }
	                    }
	                }, _callee20, this);
	            }));
	
	            function closeStopPoint() {
	                return _ref22.apply(this, arguments);
	            }
	
	            return closeStopPoint;
	        }()
	    }, {
	        key: 'renderStopPointModal',
	        value: function renderStopPointModal() {
	            if (!this.state.activeStopPoint) {
	                return null;
	            }
	
	            var buttons = _react2.default.createElement(
	                _modalTopMenuButtons2.default,
	                null,
	                _react2.default.createElement(
	                    _modalTopMenuList2.default,
	                    { className: 'top-menu_modal_edit' },
	                    _react2.default.createElement(_modalTopMenuListItem2.default, {
	                        className: 'b-icon-link_icon_print',
	                        onClick: this.print.bind(this)
	                    })
	                ),
	                _react2.default.createElement(_modalTopMenuButton2.default, {
	                    className: '_close',
	                    onClick: this.closeStopPoint.bind(this)
	                })
	            );
	
	            var stopPoint = this.state.activeStopPoint;
	
	            var title = _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title__name' },
	                    stopPoint.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title__date' },
	                    '\u0414\u0432\u0438\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 ',
	                    this.state.stopPointTime.format(_formats2.default.DATETIME_SHORT)
	                )
	            );
	
	            return [_react2.default.createElement(
	                _pageModal2.default,
	                {
	                    key: 'stop-point',
	                    header: { titleFull: title, buttons: buttons },
	                    withFade: false,
	                    className: 'b-modal-trip-planner-result b-modal-trip-planner-result-panel',
	                    onClose: this.closeStopPoint.bind(this) },
	                this.state.isRoutesLoading ? _react2.default.createElement(_globalLoader2.default, null) : null,
	                _react2.default.createElement(
	                    _accordion2.default,
	                    { ref: 'stop-point' },
	                    (0, _map3.default)(this.state.routes, this.renderStopPointRoute.bind(this))
	                )
	            ), this.state.fullScheduleRoute ? this.renderFullSchedule() : null];
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            (0, _print2.print)((0, _index.printSchedule)(this.state.activeStopPoint, this.state.routes, this.state.stopPointRouteRuns));
	        }
	    }, {
	        key: 'renderStopPointRoute',
	        value: function renderStopPointRoute(route) {
	            var uuid = route.uuid,
	                number = route.number,
	                title = route.title,
	                from = route.from,
	                to = route.to,
	                count = route.count,
	                time = route.time;
	
	
	            var afterTitle = _react2.default.createElement(
	                'div',
	                { className: 'accordion__dscn' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'accordion__route transport_info' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'transport_icon' },
	                        _react2.default.createElement('i', { className: 'transport_bus' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'transport_number' },
	                        number
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'transport_route' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'transport_route_start' },
	                            from
	                        ),
	                        '-',
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'transport_route_finish' },
	                            to
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'transport_station' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'transport_station-count' },
	                            count
	                        ),
	                        ' \u043E\u0441\u0442.',
	                        time !== -1 ? _react2.default.createElement('i', { className: 'transport_station-icon', onClick: this.showFullSchedule.bind(this, uuid) }) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'transport_time' },
	                        time !== -1 ? [_react2.default.createElement(
	                            'span',
	                            { key: 'status', className: 'transport_status transport_status_tilda' },
	                            '~'
	                        ), _react2.default.createElement(
	                            'span',
	                            { key: 'time',
	                                className: 'transport_time-count' },
	                            (0, _functions.formatTime)(Math.round(time / 60))
	                        )] : _react2.default.createElement(
	                            'span',
	                            { className: 'transport_time-count' },
	                            '-'
	                        )
	                    )
	                )
	            );
	
	            var runs = (0, _filter3.default)((0, _flatten3.default)((0, _get3.default)(this.state.stopPointRouteRuns, uuid, [])));
	            var lastPageRuns = (0, _get3.default)(this.state.stopPointRouteRuns, uuid + '.' + this.state.stopPointRoutePages[uuid], []);
	
	            return _react2.default.createElement(
	                _accordionItem2.default,
	                { key: route.uuid, afterTitle: afterTitle,
	                    onOpened: this.loadStopPointRouteRuns.bind(this, uuid),
	                    collapsable: time !== -1,
	                    withoutWrapper: time === -1 },
	                (0, _map3.default)(runs, this.renderRouteRun.bind(this, uuid)),
	                time !== -1 ? _react2.default.createElement(
	                    'button',
	                    { className: 'transport_later',
	                        title: '\u041F\u043E\u0437\u0436\u0435',
	                        onClick: this.loadStopPointRouteRuns.bind(this, uuid, this.state.stopPointRoutePages[uuid] + 1) },
	                    _react2.default.createElement('i', { className: 'transport_arrow transport_arrow_bottom' })
	                ) : null
	            );
	        }
	    }, {
	        key: 'focusOnRun',
	        value: function focusOnRun(geometry) {
	            this.map.refs.map.getWrappedInstance().fitBounds(new _leaflet4.default.geoJSON(geometry).getBounds(), {
	                padding: new _leaflet4.default.point(20, 20)
	            });
	        }
	    }, {
	        key: 'showFullSchedule',
	        value: function () {
	            var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(routeUuid) {
	                var response;
	                return regeneratorRuntime.wrap(function _callee21$(_context22) {
	                    while (1) {
	                        switch (_context22.prev = _context22.next) {
	                            case 0:
	                                _context22.next = 2;
	                                return this.setState({
	                                    fullScheduleRoute: routeUuid,
	                                    fullScheduleRouteRun: null
	                                });
	
	                            case 2:
	                                this.map.refs.map.getWrappedInstance().invalidateSize();
	                                _context22.next = 5;
	                                return this.props.getStopPointRouteRuns(this.state.activeStopPoint.uuid, routeUuid, null, true);
	
	                            case 5:
	                                response = _context22.sent;
	
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        fullScheduleRoute: routeUuid,
	                                        fullScheduleRouteRun: (0, _first3.default)(response.payload.items)
	                                    });
	                                    this.focusOnRun((0, _first3.default)(response.payload.items).geometry);
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 7:
	                            case 'end':
	                                return _context22.stop();
	                        }
	                    }
	                }, _callee21, this);
	            }));
	
	            function showFullSchedule(_x18) {
	                return _ref23.apply(this, arguments);
	            }
	
	            return showFullSchedule;
	        }()
	    }, {
	        key: 'closeFullSchedule',
	        value: function () {
	            var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
	                return regeneratorRuntime.wrap(function _callee22$(_context23) {
	                    while (1) {
	                        switch (_context23.prev = _context23.next) {
	                            case 0:
	                                _context23.next = 2;
	                                return this.setState({
	                                    fullScheduleRoute: null,
	                                    fullScheduleRouteRun: null
	                                });
	
	                            case 2:
	                                this.map.refs.map.getWrappedInstance().invalidateSize();
	
	                            case 3:
	                            case 'end':
	                                return _context23.stop();
	                        }
	                    }
	                }, _callee22, this);
	            }));
	
	            function closeFullSchedule() {
	                return _ref24.apply(this, arguments);
	            }
	
	            return closeFullSchedule;
	        }()
	    }, {
	        key: 'renderFullSchedule',
	        value: function renderFullSchedule() {
	            var buttons = _react2.default.createElement(
	                _modalTopMenuButtons2.default,
	                null,
	                _react2.default.createElement(_modalTopMenuButton2.default, {
	                    className: '_close',
	                    onClick: this.closeFullSchedule.bind(this)
	                })
	            );
	
	            var stopPoint = this.state.activeStopPoint;
	            var run = this.state.fullScheduleRouteRun;
	            var route = (0, _find3.default)(this.state.routes, { uuid: this.state.fullScheduleRoute });
	
	            var title = _react2.default.createElement(
	                'div',
	                { className: 'b-modal__name' },
	                '\u0421\u0445\u0435\u043C\u0430 \u0440\u0435\u0439\u0441\u0430',
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__name-dscn font-weight-normal' },
	                    '\u0427\u0435\u0440\u0435\u0437 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443 ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        stopPoint.title
	                    ),
	                    ' ',
	                    _react2.default.createElement('br', null),
	                    '\u043F\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443 ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        route.number
	                    )
	                )
	            );
	
	            var stopPoints = (0, _sortBy3.default)((0, _map3.default)((0, _get3.default)(run, 'times') || [], function (time, title) {
	                return {
	                    title: title,
	                    time: time
	                };
	            }), function (_ref25) {
	                var time = _ref25.time;
	
	                return time;
	            });
	
	            var position = 0;
	            (0, _each3.default)(stopPoints, function (_ref26, index) {
	                var time = _ref26.time,
	                    title = _ref26.title;
	
	                if (title === stopPoint.title) {
	                    position = index + 1;
	                    return false;
	                }
	            });
	
	            var content = null;
	            if (run) {
	                content = _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 't-segment' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 't-segment__header' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 't-segment__header-row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__header-left' },
	                                                '\u041F\u0440\u043E\u0442\u044F\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u044C'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                {
	                                                    className: 't-segment__header-right' },
	                                                (0, _functions.formatDistance)(run.distance)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 't-segment__header-row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__header-left' },
	                                                '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__header-right' },
	                                                (0, _functions.formatTime)(run.total_time)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 't-segment__header-row' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__header-left' },
	                                                '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043E\u043A \u0434\u043E \u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0439'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                {
	                                                    className: 't-segment__header-right' },
	                                                Math.max(0, stopPoints.length - position),
	                                                '(\u0432\u0441\u0435\u0433\u043E - ',
	                                                stopPoints.length - 1,
	                                                ')'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 't-segment__content' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 't-segment__content-right' },
	                                            (0, _map3.default)(stopPoints, function (_ref27, index) {
	                                                var title = _ref27.title,
	                                                    time = _ref27.time;
	
	                                                if (index === 0) {
	                                                    return _react2.default.createElement(
	                                                        'div',
	                                                        { key: index,
	                                                            className: (0, _classnames2.default)('t-segment__point t-segment__point_start', {
	                                                                't-segment__point_start-current': index === position - 1
	                                                            }) },
	                                                        _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_gray p-result__icon_border p-result__icon_wh24' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__point-text' },
	                                                            title
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            {
	                                                                className: 't-segment__stops-item-time' },
	                                                            (0, _moment2.default)(time).format(_formats2.default.TIME)
	                                                        )
	                                                    );
	                                                }
	
	                                                if (index === stopPoints.length - 1) {
	                                                    return _react2.default.createElement(
	                                                        'div',
	                                                        { key: index,
	                                                            className: (0, _classnames2.default)('t-segment__point t-segment__point_final', {
	                                                                't-segment__point_final-current': index === position - 1
	                                                            }) },
	                                                        _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_green p-result__icon_border p-result__icon_wh24' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__point-text' },
	                                                            title
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            {
	                                                                className: 't-segment__stops-item-time' },
	                                                            (0, _moment2.default)(time).format(_formats2.default.TIME)
	                                                        )
	                                                    );
	                                                }
	
	                                                var stopPointBlock = _react2.default.createElement(
	                                                    'div',
	                                                    { key: index,
	                                                        className: (0, _classnames2.default)('t-segment__stops-item', {}) },
	                                                    _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_inner-green p-result__icon_wh24' }),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__stops-item-text' },
	                                                        title
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        {
	                                                            className: 't-segment__stops-item-time' },
	                                                        (0, _moment2.default)(time).format(_formats2.default.TIME)
	                                                    )
	                                                );
	
	                                                if (index < position - 1) {
	                                                    return _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__stops t-segment__stops-no-active' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { key: index,
	                                                                className: (0, _classnames2.default)('t-segment__stops-item', {}) },
	                                                            _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_inner-gray p-result__icon_wh24' }),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                {
	                                                                    className: 't-segment__stops-item-text' },
	                                                                title
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                {
	                                                                    className: 't-segment__stops-item-time' },
	                                                                (0, _moment2.default)(time).format(_formats2.default.TIME)
	                                                            )
	                                                        )
	                                                    );
	                                                }
	
	                                                if (index === position - 1) {
	                                                    return _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__stops t-segment__stops_current' },
	                                                        stopPointBlock
	                                                    );
	                                                }
	
	                                                return stopPointBlock;
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                _pageModal2.default,
	                {
	                    key: 'stop-point-run',
	                    header: { titleFull: title, buttons: buttons },
	                    withFade: false,
	                    className: 'b-modal-trip-planner-result tripStructure',
	                    onClose: this.closeStopPoint.bind(this) },
	                !run ? _react2.default.createElement(_globalLoader2.default, null) : null,
	                content
	            );
	        }
	    }, {
	        key: 'showFullScheduleForRun',
	        value: function () {
	            var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(routeUuid, run) {
	                return regeneratorRuntime.wrap(function _callee23$(_context24) {
	                    while (1) {
	                        switch (_context24.prev = _context24.next) {
	                            case 0:
	                                _context24.next = 2;
	                                return this.setState({
	                                    fullScheduleRoute: routeUuid,
	                                    fullScheduleRouteRun: run
	                                });
	
	                            case 2:
	                                _context24.next = 4;
	                                return this.map.refs.map.getWrappedInstance().invalidateSize();
	
	                            case 4:
	
	                                this.focusOnRun(this.getRunGeometry(run));
	
	                            case 5:
	                            case 'end':
	                                return _context24.stop();
	                        }
	                    }
	                }, _callee23, this);
	            }));
	
	            function showFullScheduleForRun(_x19, _x20) {
	                return _ref28.apply(this, arguments);
	            }
	
	            return showFullScheduleForRun;
	        }()
	    }, {
	        key: 'getRunGeometry',
	        value: function getRunGeometry(run) {
	            var geometry = run.geometry;
	            if (!geometry) {
	                return geometry;
	            }
	
	            geometry.coordinates = (0, _filter3.default)(geometry.coordinates, function (coordinates) {
	                return coordinates[0] !== 0 && coordinates[1] !== 0;
	            });
	
	            return geometry;
	        }
	    }, {
	        key: 'renderRouteRun',
	        value: function renderRouteRun(routeUuid, run, index) {
	            var time = run.time,
	                end_at = run.end_at,
	                times = run.times;
	
	
	            var diff = (0, _moment2.default)(time).diff(this.state.stopPointTime, 'minutes');
	
	            return _react2.default.createElement(
	                'div',
	                { key: index, className: 'transport_row', onClick: this.showFullScheduleForRun.bind(this, routeUuid, run) },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'transport_status transport_status_tilda' },
	                    '~'
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'transport_timetable' },
	                    (0, _moment2.default)(time).format(_formats2.default.TIME)
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'transport_time-finitestate' },
	                    '\u043D\u0430 \u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0439',
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'transport_status transport_status_tilda' },
	                        '~'
	                    ),
	                    (0, _moment2.default)(end_at).format(_formats2.default.TIME),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'transport_question' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'transport_question_prompt prompt' },
	                            (0, _map3.default)(times, function (time, title) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { key: title + ':' + (0, _moment2.default)(time).format(_formats2.default.TIME), className: 'prompt_row' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        title
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'prompt_time' },
	                                        (0, _moment2.default)(time).format(_formats2.default.TIME)
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'loadStopPointRouteRuns',
	        value: function () {
	            var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(routeUuid) {
	                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	                var stopPointRoutePages, response, stopPointRouteRuns;
	                return regeneratorRuntime.wrap(function _callee24$(_context25) {
	                    while (1) {
	                        switch (_context25.prev = _context25.next) {
	                            case 0:
	                                stopPointRoutePages = this.state.stopPointRoutePages;
	
	                                stopPointRoutePages[routeUuid] = Math.max(stopPointRoutePages[routeUuid] || 1, page);
	
	                                if (!(0, _get3.default)(this.state.stopPointRouteRuns, routeUuid + '.' + page)) {
	                                    _context25.next = 5;
	                                    break;
	                                }
	
	                                this.setState({ stopPointRoutePages: stopPointRoutePages });
	                                return _context25.abrupt('return');
	
	                            case 5:
	                                _context25.next = 7;
	                                return this.props.getStopPointRouteRuns(this.state.activeStopPoint.uuid, routeUuid, null, false, page);
	
	                            case 7:
	                                response = _context25.sent;
	
	
	                                if (response.isOk) {
	                                    stopPointRouteRuns = this.state.stopPointRouteRuns;
	
	                                    (0, _set3.default)(stopPointRouteRuns, routeUuid + '.' + page, response.payload.items);
	                                    this.setState({ stopPointRouteRuns: stopPointRouteRuns, stopPointRoutePages: stopPointRoutePages });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 9:
	                            case 'end':
	                                return _context25.stop();
	                        }
	                    }
	                }, _callee24, this);
	            }));
	
	            function loadStopPointRouteRuns(_x21) {
	                return _ref29.apply(this, arguments);
	            }
	
	            return loadStopPointRouteRuns;
	        }()
	    }, {
	        key: 'formatTime',
	        value: function formatTime(seconds) {
	            if (seconds === -1) {
	                return '-';
	            }
	            if (seconds < 60) {
	                return '\u0447\u0435\u0440\u0435\u0437 ' + seconds + ' \u0441\u0435\u043A';
	            }
	            var minutes = seconds / 60;
	            if (minutes < 60) {
	                return '\u0447\u0435\u0440\u0435\u0437 ' + (0, _round3.default)(minutes) + ' \u043C\u0438\u043D';
	            }
	            var hours = minutes / 60;
	            if (hours < 24) {
	                return '\u0447\u0435\u0440\u0435\u0437 ' + (0, _round3.default)(hours) + ' \u0447';
	            }
	            return '\u0447\u0435\u0440\u0435\u0437 ' + (0, _round3.default)(hours / 24) + ' \u0434\u043D';
	        }
	    }, {
	        key: 'loadMo',
	        value: function () {
	            var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(type) {
	                var meta, response;
	                return regeneratorRuntime.wrap(function _callee25$(_context26) {
	                    while (1) {
	                        switch (_context26.prev = _context26.next) {
	                            case 0:
	                                meta = {
	                                    filters: {
	                                        withComponent: type
	                                    }
	                                };
	                                _context26.next = 3;
	                                return this.props.listUserGeoObjectsMO(meta);
	
	                            case 3:
	                                response = _context26.sent;
	
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        mo: response.payload.items
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 5:
	                            case 'end':
	                                return _context26.stop();
	                        }
	                    }
	                }, _callee25, this);
	            }));
	
	            function loadMo(_x23) {
	                return _ref30.apply(this, arguments);
	            }
	
	            return loadMo;
	        }()
	    }, {
	        key: 'getWorksDoneByMunicipalityUuid',
	        value: function () {
	            var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(communal_municipality_uuid) {
	                var dateTo, dateFrom, from_date, to_date, meta, response;
	                return regeneratorRuntime.wrap(function _callee26$(_context27) {
	                    while (1) {
	                        switch (_context27.prev = _context27.next) {
	                            case 0:
	                                dateTo = (0, _moment2.default)().utcOffset(0);
	
	                                dateTo.set({ hour: 23, minute: 59, second: 0, millisecond: 0 });
	
	                                dateFrom = (0, _moment2.default)().utcOffset(0);
	
	                                dateFrom.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
	
	                                from_date = 0;
	                                to_date = 0;
	                                _context27.t0 = this.state.customDateSelected;
	                                _context27.next = _context27.t0 === 0 ? 9 : _context27.t0 === 1 ? 12 : _context27.t0 === 2 ? 15 : 18;
	                                break;
	
	                            case 9:
	                                from_date = (0, _moment2.default)(dateFrom).subtract(1, 'd').format();
	                                to_date = (0, _moment2.default)(dateTo).subtract(1, 'd').format();
	                                return _context27.abrupt('break', 20);
	
	                            case 12:
	                                from_date = (0, _moment2.default)(dateFrom).format();
	                                to_date = (0, _moment2.default)(dateTo).format();
	                                return _context27.abrupt('break', 20);
	
	                            case 15:
	                                from_date = (0, _moment2.default)(dateFrom).add(1, 'd').format();
	                                to_date = (0, _moment2.default)(dateTo).add(1, 'd').format();
	                                return _context27.abrupt('break', 20);
	
	                            case 18:
	                                from_date = (0, _moment2.default)(dateFrom).format();
	                                to_date = (0, _moment2.default)(dateTo).format();
	
	                            case 20:
	                                meta = {
	                                    filters: {
	                                        withPeriod: [from_date, to_date]
	                                    }
	                                };
	
	
	                                if (this.state.selected_work_type !== 'all') {
	                                    meta.filters.withWorkTypes = [this.state.selected_work_type];
	                                }
	
	                                if (communal_municipality_uuid || this.state.selected_communal_uuid) {
	                                    meta.filters.withCommunalMunicipalities = communal_municipality_uuid ? [communal_municipality_uuid] : [this.state.selected_communal_uuid];
	                                }
	
	                                _context27.next = 25;
	                                return this.props.getTabletWorkSummary(meta);
	
	                            case 25:
	                                response = _context27.sent;
	                                return _context27.abrupt('return', response);
	
	                            case 27:
	                            case 'end':
	                                return _context27.stop();
	                        }
	                    }
	                }, _callee26, this);
	            }));
	
	            function getWorksDoneByMunicipalityUuid(_x24) {
	                return _ref31.apply(this, arguments);
	            }
	
	            return getWorksDoneByMunicipalityUuid;
	        }()
	    }, {
	        key: 'filteredByCommunalUuid',
	        value: function filteredByCommunalUuid(items, hasProperty) {
	            return items.filter(function (item) {
	                return 'communal_municipality_uuid' in item === hasProperty && item.hasOwnProperty('communal_municipality_uuid') === hasProperty;
	            });
	        }
	    }, {
	        key: 'loadMu',
	        value: function () {
	            var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(type) {
	                var layers, uuid, response, withCommunal, withoutCommunal, communalPromises, resultWithCommunal, defaultMunicipality;
	                return regeneratorRuntime.wrap(function _callee27$(_context28) {
	                    while (1) {
	                        switch (_context28.prev = _context28.next) {
	                            case 0:
	                                if (this.state.mu) {
	                                    _context28.next = 24;
	                                    break;
	                                }
	
	                                _context28.next = 3;
	                                return this.props.listLayers();
	
	                            case 3:
	                                layers = _context28.sent;
	                                uuid = layers.payload.items.filter(function (layer) {
	                                    return layer.title.includes('Муниципальные образования');
	                                })[0].uuid;
	                                _context28.next = 7;
	                                return this.props.listUserGeoObjectsByLayers({
	                                    items: [uuid]
	                                });
	
	                            case 7:
	                                response = _context28.sent;
	
	                                if (!response.isOk) {
	                                    _context28.next = 23;
	                                    break;
	                                }
	
	                                withCommunal = this.filteredByCommunalUuid(response.payload.items, true).sort(function (a, b) {
	                                    return a.title.toUpperCase() > b.title.toUpperCase() ? 1 : -1;
	                                });
	                                withoutCommunal = this.filteredByCommunalUuid(response.payload.items, false);
	                                communalPromises = withCommunal.map(function (itemMu) {
	                                    return itemMu;
	                                });
	                                _context28.next = 14;
	                                return Promise.all(communalPromises);
	
	                            case 14:
	                                resultWithCommunal = _context28.sent;
	                                _context28.next = 17;
	                                return this.setState({
	                                    selector_municipalities: withCommunal,
	                                    mu: [].concat(_toConsumableArray(resultWithCommunal), _toConsumableArray(withoutCommunal))
	                                });
	
	                            case 17:
	                                if (!(window.RNIS_SETTINGS.CITY_MURMANSK && withCommunal.length)) {
	                                    _context28.next = 21;
	                                    break;
	                                }
	
	                                defaultMunicipality = withCommunal.filter(function (municipality) {
	                                    return municipality.title === 'Городской округ Мурманск';
	                                })[0];
	                                _context28.next = 21;
	                                return this.setState({
	                                    selected_communal_uuid: defaultMunicipality.communal_municipality_uuid
	                                });
	
	                            case 21:
	                                _context28.next = 24;
	                                break;
	
	                            case 23:
	                                response.showErrors();
	
	                            case 24:
	                            case 'end':
	                                return _context28.stop();
	                        }
	                    }
	                }, _callee27, this);
	            }));
	
	            function loadMu(_x25) {
	                return _ref32.apply(this, arguments);
	            }
	
	            return loadMu;
	        }()
	    }, {
	        key: 'getGeometryFromContract',
	        value: function () {
	            var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
	                var dateTo, dateFrom, from_date, to_date, meta, response, contracts, bluePolygonsRoadPartUuid;
	                return regeneratorRuntime.wrap(function _callee28$(_context29) {
	                    while (1) {
	                        switch (_context29.prev = _context29.next) {
	                            case 0:
	                                dateTo = (0, _moment2.default)().utcOffset(0);
	
	                                dateTo.set({ hour: 23, minute: 59, second: 0, millisecond: 0 });
	
	                                dateFrom = (0, _moment2.default)().utcOffset(0);
	
	                                dateFrom.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
	
	                                from_date = 0;
	                                to_date = 0;
	                                _context29.t0 = this.state.customDateSelected;
	                                _context29.next = _context29.t0 === 0 ? 9 : _context29.t0 === 1 ? 12 : _context29.t0 === 2 ? 15 : 18;
	                                break;
	
	                            case 9:
	                                from_date = (0, _moment2.default)(dateFrom).subtract(1, 'd').format();
	                                to_date = (0, _moment2.default)(dateTo).subtract(1, 'd').format();
	                                return _context29.abrupt('break', 20);
	
	                            case 12:
	                                from_date = (0, _moment2.default)(dateFrom).format();
	                                to_date = (0, _moment2.default)(dateTo).format();
	                                return _context29.abrupt('break', 20);
	
	                            case 15:
	                                from_date = (0, _moment2.default)(dateFrom).add(1, 'd').format();
	                                to_date = (0, _moment2.default)(dateTo).add(1, 'd').format();
	                                return _context29.abrupt('break', 20);
	
	                            case 18:
	                                from_date = (0, _moment2.default)(dateFrom).format();
	                                to_date = (0, _moment2.default)(dateTo).format();
	
	                            case 20:
	                                meta = {
	                                    filters: {
	                                        withPeriod: [from_date, to_date],
	                                        withCommunalMunicipalities: ['cf68f132-f684-11ea-a75f-0252e77e7abb']
	                                    }
	                                };
	
	                                if (this.state.selected_work_type !== 'all') {
	                                    meta.filters.withWorkTypes = [this.state.selected_work_type];
	                                }
	                                if (this.state.selected_communal_uuid) {
	                                    meta.filters.withCommunalMunicipalities = [this.state.selected_communal_uuid];
	                                }
	
	                                _context29.next = 25;
	                                return this.props.getGeometryFromContract(meta, {}, storage.get('user').token);
	
	                            case 25:
	                                response = _context29.sent;
	                                contracts = {};
	
	                                if (!response.isOk) {
	                                    _context29.next = 33;
	                                    break;
	                                }
	
	                                if (!(response.payload && response.payload.items.length)) {
	                                    _context29.next = 33;
	                                    break;
	                                }
	
	                                response.payload.items.forEach(function (itemContract) {
	                                    contracts[itemContract.uuid] = itemContract.contracts;
	                                });
	                                bluePolygonsRoadPartUuid = (0, _uniq3.default)(response.payload.items.map(function (item) {
	                                    return item.uuid;
	                                }));
	                                _context29.next = 33;
	                                return this.setState({
	                                    bluePolygonsRoadPartUuid: bluePolygonsRoadPartUuid,
	                                    contracts: contracts,
	                                    contractsToRender: response.payload.items
	                                });
	
	                            case 33:
	                            case 'end':
	                                return _context29.stop();
	                        }
	                    }
	                }, _callee28, this);
	            }));
	
	            function getGeometryFromContract() {
	                return _ref33.apply(this, arguments);
	            }
	
	            return getGeometryFromContract;
	        }()
	    }, {
	        key: 'loadMuRoadParts',
	        value: function () {
	            var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(communal_uuid) {
	                var muTasksObjects, dateTo, dateFrom, from_date, to_date, meta, responseTasks, response, localWorkTypes, uniqueTasks, work_type;
	                return regeneratorRuntime.wrap(function _callee29$(_context30) {
	                    while (1) {
	                        switch (_context30.prev = _context30.next) {
	                            case 0:
	                                _context30.next = 2;
	                                return this.setState({
	                                    muTasks: null,
	                                    computedGeometry: null
	                                });
	
	                            case 2:
	                                _context30.next = 4;
	                                return this.getGeometryFromContract();
	
	                            case 4:
	                                localStorage.removeItem('renderMuContracts');
	                                localStorage.removeItem('renderMuRoadParts');
	                                muTasksObjects = null;
	                                dateTo = (0, _moment2.default)().utcOffset(0);
	
	                                dateTo.set({ hour: 23, minute: 59, second: 0, millisecond: 0 });
	
	                                dateFrom = (0, _moment2.default)().utcOffset(0);
	
	                                dateFrom.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
	
	                                from_date = 0;
	                                to_date = 0;
	                                _context30.t0 = this.state.customDateSelected;
	                                _context30.next = _context30.t0 === 0 ? 16 : _context30.t0 === 1 ? 19 : _context30.t0 === 2 ? 22 : 25;
	                                break;
	
	                            case 16:
	                                from_date = (0, _moment2.default)(dateFrom).subtract(1, 'd').format();
	                                to_date = (0, _moment2.default)(dateTo).subtract(1, 'd').format();
	                                return _context30.abrupt('break', 27);
	
	                            case 19:
	                                from_date = (0, _moment2.default)(dateFrom).format();
	                                to_date = (0, _moment2.default)(dateTo).format();
	                                return _context30.abrupt('break', 27);
	
	                            case 22:
	                                from_date = (0, _moment2.default)(dateFrom).add(1, 'd').format();
	                                to_date = (0, _moment2.default)(dateTo).add(1, 'd').format();
	                                return _context30.abrupt('break', 27);
	
	                            case 25:
	                                from_date = (0, _moment2.default)(dateFrom).format();
	                                to_date = (0, _moment2.default)(dateTo).format();
	
	                            case 27:
	                                meta = {
	                                    filters: {
	                                        withPeriod: [from_date, to_date]
	                                    }
	                                };
	
	
	                                if (this.state.selected_work_type !== 'all') {
	                                    meta.filters.withWorkTypes = [this.state.selected_work_type];
	                                }
	
	                                if (communal_uuid || this.state.selected_communal_uuid) {
	                                    meta.filters.withCommunalMunicipalities = communal_uuid ? [communal_uuid] : [this.state.selected_communal_uuid];
	                                }
	
	                                _context30.next = 32;
	                                return this.props.getTasks(meta);
	
	                            case 32:
	                                responseTasks = _context30.sent;
	
	                                if (responseTasks.isOk && responseTasks.payload.items.length) {
	                                    muTasksObjects = responseTasks.payload.items;
	                                } else {
	                                    responseTasks.showErrors();
	                                }
	
	                                _context30.next = 36;
	                                return this.getWorksDoneByMunicipalityUuid(communal_uuid);
	
	                            case 36:
	                                response = _context30.sent;
	
	
	                                if (response.isOk) {
	                                    localWorkTypes = {};
	
	                                    if (response.payload.items) {
	                                        uniqueTasks = [].concat(_toConsumableArray(new Set(response.payload.items.map(function (task) {
	                                            return task.work_type_uuid;
	                                        }))));
	
	                                        for (work_type in this.state.work_types) {
	                                            if (uniqueTasks.includes(work_type)) {
	                                                localWorkTypes[work_type] = this.state.work_types[work_type];
	                                            }
	                                        }
	                                    }
	
	                                    this.setState({
	                                        filter_work_types: Object.keys(localWorkTypes).length ? localWorkTypes : null,
	                                        muTasksObjects: muTasksObjects,
	                                        muTasks: response.payload.items.length ? response.payload.items : null,
	                                        isNeedContractRender: response.payload.items.length ? false : true
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 38:
	                            case 'end':
	                                return _context30.stop();
	                        }
	                    }
	                }, _callee29, this);
	            }));
	
	            function loadMuRoadParts(_x26) {
	                return _ref34.apply(this, arguments);
	            }
	
	            return loadMuRoadParts;
	        }()
	    }, {
	        key: 'renderMu',
	        value: function renderMu() {
	            var _this7 = this;
	
	            return (0, _map3.default)(this.state.mu, function (item, index) {
	                return _react2.default.createElement(_geojson2.default, {
	                    fillOpacity: 0,
	                    opacity: 1,
	                    color: '#EEDDD9',
	                    bringToBack: item.geometry.coordinates[0].length > 200 ? true : false,
	                    key: item.uuid,
	                    map: _this7.map.refs.map,
	                    leafletMap: _this7.map.refs.map.getWrappedInstance().map,
	                    geometry: item.geometry
	                });
	            });
	        }
	    }, {
	        key: 'logicForGeoJsonObjectColor',
	        value: function logicForGeoJsonObjectColor(factCount, planCount, is_end) {
	            if (factCount === planCount && planCount !== 0) {
	                return 'green';
	            }
	            if (factCount < planCount && factCount !== 0 && planCount !== 0) {
	                if (is_end) {
	                    return 'white';
	                } else {
	                    return 'yellow';
	                }
	            }
	            if (factCount < planCount && factCount === 0 && planCount > 0) {
	                if (is_end === false) {
	                    return 'grey';
	                } else {
	                    return 'red';
	                }
	            }
	            if (factCount > planCount && factCount !== 0 && planCount !== 0) {
	                return 'green';
	            }
	            return 'none';
	        }
	    }, {
	        key: 'computeSummaryCountConfirmedTaskEnd',
	        value: function computeSummaryCountConfirmedTaskEnd(items_fact, items_plan, blue) {
	            var factCount = 0;
	            var planCount = 0;
	            var is_confirmed = items_fact.length && Object.keys(items_fact[0]).includes('is_confirmed') ? items_fact[0].is_confirmed : false;
	            var time = items_fact.length ? items_fact[0].time_to : items_plan[0].time_to;
	            var date = items_fact.length ? items_fact[0].date : items_plan[0].date;
	            var hours = time.split(':')[0];
	            var minutes = time.split(':')[1];
	            var dateOfItem = (0, _moment2.default)(date).set({ hour: hours, minute: minutes });
	            var is_end = dateOfItem.isBefore((0, _moment2.default)()) ? true : false;
	
	            if (items_fact.length) {
	                factCount = items_fact.reduce(function (acc, item) {
	                    if (item.count) {
	                        return acc + item.count;
	                    } else {
	                        return acc;
	                    }
	                }, 0);
	            }
	            if (items_plan.length) {
	                planCount = items_plan.reduce(function (acc, item) {
	                    if (item.count) {
	                        return acc + item.count;
	                    } else {
	                        return acc;
	                    }
	                }, 0);
	            }
	            var color = this.logicForGeoJsonObjectColor(factCount, planCount, is_end);
	            if (color === 'none' && blue) {
	                color = 'blue';
	            }
	            var result = { factCount: factCount, planCount: planCount, is_confirmed: is_confirmed, color: color };
	            if (blue) {
	                result['colorBlue'] = true;
	            }
	            return result;
	        }
	    }, {
	        key: 'onChangeWorkType',
	        value: function () {
	            var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(field, e) {
	                var value;
	                return regeneratorRuntime.wrap(function _callee30$(_context31) {
	                    while (1) {
	                        switch (_context31.prev = _context31.next) {
	                            case 0:
	                                value = e.value || e.target.value;
	                                _context31.next = 3;
	                                return this.setState({
	                                    selected_work_type: value
	                                });
	
	                            case 3:
	                                this.loadMuRoadParts();
	
	                            case 4:
	                            case 'end':
	                                return _context31.stop();
	                        }
	                    }
	                }, _callee30, this);
	            }));
	
	            function onChangeWorkType(_x27, _x28) {
	                return _ref35.apply(this, arguments);
	            }
	
	            return onChangeWorkType;
	        }()
	    }, {
	        key: 'renderWorkTypeSelect',
	        value: function renderWorkTypeSelect() {
	            var work_types = void 0;
	            if (this.state.filter_work_types) {
	                var customWorkTypes = Object.keys(this.state.filter_work_types).length ? this.state.filter_work_types : this.state.work_types;
	                work_types = _extends({ '000f000': { uuid: 'all', name: 'Все виды работ' } }, customWorkTypes);
	            } else {
	                work_types = _extends({ '000f000': { uuid: 'all', name: 'Все виды работ' } }, this.state.work_types);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'select-workType' },
	                _react2.default.createElement(_select2.default, {
	                    name: 'form-field-name',
	                    options: (0, _map3.default)(work_types, function (work_type) {
	                        return {
	                            value: work_type.uuid,
	                            label: work_type.name
	                        };
	                    }),
	                    value: this.state.selected_work_type,
	                    clearable: false,
	                    onChange: this.onChangeWorkType.bind(this, 'work_type')
	                })
	            );
	        }
	    }, {
	        key: 'customPickerSelect',
	        value: function () {
	            var _ref36 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(dateSelected) {
	                return regeneratorRuntime.wrap(function _callee31$(_context32) {
	                    while (1) {
	                        switch (_context32.prev = _context32.next) {
	                            case 0:
	                                _context32.next = 2;
	                                return this.setState({
	                                    customDateSelected: dateSelected
	                                });
	
	                            case 2:
	                                this.loadMuRoadParts();
	
	                            case 3:
	                            case 'end':
	                                return _context32.stop();
	                        }
	                    }
	                }, _callee31, this);
	            }));
	
	            function customPickerSelect(_x29) {
	                return _ref36.apply(this, arguments);
	            }
	
	            return customPickerSelect;
	        }()
	    }, {
	        key: 'renderCustomDatePicker',
	        value: function renderCustomDatePicker() {
	            var _this8 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'select-customDateSelect' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'select-customDateSelect-body' },
	                    _react2.default.createElement(
	                        'p',
	                        { onClick: function onClick() {
	                                return _this8.customPickerSelect(0);
	                            }, className: (0, _classnames2.default)('select-customDateSelect-item', this.state.customDateSelected === 0 && 'select-customDateSelect-item_active') },
	                        '\u0412\u0447\u0435\u0440\u0430'
	                    ),
	                    _react2.default.createElement('span', { className: 'select-customDateSelect-hr' }),
	                    _react2.default.createElement(
	                        'p',
	                        { onClick: function onClick() {
	                                return _this8.customPickerSelect(1);
	                            }, className: (0, _classnames2.default)('select-customDateSelect-item', this.state.customDateSelected === 1 && 'select-customDateSelect-item_active') },
	                        '\u0421\u0435\u0433\u043E\u0434\u043D\u044F'
	                    ),
	                    _react2.default.createElement('span', { className: 'select-customDateSelect-hr select-customDateSelect-hr_last' }),
	                    _react2.default.createElement(
	                        'p',
	                        { onClick: function onClick() {
	                                return _this8.customPickerSelect(2);
	                            }, className: (0, _classnames2.default)('select-customDateSelect-item', this.state.customDateSelected === 2 && 'select-customDateSelect-item_active') },
	                        '\u0417\u0430\u0432\u0442\u0440\u0430'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'setPositionAndZoomMunicipality',
	        value: function setPositionAndZoomMunicipality(label) {
	            var selectedCommunal = this.state.selector_municipalities.filter(function (item) {
	                return item.title === label;
	            })[0];
	            var __layer = new _leaflet4.default.GeoJSON(selectedCommunal.geometry, {});
	            if (label.includes('Апатиты')) {
	                this.map.refs.map.getWrappedInstance().map.setView(new _leaflet4.default.LatLng(67.568023, 33.407187), 11);
	            } else {
	                var polygonCenter = __layer.getBounds().getCenter();
	                this.map.refs.map.getWrappedInstance().map.setView(new _leaflet4.default.LatLng(polygonCenter.lat, polygonCenter.lng), 11);
	            }
	        }
	    }, {
	        key: 'renderMunicipalities',
	        value: function renderMunicipalities() {
	            var _this9 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'select-municipalitySelect' },
	                _react2.default.createElement(_select2.default, {
	                    options: (0, _map3.default)(this.state.selector_municipalities, function (municipality) {
	                        return {
	                            value: municipality.communal_municipality_uuid,
	                            label: municipality.title
	                        };
	                    }),
	                    value: this.state.selected_communal_uuid,
	                    clearable: false,
	                    placeholder: 'Выбрать город',
	                    onChange: function () {
	                        var _ref37 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32(e) {
	                            var value;
	                            return regeneratorRuntime.wrap(function _callee32$(_context33) {
	                                while (1) {
	                                    switch (_context33.prev = _context33.next) {
	                                        case 0:
	                                            value = e ? e.value : null;
	                                            _context33.next = 3;
	                                            return _this9.setState({
	                                                selected_communal_uuid: value
	                                            });
	
	                                        case 3:
	                                            _this9.setPositionAndZoomMunicipality(e.label);
	                                            _this9.loadMuRoadParts();
	
	                                        case 5:
	                                        case 'end':
	                                            return _context33.stop();
	                                    }
	                                }
	                            }, _callee32, _this9);
	                        }));
	
	                        return function (_x30) {
	                            return _ref37.apply(this, arguments);
	                        };
	                    }()
	                })
	            );
	        }
	    }, {
	        key: 'getPriorityColor',
	        value: function getPriorityColor(arrayWithColors) {
	            if (arrayWithColors.includes('green')) {
	                return 'green';
	            }
	            if (arrayWithColors.includes('grey')) {
	                return 'grey';
	            }
	            if (arrayWithColors.includes('yellow')) {
	                return 'yellow';
	            }
	            if (arrayWithColors.includes('red')) {
	                return 'red';
	            }
	            if (arrayWithColors.includes('blue')) {
	                return 'blue';
	            }
	        }
	    }, {
	        key: 'renderMuContracts',
	        value: function renderMuContracts() {
	            var _this10 = this;
	
	            if (!localStorage.getItem('renderMuContracts')) {
	                var geometry = this.state.contractsToRender.map(function (item, key) {
	                    return _react2.default.createElement(_geojson2.default, {
	                        color: "blue",
	                        key: (0, _uniqueId3.default)(key),
	                        map: _this10.map.refs.map,
	                        leafletMap: _this10.map.refs.map.getWrappedInstance().map,
	                        geometry: item.geometry
	                    });
	                });
	                localStorage.setItem('renderMuContracts', true);
	                this.setState({
	                    computedGeometry: geometry
	                });
	                return geometry;
	            } else {
	                return this.state.computedGeometry;
	            }
	        }
	    }, {
	        key: 'renderMuRoadParts',
	        value: function renderMuRoadParts() {
	            var _this11 = this;
	
	            if (!localStorage.getItem('renderMuRoadParts')) {
	                var relationsUniqueNumbers = (0, _uniq3.default)(this.state.muTasks.map(function (task) {
	                    return task.relation_number;
	                }));
	
	                var collection = {};
	                var earlyCollection = {};
	                var priorityCollectionColors = {};
	
	                //первоначальная закраска
	                relationsUniqueNumbers.forEach(function (relationNumber) {
	                    var relationNumberPairs = _this11.state.muTasks.filter(function (task) {
	                        return task.relation_number === relationNumber;
	                    });
	                    var item_fact = relationNumberPairs.filter(function (item) {
	                        return item.type === 'fact';
	                    });
	                    var item_plan = relationNumberPairs.filter(function (item) {
	                        return item.type === 'plan';
	                    });
	                    var roadPartUuidToCheckInBlueColors = item_fact[0] ? item_fact[0].road_part_uuid : item_plan[0].road_part_uuid;
	                    var polygonUuidToCheckInBlueColors = item_fact[0] ? item_fact[0].user_geo_object_uuid : item_plan[0].user_geo_object_uuid;
	
	                    var blue = false;
	                    if (roadPartUuidToCheckInBlueColors && _this11.state.bluePolygonsRoadPartUuid && _this11.state.bluePolygonsRoadPartUuid.includes(roadPartUuidToCheckInBlueColors)) {
	                        blue = true;
	                    }
	                    if (polygonUuidToCheckInBlueColors && _this11.state.bluePolygonsRoadPartUuid && _this11.state.bluePolygonsRoadPartUuid.includes(polygonUuidToCheckInBlueColors)) {
	                        blue = true;
	                    }
	                    var service_info = _this11.computeSummaryCountConfirmedTaskEnd(item_fact, item_plan, blue);
	                    collection[relationNumber] = {
	                        item_fact: item_fact.date ? item_fact : item_fact[0],
	                        item_plan: item_plan.date ? item_plan : item_plan[0],
	                        service_info: service_info
	                    };
	
	                    var itemDate = collection[relationNumber].item_fact ? collection[relationNumber].item_fact.date : collection[relationNumber].item_plan.date;
	                    var roadPartUuid = collection[relationNumber].item_fact ? collection[relationNumber].item_fact.road_part_uuid : collection[relationNumber].item_plan.road_part_uuid;
	                    var polygonPartUuid = collection[relationNumber].item_fact ? collection[relationNumber].item_fact.user_geo_object_uuid : collection[relationNumber].item_plan.user_geo_object_uuid;
	
	                    var resultPartUuid = roadPartUuid ? roadPartUuid : polygonPartUuid;
	                    collection[relationNumber].partUuid = resultPartUuid;
	
	                    var roadPartDay = (0, _moment2.default)(itemDate);
	                    var todayDate = (0, _moment2.default)();
	                    if ((0, _moment2.default)((0, _moment2.default)(roadPartDay).format('DD.MM.YYYY')).isBefore((0, _moment2.default)(todayDate).format('DD.MM.YYYY'))) {
	                        var roadPartUuidArray = earlyCollection[resultPartUuid] ? earlyCollection[resultPartUuid] : [];
	                        var roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
	                        roadPartUuidArray.push(collection[relationNumber].service_info.color);
	                        roadPartUuidArrayPriority.push(collection[relationNumber].service_info.color);
	                        if (collection[relationNumber].service_info['colorBlue']) {
	                            roadPartUuidArrayPriority.push('blue');
	                        }
	                        earlyCollection[resultPartUuid] = [].concat(_toConsumableArray(new Set(roadPartUuidArray)));
	                        priorityCollectionColors[resultPartUuid] = [].concat(_toConsumableArray(new Set(roadPartUuidArrayPriority)));
	                    } else {
	                        var _roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
	                        _roadPartUuidArrayPriority.push(collection[relationNumber].service_info.color);
	                        if (collection[relationNumber].service_info['colorBlue']) {
	                            _roadPartUuidArrayPriority.push('blue');
	                        }
	                        priorityCollectionColors[resultPartUuid] = _roadPartUuidArrayPriority;
	                    }
	                });
	
	                //закраска не однозначных цветов, которые надо проверить, есть ли в прошлом для них road_part_uuid, которые green, red или оба
	                // если не совпало в прошлом, либо прошлых вообще нет - то тогда остается красным цветом
	                for (var item in collection) {
	                    var roadPartUuid = collection[item].item_fact ? collection[item].item_fact.road_part_uuid : collection[item].item_plan.road_part_uuid;
	                    var polygonPartUuid = collection[item].item_fact ? collection[item].item_fact.user_geo_object_uuid : collection[item].item_plan.user_geo_object_uuid;
	                    var resultPartUuid = roadPartUuid ? roadPartUuid : polygonPartUuid;
	
	                    if (collection[item].service_info.color === 'white') {
	                        if (earlyCollection[resultPartUuid]) {
	                            if (earlyCollection[resultPartUuid].includes('green') && earlyCollection[resultPartUuid].includes('red')) {
	                                collection[item].service_info.color = 'yellow';
	                                var _roadPartUuidArrayPriority2 = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
	                                _roadPartUuidArrayPriority2.push('yellow');
	                                priorityCollectionColors[resultPartUuid] = _roadPartUuidArrayPriority2.filter(function (item) {
	                                    return item !== 'white';
	                                });
	                            }
	                            if (earlyCollection[resultPartUuid].includes('green') && !earlyCollection[resultPartUuid].includes('red') || earlyCollection[resultPartUuid].includes("red") && !!earlyCollection[resultPartUuid].includes("green")) {
	                                collection[item].service_info.color = 'yellow';
	                                var _roadPartUuidArrayPriority3 = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
	                                _roadPartUuidArrayPriority3.push('yellow');
	                                priorityCollectionColors[resultPartUuid] = _roadPartUuidArrayPriority3.filter(function (item) {
	                                    return item !== 'white';
	                                });
	                            }
	                            collection[item].service_info.color = 'red';
	                            var roadPartUuidArrayPriority = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
	                            roadPartUuidArrayPriority.push('red');
	                            priorityCollectionColors[resultPartUuid] = roadPartUuidArrayPriority.filter(function (item) {
	                                return item !== 'white';
	                            });
	                        } else {
	                            collection[item].service_info.color = 'red';
	                            var _roadPartUuidArrayPriority4 = priorityCollectionColors[resultPartUuid] ? priorityCollectionColors[resultPartUuid] : [];
	                            _roadPartUuidArrayPriority4.push('red');
	                            priorityCollectionColors[resultPartUuid] = _roadPartUuidArrayPriority4.filter(function (item) {
	                                return item !== 'white';
	                            });
	                        }
	                    }
	                }
	
	                //закраска с учетом приоритета цветов
	                for (var _item in collection) {
	                    var _roadPartUuid = collection[_item].item_fact ? collection[_item].item_fact.road_part_uuid : collection[_item].item_plan.road_part_uuid;
	                    var _polygonPartUuid = collection[_item].item_fact ? collection[_item].item_fact.user_geo_object_uuid : collection[_item].item_plan.user_geo_object_uuid;
	                    var _resultPartUuid = _roadPartUuid ? _roadPartUuid : _polygonPartUuid;
	                    collection[_item].service_info.color = this.getPriorityColor(priorityCollectionColors[_resultPartUuid]);
	                }
	
	                var contractsGeometry = this.state.contractsToRender.map(function (contract, key) {
	                    var color = priorityCollectionColors[contract.uuid] ? _this11.getPriorityColor(priorityCollectionColors[contract.uuid]) : 'blue';
	                    return _react2.default.createElement(_geojson2.default, {
	                        color: color,
	                        opacity: color === 'blue' && contract.geometry.type === 'Polygon' ? 0.6 : 1,
	                        key: (0, _uniqueId3.default)(key),
	                        map: _this11.map.refs.map,
	                        leafletMap: _this11.map.refs.map.getWrappedInstance().map,
	                        geometry: contract.geometry
	                    });
	                });
	
	                var geometry = Object.keys(collection).map(function (key) {
	                    var fact = [];
	                    var plan = [];
	                    if (collection[key].item_fact && collection[key].item_fact.geojson && collection[key].service_info.color) {
	                        fact = [_react2.default.createElement(_geojson2.default, {
	                            color: collection[key].service_info.color,
	                            opacity: collection[key].item_fact.geojson.type === "Polygon" ? 0.6 : 1,
	                            key: (0, _uniqueId3.default)(key),
	                            map: _this11.map.refs.map,
	                            leafletMap: _this11.map.refs.map.getWrappedInstance().map,
	                            geometry: collection[key].item_fact.geojson
	                        })];
	                    }
	
	                    if (collection[key].item_plan && collection[key].item_plan.geojson && collection[key].service_info.color) {
	                        plan = [_react2.default.createElement(_geojson2.default, {
	                            color: collection[key].service_info.color,
	                            opacity: collection[key].item_plan.geojson.type === "Polygon" ? 0.6 : 1,
	                            key: (0, _uniqueId3.default)(key),
	                            map: _this11.map.refs.map,
	                            leafletMap: _this11.map.refs.map.getWrappedInstance().map,
	                            geometry: collection[key].item_plan.geojson
	                        })];
	                    }
	
	                    return [].concat(_toConsumableArray(fact), _toConsumableArray(plan));
	                });
	                localStorage.setItem('renderMuRoadParts', true);
	                this.setState({
	                    computedGeometry: [].concat(_toConsumableArray(geometry), _toConsumableArray(contractsGeometry))
	                });
	                console.info('Collection', collection);
	                console.info('EarlyCollection', earlyCollection);
	                console.info('PriorityCollectionColors', priorityCollectionColors);
	                return [].concat(_toConsumableArray(geometry), _toConsumableArray(contractsGeometry));
	            } else {
	                return this.state.computedGeometry;
	            }
	        }
	    }, {
	        key: 'renderMo',
	        value: function renderMo() {
	            var _this12 = this;
	
	            if (this.props.params.type !== 'garbage' && this.props.params.type !== 'road') {
	                return null;
	            }
	
	            if (!this.map) {
	                return;
	            }
	
	            return (0, _map3.default)(this.state.mo, function (item) {
	                return _react2.default.createElement(_geojson2.default, {
	                    key: item.uuid,
	                    map: _this12.map.refs.map,
	                    leafletMap: _this12.map.refs.map.getWrappedInstance().map,
	                    geometry: item.geometry,
	                    tooltip: '<h3 style="text-align: center">' + item.title + ' </h3><p>' + (item.org_name ? item.org_name : '') + '</p> <p>' + (item.phone ? item.phone : '') + '</p> <p>' + (item.email ? item.email : '') + '</p>'
	                });
	            });
	        }
	    }, {
	        key: 'renderRoute',
	        value: function renderRoute() {
	            if (!this.state.fullScheduleRoute) {
	                return null;
	            }
	
	            var run = this.state.fullScheduleRouteRun;
	            if (!run || !run.geometry) {
	                return null;
	            }
	
	            return _react2.default.createElement(_geojson2.default, {
	                map: this.map.refs.map,
	                leafletMap: this.map.refs.map.getWrappedInstance().map,
	                geometry: this.getRunGeometry(run)
	            });
	        }
	    }]);
	
	    return MapComponent;
	}(_react.Component)) || _class);
	exports.default = MapComponent;

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _last2 = __webpack_require__(228);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _values2 = __webpack_require__(513);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _keys2 = __webpack_require__(70);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _first2 = __webpack_require__(114);
	
	var _first3 = _interopRequireDefault(_first2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _flatten2 = __webpack_require__(224);
	
	var _flatten3 = _interopRequireDefault(_flatten2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	exports.printSchedule = printSchedule;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function printSchedule(stopPoint, routes, routeRuns) {
	    return "\n        <link rel=\"stylesheet\" href=\"/static/css/print.css\">\n        <table class=\"w-700\">\n            <thead>\n                <tr style=\"background: #454b52;\">\n                    <th class=\"border-none w2-5\">&nbsp</th>\n                    <th class=\"border-none text-left color-white w35 logo-text\">\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F \u0447\u0435\u0440\u0435\u0437 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443 <br> \u043D\u0430 <span>25.09.2017</span></th>\n                    <th class=\"border-none text-left font-normal w55\">\n                        <div class=\"header__logo text-right padding-bottom-10 padding-top-10\">\n                            <img src=\"data:image/png;base64,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\" style=\"width: 181px; height: 39px;\"/>\n                            <span class=\"header__logo-txt text-left logo-text logo-block color-white padding-left-5\">{window.RNIS_SETTINGS.TITLE}</span>\n                        </div>\n                    </th>\n                </tr>\n            </thead>\n        </table>\n        <table class=\"w-700\">\n            <thead>\n                <tr>\n                    <th colspan=\"5\" class=\"border-none border-bottom text-center font-normal padding-top-10\">" + stopPoint.title + "</th>\n                </tr>\n            </thead>\n            <tbody class=\"border-none\">\n                " + (0, _filter3.default)((0, _map3.default)(routes, function (route) {
	        var runs = (0, _filter3.default)((0, _flatten3.default)((0, _get3.default)(routeRuns, route.uuid) || []));
	        if (runs.length === 0) {
	            return null;
	        }
	
	        return "<tr>\n                                <th class=\"border-none\">&nbsp;</th>\n                                <th colspan=\"5\" class=\"font-bold border-none text-left padding-bottom-5 padding-top-10 text-decoration-underline\">\u0410\u0432\u0442\u043E\u0431\u0443\u0441 " + route.number + "</th>\n                            </tr>" + (0, _map3.default)(runs, function (_ref) {
	            var time = _ref.time,
	                end_at = _ref.end_at,
	                times = _ref.times;
	
	            var from = (0, _first3.default)((0, _keys3.default)(times));
	            var fromTime = (0, _first3.default)((0, _values3.default)(times));
	            var to = (0, _last3.default)((0, _keys3.default)(times));
	            var toTime = (0, _last3.default)((0, _values3.default)(times));
	
	            return "<tr>\n                                    <th class=\"border-none w2-5\">&nbsp;</th>\n                                    <td class=\"border-all w10\">" + (0, _moment2.default)(time).format(_formats2.default.TIME) + "</td>\n                                    <td class=\"border-all w50 text-left padding-left-10 padding-right-10\">\n                                        " + from + " (" + (0, _moment2.default)(fromTime).format(_formats2.default.TIME) + ")\n                                        -\n                                        " + to + " (" + (0, _moment2.default)(toTime).format(_formats2.default.TIME) + ")\n                                    </td>\n                                    <td class=\"border-all w20\">\n                                        \u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043E\u043A: " + (0, _values3.default)(times).length + "\n                                    </td>\n                                </tr>";
	        }).join('');
	    })).join('') + "\n            </tbody>\n            <tfoot class=\"font-bold\">\n        \n            </tfoot>\n        </table>\n    ";
	}

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1078);
	
	var _reactRedux = __webpack_require__(17);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _mobile = __webpack_require__(389);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailChangeConfirmComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { confirmEmailChangeCheck: _mobile.confirmEmailChangeCheck }), _dec(_class = function (_Component) {
	    _inherits(EmailChangeConfirmComponent, _Component);
	
	    function EmailChangeConfirmComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EmailChangeConfirmComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailChangeConfirmComponent.__proto__ || Object.getPrototypeOf(EmailChangeConfirmComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            loading: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EmailChangeConfirmComponent, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.setState({ loading: true });
	                                _context.next = 3;
	                                return this.props.confirmEmailChangeCheck({
	                                    new_email: this.props.params.email,
	                                    new_email_activation_code: this.props.params.code
	                                });
	
	                            case 3:
	                                response = _context.sent;
	
	                                this.setState({ loading: false });
	                                if (response.isOk) {
	                                    alerts.success('Email успешно изменен');
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'EmailConfirm' },
	                loader
	            );
	        }
	    }]);
	
	    return EmailChangeConfirmComponent;
	}(_react.Component)) || _class);
	exports.default = EmailChangeConfirmComponent;

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1079);
	
	var _reactRedux = __webpack_require__(17);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _mobile = __webpack_require__(389);
	
	var _session = __webpack_require__(30);
	
	var rpc = _interopRequireWildcard(_session);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailConfirmComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { confirmEmailCheck: _mobile.confirmEmailCheck }), _dec(_class = function (_Component) {
	    _inherits(EmailConfirmComponent, _Component);
	
	    function EmailConfirmComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EmailConfirmComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailConfirmComponent.__proto__ || Object.getPrototypeOf(EmailConfirmComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            loading: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EmailConfirmComponent, [{
	        key: 'componentDidMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.setState({ loading: true });
	                                _context.next = 3;
	                                return this.props.confirmEmailCheck({
	                                    email: this.props.params.email,
	                                    email_activation_code: this.props.params.code
	                                });
	
	                            case 3:
	                                response = _context.sent;
	
	                                this.setState({ loading: false });
	                                if (response.isOk) {
	                                    alerts.success('Email успешно подтвержден');
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'EmailConfirm' },
	                loader
	            );
	        }
	    }]);
	
	    return EmailConfirmComponent;
	}(_react.Component)) || _class);
	exports.default = EmailConfirmComponent;

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(128);
	
	var _reactRedux = __webpack_require__(17);
	
	var _news = __webpack_require__(99);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _reactRenderHtml = __webpack_require__(117);
	
	var _reactRenderHtml2 = _interopRequireDefault(_reactRenderHtml);
	
	var _sidebar = __webpack_require__(183);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsFullComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getNewsItem: _news.getNewsItem }), _dec(_class = function (_Component) {
	    _inherits(NewsFullComponent, _Component);
	
	    function NewsFullComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewsFullComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsFullComponent.__proto__ || Object.getPrototypeOf(NewsFullComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            loading: false,
	            news: {},
	            uuid: null
	        }, _this.months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewsFullComponent, [{
	        key: 'componentWillUpdate',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!(props.params.uuid !== this.state.uuid)) {
	                                    _context.next = 4;
	                                    break;
	                                }
	
	                                _context.next = 3;
	                                return this.setState({
	                                    uuid: props.params.uuid
	                                });
	
	                            case 3:
	                                this.loadNews();
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillUpdate(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillUpdate;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.setState({
	                                    uuid: this.props.params.uuid
	                                });
	
	                            case 2:
	
	                                this.loadNews();
	
	                            case 3:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function componentDidMount() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: 'loadNews',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                var response, news;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                this.setState({ loading: true });
	                                _context3.next = 3;
	                                return this.props.getNewsItem(this.state.uuid);
	
	                            case 3:
	                                response = _context3.sent;
	
	                                this.setState({ loading: false });
	                                if (response.isOk) {
	                                    news = response.payload;
	
	                                    this.setState({ news: news });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function loadNews() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return loadNews;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'News',
	                    title: '\u041D\u043E\u0432\u043E\u0441\u0442\u0438' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block' },
	                        loader,
	                        !loader ? this.renderNews() : null
	                    ),
	                    _react2.default.createElement(_sidebar2.default, this.props)
	                )
	            );
	        }
	    }, {
	        key: 'formatTimestamp',
	        value: function formatTimestamp(timestamp) {
	            return _react2.default.createElement(
	                'span',
	                null,
	                (0, _moment2.default)(timestamp).format('D'),
	                ' ',
	                this.months[(0, _moment2.default)(timestamp).format('MM') - 1],
	                ' ',
	                (0, _moment2.default)(timestamp).format('YYYY'),
	                ' \u0433.'
	            );
	        }
	    }, {
	        key: 'renderNews',
	        value: function renderNews() {
	            var _state$news = this.state.news,
	                title = _state$news.title,
	                text = _state$news.text,
	                timestamp = _state$news.timestamp,
	                source = _state$news.source,
	                image = _state$news.image;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'one-news' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'one-news__title' },
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'one-news__date' },
	                    '\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043E: ',
	                    this.formatTimestamp(timestamp)
	                ),
	                image ? _react2.default.createElement('div', { className: 'one-news__img', style: { backgroundImage: 'url(' + image + ')' } }) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'one-news__source' },
	                    '\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A: ',
	                    source
	                ),
	                _react2.default.createElement('div', { className: 'one-news__text', dangerouslySetInnerHTML: { __html: '<div>' + text + '</div>' } })
	            );
	        }
	    }]);
	
	    return NewsFullComponent;
	}(_react.Component)) || _class);
	exports.default = NewsFullComponent;

/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _truncate2 = __webpack_require__(329);
	
	var _truncate3 = _interopRequireDefault(_truncate2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(128);
	
	var _reactRedux = __webpack_require__(17);
	
	var _news = __webpack_require__(99);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _reactRenderHtml = __webpack_require__(117);
	
	var _reactRenderHtml2 = _interopRequireDefault(_reactRenderHtml);
	
	var _tags = __webpack_require__(184);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _sidebar = __webpack_require__(183);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsAllComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getNews: _news.getNews }), _dec(_class = function (_Component) {
	    _inherits(NewsAllComponent, _Component);
	
	    function NewsAllComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewsAllComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsAllComponent.__proto__ || Object.getPrototypeOf(NewsAllComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            page: 1,
	            news: [],
	            loading: false
	        }, _this.months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewsAllComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.setState({ loading: true });
	            Promise.all([this.loadNews()]).then(function () {
	                _this2.setState({ loading: false });
	            });
	        }
	    }, {
	        key: 'loadNews',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response, news;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.getNews({
	                                    filters: {
	                                        onlyActive: true,
	                                        withPinned: [false]
	                                    },
	                                    pagination: {
	                                        page: 1
	                                    },
	                                    order: {
	                                        column: 'timestamp',
	                                        direction: 'desc'
	                                    }
	                                });
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (response.isOk) {
	                                    news = response.payload.items;
	
	                                    this.setState({
	                                        news: news
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadNews() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadNews;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'News', title: '\u041D\u043E\u0432\u043E\u0441\u0442\u0438' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block' },
	                        loader,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'news' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'news__title' },
	                                '\u0412\u0441\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438 \u043F\u043E\u0440\u0442\u0430\u043B\u0430'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'news-list clearAfter' },
	                                this.state.news.map(this.renderNews.bind(this))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_sidebar2.default, this.props)
	                )
	            );
	        }
	    }, {
	        key: 'renderPage',
	        value: function renderPage(page, index) {
	            var className = (0, _classnames2.default)({
	                active: page + 1 === 1 * this.state.page
	            });
	
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                { key: index, to: '/news?page=' + (page + 1), className: className },
	                page + 1
	            );
	        }
	    }, {
	        key: 'renderNews',
	        value: function renderNews(news) {
	            var uuid = news.uuid,
	                title = news.title,
	                timestamp = news.timestamp,
	                image = news.image;
	
	
	            return _react2.default.createElement(
	                'li',
	                { key: uuid, className: 'news-item' },
	                _react2.default.createElement('div', { className: 'news-item__img', style: { backgroundImage: 'url(' + image + ')' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'news-item__content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__title', onClick: this.showFull.bind(this, uuid) },
	                        (0, _truncate3.default)(title, {
	                            length: 50,
	                            separator: /,? +/
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__date' },
	                        this.formatTimestamp(timestamp)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'formatTimestamp',
	        value: function formatTimestamp(timestamp) {
	            return _react2.default.createElement(
	                'span',
	                null,
	                (0, _moment2.default)(timestamp).format('D'),
	                ' ',
	                this.months[(0, _moment2.default)(timestamp).format('MM') - 1],
	                ' ',
	                (0, _moment2.default)(timestamp).format('YYYY'),
	                ' \u0433.'
	            );
	        }
	    }, {
	        key: 'showFull',
	        value: function showFull(uuid) {
	            this.props.router.push('/news/' + uuid);
	        }
	    }]);
	
	    return NewsAllComponent;
	}(_react.Component)) || _class);
	exports.default = NewsAllComponent;

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _truncate2 = __webpack_require__(329);
	
	var _truncate3 = _interopRequireDefault(_truncate2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(128);
	
	var _reactRedux = __webpack_require__(17);
	
	var _news = __webpack_require__(99);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _reactRenderHtml = __webpack_require__(117);
	
	var _reactRenderHtml2 = _interopRequireDefault(_reactRenderHtml);
	
	var _tags = __webpack_require__(184);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _sidebar = __webpack_require__(183);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsTagComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getNews: _news.getNews }), _dec(_class = function (_Component) {
	    _inherits(NewsTagComponent, _Component);
	
	    function NewsTagComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewsTagComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsTagComponent.__proto__ || Object.getPrototypeOf(NewsTagComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            page: 1,
	            news: [],
	            loading: false,
	            tag: null
	        }, _this.months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewsTagComponent, [{
	        key: 'componentWillUpdate',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!(props.params.tag !== this.state.tag)) {
	                                    _context.next = 4;
	                                    break;
	                                }
	
	                                _context.next = 3;
	                                return this.setState({
	                                    tag: props.params.tag
	                                });
	
	                            case 3:
	                                this.loadNews();
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillUpdate(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillUpdate;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.componentWillUpdate(this.props);
	        }
	    }, {
	        key: 'loadNews',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var response, news;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                this.setState({ loading: true });
	
	                                _context2.next = 3;
	                                return this.props.getNews({
	                                    filters: {
	                                        onlyActive: true,
	                                        withTag: this.state.tag
	                                    },
	                                    pagination: {
	                                        page: 1
	                                    },
	                                    order: {
	                                        column: 'timestamp',
	                                        direction: 'desc'
	                                    }
	                                });
	
	                            case 3:
	                                response = _context2.sent;
	
	                                this.setState({ loading: false });
	
	                                if (response.isOk) {
	                                    news = response.payload.items;
	
	                                    this.setState({
	                                        news: news
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function loadNews() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return loadNews;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'News', title: '\u041D\u043E\u0432\u043E\u0441\u0442\u0438' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block' },
	                        loader,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'news' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'news__title' },
	                                '\u0412\u0441\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438 \u043F\u043E\u0440\u0442\u0430\u043B\u0430'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'news-list clearAfter' },
	                                this.state.news.map(this.renderNews.bind(this))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_sidebar2.default, this.props)
	                )
	            );
	        }
	    }, {
	        key: 'renderPage',
	        value: function renderPage(page, index) {
	            var className = (0, _classnames2.default)({
	                active: page + 1 === 1 * this.state.page
	            });
	
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                { key: index, to: '/news?page=' + (page + 1), className: className },
	                page + 1
	            );
	        }
	    }, {
	        key: 'renderNews',
	        value: function renderNews(news) {
	            var uuid = news.uuid,
	                title = news.title,
	                timestamp = news.timestamp,
	                image = news.image;
	
	
	            return _react2.default.createElement(
	                'li',
	                { key: uuid, className: 'news-item' },
	                _react2.default.createElement('div', { className: 'news-item__img', style: { backgroundImage: 'url(' + image + ')' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'news-item__content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__title', onClick: this.showFull.bind(this, uuid) },
	                        (0, _truncate3.default)(title, {
	                            length: 50,
	                            separator: /,? +/
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__date' },
	                        this.formatTimestamp(timestamp)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'formatTimestamp',
	        value: function formatTimestamp(timestamp) {
	            return _react2.default.createElement(
	                'span',
	                null,
	                (0, _moment2.default)(timestamp).format('D'),
	                ' ',
	                this.months[(0, _moment2.default)(timestamp).format('MM') - 1],
	                ' ',
	                (0, _moment2.default)(timestamp).format('YYYY'),
	                ' \u0433.'
	            );
	        }
	    }, {
	        key: 'showFull',
	        value: function showFull(uuid) {
	            this.props.router.push('/news/' + uuid);
	        }
	    }]);
	
	    return NewsTagComponent;
	}(_react.Component)) || _class);
	exports.default = NewsTagComponent;

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _truncate2 = __webpack_require__(329);
	
	var _truncate3 = _interopRequireDefault(_truncate2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(128);
	
	var _reactRedux = __webpack_require__(17);
	
	var _news = __webpack_require__(99);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _reactRenderHtml = __webpack_require__(117);
	
	var _reactRenderHtml2 = _interopRequireDefault(_reactRenderHtml);
	
	var _tags = __webpack_require__(184);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _sidebar = __webpack_require__(183);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getNews: _news.getNews }), _dec(_class = function (_Component) {
	    _inherits(NewsComponent, _Component);
	
	    function NewsComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewsComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsComponent.__proto__ || Object.getPrototypeOf(NewsComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            page: 1,
	            news: [],
	            pinnedNews: [],
	            loading: false
	        }, _this.months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewsComponent, [{
	        key: 'componentWillUpdate',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!(props.location.query.page && props.location.query.page !== this.state.page)) {
	                                    _context.next = 4;
	                                    break;
	                                }
	
	                                _context.next = 3;
	                                return this.setState({
	                                    page: props.location.query.page
	                                });
	
	                            case 3:
	                                this.loadNews();
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillUpdate(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillUpdate;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.setState({ loading: true });
	            Promise.all([this.loadPinnedNews(), this.loadNews()]).then(function () {
	                _this2.setState({ loading: false });
	            });
	        }
	    }, {
	        key: 'loadPinnedNews',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.props.getNews({
	                                    filters: {
	                                        onlyActive: true,
	                                        onlyPinned: true
	                                    },
	                                    order: {
	                                        column: 'timestamp',
	                                        direction: 'desc'
	                                    }
	                                });
	
	                            case 2:
	                                response = _context2.sent;
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        pinnedNews: response.payload.items
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function loadPinnedNews() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return loadPinnedNews;
	        }()
	    }, {
	        key: 'loadNews',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                var response, news;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.props.getNews({
	                                    filters: {
	                                        onlyActive: true,
	                                        withPinned: [false]
	                                    },
	                                    pagination: {
	                                        page: 1,
	                                        limit: 9
	                                    },
	                                    order: {
	                                        column: 'timestamp',
	                                        direction: 'desc'
	                                    }
	                                });
	
	                            case 2:
	                                response = _context3.sent;
	
	                                if (response.isOk) {
	                                    news = response.payload.items;
	
	                                    this.setState({
	                                        news: news
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function loadNews() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return loadNews;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'News', title: '\u041D\u043E\u0432\u043E\u0441\u0442\u0438' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block' },
	                        loader,
	                        this.state.pinnedNews.map(this.renderPinnedNews.bind(this)),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'news' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'news__title' },
	                                '\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438 \u043F\u043E\u0440\u0442\u0430\u043B\u0430'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'news-list clearAfter' },
	                                this.state.news.map(this.renderNews.bind(this))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_sidebar2.default, this.props)
	                )
	            );
	        }
	    }, {
	        key: 'renderPage',
	        value: function renderPage(page, index) {
	            var className = (0, _classnames2.default)({
	                active: page + 1 === 1 * this.state.page
	            });
	
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                { key: index, to: '/news?page=' + (page + 1), className: className },
	                page + 1
	            );
	        }
	    }, {
	        key: 'renderNews',
	        value: function renderNews(news) {
	            var uuid = news.uuid,
	                title = news.title,
	                timestamp = news.timestamp,
	                image = news.image;
	
	
	            return _react2.default.createElement(
	                'li',
	                { key: uuid, className: 'news-item' },
	                _react2.default.createElement('div', { className: 'news-item__img', style: { backgroundImage: 'url(' + image + ')' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'news-item__content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__title', onClick: this.showFull.bind(this, uuid) },
	                        (0, _truncate3.default)(title, {
	                            length: 50,
	                            separator: /,? +/
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'news-item__date' },
	                        this.formatTimestamp(timestamp)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderPinnedNews',
	        value: function renderPinnedNews(news) {
	            var uuid = news.uuid,
	                title = news.title,
	                text = news.text,
	                timestamp = news.timestamp,
	                image = news.image;
	
	
	            return _react2.default.createElement(
	                'div',
	                { key: uuid, className: 'announcement clearAfter' },
	                image ? _react2.default.createElement('div', { className: 'announcement__img', style: { backgroundImage: 'url(' + image + ')' } }) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'announcement__content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'announcement__title', onClick: this.showFull.bind(this, uuid) },
	                        title
	                    ),
	                    _react2.default.createElement('div', { className: 'announcement__text', dangerouslySetInnerHTML: { __html: '<div>' + (0, _truncate3.default)(text, {
	                                length: 500,
	                                separator: /,? +/
	                            }) + '</div>' } }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'announcement__date' },
	                        '\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043E: ',
	                        this.formatTimestamp(timestamp)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'formatTimestamp',
	        value: function formatTimestamp(timestamp) {
	            return _react2.default.createElement(
	                'span',
	                null,
	                (0, _moment2.default)(timestamp).format('D'),
	                ' ',
	                this.months[(0, _moment2.default)(timestamp).format('MM') - 1],
	                ' ',
	                (0, _moment2.default)(timestamp).format('YYYY'),
	                ' \u0433.'
	            );
	        }
	    }, {
	        key: 'showFull',
	        value: function showFull(uuid) {
	            this.props.router.push('/news/' + uuid);
	        }
	    }]);
	
	    return NewsComponent;
	}(_react.Component)) || _class);
	exports.default = NewsComponent;

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	__webpack_require__(1080);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFoundComponent = function (_Component) {
	    _inherits(NotFoundComponent, _Component);
	
	    function NotFoundComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NotFoundComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotFoundComponent.__proto__ || Object.getPrototypeOf(NotFoundComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NotFoundComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'NotFound', title: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430.'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NotFoundComponent;
	}(_react.Component);
	
	exports.default = NotFoundComponent;

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	__webpack_require__(1081);
	
	var _reactRedux = __webpack_require__(17);
	
	var _reactRenderHtml = __webpack_require__(117);
	
	var _reactRenderHtml2 = _interopRequireDefault(_reactRenderHtml);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _pages = __webpack_require__(390);
	
	__webpack_require__(1116);
	
	var _reactRouter = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getPage: _pages.getPage }), _dec(_class = function (_Component) {
	    _inherits(PageComponent, _Component);
	
	    function PageComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PageComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageComponent.__proto__ || Object.getPrototypeOf(PageComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            loading: false,
	            page: {},
	            key: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PageComponent, [{
	        key: 'componentWillUpdate',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props, state) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!(props.params.key !== state.key)) {
	                                    _context.next = 4;
	                                    break;
	                                }
	
	                                _context.next = 3;
	                                return this.setState({
	                                    key: props.params.key
	                                });
	
	                            case 3:
	                                this.loadPage();
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillUpdate(_x, _x2) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillUpdate;
	        }()
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.forceUpdate();
	        }
	    }, {
	        key: 'loadPage',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var response, page;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                this.setState({ loading: true });
	                                _context2.next = 3;
	                                return this.props.getPage(this.state.key);
	
	                            case 3:
	                                response = _context2.sent;
	
	                                this.setState({ loading: false });
	                                if (response.isOk) {
	                                    page = response.payload;
	
	                                    page.text = page.text.replace(/href="([^"]+)"/g, function (full, match) {
	                                        return 'href="' + match.replace(/\+/g, '%20') + '"';
	                                    });
	                                    this.setState({ page: page });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function loadPage() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return loadPage;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'Page', title: this.state.page.title || '...' },
	                loader,
	                _react2.default.createElement('div', { className: 'full ql-editor', dangerouslySetInnerHTML: { __html: this.state.page.text || '' } })
	            );
	        }
	    }]);
	
	    return PageComponent;
	}(_react.Component)) || _class);
	exports.default = PageComponent;

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _range2 = __webpack_require__(1280);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isEmpty2 = __webpack_require__(1264);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _indexOf2 = __webpack_require__(225);
	
	var _indexOf3 = _interopRequireDefault(_indexOf2);
	
	var _find2 = __webpack_require__(89);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _cloneDeep2 = __webpack_require__(223);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _random2 = __webpack_require__(1279);
	
	var _random3 = _interopRequireDefault(_random2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	__webpack_require__(1082);
	
	var _reactRedux = __webpack_require__(17);
	
	var _modalTopMenuList = __webpack_require__(377);
	
	var _modalTopMenuList2 = _interopRequireDefault(_modalTopMenuList);
	
	var _modalTopMenuListItem = __webpack_require__(376);
	
	var _modalTopMenuListItem2 = _interopRequireDefault(_modalTopMenuListItem);
	
	var _baseEditorForm = __webpack_require__(733);
	
	var _baseEditorForm2 = _interopRequireDefault(_baseEditorForm);
	
	var _block = __webpack_require__(251);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _button = __webpack_require__(149);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _feedback = __webpack_require__(368);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _register = __webpack_require__(797);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _systems = __webpack_require__(770);
	
	var _systems2 = _interopRequireDefault(_systems);
	
	var _dictionary = __webpack_require__(258);
	
	var _reactFileReaderInput = __webpack_require__(691);
	
	var _reactFileReaderInput2 = _interopRequireDefault(_reactFileReaderInput);
	
	var _api = __webpack_require__(15);
	
	var _rfc = __webpack_require__(1486);
	
	var rfc2253 = _interopRequireWildcard(_rfc);
	
	var _reactLoadScript = __webpack_require__(1409);
	
	var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);
	
	var _carriers = __webpack_require__(190);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegisterComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, {
	    checkRegisterRequestCreate: _register.checkRegisterRequestCreate,
	    getRegisterRequest: _register.getRegisterRequest,
	    createRegisterRequest: _register.createRegisterRequest,
	    updateRegisterRequest: _register.updateRegisterRequest,
	    getDictionaryList: _dictionary.getDictionaryList,
	    loginRegisterRequest: _register.loginRegisterRequest,
	    getUnit: _carriers.getUnit
	}), _dec(_class = function (_BaseEditorFormCompon) {
	    _inherits(RegisterComponent, _BaseEditorFormCompon);
	
	    function RegisterComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RegisterComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegisterComponent.__proto__ || Object.getPrototypeOf(RegisterComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            step: 1,
	            loading: false,
	            errors: [],
	            register_request: {
	                documents: []
	            },
	            certificates: [],
	            selected_certificate: null,
	            request_documents: [],
	            documentIndex: null,
	            new_document: {}
	        }, _this.cadesLoaded = false, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RegisterComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.loadDictionaries(['request_documents']);
	            if (this.props.params.uuid) {
	                this.loadRegisterRequest(this.props.params.uuid);
	            }
	
	            if (window.RNIS_SETTINGS.ECPOFF) {
	                this.setValue('register_request.certificate.serial', '_ecpoff');
	                this.setValue('register_request.certificate.valid_to', '2030-01-01T00:00:00+03:00');
	                this.setValue('register_request.certificate.issuer', '_ecpoff');
	            }
	            if (this.props.location.query.debug) {
	                this.setState({
	                    certificates: [{
	                        label: 'Test certificate',
	                        value: 0,
	                        certificate: {
	                            thumbprint: 'test',
	                            certTillDate: '2020-01-01',
	                            issuerName: 'test',
	                            subjectName: 'test'
	                        }
	                    }]
	                });
	            }
	        }
	    }, {
	        key: 'loadRegisterRequest',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(uuid) {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.startLoad();
	                                _context.next = 3;
	                                return this.props.getRegisterRequest(uuid);
	
	                            case 3:
	                                response = _context.sent;
	
	                                this.endLoad();
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        step: 3,
	                                        register_request: response.payload
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadRegisterRequest(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadRegisterRequest;
	        }()
	    }, {
	        key: 'startLoad',
	        value: function startLoad() {
	            this.setState({
	                loading: true
	            });
	        }
	    }, {
	        key: 'endLoad',
	        value: function endLoad() {
	            this.setState({
	                loading: false
	            });
	        }
	    }, {
	        key: 'get',
	        value: function get(fieldName) {
	            var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return (0, _get3.default)(this.state.register_request, fieldName, defaultValue);
	        }
	    }, {
	        key: 'canGotoStep2',
	        value: function canGotoStep2() {
	            return this.get('login') && this.get('email') && this.get('password') && this.get('password') === this.get('password_confirm');
	        }
	    }, {
	        key: 'gotoStep2',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                this.setState({
	                                    errors: []
	                                });
	                                this.startLoad();
	                                _context2.next = 4;
	                                return this.props.checkRegisterRequestCreate(this.state.register_request);
	
	                            case 4:
	                                response = _context2.sent;
	
	                                this.endLoad();
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        step: 2
	                                    });
	                                } else {
	                                    this.setState({
	                                        errors: response.validationErrors
	                                    });
	                                    response.showErrors();
	                                }
	
	                            case 7:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function gotoStep2() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return gotoStep2;
	        }()
	    }, {
	        key: 'getStep1',
	        value: function getStep1() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__top' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__title' },
	                        '\u0428\u0430\u0433 1 - \u0443\u0447\u0435\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0441\u0442\u0435\u0440-\u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__desc' },
	                        '\u041F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043C\u0430\u0441\u0442\u0435\u0440-\u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u0432 \u0443\u043F\u0440\u043E\u0449\u0435\u043D\u043D\u043E\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0443\u0447\u0435\u0442\u043D\u044B\u0435 \u0437\u0430\u043F\u0438\u0441\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0420\u041D\u0418\u0421 \u043E\u0442 \u0412\u0430\u0448\u0435\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438.'
	                    ),
	                    _react2.default.createElement('hr', null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438' },
	                            this.textInput('register_request.login')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430' },
	                            this.textInput('register_request.email')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u041F\u0430\u0440\u043E\u043B\u044C' },
	                            this.textInput('register_request.password', {
	                                type: 'password'
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F' },
	                            this.textInput('register_request.password_confirm', {
	                                type: 'password'
	                            }),
	                            this.get('password') && this.get('password_confirm') && this.get('password') !== this.get('password_confirm') ? _react2.default.createElement(
	                                'div',
	                                { className: 'input__style_state_wrong' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'input__style_state_msg_wrong' },
	                                    '\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442'
	                                )
	                            ) : null
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__bottom' },
	                    _react2.default.createElement(_button2.default, { color: 'red', shadow: 'red', text: '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C', size: 'md', disabled: !this.canGotoStep2(),
	                        onClick: this.gotoStep2.bind(this) })
	                )
	            );
	        }
	    }, {
	        key: 'cryptoproError',
	        value: function cryptoproError(error) {
	            alerts.error('КриптоПро: ' + error);
	        }
	    }, {
	        key: 'getEcpPart',
	        value: function getEcpPart(subject, part) {
	            if (this.props.location.query.debug) {
	                if (part === 'SN') {
	                    return 'Иванов';
	                }
	                if (part === 'G') {
	                    return 'Иван Иванович';
	                }
	                if (part === 'ИНН') {
	                    return (0, _random3.default)(1000000000, 9999999999).toString();
	                }
	                return 'test';
	            }
	            return rfc2253.parse(subject).get(part) || '';
	        }
	    }, {
	        key: 'cadesOnLoad',
	        value: function cadesOnLoad() {
	            var _this2 = this;
	
	            this.cryptopro.CheckForPlugIn(function (version) {
	                _this2.cryptopro.GetCertificates(function (list) {
	                    if (list.length === 0) {
	                        _this2.cryptoproError('не найден сертификат');
	                        return;
	                    }
	                    if (_this2.cadesLoaded) {
	                        return;
	                    }
	                    _this2.cadesLoaded = true;
	
	                    var certificates = (0, _map3.default)(list, function (cert, index) {
	                        var cn = _this2.getEcpPart(cert.subjectName, 'CN');
	                        while (cn.indexOf('""') !== -1) {
	                            cn = cn.replace(/""/g, '"');
	                        }
	                        var ogrn = _this2.getEcpPart(cert.subjectName, 'ОГРН') || _this2.getEcpPart(cert.subjectName, 'OGRN');
	                        var inn = _this2.getEcpPart(cert.subjectName, 'ИНН') || _this2.getEcpPart(cert.subjectName, 'INN');
	                        var isPrivate = inn && inn.substr(0, 1) !== '0' && !ogrn;
	                        inn = inn.replace(/^[0]+/, '');
	                        var sn = _this2.getEcpPart(cert.subjectName, 'SN');
	                        var g = _this2.getEcpPart(cert.subjectName, 'G');
	                        var label = cn;
	                        if (inn && sn && g && !isPrivate) {
	                            label = cn + ' (\u0418\u041D\u041D ' + inn + ', ' + sn + ' ' + g + ')';
	                        } else if (inn) {
	                            label = cn + ' (\u0418\u041D\u041D ' + inn + ')';
	                        }
	
	                        return {
	                            label: label,
	                            value: index,
	                            certificate: cert
	                        };
	                    });
	
	                    _this2.setState({
	                        certificates: certificates
	                    });
	                });
	            }, function (error) {
	                _this2.cryptoproError(error);
	            });
	        }
	    }, {
	        key: 'onCertificateSelect',
	        value: function onCertificateSelect(e) {
	            var value = e ? e.value : null;
	            var certificate = e ? e.certificate : null;
	
	            this.setValue('selected_certificate', value);
	
	            this.setValue('register_request.certificate.serial', certificate ? certificate.thumbprint : null);
	            this.setValue('register_request.certificate.valid_to', certificate ? (0, _moment2.default)(certificate.certTillDate).format(_formats2.default.DATE_API) : null);
	            this.setValue('register_request.certificate.issuer', certificate ? this.getEcpPart(certificate.issuerName, 'CN') : null);
	            this.setValue('register_request.certificate.owner', certificate ? (0, _filter3.default)([this.getEcpPart(certificate.subjectName, 'SN'), this.getEcpPart(certificate.subjectName, 'G')]).join(' ') : null);
	            this.setValue('register_request.certificate.name', certificate ? this.getEcpPart(certificate.subjectName, 'CN') : null);
	            this.setValue('register_request.certificate.inn', certificate ? this.parseINN(this.getEcpPart(certificate.subjectName, 'ИНН') || this.getEcpPart(certificate.subjectName, 'INN')) : null);
	            this.setValue('register_request.certificate.ogrn', certificate ? this.getEcpPart(certificate.subjectName, 'ОГРН') || this.getEcpPart(certificate.subjectName, 'OGRN') : null);
	            this.setValue('register_request.certificate.address', certificate ? (0, _filter3.default)([this.getEcpPart(certificate.subjectName, 'L'), this.getEcpPart(certificate.subjectName, 'STREET') || this.getEcpPart(certificate.subjectName, 'ST')]).join(' ') : null);
	            this.setValue('register_request.certificate.position', certificate ? this.getEcpPart(certificate.subjectName, 'TITLE') || this.getEcpPart(certificate.subjectName, 'T') : null);
	        }
	    }, {
	        key: 'parseINN',
	        value: function parseINN(inn) {
	            return inn.replace(/^([0]+)/, '');
	        }
	    }, {
	        key: 'canGotoStep3',
	        value: function canGotoStep3() {
	            return this.get('certificate.serial') && this.get('certificate.valid_to') && this.get('certificate.issuer') && this.get('certificate.owner') && this.get('certificate.name') && this.get('certificate.inn') && this.get('certificate.ogrn') && this.get('certificate.address') && this.get('certificate.position');
	        }
	    }, {
	        key: 'gotoStep3',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                var unit;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.checkUnit();
	
	                            case 2:
	                                unit = _context3.sent;
	
	                                if (unit) {
	                                    this.registerInUnit(unit);
	                                } else {
	                                    this.setState({
	                                        step: 3
	                                    });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function gotoStep3() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return gotoStep3;
	        }()
	    }, {
	        key: 'registerInUnit',
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(unit) {
	                var _this3 = this;
	
	                var request, response;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                request = (0, _cloneDeep3.default)(this.state.register_request);
	
	                                request.unit_uuid = unit.uuid;
	
	                                _context4.next = 4;
	                                return this.props.createRegisterRequest(request);
	
	                            case 4:
	                                response = _context4.sent;
	
	
	                                if (response.isOk) {
	                                    alerts.success('Учетная запись успешно создана; реквизиты для доступа к Системе высланы на указанный email', null, function () {
	                                        _this3.props.router.push('/');
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function registerInUnit(_x3) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return registerInUnit;
	        }()
	    }, {
	        key: 'checkUnit',
	        value: function () {
	            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return this.props.getUnit(this.get('certificate.inn'), this.get('certificate.ogrn'));
	
	                            case 2:
	                                response = _context5.sent;
	
	                                if (!response.isOk) {
	                                    _context5.next = 5;
	                                    break;
	                                }
	
	                                return _context5.abrupt('return', response.payload);
	
	                            case 5:
	                                return _context5.abrupt('return', false);
	
	                            case 6:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function checkUnit() {
	                return _ref6.apply(this, arguments);
	            }
	
	            return checkUnit;
	        }()
	    }, {
	        key: 'showFeedback',
	        value: function showFeedback() {
	            this.refs.page.onFeedbackClick();
	        }
	    }, {
	        key: 'getStep2',
	        value: function getStep2() {
	            var _this4 = this;
	
	            if (!this.props.location.query.debug && !window.RNIS_SETTINGS.ECPOFF) {
	                this.cryptopro = new cadesPluginWrapper(this.cadesOnLoad.bind(this), function (error) {
	                    _this4.cryptoproError(error);
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__top' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__title' },
	                        '\u0428\u0430\u0433 2 - \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438'
	                    ),
	                    !window.RNIS_SETTINGS.ECPOFF ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'page-block__desc' },
	                            '\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0430\u044F \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u044C \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044F \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '\u0421 \u0431\u043E\u043B\u0435\u0435 \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u0438 \u043A \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0434\u043F\u0438\u0441\u0438 \u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F\u043C\u0438 \u043F\u043E \u0435\u0451 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044E \u0432 \u0420\u041D\u0418\u0421 \u043C\u043E\u0436\u043D\u043E \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F ',
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'link', href: '/page/register', target: '_blank' },
	                                '\u0437\u0434\u0435\u0441\u044C'
	                            ),
	                            '.',
	                            _react2.default.createElement('br', null),
	                            '\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u044F \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432 \u043F\u043E \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u043E\u043C \u043F\u043E \u0444\u043E\u0440\u043C\u0435 \xA0',
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'link', href: 'javascript:void(0)', onClick: this.showFeedback.bind(this) },
	                                '\u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438'
	                            ),
	                            '.'
	                        )
	                    ) : null,
	                    _react2.default.createElement('hr', null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    window.RNIS_SETTINGS.ECPOFF ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _block2.default,
	                                { title: '\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446' },
	                                this.textInput('register_request.certificate.owner')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _block2.default,
	                                { title: '\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438' },
	                                this.textInput('register_request.certificate.name')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _block2.default,
	                                { title: '\u0418\u041D\u041D' },
	                                this.textInput('register_request.certificate.inn')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _block2.default,
	                                { title: '\u041E\u0413\u0420\u041D' },
	                                this.textInput('register_request.certificate.ogrn')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _block2.default,
	                                { title: '\u0410\u0434\u0440\u0435\u0441 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438' },
	                                this.textInput('register_request.certificate.address')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _block2.default,
	                                { title: '\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C' },
	                                this.textInput('register_request.certificate.position')
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _block2.default,
	                            { size: 'xl', title: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442' },
	                            this.select('selected_certificate', this.state.certificates, {
	                                onChange: this.onCertificateSelect.bind(this)
	                            })
	                        ),
	                        this.state.selected_certificate !== null ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'group' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'group__title' },
	                                    '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'group__content' },
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u042D\u0426\u041F' },
	                                        this.get('certificate.serial') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0434\u043E' },
	                                        this.get('certificate.valid_to') ? (0, _moment2.default)(this.get('certificate.valid_to')).format(_formats2.default.DATE) : _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u0412\u044B\u0434\u0430\u043D' },
	                                        this.get('certificate.issuer') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446' },
	                                        this.get('certificate.owner') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'group' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'group__title' },
	                                    '\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'group__content' },
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435' },
	                                        this.get('certificate.name') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u0418\u041D\u041D' },
	                                        this.get('certificate.inn') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u041E\u0413\u0420\u041D' },
	                                        this.get('certificate.ogrn') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u0410\u0434\u0440\u0435\u0441 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438' },
	                                        this.get('certificate.address') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _block2.default,
	                                        { size: 'xl', className: 'b-block_right', title: '\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C' },
	                                        this.get('certificate.position') || _react2.default.createElement(
	                                            'span',
	                                            { className: 'error' },
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                                        )
	                                    )
	                                )
	                            )
	                        ) : null
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__bottom' },
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement(_button2.default, { color: 'red', shadow: 'red', text: '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C', size: 'md', disabled: !this.canGotoStep3(),
	                        onClick: this.gotoStep3.bind(this) })
	                )
	            );
	        }
	    }, {
	        key: 'onDocumentTypeSelect',
	        value: function onDocumentTypeSelect(e) {
	            var value = e ? e.value : null;
	
	            if (value) {
	                this.addDocumentWithType(value);
	            }
	        }
	    }, {
	        key: 'deleteDocument',
	        value: function deleteDocument(index) {
	            var register_request = this.state.register_request;
	            register_request.documents.splice(index, 1);
	            this.setState({
	                register_request: register_request
	            });
	        }
	    }, {
	        key: 'getStep3',
	        value: function getStep3() {
	            var _this5 = this;
	
	            var fields = {
	                'register_request.login': 'Логин',
	                'register_request.password': 'Пароль',
	                'register_request.email': 'Email',
	                'register_request.certificate.name': 'ЭЦП: наименование',
	                'register_request.certificate.serial': 'ЭЦП: номер',
	                'register_request.certificate.valid_to': 'ЭЦП: действителен до',
	                'register_request.certificate.issuer': 'ЭЦП: выдан',
	                'register_request.certificate.owner': 'ЭЦП: владелец',
	                'register_request.certificate.inn': 'ЭЦП: ИНН',
	                'register_request.certificate.ogrn': 'ЭЦП: ОГРН',
	                'register_request.certificate.address': 'ЭЦП: адрес регистрации',
	                'register_request.certificate.position': 'ЭЦП: должность'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__top' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__title' },
	                        '\u0428\u0430\u0433 3 - \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__desc' },
	                        '\u041E\u0447\u0435\u0440\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0432\u0430\u0448\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043F\u043B\u0430\u043D\u0438\u0440\u0443\u0435\u0442 \u0432\u0435\u0441\u0442\u0438 \u0432 \u0420\u041D\u0418\u0421'
	                    ),
	                    _react2.default.createElement('hr', null)
	                ),
	                (0, _map3.default)(fields, function (name, field) {
	                    var error = _this5.getError(field);
	                    return error ? _react2.default.createElement(
	                        'div',
	                        { key: field, className: 'input__style_state_wrong' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'input__style_state_msg_wrong' },
	                            name,
	                            ': ',
	                            error
	                        )
	                    ) : null;
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: this.props.params.uuid ? 'half' : '' },
	                    _react2.default.createElement(
	                        _block2.default,
	                        { size: 'xl', title: '\u041F\u0440\u043E\u0444\u0438\u043B\u044C\u043D\u044B\u0435 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438' },
	                        this.canEdit() ? this.select('register_request.components', (0, _map3.default)(_systems2.default, function (label, value) {
	                            return {
	                                value: value,
	                                label: label
	                            };
	                        }), {
	                            multi: true
	                        }) : (0, _map3.default)(this.get('components'), function (component) {
	                            return (0, _get3.default)(_systems2.default, component);
	                        }).join(', ')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'set' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'set__title' },
	                        '\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'set__content clearAfter' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'half' },
	                            this.get('documents', []).map(this.renderDocument.bind(this))
	                        ),
	                        this.canEdit() ? _react2.default.createElement(
	                            'div',
	                            { className: 'half' },
	                            this.renderDocumentEdit()
	                        ) : null
	                    )
	                ),
	                this.get('history', []).length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: this.props.params.uuid ? 'half' : '' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'group__title' },
	                            '\u0425\u043E\u0434 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438'
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { size: 'xl' },
	                            this.get('history', []).map(this.renderHistory.bind(this))
	                        ),
	                        !this.get('status') || this.get('status') === 'returned' ? _react2.default.createElement(
	                            _block2.default,
	                            { size: 'xl', title: '\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439' },
	                            this.textarea('register_request.status_comment')
	                        ) : null
	                    )
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__bottom' },
	                    _react2.default.createElement('hr', null),
	                    !this.get('status') || this.get('status') === 'returned' ? _react2.default.createElement(_button2.default, { size: 'md', color: 'red', shadow: 'red', width: 'auto', text: '\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442',
	                        onClick: this.send.bind(this) }) : null
	                )
	            );
	        }
	    }, {
	        key: 'renderDocument',
	        value: function renderDocument(document, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: index, className: 'document-set' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'document-set__title' },
	                    (0, _get3.default)((0, _find3.default)(this.state.request_documents, { value: document.request_document_uuid }), 'label')
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'files' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'files__item' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'files__info' },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                document.filename
	                            )
	                        ),
	                        this.canEdit() ? _react2.default.createElement(
	                            'div',
	                            { className: 'files-menu' },
	                            _react2.default.createElement(
	                                'span',
	                                {
	                                    className: 'files-menu__item edit',
	                                    onClick: this.editDocument.bind(this, index) },
	                                '\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                {
	                                    className: 'files-menu__item remove',
	                                    onClick: this.deleteDocument.bind(this, index) },
	                                '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B'
	                            )
	                        ) : null
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'editDocument',
	        value: function editDocument(index) {
	            this.setState({
	                documentIndex: index
	            });
	        }
	    }, {
	        key: 'renderDocumentEdit',
	        value: function renderDocumentEdit() {
	            var _this6 = this;
	
	            var index = this.state.documentIndex;
	            var title = index !== null ? 'Редактирование' : 'Добавление';
	
	            var document = (0, _get3.default)((0, _find3.default)(this.state.request_documents, { value: index !== null ? (0, _get3.default)(this.state, 'register_request.documents.' + index + '.request_document_uuid') : (0, _get3.default)(this.state, 'new_document.request_document_uuid') }), 'document');
	
	            var urlError = this.getError(index !== null ? 'register_request.documents.' + index + '.url' : 'new_document.url');
	            return _react2.default.createElement(
	                'div',
	                { className: 'group group-document' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'group__content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'document' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'group__title' },
	                            title,
	                            ' \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block _xl' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'b-block__title' },
	                                '\u0424\u0430\u0439\u043B'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'b-block__text' },
	                                this.textInput(index !== null ? 'register_request.documents.' + index + '.filename' : 'new_document.filename'),
	                                _react2.default.createElement(
	                                    _reactFileReaderInput2.default,
	                                    { as: 'binary', id: 'my-file-input',
	                                        onChange: this.uploadFile.bind(this, index) },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'add-file' },
	                                        '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C'
	                                    )
	                                ),
	                                urlError ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'input__style_state_wrong' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'input__style_state_msg_wrong' },
	                                        urlError
	                                    )
	                                ) : null
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { size: 'xl', title: '\u0422\u0438\u043F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430' },
	                            this.select(index !== null ? 'register_request.documents.' + index + '.request_document_uuid' : 'new_document.request_document_uuid', (0, _filter3.default)(this.state.request_documents, function (document) {
	                                return (0, _indexOf3.default)(_this6.get('components'), document.document.component) !== -1;
	                            }))
	                        ),
	                        _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D', className: 'expand-top' },
	                            this.datepicker(index !== null ? 'register_request.documents.' + index + '.issued_at' : 'new_document.issued_at')
	                        ),
	                        !document || !document.is_unlimited ? _react2.default.createElement(
	                            _block2.default,
	                            { title: '\u0418\u0441\u0442\u0435\u043A\u0430\u0435\u0442', className: 'expand-top' },
	                            this.datepicker(index !== null ? 'register_request.documents.' + index + '.valid_to' : 'new_document.valid_to')
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'b-block _xl' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'b-button b-button_red b-button_shadow_red b-button_size_md',
	                                        onClick: this.saveDocument.bind(this) },
	                                    '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'b-button b-button_white b-button_shadow_gray b-button_size_md',
	                                        onClick: this.cancelDocument.bind(this) },
	                                    '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'validateDocument',
	        value: function validateDocument() {
	            var _this7 = this;
	
	            var index = this.state.documentIndex;
	            var prefix = index !== null ? 'register_request.documents.' + index + '.' : 'new_document.';
	
	            var errors = {};
	            (0, _each3.default)(['filename', 'url', 'request_document_uuid', 'issued_at', 'valid_to'], function (field) {
	                if (!_this7.getValue(prefix + field)) {
	                    errors[prefix + field] = 'Обязательно для заполнения';
	                }
	            });
	
	            this.setState({
	                errors: errors
	            });
	
	            return (0, _isEmpty3.default)(errors);
	        }
	    }, {
	        key: 'saveDocument',
	        value: function saveDocument() {
	            /*if (!this.validateDocument()) {
	                return;
	            }*/
	            if (this.state.documentIndex === null) {
	                var register_request = this.state.register_request;
	                register_request.documents.push(this.state.new_document);
	                this.setState({
	                    register_request: register_request,
	                    documentIndex: null,
	                    new_document: {}
	                });
	            } else {
	                this.setState({
	                    documentIndex: null,
	                    new_document: {}
	                });
	            }
	        }
	    }, {
	        key: 'cancelDocument',
	        value: function cancelDocument() {
	            this.setState({
	                documentIndex: null,
	                new_document: {}
	            });
	        }
	    }, {
	        key: 'renderHistory',
	        value: function renderHistory(history, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: index, className: 'LogItem' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'LogItem-table' },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: 'LogItem-cell LogItem-time border-right' },
	                        (0, _moment2.default)(history.timestamp).format(_formats2.default.DATETIME)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'LogItem-cell LogItem-text' },
	                        history.text
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'LogItem-cell LogItem-user border-left' },
	                        history.comment
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'uploadFile',
	        value: function () {
	            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(index, e, results) {
	                var tokenInfo, formData, response, value;
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                _context6.next = 2;
	                                return this.getUploadToken();
	
	                            case 2:
	                                tokenInfo = _context6.sent;
	                                formData = new FormData();
	
	
	                                results.forEach(function (result) {
	                                    var _result = _slicedToArray(result, 2),
	                                        e = _result[0],
	                                        file = _result[1];
	                                    //formData.append('file', e.target.result);
	
	
	                                    formData.append('file', file);
	                                });
	
	                                formData.append('token', tokenInfo.token);
	
	                                _context6.next = 8;
	                                return _api.api.storage.uploadFile(tokenInfo.upload_url, formData);
	
	                            case 8:
	                                response = _context6.sent;
	                                value = response.url.replace('http://', 'https://');
	
	
	                                this.setValue(index !== null ? 'register_request.documents.' + index + '.url' : 'new_document.url', value);
	                                this.setValue(index !== null ? 'register_request.documents.' + index + '.filename' : 'new_document.filename', response.original_filename);
	
	                            case 12:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function uploadFile(_x4, _x5, _x6) {
	                return _ref7.apply(this, arguments);
	            }
	
	            return uploadFile;
	        }()
	    }, {
	        key: 'getUploadToken',
	        value: function () {
	            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                _context7.prev = 0;
	                                _context7.next = 3;
	                                return _api.api.storage.getUploadToken();
	
	                            case 3:
	                                response = _context7.sent;
	                                return _context7.abrupt('return', response.payload);
	
	                            case 7:
	                                _context7.prev = 7;
	                                _context7.t0 = _context7['catch'](0);
	
	                                console.log('Ошибка получения токена загрузки', _context7.t0);
	
	                            case 10:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this, [[0, 7]]);
	            }));
	
	            function getUploadToken() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return getUploadToken;
	        }()
	    }, {
	        key: 'send',
	        value: function () {
	            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	                var _this8 = this;
	
	                var documentTypes, full;
	                return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                documentTypes = (0, _map3.default)((0, _filter3.default)(this.state.request_documents, function (document) {
	                                    return (0, _indexOf3.default)(_this8.get('components'), document.document.component) !== -1;
	                                }), 'value');
	                                full = true;
	
	                                (0, _each3.default)(documentTypes, function (uuid) {
	                                    if (!(0, _find3.default)(_this8.get('documents'), {
	                                        request_document_uuid: uuid
	                                    })) {
	                                        full = false;
	                                    }
	                                });
	
	                                if (full) {
	                                    this.sendReal();
	                                } else {
	                                    alerts.confirm('Неполная комплектность документов. Продолжить?', function () {
	                                        _this8.sendReal();
	                                    });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function send() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return send;
	        }()
	    }, {
	        key: 'sendReal',
	        value: function () {
	            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	                var _this9 = this;
	
	                var response;
	                return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                this.startLoad();
	                                this.setState({
	                                    errors: []
	                                });
	
	                                if (!this.state.register_request.uuid) {
	                                    _context9.next = 8;
	                                    break;
	                                }
	
	                                _context9.next = 5;
	                                return this.props.updateRegisterRequest(this.state.register_request);
	
	                            case 5:
	                                _context9.t0 = _context9.sent;
	                                _context9.next = 11;
	                                break;
	
	                            case 8:
	                                _context9.next = 10;
	                                return this.props.createRegisterRequest(this.state.register_request);
	
	                            case 10:
	                                _context9.t0 = _context9.sent;
	
	                            case 11:
	                                response = _context9.t0;
	
	                                this.endLoad();
	
	                                if (response.isOk) {
	                                    if (this.state.register_request.uuid) {
	                                        alerts.success('Заявка успешно отправлена повторно', null, function () {
	                                            window.location.reload();
	                                        });
	                                    } else {
	                                        alerts.success('Заявка успешно создана', null, function () {
	                                            _this9.props.router.push('/');
	                                        });
	                                    }
	                                } else {
	                                    response.showErrors();
	                                    this.setState({
	                                        errors: response.validationErrors
	                                    });
	                                }
	
	                            case 14:
	                            case 'end':
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee9, this);
	            }));
	
	            function sendReal() {
	                return _ref10.apply(this, arguments);
	            }
	
	            return sendReal;
	        }()
	    }, {
	        key: 'getLoginForm',
	        value: function getLoginForm() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'page-block' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__top' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__title' },
	                        '\u0412\u043E\u0439\u0442\u0438'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__desc' },
	                        '\u0414\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0412\u0430\u0448\u0435\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0432 \u0420\u041D\u0418\u0421, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0448\u0430\u0433\u0435 1 \u043C\u0430\u0441\u0442\u0435\u0440\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0447\u0435\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435'
	                    ),
	                    _react2.default.createElement('hr', null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _block2.default,
	                        { title: '\u041B\u043E\u0433\u0438\u043D \u0438\u043B\u0438 email' },
	                        this.textInput('register_request.login')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _block2.default,
	                        { title: '\u041F\u0430\u0440\u043E\u043B\u044C' },
	                        this.textInput('register_request.password', {
	                            type: 'password'
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _block2.default,
	                    { size: 'xl' },
	                    _react2.default.createElement(_button2.default, { color: 'red', shadow: 'red', text: '\u0412\u0445\u043E\u0434', size: 'md', onClick: this.onLogin.bind(this) })
	                )
	            );
	        }
	    }, {
	        key: 'onLogin',
	        value: function () {
	            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                    while (1) {
	                        switch (_context10.prev = _context10.next) {
	                            case 0:
	                                this.startLoad();
	                                _context10.next = 3;
	                                return this.props.loginRegisterRequest({
	                                    login: this.get('login'),
	                                    password: this.get('password')
	                                });
	
	                            case 3:
	                                response = _context10.sent;
	
	                                this.endLoad();
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        register_request: response.payload,
	                                        step: 3
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context10.stop();
	                        }
	                    }
	                }, _callee10, this);
	            }));
	
	            function onLogin() {
	                return _ref11.apply(this, arguments);
	            }
	
	            return onLogin;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	            var form = this['getStep' + this.state.step]();
	
	            return _react2.default.createElement(
	                _page2.default,
	                { ref: 'page', pageId: 'Register', title: '\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0439' },
	                _react2.default.createElement(_reactLoadScript2.default, { url: '/static/js/cryptopro/cadesplugin_api.js' }),
	                _react2.default.createElement(_reactLoadScript2.default, { url: '/static/js/cryptopro/cadesplugin_wrapper.js' }),
	                _react2.default.createElement(_reactLoadScript2.default, { url: '/static/js/cryptopro/cadesplugin_wrapper_async.js' }),
	                loader,
	                this.props.params.type === 'login' && this.state.step === 1 ? this.getLoginForm() : _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'steps' },
	                            this.renderSteps()
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block' },
	                        form
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderSteps',
	        value: function renderSteps() {
	            var _this10 = this;
	
	            if (this.props.params.type === 'login') {
	                return;
	            }
	
	            return (0, _map3.default)((0, _range3.default)(3), function (step) {
	                var className = (0, _classnames2.default)({
	                    step: true,
	                    current: step === _this10.state.step - 1,
	                    first: step === 0,
	                    last: step === 2,
	                    done: step < _this10.state.step - 1,
	                    disabled: step > _this10.state.step - 1
	                });
	                return _react2.default.createElement(
	                    'div',
	                    { key: step, className: className,
	                        onClick: step <= _this10.state.step - 1 ? _this10.gotoStep.bind(_this10, step + 1) : null },
	                    '\u0428\u0430\u0433 ',
	                    step + 1
	                );
	            });
	        }
	    }, {
	        key: 'gotoStep',
	        value: function gotoStep(step) {
	            this.setState({
	                step: step
	            });
	        }
	    }, {
	        key: 'canEdit',
	        value: function canEdit() {
	            return !this.state.register_request.status || this.state.register_request.status === 'returned';
	        }
	    }]);
	
	    return RegisterComponent;
	}(_baseEditorForm2.default)) || _class);
	exports.default = RegisterComponent;

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _padStart2 = __webpack_require__(327);
	
	var _padStart3 = _interopRequireDefault(_padStart2);
	
	var _concat2 = __webpack_require__(506);
	
	var _concat3 = _interopRequireDefault(_concat2);
	
	var _last2 = __webpack_require__(228);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _isString2 = __webpack_require__(1268);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _first2 = __webpack_require__(114);
	
	var _first3 = _interopRequireDefault(_first2);
	
	var _find2 = __webpack_require__(89);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _cloneDeep2 = __webpack_require__(223);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _flatten2 = __webpack_require__(224);
	
	var _flatten3 = _interopRequireDefault(_flatten2);
	
	var _uniq2 = __webpack_require__(512);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _sortBy2 = __webpack_require__(137);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _reactNl2br = __webpack_require__(71);
	
	var _reactNl2br2 = _interopRequireDefault(_reactNl2br);
	
	__webpack_require__(1083);
	
	var _reactRedux = __webpack_require__(17);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _reactRouter = __webpack_require__(35);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _select = __webpack_require__(98);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _carriers = __webpack_require__(190);
	
	var _textField = __webpack_require__(188);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _datepicker = __webpack_require__(185);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _schedule = __webpack_require__(793);
	
	var _input = __webpack_require__(186);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _print = __webpack_require__(381);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _routes = __webpack_require__(151);
	
	var _geocoding = __webpack_require__(150);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _inputMask = __webpack_require__(369);
	
	var _inputMask2 = _interopRequireDefault(_inputMask);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduleComponent = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, {
	    portalSchedule: _schedule.portalSchedule,
	    portalScheduleExtended: _schedule.portalScheduleExtended,
	    portalScheduleRoute: _schedule.portalScheduleRoute,
	    getStopPoints: _routes.getStopPoints,
	    routing: _geocoding.routing,
	    getCarriers: _carriers.getCarriers
	}), _dec(_class = function (_Component) {
	    _inherits(ScheduleComponent, _Component);
	
	    function ScheduleComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ScheduleComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScheduleComponent.__proto__ || Object.getPrototypeOf(ScheduleComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            items: [],
	            route_items: [],
	            loading: false,
	            number: null,
	            label: null,
	            date: (0, _moment2.default)(),
	            time: (0, _moment2.default)().format(_formats2.default.TIME),
	            selectedOrderRunUuid: null,
	            from: null,
	            to: null,
	            routes: []
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ScheduleComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadRoutes();
	        }
	    }, {
	        key: 'loadRoutes',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.getCarriers({
	                                    filters: {
	                                        withComponent: 'kiutr'
	                                    }
	                                });
	
	                            case 2:
	                                response = _context.sent;
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        routes: (0, _sortBy3.default)((0, _map3.default)((0, _uniq3.default)((0, _flatten3.default)((0, _map3.default)(response.payload.items, 'routes'))), function (item) {
	                                            return {
	                                                value: item,
	                                                label: item
	                                            };
	                                        }), 'label')
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadRoutes() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadRoutes;
	        }()
	    }, {
	        key: 'onChange',
	        value: function onChange(field, _ref3) {
	            var value = _ref3.target.value;
	
	            if (field === 'time') {
	                //чекаем введенное пользователем кривое время
	                var hours = Number(value.split(':')[0]);
	                var minutes = Number(value.split(':')[1]);
	                if (!isNaN(hours) && hours > 23) {
	                    hours = 23;
	                    value = hours + ':' + value.split(':')[1];
	                }
	                if (!isNaN(minutes) && minutes > 59) {
	                    minutes = 59;
	                    value = value.split(':')[0] + ':' + minutes;
	                }
	            }
	            var state = this.state;
	            state[field] = value;
	            if (field === 'number') {
	                state.from = null;
	                state.to = null;
	            }
	            this.setState(state);
	        }
	    }, {
	        key: 'onChangeSelect',
	        value: function onChangeSelect(field, e) {
	            var value = e || '';
	
	            var state = this.state;
	            /*state[field] = value;
	            state.number = null;*/
	            field === 'number' ? state[field] = value.value : state[field] = value;
	            this.setState(state);
	        }
	    }, {
	        key: 'onChangeNumber',
	        value: function onChangeNumber(field, e) {
	            var value = e ? e.value : null;
	            var label = e ? e.label : null;
	            var state = this.state;
	            state[field] = value;
	            state.label = label;
	            this.setState(state);
	        }
	    }, {
	        key: 'reverse',
	        value: function reverse() {
	            this.setState({
	                from: this.state.to,
	                to: this.state.from
	            });
	        }
	    }, {
	        key: 'loadData',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var correctTime, response;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (!((!this.state.from || !this.state.to) && !this.state.number)) {
	                                    _context2.next = 3;
	                                    break;
	                                }
	
	                                alerts.error('Необходимо заполнить обязательные поля');
	                                return _context2.abrupt('return');
	
	                            case 3:
	                                if (!this.state.time.includes('_')) {
	                                    _context2.next = 7;
	                                    break;
	                                }
	
	                                correctTime = this.state.time.replaceAll('_', '0');
	                                _context2.next = 7;
	                                return this.setState({
	                                    time: correctTime
	                                });
	
	                            case 7:
	
	                                this.setState({ loading: true });
	                                response = void 0;
	
	                                if (!this.state.number) {
	                                    _context2.next = 21;
	                                    break;
	                                }
	
	                                if (!(window.RNIS_SETTINGS.isNSO && this.state.from && this.state.to)) {
	                                    _context2.next = 16;
	                                    break;
	                                }
	
	                                _context2.next = 13;
	                                return this.props.portalScheduleExtended(this.state.label, (0, _moment2.default)((0, _moment2.default)(this.state.date).format('YYYY-MM-DD') + ' ' + this.state.time).format(_formats2.default.DATETIME_API), this.state.from.value, this.state.to.value);
	
	                            case 13:
	                                response = _context2.sent;
	                                _context2.next = 19;
	                                break;
	
	                            case 16:
	                                _context2.next = 18;
	                                return this.props.portalSchedule(this.state.label, (0, _moment2.default)((0, _moment2.default)(this.state.date).format('YYYY-MM-DD') + ' ' + this.state.time).format(_formats2.default.DATETIME_API));
	
	                            case 18:
	                                response = _context2.sent;
	
	                            case 19:
	                                _context2.next = 24;
	                                break;
	
	                            case 21:
	                                _context2.next = 23;
	                                return this.routing();
	
	                            case 23:
	                                response = _context2.sent;
	
	                            case 24:
	                                this.setState({ loading: false });
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        items: response.payload.items
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 26:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function loadData() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return loadData;
	        }()
	    }, {
	        key: 'loadRouteData',
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                this.setState({ loading: true });
	                                _context3.next = 3;
	                                return this.props.portalScheduleRoute(this.state.selectedOrderRunUuid);
	
	                            case 3:
	                                response = _context3.sent;
	
	                                this.setState({ loading: false });
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        route_items: response.payload.items
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function loadRouteData() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return loadRouteData;
	        }()
	    }, {
	        key: 'selectRow',
	        value: function () {
	            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
	                var selectedOrderRunUuid;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                selectedOrderRunUuid = row.order_run_uuid;
	
	                                if (!row.route_uuid) {
	                                    _context4.next = 7;
	                                    break;
	                                }
	
	                                _context4.next = 4;
	                                return this.setState({
	                                    selectedOrderRunUuid: selectedOrderRunUuid,
	                                    route_items: []
	                                });
	
	                            case 4:
	
	                                this.loadRouteData();
	                                _context4.next = 8;
	                                break;
	
	                            case 7:
	                                this.setState({
	                                    selectedOrderRunUuid: selectedOrderRunUuid,
	                                    route_items: row.stop_points
	                                });
	
	                            case 8:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function selectRow(_x) {
	                return _ref6.apply(this, arguments);
	            }
	
	            return selectRow;
	        }()
	    }, {
	        key: 'closeSelected',
	        value: function closeSelected() {
	            this.setState({
	                selectedOrderRunUuid: null
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var loader = this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null;
	
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'RouteList', title: '\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F' },
	                loader,
	                this.state.selectedOrderRunUuid ? this.renderSelectedRoute() : this.renderRoutes()
	            );
	        }
	    }, {
	        key: 'renderRoutes',
	        value: function renderRoutes() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'page-block' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__header' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__menu _lg' },
	                        _react2.default.createElement('div', { className: 'page-block__menu-link page-block__menu-link_print', onClick: this.print.bind(this) })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _sm' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__title' },
	                            '\u2116 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__text' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input' },
	                                _react2.default.createElement(_select2.default, {
	                                    value: this.state.number,
	                                    onChange: this.onChangeNumber.bind(this, 'number')
	                                    //options={this.state.routes}
	                                    , options: (0, _map3.default)(this.state.routes, function (item) {
	                                        return {
	                                            value: item.value.uuid,
	                                            label: item.value.number
	                                        };
	                                    })
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _md' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__title' },
	                            '\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__text' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input' },
	                                _react2.default.createElement(_select.SelectAsync, {
	                                    name: 'from',
	                                    value: (0, _get3.default)(this.state.from, 'value'),
	                                    onChange: this.onChangeSelect.bind(this, 'from'),
	                                    loadOptions: this.loadStopPoints.bind(this),
	                                    options: this.state.from ? [(0, _cloneDeep3.default)(this.state.from)] : []
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('span', { className: 'reverse-direction full', onClick: this.reverse.bind(this) }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _md' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__title' },
	                            '\u041A\u043E\u043D\u0435\u0447\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__text' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input' },
	                                _react2.default.createElement(_select.SelectAsync, {
	                                    value: (0, _get3.default)(this.state.to, 'value'),
	                                    onChange: this.onChangeSelect.bind(this, 'to'),
	                                    loadOptions: this.loadStopPoints.bind(this),
	                                    options: this.state.to ? [this.state.to] : []
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _sm' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__title' },
	                            '\u0414\u0430\u0442\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__text' },
	                            _react2.default.createElement(_datepicker2.default, {
	                                value: this.state.date,
	                                onChange: this.onChange.bind(this, 'date')
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _sm' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__title' },
	                            '\u0412\u0440\u0435\u043C\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__text' },
	                            _react2.default.createElement(_inputMask2.default, { mask: '99:99', value: this.state.time,
	                                onChange: this.onChange.bind(this, 'time') })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block _sm' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                onClick: this.loadData.bind(this),
	                                className: 'b-button b-button_red b-button_shadow_red b-button_posit b-button_size_lg b-button_width_full' },
	                            '\u041D\u0430\u0439\u0442\u0438'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-block _xl' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'table-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Table _no-indent' },
	                            _react2.default.createElement(
	                                'table',
	                                { className: 'b-table', ref: 'table' },
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        { className: 'b-table__header' },
	                                        _react2.default.createElement('th', null),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u2116'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u041C\u0430\u0440\u0448\u0440\u0443\u0442'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u0412\u0440\u0435\u043C\u044F \u0432 \u043F\u0443\u0442\u0438'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u041F\u0440\u0438\u0431\u044B\u0442\u0438\u0435'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    (0, _map3.default)((0, _sortBy3.default)(this.state.items, 'start_at'), this.renderItem.bind(this))
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            var table = this.refs.table;
	            var tableClone = (0, _jquery2.default)(table).clone();
	            tableClone.find('td:first-child,th:first-child').remove();
	            var headers = (0, _jquery2.default)(tableClone).find('th');
	            var rows = (0, _jquery2.default)(tableClone).find('tbody tr');
	            (0, _print.printTable)(headers, rows, 'landscape', 'A4');
	        }
	    }, {
	        key: 'renderItem',
	        value: function renderItem(item, index) {
	            return _react2.default.createElement(
	                'tr',
	                { key: index, onClick: this.selectRow.bind(this, item) },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement('span', { className: 'icon-route-ts icon-route-ts_type_bus' })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    item.number
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    item.title
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'bold' },
	                        item.start_at
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        item.start_from
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    item.time,
	                    ' \u043C\u0438\u043D'
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'bold' },
	                        item.end_at
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        item.end_from
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderSelectedRoute',
	        value: function renderSelectedRoute() {
	            var route = (0, _find3.default)(this.state.items, { order_run_uuid: this.state.selectedOrderRunUuid });
	            var routeUuid = (0, _get3.default)(route, 'route_uuid');
	            var nextRoute = (0, _first3.default)((0, _sortBy3.default)((0, _filter3.default)((0, _filter3.default)(this.state.items, { route_uuid: routeUuid }), function (item) {
	                return (0, _moment2.default)(item.start_at, _formats2.default.TIME).isSameOrAfter((0, _moment2.default)(route.end_at, _formats2.default.TIME));
	            }), 'start_at'));
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'page-block' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-block__header' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__menu _lg' },
	                        _react2.default.createElement('div', { className: 'page-block__menu-link page-block__menu-link_print', onClick: this.print.bind(this) })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'page-block__title' },
	                        _react2.default.createElement('span', { className: 'arrow-back', onClick: this.closeSelected.bind(this) }),
	                        route.start_from,
	                        nextRoute ? _react2.default.createElement('span', { className: 'reverse-direction', onClick: this.selectRow.bind(this, nextRoute) }) : _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u2014'
	                        ),
	                        route.end_from
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-block _xl' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'table-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Table _no-indent' },
	                            _react2.default.createElement(
	                                'table',
	                                { className: 'b-table', ref: 'table' },
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        { className: 'b-table__header' },
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u041C\u0435\u0441\u0442\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            '\u0412\u0440\u0435\u043C\u044F \u0432 \u043F\u0443\u0442\u0438'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    (0, _map3.default)(this.state.route_items, this.renderRouteItem.bind(this))
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderRouteItem',
	        value: function renderRouteItem(item, index) {
	            if ((0, _isString3.default)(item)) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: index, className: 'transfer' },
	                    _react2.default.createElement(
	                        'td',
	                        { colSpan: 3 },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bold' },
	                            item
	                        )
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                'tr',
	                { key: index },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    item.name
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    item.arrival_time
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    item.time ? item.time + ' \u043C\u0438\u043D' : null
	                )
	            );
	        }
	    }, {
	        key: 'loadStopPoints',
	        value: function () {
	            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(input, callback) {
	                var filters, response;
	                return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                if (input) {
	                                    _context5.next = 3;
	                                    break;
	                                }
	
	                                callback(null, {
	                                    options: [],
	                                    complete: false
	                                });
	                                return _context5.abrupt('return');
	
	                            case 3:
	                                filters = {
	                                    withSource: 'inventarisation_active',
	                                    withRoutes: [this.state.number]
	                                };
	
	
	                                if (!window.RNIS_SETTINGS.isNSO) {
	                                    delete filters.withRoutes;
	                                }
	
	                                _context5.next = 7;
	                                return this.props.getStopPoints({
	                                    search: input,
	                                    pagination: {
	                                        page: 1,
	                                        limit: 10
	                                    },
	                                    filters: filters
	                                });
	
	                            case 7:
	                                response = _context5.sent;
	
	
	                                if (response.isOk) {
	                                    callback(null, {
	                                        options: (0, _sortBy3.default)((0, _map3.default)(response.payload.items, function (item) {
	                                            return {
	                                                value: item.uuid,
	                                                label: item.title,
	                                                latitude: item.latitude,
	                                                longitude: item.longitude
	                                            };
	                                        }), 'label'),
	                                        complete: false
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 9:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function loadStopPoints(_x2, _x3) {
	                return _ref7.apply(this, arguments);
	            }
	
	            return loadStopPoints;
	        }()
	    }, {
	        key: 'routing',
	        value: function () {
	            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	                var _this2 = this;
	
	                var response, currentRoute;
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                _context6.next = 2;
	                                return this.props.routing({
	                                    from: this.state.from,
	                                    to: this.state.to,
	                                    transit: [],
	                                    datetime: (0, _moment2.default)((0, _moment2.default)(this.state.date).format('YYYY-MM-DD') + ' ' + this.state.time).format(_formats2.default.DATETIME_API),
	                                    version: 1,
	                                    modes: ['TRANSIT']
	                                });
	
	                            case 2:
	                                response = _context6.sent;
	
	                                if (!response.isOk) {
	                                    _context6.next = 8;
	                                    break;
	                                }
	
	                                currentRoute = null;
	                                return _context6.abrupt('return', {
	                                    isOk: true,
	                                    payload: {
	                                        items: (0, _map3.default)(response.payload.items, function (item, _index) {
	                                            var points = (0, _filter3.default)(item.points, { type: 'bus' });
	                                            var start = _this2.timeToInt((0, _get3.default)((0, _first3.default)(points), 'time_at'));
	
	                                            return {
	                                                number: (0, _filter3.default)((0, _uniq3.default)((0, _map3.default)(points, 'route.number'))).join(', '),
	                                                title: (0, _get3.default)(_this2.state.from, 'label') + ' - ' + (0, _get3.default)(_this2.state.to, 'label'),
	                                                start_at: (0, _get3.default)((0, _first3.default)(points), 'time_at'),
	                                                start_from: (0, _get3.default)((0, _first3.default)(points), 'stop_point.name'),
	                                                end_at: (0, _get3.default)((0, _last3.default)(points), 'time_at'),
	                                                end_from: (0, _get3.default)((0, _last3.default)(points), 'stop_point.name'),
	                                                time: item.time,
	                                                order_run_uuid: _index + 1,
	                                                stop_points: (0, _flatten3.default)((0, _map3.default)((0, _filter3.default)(points, function (point) {
	                                                    return point.stop_point;
	                                                }), function (point, index) {
	                                                    if (!currentRoute) {
	                                                        currentRoute = point.route.number;
	                                                    }
	                                                    var result = [];
	                                                    if (point.route.number !== currentRoute) {
	                                                        currentRoute = point.route.number;
	                                                        result.push('\u041F\u0435\u0440\u0435\u0445\u043E\u0434 \u043D\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442 \u2116 ' + currentRoute);
	                                                    }
	                                                    return (0, _concat3.default)(result, [{
	                                                        name: point.stop_point.name,
	                                                        arrival_time: (0, _get3.default)(point, 'time_at'),
	                                                        time: _this2.timeToInt((0, _get3.default)(point, 'time_at')) - start
	                                                    }]);
	                                                }))
	                                            };
	                                        })
	                                    }
	                                });
	
	                            case 8:
	                                return _context6.abrupt('return', response);
	
	                            case 9:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function routing() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return routing;
	        }()
	    }, {
	        key: 'intToTime',
	        value: function intToTime(int) {
	            var hours = (0, _padStart3.default)(Math.floor(int / 60), 2, '0');
	            var minutes = (0, _padStart3.default)(int % 60, 2, '0');
	            return hours + ':' + minutes;
	        }
	    }, {
	        key: 'timeToInt',
	        value: function timeToInt(time) {
	            var timeObject = (0, _moment2.default)(time, _formats2.default.TIME);
	            return timeObject.hours() * 60 + timeObject.minutes();
	        }
	    }]);
	
	    return ScheduleComponent;
	}(_react.Component)) || _class);
	exports.default = ScheduleComponent;

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _page = __webpack_require__(32);
	
	var _page2 = _interopRequireDefault(_page);
	
	__webpack_require__(1084);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SoonComponent = function (_Component) {
	    _inherits(SoonComponent, _Component);
	
	    function SoonComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SoonComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoonComponent.__proto__ || Object.getPrototypeOf(SoonComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SoonComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _page2.default,
	                { pageId: 'Soon', title: '' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement('div', { className: 'icon' }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u041C\u044B \u043F\u0440\u043E\u0434\u0435\u043B\u0430\u043B\u0438 \u043E\u0433\u0440\u043E\u043C\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443,',
	                        _react2.default.createElement('br', null),
	                        '\u0447\u0442\u043E\u0431\u044B \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0430\u0437\u0434\u0435\u043B.'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u0421\u043A\u043E\u0440\u043E \u043E\u043D \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435.'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SoonComponent;
	}(_react.Component);
	
	exports.default = SoonComponent;

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.LabeledCheckbox = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _dec3, _dec4, _class2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1086);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabeledCheckbox = exports.LabeledCheckbox = (_dec = (0, _reactPropsDecorators.propTypes)({
	    label: _propTypes2.default.string.isRequired,
	    checked: _propTypes2.default.bool
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    onChange: function onChange() {}
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(LabeledCheckbox, _Component);
	
	    function LabeledCheckbox() {
	        _classCallCheck(this, LabeledCheckbox);
	
	        return _possibleConstructorReturn(this, (LabeledCheckbox.__proto__ || Object.getPrototypeOf(LabeledCheckbox)).apply(this, arguments));
	    }
	
	    _createClass(LabeledCheckbox, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'checkbox-labeled', onClick: this.onChange.bind(this) },
	                _react2.default.createElement(Checkbox, { checked: this.props.checked }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    this.props.label
	                )
	            );
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(e) {
	            this.props.onChange(!this.props.checked);
	        }
	    }]);
	
	    return LabeledCheckbox;
	}(_react.Component)) || _class) || _class);
	var Checkbox = (_dec3 = (0, _reactPropsDecorators.propTypes)({
	    checked: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func
	}), _dec4 = (0, _reactPropsDecorators.defaultProps)({
	    onChange: function onChange() {}
	}), _dec3(_class2 = _dec4(_class2 = function (_Component2) {
	    _inherits(Checkbox, _Component2);
	
	    function Checkbox() {
	        _classCallCheck(this, Checkbox);
	
	        return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	    }
	
	    _createClass(Checkbox, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'b-checkbox' },
	                _react2.default.createElement('input', { type: 'checkbox', className: 'b-checkbox__inner', checked: this.props.checked, onChange: this.onChange.bind(this) }),
	                _react2.default.createElement('label', { className: 'b-checkbox__label' })
	            );
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            this.props.onChange(!this.props.checked);
	        }
	    }]);
	
	    return Checkbox;
	}(_react.Component)) || _class2) || _class2);
	exports.default = Checkbox;

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	__webpack_require__(1087);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormGroup = (_dec = (0, _reactPropsDecorators.propTypes)({
	    name: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string.isRequired
	}), _dec(_class = function (_Component) {
	    _inherits(FormGroup, _Component);
	
	    function FormGroup() {
	        _classCallCheck(this, FormGroup);
	
	        return _possibleConstructorReturn(this, (FormGroup.__proto__ || Object.getPrototypeOf(FormGroup)).apply(this, arguments));
	    }
	
	    _createClass(FormGroup, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'formGroup' },
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.name },
	                    this.props.label
	                ),
	                this.props.children
	            );
	        }
	    }]);
	
	    return FormGroup;
	}(_react.Component)) || _class);
	exports.default = FormGroup;

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1092);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Textarea = (_dec = (0, _reactPropsDecorators.propTypes)({}), _dec2 = (0, _reactPropsDecorators.defaultProps)({}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(Textarea, _Component);
	
	    function Textarea() {
	        _classCallCheck(this, Textarea);
	
	        return _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).apply(this, arguments));
	    }
	
	    _createClass(Textarea, [{
	        key: 'render',
	        value: function render() {
	            var inputProps = {};
	
	            if (this.props.onEnter) inputProps.onKeyPress = this.handleKeyPress.bind(this);
	
	            if (this.props.name) inputProps.name = this.props.name;
	
	            if (this.props.value) {
	                inputProps.value = this.props.value;
	            }
	
	            var styleClassName = (0, _classnames2.default)('textarea_input__style', this.props.error ? 'textarea_input__style_state_wrong' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'textarea_input' },
	                _react2.default.createElement('textarea', _extends({
	                    ref: 'input',
	                    className: 'textarea_input__control',
	                    defaultValue: this.props.defaultValue,
	                    type: this.props.type,
	                    placeholder: this.props.placeholder,
	                    onChange: this.props.onChange
	                }, inputProps)),
	                _react2.default.createElement(
	                    'div',
	                    { className: styleClassName },
	                    this.props.error ? _react2.default.createElement(
	                        'span',
	                        { className: 'textarea_input__style_state_msg textarea_input__style_state_msg_wrong' },
	                        this.props.error
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'handleKeyPress',
	        value: function handleKeyPress(e) {
	            if (e.key === 'Enter') {
	                e.preventDefault();
	                this.props.onEnter();
	            }
	        }
	    }]);
	
	    return Textarea;
	}(_react.Component)) || _class) || _class);
	exports.default = Textarea;

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(35);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1095);
	
	var _reactRedux = __webpack_require__(17);
	
	var _menu = __webpack_require__(388);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _iscroll = __webpack_require__(1143);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeftSide = (_dec = (0, _reactPropsDecorators.propTypes)({
	    menu: _propTypes2.default.array
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    menu: []
	}), _dec3 = (0, _reactRedux.connect)(function (state) {
	    return {
	        submenu: state.menu.get('submenu')
	    };
	}, { openSubmenu: _menu.openSubmenu, closeSubmenu: _menu.closeSubmenu }), _dec(_class = _dec2(_class = _dec3(_class = function (_Component) {
	    _inherits(LeftSide, _Component);
	
	    function LeftSide() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LeftSide);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeftSide.__proto__ || Object.getPrototypeOf(LeftSide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            opened: false
	        }, _this.updateCount = 0, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LeftSide, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.updateCount++;
	            //if (!$('.sub-menu_open').length) {
	            new _iscroll2.default('.left-menu__wrapper', {
	                mouseWheel: true,
	                scrollbars: false,
	                click: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
	            });
	            /*} else {
	                new IScroll('.sub-menu_open', {
	                    mouseWheel: true,
	                    scrollbars: false,
	                    click: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
	                });
	            }*/
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.forceUpdate();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var menuClassName = (0, _classnames2.default)('left-menu', this.state.opened ? 'left-menu_expanded' : '');
	            var buttonsClassName = (0, _classnames2.default)('left-menu-button', this.state.opened ? 'left-menu-button_open' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: menuClassName },
	                _react2.default.createElement('a', { href: '#', className: buttonsClassName, onClick: this.toggleMenu.bind(this) }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'left-menu__wrapper' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'left-menu__list' },
	                        this.props.menu.map(this.renderItem.bind(this)),
	                        window.RNIS_SETTINGS.HIDECOPYRIGHT ? null : _react2.default.createElement(
	                            'li',
	                            { className: 'left-menu__version' },
	                            '\xA9 ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://www.t1-group.ru' },
	                                '\u0410\u041E \xAB\u0413\u0440\u0443\u043F\u043F\u0430 \u0422-1\xBB'
	                            ),
	                            _react2.default.createElement('br', null),
	                            '2017-2021'
	                        ),
	                        window.RNIS_SETTINGS.CITY_MURMANSK ? _react2.default.createElement(
	                            'li',
	                            { className: 'left-menu__version' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://nashsever51.ru' },
	                                _react2.default.createElement('img', { src: '/static/img/ns.png', alt: '', width: "50px" })
	                            )
	                        ) : null,
	                        window.RNIS_SETTINGS.CITY_MURMANSK ? _react2.default.createElement(
	                            'li',
	                            { className: 'left-menu__version_smut' },
	                            '\u041D\u0430\u0448 \u0421\u0435\u0432\u0435\u0440',
	                            _react2.default.createElement('br', null)
	                        ) : null
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'toggleMenu',
	        value: function toggleMenu(e) {
	            e.preventDefault();
	
	            this.setState({
	                opened: !this.state.opened
	            });
	        }
	    }, {
	        key: 'renderItem',
	        value: function renderItem(item, i) {
	            var link = void 0;
	            if (!item) return;
	
	            if (item.route) {
	                link = _react2.default.createElement(
	                    _reactRouter.Link,
	                    { key: i, className: 'left-menu__link ' + item.class, activeClassName: window.RNIS_SETTINGS.CITY_MURMANSK ? 'active smut' : 'active', to: item.route,
	                        onClick: item.onClick || this.closeAlerts.bind(this) },
	                    item.counter,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'left-menu__text' },
	                        item.text
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'left-menu__title' },
	                        item.text
	                    )
	                );
	            } else if (item.href) {
	                link = _react2.default.createElement(
	                    'a',
	                    { key: i, target: '_blank', className: 'left-menu__link ' + item.class, href: item.href,
	                        onClick: item.onClick || this.closeAlerts.bind(this) },
	                    item.counter,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'left-menu__text' },
	                        item.text
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'left-menu__title' },
	                        item.text
	                    )
	                );
	            } else {
	                link = _react2.default.createElement(
	                    'a',
	                    { key: i, className: 'left-menu__link ' + item.class, href: '#',
	                        onClick: this.openSubmenu.bind(this, item.key) },
	                    item.counter,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'left-menu__text' },
	                        item.text
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'left-menu__title' },
	                        item.text
	                    )
	                );
	            }
	
	            var submenu = null;
	            if (item.submenu) {
	                if (!this.hasSubmenu(item)) {
	                    return null;
	                }
	                var submenuClass = (0, _classnames2.default)('sub-menu', item.key && this.props.submenu.indexOf(item.key) !== -1 ? 'sub-menu_open' : '');
	                submenu = _react2.default.createElement(
	                    'div',
	                    { className: submenuClass },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'left-menu__list' },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'left-menu__item' },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'left-menu__link back', href: '#', onClick: this.closeSubmenu.bind(this) },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'left-menu__text' },
	                                    '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'left-menu__title' },
	                                    '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434'
	                                )
	                            )
	                        ),
	                        item.submenu.map(this.renderItem.bind(this))
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                'li',
	                { key: i, className: (0, _classnames2.default)('left-menu__item', item.superclass) },
	                link,
	                submenu
	            );
	        }
	    }, {
	        key: 'hasSubmenu',
	        value: function hasSubmenu(item) {
	            return (0, _filter3.default)(item.submenu, function (item) {
	                if (!item) return false;
	                if (!item.permission) {
	                    return true;
	                }
	                return true;
	            }).length > 0;
	        }
	    }, {
	        key: 'closeAlerts',
	        value: function closeAlerts() {
	            alerts.close();
	        }
	    }, {
	        key: 'openSubmenu',
	        value: function openSubmenu(submenuKey, e) {
	            e.preventDefault();
	            this.props.openSubmenu(submenuKey);
	        }
	    }, {
	        key: 'closeSubmenu',
	        value: function closeSubmenu(e) {
	            e.preventDefault();
	            this.props.closeSubmenu();
	        }
	    }]);
	
	    return LeftSide;
	}(_react.Component)) || _class) || _class) || _class);
	exports.default = LeftSide;

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _first2 = __webpack_require__(114);
	
	var _first3 = _interopRequireDefault(_first2);
	
	var _indexOf2 = __webpack_require__(225);
	
	var _indexOf3 = _interopRequireDefault(_indexOf2);
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _sortBy2 = __webpack_require__(137);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _uniqBy2 = __webpack_require__(1286);
	
	var _uniqBy3 = _interopRequireDefault(_uniqBy2);
	
	var _slice2 = __webpack_require__(1282);
	
	var _slice3 = _interopRequireDefault(_slice2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(1097);
	
	var _searchField = __webpack_require__(769);
	
	var _searchField2 = _interopRequireDefault(_searchField);
	
	var _reactRedux = __webpack_require__(17);
	
	var _textField = __webpack_require__(188);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	__webpack_require__(1148);
	
	__webpack_require__(1068);
	
	var _geocoding = __webpack_require__(150);
	
	var _debounce = __webpack_require__(247);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _mapZoomButton = __webpack_require__(372);
	
	var _mapZoomButton2 = _interopRequireDefault(_mapZoomButton);
	
	var _routes = __webpack_require__(151);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapSearch = (_dec = (0, _reactPropsDecorators.propTypes)({
	    onClick: _propTypes2.default.func.isRequired,
	    map: _propTypes2.default.object.isRequired
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({}), _dec3 = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { searchAddress: _geocoding.searchAddress, getStopPointsWithBounds: _routes.getStopPointsWithBounds }), _dec(_class = _dec2(_class = _dec3(_class = function (_Component) {
	    _inherits(MapSearch, _Component);
	
	    function MapSearch() {
	        var _ref, _context;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MapSearch);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapSearch.__proto__ || Object.getPrototypeOf(MapSearch)).call.apply(_ref, [this].concat(args))), _this), _this.suggestAddressDebounce = (0, _debounce2.default)(500, (_context = _this).suggestAddress.bind(_context)), _this.state = {
	            collapsed: false,
	            hasResult: false,
	            suggests: [],
	            activeSuggest: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MapSearch, [{
	        key: 'render',
	        value: function render() {
	            var toggleBtnText = this.state.collapsed ? _react2.default.createElement(
	                'span',
	                null,
	                '\u2193 \u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C'
	            ) : _react2.default.createElement(
	                'span',
	                null,
	                '\u2191 \u0421\u043A\u0440\u044B\u0442\u044C'
	            );
	
	            var results = null;
	            if (this.state.suggests.length > 0) {
	                results = _react2.default.createElement(
	                    'div',
	                    { className: 'results' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'toggle-btn', onClick: this.toggleClick.bind(this) },
	                        toggleBtnText
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'list' },
	                        this.state.collapsed ? null : this.state.suggests.map(this.renderItem.bind(this))
	                    )
	                );
	            } else if (this.state.hasResult) {
	                results = _react2.default.createElement(
	                    'div',
	                    { className: 'results' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'list' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'list-item inactive' },
	                            '\u041F\u043E\u0438\u0441\u043A \u043D\u0435 \u0434\u0430\u043B \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432'
	                        )
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'MapSearch' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'f-search f-search-posit visible' },
	                        _react2.default.createElement(
	                            'form',
	                            { action: '#' },
	                            _react2.default.createElement(_textField2.default, { placeholder: '\u041F\u043E\u0438\u0441\u043A', withoutWrapper: true, className: 'f-search__pole', ref: 'input',
	                                onChange: this.suggestAddressDebounce.bind(this),
	                                onEnter: this.onClick.bind(this) }),
	                            _react2.default.createElement('input', { className: 'f-search__button', type: 'button', onClick: this.onClick.bind(this) }),
	                            this.state.activeSuggest ? _react2.default.createElement(_mapZoomButton2.default, { type: 'closest', tooltip: '\u0411\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438',
	                                onClick: this.loadClosest.bind(this) }) : null
	                        )
	                    ),
	                    results
	                )
	            );
	        }
	    }, {
	        key: 'loadClosest',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var point, bounds, boundingBox, response, stopPointTitles, filtered, stopPoints;
	                return regeneratorRuntime.wrap(function _callee$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                point = new _leaflet2.default.latLng(this.state.activeSuggest.latitude, this.state.activeSuggest.longitude);
	                                bounds = point.toBounds(2000);
	                                boundingBox = {
	                                    left_top: {
	                                        latitude: bounds.getNorth(),
	                                        longitude: bounds.getEast()
	                                    },
	                                    right_bottom: {
	                                        latitude: bounds.getSouth(),
	                                        longitude: bounds.getWest()
	                                    }
	                                };
	                                _context2.next = 5;
	                                return this.props.getStopPointsWithBounds(boundingBox, this.props.zoom);
	
	                            case 5:
	                                response = _context2.sent;
	
	
	                                if (response.isOk) {
	                                    stopPointTitles = (0, _map3.default)((0, _slice3.default)((0, _uniqBy3.default)((0, _sortBy3.default)(response.payload.items, function (item) {
	                                        var itemPoint = new _leaflet2.default.latLng(item.latitude, item.longitude);
	
	                                        return itemPoint.distanceTo(point);
	                                    }), 'title'), 0, 5), 'title');
	                                    filtered = (0, _filter3.default)(response.payload.items, function (item) {
	                                        return (0, _indexOf3.default)(stopPointTitles, item.title) !== -1;
	                                    });
	                                    stopPoints = (0, _map3.default)((0, _slice3.default)((0, _uniqBy3.default)((0, _sortBy3.default)(filtered, function (item) {
	                                        var itemPoint = new _leaflet2.default.latLng(item.latitude, item.longitude);
	
	                                        return itemPoint.distanceTo(point);
	                                    }), 'title'), 0, 5), 'uuid');
	
	
	                                    this.props.setSearchStopPoints((0, _map3.default)(filtered, function (item) {
	                                        item.permanent = (0, _indexOf3.default)(stopPoints, item.uuid) !== -1;
	
	                                        return item;
	                                    }));
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 7:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function loadClosest() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadClosest;
	        }()
	    }, {
	        key: 'onClick',
	        value: function onClick() {
	            var first = (0, _first3.default)(this.state.suggests);
	            if (!first) {
	                return;
	            }
	
	            this.setState({
	                activeSuggest: first
	            });
	            this.props.onClick(first);
	        }
	    }, {
	        key: 'suggestAddress',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var input, bounds, boundingBox, response;
	                return regeneratorRuntime.wrap(function _callee2$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                input = this.refs.input.getValue();
	
	                                if (input) {
	                                    _context3.next = 5;
	                                    break;
	                                }
	
	                                this.setState({
	                                    collapsed: false,
	                                    hasResult: false,
	                                    suggests: [],
	                                    activeSuggest: null
	                                });
	                                this.props.setSearchStopPoints([]);
	                                return _context3.abrupt('return');
	
	                            case 5:
	                                bounds = this.props.map.getBounds();
	                                boundingBox = {
	                                    left: bounds.getNorth(),
	                                    top: bounds.getEast(),
	                                    right: bounds.getSouth(),
	                                    bottom: bounds.getWest()
	                                };
	                                _context3.next = 9;
	                                return this.props.searchAddress(input, boundingBox, this.props.zoom);
	
	                            case 9:
	                                response = _context3.sent;
	
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        suggests: (0, _sortBy3.default)((0, _map3.default)(response.payload.items, function (item) {
	                                            return {
	                                                value: item.name,
	                                                label: item.name,
	                                                latitude: item.coordinates.latitude,
	                                                longitude: item.coordinates.longitude
	                                            };
	                                        }), 'label'),
	                                        hasResult: true
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 11:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function suggestAddress() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return suggestAddress;
	        }()
	    }, {
	        key: 'renderItem',
	        value: function renderItem(item, index) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'list-item', key: index, onClick: this.onItemClick.bind(this, item) },
	                item.label
	            );
	        }
	    }, {
	        key: 'onItemClick',
	        value: function onItemClick(object) {
	            this.setState({
	                activeSuggest: object
	            });
	            this.props.onClick(object);
	        }
	    }, {
	        key: 'expand',
	        value: function expand() {
	            this.setState({ collapsed: false });
	        }
	    }, {
	        key: 'collapse',
	        value: function collapse() {
	            this.setState({ collapsed: true });
	        }
	    }, {
	        key: 'toggleClick',
	        value: function toggleClick() {
	            this.state.collapsed ? this.expand() : this.collapse();
	        }
	    }]);
	
	    return MapSearch;
	}(_react.Component)) || _class) || _class) || _class);
	exports.default = MapSearch;

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _keys2 = __webpack_require__(70);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _omit2 = __webpack_require__(1276);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1098);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapVehicleClusterIcon = (_dec = (0, _reactPropsDecorators.propTypes)({
	    info: _propTypes2.default.object.isRequired
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(MapVehicleClusterIcon, _Component);
	
	    function MapVehicleClusterIcon() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MapVehicleClusterIcon);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapVehicleClusterIcon.__proto__ || Object.getPrototypeOf(MapVehicleClusterIcon)).call.apply(_ref, [this].concat(args))), _this), _this.sizeClassNames = {
	            1: 'sector_size_onehundred',
	            2: 'sector_size_fifty',
	            3: 'sector_size_thirtythree',
	            4: 'sector_size_twentyfive',
	            5: 'sector_size_twenty'
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MapVehicleClusterIcon, [{
	        key: 'render',
	        value: function render() {
	            var info = (0, _omit3.default)(this.props.info, ['id', 'devices']);
	
	            var sizeClassName = this.sizeClassNames[(0, _keys3.default)(info).length];
	
	            var sectors = (0, _map3.default)(info, function (count, type) {
	                var className = (0, _classnames2.default)('sector', sizeClassName, 'sector_type_' + type);
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: className, key: type },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'sector__slice' },
	                        _react2.default.createElement('div', { className: 'sector__content' })
	                    )
	                );
	            });
	
	            var sectorsInfo = (0, _map3.default)(info, function (count, type) {
	                var className = (0, _classnames2.default)('sector', sizeClassName);
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: className, key: type },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sector__value' },
	                        count
	                    )
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cluster__sectors' },
	                    sectors
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cluster__info' },
	                    sectorsInfo
	                )
	            );
	        }
	    }]);
	
	    return MapVehicleClusterIcon;
	}(_react.Component)) || _class) || _class);
	exports.default = MapVehicleClusterIcon;

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _first2 = __webpack_require__(114);
	
	var _first3 = _interopRequireDefault(_first2);
	
	var _concat2 = __webpack_require__(506);
	
	var _concat3 = _interopRequireDefault(_concat2);
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _set2 = __webpack_require__(230);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _toInteger2 = __webpack_require__(91);
	
	var _toInteger3 = _interopRequireDefault(_toInteger2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _sortBy2 = __webpack_require__(137);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _cloneDeep2 = __webpack_require__(223);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _reactLoaders = __webpack_require__(693);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _server = __webpack_require__(94);
	
	var _server2 = _interopRequireDefault(_server);
	
	__webpack_require__(464);
	
	__webpack_require__(448);
	
	__webpack_require__(447);
	
	__webpack_require__(1147);
	
	__webpack_require__(1067);
	
	__webpack_require__(1069);
	
	__webpack_require__(1149);
	
	__webpack_require__(1101);
	
	var _reactRedux = __webpack_require__(17);
	
	var _mapZoomButton = __webpack_require__(372);
	
	var _mapZoomButton2 = _interopRequireDefault(_mapZoomButton);
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	var _geocoding = __webpack_require__(150);
	
	var _debounce = __webpack_require__(247);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _mapVehicleIcon = __webpack_require__(97);
	
	var _mapVehicleIcon2 = _interopRequireDefault(_mapVehicleIcon);
	
	var _button = __webpack_require__(149);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(1146);
	
	var _sweetalert = __webpack_require__(724);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _index = __webpack_require__(759);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _routingMarker = __webpack_require__(768);
	
	var _routingMarker2 = _interopRequireDefault(_routingMarker);
	
	var _index3 = __webpack_require__(758);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _geojson = __webpack_require__(254);
	
	var _geojson2 = _interopRequireDefault(_geojson);
	
	var _stopPointMarker = __webpack_require__(375);
	
	var _stopPointMarker2 = _interopRequireDefault(_stopPointMarker);
	
	var _globalLoader = __webpack_require__(27);
	
	var _globalLoader2 = _interopRequireDefault(_globalLoader);
	
	var _functions = __webpack_require__(189);
	
	var _routes = __webpack_require__(151);
	
	var _mapSearch = __webpack_require__(755);
	
	var _mapSearch2 = _interopRequireDefault(_mapSearch);
	
	var _historyPointMarker = __webpack_require__(762);
	
	var _historyPointMarker2 = _interopRequireDefault(_historyPointMarker);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var payload = {
	    "from": {
	        "address": '\u041C\u043E\u0441\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B., \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u0441\u043A\u0438\u0439 \u0440-\u043D, \u0433. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E, \u0448. \u041C\u043E\u0436\u0430\u0439\u0441\u043A\u043E\u0435, \u0434. 136\u0410',
	        "latitude": 55.684165654195,
	        "longitude": 37.310256958008
	    },
	    "to": {
	        "address": '\u041C\u043E\u0441\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B., \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u0441\u043A\u0438\u0439 \u0440-\u043D, \u0433. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E, \u0443\u043B. \u0422\u0440\u0438\u0443\u043C\u0444\u0430\u043B\u044C\u043D\u0430\u044F, \u0434. 1\u0410',
	        "latitude": 55.658221394811,
	        "longitude": 37.234725952148
	    },
	    "items": [{
	        "distance_total": 7388,
	        "distance_walk": 1376,
	        "time": 32,
	        "departure_time": "20:46",
	        "arrive_time": "21:18",
	        "segments": [{
	            "distance": 528,
	            "time": 7,
	            "mode": "walk",
	            "start_at": "20:46",
	            "end_at": "20:52",
	            "stop_points": [{ "name": '\u041E\u0442\u043F\u0440\u0430\u0432\u043D\u0430\u044F \u0442\u043E\u0447\u043A\u0430' }, {
	                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043C\u043E\u043D\u043E\u0432\u043E',
	                "latitude": 55.687211,
	                "longitude": 37.310902
	            }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.31016, 55.68413], [37.30975, 55.68447], [37.30943, 55.68486], [37.30919, 55.68517], [37.30888, 55.68551], [37.30812, 55.68619], [37.30811, 55.6862], [37.30811, 55.6862], [37.30811, 55.6862], [37.30802, 55.68628], [37.30775, 55.68654], [37.30769, 55.6866], [37.30805, 55.68666], [37.30862, 55.68676], [37.30964, 55.68694], [37.31014, 55.68705], [37.31067, 55.68713], [37.31088, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716]]
	            }
	        }, {
	            "distance": 2799,
	            "time": 7,
	            "mode": "bus",
	            "route_uuid": "a8db86fa-eb89-11e7-a2ab-439f4af8ccf7",
	            "route_number": "003",
	            "start_at": "20:53",
	            "end_at": "21:00",
	            "stop_points": [{
	                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043C\u043E\u043D\u043E\u0432\u043E',
	                "latitude": 55.687211,
	                "longitude": 37.310902
	            }, {
	                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
	                "name": '\u0428\u043A\u043E\u043B\u0430 \u0418\u0441\u043A\u0443\u0441\u0441\u0442\u0432',
	                "latitude": 55.685643,
	                "longitude": 37.302287
	            }, {
	                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
	                "name": '\u041D\u043E\u0432\u044B\u0435 \u0434\u043E\u043C\u0430',
	                "latitude": 55.684297,
	                "longitude": 37.296936
	            }, {
	                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
	                "name": '\u0413\u0440\u0435\u0431\u043D\u0451\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.68158899,
	                "longitude": 37.290746
	            }, {
	                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
	                "name": '\u0412\u043E\u043A\u0437\u0430\u043B\u044C\u043D\u0430\u044F \u0443\u043B\u0438\u0446\u0430',
	                "latitude": 55.67878299,
	                "longitude": 37.283718
	            }, {
	                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
	                "name": '\u0414\u0443\u0431\u0440\u0430\u0432\u0430',
	                "latitude": 55.67685699,
	                "longitude": 37.280429
	            }, {
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }],
	            "route_stop_points": [{
	                "uuid": "849a4a32-3bee-11e8-8d7c-02faeaaa1bbe",
	                "name": '\u041D\u043E\u0432\u0430\u044F \u0422\u0440\u0451\u0445\u0433\u043E\u0440\u043A\u0430',
	                "latitude": 55.70419199,
	                "longitude": 37.326826
	            }, {
	                "uuid": "704ae09a-3bea-11e8-ab47-02faeaaa1bbe",
	                "name": '\u041C\u0438\u043A\u0440\u043E\u0440\u0430\u0439\u043E\u043D \u041A\u0443\u0442\u0443\u0437\u043E\u0432\u0441\u043A\u0438\u0439',
	                "latitude": 55.69578499,
	                "longitude": 37.332505
	            }, {
	                "uuid": "6703b5b0-3bf0-11e8-bfad-02faeaaa1bbe",
	                "name": '\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0422\u0440\u0451\u0445\u0433\u043E\u0440\u043A\u0430',
	                "latitude": 55.69487099,
	                "longitude": 37.333876
	            }, {
	                "uuid": "a290721a-3bed-11e8-809e-02faeaaa1bbe",
	                "name": '\u041B\u043E\u0445\u0438\u043D\u043E',
	                "latitude": 55.68999399,
	                "longitude": 37.322677
	            }, {
	                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043C\u043E\u043D\u043E\u0432\u043E',
	                "latitude": 55.68721099,
	                "longitude": 37.310902
	            }, {
	                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
	                "name": '\u0428\u043A\u043E\u043B\u0430 \u0418\u0441\u043A\u0443\u0441\u0441\u0442\u0432',
	                "latitude": 55.68564299,
	                "longitude": 37.302287
	            }, {
	                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
	                "name": '\u041D\u043E\u0432\u044B\u0435 \u0434\u043E\u043C\u0430',
	                "latitude": 55.684297,
	                "longitude": 37.296936
	            }, {
	                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
	                "name": '\u0413\u0440\u0435\u0431\u043D\u0451\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.68158899,
	                "longitude": 37.290746
	            }, {
	                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
	                "name": '\u0412\u043E\u043A\u0437\u0430\u043B\u044C\u043D\u0430\u044F \u0443\u043B\u0438\u0446\u0430',
	                "latitude": 55.67878299,
	                "longitude": 37.283718
	            }, {
	                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
	                "name": '\u0414\u0443\u0431\u0440\u0430\u0432\u0430',
	                "latitude": 55.67685699,
	                "longitude": 37.280429
	            }, {
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.3109, 55.68721], [37.31091, 55.68716], [37.30233, 55.68557], [37.30228, 55.68564], [37.30233, 55.68557], [37.2994, 55.68502], [37.29701, 55.68422], [37.29693, 55.68429], [37.29701, 55.68422], [37.29535, 55.68358], [37.29406, 55.68293], [37.29083, 55.68152], [37.29074, 55.68158], [37.29083, 55.68152], [37.28379, 55.67872], [37.28371, 55.67878], [37.28379, 55.67872], [37.28256, 55.67816], [37.28052, 55.67681], [37.28042, 55.67685], [37.28052, 55.67681], [37.27911, 55.67584], [37.27795, 55.67516], [37.27426, 55.67369], [37.27332, 55.67373], [37.2729, 55.67363], [37.27266, 55.67339], [37.27269, 55.67318], [37.27293, 55.67297], [37.27339, 55.67287], [37.27383, 55.67291], [37.27406, 55.67304], [37.27435, 55.67366], [37.27784, 55.67503], [37.27867, 55.67543], [37.28249, 55.67802], [37.28459, 55.67899], [37.289, 55.67609], [37.28407, 55.67373], [37.28281, 55.67349], [37.28133, 55.67276], [37.28105, 55.67274], [37.2809, 55.67204]]
	            }
	        }, {
	            "distance": 3213,
	            "time": 7,
	            "mode": "bus",
	            "route_uuid": "7beeecb4-eb8d-11e7-af9d-7359ef83c4de",
	            "route_number": "1055",
	            "start_at": "21:00",
	            "end_at": "21:07",
	            "stop_points": [{
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }, {
	                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
	                "name": '\u043A-\u0442 \u0421\u0442\u0440\u043E\u0439\u0438\u043D\u0434\u0443\u0441\u0442\u0440\u0438\u044F',
	                "latitude": 55.671621,
	                "longitude": 37.26823
	            }, {
	                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
	                "name": '\u0423\u0412\u0414',
	                "latitude": 55.67030699,
	                "longitude": 37.263691
	            }, {
	                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
	                "name": '\u041E\u0442\u0440\u0430\u0434\u043D\u043E\u0435',
	                "latitude": 55.666001,
	                "longitude": 37.249983
	            }, {
	                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.66356899,
	                "longitude": 37.24267
	            }, {
	                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u043E',
	                "latitude": 55.66156699,
	                "longitude": 37.234113
	            }],
	            "route_stop_points": [{
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }, {
	                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
	                "name": '\u043A-\u0442 \u0421\u0442\u0440\u043E\u0439\u0438\u043D\u0434\u0443\u0441\u0442\u0440\u0438\u044F',
	                "latitude": 55.671621,
	                "longitude": 37.26823
	            }, {
	                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
	                "name": '\u0423\u0412\u0414',
	                "latitude": 55.67030699,
	                "longitude": 37.263691
	            }, {
	                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
	                "name": '\u041E\u0442\u0440\u0430\u0434\u043D\u043E\u0435',
	                "latitude": 55.666001,
	                "longitude": 37.249983
	            }, {
	                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.66356899,
	                "longitude": 37.24267
	            }, {
	                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u043E',
	                "latitude": 55.66156699,
	                "longitude": 37.234113
	            }, {
	                "uuid": "906985b0-3beb-11e8-9221-02faeaaa1bbe",
	                "name": '\u0414\u0443\u0431\u043A\u0438',
	                "latitude": 55.661,
	                "longitude": 37.2108
	            }, {
	                "uuid": "6dc8ad7e-3bf0-11e8-be0f-02faeaaa1bbe",
	                "name": '\u042E\u0434\u0438\u043D\u043E',
	                "latitude": 55.6588,
	                "longitude": 37.1853
	            }, {
	                "uuid": "ce42d170-3bf0-11e8-af05-02faeaaa1bbe",
	                "name": '\u041A\u0440\u044E\u043A\u043E\u0432\u043E',
	                "latitude": 55.65623099,
	                "longitude": 37.172507
	            }, {
	                "uuid": "54087cc8-3bed-11e8-9e34-02faeaaa1bbe",
	                "name": '\u0411\u043E\u043B\u044C\u043D\u0438\u0446\u0430',
	                "latitude": 55.6538,
	                "longitude": 37.1562
	            }, {
	                "uuid": "e0f30f7c-8658-11e7-a8f8-53404d2ea619",
	                "name": '\u041C\u0430\u0433\u0430\u0437\u0438\u043D',
	                "latitude": 55.65459699,
	                "longitude": 37.141105
	            }, {
	                "uuid": "41e9b474-3bef-11e8-a075-02faeaaa1bbe",
	                "name": '\u0426\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.6557,
	                "longitude": 37.1364
	            }, {
	                "uuid": "e871eb7e-8658-11e7-b334-220e952516f1",
	                "name": '\u041F\u0435\u0440\u0445\u0443\u0448\u043A\u043E\u0432\u043E',
	                "latitude": 55.65836899,
	                "longitude": 37.126763
	            }, {
	                "uuid": "eeaaa1c0-3bed-11e8-8a08-02faeaaa1bbe",
	                "name": '\u0414\u0430\u0447\u0438',
	                "latitude": 55.6581,
	                "longitude": 37.1153
	            }, {
	                "uuid": "e6f5dad2-3bf0-11e8-be1c-02faeaaa1bbe",
	                "name": '\u0416\u0430\u0432\u043E\u0440\u043E\u043D\u043A\u0438 - 2',
	                "latitude": 55.6562,
	                "longitude": 37.099
	            }, {
	                "uuid": "e3cd06d0-8658-11e7-b07f-eda5aa455dd8",
	                "name": '\u041C\u043E\u0436\u0430\u0439\u0441\u043A\u043E\u0435 \u0448\u043E\u0441\u0441\u0435',
	                "latitude": 55.65207999,
	                "longitude": 37.087948
	            }, {
	                "uuid": "520b46bc-3bf2-11e8-9f65-02faeaaa1bbe",
	                "name": '\u0410\u0417\u0421',
	                "latitude": 55.6474,
	                "longitude": 37.0751
	            }, {
	                "uuid": "d966e126-3be7-11e8-ab77-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043B\u044B\u0435 \u0412\u044F\u0437\u0451\u043C\u044B',
	                "latitude": 55.6337,
	                "longitude": 37.0353
	            }, {
	                "uuid": "fd7c2994-8658-11e7-aac9-53f36665a911",
	                "name": '\u0424\u0430\u0431\u0440\u0438\u043A\u0430',
	                "latitude": 55.62986699,
	                "longitude": 37.019303
	            }, {
	                "uuid": "43416950-3bec-11e8-a307-02faeaaa1bbe",
	                "name": '\u0413\u043E\u043B\u0410\u0417',
	                "latitude": 55.6299,
	                "longitude": 37.0109
	            }, {
	                "uuid": "2bc6a828-3bea-11e8-936a-02faeaaa1bbe",
	                "name": '\u041F\u043E\u0441\u0451\u043B\u043E\u043A \u0428\u043A\u043E\u043B\u044C\u043D\u044B\u0439',
	                "latitude": 55.63,
	                "longitude": 37.0042
	            }, {
	                "uuid": "dad8ee36-8658-11e7-8b14-007cfa75f777",
	                "name": '\u0418\u043D\u0441\u0442\u0438\u0442\u0443\u0442',
	                "latitude": 55.62993599,
	                "longitude": 36.996558
	            }, {
	                "uuid": "9ff4629a-3bee-11e8-abaf-02faeaaa1bbe",
	                "name": '\u0411\u043E\u043B\u044C\u0448\u0438\u0435 \u0412\u044F\u0437\u0451\u043C\u044B',
	                "latitude": 55.629522316794,
	                "longitude": 36.985355615616
	            }, {
	                "uuid": "b999cb88-3be7-11e8-95e9-02faeaaa1bbe",
	                "name": '\u0414\u0435\u0432\u044F\u0442\u043A\u0438',
	                "latitude": 55.6205,
	                "longitude": 36.9848
	            }, {
	                "uuid": "4561fe66-865c-11e7-bc80-be4b3dc833bf",
	                "name": '\u0421\u0442.\u0413\u043E\u043B\u0438\u0446\u044B\u043D\u043E',
	                "latitude": 55.616398861671,
	                "longitude": 36.988785842394
	            }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.2809, 55.67204], [37.28105, 55.67274], [37.27963, 55.67369], [37.27775, 55.67509], [37.27252, 55.67294], [37.26827, 55.67156], [37.26823, 55.67162], [37.26827, 55.67156], [37.26379, 55.67019], [37.26369, 55.6703], [37.26379, 55.67019], [37.2585, 55.6687], [37.25007, 55.66591], [37.24998, 55.666], [37.25007, 55.66591], [37.24275, 55.66347], [37.24266, 55.66356], [37.24275, 55.66347], [37.23893, 55.66229], [37.23416, 55.66147], [37.23411, 55.66156]]
	            }
	        }, {
	            "distance": 848,
	            "time": 11,
	            "mode": "walk",
	            "start_at": "21:07",
	            "end_at": "21:18",
	            "stop_points": [{
	                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u043E',
	                "latitude": 55.66156699,
	                "longitude": 37.234113
	            }, { "name": '\u041A\u043E\u043D\u0435\u0447\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442' }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.23416, 55.66147], [37.23489, 55.66159], [37.23489, 55.66159], [37.23523, 55.66165], [37.23756, 55.66204], [37.23807, 55.66123], [37.23809, 55.66109], [37.23813, 55.66081], [37.23815, 55.66051], [37.23813, 55.66036], [37.23783, 55.65959], [37.23628, 55.65943], [37.2361, 55.6594], [37.23603, 55.65936], [37.23598, 55.6593], [37.23596, 55.65921], [37.236, 55.65885], [37.236, 55.65883], [37.236, 55.65883], [37.23604, 55.65844], [37.23607, 55.65805], [37.23539, 55.65803], [37.23475, 55.658]]
	            }
	        }]
	    }, {
	        "distance_total": 7388,
	        "distance_walk": 1376,
	        "time": 43,
	        "departure_time": "21:15",
	        "arrive_time": "21:58",
	        "segments": [{
	            "distance": 528,
	            "time": 7,
	            "mode": "walk",
	            "start_at": "21:15",
	            "end_at": "21:21",
	            "stop_points": [{ "name": '\u041E\u0442\u043F\u0440\u0430\u0432\u043D\u0430\u044F \u0442\u043E\u0447\u043A\u0430' }, {
	                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043C\u043E\u043D\u043E\u0432\u043E',
	                "latitude": 55.687211,
	                "longitude": 37.310902
	            }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.31016, 55.68413], [37.30975, 55.68447], [37.30943, 55.68486], [37.30919, 55.68517], [37.30888, 55.68551], [37.30812, 55.68619], [37.30811, 55.6862], [37.30811, 55.6862], [37.30811, 55.6862], [37.30802, 55.68628], [37.30775, 55.68654], [37.30769, 55.6866], [37.30805, 55.68666], [37.30862, 55.68676], [37.30964, 55.68694], [37.31014, 55.68705], [37.31067, 55.68713], [37.31088, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716]]
	            }
	        }, {
	            "distance": 2799,
	            "time": 11,
	            "mode": "bus",
	            "route_uuid": "a8db86fa-eb89-11e7-a2ab-439f4af8ccf7",
	            "route_number": "003",
	            "start_at": "21:22",
	            "end_at": "21:33",
	            "stop_points": [{
	                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043C\u043E\u043D\u043E\u0432\u043E',
	                "latitude": 55.687211,
	                "longitude": 37.310902
	            }, {
	                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
	                "name": '\u0428\u043A\u043E\u043B\u0430 \u0418\u0441\u043A\u0443\u0441\u0441\u0442\u0432',
	                "latitude": 55.685643,
	                "longitude": 37.302287
	            }, {
	                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
	                "name": '\u041D\u043E\u0432\u044B\u0435 \u0434\u043E\u043C\u0430',
	                "latitude": 55.684297,
	                "longitude": 37.296936
	            }, {
	                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
	                "name": '\u0413\u0440\u0435\u0431\u043D\u0451\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.68158899,
	                "longitude": 37.290746
	            }, {
	                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
	                "name": '\u0412\u043E\u043A\u0437\u0430\u043B\u044C\u043D\u0430\u044F \u0443\u043B\u0438\u0446\u0430',
	                "latitude": 55.67878299,
	                "longitude": 37.283718
	            }, {
	                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
	                "name": '\u0414\u0443\u0431\u0440\u0430\u0432\u0430',
	                "latitude": 55.67685699,
	                "longitude": 37.280429
	            }, {
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }],
	            "route_stop_points": [{
	                "uuid": "f2e7f80e-3bee-11e8-be46-02faeaaa1bbe",
	                "name": '\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0422\u0440\u0451\u0445\u0433\u043E\u0440\u043A\u0430',
	                "latitude": 55.69487199,
	                "longitude": 37.334856
	            }, {
	                "uuid": "6703b5b0-3bf0-11e8-bfad-02faeaaa1bbe",
	                "name": '\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0422\u0440\u0451\u0445\u0433\u043E\u0440\u043A\u0430',
	                "latitude": 55.69487099,
	                "longitude": 37.333876
	            }, {
	                "uuid": "a290721a-3bed-11e8-809e-02faeaaa1bbe",
	                "name": '\u041B\u043E\u0445\u0438\u043D\u043E',
	                "latitude": 55.68999399,
	                "longitude": 37.322677
	            }, {
	                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043C\u043E\u043D\u043E\u0432\u043E',
	                "latitude": 55.68721099,
	                "longitude": 37.310902
	            }, {
	                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
	                "name": '\u0428\u043A\u043E\u043B\u0430 \u0418\u0441\u043A\u0443\u0441\u0441\u0442\u0432',
	                "latitude": 55.68564299,
	                "longitude": 37.302287
	            }, {
	                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
	                "name": '\u041D\u043E\u0432\u044B\u0435 \u0434\u043E\u043C\u0430',
	                "latitude": 55.684297,
	                "longitude": 37.296936
	            }, {
	                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
	                "name": '\u0413\u0440\u0435\u0431\u043D\u0451\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.68158899,
	                "longitude": 37.290746
	            }, {
	                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
	                "name": '\u0412\u043E\u043A\u0437\u0430\u043B\u044C\u043D\u0430\u044F \u0443\u043B\u0438\u0446\u0430',
	                "latitude": 55.67878299,
	                "longitude": 37.283718
	            }, {
	                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
	                "name": '\u0414\u0443\u0431\u0440\u0430\u0432\u0430',
	                "latitude": 55.67685699,
	                "longitude": 37.280429
	            }, {
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.3109, 55.68721], [37.31091, 55.68716], [37.30233, 55.68557], [37.30228, 55.68564], [37.30233, 55.68557], [37.2994, 55.68502], [37.29701, 55.68422], [37.29693, 55.68429], [37.29701, 55.68422], [37.29535, 55.68358], [37.29406, 55.68293], [37.29083, 55.68152], [37.29074, 55.68158], [37.29083, 55.68152], [37.28379, 55.67872], [37.28371, 55.67878], [37.28379, 55.67872], [37.28256, 55.67816], [37.28052, 55.67681], [37.28042, 55.67685], [37.28052, 55.67681], [37.27911, 55.67584], [37.27795, 55.67516], [37.27426, 55.67369], [37.27332, 55.67373], [37.2729, 55.67363], [37.27266, 55.67339], [37.27269, 55.67318], [37.27293, 55.67297], [37.27339, 55.67287], [37.27383, 55.67291], [37.27406, 55.67304], [37.27435, 55.67366], [37.27784, 55.67503], [37.27867, 55.67543], [37.28249, 55.67802], [37.28459, 55.67899], [37.289, 55.67609], [37.28407, 55.67373], [37.28281, 55.67349], [37.28133, 55.67276], [37.28105, 55.67274], [37.2809, 55.67204]]
	            }
	        }, {
	            "distance": 3213,
	            "time": 7,
	            "mode": "bus",
	            "route_uuid": "7beeecb4-eb8d-11e7-af9d-7359ef83c4de",
	            "route_number": "1055",
	            "start_at": "21:40",
	            "end_at": "21:47",
	            "stop_points": [{
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }, {
	                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
	                "name": '\u043A-\u0442 \u0421\u0442\u0440\u043E\u0439\u0438\u043D\u0434\u0443\u0441\u0442\u0440\u0438\u044F',
	                "latitude": 55.671621,
	                "longitude": 37.26823
	            }, {
	                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
	                "name": '\u0423\u0412\u0414',
	                "latitude": 55.67030699,
	                "longitude": 37.263691
	            }, {
	                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
	                "name": '\u041E\u0442\u0440\u0430\u0434\u043D\u043E\u0435',
	                "latitude": 55.666001,
	                "longitude": 37.249983
	            }, {
	                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.66356899,
	                "longitude": 37.24267
	            }, {
	                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u043E',
	                "latitude": 55.66156699,
	                "longitude": 37.234113
	            }],
	            "route_stop_points": [{
	                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
	                "name": '\u0441\u0442. \u041E\u0434\u0438\u043D\u0446\u043E\u0432\u043E',
	                "latitude": 55.6720448283,
	                "longitude": 37.28090270056
	            }, {
	                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
	                "name": '\u043A-\u0442 \u0421\u0442\u0440\u043E\u0439\u0438\u043D\u0434\u0443\u0441\u0442\u0440\u0438\u044F',
	                "latitude": 55.671621,
	                "longitude": 37.26823
	            }, {
	                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
	                "name": '\u0423\u0412\u0414',
	                "latitude": 55.67030699,
	                "longitude": 37.263691
	            }, {
	                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
	                "name": '\u041E\u0442\u0440\u0430\u0434\u043D\u043E\u0435',
	                "latitude": 55.666001,
	                "longitude": 37.249983
	            }, {
	                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u0441\u043A\u0430\u044F \u0446\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.66356899,
	                "longitude": 37.24267
	            }, {
	                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u043E',
	                "latitude": 55.66156699,
	                "longitude": 37.234113
	            }, {
	                "uuid": "906985b0-3beb-11e8-9221-02faeaaa1bbe",
	                "name": '\u0414\u0443\u0431\u043A\u0438',
	                "latitude": 55.661,
	                "longitude": 37.2108
	            }, {
	                "uuid": "6dc8ad7e-3bf0-11e8-be0f-02faeaaa1bbe",
	                "name": '\u042E\u0434\u0438\u043D\u043E',
	                "latitude": 55.6588,
	                "longitude": 37.1853
	            }, {
	                "uuid": "ce42d170-3bf0-11e8-af05-02faeaaa1bbe",
	                "name": '\u041A\u0440\u044E\u043A\u043E\u0432\u043E',
	                "latitude": 55.65623099,
	                "longitude": 37.172507
	            }, {
	                "uuid": "54087cc8-3bed-11e8-9e34-02faeaaa1bbe",
	                "name": '\u0411\u043E\u043B\u044C\u043D\u0438\u0446\u0430',
	                "latitude": 55.6538,
	                "longitude": 37.1562
	            }, {
	                "uuid": "e0f30f7c-8658-11e7-a8f8-53404d2ea619",
	                "name": '\u041C\u0430\u0433\u0430\u0437\u0438\u043D',
	                "latitude": 55.65459699,
	                "longitude": 37.141105
	            }, {
	                "uuid": "41e9b474-3bef-11e8-a075-02faeaaa1bbe",
	                "name": '\u0426\u0435\u0440\u043A\u043E\u0432\u044C',
	                "latitude": 55.6557,
	                "longitude": 37.1364
	            }, {
	                "uuid": "e871eb7e-8658-11e7-b334-220e952516f1",
	                "name": '\u041F\u0435\u0440\u0445\u0443\u0448\u043A\u043E\u0432\u043E',
	                "latitude": 55.65836899,
	                "longitude": 37.126763
	            }, {
	                "uuid": "eeaaa1c0-3bed-11e8-8a08-02faeaaa1bbe",
	                "name": '\u0414\u0430\u0447\u0438',
	                "latitude": 55.6581,
	                "longitude": 37.1153
	            }, {
	                "uuid": "e6f5dad2-3bf0-11e8-be1c-02faeaaa1bbe",
	                "name": '\u0416\u0430\u0432\u043E\u0440\u043E\u043D\u043A\u0438 - 2',
	                "latitude": 55.6562,
	                "longitude": 37.099
	            }, {
	                "uuid": "e3cd06d0-8658-11e7-b07f-eda5aa455dd8",
	                "name": '\u041C\u043E\u0436\u0430\u0439\u0441\u043A\u043E\u0435 \u0448\u043E\u0441\u0441\u0435',
	                "latitude": 55.65207999,
	                "longitude": 37.087948
	            }, {
	                "uuid": "520b46bc-3bf2-11e8-9f65-02faeaaa1bbe",
	                "name": '\u0410\u0417\u0421',
	                "latitude": 55.6474,
	                "longitude": 37.0751
	            }, {
	                "uuid": "d966e126-3be7-11e8-ab77-02faeaaa1bbe",
	                "name": '\u041C\u0430\u043B\u044B\u0435 \u0412\u044F\u0437\u0451\u043C\u044B',
	                "latitude": 55.6337,
	                "longitude": 37.0353
	            }, {
	                "uuid": "fd7c2994-8658-11e7-aac9-53f36665a911",
	                "name": '\u0424\u0430\u0431\u0440\u0438\u043A\u0430',
	                "latitude": 55.62986699,
	                "longitude": 37.019303
	            }, {
	                "uuid": "43416950-3bec-11e8-a307-02faeaaa1bbe",
	                "name": '\u0413\u043E\u043B\u0410\u0417',
	                "latitude": 55.6299,
	                "longitude": 37.0109
	            }, {
	                "uuid": "2bc6a828-3bea-11e8-936a-02faeaaa1bbe",
	                "name": '\u041F\u043E\u0441\u0451\u043B\u043E\u043A \u0428\u043A\u043E\u043B\u044C\u043D\u044B\u0439',
	                "latitude": 55.63,
	                "longitude": 37.0042
	            }, {
	                "uuid": "dad8ee36-8658-11e7-8b14-007cfa75f777",
	                "name": '\u0418\u043D\u0441\u0442\u0438\u0442\u0443\u0442',
	                "latitude": 55.62993599,
	                "longitude": 36.996558
	            }, {
	                "uuid": "9ff4629a-3bee-11e8-abaf-02faeaaa1bbe",
	                "name": '\u0411\u043E\u043B\u044C\u0448\u0438\u0435 \u0412\u044F\u0437\u0451\u043C\u044B',
	                "latitude": 55.629522316794,
	                "longitude": 36.985355615616
	            }, {
	                "uuid": "b999cb88-3be7-11e8-95e9-02faeaaa1bbe",
	                "name": '\u0414\u0435\u0432\u044F\u0442\u043A\u0438',
	                "latitude": 55.6205,
	                "longitude": 36.9848
	            }, {
	                "uuid": "4561fe66-865c-11e7-bc80-be4b3dc833bf",
	                "name": '\u0421\u0442.\u0413\u043E\u043B\u0438\u0446\u044B\u043D\u043E',
	                "latitude": 55.616398861671,
	                "longitude": 36.988785842394
	            }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.2809, 55.67204], [37.28105, 55.67274], [37.27963, 55.67369], [37.27775, 55.67509], [37.27252, 55.67294], [37.26827, 55.67156], [37.26823, 55.67162], [37.26827, 55.67156], [37.26379, 55.67019], [37.26369, 55.6703], [37.26379, 55.67019], [37.2585, 55.6687], [37.25007, 55.66591], [37.24998, 55.666], [37.25007, 55.66591], [37.24275, 55.66347], [37.24266, 55.66356], [37.24275, 55.66347], [37.23893, 55.66229], [37.23416, 55.66147], [37.23411, 55.66156]]
	            }
	        }, {
	            "distance": 848,
	            "time": 11,
	            "mode": "walk",
	            "start_at": "21:47",
	            "end_at": "21:58",
	            "stop_points": [{
	                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
	                "name": '\u0410\u043A\u0443\u043B\u043E\u0432\u043E',
	                "latitude": 55.66156699,
	                "longitude": 37.234113
	            }, { "name": '\u041A\u043E\u043D\u0435\u0447\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442' }],
	            "geometry": {
	                "type": "LineString",
	                "coordinates": [[37.23416, 55.66147], [37.23489, 55.66159], [37.23489, 55.66159], [37.23523, 55.66165], [37.23756, 55.66204], [37.23807, 55.66123], [37.23809, 55.66109], [37.23813, 55.66081], [37.23815, 55.66051], [37.23813, 55.66036], [37.23783, 55.65959], [37.23628, 55.65943], [37.2361, 55.6594], [37.23603, 55.65936], [37.23598, 55.6593], [37.23596, 55.65921], [37.236, 55.65885], [37.236, 55.65883], [37.236, 55.65883], [37.23604, 55.65844], [37.23607, 55.65805], [37.23539, 55.65803], [37.23475, 55.658]]
	            }
	        }]
	    }]
	};
	
	var MapComponent = (_dec = (0, _reactPropsDecorators.propTypes)({
	    showLayers: _propTypes2.default.bool,
	    withRouting: _propTypes2.default.bool,
	    showSearch: _propTypes2.default.bool,
	    layers: _propTypes2.default.array,
	    onZoom: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    showLayers: true,
	    withRouting: false,
	    showSearch: true,
	    layers: [],
	    onZoom: function onZoom() {}
	}), _dec3 = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { geocode: _geocoding.geocode, reverseGeocode: _geocoding.reverseGeocode, searchAddress: _geocoding.searchAddress, routing: _geocoding.routing, getClosestStopPoint: _routes.getClosestStopPoint }, null, { withRef: true }), _dec(_class = _dec2(_class = _dec3(_class = function (_Component) {
	    _inherits(MapComponent, _Component);
	
	    function MapComponent() {
	        var _ref, _context;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MapComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapComponent.__proto__ || Object.getPrototypeOf(MapComponent)).call.apply(_ref, [this].concat(args))), _this), _this.defaultRouting = {
	            date: (0, _moment2.default)(),
	            time: (0, _moment2.default)().format(_formats2.default.TIME),
	            max_time: '04:00',
	            max_transfers: 2,
	            walk_reluctance: 2,
	            is_wheelchair: false,
	            mode_bus: true,
	            mode_tram: true,
	            mode_train: true,
	            mode_subway: true,
	            from: {
	                latitude: null,
	                longitude: null,
	                address: ''
	            },
	            to: {
	                latitude: null,
	                longitude: null,
	                address: ''
	            },
	            transit: []
	        }, _this.geocodeDebounce = (0, _debounce2.default)(500, (_context = _this).geocode.bind(_context)), _this.suggestAddressDebounce = (0, _debounce2.default)(500, (_context = _this).suggestAddress.bind(_context)), _this.state = {
	            loading: false,
	            routingActive: false,
	            routingResultActive: false,
	            routing: (0, _cloneDeep3.default)(_this.defaultRouting),
	            routingResult: null,
	            activeRoutingResultItem: 0,
	            activeSegment: null,
	            activeSearchMarker: null,
	            searchStopPoints: []
	        }, _this.map = null, _this.objectsLayer = null, _this.mapSearchObjectsLayer = null, _this.locateBtn = null, _this.measureBtn = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MapComponent, [{
	        key: 'tilePath',
	        value: function tilePath(tile) {
	            return window.RNIS_SETTINGS.OSMDEFAULTLAYER ? tile.s + '.tile.openstreetmap.org/' + tile.z + '/' + tile.x + '/' + tile.y + '.png' : (tile.z + '00' + (1000000000 + tile.x).toString().substr(1) + (1000000000 + tile.y).toString().substr(1)).replace(/^(\d{1,2})00(\d{3})(\d{3})(\d{3})(\d{3})(\d{3})(\d{3})/, '$1/00/$2/$3/$4/$5/$6/$7');
	        }
	
	        // тайлы новосибирска
	
	    }, {
	        key: 'arcgisTilePath',
	        value: function arcgisTilePath(tile) {
	            return 'maps.nso.ru/arcgis3/rest/services/Common/BASEMAP_BIPD/MapServer/tile/' + tile.z + '/' + tile.y + '/' + tile.x;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.init();
	
	            setTimeout(function () {
	                _this2.map.invalidateSize();
	            }, 500);
	
	            setTimeout(function () {
	                _this2.map.invalidateSize();
	            }, 1500);
	        }
	    }, {
	        key: 'isMosreg',
	        value: function isMosreg() {
	            return (/\.mosreg.ru$/.test(window.location.hostname)
	            );
	        }
	    }, {
	        key: 'isNso',
	        value: function isNso() {
	            return (/\.nso.ru$/.test(window.location.hostname)
	            );
	        }
	    }, {
	        key: 'isLocalhost',
	        value: function isLocalhost() {
	            return (/localhost$/.test(window.location.hostname)
	            );
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            var osmDelault = window.RNIS_SETTINGS.OSMDEFAULTLAYER !== undefined ? window.RNIS_SETTINGS.OSMDEFAULTLAYER : false;
	            //const osmUrl = (/\.mosreg.ru$/.test(window.location.hostname)) ? '//portal.rnis.mosreg.ru/g-map/lv{path}.png' : 'http://95.181.199.194/g-map/lv{path}.png';
	            var osmUrl = osmDelault ? 'http://{path}' : window.location.protocol + '//portal.rnis.mosreg.ru/g-map/lv{path}.png';
	
	            this.osmLayer = new _leaflet2.default.TileLayer(osmUrl, {
	                path: this.tilePath,
	                maxZoom: 19,
	                minZoom: 3,
	                tms: !window.RNIS_SETTINGS.OSMDEFAULTLAYER,
	                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	            });
	
	            this.arcgisLayer = new _leaflet2.default.TileLayer(osmUrl, {
	                path: this.arcgisTilePath,
	                maxZoom: 19,
	                minZoom: 3,
	                tms: !window.RNIS_SETTINGS.OSMDEFAULTLAYER
	            });
	
	            /* const osmLayer = new L.TileLayer(osmUrl, {
	                 path: this.tilePath,
	                 maxZoom: 19,
	                 minZoom: 3,
	                 tms: !window.RNIS_SETTINGS.OSMDEFAULTLAYER
	             });*/
	
	            _leaflet2.default.Icon.Default.imagePath = '/static/img/vendor/leaflet/';
	            var center = void 0;
	            var zoom = void 0;
	            if (window.RNIS_SETTINGS.CITY_MURMANSK) {
	                center = new _leaflet2.default.LatLng(68.9629, 33.0831);
	                zoom = 5;
	            } else {
	                zoom = 11;
	                if (window.RNIS_SETTINGS.MAPCENTER) {
	                    center = new _leaflet2.default.LatLng(window.RNIS_SETTINGS.MAPCENTER.LAT, window.RNIS_SETTINGS.MAPCENTER.LON);
	                } else {
	                    center = new _leaflet2.default.LatLng(55.753559, 37.609218);
	                }
	            }
	
	            this.map = new _leaflet2.default.map(this.refs.container, {
	                center: center,
	                //path: this.tilePath,
	                zoom: zoom,
	                maxZoom: 17,
	                minZoom: 3,
	                preferCanvas: false,
	                layers: this.isNso() ? [this.arcgisLayer] : [this.osmLayer],
	                zoomControl: false
	            });
	
	            if (this.isNso()) {
	                var layers = {
	                    'РГИС НСО': this.arcgisLayer,
	                    'OpenStreetMap': this.osmLayer
	                };
	
	                !this.isNso() && delete layers['РГИС НСО'];
	
	                _leaflet2.default.control.layers(layers).addTo(this.map);
	            }
	
	            this.locateBtn = _leaflet2.default.control.locate({
	                position: 'topright',
	                onLocationError: function onLocationError(err) {
	                    alerts.error('Ошибка определения местоположения.');
	                },
	                showPopup: false,
	                strings: {
	                    title: 'Определить местоположение'
	                }
	            });
	            this.locateBtn.addTo(this.map);
	
	            this.map.on('click', this.onMapClick.bind(this));
	            this.map.on('mousemove', this.onMapMouseMove.bind(this));
	
	            this.measureBtn = _leaflet2.default.control.polylineMeasure();
	            this.measureBtn.addTo(this.map);
	
	            this.map.on('moveend', this.onZoom.bind(this));
	            this.map.on('zoomend', this.onZoomChange.bind(this));
	
	            this.objectsLayer = new _leaflet2.default.layerGroup().addTo(this.map);
	            this.mapSearchObjectsLayer = new _leaflet2.default.layerGroup().addTo(this.map);
	
	            this.setState({ map: this.map });
	        }
	    }, {
	        key: 'getBoundingBox',
	        value: function getBoundingBox() {
	            var map = this.map;
	
	            var bounds = map.getBounds();
	
	            if (window.RNIS_SETTINGS.CITY_MURMANSK) {
	                var latlngs = [[70.8806, 27.6681], [65.6981, 29.4259], [65.8245, 44.1036], [70.9812, 40.0607], [70.8806, 27.6681]];
	                var polygon = _leaflet2.default.polygon(latlngs, {});
	                if (!polygon.getBounds().contains(bounds)) {
	                    return {
	                        left_top: {
	                            latitude: 69.94537515,
	                            longitude: 27.90527344
	                        },
	                        right_bottom: {
	                            latitude: 65.73062649,
	                            longitude: 41.69311523
	                        }
	                    };
	                } else {
	                    return {
	                        left_top: {
	                            latitude: bounds.getNorth(),
	                            longitude: bounds.getEast()
	                        },
	                        right_bottom: {
	                            latitude: bounds.getSouth(),
	                            longitude: bounds.getWest()
	                        }
	                    };
	                }
	            }
	
	            return {
	                left_top: {
	                    latitude: bounds.getNorth(),
	                    longitude: bounds.getEast()
	                },
	                right_bottom: {
	                    latitude: bounds.getSouth(),
	                    longitude: bounds.getWest()
	                }
	            };
	        }
	    }, {
	        key: 'getMapSize',
	        value: function getMapSize() {
	            var map = this.map;
	
	            var size = map.getSize();
	            return {
	                width: size.x,
	                height: size.y
	            };
	        }
	    }, {
	        key: 'getZoom',
	        value: function getZoom() {
	            return this.map.getZoom();
	        }
	    }, {
	        key: 'onZoom',
	        value: function onZoom() {
	            this.props.onZoom();
	        }
	    }, {
	        key: 'onZoomChange',
	        value: function onZoomChange(e) {
	            this.forceUpdate();
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(props, state) {
	            this.renderUserGeoObjects(props.userGeoObjects);
	            this.renderMapSearchObjects(props.mapSearchObjects);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var mapSearch = this.map && !window.RNIS_SETTINGS.CITY_MURMANSK ? _react2.default.createElement(_mapSearch2.default, { onClick: this.onSuggestClick.bind(this), map: this.map, zoom: this.getZoom(),
	                setSearchStopPoints: this.setSearchStopPoints.bind(this) }) : null;
	            var mapZoomControls = this.map ? _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('leaflet-map-zoom-buttons', {
	                        'routing-active': this.state.routingActive,
	                        'routing-result-active': this.state.routingResultActive
	                    }) },
	                _react2.default.createElement(_mapZoomButton2.default, { type: 'in', onClick: this.zoomIn.bind(this) }),
	                _react2.default.createElement(_mapZoomButton2.default, { type: 'out', onClick: this.zoomOut.bind(this) }),
	                !window.RNIS_SETTINGS.CITY_MURMANSK ? _react2.default.createElement(_mapZoomButton2.default, { type: 'locate', onClick: this.locate.bind(this), tooltip: '\u041C\u043E\u0451 \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435' }) : null,
	                !location.pathname.includes('map/road') && _react2.default.createElement(_mapZoomButton2.default, { type: 'measure', onClick: this.measure.bind(this), tooltip: '\u041B\u0438\u043D\u0435\u0439\u043A\u0430' }),
	                this.props.withRouting ? _react2.default.createElement(_mapZoomButton2.default, { type: 'routing', onClick: this.routing.bind(this), tooltip: '\u041F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442' }) : null
	            ) : null;
	            var routingControls = this.state.routingActive && !this.state.routingResultActive ? _react2.default.createElement(_index2.default, {
	                ref: 'routing',
	                onClose: this.closeRouting.bind(this),
	                data: this.state.routing,
	                onChange: this.onRoutingChange.bind(this),
	                routingFocus: this.routingFocus.bind(this),
	                startRouting: this.startRouting.bind(this),
	                suggestAddress: this.suggestAddress.bind(this)
	            }) : null;
	            var routingResultControls = this.state.routingActive && this.state.routingResultActive ? _react2.default.createElement(_index4.default, {
	                ref: 'routing-results',
	                onClose: this.closeRouting.bind(this),
	                data: this.state.routingResult,
	                onRoutingConfigure: this.onRoutingConfigure.bind(this),
	                onRoutingReset: this.onRoutingReset.bind(this),
	                activeRoutingResultItem: this.state.activeRoutingResultItem,
	                setActiveRoutingResultItem: this.setActiveRoutingResultItem.bind(this),
	                activeSegment: this.state.activeSegment,
	                setActiveSegment: this.setActiveSegment.bind(this)
	            }) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('leaflet-map', this.map ? 'zoom-' + this.map.getZoom() : '', {
	                        'routing-result-active': this.state.routingResultActive
	                    }) },
	                this.state.loading ? _react2.default.createElement(_globalLoader2.default, null) : null,
	                mapSearch,
	                mapZoomControls,
	                routingControls,
	                routingResultControls,
	                _react2.default.createElement('div', { className: 'map-container', ref: 'container' }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' } },
	                    this.renderRoutingRequestMarkers(),
	                    this.renderRoutingResult(),
	                    this.props.children,
	                    this.renderActiveSearch(),
	                    this.renderSearchStopPoints()
	                )
	            );
	        }
	    }, {
	        key: 'setActiveRoutingResultItem',
	        value: function setActiveRoutingResultItem(index) {
	            if (index < 0) {
	                index = this.state.routingResult.items.length - 1;
	            }
	            if (index >= this.state.routingResult.items.length) {
	                index = 0;
	            }
	            this.setState({
	                activeRoutingResultItem: index
	            });
	        }
	    }, {
	        key: 'suggestAddress',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(input, callback) {
	                var bounds, boundingBox, response;
	                return regeneratorRuntime.wrap(function _callee$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (input) {
	                                    _context2.next = 3;
	                                    break;
	                                }
	
	                                callback(null, {
	                                    options: [],
	                                    complete: false
	                                });
	                                return _context2.abrupt('return');
	
	                            case 3:
	                                bounds = this.map.getBounds();
	                                boundingBox = {
	                                    left: bounds.getNorth(),
	                                    top: bounds.getEast(),
	                                    right: bounds.getSouth(),
	                                    bottom: bounds.getWest()
	                                };
	                                _context2.next = 7;
	                                return this.props.searchAddress(input, boundingBox, this.getZoom());
	
	                            case 7:
	                                response = _context2.sent;
	
	
	                                if (response.isOk) {
	                                    callback(null, {
	                                        options: (0, _sortBy3.default)((0, _map3.default)(response.payload.items, function (item) {
	                                            return {
	                                                value: item.name,
	                                                label: item.name,
	                                                latitude: item.coordinates.latitude,
	                                                longitude: item.coordinates.longitude,
	                                                address: item.address
	                                            };
	                                        }), 'label'),
	                                        complete: false
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 9:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function suggestAddress(_x, _x2) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return suggestAddress;
	        }()
	    }, {
	        key: 'onRoutingConfigure',
	        value: function onRoutingConfigure() {
	            this.setState({
	                routingResultActive: false
	            });
	        }
	    }, {
	        key: 'onRoutingReset',
	        value: function onRoutingReset() {
	            this.setState({
	                routingResultActive: false,
	                routing: (0, _cloneDeep3.default)(this.defaultRouting)
	            });
	        }
	    }, {
	        key: 'onRoutingChange',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(field, value) {
	                var ignore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	                var routing, addressMatches;
	                return regeneratorRuntime.wrap(function _callee2$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                if (field === 'max_transfers') {
	                                    value = (0, _toInteger3.default)(value);
	                                }
	
	                                routing = this.state.routing;
	
	                                (0, _set3.default)(routing, field, value);
	                                _context3.next = 5;
	                                return this.setState({ routing: routing });
	
	                            case 5:
	                                if (!ignore) {
	                                    _context3.next = 7;
	                                    break;
	                                }
	
	                                return _context3.abrupt('return');
	
	                            case 7:
	                                addressMatches = /^(.+)\.address$/.exec(field);
	
	                                if (addressMatches) {
	                                    this.geocodeDebounce(addressMatches[1]);
	                                }
	
	                            case 9:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onRoutingChange(_x3, _x4) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return onRoutingChange;
	        }()
	    }, {
	        key: 'geocode',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(focusRoute) {
	                var bounds, boundingBox, response;
	                return regeneratorRuntime.wrap(function _callee3$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                bounds = this.map.getBounds();
	                                boundingBox = {
	                                    left: bounds.getNorth(),
	                                    top: bounds.getEast(),
	                                    right: bounds.getSouth(),
	                                    bottom: bounds.getWest()
	                                };
	                                _context4.next = 4;
	                                return this.props.geocode((0, _get3.default)(this.state.routing, focusRoute + '.address'), boundingBox, this.getZoom());
	
	                            case 4:
	                                response = _context4.sent;
	
	                                if (response.isOk) {
	                                    this.onRoutingChange(focusRoute + '.latitude', response.payload.coordinates.latitude);
	                                    this.onRoutingChange(focusRoute + '.longitude', response.payload.coordinates.longitude);
	                                }
	
	                            case 6:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function geocode(_x6) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return geocode;
	        }()
	    }, {
	        key: 'routingFocus',
	        value: function routingFocus(focusRoute, lat, lon) {
	            this.setState({ focusRoute: focusRoute });
	            if (lat && lat) {
	                this.reverseGeocode(lat, lon, 'from');
	            }
	        }
	
	        // handleClearRoutingFocus = () => {
	        //     this.setState({focusRoute: null});
	        // }
	
	    }, {
	        key: 'onMapClick',
	        value: function onMapClick(e) {
	            if (!this.state.routingActive || !this.state.focusRoute) {
	                return;
	            }
	            if (/transit/.test(this.state.focusRoute)) {
	                this.findClosestStopPoint(e.latlng.lat, e.latlng.lng);
	                return;
	            }
	
	            this.reverseGeocode(e.latlng.lat, e.latlng.lng, this.state.focusRoute);
	            this.setState({
	                focusRoute: null
	            });
	        }
	    }, {
	        key: 'findClosestStopPoint',
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(latitude, longitude) {
	                var response, stopPoint;
	                return regeneratorRuntime.wrap(function _callee4$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return this.props.getClosestStopPoint(latitude, longitude);
	
	                            case 2:
	                                response = _context5.sent;
	
	
	                                if (response.isOk) {
	                                    stopPoint = response.payload;
	
	
	                                    this.onRoutingChange(this.state.focusRoute + '.address', stopPoint.title, true);
	                                    this.onRoutingChange(this.state.focusRoute + '.latitude', stopPoint.latitude);
	                                    this.onRoutingChange(this.state.focusRoute + '.longitude', stopPoint.longitude);
	
	                                    this.setState({
	                                        focusRoute: null
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function findClosestStopPoint(_x7, _x8) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return findClosestStopPoint;
	        }()
	    }, {
	        key: 'onStopPointClick',
	        value: function () {
	            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(stopPoint) {
	                return regeneratorRuntime.wrap(function _callee5$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                this.onRoutingChange(this.state.focusRoute + '.address', stopPoint.title, true);
	                                this.onRoutingChange(this.state.focusRoute + '.latitude', stopPoint.latitude);
	                                this.onRoutingChange(this.state.focusRoute + '.longitude', stopPoint.longitude);
	
	                                this.setState({
	                                    focusRoute: null
	                                });
	
	                            case 4:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function onStopPointClick(_x9) {
	                return _ref6.apply(this, arguments);
	            }
	
	            return onStopPointClick;
	        }()
	    }, {
	        key: 'onMapMouseMove',
	        value: function onMapMouseMove(e) {
	            if (!this.state.routingActive || !this.state.focusRoute) {
	                return;
	            }
	
	            this.onRoutingChange(this.state.focusRoute + '.latitude', e.latlng.lat);
	            this.onRoutingChange(this.state.focusRoute + '.longitude', e.latlng.lng);
	        }
	    }, {
	        key: 'onMarkerDragEnd',
	        value: function onMarkerDragEnd(focusRoute, _ref7) {
	            var target = _ref7.target;
	
	            var _target$getLatLng = target.getLatLng(),
	                lat = _target$getLatLng.lat,
	                lng = _target$getLatLng.lng;
	
	            this.onRoutingChange(focusRoute + '.latitude', lat);
	            this.onRoutingChange(focusRoute + '.longitude', lng);
	            this.reverseGeocode(lat, lng, focusRoute);
	        }
	    }, {
	        key: 'reverseGeocode',
	        value: function () {
	            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(latitude, longitude, focusRoute) {
	                var bounds, boundingBox, response;
	                return regeneratorRuntime.wrap(function _callee6$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                this.onRoutingChange(focusRoute + '.latitude', latitude);
	                                this.onRoutingChange(focusRoute + '.longitude', longitude);
	
	                                bounds = this.map.getBounds();
	                                boundingBox = {
	                                    left: bounds.getNorth(),
	                                    top: bounds.getEast(),
	                                    right: bounds.getSouth(),
	                                    bottom: bounds.getWest()
	                                };
	                                _context7.next = 6;
	                                return this.props.reverseGeocode({ latitude: latitude, longitude: longitude }, boundingBox, this.getZoom());
	
	                            case 6:
	                                response = _context7.sent;
	
	                                if (response.isOk) {
	                                    this.onRoutingChange(focusRoute + '.address', response.payload.address, true);
	                                }
	                                this.setState({ focusRoute: null });
	
	                            case 9:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function reverseGeocode(_x10, _x11, _x12) {
	                return _ref8.apply(this, arguments);
	            }
	
	            return reverseGeocode;
	        }()
	    }, {
	        key: 'zoomIn',
	        value: function zoomIn() {
	            this.map.setZoom(this.map.getZoom() + 1);
	        }
	    }, {
	        key: 'zoomOut',
	        value: function zoomOut() {
	            this.map.setZoom(this.map.getZoom() - 1);
	        }
	    }, {
	        key: 'locate',
	        value: function locate() {
	            this.locateBtn._onClick();
	            this.measureBtn._disableMeasure();
	        }
	    }, {
	        key: 'measure',
	        value: function measure() {
	            /*this.setState({
	                routingActive: false,
	            });*/
	            this.measureBtn._toggleMeasure();
	        }
	    }, {
	        key: 'routing',
	        value: function () {
	            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	                return regeneratorRuntime.wrap(function _callee7$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                this.measureBtn._disableMeasure();
	
	                                _context8.next = 3;
	                                return this.setState({
	                                    routingActive: !this.state.routingActive
	                                });
	
	                            case 3:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	
	            function routing() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return routing;
	        }()
	    }, {
	        key: 'closeRouting',
	        value: function () {
	            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	                return regeneratorRuntime.wrap(function _callee8$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                _context9.next = 2;
	                                return this.setState({
	                                    routingActive: false,
	                                    routingResultActive: false
	                                });
	
	                            case 2:
	                                if (window.RNIS_SETTINGS.planning_trip_from_to) {
	                                    _context9.next = 5;
	                                    break;
	                                }
	
	                                _context9.next = 5;
	                                return this.setState({
	                                    routing: (0, _cloneDeep3.default)(this.defaultRouting)
	                                });
	
	                            case 5:
	                            case 'end':
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function closeRouting() {
	                return _ref10.apply(this, arguments);
	            }
	
	            return closeRouting;
	        }()
	    }, {
	        key: 'fitBounds',
	        value: function fitBounds(bounds) {
	            this.map.fitBounds(bounds);
	        }
	    }, {
	        key: 'panTo',
	        value: function panTo(coordinates) {
	            this.map.panTo(coordinates);
	        }
	    }, {
	        key: 'flyTo',
	        value: function flyTo(coordinates, zoom) {
	            this.map.flyTo(coordinates, zoom);
	        }
	    }, {
	        key: 'renderUserGeoObjects',
	        value: function renderUserGeoObjects(userGeoObjects) {
	            var _this3 = this;
	
	            this.objectsLayer.clearLayers();
	            (0, _each3.default)(userGeoObjects, function (object) {
	                var geometry = {
	                    type: 'Feature',
	                    geometry: object.geometry
	                };
	                var layer = new _leaflet2.default.GeoJSON(geometry);
	                layer.bindTooltip(object.title, { sticky: true });
	                _this3.objectsLayer.addLayer(layer);
	            });
	        }
	    }, {
	        key: 'renderMapSearchObjects',
	        value: function renderMapSearchObjects(mapSearchObjects) {
	            var _this4 = this;
	
	            this.mapSearchObjectsLayer.clearLayers();
	
	            (0, _each3.default)(mapSearchObjects, function (object) {
	                var geometry = {
	                    type: 'Feature',
	                    geometry: object.geometry
	                };
	                var layer = new _leaflet2.default.GeoJSON(geometry);
	
	                if (object.hint) {
	                    layer.bindTooltip(object.hint, { sticky: true });
	                }
	                if (object.popup) {
	                    layer.bindPopup(object.popup);
	                }
	
	                _this4.mapSearchObjectsLayer.addLayer(layer);
	            });
	        }
	    }, {
	        key: 'renderRoutingRequestMarkers',
	        value: function renderRoutingRequestMarkers() {
	            var _this5 = this;
	
	            if (!this.state.routingActive) {
	                return;
	            }
	
	            var routing = this.state.routing;
	
	            return (0, _concat3.default)([routing.from.latitude && routing.from.longitude ? _react2.default.createElement(_routingMarker2.default, {
	                key: 'from',
	                map: this,
	                leafletMap: this.map,
	                latitude: routing.from.latitude,
	                longitude: routing.from.longitude,
	                type: 'from',
	                onDrag: this.onMarkerDragEnd.bind(this, 'from'),
	                options: {
	                    //interactive: this.state.focusRoute !== 'from',
	                }
	            }) : null, routing.to.latitude && routing.to.longitude ? _react2.default.createElement(_routingMarker2.default, {
	                key: 'to',
	                map: this,
	                leafletMap: this.map,
	                latitude: routing.to.latitude,
	                longitude: routing.to.longitude,
	                type: 'to',
	                onDrag: this.onMarkerDragEnd.bind(this, 'to'),
	                options: {
	                    //interactive: this.state.focusRoute !== 'to',
	                }
	            }) : null], (0, _map3.default)(routing.transit, function (transit, index) {
	                if (transit.latitude && transit.longitude) {
	                    return _react2.default.createElement(_routingMarker2.default, {
	                        key: 'transit:' + index,
	                        map: _this5,
	                        leafletMap: _this5.map,
	                        latitude: transit.latitude,
	                        longitude: transit.longitude,
	                        onDrag: _this5.onMarkerDragEnd.bind(_this5, 'transit.' + index),
	                        options: {
	                            //interactive: this.state.focusRoute !== `transit.${index}`,
	                        }
	                    });
	                }
	
	                return null;
	            }));
	        }
	    }, {
	        key: 'renderRoutingResult',
	        value: function renderRoutingResult() {
	            var _this6 = this;
	
	            if (!this.state.routingActive || !this.state.routingResultActive) {
	                return;
	            }
	            var result = this.state.routingResult;
	            var item = (0, _get3.default)(result.items, this.state.activeRoutingResultItem);
	            if (!item) {
	                return;
	            }
	
	            return (0, _map3.default)(item.segments, function (segment, index) {
	                var isActive = _this6.state.activeSegment === index;
	
	                var from = (0, _first3.default)(segment.geometry.coordinates);
	
	                switch (segment.mode) {
	                    case 'walk':
	                        var tooltip = '<i class="p-result__icon p-result__icon_wh24 p-result__icon_walk"></i> ' + segment.time + '\u043C\u0438\u043D, ' + (0, _functions.formatDistance)(segment.distance);
	                        return [_react2.default.createElement(_geojson2.default, {
	                            key: index,
	                            map: _this6,
	                            leafletMap: _this6.map,
	                            geometry: segment.geometry,
	                            color: '#000000',
	                            weight: isActive ? 8 : 2,
	                            onClick: _this6.setActiveSegment.bind(_this6, index)
	                        }), _react2.default.createElement(_routingMarker2.default, {
	                            key: index + ':from',
	                            map: _this6,
	                            leafletMap: _this6.map,
	                            latitude: from[1],
	                            longitude: from[0],
	                            tooltip: isActive ? '<b>' + tooltip + '</b>' : tooltip,
	                            onClick: _this6.setActiveSegment.bind(_this6, index),
	                            permanentTooltip: true,
	                            zIndex: isActive ? 100 : 10,
	                            options: {
	                                interactive: true,
	                                opacity: 0
	                            }
	                        })];
	                    case 'bus':
	                        var tooltipBus = '<i class="p-result__icon p-result__icon_wh24 p-result__icon_bus"></i> ' + segment.route_number + ', ' + segment.time + '\u043C\u0438\u043D';
	                        return (0, _concat3.default)([_react2.default.createElement(_geojson2.default, {
	                            key: index,
	                            map: _this6,
	                            leafletMap: _this6.map,
	                            geometry: segment.geometry,
	                            color: '#FF0000',
	                            weight: isActive ? 8 : 2,
	                            onClick: _this6.setActiveSegment.bind(_this6, index)
	                        }), _react2.default.createElement(_routingMarker2.default, {
	                            key: index + ':from',
	                            map: _this6,
	                            leafletMap: _this6.map,
	                            latitude: from[1],
	                            longitude: from[0],
	                            tooltip: isActive ? '<b>' + tooltipBus + '</b>' : tooltipBus,
	                            onClick: _this6.setActiveSegment.bind(_this6, index),
	                            permanentTooltip: true,
	                            zIndex: isActive ? 100 : 10,
	                            options: {
	                                interactive: true,
	                                opacity: 0
	                            }
	                        })], (0, _map3.default)(segment.stop_points, function (stopPoint, stopPointIndex) {
	                            if (!isActive && stopPointIndex !== 0) {
	                                return;
	                            }
	                            return _react2.default.createElement(_stopPointMarker2.default, {
	                                key: index + ':' + stopPointIndex,
	                                map: _this6,
	                                leafletMap: _this6.map,
	                                latitude: stopPoint.latitude,
	                                longitude: stopPoint.longitude,
	                                color: 'red',
	                                item: {
	                                    title: stopPointIndex === 0 ? stopPoint.name + ', "' + segment.route_number + '", ' + segment.time + '\u043C\u0438\u043D' : stopPoint.name
	                                },
	                                withoutPopup: true,
	                                zIndex: 9999
	                            });
	                        }));
	                }
	            });
	        }
	    }, {
	        key: 'invalidateSize',
	        value: function () {
	            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	                var _this7 = this;
	
	                return regeneratorRuntime.wrap(function _callee9$(_context10) {
	                    while (1) {
	                        switch (_context10.prev = _context10.next) {
	                            case 0:
	                                _context10.next = 2;
	                                return setTimeout(function () {
	                                    _this7.map.invalidateSize();
	                                }, 500);
	
	                            case 2:
	                            case 'end':
	                                return _context10.stop();
	                        }
	                    }
	                }, _callee9, this);
	            }));
	
	            function invalidateSize() {
	                return _ref11.apply(this, arguments);
	            }
	
	            return invalidateSize;
	        }()
	    }, {
	        key: 'startRouting',
	        value: function () {
	            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
	                var routing, response;
	                return regeneratorRuntime.wrap(function _callee10$(_context11) {
	                    while (1) {
	                        switch (_context11.prev = _context11.next) {
	                            case 0:
	                                this.invalidateSize();
	                                /*await this.setState({
	                                    routingResult: payload,
	                                    routingResultActive: true,
	                                });
	                                console.log('qwe', payload);
	                                return;*/
	
	                                routing = this.state.routing;
	
	                                if (!(!routing.from.latitude || !routing.from.longitude)) {
	                                    _context11.next = 5;
	                                    break;
	                                }
	
	                                alerts.alert('Не задан начальный пункт');
	                                return _context11.abrupt('return');
	
	                            case 5:
	                                if (!(!routing.to.latitude || !routing.to.longitude)) {
	                                    _context11.next = 8;
	                                    break;
	                                }
	
	                                alerts.alert('Не задан конечный пункт');
	                                return _context11.abrupt('return');
	
	                            case 8:
	
	                                this.setState({
	                                    loading: true
	                                });
	
	                                _context11.next = 11;
	                                return this.props.routing({
	                                    from: routing.from,
	                                    to: routing.to,
	                                    transit: routing.transit,
	                                    datetime: (0, _moment2.default)((0, _moment2.default)(routing.date).format(_formats2.default.DATE) + ' ' + routing.time, _formats2.default.DATETIME_SHORT).format(_formats2.default.DATETIME_API),
	                                    max_time: this.timeToInt(routing.max_time),
	                                    max_transfers: routing.max_transfers,
	                                    modes: this.getRoutingModes(),
	                                    walk_reluctance: this.getWalkReluctance(routing.walk_reluctance),
	                                    is_wheelchair: routing.is_wheelchair,
	                                    version: 2
	                                });
	
	                            case 11:
	                                response = _context11.sent;
	
	
	                                this.setState({
	                                    loading: false
	                                });
	
	                                if (!response.isOk) {
	                                    _context11.next = 18;
	                                    break;
	                                }
	
	                                _context11.next = 16;
	                                return this.setState({
	                                    routingResult: this.prepareRouting(response.payload),
	                                    routingResultActive: true
	                                });
	
	                            case 16:
	                                _context11.next = 19;
	                                break;
	
	                            case 18:
	                                response.showErrors();
	
	                            case 19:
	                            case 'end':
	                                return _context11.stop();
	                        }
	                    }
	                }, _callee10, this);
	            }));
	
	            function startRouting() {
	                return _ref12.apply(this, arguments);
	            }
	
	            return startRouting;
	        }()
	    }, {
	        key: 'prepareRouting',
	        value: function prepareRouting(payload) {
	            var _this8 = this;
	
	            var transitIndex = 0;
	
	            payload.items = (0, _map3.default)(payload.items, function (item) {
	                item.segments = (0, _map3.default)(item.segments, function (segment) {
	                    segment.stop_points = (0, _map3.default)(segment.stop_points || [], function (stopPoint) {
	                        if (stopPoint.name === 'Конечный пункт') {
	                            var transit = (0, _get3.default)(_this8.state.routing.transit, transitIndex);
	                            if (transit) {
	                                stopPoint.name = transit.address || '-';
	                                transitIndex++;
	                            }
	                        }
	
	                        return stopPoint;
	                    });
	
	                    return segment;
	                });
	
	                return item;
	            });
	
	            return payload;
	        }
	    }, {
	        key: 'getWalkReluctance',
	        value: function getWalkReluctance(walkReluctance) {
	            switch (walkReluctance) {
	                case 0:
	                    return 16;
	                case 1:
	                    return 4;
	                case 2:
	                    return 2;
	                case 3:
	                    return 1;
	            }
	        }
	    }, {
	        key: 'timeToInt',
	        value: function timeToInt(time) {
	            var timeObject = (0, _moment2.default)(time, _formats2.default.TIME);
	            return timeObject.hours() * 60 + timeObject.minutes();
	        }
	    }, {
	        key: 'getRoutingModes',
	        value: function getRoutingModes() {
	            var modes = [];
	
	            modes.push('WALK');
	            if (this.state.routing.mode_bus) {
	                modes.push('TRANSIT');
	            }
	
	            return modes;
	        }
	    }, {
	        key: 'setActiveSegment',
	        value: function () {
	            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(index) {
	                var segment;
	                return regeneratorRuntime.wrap(function _callee11$(_context12) {
	                    while (1) {
	                        switch (_context12.prev = _context12.next) {
	                            case 0:
	                                _context12.next = 2;
	                                return this.setState({
	                                    activeSegment: this.state.activeSegment !== index ? index : null
	                                });
	
	                            case 2:
	                                segment = (0, _get3.default)(this.state.routingResult, 'items.' + this.state.activeRoutingResultItem + '.segments.' + this.state.activeSegment);
	
	                                if (segment) {
	                                    this.map.fitBounds(new _leaflet2.default.geoJSON(segment.geometry).getBounds(), {
	                                        padding: new _leaflet2.default.point(20, 20)
	                                    });
	                                }
	
	                            case 4:
	                            case 'end':
	                                return _context12.stop();
	                        }
	                    }
	                }, _callee11, this);
	            }));
	
	            function setActiveSegment(_x13) {
	                return _ref13.apply(this, arguments);
	            }
	
	            return setActiveSegment;
	        }()
	    }, {
	        key: 'onSuggestClick',
	        value: function onSuggestClick(object) {
	            this.flyTo({
	                lat: object.latitude,
	                lng: object.longitude
	            }, 16);
	
	            this.setState({
	                activeSearchMarker: object
	            });
	        }
	    }, {
	        key: 'renderActiveSearch',
	        value: function renderActiveSearch() {
	            if (!this.state.activeSearchMarker) {
	                return;
	            }
	
	            return _react2.default.createElement(_historyPointMarker2.default, {
	                map: this,
	                leafletMap: this.map,
	                latitude: this.state.activeSearchMarker.latitude,
	                longitude: this.state.activeSearchMarker.longitude
	            });
	        }
	    }, {
	        key: 'setSearchStopPoints',
	        value: function setSearchStopPoints(stopPoints) {
	            this.setState({
	                searchStopPoints: stopPoints
	            });
	        }
	    }, {
	        key: 'renderSearchStopPoints',
	        value: function renderSearchStopPoints() {
	            var _this9 = this;
	
	            return (0, _map3.default)(this.state.searchStopPoints, function (stopPoint) {
	                return _react2.default.createElement(_stopPointMarker2.default, {
	                    key: stopPoint.uuid,
	                    map: _this9,
	                    leafletMap: _this9.map,
	                    latitude: stopPoint.latitude,
	                    longitude: stopPoint.longitude,
	                    item: stopPoint,
	                    color: 'red',
	                    permanentTooltip: stopPoint.permanent,
	                    onScheduleClick: _this9.onScheduleClick.bind(_this9, stopPoint),
	                    onFromHereClick: _this9.onFromHereClick.bind(_this9, stopPoint),
	                    onToHereClick: _this9.onToHereClick.bind(_this9, stopPoint),
	                    zIndex: 9999
	                });
	            });
	        }
	    }, {
	        key: 'onScheduleClick',
	        value: function onScheduleClick(stopPoint) {
	            this.props.onStopPointScheduleClick(stopPoint);
	        }
	    }, {
	        key: 'onFromHereClick',
	        value: function onFromHereClick(stopPoint) {
	            this.props.onStopPointFromHereClick(stopPoint);
	        }
	    }, {
	        key: 'onToHereClick',
	        value: function onToHereClick(stopPoint) {
	            this.props.onStopPointToHereClick(stopPoint);
	        }
	    }, {
	        key: 'onSearchStopPointClick',
	        value: function onSearchStopPointClick(stopPoint) {
	            this.props.onStopPointClick(stopPoint);
	        }
	    }]);
	
	    return MapComponent;
	}(_react.Component)) || _class) || _class) || _class);
	exports.default = MapComponent;

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _indexOf2 = __webpack_require__(225);
	
	var _indexOf3 = _interopRequireDefault(_indexOf2);
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _last2 = __webpack_require__(228);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _first2 = __webpack_require__(114);
	
	var _first3 = _interopRequireDefault(_first2);
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	__webpack_require__(1102);
	
	var _pageModal = __webpack_require__(257);
	
	var _pageModal2 = _interopRequireDefault(_pageModal);
	
	var _modalTopMenuButtons = __webpack_require__(256);
	
	var _modalTopMenuButtons2 = _interopRequireDefault(_modalTopMenuButtons);
	
	var _modalTopMenuButton = __webpack_require__(255);
	
	var _modalTopMenuButton2 = _interopRequireDefault(_modalTopMenuButton);
	
	var _accordion = __webpack_require__(250);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _accordionItem = __webpack_require__(249);
	
	var _accordionItem2 = _interopRequireDefault(_accordionItem);
	
	var _datepicker = __webpack_require__(185);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _rcSlider = __webpack_require__(659);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	var _rcTooltip = __webpack_require__(336);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(453);
	
	__webpack_require__(454);
	
	var _radio = __webpack_require__(253);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _checkbox = __webpack_require__(252);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _button = __webpack_require__(149);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _reactRedux = __webpack_require__(17);
	
	var _geocoding = __webpack_require__(150);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1122);
	
	var _reactSlick = __webpack_require__(1447);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _functions = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Handle = _rcSlider2.default.Handle;
	
	var RoutingResultModal = (_dec = (0, _reactPropsDecorators.propTypes)({
	    onClose: _propTypes2.default.func.isRequired,
	    data: _propTypes2.default.object
	}), _dec(_class = function (_Component) {
	    _inherits(RoutingResultModal, _Component);
	
	    function RoutingResultModal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RoutingResultModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoutingResultModal.__proto__ || Object.getPrototypeOf(RoutingResultModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            expanded: {
	                up: {},
	                down: {}
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RoutingResultModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            setTimeout(function () {
	                window.dispatchEvent(new Event('resize'));
	            }, 0);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var buttons = _react2.default.createElement(
	                _modalTopMenuButtons2.default,
	                null,
	                _react2.default.createElement(_modalTopMenuButton2.default, {
	                    className: '_close',
	                    onClick: this.props.onClose
	                })
	            );
	
	            var headerText = window.RNIS_SETTINGS.CITY_NOVOSIBIRSK ? 'Планировщик поездки' : 'Планировщик поездки | Тестовая версия';
	
	            return _react2.default.createElement(
	                _pageModal2.default,
	                {
	                    header: { title: headerText, buttons: buttons },
	                    className: 'b-modal-trip-planner-result b-modal_w-footer',
	                    withFade: false,
	                    buttons: this.getButtons() },
	                this.renderContent()
	            );
	        }
	    }, {
	        key: 'getButtons',
	        value: function getButtons() {
	            return [_react2.default.createElement(_button2.default, { key: 'routing-config', size: 'md', color: 'red', text: _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('i', { className: 'arrow-icon arrow-icon_left arrow-icon_white' }),
	                    '\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u043E\u0435\u0437\u0434\u043A\u0438'
	                ), onClick: this.props.onRoutingConfigure }), _react2.default.createElement(_button2.default, { key: 'routing-reset', size: 'md', color: 'red', text: '\u041D\u043E\u0432\u0430\u044F \u043F\u043E\u0435\u0437\u0434\u043A\u0430',
	                onClick: this.props.onRoutingReset })];
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$data = _props.data,
	                from = _props$data.from,
	                to = _props$data.to,
	                items = _props$data.items,
	                activeRoutingResultItem = _props.activeRoutingResultItem;
	
	            var settings = {
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                centerMode: true,
	                infinite: false,
	                focusOnSelect: true,
	                prevArrow: _react2.default.createElement(PrevArrow, null),
	                nextArrow: _react2.default.createElement(NextArrow, null),
	                variableWidth: true,
	                afterChange: function afterChange(index) {
	                    _this2.props.setActiveRoutingResultItem(index);
	                }
	            };
	
	            return _react2.default.createElement(
	                _accordion2.default,
	                null,
	                _react2.default.createElement(
	                    _accordionItem2.default,
	                    { title: '\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F', opened: true, withoutWrapper: true, afterTitle: _react2.default.createElement(
	                            'div',
	                            { className: 'accordion__dscn' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'accordion__route' },
	                                _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_wh20 p-result__icon_start p-result__icon_border' }),
	                                from.address
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'accordion__route' },
	                                _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_wh20 p-result__icon_end p-result__icon_border' }),
	                                to.address
	                            )
	                        ) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'accordion__posit accordion__posit_top-bord' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container-fluid' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'accordion__slider' },
	                                        items.length === 0 ? _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430'
	                                        ) : _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'accordion__display' },
	                                                _react2.default.createElement(
	                                                    _reactSlick2.default,
	                                                    settings,
	                                                    (0, _map3.default)(items, this.renderItem.bind(this))
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                this.renderSegments((0, _get3.default)(items, activeRoutingResultItem))
	            );
	        }
	    }, {
	        key: 'renderItem',
	        value: function renderItem(item, index) {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'accordion__slide' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'p-result' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'p-result__title' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'p-result__num' },
	                            index + 1,
	                            '.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'p-result__path' },
	                            (0, _functions.formatDistance)(item.distance_total),
	                            '/ ',
	                            (0, _functions.formatTime)(item.time)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'p-result__foot' },
	                            _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_wh24 p-result__icon_walk' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'p-result__foot-text' },
	                                (0, _functions.formatDistance)(item.distance_walk)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'p-result__route' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'p-result__zone' },
	                            _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_wh32 p-result__icon_start p-result__icon_border' }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'p-result__zone_start' },
	                                item.departure_time
	                            )
	                        ),
	                        (0, _map3.default)(item.segments, function (segment, segmentIndex) {
	                            return _react2.default.createElement(
	                                'div',
	                                {
	                                    key: segmentIndex,
	                                    className: 'p-result__step d-flex justify-content-center align-items-center' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'p-result__req-time' },
	                                    (0, _functions.formatTime)(segment.time)
	                                ),
	                                _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_white p-result__icon_wh24 p-result__icon_' + segment.mode + ' p-result__icon_border',
	                                    onClick: _this3.setActiveSegment.bind(_this3, segmentIndex) }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'p-result__adding' },
	                                    segment.route_number ? _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '\u0410\u0432\u0442\u043E\u0431\u0443\u0441 ',
	                                        segment.route_number,
	                                        _react2.default.createElement('br', null),
	                                        '\u041F\u043E\u0441\u0430\u0434\u043A\u0430: ',
	                                        segment.start_at
	                                    ) : '' + (0, _functions.formatDistance)(segment.distance)
	                                )
	                            );
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'p-result__zone' },
	                            _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_wh32 p-result__icon_end p-result__icon_border' }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'p-result__zone_start' },
	                                item.arrive_time
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'prevItem',
	        value: function prevItem() {
	            this.props.setActiveRoutingResultItem(this.props.activeRoutingResultItem - 1);
	        }
	    }, {
	        key: 'nextItem',
	        value: function nextItem() {
	            this.props.setActiveRoutingResultItem(this.props.activeRoutingResultItem + 1);
	        }
	    }, {
	        key: 'renderSegments',
	        value: function renderSegments(item) {
	            var _this4 = this;
	
	            if (!item) {
	                return;
	            }
	
	            return (0, _map3.default)(item.segments, function (segment, index) {
	                var nextSegment = (0, _get3.default)(item.segments, index + 1);
	
	                return _this4.renderSegment(segment, nextSegment, index);
	            });
	        }
	    }, {
	        key: 'renderSegment',
	        value: function renderSegment(segment, nextSegment, segmentIndex) {
	            var result = [];
	
	            if (segmentIndex !== this.props.activeSegment) {
	                return;
	            }
	
	            switch (segment.mode) {
	                case 'walk':
	                    result.push(_react2.default.createElement(
	                        _accordionItem2.default,
	                        { key: segmentIndex, title: '\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u043F\u043E\u0435\u0437\u0434\u043A\u0438', opened: true, withoutWrapper: true },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'accordion__posit accordion__posit_top-bord' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'container-fluid' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 't-segment' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__title' },
	                                                _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_walk p-result__icon_wh24' }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: 't-segment__title-text' },
	                                                    '\u041F\u0435\u0440\u0435\u0445\u043E\u0434: ',
	                                                    segment.start_at,
	                                                    '- ',
	                                                    segment.end_at
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__content flex-column' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__content-row d-flex' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-prop' },
	                                                        '\u041E\u0442:'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        {
	                                                            className: 't-segment__content-val' },
	                                                        (0, _get3.default)((0, _first3.default)(segment.stop_points), 'name')
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__content-row d-flex' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-prop' },
	                                                        '\u0414\u043E:'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        {
	                                                            className: 't-segment__content-val' },
	                                                        (0, _get3.default)((0, _last3.default)(segment.stop_points), 'name')
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__content-row d-flex' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-prop' },
	                                                        '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C:'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        {
	                                                            className: 't-segment__content-val' },
	                                                        (0, _functions.formatTime)(segment.time)
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__content-row d-flex' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-prop' },
	                                                        '\u0420\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u0435:'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        {
	                                                            className: 't-segment__content-val' },
	                                                        (0, _functions.formatDistance)(segment.distance)
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ));
	                    break;
	                case 'bus':
	                    var _getRouteStopPoints = this.getRouteStopPoints(segment),
	                        prev = _getRouteStopPoints.prev,
	                        next = _getRouteStopPoints.next;
	
	                    var isFromFirst = (0, _get3.default)((0, _first3.default)(segment.route_stop_points), 'uuid') === (0, _get3.default)((0, _first3.default)(segment.stop_points), 'uuid');
	                    var isToLast = (0, _get3.default)((0, _last3.default)(segment.route_stop_points), 'uuid') === (0, _get3.default)((0, _last3.default)(segment.stop_points), 'uuid');
	
	                    result.push(_react2.default.createElement(
	                        _accordionItem2.default,
	                        { key: segmentIndex, title: '\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u043F\u043E\u0435\u0437\u0434\u043A\u0438', opened: true, withoutWrapper: true },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'accordion__posit accordion__posit_top-bord' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'container-fluid' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 't-segment' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__title' },
	                                                _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_bus p-result__icon_wh24' }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    {
	                                                        className: 't-segment__title-text' },
	                                                    '\u0410\u0432\u0442\u043E\u0431\u0443\u0441 ',
	                                                    segment.route_number
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment__content' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__content-left' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        {
	                                                            className: 't-segment__req-time' },
	                                                        (0, _functions.formatTime)(segment.time)
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__content-right' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__point' },
	                                                        _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_' + (isFromFirst ? 'green' : 'red') + ' p-result__icon_border p-result__icon_wh24' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            {
	                                                                className: 't-segment__point-text' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                {
	                                                                    className: 't-segment__board' },
	                                                                isFromFirst ? '[Посадка] ' : '',
	                                                                (0, _get3.default)((0, _first3.default)(segment.stop_points), 'name'),
	                                                                ' '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                {
	                                                                    className: 't-segment__time' },
	                                                                isFromFirst ? segment.start_at : ''
	                                                            )
	                                                        )
	                                                    ),
	                                                    prev.length > 0 ? _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__stops t-segment__stops-no-active' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__stops-title',
	                                                                onClick: this.toggle.bind(this, 'up', segmentIndex) },
	                                                            _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_rect p-result__icon_wh24' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                {
	                                                                    className: (0, _classnames2.default)('t-segment__stops-title-text', {
	                                                                        collapse: this.state.expanded.up[segmentIndex]
	                                                                    }) },
	                                                                '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043E\u043A: ',
	                                                                prev.length
	                                                            )
	                                                        ),
	                                                        this.state.expanded.up[segmentIndex] ? _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__stops-list' },
	                                                            (0, _map3.default)(prev, function (stopPoint, index) {
	                                                                return _react2.default.createElement(
	                                                                    'div',
	                                                                    {
	                                                                        key: 'prev:' + index,
	                                                                        className: 't-segment__stops-item' },
	                                                                    _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_inner-gray p-result__icon_wh24' }),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        {
	                                                                            className: 't-segment__stops-item-text' },
	                                                                        stopPoint.name
	                                                                    )
	                                                                );
	                                                            })
	                                                        ) : null
	                                                    ) : null,
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__stops' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__stops-list' },
	                                                            (0, _map3.default)(segment.stop_points, function (stopPoint, index) {
	                                                                if (index === 0) {
	                                                                    if (isFromFirst) {
	                                                                        return;
	                                                                    }
	                                                                    return _react2.default.createElement(
	                                                                        'div',
	                                                                        {
	                                                                            key: index,
	                                                                            className: 't-segment__stops-item t-segment__stops-item_bold' },
	                                                                        _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_inner-green p-result__icon_wh24' }),
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            {
	                                                                                className: 't-segment__stops-item-text' },
	                                                                            '[\u041F\u043E\u0441\u0430\u0434\u043A\u0430] ',
	                                                                            _react2.default.createElement(
	                                                                                'span',
	                                                                                null,
	                                                                                stopPoint.name
	                                                                            )
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            {
	                                                                                className: 't-segment__stops-item-time' },
	                                                                            segment.start_at
	                                                                        )
	                                                                    );
	                                                                }
	
	                                                                if (index === segment.stop_points.length - 1) {
	                                                                    if (isToLast) {
	                                                                        return;
	                                                                    }
	                                                                    return _react2.default.createElement(
	                                                                        'div',
	                                                                        {
	                                                                            key: index,
	                                                                            className: 't-segment__stops-item t-segment__stops-item_bold' },
	                                                                        _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_inner-green p-result__icon_wh24' }),
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            { className: 't-segment__stops-item-text' },
	                                                                            '[\u0412\u044B\u0441\u0430\u0434\u043A\u0430] ',
	                                                                            _react2.default.createElement(
	                                                                                'span',
	                                                                                null,
	                                                                                stopPoint.name
	                                                                            )
	                                                                        ),
	                                                                        _react2.default.createElement(
	                                                                            'div',
	                                                                            {
	                                                                                className: 't-segment__stops-item-time' },
	                                                                            segment.end_at
	                                                                        )
	                                                                    );
	                                                                }
	                                                                return _react2.default.createElement(
	                                                                    'div',
	                                                                    {
	                                                                        key: index,
	                                                                        className: 't-segment__stops-item' },
	                                                                    _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_inner-green p-result__icon_wh24' }),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        {
	                                                                            className: 't-segment__stops-item-text' },
	                                                                        stopPoint.name
	                                                                    )
	                                                                );
	                                                            })
	                                                        )
	                                                    ),
	                                                    next.length > 0 ? _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__stops t-segment__stops-no-active' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__stops-title',
	                                                                onClick: this.toggle.bind(this, 'down', segmentIndex) },
	                                                            _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_rect p-result__icon_wh24' }),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                {
	                                                                    className: (0, _classnames2.default)('t-segment__stops-title-text', {
	                                                                        collapse: this.state.expanded.down[segmentIndex]
	                                                                    }) },
	                                                                '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043E\u043A: ',
	                                                                next.length
	                                                            )
	                                                        ),
	                                                        this.state.expanded.down[segmentIndex] ? _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__stops-list' },
	                                                            (0, _map3.default)(next, function (stopPoint, index) {
	                                                                return _react2.default.createElement(
	                                                                    'div',
	                                                                    {
	                                                                        key: 'next:' + index,
	                                                                        className: 't-segment__stops-item' },
	                                                                    _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_inner-gray p-result__icon_wh24' }),
	                                                                    _react2.default.createElement(
	                                                                        'div',
	                                                                        {
	                                                                            className: 't-segment__stops-item-text' },
	                                                                        stopPoint.name
	                                                                    )
	                                                                );
	                                                            })
	                                                        ) : null
	                                                    ) : null,
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__point' },
	                                                        _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_' + (isToLast ? 'green' : 'red') + ' p-result__icon_border p-result__icon_wh24' }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            {
	                                                                className: 't-segment__point-text' },
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                {
	                                                                    className: 't-segment__board' },
	                                                                isToLast ? '[Высадка] ' : '',
	                                                                (0, _get3.default)((0, _last3.default)(segment.route_stop_points), 'name'),
	                                                                ' '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                {
	                                                                    className: 't-segment__time' },
	                                                                isToLast ? segment.end_at : ''
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ));
	                    if (nextSegment && nextSegment.mode === 'bus') {
	                        result.push(_react2.default.createElement(
	                            _accordionItem2.default,
	                            { key: segmentIndex + ':switch', title: '\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u043F\u043E\u0435\u0437\u0434\u043A\u0438', opened: true,
	                                withoutWrapper: true },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'accordion__posit accordion__posit_top-bord' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'container-fluid' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-xs-12' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 't-segment' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__title' },
	                                                    _react2.default.createElement('i', { className: 'p-result__icon p-result__icon_refresh p-result__icon_wh24' }),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        {
	                                                            className: 't-segment__title-text' },
	                                                        '\u041F\u0435\u0440\u0435\u0441\u0430\u0434\u043A\u0430: ',
	                                                        segment.end_at,
	                                                        '- ',
	                                                        nextSegment.start_at
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 't-segment__content flex-column' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-row d-flex' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__content-prop' },
	                                                            '\u0423\u0437\u0435\u043B:'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            {
	                                                                className: 't-segment__content-val' },
	                                                            (0, _get3.default)((0, _last3.default)(segment.stop_points), 'name')
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-row d-flex' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__content-prop' },
	                                                            '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C:'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            {
	                                                                className: 't-segment__content-val' },
	                                                            (0, _functions.formatTime)((0, _moment2.default)(nextSegment.start_at, _formats2.default.TIME).diff((0, _moment2.default)(segment.end_at, _formats2.default.TIME), 'minutes'))
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-row d-flex' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__content-prop' },
	                                                            '\u0421\u0445\u043E\u0434:'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__content-val' },
	                                                            '\u0410\u0432\u0442\u043E\u0431\u0443\u0441 ',
	                                                            segment.route_number
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 't-segment__content-row d-flex' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__content-prop' },
	                                                            '\u041F\u043E\u0441\u0430\u0434\u043A\u0430 \u043D\u0430:'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 't-segment__content-val' },
	                                                            '\u0410\u0432\u0442\u043E\u0431\u0443\u0441 ',
	                                                            nextSegment.route_number
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ));
	                    }
	                    break;
	            }
	            return result;
	        }
	    }, {
	        key: 'toggle',
	        value: function toggle(direction, index) {
	            var expanded = this.state.expanded;
	            expanded[direction][index] = !expanded[direction][index];
	            this.setState({ expanded: expanded });
	        }
	    }, {
	        key: 'getRouteStopPoints',
	        value: function getRouteStopPoints(segment) {
	            var prev = [];
	            var next = [];
	
	            var stopPointsUuids = (0, _map3.default)(segment.stop_points, 'uuid');
	
	            var founded = false;
	            (0, _each3.default)(segment.route_stop_points, function (stopPoint) {
	                if ((0, _indexOf3.default)(stopPointsUuids, stopPoint.uuid) === -1) {
	                    if (founded) {
	                        next.push(stopPoint);
	                    } else {
	                        prev.push(stopPoint);
	                    }
	                } else {
	                    founded = true;
	                }
	            });
	
	            return {
	                prev: prev,
	                next: next
	            };
	        }
	    }, {
	        key: 'setActiveSegment',
	        value: function setActiveSegment(index) {
	            this.props.setActiveSegment(index);
	        }
	    }]);
	
	    return RoutingResultModal;
	}(_react.Component)) || _class);
	exports.default = RoutingResultModal;
	
	
	function NextArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return _react2.default.createElement('div', { className: className + ' accordion__btn accordion__btn_next', style: _extends({}, style),
	        onClick: onClick });
	}
	
	function PrevArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return _react2.default.createElement('div', { className: className + ' accordion__btn accordion__btn_prev', style: _extends({}, style),
	        onClick: onClick });
	}

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _padStart2 = __webpack_require__(327);
	
	var _padStart3 = _interopRequireDefault(_padStart2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	__webpack_require__(1103);
	
	var _pageModal = __webpack_require__(257);
	
	var _pageModal2 = _interopRequireDefault(_pageModal);
	
	var _modalTopMenuButtons = __webpack_require__(256);
	
	var _modalTopMenuButtons2 = _interopRequireDefault(_modalTopMenuButtons);
	
	var _modalTopMenuButton = __webpack_require__(255);
	
	var _modalTopMenuButton2 = _interopRequireDefault(_modalTopMenuButton);
	
	var _accordion = __webpack_require__(250);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _accordionItem = __webpack_require__(249);
	
	var _accordionItem2 = _interopRequireDefault(_accordionItem);
	
	var _datepicker = __webpack_require__(185);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _rcSlider = __webpack_require__(659);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	var _rcTooltip = __webpack_require__(336);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	__webpack_require__(453);
	
	__webpack_require__(454);
	
	var _radio = __webpack_require__(253);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _checkbox = __webpack_require__(252);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _button = __webpack_require__(149);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _reactRedux = __webpack_require__(17);
	
	var _geocoding = __webpack_require__(150);
	
	var _select = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Handle = _rcSlider2.default.Handle;
	
	var optionRender = function optionRender(data) {
	    return '' + data.value + (data.address ? ', ' + data.address : '');
	};
	
	var RoutingModal = (_dec = (0, _reactPropsDecorators.propTypes)({
	    onClose: _propTypes2.default.func.isRequired,
	    data: _propTypes2.default.object
	}), _dec(_class = function (_Component) {
	    _inherits(RoutingModal, _Component);
	
	    function RoutingModal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RoutingModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoutingModal.__proto__ || Object.getPrototypeOf(RoutingModal)).call.apply(_ref, [this].concat(args))), _this), _this.walkReluctances = ['По возможности исключить', 'Минимизировать', 'Без предпочтений', 'Преимущественно пешком'], _this.state = {
	            userPosition: {}
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RoutingModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!window.RNIS_SETTINGS.planning_trip_from_to) {
	                this.getLocation();
	            }
	
	            /*if (this.props.data.from.latitude) {
	                this.props.routingFocus('from', );
	            }*/
	        }
	    }, {
	        key: 'geoLocationSuccess',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(position) {
	                var latitude, longitude;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                latitude = position.coords.latitude;
	                                longitude = position.coords.longitude;
	
	                                this.props.routingFocus('from', latitude, longitude);
	
	                            case 3:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function geoLocationSuccess(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return geoLocationSuccess;
	        }()
	    }, {
	        key: 'geoLocationError',
	        value: function geoLocationError() {
	            console.log('Невозможно определить местоположение');
	        }
	    }, {
	        key: 'getLocation',
	        value: function getLocation() {
	            if (!navigator.geolocation) {
	                this.status.textContent = 'Определение местоположениея не поддерживается вашим браузером';
	            } else {
	                navigator.geolocation.getCurrentPosition(this.geoLocationSuccess.bind(this), this.geoLocationError);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var buttons = _react2.default.createElement(
	                _modalTopMenuButtons2.default,
	                null,
	                _react2.default.createElement(_modalTopMenuButton2.default, {
	                    className: '_close',
	                    onClick: this.props.onClose
	                })
	            );
	
	            return _react2.default.createElement(
	                _pageModal2.default,
	                {
	                    header: { title: 'Планировщик поездки', buttons: buttons },
	                    className: 'b-modal-trip-planner-params b-modal_w-footer',
	                    withFade: false,
	                    buttons: this.getRoutingButton() },
	                this.renderContent()
	            );
	        }
	    }, {
	        key: 'getRoutingButton',
	        value: function getRoutingButton() {
	            return [_react2.default.createElement(_button2.default, { key: 'routing', size: 'md', color: 'red', text: '\u041F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442', onClick: this.props.startRouting })];
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(e) {
	            if (e.keyCode === 13) {
	                this.props.startRouting();
	            }
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	
	            return _react2.default.createElement(
	                _accordion2.default,
	                { onKeyUp: this.onKeyUp.bind(this) },
	                _react2.default.createElement(
	                    _accordionItem2.default,
	                    { title: '\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0442\u043E\u0447\u043A\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430',
	                        opened: true,
	                        afterTitle: _react2.default.createElement(
	                            'div',
	                            { className: 'accordion__menu' },
	                            _react2.default.createElement('div', {
	                                className: 'accordion__link accordion__link_icon accordion__link_icon_reverse',
	                                onClick: this.reversePoints.bind(this) })
	                        ) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__title' },
	                                    '\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__text' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'mappicker' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'input' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input__wrapper' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_select.SelectAsync, {
	                                                        value: this.props.data.from.address,
	                                                        onChange: this.onAddressChange.bind(this, 'from.address'),
	                                                        loadOptions: this.props.suggestAddress,
	                                                        options: this.props.data.from.address ? [{
	                                                            value: this.props.data.from.address,
	                                                            label: this.props.data.from.address
	                                                        }] : null,
	                                                        optionRenderer: optionRender
	
	                                                    }),
	                                                    _react2.default.createElement('a', { className: 'rnis-icon rnis-icon_big rnis-icon_map',
	                                                        href: 'javascript:void(0)',
	                                                        onClick: this.focusMapOn.bind(this, 'from') })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__title' },
	                                    '\u041A\u043E\u043D\u0435\u0447\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__text' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'mappicker' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'input' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input__wrapper' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(_select.SelectAsync, {
	                                                        value: this.props.data.to.address,
	                                                        onChange: this.onAddressChange.bind(this, 'to.address'),
	                                                        loadOptions: this.props.suggestAddress,
	                                                        options: this.props.data.to.address ? [{
	                                                            value: this.props.data.to.address,
	                                                            label: this.props.data.to.address
	                                                        }] : null,
	                                                        optionRenderer: optionRender
	                                                    }),
	                                                    _react2.default.createElement('a', { className: 'rnis-icon rnis-icon_big rnis-icon_map',
	                                                        href: 'javascript:void(0)',
	                                                        onClick: this.focusMapOn.bind(this, 'to') })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'accordion__title' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0422\u0440\u0430\u043D\u0437\u0438\u0442\u043D\u044B\u0435 \u043F\u0443\u043D\u043A\u0442\u044B'
	                                )
	                            ),
	                            (0, _map3.default)(this.props.data.transit, this.renderTransit.bind(this)),
	                            this.props.data.transit.length === 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 outer-indent-bottom' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'add-point',
	                                        onClick: this.addTransit.bind(this) },
	                                    '+ \u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C'
	                                )
	                            ) : null
	                        ),
	                        _react2.default.createElement('hr', null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'accordion__title' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0414\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F:'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-3 expand-right' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__text' },
	                                    _react2.default.createElement(_datepicker2.default, {
	                                        value: this.props.data.date,
	                                        onChange: this.onChange.bind(this, 'date')
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-9' },
	                                _react2.default.createElement(_rcSlider2.default, {
	                                    value: this.timeToInt(this.props.data.time) < this.timeToInt('03:00') ? this.timeToInt(this.props.data.time) + 60 * 24 : this.timeToInt(this.props.data.time),
	                                    min: this.timeToInt('03:00'),
	                                    max: this.timeToInt('02:50') + 60 * 24,
	                                    step: 10,
	                                    marks: this.getSliderMarks(this.timeToInt('03:00'), this.timeToInt('03:00') + 60 * 24),
	                                    handle: this.getSliderHandle.bind(this),
	                                    onChange: this.onCurrentTimeChange.bind(this, 'time'),
	                                    className: 'mos-widget__row'
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _accordionItem2.default,
	                    { title: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F', opened: true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row outer-indent-bottom' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-3' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__title' },
	                                    '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C, \u0447\u0430\u0441'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-9' },
	                                _react2.default.createElement(_rcSlider2.default, {
	                                    value: this.timeToInt(this.props.data.max_time),
	                                    min: this.timeToInt('00:00'),
	                                    max: this.timeToInt('04:00'),
	                                    step: 10,
	                                    marks: this.getSliderMarks(this.timeToInt('00:00'), this.timeToInt('04:00'), 30),
	                                    handle: this.getSliderHandle.bind(this),
	                                    onChange: this.onCurrentTimeChange.bind(this, 'max_time'),
	                                    className: 'mos-widget__row'
	                                })
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'row outer-indent-bottom' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row outer-indent-bottom custom' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-3' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__title' },
	                                    '\u041F\u0435\u0448\u0438\u0435 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u044B'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-9' },
	                                _react2.default.createElement(_rcSlider2.default, {
	                                    value: this.props.data.walk_reluctance,
	                                    min: 0,
	                                    max: 3,
	                                    step: 1,
	                                    marks: this.walkReluctances,
	                                    handle: this.getSliderHandle2.bind(this),
	                                    onChange: this.onReluctanceChange.bind(this, 'walk_reluctance'),
	                                    className: 'mos-widget__row'
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-3' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'b-block__title' },
	                                    '\u0414\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0441 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u043C\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-9' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'd-flex b-checkbox-wrap' },
	                                    _react2.default.createElement(_checkbox2.default, {
	                                        checked: this.props.data.is_wheelchair,
	                                        label: '',
	                                        onChange: this.onChange.bind(this, 'is_wheelchair')
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'reversePoints',
	        value: function reversePoints() {
	            var _props$data = this.props.data,
	                from = _props$data.from,
	                to = _props$data.to;
	
	
	            this.props.onChange('from', to);
	            this.props.onChange('to', from);
	        }
	    }, {
	        key: 'onCurrentTimeChange',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(field, value) {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                this.props.onChange(field, (0, _moment2.default)(this.intToTime(value), _formats2.default.TIME).format(_formats2.default.TIME));
	
	                            case 1:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onCurrentTimeChange(_x2, _x3) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return onCurrentTimeChange;
	        }()
	    }, {
	        key: 'onReluctanceChange',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(field, value) {
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                this.props.onChange(field, value);
	
	                            case 1:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function onReluctanceChange(_x4, _x5) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return onReluctanceChange;
	        }()
	    }, {
	        key: 'getSliderHandle',
	        value: function getSliderHandle(props) {
	            var value = props.value,
	                dragging = props.dragging,
	                index = props.index,
	                restProps = _objectWithoutProperties(props, ['value', 'dragging', 'index']);
	
	            return _react2.default.createElement(
	                _rcTooltip2.default,
	                {
	                    prefixCls: 'rc-slider-tooltip',
	                    overlay: this.intToTime(value),
	                    visible: dragging,
	                    placement: 'top',
	                    key: index
	                },
	                _react2.default.createElement(Handle, _extends({ value: value }, restProps))
	            );
	        }
	    }, {
	        key: 'getSliderHandle2',
	        value: function getSliderHandle2(props) {
	            var value = props.value,
	                dragging = props.dragging,
	                index = props.index,
	                restProps = _objectWithoutProperties(props, ['value', 'dragging', 'index']);
	
	            return _react2.default.createElement(
	                _rcTooltip2.default,
	                {
	                    prefixCls: 'rc-slider-tooltip',
	                    overlay: this.walkReluctances[value],
	                    visible: dragging,
	                    placement: 'top',
	                    key: index
	                },
	                _react2.default.createElement(Handle, _extends({ value: value }, restProps))
	            );
	        }
	    }, {
	        key: 'getSliderMarks',
	        value: function getSliderMarks(min, max) {
	            var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 120;
	            var inTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	            var result = {};
	            for (var i = min; i <= max; i += step) {
	                result[i] = inTime ? this.intToTime(i) : i;
	            }
	            return result;
	        }
	    }, {
	        key: 'intToTime',
	        value: function intToTime(int) {
	            var hours = (0, _padStart3.default)(Math.floor(int / 60), 2, '0');
	            if (hours >= 24) {
	                hours -= 24;
	            }
	            var minutes = (0, _padStart3.default)(int % 60, 2, '0');
	            return hours + ':' + minutes;
	        }
	    }, {
	        key: 'timeToInt',
	        value: function timeToInt(time) {
	            var timeObject = (0, _moment2.default)(time, _formats2.default.TIME);
	            return timeObject.hours() * 60 + timeObject.minutes();
	        }
	    }, {
	        key: 'renderTransit',
	        value: function renderTransit(transit, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: index },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block__title' },
	                        '\u0410\u0434\u0440\u0435\u0441'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block__text' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'mappicker' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input' },
	                                _react2.default.createElement(_select.SelectAsync, {
	                                    value: transit.address,
	                                    onChange: this.onAddressChange.bind(this, 'transit.' + index),
	                                    loadOptions: this.props.suggestAddress,
	                                    readonly: true,
	                                    disabled: true,
	                                    options: transit.address ? [{
	                                        value: transit.address,
	                                        label: transit.address
	                                    }] : null
	                                }),
	                                _react2.default.createElement('a', { className: 'rnis-icon rnis-icon_big rnis-icon_map',
	                                    href: 'javascript:void(0)',
	                                    onClick: this.focusMapOn.bind(this, 'transit.' + index) })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 outer-indent-bottom' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'remove-point', href: 'javascript:void(0)',
	                            onClick: this.deleteTransit.bind(this, index), draggable: 'false' },
	                        '- \u0423\u0434\u0430\u043B\u0438\u0442\u044C'
	                    ),
	                    this.props.data.transit.length - 1 === index ? _react2.default.createElement(
	                        'span',
	                        { className: 'add-point', onClick: this.addTransit.bind(this) },
	                        '+ \u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C'
	                    ) : null
	                )
	            );
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(field, _ref5) {
	            var value = _ref5.target.value;
	
	            this.props.onChange(field, value);
	        }
	    }, {
	        key: 'onAddressChange',
	        value: function onAddressChange(field, e) {
	            var value = e ? e.value : null;
	            this.props.onChange(field, value);
	        }
	    }, {
	        key: 'addTransit',
	        value: function addTransit() {
	            var transit = this.props.data.transit;
	            transit.push({
	                latitude: null,
	                longitude: null,
	                address: ''
	            });
	            this.props.onChange('transit', transit);
	        }
	    }, {
	        key: 'deleteTransit',
	        value: function deleteTransit(index) {
	            var transit = this.props.data.transit;
	            transit.splice(index, 1);
	            this.props.onChange('transit', transit);
	        }
	    }, {
	        key: 'focusMapOn',
	        value: function focusMapOn(point) {
	            this.props.routingFocus(point);
	        }
	    }]);
	
	    return RoutingModal;
	}(_react.Component)) || _class);
	exports.default = RoutingModal;

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _each2 = __webpack_require__(88);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _find2 = __webpack_require__(89);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _get3 = __webpack_require__(31);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _debounce2 = __webpack_require__(1255);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get2 = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _dec3, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _layer = __webpack_require__(373);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	var _reactRedux = __webpack_require__(17);
	
	var _objects = __webpack_require__(385);
	
	var _garbagePointMarker = __webpack_require__(761);
	
	var _garbagePointMarker2 = _interopRequireDefault(_garbagePointMarker);
	
	var _dictionary = __webpack_require__(258);
	
	var _geojson = __webpack_require__(254);
	
	var _geojson2 = _interopRequireDefault(_geojson);
	
	var _objects2 = __webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var garbageObjectTypes = null;
	
	var GarbageObjectsLayer = (_dec = (0, _reactPropsDecorators.propTypes)({
	    type: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    onDblClick: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    onClick: null,
	    onDblClick: function onDblClick() {}
	}), _dec3 = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { getDictionaryList: _dictionary.getDictionaryList, getObjects: _objects.getObjects }), _dec(_class = _dec2(_class = _dec3(_class = function (_AbstractMapLayer) {
	    _inherits(GarbageObjectsLayer, _AbstractMapLayer);
	
	    function GarbageObjectsLayer() {
	        var _ref, _context;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, GarbageObjectsLayer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GarbageObjectsLayer.__proto__ || Object.getPrototypeOf(GarbageObjectsLayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            objects: [],
	            active: null,
	            garbage_object_types: [],
	            geo_zones: []
	        }, _this.loadCallback = (0, _debounce3.default)((_context = _this).load.bind(_context), 1000), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(GarbageObjectsLayer, [{
	        key: 'componentWillMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                var response;
	                return regeneratorRuntime.wrap(function _callee$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	
	                                _get2(GarbageObjectsLayer.prototype.__proto__ || Object.getPrototypeOf(GarbageObjectsLayer.prototype), 'componentWillMount', this).call(this);
	
	                                if (this.state.geo_zones.length) {
	                                    _context2.next = 6;
	                                    break;
	                                }
	
	                                _context2.next = 4;
	                                return (0, _objects2.getLayers)()();
	
	                            case 4:
	                                response = _context2.sent;
	
	                                if (response.isOk) {
	                                    this.setState({ geo_zones: response.payload.items });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 6:
	                                if (garbageObjectTypes) {
	                                    _context2.next = 12;
	                                    break;
	                                }
	
	                                _context2.next = 9;
	                                return this.loadDictionaries(['garbage_object_types']);
	
	                            case 9:
	                                garbageObjectTypes = this.state.garbage_object_types;
	                                _context2.next = 14;
	                                break;
	
	                            case 12:
	                                _context2.next = 14;
	                                return this.setState({
	                                    garbage_object_types: garbageObjectTypes
	                                });
	
	                            case 14:
	
	                                this.props.leafletMap.on('moveend', this.loadCallback);
	
	                                this.load();
	
	                            case 16:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            _get2(GarbageObjectsLayer.prototype.__proto__ || Object.getPrototypeOf(GarbageObjectsLayer.prototype), 'componentWillUnmount', this).call(this);
	
	            this.props.leafletMap.off('moveend', this.loadCallback);
	        }
	    }, {
	        key: 'getType',
	        value: function getType() {
	            var title = this.getTypeTitle();
	            return (0, _get4.default)((0, _find3.default)(this.state.garbage_object_types, { label: title }), 'value');
	        }
	    }, {
	        key: 'getTypeTitle',
	        value: function getTypeTitle() {
	            var title = null;
	            switch (this.props.type) {
	                case 'kp':
	                    title = 'Контейнерные площадки';
	                    break;
	                case 'op':
	                    title = 'Объекты перегрузки';
	                    break;
	                case 'opp':
	                    title = 'Объекты размещения';
	                    break;
	                case 'os':
	                    title = 'Объекты сортировки';
	                    break;
	            }
	            return title;
	        }
	    }, {
	        key: 'load',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                var boundingBox, zoom, response;
	                return regeneratorRuntime.wrap(function _callee2$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                boundingBox = this.props.map.getWrappedInstance ? this.props.map.getWrappedInstance().getBoundingBox() : this.props.map.getBoundingBox();
	                                zoom = this.props.map.getWrappedInstance ? this.props.map.getWrappedInstance().getZoom() : this.props.map.getZoom();
	
	                                if (!(this.props.type === 'kp' && zoom <= 13)) {
	                                    _context3.next = 5;
	                                    break;
	                                }
	
	                                this.setState({
	                                    objects: []
	                                });
	                                return _context3.abrupt('return');
	
	                            case 5:
	                                _context3.next = 7;
	                                return this.props.getObjects({
	                                    filters: {
	                                        withBoundingBox: boundingBox,
	                                        withGarbageObjectTypes: [this.getType()]
	                                    }
	                                }, {
	                                    argument: this.getType() //cancel conditions argument which repeats and need to be canceled
	                                });
	
	                            case 7:
	                                response = _context3.sent;
	
	
	                                if (response.isOk) {
	                                    this.setState({
	                                        objects: response.payload.items
	                                    });
	                                } else {
	                                    response.showErrors();
	                                }
	
	                            case 9:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function load() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return load;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'none' } },
	                    this.state.objects.map(this.renderObject.bind(this)),
	                    this.state.geo_zones.map(this.renderGeoZone.bind(this))
	                )
	            );
	        }
	    }, {
	        key: 'renderGeoZone',
	        value: function renderGeoZone(object) {
	            return _react2.default.createElement(_geojson2.default, _extends({}, object, { map: _layer2.default, leafletMap: this.props.leafletMap, tooltip: object.title }));
	        }
	    }, {
	        key: 'renderObject',
	        value: function renderObject(object) {
	            if (object.latitude) {
	                return _react2.default.createElement(_garbagePointMarker2.default, _extends({
	                    key: object.uuid
	                }, this.props, {
	                    latitude: object.latitude,
	                    longitude: object.longitude,
	                    type: this.props.type,
	                    typeTitle: this.getTypeTitle(),
	                    title: object.name,
	                    object: object,
	                    options: {
	                        zIndexOffset: 100
	                    }
	                }));
	            }
	        }
	    }, {
	        key: 'setActive',
	        value: function setActive(uuid) {
	            this.setState({
	                active: uuid
	            });
	        }
	    }, {
	        key: 'setNotActive',
	        value: function setNotActive() {
	            this.setState({
	                active: null
	            });
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(roadPart) {
	            this.props.onClick(roadPart.uuid, roadPart.geometry);
	        }
	    }, {
	        key: 'loadDictionaries',
	        value: function () {
	            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dictionaries) {
	                var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                var withoutOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	                var meta, response, state;
	                return regeneratorRuntime.wrap(function _callee3$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                this.setState({ dictionariesLoading: true });
	                                meta = {
	                                    filters: {
	                                        withComponent: component
	                                    }
	                                };
	
	                                if (!withoutOrder) {
	                                    meta.order = {
	                                        column: 'name',
	                                        direction: 'asc'
	                                    };
	                                }
	                                _context4.next = 5;
	                                return this.props.getDictionaryList(dictionaries, meta);
	
	                            case 5:
	                                response = _context4.sent;
	
	                                this.setState({ dictionariesLoading: false });
	
	                                if (!response.isOk) {
	                                    _context4.next = 14;
	                                    break;
	                                }
	
	                                state = this.state;
	
	                                (0, _each3.default)(response.payload.items, function (item) {
	                                    state[item.key] = (0, _map3.default)(item.documents, function (document) {
	                                        return {
	                                            value: document.uuid,
	                                            label: document.short_name || document.name,
	                                            document: document
	                                        };
	                                    });
	                                });
	                                _context4.next = 12;
	                                return this.setState(state);
	
	                            case 12:
	                                _context4.next = 15;
	                                break;
	
	                            case 14:
	                                response.showErrors();
	
	                            case 15:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function loadDictionaries(_x) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return loadDictionaries;
	        }()
	    }, {
	        key: 'getDictionary',
	        value: function () {
	            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dictionary) {
	                var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                var withoutOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	                var meta, response;
	                return regeneratorRuntime.wrap(function _callee4$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                meta = {
	                                    filters: {
	                                        withComponent: component
	                                    }
	                                };
	
	                                if (!withoutOrder) {
	                                    meta.order = {
	                                        column: 'name',
	                                        direction: 'asc'
	                                    };
	                                }
	                                _context5.next = 4;
	                                return this.props.getDictionaryList(dictionary, meta);
	
	                            case 4:
	                                response = _context5.sent;
	
	                                if (!response.isOk) {
	                                    _context5.next = 9;
	                                    break;
	                                }
	
	                                return _context5.abrupt('return', (0, _map3.default)(response.payload.documents, function (document) {
	                                    return {
	                                        value: document.uuid,
	                                        label: document.short_name || document.name,
	                                        document: document
	                                    };
	                                }));
	
	                            case 9:
	                                response.showErrors();
	
	                            case 10:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function getDictionary(_x4) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return getDictionary;
	        }()
	    }]);
	
	    return GarbageObjectsLayer;
	}(_layer2.default)) || _class) || _class) || _class);
	exports.default = GarbageObjectsLayer;

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _merge2 = __webpack_require__(326);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _marker = __webpack_require__(187);
	
	var _marker2 = _interopRequireDefault(_marker);
	
	var _garbageIcon = __webpack_require__(763);
	
	var _garbageIcon2 = _interopRequireDefault(_garbageIcon);
	
	var _reactLeafletPopup = __webpack_require__(179);
	
	var _reactLeafletPopup2 = _interopRequireDefault(_reactLeafletPopup);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GarbagePointMarker = (_dec = (0, _reactPropsDecorators.propTypes)({
	    title: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    permanentTooltip: _propTypes2.default.bool
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    title: '',
	    type: null,
	    permanentTooltip: false
	}), _dec(_class = _dec2(_class = function (_AbstractMapMarker) {
	    _inherits(GarbagePointMarker, _AbstractMapMarker);
	
	    function GarbagePointMarker() {
	        _classCallCheck(this, GarbagePointMarker);
	
	        return _possibleConstructorReturn(this, (GarbagePointMarker.__proto__ || Object.getPrototypeOf(GarbagePointMarker)).apply(this, arguments));
	    }
	
	    _createClass(GarbagePointMarker, [{
	        key: 'getOptions',
	        value: function getOptions() {
	            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            return (0, _merge3.default)(_get(GarbagePointMarker.prototype.__proto__ || Object.getPrototypeOf(GarbagePointMarker.prototype), 'getOptions', this).call(this), {
	                icon: _garbageIcon2.default.getIcon((props ? props.type : this.props.type) || 'kp'),
	                riseOnHover: true
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _get(GarbagePointMarker.prototype.__proto__ || Object.getPrototypeOf(GarbagePointMarker.prototype), 'componentDidMount', this).call(this);
	
	            /*if (this.props.title) {
	                this.getMarker().bindTooltip(this.props.title, {
	                    sticky: true,
	                    permanent: this.props.permanentToolTip,
	                });
	            }*/
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(props) {
	
	            /*const marker = this.getMarker();
	            const oldTitle = this.props.title;
	            const newTitle = props.title;
	            if (((oldTitle !== newTitle) || !marker.getTooltip())) {
	                marker.unbindTooltip();
	                if (newTitle) {
	                    marker.bindTooltip(newTitle, {
	                        sticky: true,
	                        permanent: this.props.permanentToolTip,
	                    });
	                }
	            }*/
	
	            if (this.props.type !== props.type) {
	                this.props.leafletMap.removeLayer(this.getMarker());
	                this.init(props);
	                this.props.leafletMap.addLayer(this.getMarker());
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _get(GarbagePointMarker.prototype.__proto__ || Object.getPrototypeOf(GarbagePointMarker.prototype), 'componentWillMount', this).call(this);
	
	            this.getMarker().on('click', this.loadPopup.bind(this));
	        }
	    }, {
	        key: 'loadPopup',
	        value: function loadPopup() {
	            if (!this.props.object) {
	                return;
	            }
	
	            var marker = this.getMarker();
	            marker.unbindPopup();
	            marker.closePopup();
	            marker.bindPopup(this.createPopup(marker.closePopup.bind(marker)));
	            marker.openPopup();
	        }
	    }, {
	        key: 'createPopup',
	        value: function createPopup(onClose) {
	            var object = this.props.object;
	
	
	            return new _reactLeafletPopup2.default({
	                reactComponent: ObjectPopup,
	                reactComponentProps: _extends({}, this.props, {
	                    object: object,
	                    onClose: onClose
	                }),
	                minWidth: 360,
	                maxWidth: 360,
	                offset: new _leaflet2.default.Point(2, -230)
	            });
	        }
	    }]);
	
	    return GarbagePointMarker;
	}(_marker2.default)) || _class) || _class);
	exports.default = GarbagePointMarker;
	
	var ObjectPopup = function (_Component) {
	    _inherits(ObjectPopup, _Component);
	
	    function ObjectPopup() {
	        _classCallCheck(this, ObjectPopup);
	
	        return _possibleConstructorReturn(this, (ObjectPopup.__proto__ || Object.getPrototypeOf(ObjectPopup)).apply(this, arguments));
	    }
	
	    _createClass(ObjectPopup, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                object = _props.object,
	                typeTitle = _props.typeTitle,
	                type = _props.type;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'b-modal b-modal-map map-tooltip-modal tooltip-locality footer-none display-block' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__header' },
	                    _react2.default.createElement('a', { href: '#', className: 'b-modal__close', onClick: this.onClose.bind(this) }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-modal__name align-middle' },
	                        object.name
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'b-modal__body' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u0422\u0438\u043F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            typeTitle
	                        )
	                    ),
	                    type !== 'kp' ? [_react2.default.createElement(
	                        'div',
	                        { key: 'capacity', className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u0401\u043C\u043A\u043E\u0441\u0442\u044C'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            object.capacity
	                        )
	                    ), _react2.default.createElement(
	                        'div',
	                        { key: 'contact', className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            object.contact
	                        )
	                    ), _react2.default.createElement(
	                        'div',
	                        { key: 'license', className: 'b-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__desc' },
	                            '\u041B\u0438\u0446\u0435\u043D\u0437\u0438\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'b-block__value' },
	                            object.license
	                        )
	                    )] : null
	                )
	            );
	        }
	    }, {
	        key: 'onClose',
	        value: function onClose(e) {
	            e.preventDefault();
	            this.props.onClose();
	        }
	    }]);
	
	    return ObjectPopup;
	}(_react.Component);

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _merge2 = __webpack_require__(326);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _marker = __webpack_require__(187);
	
	var _marker2 = _interopRequireDefault(_marker);
	
	var _pointIcon = __webpack_require__(764);
	
	var _pointIcon2 = _interopRequireDefault(_pointIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HistoryPointMarker = (_dec = (0, _reactPropsDecorators.propTypes)({
	    title: _propTypes2.default.string,
	    permanentTooltip: _propTypes2.default.bool
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    title: '',
	    permanentTooltip: false
	}), _dec(_class = _dec2(_class = function (_AbstractMapMarker) {
	    _inherits(HistoryPointMarker, _AbstractMapMarker);
	
	    function HistoryPointMarker() {
	        _classCallCheck(this, HistoryPointMarker);
	
	        return _possibleConstructorReturn(this, (HistoryPointMarker.__proto__ || Object.getPrototypeOf(HistoryPointMarker)).apply(this, arguments));
	    }
	
	    _createClass(HistoryPointMarker, [{
	        key: 'getOptions',
	        value: function getOptions() {
	            return (0, _merge3.default)(_get(HistoryPointMarker.prototype.__proto__ || Object.getPrototypeOf(HistoryPointMarker.prototype), 'getOptions', this).call(this), {
	                icon: _pointIcon2.default.getIcon(),
	                riseOnHover: true
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _get(HistoryPointMarker.prototype.__proto__ || Object.getPrototypeOf(HistoryPointMarker.prototype), 'componentDidMount', this).call(this);
	
	            if (this.props.title) {
	                this.getMarker().bindTooltip(this.props.title, {
	                    sticky: true,
	                    permanent: this.props.permanentToolTip
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(props) {
	            var marker = this.getMarker();
	            var oldTitle = this.props.title;
	            var newTitle = props.title;
	            if (oldTitle !== newTitle || !marker.getTooltip()) {
	                marker.unbindTooltip();
	                if (newTitle) {
	                    marker.bindTooltip(newTitle, {
	                        sticky: true,
	                        permanent: this.props.permanentToolTip
	                    });
	                }
	            }
	        }
	    }]);
	
	    return HistoryPointMarker;
	}(_marker2.default)) || _class) || _class);
	exports.default = HistoryPointMarker;

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(94);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _mapVehicleIcon = __webpack_require__(97);
	
	var _mapVehicleIcon2 = _interopRequireDefault(_mapVehicleIcon);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(1104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GarbageIcon = function () {
	    function GarbageIcon() {
	        _classCallCheck(this, GarbageIcon);
	    }
	
	    _createClass(GarbageIcon, null, [{
	        key: 'getIcon',
	        value: function getIcon(type) {
	            var html = '';
	
	            var className = 'marker-locality trash';
	            switch (type) {
	                case 'os':
	                    className = 'marker-object ts';
	                    break;
	                case 'opp':
	                    className = 'marker-object kdm';
	                    break;
	                case 'op':
	                    className = 'marker-object trash';
	                    break;
	            }
	            var size = type !== 'kp' ? [70, 70] : [16, 16];
	            return new _leaflet2.default.DivIcon({
	                html: html,
	                className: className,
	                iconSize: new _leaflet2.default.Point(size[0], size[1]),
	                iconAnchor: new _leaflet2.default.Point(size[0] / 2, size[1] / 2)
	            });
	        }
	    }]);
	
	    return GarbageIcon;
	}();
	
	exports.default = GarbageIcon;

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(94);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _mapVehicleIcon = __webpack_require__(97);
	
	var _mapVehicleIcon2 = _interopRequireDefault(_mapVehicleIcon);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PointIcon = function () {
	    function PointIcon() {
	        _classCallCheck(this, PointIcon);
	    }
	
	    _createClass(PointIcon, null, [{
	        key: 'getIcon',
	        value: function getIcon() {
	            var html = _server2.default.renderToStaticMarkup(_react2.default.createElement(_mapVehicleIcon2.default, { device: { type: null } }));
	
	            var className = 'marker marker_type_bus marker_sm';
	            var size = 26;
	            return new _leaflet2.default.DivIcon({
	                html: html,
	                className: className,
	                iconSize: new _leaflet2.default.Point(size, size),
	                iconAnchor: new _leaflet2.default.Point(size / 2, size / 2)
	            });
	        }
	    }]);
	
	    return PointIcon;
	}();
	
	exports.default = PointIcon;

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(94);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _mapVehicleIcon = __webpack_require__(97);
	
	var _mapVehicleIcon2 = _interopRequireDefault(_mapVehicleIcon);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RoutingIcon = function () {
	    function RoutingIcon() {
	        _classCallCheck(this, RoutingIcon);
	    }
	
	    _createClass(RoutingIcon, null, [{
	        key: 'getIcon',
	        value: function getIcon(type) {
	            var text = '';
	            switch (type) {
	                case 'from':
	                    text = 'A';
	                    break;
	                case 'to':
	                    text = 'B';
	                    break;
	            }
	
	            var html = _server2.default.renderToStaticMarkup(_react2.default.createElement(
	                'div',
	                null,
	                text
	            ));
	
	            return new _leaflet2.default.DivIcon({
	                html: html,
	                className: 'routing-marker routing-marker-' + (type === 'transit' ? 'transit' : type),
	                iconSize: new _leaflet2.default.Point(20, 20),
	                iconAnchor: new _leaflet2.default.Point(10, 10)
	            });
	        }
	    }]);
	
	    return RoutingIcon;
	}();
	
	exports.default = RoutingIcon;

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(94);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _mapVehicleIcon = __webpack_require__(97);
	
	var _mapVehicleIcon2 = _interopRequireDefault(_mapVehicleIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StopPointIcon = function () {
	    function StopPointIcon() {
	        _classCallCheck(this, StopPointIcon);
	    }
	
	    _createClass(StopPointIcon, null, [{
	        key: 'getIcon',
	        value: function getIcon() {
	            var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            color = color || 'bus';
	            var html = _server2.default.renderToStaticMarkup(_react2.default.createElement(_mapVehicleIcon2.default, { device: { type: color + '-stop' } }));
	
	            var className = 'marker marker-stop marker-stop_type_' + color + ' marker_sm';
	            var size = 23;
	            return new L.DivIcon({
	                html: html,
	                className: className,
	                iconSize: new L.Point(size, size),
	                iconAnchor: new L.Point(size / 2, size / 2)
	            });
	        }
	    }]);
	
	    return StopPointIcon;
	}();
	
	exports.default = StopPointIcon;

/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(94);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _mapVehicleIcon = __webpack_require__(97);
	
	var _mapVehicleIcon2 = _interopRequireDefault(_mapVehicleIcon);
	
	var _leaflet = __webpack_require__(28);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VehicleIcon = function () {
	    function VehicleIcon() {
	        _classCallCheck(this, VehicleIcon);
	    }
	
	    _createClass(VehicleIcon, null, [{
	        key: 'getIcon',
	        value: function getIcon(vehicle, device) {
	            var fast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var type = 'bus';
	            var html = _server2.default.renderToStaticMarkup(_react2.default.createElement(_mapVehicleIcon2.default, { device: { type: type }, direction: device.course, fast: fast }));
	
	            var className = 'marker marker_type_' + type;
	            var size = 46;
	            return new _leaflet2.default.DivIcon({
	                html: html,
	                className: className,
	                iconSize: new _leaflet2.default.Point(size, size),
	                iconAnchor: new _leaflet2.default.Point(size / 2, size / 2)
	            });
	        }
	    }]);
	
	    return VehicleIcon;
	}();
	
	exports.default = VehicleIcon;

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _marker = __webpack_require__(187);
	
	var _marker2 = _interopRequireDefault(_marker);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vehicleIcon = __webpack_require__(767);
	
	var _vehicleIcon2 = _interopRequireDefault(_vehicleIcon);
	
	var _reactLeafletPopup = __webpack_require__(179);
	
	var _reactLeafletPopup2 = _interopRequireDefault(_reactLeafletPopup);
	
	var _routingIcon = __webpack_require__(765);
	
	var _routingIcon2 = _interopRequireDefault(_routingIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoutingMarker = (_dec = (0, _reactPropsDecorators.propTypes)({
	    type: _propTypes2.default.string,
	    onDrag: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    type: 'transit'
	}), _dec(_class = _dec2(_class = function (_AbstractMapMarker) {
	    _inherits(RoutingMarker, _AbstractMapMarker);
	
	    function RoutingMarker() {
	        _classCallCheck(this, RoutingMarker);
	
	        return _possibleConstructorReturn(this, (RoutingMarker.__proto__ || Object.getPrototypeOf(RoutingMarker)).apply(this, arguments));
	    }
	
	    _createClass(RoutingMarker, [{
	        key: 'getOptions',
	        value: function getOptions() {
	            return {
	                icon: _routingIcon2.default.getIcon(this.props.type),
	                riseOnHover: true,
	                draggable: true
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _get(RoutingMarker.prototype.__proto__ || Object.getPrototypeOf(RoutingMarker.prototype), 'componentWillMount', this).call(this);
	
	            if (this.props.onDrag) {
	                this.getMarker().on('dragend', this.props.onDrag);
	            }
	            if (this.props.tooltip) {
	                this.getMarker().unbindTooltip().bindTooltip(this.props.tooltip, {
	                    permanent: true,
	                    interactive: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            _get(RoutingMarker.prototype.__proto__ || Object.getPrototypeOf(RoutingMarker.prototype), 'componentDidUpdate', this).call(this, prevProps);
	
	            if (this.props.tooltip) {
	                this.getMarker().unbindTooltip().bindTooltip(this.props.tooltip, {
	                    permanent: true,
	                    interactive: true
	                });
	            }
	        }
	    }]);
	
	    return RoutingMarker;
	}(_marker2.default)) || _class) || _class);
	exports.default = RoutingMarker;

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPropsDecorators = __webpack_require__(6);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _iconButton = __webpack_require__(370);
	
	var _iconButton2 = _interopRequireDefault(_iconButton);
	
	var _debounce = __webpack_require__(247);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(1111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchField = (_dec = (0, _reactPropsDecorators.propTypes)({
	    value: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onShow: _propTypes2.default.func,
	    onHide: _propTypes2.default.func
	}), _dec2 = (0, _reactPropsDecorators.defaultProps)({
	    onChange: function onChange() {},
	    onShow: function onShow() {},
	    onHide: function onHide() {}
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(SearchField, _Component);
	
	    function SearchField() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SearchField);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchField.__proto__ || Object.getPrototypeOf(SearchField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showInput: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SearchField, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)('f-search f-search-posit', this.state.showInput ? 'visible' : '');
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_iconButton2.default, { icon: 'search', tooltip: '\u041F\u043E\u0438\u0441\u043A', onClick: this.onClickIcon.bind(this) }),
	                _react2.default.createElement(
	                    'div',
	                    { className: className },
	                    _react2.default.createElement(
	                        'form',
	                        { action: '#' },
	                        _react2.default.createElement('input', { className: 'f-search__pole', type: 'text', placeholder: '\u043F\u043E\u0438\u0441\u043A', onChange: this.submitChanges.bind(this),
	                            value: this.props.value, ref: 'input' }),
	                        _react2.default.createElement('input', { className: 'f-search__button', type: 'button', onClick: this.onClickIcon.bind(this) })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'open',
	        value: function open() {
	            this.setState({ showInput: true });
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue() {
	            return this.refs.input.value;
	        }
	    }, {
	        key: 'submitChanges',
	        value: function submitChanges() {
	            this.props.onChange(this.getValue());
	        }
	    }, {
	        key: 'onClickIcon',
	        value: function onClickIcon() {
	            var _this2 = this;
	
	            if (this.state.showInput) {
	                this.props.onHide();
	                this.setState({ showInput: false });
	            } else {
	                this.props.onShow();
	                this.setState({ showInput: true });
	
	                setTimeout(function () {
	                    _this2.refs.input.focus();
	                }, 100);
	            }
	        }
	    }]);
	
	    return SearchField;
	}(_react.Component)) || _class) || _class);
	exports.default = SearchField;

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    kiutr: 'Пассажирские перевозки',
	    road: 'Обслуживание дорог',
	    communal: 'Коммунальные работы',
	    children: 'Перевозка детей',
	    garbage: 'Вывоз мусора'
	};

/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getGuestToken = undefined;
	
	var getGuestToken = exports.getGuestToken = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.auth.action.login_as_guest');
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getGuestToken() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDictionaryList = exports.getDictionaryLists = undefined;
	
	var getDictionaryLists = exports.getDictionaryLists = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(keys, meta) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.dictionary.action.lists', {
	                            keys: keys
	                        }, { meta: meta });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getDictionaryLists(_x, _x2) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getDictionaryList = exports.getDictionaryList = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key, meta) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _session.rpc.request('com.rnis.dictionary.action.list', {
	                            dictionary: { key: key }
	                        }, { meta: meta });
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getDictionaryList(_x3, _x4) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getObjects = undefined;
	
	var getObjects = exports.getObjects = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var cancelConditions = arguments[1];
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.garbage.action.object.list', {}, { meta: meta }, cancelConditions);
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getObjects() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.portalScheduleRoute = exports.portalScheduleExtended = exports.portalSchedule = exports.getStopPointRouteRuns = exports.getStopPointRoutes = exports.getStopPoints = exports.listUserGeoObjectsMO = exports.listUserGeoObjectsByLayers = exports.listLayers = exports.reverseGeocode = exports.searchAddress = exports.geocode = exports.getClosestStopPoint = exports.routing = undefined;
	
	var _get2 = __webpack_require__(31);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var routing = exports.routing = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(points) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.service.routing', { points: points });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function routing(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getClosestStopPoint = exports.getClosestStopPoint = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(latitude, longitude) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.stop_point.closest.get', { latitude: latitude, longitude: longitude });
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getClosestStopPoint(_x2, _x3) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var geocode = exports.geocode = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(q, bounding_box, zoom) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.service.geocoding', { q: q, bounding_box: bounding_box, zoom: zoom });
	
	                    case 2:
	                        return _context3.abrupt('return', _context3.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function geocode(_x4, _x5, _x6) {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	var searchAddress = exports.searchAddress = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(q, bounding_box, zoom) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        _context4.next = 2;
	                        return _session.rpc.request(window.RNIS_SETTINGS.isNSO ? 'com.rnis.geo.action.stop_point.geocoding.search' : 'com.rnis.geo.action.service.geocoding.search', { q: q, bounding_box: bounding_box, zoom: zoom });
	
	                    case 2:
	                        return _context4.abrupt('return', _context4.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context4.stop();
	                }
	            }
	        }, _callee4, this);
	    }));
	
	    return function searchAddress(_x7, _x8, _x9) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var reverseGeocode = exports.reverseGeocode = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(coordinates, bounding_box, zoom) {
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	                        _context5.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.service.geocoding', { coordinates: coordinates, bounding_box: bounding_box, zoom: zoom });
	
	                    case 2:
	                        return _context5.abrupt('return', _context5.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context5.stop();
	                }
	            }
	        }, _callee5, this);
	    }));
	
	    return function reverseGeocode(_x10, _x11, _x12) {
	        return _ref5.apply(this, arguments);
	    };
	}();
	
	var listLayers = exports.listLayers = function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	            while (1) {
	                switch (_context6.prev = _context6.next) {
	                    case 0:
	                        _context6.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.layer.list', {}, {
	                            meta: {
	                                filters: {
	                                    onlyVisible: true
	                                }
	                            }
	                        });
	
	                    case 2:
	                        return _context6.abrupt('return', _context6.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context6.stop();
	                }
	            }
	        }, _callee6, this);
	    }));
	
	    return function listLayers() {
	        return _ref6.apply(this, arguments);
	    };
	}();
	
	var listUserGeoObjectsByLayers = exports.listUserGeoObjectsByLayers = function () {
	    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(layers) {
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	            while (1) {
	                switch (_context7.prev = _context7.next) {
	                    case 0:
	                        _context7.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.user_geo_object.list_by_layers', layers);
	
	                    case 2:
	                        return _context7.abrupt('return', _context7.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context7.stop();
	                }
	            }
	        }, _callee7, this);
	    }));
	
	    return function listUserGeoObjectsByLayers(_x13) {
	        return _ref7.apply(this, arguments);
	    };
	}();
	
	var listUserGeoObjectsMO = exports.listUserGeoObjectsMO = function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(meta) {
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	            while (1) {
	                switch (_context8.prev = _context8.next) {
	                    case 0:
	                        _context8.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.user_geo_object.mo', {}, { meta: meta });
	
	                    case 2:
	                        return _context8.abrupt('return', _context8.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context8.stop();
	                }
	            }
	        }, _callee8, this);
	    }));
	
	    return function listUserGeoObjectsMO(_x14) {
	        return _ref8.apply(this, arguments);
	    };
	}();
	
	var getStopPoints = exports.getStopPoints = function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(meta) {
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	            while (1) {
	                switch (_context9.prev = _context9.next) {
	                    case 0:
	                        if (!((0, _get3.default)(meta, 'filters.withZoom', 20) <= 13)) {
	                            _context9.next = 2;
	                            break;
	                        }
	
	                        return _context9.abrupt('return', {
	                            isOk: true,
	                            payload: {
	                                items: []
	                            }
	                        });
	
	                    case 2:
	                        _context9.next = 4;
	                        return _session.rpc.request('com.rnis.geo.action.stop_point.list', {}, { meta: meta });
	
	                    case 4:
	                        return _context9.abrupt('return', _context9.sent);
	
	                    case 5:
	                    case 'end':
	                        return _context9.stop();
	                }
	            }
	        }, _callee9, this);
	    }));
	
	    return function getStopPoints(_x15) {
	        return _ref9.apply(this, arguments);
	    };
	}();
	
	var getStopPointRoutes = exports.getStopPointRoutes = function () {
	    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(uuid) {
	        var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	            while (1) {
	                switch (_context10.prev = _context10.next) {
	                    case 0:
	                        _context10.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.stop_point.routes', { uuid: uuid, time: time });
	
	                    case 2:
	                        return _context10.abrupt('return', _context10.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context10.stop();
	                }
	            }
	        }, _callee10, this);
	    }));
	
	    return function getStopPointRoutes(_x16) {
	        return _ref10.apply(this, arguments);
	    };
	}();
	
	var getStopPointRouteRuns = exports.getStopPointRouteRuns = function () {
	    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(uuid, routeUuid) {
	        var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        var onlyFirst = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	        var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	            while (1) {
	                switch (_context11.prev = _context11.next) {
	                    case 0:
	                        _context11.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.stop_point.route.runs', {
	                            uuid: uuid,
	                            route_uuid: routeUuid,
	                            time: time,
	                            only_first: onlyFirst,
	                            page: page
	                        });
	
	                    case 2:
	                        return _context11.abrupt('return', _context11.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context11.stop();
	                }
	            }
	        }, _callee11, this);
	    }));
	
	    return function getStopPointRouteRuns(_x18, _x19) {
	        return _ref11.apply(this, arguments);
	    };
	}();
	
	var portalSchedule = exports.portalSchedule = function () {
	    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(number, date) {
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	            while (1) {
	                switch (_context12.prev = _context12.next) {
	                    case 0:
	                        _context12.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.portal_schedule', { number: number, date: date });
	
	                    case 2:
	                        return _context12.abrupt('return', _context12.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context12.stop();
	                }
	            }
	        }, _callee12, this);
	    }));
	
	    return function portalSchedule(_x23, _x24) {
	        return _ref12.apply(this, arguments);
	    };
	}();
	
	var portalScheduleExtended = exports.portalScheduleExtended = function () {
	    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(number, date, from, to) {
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	            while (1) {
	                switch (_context13.prev = _context13.next) {
	                    case 0:
	                        _context13.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.portal_schedule', { number: number, date: date, from: from, to: to });
	
	                    case 2:
	                        return _context13.abrupt('return', _context13.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context13.stop();
	                }
	            }
	        }, _callee13, this);
	    }));
	
	    return function portalScheduleExtended(_x25, _x26, _x27, _x28) {
	        return _ref13.apply(this, arguments);
	    };
	}();
	
	var portalScheduleRoute = exports.portalScheduleRoute = function () {
	    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(orderRunUuid) {
	        return regeneratorRuntime.wrap(function _callee14$(_context14) {
	            while (1) {
	                switch (_context14.prev = _context14.next) {
	                    case 0:
	                        _context14.next = 2;
	                        return _session.rpc.request('com.rnis.geo.action.portal_schedule.route', {
	                            order_run_uuid: orderRunUuid
	                        });
	
	                    case 2:
	                        return _context14.abrupt('return', _context14.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context14.stop();
	                }
	            }
	        }, _callee14, this);
	    }));
	
	    return function portalScheduleRoute(_x29) {
	        return _ref14.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getGeometryFromContract = exports.getTasksGuests = exports.getTasks = undefined;
	
	var getTasks = exports.getTasks = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return (0, _session.postData)('com.rnis.kurs.action.portal.task.list', meta, { payload: payload });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getTasks() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getTasksGuests = exports.getTasksGuests = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return (0, _session.postData)('com.rnis.kurs.action.task.list', meta, { payload: payload }, token);
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getTasksGuests() {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var getGeometryFromContract = exports.getGeometryFromContract = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.next = 2;
	                        return (0, _session.postData)('com.rnis.kurs.action.analytics.geometry_form_contract.list', meta, { payload: payload }, token);
	
	                    case 2:
	                        return _context3.abrupt('return', _context3.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function getGeometryFromContract() {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.confirmEmailChangeCheck = exports.confirmEmailCheck = undefined;
	
	var confirmEmailCheck = exports.confirmEmailCheck = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.mobile.action.mobile_user.email.confirm.check', data);
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function confirmEmailCheck(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var confirmEmailChangeCheck = exports.confirmEmailChangeCheck = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _session.rpc.request('com.rnis.mobile.action.mobile_user.new_email.confirm.check', data);
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function confirmEmailChangeCheck(_x2) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUnit = exports.getCarriers = undefined;
	
	var getCarriers = exports.getCarriers = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.organizational_units.action.carriers', {}, { meta: meta });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getCarriers() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getUnit = exports.getUnit = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(inn, ogrn) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _session.rpc.request('com.rnis.organizational_units.action.unit.get', { inn: inn, ogrn: ogrn });
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getUnit(_x2, _x3) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTags = exports.loginRegisterRequest = exports.updateRegisterRequest = exports.getRegisterRequest = exports.createRegisterRequest = exports.checkRegisterRequestCreate = exports.getCaptcha = exports.sendFeedback = exports.getPage = exports.getFaq = exports.getNewsItem = exports.getNews = undefined;
	
	var getNews = exports.getNews = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.news', {}, { meta: meta });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getNews() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getNewsItem = exports.getNewsItem = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uuid) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.news.get', { uuid: uuid });
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getNewsItem(_x2) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var getFaq = exports.getFaq = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.faq', {}, { meta: meta });
	
	                    case 2:
	                        return _context3.abrupt('return', _context3.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function getFaq() {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	var getPage = exports.getPage = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(key) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        _context4.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.page.get', { key: key });
	
	                    case 2:
	                        return _context4.abrupt('return', _context4.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context4.stop();
	                }
	            }
	        }, _callee4, this);
	    }));
	
	    return function getPage(_x4) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var sendFeedback = exports.sendFeedback = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	                        _context5.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.feedback.send', data);
	
	                    case 2:
	                        return _context5.abrupt('return', _context5.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context5.stop();
	                }
	            }
	        }, _callee5, this);
	    }));
	
	    return function sendFeedback(_x5) {
	        return _ref5.apply(this, arguments);
	    };
	}();
	
	var getCaptcha = exports.getCaptcha = function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	            while (1) {
	                switch (_context6.prev = _context6.next) {
	                    case 0:
	                        _context6.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.captcha.get');
	
	                    case 2:
	                        return _context6.abrupt('return', _context6.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context6.stop();
	                }
	            }
	        }, _callee6, this);
	    }));
	
	    return function getCaptcha() {
	        return _ref6.apply(this, arguments);
	    };
	}();
	
	var checkRegisterRequestCreate = exports.checkRegisterRequestCreate = function () {
	    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(data) {
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	            while (1) {
	                switch (_context7.prev = _context7.next) {
	                    case 0:
	                        _context7.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.register_request.create.check', data);
	
	                    case 2:
	                        return _context7.abrupt('return', _context7.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context7.stop();
	                }
	            }
	        }, _callee7, this);
	    }));
	
	    return function checkRegisterRequestCreate(_x6) {
	        return _ref7.apply(this, arguments);
	    };
	}();
	
	var createRegisterRequest = exports.createRegisterRequest = function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(data) {
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	            while (1) {
	                switch (_context8.prev = _context8.next) {
	                    case 0:
	                        _context8.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.register_request.create', data);
	
	                    case 2:
	                        return _context8.abrupt('return', _context8.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context8.stop();
	                }
	            }
	        }, _callee8, this);
	    }));
	
	    return function createRegisterRequest(_x7) {
	        return _ref8.apply(this, arguments);
	    };
	}();
	
	var getRegisterRequest = exports.getRegisterRequest = function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(uuid) {
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	            while (1) {
	                switch (_context9.prev = _context9.next) {
	                    case 0:
	                        _context9.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.register_request.get', { uuid: uuid });
	
	                    case 2:
	                        return _context9.abrupt('return', _context9.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context9.stop();
	                }
	            }
	        }, _callee9, this);
	    }));
	
	    return function getRegisterRequest(_x8) {
	        return _ref9.apply(this, arguments);
	    };
	}();
	
	var updateRegisterRequest = exports.updateRegisterRequest = function () {
	    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(data) {
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	            while (1) {
	                switch (_context10.prev = _context10.next) {
	                    case 0:
	                        _context10.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.register_request.update', data);
	
	                    case 2:
	                        return _context10.abrupt('return', _context10.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context10.stop();
	                }
	            }
	        }, _callee10, this);
	    }));
	
	    return function updateRegisterRequest(_x9) {
	        return _ref10.apply(this, arguments);
	    };
	}();
	
	var loginRegisterRequest = exports.loginRegisterRequest = function () {
	    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(data) {
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	            while (1) {
	                switch (_context11.prev = _context11.next) {
	                    case 0:
	                        _context11.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.login', data);
	
	                    case 2:
	                        return _context11.abrupt('return', _context11.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context11.stop();
	                }
	            }
	        }, _callee11, this);
	    }));
	
	    return function loginRegisterRequest(_x10) {
	        return _ref11.apply(this, arguments);
	    };
	}();
	
	var getTags = exports.getTags = function () {
	    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	            while (1) {
	                switch (_context12.prev = _context12.next) {
	                    case 0:
	                        _context12.next = 2;
	                        return _session.rpc.request('com.rnis.portal.action.news.tags');
	
	                    case 2:
	                        return _context12.abrupt('return', _context12.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context12.stop();
	                }
	            }
	        }, _callee12, this);
	    }));
	
	    return function getTags() {
	        return _ref12.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTabletWorkSummary = undefined;
	
	var getTabletWorkSummary = exports.getTabletWorkSummary = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return (0, _session.postData)('com.rnis.kurs.action.portal.date.tasks.item_chart.list', meta, { payload: {} });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getTabletWorkSummary() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.find = undefined;
	
	var find = exports.find = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.routing.action.find', data);
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function find(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uploadFile = exports.getUploadToken = undefined;
	
	var getUploadToken = exports.getUploadToken = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.storage.action.token.unauth');
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getUploadToken() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var uploadFile = exports.uploadFile = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, data) {
	        var response, json;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return fetch(url, {
	                            method: 'POST',
	                            body: data
	                        });
	
	                    case 2:
	                        response = _context2.sent;
	                        _context2.next = 5;
	                        return response.json();
	
	                    case 5:
	                        json = _context2.sent;
	                        return _context2.abrupt('return', json.payload);
	
	                    case 7:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function uploadFile(_x, _x2) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.telematicsUpdateUnsubscribe = exports.filtersUpdate = exports.telematicsUpdateSubscribe = exports.getTelematicsTotalCount = exports.getTelematics = exports.getTelematicsWithDevices = undefined;
	
	var getTelematicsWithDevices = exports.getTelematicsWithDevices = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(devices, source) {
	        var boundingBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        var mapSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	        var zoom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 18;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.telematics.action.telematics.get', {
	                            compression: 'precalculated',
	                            bounding_box: boundingBox,
	                            map_size: mapSize,
	                            source: source,
	                            devices: devices,
	                            clusters: true,
	                            zoom: zoom
	                        });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getTelematicsWithDevices(_x, _x2) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getTelematics = exports.getTelematics = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(component, source) {
	        var boundingBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        var mapSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	        var zoom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 18;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _session.rpc.request('com.rnis.telematics.action.telematics.portal.clustered', {
	                            compression: 'precalculated',
	                            bounding_box: boundingBox,
	                            map_size: mapSize,
	                            source: source,
	                            devices: [component],
	                            clusters: true,
	                            zoom: zoom
	                        });
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getTelematics(_x6, _x7) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var getTelematicsTotalCount = exports.getTelematicsTotalCount = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.next = 2;
	                        return _session.rpc.request('com.rnis.telematics.action.telematics.portal.get.count', {});
	
	                    case 2:
	                        return _context3.abrupt('return', _context3.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function getTelematicsTotalCount() {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	var telematicsUpdateSubscribe = exports.telematicsUpdateSubscribe = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(filter, callback) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        _context4.next = 2;
	                        return _session.rpc.subscribe('com.rnis.telematics.action.telematics.portal.update', callback, filter);
	
	                    case 2:
	                    case 'end':
	                        return _context4.stop();
	                }
	            }
	        }, _callee4, this);
	    }));
	
	    return function telematicsUpdateSubscribe(_x11, _x12) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var filtersUpdate = exports.filtersUpdate = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(subject, filters) {
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	                        _context5.next = 2;
	                        return _session.rpc.wsRequest('filters', {
	                            subject: subject,
	                            filters: filters
	                        });
	
	                    case 2:
	                    case 'end':
	                        return _context5.stop();
	                }
	            }
	        }, _callee5, this);
	    }));
	
	    return function filtersUpdate(_x13, _x14) {
	        return _ref5.apply(this, arguments);
	    };
	}();
	
	var telematicsUpdateUnsubscribe = exports.telematicsUpdateUnsubscribe = function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	            while (1) {
	                switch (_context6.prev = _context6.next) {
	                    case 0:
	                        _context6.next = 2;
	                        return _session.rpc.unsubscribe('com.rnis.telematics.action.telematics.portal.update');
	
	                    case 2:
	                    case 'end':
	                        return _context6.stop();
	                }
	            }
	        }, _callee6, this);
	    }));
	
	    return function telematicsUpdateUnsubscribe() {
	        return _ref6.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getVehicleListGuest = exports.getVehicleList = undefined;
	
	var getVehicleList = exports.getVehicleList = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(meta) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return _session.rpc.request('com.rnis.vehicles.action.vehicle.list.portal', {}, { meta: meta });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getVehicleList(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getVehicleListGuest = exports.getVehicleListGuest = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(meta) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _session.rpc.request('com.rnis.vehicles.action.vehicle.list', {}, { meta: meta });
	
	                    case 2:
	                        return _context2.abrupt('return', _context2.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getVehicleListGuest(_x2) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var _session = __webpack_require__(30);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter2 = __webpack_require__(74);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _map2 = __webpack_require__(41);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _join2 = __webpack_require__(1269);
	
	var _join3 = _interopRequireDefault(_join2);
	
	exports.showError = showError;
	
	var _alerts = __webpack_require__(55);
	
	var alerts = _interopRequireWildcard(_alerts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function showError(error) {
	    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Ошибка';
	
	    console.error('Error:', error);
	    if (!hasNotValidationErrors(error.errors)) return;
	
	    var html = formatError(error.errors);
	    alerts.error(html, title);
	}
	
	function formatError(errors) {
	    return (0, _join3.default)((0, _map3.default)(errors, function (error) {
	        return '[<strong>' + error.code + '</strong>] ' + error.text;
	    }), '<br/>');
	}
	
	function hasNotValidationErrors(errors) {
	    return (0, _filter3.default)(errors, function (error) {
	        return error.code !== '1-0-0-3';
	    }).length > 0;
	}

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getErrors = undefined;
	
	var _forEach2 = __webpack_require__(507);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VALIDATION_ERROR_CODE = '1-0-0-3';
	
	var getErrors = exports.getErrors = function getErrors(e) {
	  var errors = [];
	  if (e.errors) {
	    e.errors.map(function (error) {
	      if (error.code == VALIDATION_ERROR_CODE) {
	        (0, _forEach3.default)(error.data, function (messages, field) {
	          errors[field] = messages.join(', ');
	        });
	      }
	    });
	  }
	  return errors;
	};

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getHostName = undefined;
	exports.createConnection = createConnection;
	
	var _wsrpc = __webpack_require__(790);
	
	var _wsrpc2 = _interopRequireDefault(_wsrpc);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createConnection() {
	    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	
	    if (!window.RNIS_SETTINGS) {
	        _jquery2.default.ajax({
	            dataType: 'json',
	            url: window.location.origin + '/static/settings/settings.json',
	            async: false,
	            success: function success(data) {
	                window.RNIS_SETTINGS = data;
	            }
	        });
	    }
	
	    var wsProtocol = ({"isSecure":true,"hostname":"rnisapi.regeora.ru","ws":{"uri":"","max_retry_delay":10,"max_retries":-1},"ajax":{"uri":"/ajax","retry_timeout":5},"connection":{"min_speed":5,"interval":3600,"file":{"size":6650305,"url":"/static/img/test.jpg"}},"pinger":{"interval":30000},"sip":{"host":"wss://asterisk.regeora.ru:8089/ws"}}).isSecure ? 'wss://' : 'ws://';
	    var ajaxProtocol = ({"isSecure":true,"hostname":"rnisapi.regeora.ru","ws":{"uri":"","max_retry_delay":10,"max_retries":-1},"ajax":{"uri":"/ajax","retry_timeout":5},"connection":{"min_speed":5,"interval":3600,"file":{"size":6650305,"url":"/static/img/test.jpg"}},"pinger":{"interval":30000},"sip":{"host":"wss://asterisk.regeora.ru:8089/ws"}}).isSecure ? 'https://' : 'http://';
	
	    if (window.RNIS_SETTINGS.isHTTP) {
	        wsProtocol = 'ws://';
	        ajaxProtocol = 'http://';
	    }
	
	    var wsUrl = '' + wsProtocol + getHostName('ws');
	    var ajaxUrl = '' + ajaxProtocol + getHostName('ajax');
	
	    return new _wsrpc2.default({
	        token: token,
	        ws: {
	            url: wsUrl,
	            realm: 'default',
	            max_retries: ({"isSecure":true,"hostname":"rnisapi.regeora.ru","ws":{"uri":"","max_retry_delay":10,"max_retries":-1},"ajax":{"uri":"/ajax","retry_timeout":5},"connection":{"min_speed":5,"interval":3600,"file":{"size":6650305,"url":"/static/img/test.jpg"}},"pinger":{"interval":30000},"sip":{"host":"wss://asterisk.regeora.ru:8089/ws"}}).ws.max_retries,
	            max_retry_delay: ({"isSecure":true,"hostname":"rnisapi.regeora.ru","ws":{"uri":"","max_retry_delay":10,"max_retries":-1},"ajax":{"uri":"/ajax","retry_timeout":5},"connection":{"min_speed":5,"interval":3600,"file":{"size":6650305,"url":"/static/img/test.jpg"}},"pinger":{"interval":30000},"sip":{"host":"wss://asterisk.regeora.ru:8089/ws"}}).ws.max_retry_delay
	        },
	
	        ajax: {
	            url: ajaxUrl,
	            retry_timeout: 5
	        }
	    });
	}
	
	var getHostName = exports.getHostName = function getHostName(protocol) {
	    return window.RNIS_SETTINGS.RNIS_API_URL + ({"isSecure":true,"hostname":"rnisapi.regeora.ru","ws":{"uri":"","max_retry_delay":10,"max_retries":-1},"ajax":{"uri":"/ajax","retry_timeout":5},"connection":{"min_speed":5,"interval":3600,"file":{"size":6650305,"url":"/static/img/test.jpg"}},"pinger":{"interval":30000},"sip":{"host":"wss://asterisk.regeora.ru:8089/ws"}})[protocol].uri;
	};

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(726);
	
	var _reactTapEventPlugin = __webpack_require__(1456);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _Root = __webpack_require__(732);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	global.Buffer = __webpack_require__(396);
	
	(0, _reactTapEventPlugin2.default)();
	
	var render = function render(Component) {
	  return _reactDom2.default.render(_react2.default.createElement(Component, null), document.getElementById('root'));
	};
	
	render(_Root2.default);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global, Buffer, setImmediate) {"use strict";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}(function(f){if(( false?"undefined":_typeof(exports))==="object"&&typeof module!=="undefined"){module.exports=f();}else if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else{var g;if(typeof window!=="undefined"){g=window;}else if(typeof global!=="undefined"){g=global;}else if(typeof self!=="undefined"){g=self;}else{g=this;}g.autobahn=f();}})(function(){var define,module,exports;return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f;}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e);},l,l.exports,e,t,n,r);}return n[o].exports;}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++){s(r[o]);}return s;}({1:[function(require,module,exports){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	// require('assert') would be nice .. but it does not
	// work with Google Closure after Browserify
	var crypto=require('crypto-js');// PBKDF2-base key derivation function for salted WAMP-CRA
	//
	function derive_key(secret,salt,iterations,keylen){var iterations=iterations||1000;var keylen=keylen||32;var config={keySize:keylen/4,iterations:iterations,hasher:crypto.algo.SHA256};var key=crypto.PBKDF2(secret,salt,config);return key.toString(crypto.enc.Base64);}function sign(key,challenge){return crypto.HmacSHA256(challenge,key).toString(crypto.enc.Base64);}exports.sign=sign;exports.derive_key=derive_key;},{"crypto-js":47}],2:[function(require,module,exports){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var nacl=require('tweetnacl');var util=require('../util.js');var log=require('../log.js');var connection=require('../connection.js');function load_private_key(name,force_regenerate){var seed=util.atob(localStorage.getItem(name));if(!seed||force_regenerate){seed=nacl.randomBytes(nacl.sign.seedLength);localStorage.setItem(name,util.btoa(seed));log.debug('new key seed "'+name+'" saved to local storage!');}else{log.debug('key seed "'+name+'" loaded from local storage!');}return nacl.sign.keyPair.fromSeed(seed);}exports.load_private_key=load_private_key;function delete_private_key(name){// FIXME: poor man's secure erase
	for(var i=0;i<5;++i){seed=nacl.randomBytes(nacl.sign.seedLength);localStorage.setItem(name,util.btoa(seed));localStorage.setItem(name,'');localStorage.setItem(name,null);}}exports.delete_private_key=delete_private_key;function sign_challenge(pkey,extra){var challenge=util.htob(extra.challenge);var signature=nacl.sign.detached(challenge,pkey.secretKey);var res=util.btoh(signature)+util.btoh(challenge);return res;}exports.sign_challenge=sign_challenge;function public_key(pkey){return util.btoh(pkey.publicKey);}exports.public_key=public_key;function create_connection(config){var url=config.url;var realm=config.realm;var authid=config.authid;var pkey=config.pkey;var activation_code=config.activation_code;var request_new_activation_code=config.request_new_activation_code;var serializers=config.serializers;if(config.debug){console.log(url);console.log(realm);console.log(authid);console.log(pkey);console.log(activation_code);console.log(request_new_activation_code);console.log(serializers);}function onchallenge(session,method,extra){// we only know how to process WAMP-cryptosign here!
	if(method=="cryptosign"){// and to do so, we let above helper sign the
	// WAMP-cryptosign challenge as required
	// and return a signature
	return sign_challenge(pkey,extra);}else{throw"don't know how to authenticate using '"+method+"'";}}authextra={// forward the client pubkey: this allows us to omit authid as
	// the router can identify us with the pubkey already
	pubkey:public_key(pkey),// not yet implemented. a public key the router should provide
	// a trustchain for it's public key. the trustroot can eg be
	// hard-coded in the client, or come from a command line option.
	trustroot:null,// not yet implemented. for authenticating the router, this
	// challenge will need to be signed by the router and send back
	// in AUTHENTICATE for client to verify. A string with a hex
	// encoded 32 bytes random value.
	challenge:null,// FIXME: at least on NodeJS, it should be possible to implement
	// this additional security measure!
	//channel_binding: 'tls-unique'
	channel_binding:null,// you should only provide an activation_code the very first time
	// the key pair used is paired. a token can only be used exactly once
	// and reusing it, even from the original client, will result in an error!
	activation_code:activation_code,// if true, request sending a new email with a new activation code
	request_new_activation_code:request_new_activation_code// now create a AutobahnJS Connection object
	// with WAMP-cryptosign being the only configured
	// authentication method:
	};var _connection=new connection.Connection({// this MUST be given
	url:url,// this MAY be given - if not, then connect to global user realm
	// if given, the user must have access permissions for the respective
	// management realm (to which both users and fabric nodes are connected)
	realm:realm,// this MAY be given (but MUST be given on register/pairing)
	authid:authid,// this MUST be given
	authmethods:["cryptosign"],// see above
	onchallenge:onchallenge,// see above
	authextra:authextra,// WAMP serializers to use
	serializers:config.serializers});return _connection;}exports.create_connection=create_connection;},{"../connection.js":6,"../log.js":7,"../util.js":21,"tweetnacl":130}],3:[function(require,module,exports){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var when=require('when');var when_fn=require("when/function");function auth(session,user,extra){// Persona Issues:
	//
	// Chrome: https://github.com/mozilla/persona/issues/4083
	// IE11: https://groups.google.com/forum/#!topic/mozilla.dev.identity/keEkVpvfLA8
	var d=session.defer();navigator.id.watch({loggedInUser:user,onlogin:function onlogin(assertion){// A user has logged in! Here you need to:
	// 1. Send the assertion to your backend for verification and to create a session.
	// 2. Update your UI.
	d.resolve(assertion);},onlogout:function onlogout(){// A user has logged out! Here you need to:
	// Tear down the user's session by redirecting the user or making a call to your backend.
	// Also, make sure loggedInUser will get set to null on the next page load.
	// (That's a literal JavaScript null. Not false, 0, or undefined. null.)
	session.leave("wamp.close.logout");}});if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}}exports.auth=auth;},{"when":161,"when/function":137}],4:[function(require,module,exports){(function(global){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	// Polyfills for <= IE9
	require('./polyfill.js');var pjson=require('../package.json');var when=require('when');//var fn = require("when/function");
	var msgpack=require('msgpack-lite');var cbor=require('cbor');var nacl=require('tweetnacl');if('AUTOBAHN_DEBUG'in global&&AUTOBAHN_DEBUG){// https://github.com/cujojs/when/blob/master/docs/api.md#whenmonitor
	require('when/monitor/console');if('console'in global){console.log("AutobahnJS debug enabled");}}var util=require('./util.js');var log=require('./log.js');var session=require('./session.js');var connection=require('./connection.js');var configure=require('./configure.js');var serializer=require('./serializer.js');var persona=require('./auth/persona.js');var cra=require('./auth/cra.js');var cryptosign=require('./auth/cryptosign.js');exports.version=pjson.version;exports.transports=configure.transports;exports.Connection=connection.Connection;exports.Session=session.Session;exports.Invocation=session.Invocation;exports.Event=session.Event;exports.Result=session.Result;exports.Error=session.Error;exports.Subscription=session.Subscription;exports.Registration=session.Registration;exports.Publication=session.Publication;exports.serializer=serializer;exports.auth_persona=persona.auth;exports.auth_cra=cra;exports.auth_cryptosign=cryptosign;exports.when=when;exports.msgpack=msgpack;exports.cbor=cbor;exports.nacl=nacl;exports.util=util;exports.log=log;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{"../package.json":162,"./auth/cra.js":1,"./auth/cryptosign.js":2,"./auth/persona.js":3,"./configure.js":5,"./connection.js":6,"./log.js":7,"./polyfill.js":8,"./serializer.js":16,"./session.js":17,"./util.js":21,"cbor":28,"msgpack-lite":80,"tweetnacl":130,"when":161,"when/monitor/console":159}],5:[function(require,module,exports){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	function Transports(){this._repository={};}Transports.prototype.register=function(name,factory){this._repository[name]=factory;};Transports.prototype.isRegistered=function(name){return this._repository[name]?true:false;};Transports.prototype.get=function(name){if(this._repository[name]!==undefined){return this._repository[name];}else{throw"no such transport: "+name;}};Transports.prototype.list=function(){var items=[];for(var name in this._repository){items.push(name);}return items;};var _transports=new Transports();// register default transports
	var websocket=require('./transport/websocket.js');_transports.register("websocket",websocket.Factory);var longpoll=require('./transport/longpoll.js');_transports.register("longpoll",longpoll.Factory);var rawsocket=require('./transport/rawsocket.js');_transports.register("rawsocket",rawsocket.Factory);exports.transports=_transports;},{"./transport/longpoll.js":18,"./transport/rawsocket.js":19,"./transport/websocket.js":20}],6:[function(require,module,exports){(function(global){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var when=require('when');var session=require('./session.js');var util=require('./util.js');var log=require('./log.js');var autobahn=require('./autobahn.js');var Connection=function Connection(options){var self=this;self._options=options;// Deferred factory
	//
	if(options&&options.use_es6_promises){if('Promise'in global){// ES6-based deferred factory
	//
	self._defer=function(){var deferred={};deferred.promise=new Promise(function(resolve,reject){deferred.resolve=resolve;deferred.reject=reject;});return deferred;};}else{log.debug("Warning: ES6 promises requested, but not found! Falling back to whenjs.");// whenjs-based deferred factory
	//
	self._defer=when.defer;}}else if(options&&options.use_deferred){// use explicit deferred factory, e.g. jQuery.Deferred or Q.defer
	//
	self._defer=options.use_deferred;}else{// whenjs-based deferred factory
	//
	self._defer=when.defer;}// WAMP transport
	//
	// backward compatiblity
	if(!self._options.transports){self._options.transports=[{type:'websocket',url:self._options.url}];}self._transport_factories=[];self._init_transport_factories();// WAMP session
	//
	self._session=null;self._session_close_reason=null;self._session_close_message=null;// automatic reconnection configuration
	//
	// enable automatic reconnect if host is unreachable
	if(self._options.retry_if_unreachable!==undefined){self._retry_if_unreachable=self._options.retry_if_unreachable;}else{self._retry_if_unreachable=true;}// maximum number of reconnection attempts
	self._max_retries=typeof self._options.max_retries!=='undefined'?self._options.max_retries:15;// initial retry delay in seconds
	self._initial_retry_delay=self._options.initial_retry_delay||1.5;// maximum seconds between reconnection attempts
	self._max_retry_delay=self._options.max_retry_delay||300;// the growth factor applied to the retry delay on each retry cycle
	self._retry_delay_growth=self._options.retry_delay_growth||1.5;// the SD of a Gaussian to jitter the delay on each retry cycle
	// as a fraction of the mean
	self._retry_delay_jitter=self._options.retry_delay_jitter||0.1;// reconnection tracking
	//
	// total number of successful connections
	self._connect_successes=0;// controls if we should try to reconnect
	self._retry=false;// current number of reconnect cycles we went through
	self._retry_count=0;// the current retry delay
	self._retry_delay=self._initial_retry_delay;// flag indicating if we are currently in a reconnect cycle
	self._is_retrying=false;// when retrying, this is the timer object returned from window.setTimeout()
	self._retry_timer=null;};Connection.prototype._create_transport=function(){for(var i=0;i<this._transport_factories.length;++i){var transport_factory=this._transport_factories[i];log.debug("trying to create WAMP transport of type: "+transport_factory.type);try{var transport=transport_factory.create();if(transport){log.debug("using WAMP transport type: "+transport_factory.type);return transport;}}catch(e){// ignore
	log.warn("could not create WAMP transport '"+transport_factory.type+"': "+e);}}log.warn('could not create any WAMP transport');return null;};Connection.prototype._init_transport_factories=function(){// WAMP transport
	//
	var transports,transport_options,transport_factory,transport_factory_klass;util.assert(this._options.transports,"No transport.factory specified");transports=this._options.transports;//if(typeof transports === "object") {
	//    this._options.transports = [transports];
	//}
	for(var i=0;i<this._options.transports.length;++i){// cascading transports until we find one which works
	transport_options=this._options.transports[i];if(!transport_options.url){// defaulting to options.url if none is provided
	transport_options.url=this._options.url;}if(!transport_options.serializers){transport_options.serializers=this._options.serializers;}if(!transport_options.protocols){transport_options.protocols=this._options.protocols;}util.assert(transport_options.type,"No transport.type specified");util.assert(typeof transport_options.type==="string","transport.type must be a string");try{transport_factory_klass=autobahn.transports.get(transport_options.type);if(transport_factory_klass){transport_factory=new transport_factory_klass(transport_options);this._transport_factories.push(transport_factory);}}catch(exc){console.error(exc);}}};Connection.prototype._autoreconnect_reset_timer=function(){var self=this;if(self._retry_timer){clearTimeout(self._retry_timer);}self._retry_timer=null;};Connection.prototype._autoreconnect_reset=function(){var self=this;self._autoreconnect_reset_timer();self._retry_count=0;self._retry_delay=self._initial_retry_delay;self._is_retrying=false;};Connection.prototype._autoreconnect_advance=function(){var self=this;// jitter retry delay
	if(self._retry_delay_jitter){self._retry_delay=util.rand_normal(self._retry_delay,self._retry_delay*self._retry_delay_jitter);}// cap the retry delay
	if(self._retry_delay>self._max_retry_delay){self._retry_delay=self._max_retry_delay;}// count number of retries
	self._retry_count+=1;var res;if(self._retry&&(self._max_retries===-1||self._retry_count<=self._max_retries)){res={count:self._retry_count,delay:self._retry_delay,will_retry:true};}else{res={count:null,delay:null,will_retry:false};}// retry delay growth for next retry cycle
	if(self._retry_delay_growth){self._retry_delay=self._retry_delay*self._retry_delay_growth;}return res;};Connection.prototype.open=function(){var self=this;if(self._transport){throw"connection already open (or opening)";}self._autoreconnect_reset();self._retry=true;function retry(){// create a WAMP transport
	try{self._transport=self._create_transport();}catch(e){console.log(e);}if(!self._transport){// failed to create a WAMP transport
	self._retry=false;if(self.onclose){var details={reason:null,message:null,retry_delay:null,retry_count:null,will_retry:false};self.onclose("unsupported",details);}return;}// create a new WAMP session using the WebSocket connection as transport
	self._session=new session.Session(self._transport,self._defer,self._options.onchallenge);self._session_close_reason=null;self._session_close_message=null;self._transport.onopen=function(){// reset auto-reconnect timer and tracking
	self._autoreconnect_reset();// log successful connections
	self._connect_successes+=1;// start WAMP session
	self._session.join(self._options.realm,self._options.authmethods,self._options.authid,self._options.authextra);};self._session.onjoin=function(details){if(self.onopen){try{// forward transport info ..
	details.transport=self._transport.info;self.onopen(self._session,details);}catch(e){log.debug("Exception raised from app code while firing Connection.onopen()",e);}}};//
	// ... WAMP session is now attached to realm.
	//
	self._session.onleave=function(reason,details){self._session_close_reason=reason;self._session_close_message=details.message||"";self._retry=false;self._transport.close(1000);};self._transport.onclose=function(evt){// remove any pending reconnect timer
	self._autoreconnect_reset_timer();self._transport=null;var reason=null;if(self._connect_successes===0){reason="unreachable";if(!self._retry_if_unreachable){self._retry=false;}}else if(!evt.wasClean){reason="lost";}else{reason="closed";}var next_retry=self._autoreconnect_advance();// fire app code handler
	//
	if(self.onclose){var details={reason:self._session_close_reason,message:self._session_close_message,retry_delay:next_retry.delay,retry_count:next_retry.count,will_retry:next_retry.will_retry};try{// Connection.onclose() allows to cancel any subsequent retry attempt
	var stop_retrying=self.onclose(reason,details);}catch(e){log.debug("Exception raised from app code while firing Connection.onclose()",e);}}// reset session info
	//
	if(self._session){self._session._id=null;self._session=null;self._session_close_reason=null;self._session_close_message=null;}// automatic reconnection
	//
	if(self._retry&&!stop_retrying){if(next_retry.will_retry){self._is_retrying=true;log.debug("retrying in "+next_retry.delay+" s");self._retry_timer=setTimeout(retry,next_retry.delay*1000);}else{log.debug("giving up trying to reconnect");}}};}retry();};Connection.prototype.close=function(reason,message){var self=this;if(!self._transport&&!self._is_retrying){throw"connection already closed";}// the app wants to close .. don't retry
	self._retry=false;if(self._session&&self._session.isOpen){// if there is an open session, close that first.
	self._session.leave(reason,message);}else if(self._transport){// no session active: just close the transport
	self._transport.close(1000);}};Object.defineProperty(Connection.prototype,"defer",{get:function get(){return this._defer;}});Object.defineProperty(Connection.prototype,"session",{get:function get(){return this._session;}});Object.defineProperty(Connection.prototype,"isOpen",{get:function get(){if(this._session&&this._session.isOpen){return true;}else{return false;}}});Object.defineProperty(Connection.prototype,"isConnected",{get:function get(){if(this._transport){return true;}else{return false;}}});Object.defineProperty(Connection.prototype,"transport",{get:function get(){if(this._transport){return this._transport;}else{return{info:{type:'none',url:null,protocol:null}};}}});Object.defineProperty(Connection.prototype,"isRetrying",{get:function get(){return this._is_retrying;}});exports.Connection=Connection;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{"./autobahn.js":4,"./log.js":7,"./session.js":17,"./util.js":21,"when":161}],7:[function(require,module,exports){(function(global){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var debug=function debug(){};if('AUTOBAHN_DEBUG'in global&&AUTOBAHN_DEBUG&&'console'in global){debug=function debug(){console.log.apply(console,arguments);};}var warn=console.warn;exports.debug=debug;exports.warn=warn;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],8:[function(require,module,exports){require('./polyfill/object.js');require('./polyfill/array.js');require('./polyfill/string.js');require('./polyfill/function.js');require('./polyfill/console.js');require('./polyfill/typedarray.js');require('./polyfill/json.js');},{"./polyfill/array.js":9,"./polyfill/console.js":10,"./polyfill/function.js":11,"./polyfill/json.js":12,"./polyfill/object.js":13,"./polyfill/string.js":14,"./polyfill/typedarray.js":15}],9:[function(require,module,exports){if('function'!==typeof Array.prototype.reduce){Array.prototype.reduce=function(callback/*, initialValue*/){'use strict';var len,t,value,k;if(null===this||'undefined'===typeof this){throw new TypeError('Array.prototype.reduce called on null or undefined');}if('function'!==typeof callback){throw new TypeError(callback+' is not a function');}t=Object(this);len=t.length>>>0;k=0;if(arguments.length>=2){value=arguments[1];}else{while(k<len&&!k in t){k++;}if(k>=len)throw new TypeError('Reduce of empty array with no initial value');value=t[k++];}for(;k<len;k++){if(k in t){value=callback(value,t[k],k,t);}}return value;};}// Add ECMA262-5 Array methods if not supported natively
	//
	if(!('indexOf'in Array.prototype)){Array.prototype.indexOf=function(find,i/*opt*/){if(i===undefined)i=0;if(i<0)i+=this.length;if(i<0)i=0;for(var n=this.length;i<n;i++){if(i in this&&this[i]===find)return i;}return-1;};}if(!('lastIndexOf'in Array.prototype)){Array.prototype.lastIndexOf=function(find,i/*opt*/){if(i===undefined)i=this.length-1;if(i<0)i+=this.length;if(i>this.length-1)i=this.length-1;for(i++;i-->0;){/* i++ because from-argument is sadly inclusive */if(i in this&&this[i]===find)return i;}return-1;};}if(!('forEach'in Array.prototype)){Array.prototype.forEach=function(action,that/*opt*/){for(var i=0,n=this.length;i<n;i++){if(i in this)action.call(that,this[i],i,this);}};}if(!('map'in Array.prototype)){Array.prototype.map=function(mapper,that/*opt*/){var other=new Array(this.length);for(var i=0,n=this.length;i<n;i++){if(i in this)other[i]=mapper.call(that,this[i],i,this);}return other;};}if(!('filter'in Array.prototype)){Array.prototype.filter=function(filter,that/*opt*/){var other=[],v;for(var i=0,n=this.length;i<n;i++){if(i in this&&filter.call(that,v=this[i],i,this))other.push(v);}return other;};}if(!('every'in Array.prototype)){Array.prototype.every=function(tester,that/*opt*/){for(var i=0,n=this.length;i<n;i++){if(i in this&&!tester.call(that,this[i],i,this))return false;}return true;};}if(!('some'in Array.prototype)){Array.prototype.some=function(tester,that/*opt*/){for(var i=0,n=this.length;i<n;i++){if(i in this&&tester.call(that,this[i],i,this))return true;}return false;};}if('function'!==typeof Array.prototype.reduceRight){Array.prototype.reduceRight=function(callback/*, initialValue*/){'use strict';if(null===this||'undefined'===typeof this){throw new TypeError('Array.prototype.reduce called on null or undefined');}if('function'!==typeof callback){throw new TypeError(callback+' is not a function');}var t=Object(this),len=t.length>>>0,k=len-1,value;if(arguments.length>=2){value=arguments[1];}else{while(k>=0&&!k in t){k--;}if(k<0)throw new TypeError('Reduce of empty array with no initial value');value=t[k--];}for(;k>=0;k--){if(k in t){value=callback(value,t[k],k,t);}}return value;};}},{}],10:[function(require,module,exports){(function(console){/*********************************************************************************************
	    * Make sure console exists because IE blows up if it's not open and you attempt to access it
	    * Create some dummy functions if we need to, so we don't have to if/else everything
	    *********************************************************************************************/console||(console=window.console={// all this "a, b, c, d, e" garbage is to make the IDEs happy, since they can't do variable argument lists
	/**
	       * @param a
	       * @param [b]
	       * @param [c]
	       * @param [d]
	       * @param [e]
	       */log:function log(a,b,c,d,e){},/**
	       * @param a
	       * @param [b]
	       * @param [c]
	       * @param [d]
	       * @param [e]
	       */info:function info(a,b,c,d,e){},/**
	       * @param a
	       * @param [b]
	       * @param [c]
	       * @param [d]
	       * @param [e]
	       */warn:function warn(a,b,c,d,e){},/**
	       * @param a
	       * @param [b]
	       * @param [c]
	       * @param [d]
	       * @param [e]
	       */error:function error(a,b,c,d,e){},assert:function assert(test,message){}});// IE 9 won't allow us to call console.log.apply (WTF IE!) It also reports typeof(console.log) as 'object' (UNH!)
	// but together, those two errors can be useful in allowing us to fix stuff so it works right
	if(_typeof(console.log)==='object'){// Array.forEach doesn't work in IE 8 so don't try that :(
	console.log=Function.prototype.call.bind(console.log,console);console.info=Function.prototype.call.bind(console.info,console);console.warn=Function.prototype.call.bind(console.warn,console);console.error=Function.prototype.call.bind(console.error,console);console.debug=Function.prototype.call.bind(console.info,console);}/**
	    * Support group and groupEnd functions
	    */'group'in console||(console.group=function(msg){console.info("\n--- "+msg+" ---\n");});'groupEnd'in console||(console.groupEnd=function(){console.log("\n");});'assert'in console||(console.assert=function(test,message){if(!test){try{// attempt to preserve the stack
	throw new Error("assertion failed: "+message);}catch(error){setTimeout(function(){throw error;},0);}}});/**
	    * Support time and timeEnd functions
	    */'time'in console||function(){var trackedTimes={};console.time=function(msg){trackedTimes[msg]=new Date().getTime();};console.timeEnd=function(msg){var end=new Date().getTime(),time=msg in trackedTimes?end-trackedTimes[msg]:0;console.info(msg+': '+time+'ms');};}();})(typeof console!=='undefined'?console:undefined);},{}],11:[function(require,module,exports){if(!Function.prototype.bind){//credits: taken from bind_even_never in this discussion: https://prototype.lighthouseapp.com/projects/8886/tickets/215-optimize-bind-bindaseventlistener#ticket-215-9
	Function.prototype.bind=function(context){var fn=this,args=Array.prototype.slice.call(arguments,1);return function(){return fn.apply(context,Array.prototype.concat.apply(args,arguments));};};}},{}],12:[function(require,module,exports){/*
	    json2.js
	    2014-02-04
	
	    Public Domain.
	
	    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	
	    See http://www.JSON.org/js.html
	
	
	    This code should be minified before deployment.
	    See http://javascript.crockford.com/jsmin.html
	
	    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
	    NOT CONTROL.
	
	
	    This file creates a global JSON object containing two methods: stringify
	    and parse.
	
	        JSON.stringify(value, replacer, space)
	            value       any JavaScript value, usually an object or array.
	
	            replacer    an optional parameter that determines how object
	                        values are stringified for objects. It can be a
	                        function or an array of strings.
	
	            space       an optional parameter that specifies the indentation
	                        of nested structures. If it is omitted, the text will
	                        be packed without extra whitespace. If it is a number,
	                        it will specify the number of spaces to indent at each
	                        level. If it is a string (such as '\t' or '&nbsp;'),
	                        it contains the characters used to indent at each level.
	
	            This method produces a JSON text from a JavaScript value.
	
	            When an object value is found, if the object contains a toJSON
	            method, its toJSON method will be called and the result will be
	            stringified. A toJSON method does not serialize: it returns the
	            value represented by the name/value pair that should be serialized,
	            or undefined if nothing should be serialized. The toJSON method
	            will be passed the key associated with the value, and this will be
	            bound to the value
	
	            For example, this would serialize Dates as ISO strings.
	
	                Date.prototype.toJSON = function (key) {
	                    function f(n) {
	                        // Format integers to have at least two digits.
	                        return n < 10 ? '0' + n : n;
	                    }
	
	                    return this.getUTCFullYear()   + '-' +
	                         f(this.getUTCMonth() + 1) + '-' +
	                         f(this.getUTCDate())      + 'T' +
	                         f(this.getUTCHours())     + ':' +
	                         f(this.getUTCMinutes())   + ':' +
	                         f(this.getUTCSeconds())   + 'Z';
	                };
	
	            You can provide an optional replacer method. It will be passed the
	            key and value of each member, with this bound to the containing
	            object. The value that is returned from your method will be
	            serialized. If your method returns undefined, then the member will
	            be excluded from the serialization.
	
	            If the replacer parameter is an array of strings, then it will be
	            used to select the members to be serialized. It filters the results
	            such that only members with keys listed in the replacer array are
	            stringified.
	
	            Values that do not have JSON representations, such as undefined or
	            functions, will not be serialized. Such values in objects will be
	            dropped; in arrays they will be replaced with null. You can use
	            a replacer function to replace those with JSON values.
	            JSON.stringify(undefined) returns undefined.
	
	            The optional space parameter produces a stringification of the
	            value that is filled with line breaks and indentation to make it
	            easier to read.
	
	            If the space parameter is a non-empty string, then that string will
	            be used for indentation. If the space parameter is a number, then
	            the indentation will be that many spaces.
	
	            Example:
	
	            text = JSON.stringify(['e', {pluribus: 'unum'}]);
	            // text is '["e",{"pluribus":"unum"}]'
	
	
	            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
	            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
	
	            text = JSON.stringify([new Date()], function (key, value) {
	                return this[key] instanceof Date ?
	                    'Date(' + this[key] + ')' : value;
	            });
	            // text is '["Date(---current time---)"]'
	
	
	        JSON.parse(text, reviver)
	            This method parses a JSON text to produce an object or array.
	            It can throw a SyntaxError exception.
	
	            The optional reviver parameter is a function that can filter and
	            transform the results. It receives each of the keys and values,
	            and its return value is used instead of the original value.
	            If it returns what it received, then the structure is not modified.
	            If it returns undefined then the member is deleted.
	
	            Example:
	
	            // Parse the text. Values that look like ISO date strings will
	            // be converted to Date objects.
	
	            myData = JSON.parse(text, function (key, value) {
	                var a;
	                if (typeof value === 'string') {
	                    a =
	/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
	                    if (a) {
	                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
	                            +a[5], +a[6]));
	                    }
	                }
	                return value;
	            });
	
	            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
	                var d;
	                if (typeof value === 'string' &&
	                        value.slice(0, 5) === 'Date(' &&
	                        value.slice(-1) === ')') {
	                    d = new Date(value.slice(5, -1));
	                    if (d) {
	                        return d;
	                    }
	                }
	                return value;
	            });
	
	
	    This is a reference implementation. You are free to copy, modify, or
	    redistribute.
	*//*jslint evil: true, regexp: true *//*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
	    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
	    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
	    lastIndex, length, parse, prototype, push, replace, slice, stringify,
	    test, toJSON, toString, valueOf
	*/// Create a JSON object only if one does not already exist. We create the
	// methods in a closure to avoid creating global variables.
	if((typeof JSON==="undefined"?"undefined":_typeof(JSON))!=='object'){JSON={};}(function(){'use strict';function f(n){// Format integers to have at least two digits.
	return n<10?'0'+n:n;}if(typeof Date.prototype.toJSON!=='function'){Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+'-'+f(this.getUTCMonth()+1)+'-'+f(this.getUTCDate())+'T'+f(this.getUTCHours())+':'+f(this.getUTCMinutes())+':'+f(this.getUTCSeconds())+'Z':null;};String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf();};}var cx,escapable,gap,indent,meta,rep;function quote(string){// If the string contains no control characters, no quote characters, and no
	// backslash characters, then we can safely slap some quotes around it.
	// Otherwise we must also replace the offending characters with safe escape
	// sequences.
	escapable.lastIndex=0;return escapable.test(string)?'"'+string.replace(escapable,function(a){var c=meta[a];return typeof c==='string'?c:"\\u"+('0000'+a.charCodeAt(0).toString(16)).slice(-4);})+'"':'"'+string+'"';}function str(key,holder){// Produce a string from holder[key].
	var i,// The loop counter.
	k,// The member key.
	v,// The member value.
	length,mind=gap,partial,value=holder[key];// If the value has a toJSON method, call it to obtain a replacement value.
	if(value&&(typeof value==="undefined"?"undefined":_typeof(value))==='object'&&typeof value.toJSON==='function'){value=value.toJSON(key);}// If we were called with a replacer function, then call the replacer to
	// obtain a replacement value.
	if(typeof rep==='function'){value=rep.call(holder,key,value);}// What happens next depends on the value's type.
	switch(typeof value==="undefined"?"undefined":_typeof(value)){case'string':return quote(value);case'number':// JSON numbers must be finite. Encode non-finite numbers as null.
	return isFinite(value)?String(value):'null';case'boolean':case'null':// If the value is a boolean or null, convert it to a string. Note:
	// typeof null does not produce 'null'. The case is included here in
	// the remote chance that this gets fixed someday.
	return String(value);// If the type is 'object', we might be dealing with an object or an array or
	// null.
	case'object':// Due to a specification blunder in ECMAScript, typeof null is 'object',
	// so watch out for that case.
	if(!value){return'null';}// Make an array to hold the partial results of stringifying this object value.
	gap+=indent;partial=[];// Is the value an array?
	if(Object.prototype.toString.apply(value)==='[object Array]'){// The value is an array. Stringify every element. Use null as a placeholder
	// for non-JSON values.
	length=value.length;for(i=0;i<length;i+=1){partial[i]=str(i,value)||'null';}// Join all of the elements together, separated with commas, and wrap them in
	// brackets.
	v=partial.length===0?'[]':gap?'[\n'+gap+partial.join(',\n'+gap)+'\n'+mind+']':'['+partial.join(',')+']';gap=mind;return v;}// If the replacer is an array, use it to select the members to be stringified.
	if(rep&&(typeof rep==="undefined"?"undefined":_typeof(rep))==='object'){length=rep.length;for(i=0;i<length;i+=1){if(typeof rep[i]==='string'){k=rep[i];v=str(k,value);if(v){partial.push(quote(k)+(gap?': ':':')+v);}}}}else{// Otherwise, iterate through all of the keys in the object.
	for(k in value){if(Object.prototype.hasOwnProperty.call(value,k)){v=str(k,value);if(v){partial.push(quote(k)+(gap?': ':':')+v);}}}}// Join all of the member texts together, separated with commas,
	// and wrap them in braces.
	v=partial.length===0?'{}':gap?'{\n'+gap+partial.join(',\n'+gap)+'\n'+mind+'}':'{'+partial.join(',')+'}';gap=mind;return v;}}// If the JSON object does not yet have a stringify method, give it one.
	if(typeof JSON.stringify!=='function'){escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;meta={// table of character substitutions
	'\b':'\\b','\t':'\\t','\n':'\\n','\f':'\\f','\r':'\\r','"':'\\"','\\':'\\\\'};JSON.stringify=function(value,replacer,space){// The stringify method takes a value and an optional replacer, and an optional
	// space parameter, and returns a JSON text. The replacer can be a function
	// that can replace values, or an array of strings that will select the keys.
	// A default replacer method can be provided. Use of the space parameter can
	// produce text that is more easily readable.
	var i;gap='';indent='';// If the space parameter is a number, make an indent string containing that
	// many spaces.
	if(typeof space==='number'){for(i=0;i<space;i+=1){indent+=' ';}// If the space parameter is a string, it will be used as the indent string.
	}else if(typeof space==='string'){indent=space;}// If there is a replacer, it must be a function or an array.
	// Otherwise, throw an error.
	rep=replacer;if(replacer&&typeof replacer!=='function'&&((typeof replacer==="undefined"?"undefined":_typeof(replacer))!=='object'||typeof replacer.length!=='number')){throw new Error('JSON.stringify');}// Make a fake root object containing our value under the key of ''.
	// Return the result of stringifying the value.
	return str('',{'':value});};}// If the JSON object does not yet have a parse method, give it one.
	if(typeof JSON.parse!=='function'){cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;JSON.parse=function(text,reviver){// The parse method takes a text and an optional reviver function, and returns
	// a JavaScript value if the text is a valid JSON text.
	var j;function walk(holder,key){// The walk method is used to recursively walk the resulting structure so
	// that modifications can be made.
	var k,v,value=holder[key];if(value&&(typeof value==="undefined"?"undefined":_typeof(value))==='object'){for(k in value){if(Object.prototype.hasOwnProperty.call(value,k)){v=walk(value,k);if(v!==undefined){value[k]=v;}else{delete value[k];}}}}return reviver.call(holder,key,value);}// Parsing happens in four stages. In the first stage, we replace certain
	// Unicode characters with escape sequences. JavaScript handles many characters
	// incorrectly, either silently deleting them, or treating them as line endings.
	text=String(text);cx.lastIndex=0;if(cx.test(text)){text=text.replace(cx,function(a){return"\\u"+('0000'+a.charCodeAt(0).toString(16)).slice(-4);});}// In the second stage, we run the text against regular expressions that look
	// for non-JSON patterns. We are especially concerned with '()' and 'new'
	// because they can cause invocation, and '=' because it can cause mutation.
	// But just to be safe, we want to reject all unexpected forms.
	// We split the second stage into 4 regexp operations in order to work around
	// crippling inefficiencies in IE's and Safari's regexp engines. First we
	// replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
	// replace all simple value tokens with ']' characters. Third, we delete all
	// open brackets that follow a colon or comma or that begin the text. Finally,
	// we look to see that the remaining characters are only whitespace or ']' or
	// ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.
	if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,'@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,']').replace(/(?:^|:|,)(?:\s*\[)+/g,''))){// In the third stage we use the eval function to compile the text into a
	// JavaScript structure. The '{' operator is subject to a syntactic ambiguity
	// in JavaScript: it can begin a block or an object literal. We wrap the text
	// in parens to eliminate the ambiguity.
	j=eval('('+text+')');// In the optional fourth stage, we recursively walk the new structure, passing
	// each name/value pair to a reviver function for possible transformation.
	return typeof reviver==='function'?walk({'':j},''):j;}// If the text is not JSON parseable, then a SyntaxError is thrown.
	throw new SyntaxError('JSON.parse');};}})();exports.JSON=JSON;},{}],13:[function(require,module,exports){if(!Object.create){Object.create=function(){function F(){}return function(o){if(arguments.length!=1){throw new Error('Object.create implementation only accepts one parameter.');}F.prototype=o;return new F();};}();}// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
	if(!Object.keys){Object.keys=function(){'use strict';var hasOwnProperty=Object.prototype.hasOwnProperty,hasDontEnumBug=!{toString:null}.propertyIsEnumerable('toString'),dontEnums=['toString','toLocaleString','valueOf','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','constructor'],dontEnumsLength=dontEnums.length;return function(obj){if((typeof obj==="undefined"?"undefined":_typeof(obj))!=='object'&&(typeof obj!=='function'||obj===null)){throw new TypeError('Object.keys called on non-object');}var result=[],prop,i;for(prop in obj){if(hasOwnProperty.call(obj,prop)){result.push(prop);}}if(hasDontEnumBug){for(i=0;i<dontEnumsLength;i++){if(hasOwnProperty.call(obj,dontEnums[i])){result.push(dontEnums[i]);}}}return result;};}();}},{}],14:[function(require,module,exports){// Add ECMA262-5 string trim if not supported natively
	//
	if(!('trim'in String.prototype)){String.prototype.trim=function(){return this.replace(/^\s+/,'').replace(/\s+$/,'');};}},{}],15:[function(require,module,exports){/*
	 Copyright (c) 2010, Linden Research, Inc.
	 Copyright (c) 2014, Joshua Bell
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in
	 all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 THE SOFTWARE.
	 $/LicenseInfo$
	 */// Original can be found at:
	//   https://bitbucket.org/lindenlab/llsd
	// Modifications by Joshua Bell inexorabletash@gmail.com
	//   https://github.com/inexorabletash/polyfill
	// ES3/ES5 implementation of the Krhonos Typed Array Specification
	//   Ref: http://www.khronos.org/registry/typedarray/specs/latest/
	//   Date: 2011-02-01
	//
	// Variations:
	//  * Allows typed_array.get/set() as alias for subscripts (typed_array[])
	//  * Gradually migrating structure from Khronos spec to ES6 spec
	if(typeof Uint8Array==="undefined"){(function(global,win){'use strict';var undefined=void 0;// Paranoia
	// Beyond this value, index getters/setters (i.e. array[0], array[1]) are so slow to
	// create, and consume so much memory, that the browser appears frozen.
	var MAX_ARRAY_LENGTH=1e5;// Approximations of internal ECMAScript conversion functions
	function Type(v){switch(typeof v==="undefined"?"undefined":_typeof(v)){case'undefined':return'undefined';case'boolean':return'boolean';case'number':return'number';case'string':return'string';default:return v===null?'null':'object';}}// Class returns internal [[Class]] property, used to avoid cross-frame instanceof issues:
	function Class(v){return Object.prototype.toString.call(v).replace(/^\[object *|\]$/g,'');}function IsCallable(o){return typeof o==='function';}function ToObject(v){if(v===null||v===undefined)throw TypeError();return Object(v);}function ToInt32(v){return v>>0;}function ToUint32(v){return v>>>0;}// Snapshot intrinsics
	var LN2=Math.LN2,abs=Math.abs,floor=Math.floor,log=Math.log,max=Math.max,min=Math.min,pow=Math.pow,round=Math.round;// emulate ES5 getter/setter API using legacy APIs
	// http://blogs.msdn.com/b/ie/archive/2010/09/07/transitioning-existing-code-to-the-es5-getter-setter-apis.aspx
	// (second clause tests for Object.defineProperty() in IE<9 that only supports extending DOM prototypes, but
	// note that IE<9 does not support __defineGetter__ or __defineSetter__ so it just renders the method harmless)
	(function(){var orig=Object.defineProperty;var dom_only=!function(){try{return Object.defineProperty({},'x',{});}catch(_){return false;}}();if(!orig||dom_only){Object.defineProperty=function(o,prop,desc){// In IE8 try built-in implementation for defining properties on DOM prototypes.
	if(orig){try{return orig(o,prop,desc);}catch(_){}}if(o!==Object(o))throw TypeError('Object.defineProperty called on non-object');if(Object.prototype.__defineGetter__&&'get'in desc)Object.prototype.__defineGetter__.call(o,prop,desc.get);if(Object.prototype.__defineSetter__&&'set'in desc)Object.prototype.__defineSetter__.call(o,prop,desc.set);if('value'in desc)o[prop]=desc.value;return o;};}})();// ES5: Make obj[index] an alias for obj._getter(index)/obj._setter(index, value)
	// for index in 0 ... obj.length
	function makeArrayAccessors(obj){if(obj.length>MAX_ARRAY_LENGTH)throw RangeError('Array too large for polyfill');function makeArrayAccessor(index){Object.defineProperty(obj,index,{'get':function get(){return obj._getter(index);},'set':function set(v){obj._setter(index,v);},enumerable:true,configurable:false});}var i;for(i=0;i<obj.length;i+=1){makeArrayAccessor(i);}}// Internal conversion functions:
	//    pack<Type>()   - take a number (interpreted as Type), output a byte array
	//    unpack<Type>() - take a byte array, output a Type-like number
	function as_signed(value,bits){var s=32-bits;return value<<s>>s;}function as_unsigned(value,bits){var s=32-bits;return value<<s>>>s;}function packI8(n){return[n&0xff];}function unpackI8(bytes){return as_signed(bytes[0],8);}function packU8(n){return[n&0xff];}function unpackU8(bytes){return as_unsigned(bytes[0],8);}function packU8Clamped(n){n=round(Number(n));return[n<0?0:n>0xff?0xff:n&0xff];}function packI16(n){return[n>>8&0xff,n&0xff];}function unpackI16(bytes){return as_signed(bytes[0]<<8|bytes[1],16);}function packU16(n){return[n>>8&0xff,n&0xff];}function unpackU16(bytes){return as_unsigned(bytes[0]<<8|bytes[1],16);}function packI32(n){return[n>>24&0xff,n>>16&0xff,n>>8&0xff,n&0xff];}function unpackI32(bytes){return as_signed(bytes[0]<<24|bytes[1]<<16|bytes[2]<<8|bytes[3],32);}function packU32(n){return[n>>24&0xff,n>>16&0xff,n>>8&0xff,n&0xff];}function unpackU32(bytes){return as_unsigned(bytes[0]<<24|bytes[1]<<16|bytes[2]<<8|bytes[3],32);}function packIEEE754(v,ebits,fbits){var bias=(1<<ebits-1)-1,s,e,f,ln,i,bits,str,bytes;function roundToEven(n){var w=floor(n),f=n-w;if(f<0.5)return w;if(f>0.5)return w+1;return w%2?w+1:w;}// Compute sign, exponent, fraction
	if(v!==v){// NaN
	// http://dev.w3.org/2006/webapi/WebIDL/#es-type-mapping
	e=(1<<ebits)-1;f=pow(2,fbits-1);s=0;}else if(v===Infinity||v===-Infinity){e=(1<<ebits)-1;f=0;s=v<0?1:0;}else if(v===0){e=0;f=0;s=1/v===-Infinity?1:0;}else{s=v<0;v=abs(v);if(v>=pow(2,1-bias)){e=min(floor(log(v)/LN2),1023);f=roundToEven(v/pow(2,e)*pow(2,fbits));if(f/pow(2,fbits)>=2){e=e+1;f=1;}if(e>bias){// Overflow
	e=(1<<ebits)-1;f=0;}else{// Normalized
	e=e+bias;f=f-pow(2,fbits);}}else{// Denormalized
	e=0;f=roundToEven(v/pow(2,1-bias-fbits));}}// Pack sign, exponent, fraction
	bits=[];for(i=fbits;i;i-=1){bits.push(f%2?1:0);f=floor(f/2);}for(i=ebits;i;i-=1){bits.push(e%2?1:0);e=floor(e/2);}bits.push(s?1:0);bits.reverse();str=bits.join('');// Bits to bytes
	bytes=[];while(str.length){bytes.push(parseInt(str.substring(0,8),2));str=str.substring(8);}return bytes;}function unpackIEEE754(bytes,ebits,fbits){// Bytes to bits
	var bits=[],i,j,b,str,bias,s,e,f;for(i=bytes.length;i;i-=1){b=bytes[i-1];for(j=8;j;j-=1){bits.push(b%2?1:0);b=b>>1;}}bits.reverse();str=bits.join('');// Unpack sign, exponent, fraction
	bias=(1<<ebits-1)-1;s=parseInt(str.substring(0,1),2)?-1:1;e=parseInt(str.substring(1,1+ebits),2);f=parseInt(str.substring(1+ebits),2);// Produce number
	if(e===(1<<ebits)-1){return f!==0?NaN:s*Infinity;}else if(e>0){// Normalized
	return s*pow(2,e-bias)*(1+f/pow(2,fbits));}else if(f!==0){// Denormalized
	return s*pow(2,-(bias-1))*(f/pow(2,fbits));}else{return s<0?-0:0;}}function unpackF64(b){return unpackIEEE754(b,11,52);}function packF64(v){return packIEEE754(v,11,52);}function unpackF32(b){return unpackIEEE754(b,8,23);}function packF32(v){return packIEEE754(v,8,23);}//
	// 3 The ArrayBuffer Type
	//
	(function(){function ArrayBuffer(length){length=ToInt32(length);if(length<0)throw RangeError('ArrayBuffer size is not a small enough positive integer.');Object.defineProperty(this,'byteLength',{value:length});Object.defineProperty(this,'_bytes',{value:Array(length)});for(var i=0;i<length;i+=1){this._bytes[i]=0;}}global.ArrayBuffer=global.ArrayBuffer||ArrayBuffer;//
	// 5 The Typed Array View Types
	//
	function $TypedArray$(){// %TypedArray% ( length )
	if(!arguments.length||_typeof(arguments[0])!=='object'){return function(length){length=ToInt32(length);if(length<0)throw RangeError('length is not a small enough positive integer.');Object.defineProperty(this,'length',{value:length});Object.defineProperty(this,'byteLength',{value:length*this.BYTES_PER_ELEMENT});Object.defineProperty(this,'buffer',{value:new ArrayBuffer(this.byteLength)});Object.defineProperty(this,'byteOffset',{value:0});}.apply(this,arguments);}// %TypedArray% ( typedArray )
	if(arguments.length>=1&&Type(arguments[0])==='object'&&arguments[0]instanceof $TypedArray$){return function(typedArray){if(this.constructor!==typedArray.constructor)throw TypeError();var byteLength=typedArray.length*this.BYTES_PER_ELEMENT;Object.defineProperty(this,'buffer',{value:new ArrayBuffer(byteLength)});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:0});Object.defineProperty(this,'length',{value:typedArray.length});for(var i=0;i<this.length;i+=1){this._setter(i,typedArray._getter(i));}}.apply(this,arguments);}// %TypedArray% ( array )
	if(arguments.length>=1&&Type(arguments[0])==='object'&&!(arguments[0]instanceof $TypedArray$)&&!(arguments[0]instanceof ArrayBuffer||Class(arguments[0])==='ArrayBuffer')){return function(array){var byteLength=array.length*this.BYTES_PER_ELEMENT;Object.defineProperty(this,'buffer',{value:new ArrayBuffer(byteLength)});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:0});Object.defineProperty(this,'length',{value:array.length});for(var i=0;i<this.length;i+=1){var s=array[i];this._setter(i,Number(s));}}.apply(this,arguments);}// %TypedArray% ( buffer, byteOffset=0, length=undefined )
	if(arguments.length>=1&&Type(arguments[0])==='object'&&(arguments[0]instanceof ArrayBuffer||Class(arguments[0])==='ArrayBuffer')){return function(buffer,byteOffset,length){byteOffset=ToUint32(byteOffset);if(byteOffset>buffer.byteLength)throw RangeError('byteOffset out of range');// The given byteOffset must be a multiple of the element
	// size of the specific type, otherwise an exception is raised.
	if(byteOffset%this.BYTES_PER_ELEMENT)throw RangeError('buffer length minus the byteOffset is not a multiple of the element size.');if(length===undefined){var byteLength=buffer.byteLength-byteOffset;if(byteLength%this.BYTES_PER_ELEMENT)throw RangeError('length of buffer minus byteOffset not a multiple of the element size');length=byteLength/this.BYTES_PER_ELEMENT;}else{length=ToUint32(length);byteLength=length*this.BYTES_PER_ELEMENT;}if(byteOffset+byteLength>buffer.byteLength)throw RangeError('byteOffset and length reference an area beyond the end of the buffer');Object.defineProperty(this,'buffer',{value:buffer});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:byteOffset});Object.defineProperty(this,'length',{value:length});}.apply(this,arguments);}// %TypedArray% ( all other argument combinations )
	throw TypeError();}// Properties of the %TypedArray Instrinsic Object
	// %TypedArray%.from ( source , mapfn=undefined, thisArg=undefined )
	Object.defineProperty($TypedArray$,'from',{value:function value(iterable){return new this(iterable);}});// %TypedArray%.of ( ...items )
	Object.defineProperty($TypedArray$,'of',{value:function value()/*...items*/{return new this(arguments);}});// %TypedArray%.prototype
	var $TypedArrayPrototype$={};$TypedArray$.prototype=$TypedArrayPrototype$;// WebIDL: getter type (unsigned long index);
	Object.defineProperty($TypedArray$.prototype,'_getter',{value:function value(index){if(arguments.length<1)throw SyntaxError('Not enough arguments');index=ToUint32(index);if(index>=this.length)return undefined;var bytes=[],i,o;for(i=0,o=this.byteOffset+index*this.BYTES_PER_ELEMENT;i<this.BYTES_PER_ELEMENT;i+=1,o+=1){bytes.push(this.buffer._bytes[o]);}return this._unpack(bytes);}});// NONSTANDARD: convenience alias for getter: type get(unsigned long index);
	Object.defineProperty($TypedArray$.prototype,'get',{value:$TypedArray$.prototype._getter});// WebIDL: setter void (unsigned long index, type value);
	Object.defineProperty($TypedArray$.prototype,'_setter',{value:function value(index,_value){if(arguments.length<2)throw SyntaxError('Not enough arguments');index=ToUint32(index);if(index>=this.length)return;var bytes=this._pack(_value),i,o;for(i=0,o=this.byteOffset+index*this.BYTES_PER_ELEMENT;i<this.BYTES_PER_ELEMENT;i+=1,o+=1){this.buffer._bytes[o]=bytes[i];}}});// get %TypedArray%.prototype.buffer
	// get %TypedArray%.prototype.byteLength
	// get %TypedArray%.prototype.byteOffset
	// -- applied directly to the object in the constructor
	// %TypedArray%.prototype.constructor
	Object.defineProperty($TypedArray$.prototype,'constructor',{value:$TypedArray$});// %TypedArray%.prototype.copyWithin (target, start, end = this.length )
	Object.defineProperty($TypedArray$.prototype,'copyWithin',{value:function value(m_target,m_start){var m_end=arguments[2];var m_o=ToObject(this);var lenVal=m_o.length;var m_len=ToUint32(lenVal);m_len=max(m_len,0);var relativeTarget=ToInt32(m_target);var m_to;if(relativeTarget<0){m_to=max(m_len+relativeTarget,0);}else{m_to=min(relativeTarget,m_len);}var relativeStart=ToInt32(m_start);var m_from;if(relativeStart<0){m_from=max(m_len+relativeStart,0);}else{m_from=min(relativeStart,m_len);}var relativeEnd;if(m_end===undefined){relativeEnd=m_len;}else{relativeEnd=ToInt32(m_end);}var m_final;if(relativeEnd<0){m_final=max(m_len+relativeEnd,0);}else{m_final=min(relativeEnd,m_len);}var m_count=min(m_final-m_from,m_len-m_to);var direction;if(from<m_to&&m_to<m_from+m_count){direction=-1;m_from=m_from+m_count-1;m_to=m_to+m_count-1;}else{direction=1;}while(count>0){m_o._setter(m_to,m_o._getter(m_from));m_from=m_from+direction;m_to=m_to+direction;m_count=m_count-1;}return m_o;}});// %TypedArray%.prototype.entries ( )
	// -- defined in es6.js to shim browsers w/ native TypedArrays
	// %TypedArray%.prototype.every ( callbackfn, thisArg = undefined )
	Object.defineProperty($TypedArray$.prototype,'every',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var thisArg=arguments[1];for(var i=0;i<len;i++){if(!callbackfn.call(thisArg,t._getter(i),i,t))return false;}return true;}});// %TypedArray%.prototype.fill (value, start = 0, end = this.length )
	Object.defineProperty($TypedArray$.prototype,'fill',{value:function value(_value2){var m_start=arguments[1],m_end=arguments[2];var m_o=ToObject(this);var lenVal=m_o.length;var m_len=ToUint32(lenVal);m_len=max(m_len,0);var relativeStart=ToInt32(m_start);var m_k;if(relativeStart<0){m_k=max(m_len+relativeStart,0);}else{m_k=min(relativeStart,m_len);}var relativeEnd;if(m_end===undefined){relativeEnd=m_len;}else{relativeEnd=ToInt32(m_end);}var m_final;if(relativeEnd<0){m_final=max(m_len+relativeEnd,0);}else{m_final=min(relativeEnd,m_len);}while(m_k<m_final){m_o._setter(m_k,_value2);m_k+=1;}return m_o;}});// %TypedArray%.prototype.filter ( callbackfn, thisArg = undefined )
	Object.defineProperty($TypedArray$.prototype,'filter',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var res=[];var thisp=arguments[1];for(var i=0;i<len;i++){var val=t._getter(i);// in case fun mutates this
	if(callbackfn.call(thisp,val,i,t))res.push(val);}return new this.constructor(res);}});// %TypedArray%.prototype.find (predicate, thisArg = undefined)
	Object.defineProperty($TypedArray$.prototype,'find',{value:function value(predicate){var o=ToObject(this);var lenValue=o.length;var len=ToUint32(lenValue);if(!IsCallable(predicate))throw TypeError();var t=arguments.length>1?arguments[1]:undefined;var k=0;while(k<len){var kValue=o._getter(k);var testResult=predicate.call(t,kValue,k,o);if(Boolean(testResult))return kValue;++k;}return undefined;}});// %TypedArray%.prototype.findIndex ( predicate, thisArg = undefined )
	Object.defineProperty($TypedArray$.prototype,'findIndex',{value:function value(predicate){var o=ToObject(this);var lenValue=o.length;var len=ToUint32(lenValue);if(!IsCallable(predicate))throw TypeError();var t=arguments.length>1?arguments[1]:undefined;var k=0;while(k<len){var kValue=o._getter(k);var testResult=predicate.call(t,kValue,k,o);if(Boolean(testResult))return k;++k;}return-1;}});// %TypedArray%.prototype.forEach ( callbackfn, thisArg = undefined )
	Object.defineProperty($TypedArray$.prototype,'forEach',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var thisp=arguments[1];for(var i=0;i<len;i++){callbackfn.call(thisp,t._getter(i),i,t);}}});// %TypedArray%.prototype.indexOf (searchElement, fromIndex = 0 )
	Object.defineProperty($TypedArray$.prototype,'indexOf',{value:function value(searchElement){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(len===0)return-1;var no=0;var na;if(arguments.length>0){na=Number(arguments[1]);if(na!==no){no=0;}else if(na!==0&&na!==1/0&&na!==-(1/0)){no=(na>0||-1)*floor(abs(na));}}if(no>=len)return-1;var k=no>=0?no:max(len-abs(no),0);for(;k<len;k++){if(t._getter(k)===searchElement){return k;}}return-1;}});// %TypedArray%.prototype.join ( separator )
	Object.defineProperty($TypedArray$.prototype,'join',{value:function value(separator){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);var tmp=Array(len);for(var i=0;i<len;++i){tmp[i]=t._getter(i);}return tmp.join(separator===undefined?',':separator);// Hack for IE7
	}});// %TypedArray%.prototype.keys ( )
	// -- defined in es6.js to shim browsers w/ native TypedArrays
	// %TypedArray%.prototype.lastIndexOf ( searchElement, fromIndex = this.length-1 )
	Object.defineProperty($TypedArray$.prototype,'lastIndexOf',{value:function value(searchElement){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(len===0)return-1;var n=len;if(arguments.length>1){n=Number(arguments[1]);if(n!==n){n=0;}else if(n!==0&&n!==1/0&&n!==-(1/0)){n=(n>0||-1)*floor(abs(n));}}var k=n>=0?min(n,len-1):len-abs(n);for(;k>=0;k--){if(t._getter(k)===searchElement)return k;}return-1;}});// get %TypedArray%.prototype.length
	// -- applied directly to the object in the constructor
	// %TypedArray%.prototype.map ( callbackfn, thisArg = undefined )
	Object.defineProperty($TypedArray$.prototype,'map',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var res=[];res.length=len;var thisp=arguments[1];for(var i=0;i<len;i++){res[i]=callbackfn.call(thisp,t._getter(i),i,t);}return new this.constructor(res);}});// %TypedArray%.prototype.reduce ( callbackfn [, initialValue] )
	Object.defineProperty($TypedArray$.prototype,'reduce',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();// no value to return if no initial value and an empty array
	if(len===0&&arguments.length===1)throw TypeError();var k=0;var accumulator;if(arguments.length>=2){accumulator=arguments[1];}else{accumulator=t._getter(k++);}while(k<len){accumulator=callbackfn.call(undefined,accumulator,t._getter(k),k,t);k++;}return accumulator;}});// %TypedArray%.prototype.reduceRight ( callbackfn [, initialValue] )
	Object.defineProperty($TypedArray$.prototype,'reduceRight',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();// no value to return if no initial value, empty array
	if(len===0&&arguments.length===1)throw TypeError();var k=len-1;var accumulator;if(arguments.length>=2){accumulator=arguments[1];}else{accumulator=t._getter(k--);}while(k>=0){accumulator=callbackfn.call(undefined,accumulator,t._getter(k),k,t);k--;}return accumulator;}});// %TypedArray%.prototype.reverse ( )
	Object.defineProperty($TypedArray$.prototype,'reverse',{value:function value(){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);var half=floor(len/2);for(var i=0,j=len-1;i<half;++i,--j){var tmp=t._getter(i);t._setter(i,t._getter(j));t._setter(j,tmp);}return t;}});// %TypedArray%.prototype.set(array, offset = 0 )
	// %TypedArray%.prototype.set(typedArray, offset = 0 )
	// WebIDL: void set(TypedArray array, optional unsigned long offset);
	// WebIDL: void set(sequence<type> array, optional unsigned long offset);
	Object.defineProperty($TypedArray$.prototype,'set',{value:function value(index,_value3){if(arguments.length<1)throw SyntaxError('Not enough arguments');var array,sequence,offset,len,i,s,d,byteOffset,byteLength,tmp;if(_typeof(arguments[0])==='object'&&arguments[0].constructor===this.constructor){// void set(TypedArray array, optional unsigned long offset);
	array=arguments[0];offset=ToUint32(arguments[1]);if(offset+array.length>this.length){throw RangeError('Offset plus length of array is out of range');}byteOffset=this.byteOffset+offset*this.BYTES_PER_ELEMENT;byteLength=array.length*this.BYTES_PER_ELEMENT;if(array.buffer===this.buffer){tmp=[];for(i=0,s=array.byteOffset;i<byteLength;i+=1,s+=1){tmp[i]=array.buffer._bytes[s];}for(i=0,d=byteOffset;i<byteLength;i+=1,d+=1){this.buffer._bytes[d]=tmp[i];}}else{for(i=0,s=array.byteOffset,d=byteOffset;i<byteLength;i+=1,s+=1,d+=1){this.buffer._bytes[d]=array.buffer._bytes[s];}}}else if(_typeof(arguments[0])==='object'&&typeof arguments[0].length!=='undefined'){// void set(sequence<type> array, optional unsigned long offset);
	sequence=arguments[0];len=ToUint32(sequence.length);offset=ToUint32(arguments[1]);if(offset+len>this.length){throw RangeError('Offset plus length of array is out of range');}for(i=0;i<len;i+=1){s=sequence[i];this._setter(offset+i,Number(s));}}else{throw TypeError('Unexpected argument type(s)');}}});// %TypedArray%.prototype.slice ( start, end )
	Object.defineProperty($TypedArray$.prototype,'slice',{value:function value(m_start,m_end){var m_o=ToObject(this);var lenVal=m_o.length;var m_len=ToUint32(lenVal);var relativeStart=ToInt32(m_start);var m_k=relativeStart<0?max(m_len+relativeStart,0):min(relativeStart,m_len);var relativeEnd=m_end===undefined?m_len:ToInt32(m_end);var m_final=relativeEnd<0?max(m_len+relativeEnd,0):min(relativeEnd,m_len);var m_count=m_final-m_k;var m_c=m_o.constructor;var m_a=new m_c(m_count);var m_n=0;while(m_k<m_final){var kValue=m_o._getter(m_k);m_a._setter(m_n,kValue);++m_k;++m_n;}return m_a;}});// %TypedArray%.prototype.some ( callbackfn, thisArg = undefined )
	Object.defineProperty($TypedArray$.prototype,'some',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var thisp=arguments[1];for(var i=0;i<len;i++){if(callbackfn.call(thisp,t._getter(i),i,t)){return true;}}return false;}});// %TypedArray%.prototype.sort ( comparefn )
	Object.defineProperty($TypedArray$.prototype,'sort',{value:function value(comparefn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);var tmp=Array(len);for(var i=0;i<len;++i){tmp[i]=t._getter(i);}if(comparefn)tmp.sort(comparefn);else tmp.sort();// Hack for IE8/9
	for(i=0;i<len;++i){t._setter(i,tmp[i]);}return t;}});// %TypedArray%.prototype.subarray(begin = 0, end = this.length )
	// WebIDL: TypedArray subarray(long begin, optional long end);
	Object.defineProperty($TypedArray$.prototype,'subarray',{value:function value(start,end){function clamp(v,min,max){return v<min?min:v>max?max:v;}start=ToInt32(start);end=ToInt32(end);if(arguments.length<1){start=0;}if(arguments.length<2){end=this.length;}if(start<0){start=this.length+start;}if(end<0){end=this.length+end;}start=clamp(start,0,this.length);end=clamp(end,0,this.length);var len=end-start;if(len<0){len=0;}return new this.constructor(this.buffer,this.byteOffset+start*this.BYTES_PER_ELEMENT,len);}});// %TypedArray%.prototype.toLocaleString ( )
	// %TypedArray%.prototype.toString ( )
	// %TypedArray%.prototype.values ( )
	// %TypedArray%.prototype [ @@iterator ] ( )
	// get %TypedArray%.prototype [ @@toStringTag ]
	// -- defined in es6.js to shim browsers w/ native TypedArrays
	function makeTypedArray(elementSize,pack,unpack){// Each TypedArray type requires a distinct constructor instance with
	// identical logic, which this produces.
	var TypedArray=function TypedArray(){Object.defineProperty(this,'constructor',{value:TypedArray});$TypedArray$.apply(this,arguments);makeArrayAccessors(this);};if('__proto__'in TypedArray){TypedArray.__proto__=$TypedArray$;}else{TypedArray.from=$TypedArray$.from;TypedArray.of=$TypedArray$.of;}TypedArray.BYTES_PER_ELEMENT=elementSize;var TypedArrayPrototype=function TypedArrayPrototype(){};TypedArrayPrototype.prototype=$TypedArrayPrototype$;TypedArray.prototype=new TypedArrayPrototype();Object.defineProperty(TypedArray.prototype,'BYTES_PER_ELEMENT',{value:elementSize});Object.defineProperty(TypedArray.prototype,'_pack',{value:pack});Object.defineProperty(TypedArray.prototype,'_unpack',{value:unpack});return TypedArray;}var Int8Array=makeTypedArray(1,packI8,unpackI8);var Uint8Array=makeTypedArray(1,packU8,unpackU8);var Uint8ClampedArray=makeTypedArray(1,packU8Clamped,unpackU8);var Int16Array=makeTypedArray(2,packI16,unpackI16);var Uint16Array=makeTypedArray(2,packU16,unpackU16);var Int32Array=makeTypedArray(4,packI32,unpackI32);var Uint32Array=makeTypedArray(4,packU32,unpackU32);var Float32Array=makeTypedArray(4,packF32,unpackF32);var Float64Array=makeTypedArray(8,packF64,unpackF64);global.Int8Array=win.Int8Array=global.Int8Array||Int8Array;global.Uint8Array=win.Uint8Array=global.Uint8Array||Uint8Array;global.Uint8ClampedArray=win.Uint8ClampedArray=global.Uint8ClampedArray||Uint8ClampedArray;global.Int16Array=win.Int16Array=global.Int16Array||Int16Array;global.Uint16Array=win.Uint16Array=global.Uint16Array||Uint16Array;global.Int32Array=win.Int32Array=global.Int32Array||Int32Array;global.Uint32Array=win.Uint32Array=global.Uint32Array||Uint32Array;global.Float32Array=win.Float32Array=global.Float32Array||Float32Array;global.Float64Array=win.Float64Array=global.Float64Array||Float64Array;})();//
	// 6 The DataView View Type
	//
	(function(){function r(array,index){return IsCallable(array.get)?array.get(index):array[index];}var IS_BIG_ENDIAN=function(){var u16array=new global.Uint16Array([0x1234]),u8array=new global.Uint8Array(u16array.buffer);return r(u8array,0)===0x12;}();// DataView(buffer, byteOffset=0, byteLength=undefined)
	// WebIDL: Constructor(ArrayBuffer buffer,
	//                     optional unsigned long byteOffset,
	//                     optional unsigned long byteLength)
	function DataView(buffer,byteOffset,byteLength){if(!(buffer instanceof ArrayBuffer||Class(buffer)==='ArrayBuffer'))throw TypeError();byteOffset=ToUint32(byteOffset);if(byteOffset>buffer.byteLength)throw RangeError('byteOffset out of range');if(byteLength===undefined)byteLength=buffer.byteLength-byteOffset;else byteLength=ToUint32(byteLength);if(byteOffset+byteLength>buffer.byteLength)throw RangeError('byteOffset and length reference an area beyond the end of the buffer');Object.defineProperty(this,'buffer',{value:buffer});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:byteOffset});};// get DataView.prototype.buffer
	// get DataView.prototype.byteLength
	// get DataView.prototype.byteOffset
	// -- applied directly to instances by the constructor
	function makeGetter(arrayType){return function GetViewValue(byteOffset,littleEndian){byteOffset=ToUint32(byteOffset);if(byteOffset+arrayType.BYTES_PER_ELEMENT>this.byteLength)throw RangeError('Array index out of range');byteOffset+=this.byteOffset;var uint8Array=new global.Uint8Array(this.buffer,byteOffset,arrayType.BYTES_PER_ELEMENT),bytes=[];for(var i=0;i<arrayType.BYTES_PER_ELEMENT;i+=1){bytes.push(r(uint8Array,i));}if(Boolean(littleEndian)===Boolean(IS_BIG_ENDIAN))bytes.reverse();return r(new arrayType(new global.Uint8Array(bytes).buffer),0);};}Object.defineProperty(DataView.prototype,'getUint8',{value:makeGetter(global.Uint8Array)});Object.defineProperty(DataView.prototype,'getInt8',{value:makeGetter(global.Int8Array)});Object.defineProperty(DataView.prototype,'getUint16',{value:makeGetter(global.Uint16Array)});Object.defineProperty(DataView.prototype,'getInt16',{value:makeGetter(global.Int16Array)});Object.defineProperty(DataView.prototype,'getUint32',{value:makeGetter(global.Uint32Array)});Object.defineProperty(DataView.prototype,'getInt32',{value:makeGetter(global.Int32Array)});Object.defineProperty(DataView.prototype,'getFloat32',{value:makeGetter(global.Float32Array)});Object.defineProperty(DataView.prototype,'getFloat64',{value:makeGetter(global.Float64Array)});function makeSetter(arrayType){return function SetViewValue(byteOffset,value,littleEndian){byteOffset=ToUint32(byteOffset);if(byteOffset+arrayType.BYTES_PER_ELEMENT>this.byteLength)throw RangeError('Array index out of range');// Get bytes
	var typeArray=new arrayType([value]),byteArray=new global.Uint8Array(typeArray.buffer),bytes=[],i,byteView;for(i=0;i<arrayType.BYTES_PER_ELEMENT;i+=1){bytes.push(r(byteArray,i));}// Flip if necessary
	if(Boolean(littleEndian)===Boolean(IS_BIG_ENDIAN))bytes.reverse();// Write them
	byteView=new Uint8Array(this.buffer,byteOffset,arrayType.BYTES_PER_ELEMENT);byteView.set(bytes);};}Object.defineProperty(DataView.prototype,'setUint8',{value:makeSetter(global.Uint8Array)});Object.defineProperty(DataView.prototype,'setInt8',{value:makeSetter(global.Int8Array)});Object.defineProperty(DataView.prototype,'setUint16',{value:makeSetter(global.Uint16Array)});Object.defineProperty(DataView.prototype,'setInt16',{value:makeSetter(global.Int16Array)});Object.defineProperty(DataView.prototype,'setUint32',{value:makeSetter(global.Uint32Array)});Object.defineProperty(DataView.prototype,'setInt32',{value:makeSetter(global.Int32Array)});Object.defineProperty(DataView.prototype,'setFloat32',{value:makeSetter(global.Float32Array)});Object.defineProperty(DataView.prototype,'setFloat64',{value:makeSetter(global.Float64Array)});global.DataView=global.DataView||DataView;})();})(exports,window);}// workaround for crypto-js on IE11
	// http://code.google.com/p/crypto-js/issues/detail?id=81
	if(typeof window!=="undefined"){if(!('Uint8ClampedArray'in window)){window.Uint8ClampedArray=window.Uint8Array;}}},{}],16:[function(require,module,exports){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var log=require('./log.js');// generate a WAMP ID: this might be serializer specific, as
	// we need to enforce encoding into an integer, not float
	// eg we need to do some extra stuff for msgpack (json and
	// cbor are fine "as is")
	function newid(){return Math.floor(Math.random()*9007199254740992);}function JSONSerializer(replacer,reviver){this.replacer=replacer;this.reviver=reviver;this.SERIALIZER_ID='json';this.BINARY=false;// JSON encoder does not need anything special here
	this.newid=newid;}JSONSerializer.prototype.serialize=function(obj){try{var payload=JSON.stringify(obj,this.replacer);return payload;}catch(e){log.warn('JSON encoding error',e);throw e;}};JSONSerializer.prototype.unserialize=function(payload){try{var obj=JSON.parse(payload,this.reviver);return obj;}catch(e){log.warn('JSON decoding error',e);throw e;}};exports.JSONSerializer=JSONSerializer;// https://github.com/kawanet/msgpack-lite/
	// https://github.com/kawanet/int64-buffer
	var msgpack=require('msgpack-lite');// this is needed for correct msgpack serialization of WAMP session IDs
	var Uint64BE=require('int64-buffer').Uint64BE;function MsgpackSerializer(){this.SERIALIZER_ID='msgpack';this.BINARY=true;this.codec=msgpack.createCodec();// msgpack: Uint64BE ensures that ID is encoded as int instead of double
	this.newid=function(){return new Uint64BE(newid());};}MsgpackSerializer.prototype.serialize=function(obj){try{var payload=msgpack.encode(obj,{codec:this.codec});return payload;}catch(e){log.warn('MessagePack encoding error',e);throw e;}};MsgpackSerializer.prototype.unserialize=function(payload){try{// need to encapsulate ArrayBuffer into Uint8Array for msgpack decoding
	// https://github.com/kawanet/msgpack-lite/issues/44
	var obj=msgpack.decode(new Uint8Array(payload),{codec:this.codec});return obj;}catch(e){log.warn('MessagePack decoding error',e);throw e;}};/**
	 * Register a packer and/or unpacker functions for a given type.
	 *
	 * The msgpack specification allows applications to register up to 128 extension
	 * types.
	 *
	 * @param code numeric extension code (between 0-127)
	 * @param type constructor for the given type (only required when packer is defined)
	 * @param packer a function that takes an object and returns a Buffer
	 * @param unpacker a function that takes a Buffer and returns an instance of the given type
	 */MsgpackSerializer.prototype.registerExtType=function(code,type,packer,unpacker){if(packer&&type){this.codec.addExtPacker(code,type,packer);}if(unpacker){this.codec.addExtUnpacker(code,unpacker);}};exports.MsgpackSerializer=MsgpackSerializer;// http://hildjj.github.io/node-cbor/
	var cbor=require('cbor');function CBORSerializer(){this.SERIALIZER_ID='cbor';this.BINARY=true;// CBOR encoder does not need anything special here
	this.newid=newid;}CBORSerializer.prototype.serialize=function(obj){try{var payload=cbor.encode(obj);return payload;}catch(e){log.warn('CBOR encoding error',e);throw e;}};CBORSerializer.prototype.unserialize=function(payload){try{//var obj = cbor.decodeAllSync(payload)[0];
	var obj=cbor.decodeFirstSync(payload);return obj;}catch(e){log.warn('CBOR decoding error',e);throw e;}};exports.CBORSerializer=CBORSerializer;},{"./log.js":7,"cbor":28,"int64-buffer":77,"msgpack-lite":80}],17:[function(require,module,exports){(function(global){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	// require('assert') would be nice .. but it does not
	// work with Google Closure after Browserify
	var when=require('when');var when_fn=require("when/function");var log=require('./log.js');var util=require('./util.js');// IE fallback (http://afuchs.tumblr.com/post/23550124774/date-now-in-ie8)
	Date.now=Date.now||function(){return+new Date();};// WAMP "Advanced Profile" support in AutobahnJS per role
	//
	var WAMP_FEATURES={caller:{features:{caller_identification:true,//call_timeout: true,
	//call_canceling: true,
	progressive_call_results:true}},callee:{features:{caller_identification:true,//call_trustlevels: true,
	pattern_based_registration:true,shared_registration:true,//call_timeout: true,
	//call_canceling: true,
	progressive_call_results:true,registration_revocation:true}},publisher:{features:{publisher_identification:true,subscriber_blackwhite_listing:true,publisher_exclusion:true}},subscriber:{features:{publisher_identification:true,//publication_trustlevels: true,
	pattern_based_subscription:true,subscription_revocation:true//event_history: true,
	}}};var Invocation=function Invocation(procedure,progress,caller,caller_authid,caller_authrole){var self=this;self.procedure=procedure;self.progress=progress;self.caller=caller;self.caller_authid=caller_authid;self.caller_authrole=caller_authrole;};var Event=function Event(publication,topic,publisher,publisher_authid,publisher_authrole,retained){var self=this;self.publication=publication;self.topic=topic;self.publisher=publisher;self.publisher_authid=publisher_authid;self.publisher_authrole=publisher_authrole;self.retained=retained;};var Result=function Result(args,kwargs){var self=this;self.args=args||[];self.kwargs=kwargs||{};};var Error=function Error(error,args,kwargs){var self=this;self.error=error;self.args=args||[];self.kwargs=kwargs||{};};var Subscription=function Subscription(topic,handler,options,session,id){var self=this;self.topic=topic;self.handler=handler;self.options=options||{};self.session=session;self.id=id;self.active=true;// this will fire when the handler is unsubscribed
	self._on_unsubscribe=session._defer();if(self._on_unsubscribe.promise.then){// whenjs has the actual user promise in an attribute
	self.on_unsubscribe=self._on_unsubscribe.promise;}else{self.on_unsubscribe=self._on_unsubscribe;}};Subscription.prototype.unsubscribe=function(){var self=this;return self.session.unsubscribe(self);};var Registration=function Registration(procedure,endpoint,options,session,id){var self=this;self.procedure=procedure;self.endpoint=endpoint;self.options=options||{};self.session=session;self.id=id;self.active=true;// this will fire when the endpoint is unregistered
	self._on_unregister=session._defer();if(self._on_unregister.promise.then){// whenjs has the actual user promise in an attribute
	self.on_unregister=self._on_unregister.promise;}else{self.on_unregister=self._on_unregister;}};Registration.prototype.unregister=function(){var self=this;return self.session.unregister(self);};var Publication=function Publication(id){var self=this;self.id=id;};var MSG_TYPE={HELLO:1,WELCOME:2,ABORT:3,CHALLENGE:4,AUTHENTICATE:5,GOODBYE:6,HEARTBEAT:7,ERROR:8,PUBLISH:16,PUBLISHED:17,SUBSCRIBE:32,SUBSCRIBED:33,UNSUBSCRIBE:34,UNSUBSCRIBED:35,EVENT:36,CALL:48,CANCEL:49,RESULT:50,REGISTER:64,REGISTERED:65,UNREGISTER:66,UNREGISTERED:67,INVOCATION:68,INTERRUPT:69,YIELD:70};var Session=function Session(socket,defer,onchallenge){var self=this;// the transport connection (WebSocket object)
	self._socket=socket;// the Deferred factory to use
	self._defer=defer;// the WAMP authentication challenge handler
	self._onchallenge=onchallenge;// the WAMP session ID
	self._id=null;// the WAMP realm joined
	self._realm=null;// the WAMP features in use
	self._features=null;// closing state
	self._goodbye_sent=false;self._transport_is_closing=false;// outstanding requests;
	self._publish_reqs={};self._subscribe_reqs={};self._unsubscribe_reqs={};self._call_reqs={};self._register_reqs={};self._unregister_reqs={};// subscriptions in place;
	self._subscriptions={};// registrations in place;
	self._registrations={};// incoming invocations;
	self._invocations={};// prefix shortcuts for URIs
	self._prefixes={};// the defaults for 'disclose_me'
	self._caller_disclose_me=false;self._publisher_disclose_me=false;self._send_wamp=function(msg){log.debug(msg);// forward WAMP message to be sent to WAMP transport
	self._socket.send(msg);};self._protocol_violation=function(reason){log.warn("failing transport due to protocol violation: "+reason);self._socket.close(1002,"protocol violation: "+reason);};self._MESSAGE_MAP={};self._MESSAGE_MAP[MSG_TYPE.ERROR]={};self._process_SUBSCRIBED=function(msg){//
	// process SUBSCRIBED reply to SUBSCRIBE
	//
	var request=msg[1];var subscription=msg[2];if(request in self._subscribe_reqs){var r=self._subscribe_reqs[request];var d=r[0];var topic=r[1];var handler=r[2];var options=r[3];if(!(subscription in self._subscriptions)){self._subscriptions[subscription]=[];}var sub=new Subscription(topic,handler,options,self,subscription);self._subscriptions[subscription].push(sub);d.resolve(sub);delete self._subscribe_reqs[request];}else{self._protocol_violation("SUBSCRIBED received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.SUBSCRIBED]=self._process_SUBSCRIBED;self._process_SUBSCRIBE_ERROR=function(msg){//
	// process ERROR reply to SUBSCRIBE
	//
	var request=msg[2];if(request in self._subscribe_reqs){var details=msg[3];var error=new Error(msg[4],msg[5],msg[6]);var r=self._subscribe_reqs[request];var d=r[0];d.reject(error);delete self._subscribe_reqs[request];}else{self._protocol_violation("SUBSCRIBE-ERROR received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.SUBSCRIBE]=self._process_SUBSCRIBE_ERROR;self._process_UNSUBSCRIBED=function(msg){//
	// process UNSUBSCRIBED reply to UNSUBSCRIBE
	//
	var request=msg[1];if(request in self._unsubscribe_reqs){var r=self._unsubscribe_reqs[request];var d=r[0];var subscription_id=r[1];if(subscription_id in self._subscriptions){var subs=self._subscriptions[subscription_id];// the following should actually be NOP, since UNSUBSCRIBE was
	// only sent when subs got empty
	for(var i=0;i<subs.length;++i){subs[i].active=false;subs[i].on_unsubscribe.resolve();}delete self._subscriptions[subscription_id];}d.resolve(true);delete self._unsubscribe_reqs[request];}else{if(request===0){// router actively revoked our subscription
	//
	var details=msg[2];var subscription_id=details.subscription;var reason=details.reason;if(subscription_id in self._subscriptions){var subs=self._subscriptions[subscription_id];for(var i=0;i<subs.length;++i){subs[i].active=false;subs[i]._on_unsubscribe.resolve(reason);}delete self._subscriptions[subscription_id];}else{self._protocol_violation("non-voluntary UNSUBSCRIBED received for non-existing subscription ID "+subscription_id);}}else{self._protocol_violation("UNSUBSCRIBED received for non-pending request ID "+request);}}};self._MESSAGE_MAP[MSG_TYPE.UNSUBSCRIBED]=self._process_UNSUBSCRIBED;self._process_UNSUBSCRIBE_ERROR=function(msg){//
	// process ERROR reply to UNSUBSCRIBE
	//
	var request=msg[2];if(request in self._unsubscribe_reqs){var details=msg[3];var error=new Error(msg[4],msg[5],msg[6]);var r=self._unsubscribe_reqs[request];var d=r[0];var subscription=r[1];d.reject(error);delete self._unsubscribe_reqs[request];}else{self._protocol_violation("UNSUBSCRIBE-ERROR received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.UNSUBSCRIBE]=self._process_UNSUBSCRIBE_ERROR;self._process_PUBLISHED=function(msg){//
	// process PUBLISHED reply to PUBLISH
	//
	var request=msg[1];var publication=msg[2];if(request in self._publish_reqs){var r=self._publish_reqs[request];var d=r[0];var options=r[1];var pub=new Publication(publication);d.resolve(pub);delete self._publish_reqs[request];}else{self._protocol_violation("PUBLISHED received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.PUBLISHED]=self._process_PUBLISHED;self._process_PUBLISH_ERROR=function(msg){//
	// process ERROR reply to PUBLISH
	//
	var request=msg[2];if(request in self._publish_reqs){var details=msg[3];var error=new Error(msg[4],msg[5],msg[6]);var r=self._publish_reqs[request];var d=r[0];var options=r[1];d.reject(error);delete self._publish_reqs[request];}else{self._protocol_violation("PUBLISH-ERROR received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.PUBLISH]=self._process_PUBLISH_ERROR;self._process_EVENT=function(msg){//
	// process EVENT message
	//
	// [EVENT, SUBSCRIBED.Subscription|id, PUBLISHED.Publication|id, Details|dict, PUBLISH.Arguments|list, PUBLISH.ArgumentsKw|dict]
	var subscription=msg[1];if(subscription in self._subscriptions){var publication=msg[2];var details=msg[3];var args=msg[4]||[];var kwargs=msg[5]||{};var subs=self._subscriptions[subscription];// we want to provide the subscription topic to the handler, and may need to get this
	// from one of the subscription handler objects attached to the subscription
	// since for non-pattern subscriptions this is not sent over the wire
	var ed=new Event(publication,details.topic||subs[0]&&subs[0].topic,details.publisher,details.publisher_authid,details.publisher_authrole,details.retained||false);for(var i=0;i<subs.length;++i){var sub=subs[i];try{sub.handler(args,kwargs,ed,sub);}catch(e){log.debug("Exception raised in event handler",e);}}}else{self._protocol_violation("EVENT received for non-subscribed subscription ID "+subscription);}};self._MESSAGE_MAP[MSG_TYPE.EVENT]=self._process_EVENT;self._process_REGISTERED=function(msg){//
	// process REGISTERED reply to REGISTER
	//
	var request=msg[1];var registration=msg[2];if(request in self._register_reqs){var r=self._register_reqs[request];var d=r[0];var procedure=r[1];var endpoint=r[2];var options=r[3];var reg=new Registration(procedure,endpoint,options,self,registration);self._registrations[registration]=reg;d.resolve(reg);delete self._register_reqs[request];}else{self._protocol_violation("REGISTERED received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.REGISTERED]=self._process_REGISTERED;self._process_REGISTER_ERROR=function(msg){//
	// process ERROR reply to REGISTER
	//
	var request=msg[2];if(request in self._register_reqs){var details=msg[3];var error=new Error(msg[4],msg[5],msg[6]);var r=self._register_reqs[request];var d=r[0];d.reject(error);delete self._register_reqs[request];}else{self._protocol_violation("REGISTER-ERROR received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.REGISTER]=self._process_REGISTER_ERROR;self._process_UNREGISTERED=function(msg){//
	// process UNREGISTERED reply to UNREGISTER
	//
	var request=msg[1];if(request in self._unregister_reqs){var r=self._unregister_reqs[request];var d=r[0];var registration=r[1];if(registration.id in self._registrations){delete self._registrations[registration.id];}registration.active=false;d.resolve();delete self._unregister_reqs[request];}else{if(request===0){// the router actively revoked our registration
	//
	var details=msg[2];var registration_id=details.registration;var reason=details.reason;if(registration_id in self._registrations){var registration=self._registrations[registration_id];registration.active=false;registration._on_unregister.resolve(reason);delete self._registrations[registration_id];}else{self._protocol_violation("non-voluntary UNREGISTERED received for non-existing registration ID "+registration_id);}}else{self._protocol_violation("UNREGISTERED received for non-pending request ID "+request);}}};self._MESSAGE_MAP[MSG_TYPE.UNREGISTERED]=self._process_UNREGISTERED;self._process_UNREGISTER_ERROR=function(msg){//
	// process ERROR reply to UNREGISTER
	//
	var request=msg[2];if(request in self._unregister_reqs){var details=msg[3];var error=new Error(msg[4],msg[5],msg[6]);var r=self._unregister_reqs[request];var d=r[0];var registration=r[1];d.reject(error);delete self._unregister_reqs[request];}else{self._protocol_violation("UNREGISTER-ERROR received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.UNREGISTER]=self._process_UNREGISTER_ERROR;self._process_RESULT=function(msg){//
	// process RESULT reply to CALL
	//
	var request=msg[1];if(request in self._call_reqs){var details=msg[2];var args=msg[3]||[];var kwargs=msg[4]||{};// maybe wrap complex result:
	var result=null;if(args.length>1||Object.keys(kwargs).length>0){// wrap complex result is more than 1 positional result OR
	// non-empty keyword result
	result=new Result(args,kwargs);}else if(args.length>0){// single positional result
	result=args[0];}var r=self._call_reqs[request];var d=r[0];var options=r[1];if(details.progress){if(options&&options.receive_progress){d.notify(result);}}else{d.resolve(result);delete self._call_reqs[request];}}else{self._protocol_violation("CALL-RESULT received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.RESULT]=self._process_RESULT;self._process_CALL_ERROR=function(msg){//
	// process ERROR reply to CALL
	//
	var request=msg[2];if(request in self._call_reqs){var details=msg[3];var error=new Error(msg[4],msg[5],msg[6]);var r=self._call_reqs[request];var d=r[0];var options=r[1];d.reject(error);delete self._call_reqs[request];}else{self._protocol_violation("CALL-ERROR received for non-pending request ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.CALL]=self._process_CALL_ERROR;self._process_INVOCATION=function(msg){//
	// process INVOCATION message
	//
	// [INVOCATION, Request|id, REGISTERED.Registration|id, Details|dict, CALL.Arguments|list, CALL.ArgumentsKw|dict]
	//
	var request=msg[1];var registration=msg[2];var details=msg[3];// receive_progress
	// timeout
	// caller
	if(registration in self._registrations){var reg=self._registrations[registration];var args=msg[4]||[];var kwargs=msg[5]||{};// create progress function for invocation
	//
	var progress=null;if(details.receive_progress){progress=function progress(args,kwargs){var progress_msg=[MSG_TYPE.YIELD,request,{progress:true}];args=args||[];kwargs=kwargs||{};var kwargs_len=Object.keys(kwargs).length;if(args.length||kwargs_len){progress_msg.push(args);if(kwargs_len){progress_msg.push(kwargs);}}self._send_wamp(progress_msg);};};// we want to provide the regitration procedure to the handler and may
	// need to get this from the registration object attached to the registration
	// since for non-pattern registrations this is not sent over the wire
	var cd=new Invocation(details.procedure||reg.procedure,progress,details.caller,details.caller_authid,details.caller_authrole);// We use the following whenjs call wrapper, which automatically
	// wraps a plain, non-promise value in a (immediately resolved) promise
	//
	// See: https://github.com/cujojs/when/blob/master/docs/api.md#fncall
	//
	when_fn.call(reg.endpoint,args,kwargs,cd).then(function(res){// construct YIELD message
	// FIXME: Options
	//
	var reply=[MSG_TYPE.YIELD,request,{}];if(res instanceof Result){var kwargs_len=Object.keys(res.kwargs).length;if(res.args.length||kwargs_len){reply.push(res.args);if(kwargs_len){reply.push(res.kwargs);}}}else{reply.push([res]);}// send WAMP message
	//
	self._send_wamp(reply);},function(err){// construct ERROR message
	// [ERROR, REQUEST.Type|int, REQUEST.Request|id, Details|dict, Error|uri, Arguments|list, ArgumentsKw|dict]
	var reply=[MSG_TYPE.ERROR,MSG_TYPE.INVOCATION,request,{}];if(err instanceof Error){reply.push(err.error);var kwargs_len=Object.keys(err.kwargs).length;if(err.args.length||kwargs_len){reply.push(err.args);if(kwargs_len){reply.push(err.kwargs);}}}else{reply.push('wamp.error.runtime_error');reply.push([err]);}// send WAMP message
	//
	self._send_wamp(reply);});}else{self._protocol_violation("INVOCATION received for non-registered registration ID "+request);}};self._MESSAGE_MAP[MSG_TYPE.INVOCATION]=self._process_INVOCATION;// callback fired by WAMP transport on receiving a WAMP message
	//
	self._socket.onmessage=function(msg){var msg_type=msg[0];// WAMP session not yet open
	//
	if(!self._id){// the first message must be WELCOME, ABORT or CHALLENGE ..
	//
	if(msg_type===MSG_TYPE.WELCOME){self._id=msg[1];// determine actual set of advanced features that can be used
	//
	var rf=msg[2];self._features={};if(rf.roles.broker){// "Basic Profile" is mandatory
	self._features.subscriber={};self._features.publisher={};// fill in features that both peers support
	if(rf.roles.broker.features){for(var att in WAMP_FEATURES.publisher.features){self._features.publisher[att]=WAMP_FEATURES.publisher.features[att]&&rf.roles.broker.features[att];}for(var att in WAMP_FEATURES.subscriber.features){self._features.subscriber[att]=WAMP_FEATURES.subscriber.features[att]&&rf.roles.broker.features[att];}}}if(rf.roles.dealer){// "Basic Profile" is mandatory
	self._features.caller={};self._features.callee={};// fill in features that both peers support
	if(rf.roles.dealer.features){for(var att in WAMP_FEATURES.caller.features){self._features.caller[att]=WAMP_FEATURES.caller.features[att]&&rf.roles.dealer.features[att];}for(var att in WAMP_FEATURES.callee.features){self._features.callee[att]=WAMP_FEATURES.callee.features[att]&&rf.roles.dealer.features[att];}}}if(self.onjoin){self.onjoin(msg[2]);}}else if(msg_type===MSG_TYPE.ABORT){var details=msg[1];var reason=msg[2];if(self.onleave){self.onleave(reason,details);}}else if(msg_type===MSG_TYPE.CHALLENGE){if(self._onchallenge){var method=msg[1];var extra=msg[2];when_fn.call(self._onchallenge,self,method,extra).then(function(signature){var msg=[MSG_TYPE.AUTHENTICATE,signature,{}];self._send_wamp(msg);},function(err){log.debug("onchallenge() raised:",err);var msg=[MSG_TYPE.ABORT,{message:"sorry, I cannot authenticate (onchallenge handler raised an exception)"},"wamp.error.cannot_authenticate"];self._send_wamp(msg);self._socket.close(1000);});}else{log.debug("received WAMP challenge, but no onchallenge() handler set");var msg=[MSG_TYPE.ABORT,{message:"sorry, I cannot authenticate (no onchallenge handler set)"},"wamp.error.cannot_authenticate"];self._send_wamp(msg);self._socket.close(1000);}}else{self._protocol_violation("unexpected message type "+msg_type);}// WAMP session is open
	//
	}else{if(msg_type===MSG_TYPE.GOODBYE){if(!self._goodbye_sent){var reply=[MSG_TYPE.GOODBYE,{},"wamp.error.goodbye_and_out"];self._send_wamp(reply);}self._id=null;self._realm=null;self._features=null;var details=msg[1];var reason=msg[2];if(self.onleave){self.onleave(reason,details);}}else{if(msg_type===MSG_TYPE.ERROR){var request_type=msg[1];if(request_type in self._MESSAGE_MAP[MSG_TYPE.ERROR]){self._MESSAGE_MAP[msg_type][request_type](msg);}else{self._protocol_violation("unexpected ERROR message with request_type "+request_type);}}else{if(msg_type in self._MESSAGE_MAP){self._MESSAGE_MAP[msg_type](msg);}else{self._protocol_violation("unexpected message type "+msg_type);}}}}};// session object constructed .. track creation time
	//
	if('performance'in global&&'now'in performance){self._created=performance.now();}else{self._created=Date.now();}};Object.defineProperty(Session.prototype,"defer",{get:function get(){return this._defer;}});Object.defineProperty(Session.prototype,"id",{get:function get(){return this._id;}});Object.defineProperty(Session.prototype,"realm",{get:function get(){return this._realm;}});Object.defineProperty(Session.prototype,"isOpen",{get:function get(){return this.id!==null;}});Object.defineProperty(Session.prototype,"features",{get:function get(){return this._features;}});Object.defineProperty(Session.prototype,"caller_disclose_me",{get:function get(){return this._caller_disclose_me;},set:function set(newValue){this._caller_disclose_me=newValue;}});Object.defineProperty(Session.prototype,"publisher_disclose_me",{get:function get(){return this._publisher_disclose_me;},set:function set(newValue){this._publisher_disclose_me=newValue;}});Object.defineProperty(Session.prototype,"subscriptions",{get:function get(){var keys=Object.keys(this._subscriptions);var vals=[];for(var i=0;i<keys.length;++i){vals.push(this._subscriptions[keys[i]]);}return vals;}});Object.defineProperty(Session.prototype,"registrations",{get:function get(){var keys=Object.keys(this._registrations);var vals=[];for(var i=0;i<keys.length;++i){vals.push(this._registrations[keys[i]]);}return vals;}});Session.prototype.log=function(){var self=this;if('console'in global){var header=null;if(self._id&&self._created){var now=null;if('performance'in global&&'now'in performance){now=performance.now()-self._created;}else{now=Date.now()-self._created;}header="WAMP session "+self._id+" on '"+self._realm+"' at "+Math.round(now*1000)/1000+" ms";}else{header="WAMP session";}if('group'in console){console.group(header);for(var i=0;i<arguments.length;i+=1){console.log(arguments[i]);}console.groupEnd();}else{var items=[header+": "];for(var i=0;i<arguments.length;i+=1){items.push(arguments[i]);}console.log.apply(console,items);}}};Session.prototype.join=function(realm,authmethods,authid,authextra){util.assert(!realm||typeof realm==='string',"Session.join: <realm> must be a string");util.assert(!authmethods||Array.isArray(authmethods),"Session.join: <authmethods> must be an array []");util.assert(!authid||typeof authid==='string',"Session.join: <authid> must be a string");var self=this;if(self.isOpen){throw"session already open";}self._goodbye_sent=false;self._realm=realm;var details={};details.roles=WAMP_FEATURES;if(authmethods){details.authmethods=authmethods;}if(authid){details.authid=authid;}if(authextra){details.authextra=authextra;}var msg=[MSG_TYPE.HELLO,realm,details];self._send_wamp(msg);};Session.prototype.leave=function(reason,message){util.assert(!reason||typeof reason==='string',"Session.leave: <reason> must be a string");util.assert(!message||typeof message==='string',"Session.leave: <message> must be a string");var self=this;if(!self.isOpen){throw"session not open";}if(!reason){reason="wamp.close.normal";}var details={};if(message){details.message=message;}var msg=[MSG_TYPE.GOODBYE,details,reason];self._send_wamp(msg);self._goodbye_sent=true;};Session.prototype.call=function(procedure,args,kwargs,options){util.assert(typeof procedure==='string',"Session.call: <procedure> must be a string");util.assert(!args||Array.isArray(args),"Session.call: <args> must be an array []");util.assert(!kwargs||kwargs instanceof Object,"Session.call: <kwargs> must be an object {}");util.assert(!options||options instanceof Object,"Session.call: <options> must be an object {}");var self=this;if(!self.isOpen){throw"session not open";}options=options||{};// only set option if user hasn't set a value and global option is "on"
	if(options.disclose_me===undefined&&self._caller_disclose_me){options.disclose_me=true;}// create and remember new CALL request
	//
	var d=self._defer();var request=self._socket.serializer.newid();self._call_reqs[request]=[d,options];// construct CALL message
	//
	var msg=[MSG_TYPE.CALL,request,options,self.resolve(procedure)];if(args){msg.push(args);if(kwargs){msg.push(kwargs);}}else if(kwargs){msg.push([]);msg.push(kwargs);}// send WAMP message
	//
	self._send_wamp(msg);if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}};Session.prototype.publish=function(topic,args,kwargs,options){util.assert(typeof topic==='string',"Session.publish: <topic> must be a string");util.assert(!args||Array.isArray(args),"Session.publish: <args> must be an array []");util.assert(!kwargs||kwargs instanceof Object,"Session.publish: <kwargs> must be an object {}");util.assert(!options||options instanceof Object,"Session.publish: <options> must be an object {}");var self=this;if(!self.isOpen){throw"session not open";}options=options||{};// only set option if user hasn't set a value and global option is "on"
	if(options.disclose_me===undefined&&self._publisher_disclose_me){options.disclose_me=true;}// create and remember new PUBLISH request
	//
	var d=null;var request=self._socket.serializer.newid();if(options.acknowledge){d=self._defer();self._publish_reqs[request]=[d,options];}// construct PUBLISH message
	//
	var msg=[MSG_TYPE.PUBLISH,request,options,self.resolve(topic)];if(args){msg.push(args);if(kwargs){msg.push(kwargs);}}else if(kwargs){msg.push([]);msg.push(kwargs);}// send WAMP message
	//
	self._send_wamp(msg);if(d){if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}}};Session.prototype.subscribe=function(topic,handler,options){util.assert(typeof topic==='string',"Session.subscribe: <topic> must be a string");util.assert(typeof handler==='function',"Session.subscribe: <handler> must be a function");util.assert(!options||options instanceof Object,"Session.subscribe: <options> must be an object {}");var self=this;if(!self.isOpen){throw"session not open";}// create an remember new SUBSCRIBE request
	//
	var request=self._socket.serializer.newid();var d=self._defer();self._subscribe_reqs[request]=[d,topic,handler,options];// construct SUBSCRIBE message
	//
	var msg=[MSG_TYPE.SUBSCRIBE,request];if(options){msg.push(options);}else{msg.push({});}msg.push(self.resolve(topic));// send WAMP message
	//
	self._send_wamp(msg);if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}};Session.prototype.register=function(procedure,endpoint,options){util.assert(typeof procedure==='string',"Session.register: <procedure> must be a string");util.assert(typeof endpoint==='function',"Session.register: <endpoint> must be a function");util.assert(!options||options instanceof Object,"Session.register: <options> must be an object {}");var self=this;if(!self.isOpen){throw"session not open";}// create an remember new REGISTER request
	//
	var request=self._socket.serializer.newid();var d=self._defer();self._register_reqs[request]=[d,procedure,endpoint,options];// construct REGISTER message
	//
	var msg=[MSG_TYPE.REGISTER,request];if(options){msg.push(options);}else{msg.push({});}msg.push(self.resolve(procedure));// send WAMP message
	//
	self._send_wamp(msg);if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}};Session.prototype.unsubscribe=function(subscription){util.assert(subscription instanceof Subscription,"Session.unsubscribe: <subscription> must be an instance of class autobahn.Subscription");var self=this;if(!self.isOpen){throw"session not open";}if(!subscription.active||!(subscription.id in self._subscriptions)){throw"subscription not active";}var subs=self._subscriptions[subscription.id];var i=subs.indexOf(subscription);if(i===-1){throw"subscription not active";}// remove handler subscription
	subs.splice(i,1);subscription.active=false;var d=self._defer();if(subs.length){// there are still handlers on the subscription ..
	d.resolve(false);}else{// no handlers left ..
	// create and remember new UNSUBSCRIBE request
	//
	var request=self._socket.serializer.newid();self._unsubscribe_reqs[request]=[d,subscription.id];// construct UNSUBSCRIBE message
	//
	var msg=[MSG_TYPE.UNSUBSCRIBE,request,subscription.id];// send WAMP message
	//
	self._send_wamp(msg);}if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}};Session.prototype.unregister=function(registration){util.assert(registration instanceof Registration,"Session.unregister: <registration> must be an instance of class autobahn.Registration");var self=this;if(!self.isOpen){throw"session not open";}if(!registration.active||!(registration.id in self._registrations)){throw"registration not active";}// create and remember new UNREGISTER request
	//
	var request=self._socket.serializer.newid();var d=self._defer();self._unregister_reqs[request]=[d,registration];// construct UNREGISTER message
	//
	var msg=[MSG_TYPE.UNREGISTER,request,registration.id];// send WAMP message
	//
	self._send_wamp(msg);if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}};Session.prototype.prefix=function(prefix,uri){util.assert(typeof prefix==='string',"Session.prefix: <prefix> must be a string");util.assert(!uri||typeof uri==='string',"Session.prefix: <uri> must be a string or falsy");var self=this;if(uri){self._prefixes[prefix]=uri;}else{if(prefix in self._prefixes){delete self._prefixes[prefix];}}};Session.prototype.resolve=function(curie){util.assert(typeof curie==='string',"Session.resolve: <curie> must be a string");var self=this;// skip if not a CURIE
	var i=curie.indexOf(":");if(i>=0){var prefix=curie.substring(0,i);if(prefix in self._prefixes){return self._prefixes[prefix]+'.'+curie.substring(i+1);}else{return curie;}}else{return curie;}};exports.Session=Session;exports.Invocation=Invocation;exports.Event=Event;exports.Result=Result;exports.Error=Error;exports.Subscription=Subscription;exports.Registration=Registration;exports.Publication=Publication;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{"./log.js":7,"./util.js":21,"when":161,"when/function":137}],18:[function(require,module,exports){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var when=require('when');var util=require('../util.js');var log=require('../log.js');var serializer=require('../serializer.js');function Factory(options){var self=this;util.assert(options.url!==undefined,"options.url missing");util.assert(typeof options.url==="string","options.url must be a string");self._options=options;};Factory.prototype.type="longpoll";Factory.prototype.create=function(){var self=this;log.debug("longpoll.Factory.create");// the WAMP transport we create
	var transport={};// these will get defined further below
	transport.protocol=undefined;transport.serializer=new serializer.JSONSerializer();transport.send=undefined;transport.close=undefined;// these will get overridden by the WAMP session using this transport
	transport.onmessage=function(){};transport.onopen=function(){};transport.onclose=function(){};transport.info={type:'longpoll',url:null,protocol:'wamp.2.json'};transport._run=function(){var session_info=null;var send_buffer=[];var is_closing=false;var txseq=0;var rxseq=0;var options={'protocols':['wamp.2.json']};var request_timeout=self._options.request_timeout||12000;// timeout here > than the 10s default in Crossbar.io
	util.http_post(self._options.url+'/open',JSON.stringify(options),request_timeout).then(function(payload){session_info=JSON.parse(payload);var base_url=self._options.url+'/'+session_info.transport;transport.info.url=base_url;log.debug("longpoll.Transport: open",session_info);transport.close=function(code,reason){if(is_closing){throw"transport is already closing";}is_closing=true;util.http_post(base_url+'/close',null,request_timeout).then(function(){log.debug("longpoll.Transport: transport closed");var details={code:1000,reason:"transport closed",wasClean:true};transport.onclose(details);},function(err){log.debug("longpoll.Transport: could not close transport",err.code,err.text);});};transport.send=function(msg){if(is_closing){throw"transport is closing or closed already";}txseq+=1;log.debug("longpoll.Transport: sending message ...",msg);var payload=JSON.stringify(msg);util.http_post(base_url+'/send',payload,request_timeout).then(function(){// ok, message sent
	log.debug("longpoll.Transport: message sent");},function(err){log.debug("longpoll.Transport: could not send message",err.code,err.text);is_closing=true;var details={code:1001,reason:"transport send failure (HTTP/POST status "+err.code+" - '"+err.text+"')",wasClean:false};transport.onclose(details);});};function receive(){rxseq+=1;log.debug("longpoll.Transport: polling for message ...");util.http_post(base_url+'/receive',null,request_timeout).then(function(payload){if(payload){var msg=JSON.parse(payload);log.debug("longpoll.Transport: message received",msg);transport.onmessage(msg);}if(!is_closing){receive();}},function(err){log.debug("longpoll.Transport: could not receive message",err.code,err.text);is_closing=true;var details={code:1001,reason:"transport receive failure (HTTP/POST status "+err.code+" - '"+err.text+"')",wasClean:false};transport.onclose(details);});}receive();transport.onopen();},function(err){log.debug("longpoll.Transport: could not open transport",err.code,err.text);is_closing=true;var details={code:1001,reason:"transport open failure (HTTP/POST status "+err.code+" - '"+err.text+"')",wasClean:false};transport.onclose(details);});};transport._run();return transport;};exports.Factory=Factory;},{"../log.js":7,"../serializer.js":16,"../util.js":21,"when":161}],19:[function(require,module,exports){(function(global,Buffer){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var util=require('../util.js');var log=require('../log.js');var serializer=require('../serializer.js');var EventEmitter=require('events').EventEmitter;function Factory(options){var self=this;if(!options.protocols){options.protocols=['wamp.2.json'];}else{util.assert(Array.isArray(options.protocols),"options.protocols must be an array");}options.rawsocket_max_len_exp=options.rawsocket_max_len_exp||24;self._options=options;}Factory.prototype.type="rawsocket";Factory.prototype.create=function(){var self=this;// the WAMP transport we create
	var transport={};// these will get defined further below
	transport.protocol=undefined;transport.serializer=new serializer.JSONSerializer();transport.send=undefined;transport.close=undefined;// these will get overridden by the WAMP session using this transport
	transport.onmessage=function(){};transport.onopen=function(){};transport.onclose=function(){};transport.info={type:'rawsocket',url:null,protocol:'wamp.2.json'};// Test below used to be via the 'window' object in the browser.
	// This fails when running in a Web worker.
	//
	// running in Node.js
	//
	if(global.process&&global.process.versions.node){(function(){var net=require('net');var socket,protocol;// Create the options object to initiate the connection
	if(self._options.path){connectionOptions={path:self._options.path,allowHalfOpen:true};}else if(self._options.port){connectionOptions={port:self._options.port||8000,host:self._options.host||'localhost',allowHalfOpen:true};}else{throw"You must specify a host/port combination or a unix socket path to connect to";}// Open a TCP socket and setup the protocol
	socket=net.connect(connectionOptions);protocol=new Protocol(socket,{serializer:'json',max_len_exp:self._options.rawsocket_max_len_exp});// Relay connect event to the onopen transport handler
	protocol.on('connect',function(msg){log.debug('RawSocket transport negociated');transport.onopen(msg);});// Relay data event to the onmessage transport handler
	protocol.on('data',function(msg){log.debug('RawSocket transport received',msg);transport.onmessage(msg);});// Relay the close event to the onclose transport handler
	protocol.on('close',function(had_error){log.debug('RawSocket transport closed');transport.onclose({code:999,reason:'',wasClean:!had_error});});// Log errors
	protocol.on('error',function(error){log.debug('RawSocket transport error',error);});// Relay close call
	transport.close=function(code,reason){log.debug('RawSocket transport closing',code,reason);protocol.close();};// Relay send call
	transport.send=function(msg){log.debug('RawSocket transport sending',msg);protocol.write(msg);};})();//
	// running in the browser
	//
	}else{throw"No RawSocket support in browser";}return transport;};/**
	 *  Protocol constructor
	 *
	 * @param {Stream} stream    Source stream object
	 * @param {Object} [options] Protocol options
	 *
	 * @param {String} [options.serializer] The serializer to use (default: json)
	 * @param {Integer} [options.max_len_exp] The maximum allowed frame length as
	 *        2^x(default: 24)
	 * @param {Integer|False} [options.ping_timeout] Maximum duration in ms to wait
	 *        for an answer to a PING packet (default: 2000)
	 * @param {Integer|False} [options.autoping] If an integer, send a PING packet*
	 *        every `x`ms (default: false)
	 * @param {Boolean} [options.fail_on_ping_timeout] Whether to close the
	 *        underlying connection when the peer fails to answer to a PING within
	 *        the `ping_timeout` window (default: true)
	 * @param {Integer|False} [options.packet_timeout] The maximum amount of time to
	 *        wait for a packet !!NOT IMPLEMENTED!! (default: 2000)
	 *
	 * @see https://github.com/wamp-proto/wamp-proto
	 */function Protocol(stream,options){this._options={_peer_serializer:null,// Will hold the serializer declared by the peer
	_peer_max_len_exp:0// Will hold the maximum frame length declared by
	// the peer
	};this._options=util.defaults(this._options,options,this.DEFAULT_OPTIONS);// Check valid options
	util.assert(this._options.serializer in this.SERIALIZERS,'Unsupported serializer: '+this._options.serializer);util.assert(this._options.max_len_exp>=9&&this._options.max_len_exp<=36,'Message length out of bounds [9, 36]: '+this._options.max_len_exp);util.assert(!this._options.autoping||Number.isInteger(this._options.autoping)&&this._options.autoping>=0,'Autoping interval must be positive');util.assert(!this._options.ping_timeout||Number.isInteger(this._options.ping_timeout)&&this._options.ping_timeout>=0,'Ping timeout duration must be positive');util.assert(!this._options.packet_timeout||Number.isInteger(this._options.packet_timeout)&&this._options.packet_timeout>=0,'Packet timeout duration must be positive');util.assert(!this._options.autoping||!this._options.ping_timeout||this._options.autoping>this._options.ping_timeout,'Autoping interval ('+this._options.autoping+') must be lower '+'than ping timeout ('+this._options.ping_timeout+')');// Will store a reference to the timeout function associated with the last
	// PING packet
	this._ping_timeout=null;// Will store the payload of the last PING packet
	this._ping_payload=null;// Will store the autoping setInterval reference
	this._ping_interval=null;// Protocol status (see Protocol.prototype.STATUS)
	this._status=this.STATUS.UNINITIATED;this._stream=stream;this._emitter=new EventEmitter();// Frame buffer
	this._buffer=new Buffer(4);this._bufferLen=0;this._msgLen=0;// Hook events
	var self=this;this._stream.on('data',function(data){self._read(data);});this._stream.on('connect',function(){self._handshake();});// Proxy these events from the stream as we don't need to handle them
	var proxyEvents=['close','drain','end','error','timeout'];proxyEvents.forEach(function(evt){self._stream.on(evt,function(data){self._emitter.emit(evt,data);});});}/* Protocol magic byte */Protocol.prototype._MAGIC_BYTE=0x7f;/* Supported serializers */Protocol.prototype.SERIALIZERS={json:1};/* Protocol states */Protocol.prototype.STATUS={CLOSED:-1,UNINITIATED:0,NEGOCIATING:1,NEGOCIATED:2,RXHEAD:3,RXDATA:4,RXPING:5,RXPONG:6};/* RawSocket error codes */Protocol.prototype.ERRORS={0:"illegal (must not be used)",1:"serializer unsupported",2:"maximum message length unacceptable",3:"use of reserved bits (unsupported feature)",4:"maximum connection count reached"};/* RawSocket message types */Protocol.prototype.MSGTYPES={WAMP:0x0,PING:0x1,PONG:0x2};/* Default protocol options */Protocol.prototype.DEFAULT_OPTIONS={fail_on_ping_timeout:true,strict_pong:true,ping_timeout:2000,autoping:0,max_len_exp:24,serializer:'json',packet_timeout:2000};/**
	 * Close transport
	 *
	 * @returns {Integer} Closed state code
	 */Protocol.prototype.close=function(){this._status=this.STATUS.CLOSED;this._stream.end();return this.STATUS.CLOSED;};/**
	 * Write a frame to the transport
	 *
	 * @param   {Oject}    msg      The frame to send
	 * @param   {Integer}  type     The frame type
	 * @param   {Function} callback Callback function called when frame is sent
	 */Protocol.prototype.write=function(msg,type,callback){type=type===undefined?0:type;// If WAMP frame, serialize the object passed
	// Otherwise send as-is
	if(type===this.MSGTYPES.WAMP){msg=JSON.stringify(msg);}// Get the frame size
	var msgLen=Buffer.byteLength(msg,'utf8');// Check frame size against negociated max size
	if(msgLen>Math.pow(2,this._options._peer_max_len_exp)){this._emitter.emit('error',new ProtocolError('Frame too big'));return;}// Create the frame
	var frame=new Buffer(msgLen+4);// Message type
	frame.writeUInt8(type,0);// Prefix by frame size as a 24 bit integer
	frame.writeUIntBE(msgLen,1,3);frame.write(msg,4);this._stream.write(frame,callback);};Protocol.prototype.ping=function(payload){payload=payload||255;// Generate a random payload if none provided
	if(Number.isInteger(payload)){var base='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'+'0123456789&~"#\'{([-|`_\\^@)]=},?;.:/!*$<>';var len=Math.max(1,payload);for(var i=0;i<len;i++){payload+=base.charAt(Math.random()*base.length|0);}}// Store the payload for checking against PONG packet
	this._ping_payload=payload;// Send the packet and register the ping timeout once done
	return this.write(payload,this.MSGTYPES.PING,this._setupPingTimeout.bind(this));};Protocol.prototype._setupPingTimeout=function(){if(this._options.ping_timeout){this._ping_timeout=setTimeout(this._onPingTimeout.bind(this),this._options.ping_timeout);}};Protocol.prototype._clearPingTimeout=function(){if(this._ping_timeout){clearTimeout(this._ping_timeout);this._ping_timeout=null;}};Protocol.prototype._setupAutoPing=function(){this._clearAutoPing();if(this._options.autoping){this._autoping_interval=setInterval(this.ping.bind(this),this._options.autoping);}};Protocol.prototype._clearAutoPing=function(){if(this._autoping_interval){clearInterval(this._autoping_interval);this._autoping_interval=null;}};Protocol.prototype._onPingTimeout=function(){this._emitter.emit('error',new ProtocolError('PING timeout'));if(this._options.fail_on_ping_timeout){this.close();}};/**
	 * Handle incoming data
	 *
	 * @param {Buffer} data Incoming data
	 */Protocol.prototype._read=function(data){var handler,frame;switch(this._status){case this.STATUS.CLOSED:case this.STATUS.UNINITIATED:this._emitter.emit('error',ProtocolError('Unexpected packet'));break;case this.STATUS.NEGOCIATING:handler=this._handleHandshake;frame=4;break;case this.STATUS.NEGOCIATED:case this.STATUS.RXHEAD:this._status=this.STATUS.RXHEAD;handler=this._handleHeaderPacket;frame=4;break;case this.STATUS.RXDATA:handler=this._handleDataPacket;frame=this._msgLen;break;case this.STATUS.RXPING:handler=this._handlePingPacket;frame=this._msgLen;break;case this.STATUS.RXPONG:handler=this._handlePongPacket;frame=this._msgLen;break;}// Get a frame of the expected size
	var chunks=this._splitBytes(data,frame);// Protocol#_splitBytes returns null if there isn't enough data to fill the
	// requested frame yet. Wait for more
	if(!chunks)return;// Call the packet handler with the frame
	this._status=handler.call(this,chunks[0]);// If there is more data, handle it
	if(chunks[1].length>0){this._read(chunks[1]);}};/**
	 * Send the handshake packet to the peer
	 */Protocol.prototype._handshake=function(){if(this._status!==this.STATUS.UNINITIATED){throw'Handshake packet already sent';}// Compose handshake message
	var gday=new Buffer(4);// Protocol magic byte
	gday.writeUInt8(this._MAGIC_BYTE,0);// Announce message max length and serializer
	gday.writeUInt8(this._options.max_len_exp-9<<4|this.SERIALIZERS[this._options.serializer],1);// Reserved bytes
	gday.writeUInt8(0x00,2);gday.writeUInt8(0x00,3);this._stream.write(gday);this._status=this.STATUS.NEGOCIATING;};/**
	 * Make a frame of the requested length using the data already buffered and the
	 * passed incoming data
	 *
	 * @param   {Buffer}  data Incoming data
	 * @param   {Integer} len  Frame size
	 *
	 * @returns {null|Array(2)} Returns null if there is'nt enough data to fill the
	 *                          frame yet, or an array containing the frame at
	 *                          index 0 and the leftover bytes at index 1 otherwise.
	 */Protocol.prototype._splitBytes=function(data,len){// If the buffer we have already isn't the right size, throw the data away
	// and make a new one
	if(len!==this._buffer.length){this._buffer=new Buffer(len);this._bufferLen=0;}// Push the data to the buffer
	data.copy(this._buffer,this._bufferLen);// If there still isn't enough data, increment the counter and return null
	if(this._bufferLen+data.length<len){this._bufferLen+=data.length;return null;// Otherwise, return the requested frame and the leftover data
	}else{var bytes=this._buffer.slice();var extra=data.slice(len-this._bufferLen);this._bufferLen=0;return[bytes,extra];}};/**
	 * Handle the handshake response packet
	 *
	 * @param   {Buffer} int32 A 4 byte buffer containing the handshake packet
	 *
	 * @returns {Integer} The new protocol state
	 */Protocol.prototype._handleHandshake=function(int32){// Check magic byte
	if(int32[0]!==this._MAGIC_BYTE){this._emitter.emit('error',new ProtocolError('Invalid magic byte. Expected 0x'+this._MAGIC_BYTE.toString(16)+', got 0x'+int32[0].toString(16)));return this.close();}// Check for error
	if((int32[1]&0x0f)===0){var errcode=int32[1]>>4;this._emitter.emit('error',new ProtocolError('Peer failed handshake: '+(this.ERRORS[errcode]||'0x'+errcode.toString(16))));return this.close();}// Extract max message length and serializer
	this._options._peer_max_len_exp=(int32[1]>>4)+9;this._options._peer_serializer=int32[1]&0x0f;// We only support JSON so far
	// TODO: Support more serializers
	if(this._options._peer_serializer!==this.SERIALIZERS.json){this._emitter.emit('error',new ProtocolError('Unsupported serializer: 0x'+this._options._peer_serializer.toString(16)));return this.close();}// Protocol negociation complete, we're connected to the peer and ready to
	// talk
	this._emitter.emit('connect');// Setup the autoping
	this._setupAutoPing();return this.STATUS.NEGOCIATED;};/**
	 * Handle a frame header
	 *
	 * @param   {Buffer} int32 A 4 byte buffer representing the packet length
	 *
	 * @returns {Integer} The new protocol state
	 */Protocol.prototype._handleHeaderPacket=function(int32){var type=int32[0]&0x0f;// Decode integer and store it
	this._msgLen=int32.readUIntBE(1,3);switch(type){case this.MSGTYPES.WAMP:// WAMP frame
	return this.STATUS.RXDATA;case this.MSGTYPES.PING:// PING frame
	return this.STATUS.RXPING;case this.MSGTYPES.PONG:// PONG frame
	return this.STATUS.RXPONG;default:this._emitter.emit('error',new ProtocolError('Invalid frame type: 0x'+type.toString(16)));return this.close();}};/**
	 * Handle a data packet
	 *
	 * @param   {Buffer} buffer The received data
	 *
	 * @returns {Integer} The new protocol state
	 */Protocol.prototype._handleDataPacket=function(buffer){var msg;// Attempt to deserialize the frame
	// TODO: Support other serializers
	try{msg=JSON.parse(buffer.toString('utf8'));}catch(e){this._emitter.emit('error',new ProtocolError('Invalid JSON frame'));return this.STATUS.RXHEAD;}// Emit a data event for consumers
	this._emitter.emit('data',msg);return this.STATUS.RXHEAD;};/**
	 * Handle a ping packet - Reply with a  PONG and the same payload
	 *
	 * @param   {Buffer} buffer The received data
	 *
	 * @returns {Integer} The new protocol state
	 */Protocol.prototype._handlePingPacket=function(buffer){this.write(buffer.toString('utf8'),this.MSGTYPES.PONG);return this.STATUS.RXHEAD;};/**
	 * Handle a pong packet
	 *
	 * @param   {Buffer} buffer The received data
	 *
	 * @returns {Integer} The new protocol state
	 */Protocol.prototype._handlePongPacket=function(buffer){// Clear the ping timeout (if any)
	this._clearPingTimeout();// If strict PONG checking is activated and the payloads don't match, throw
	// an error and close the connection
	if(this._options.strict_pong&&this._ping_payload!==buffer.toString('utf8')){this._emitter.emit('error',new ProtocolError('PONG response payload doesn\'t match PING.'));return this.close();}return this.STATUS.RXHEAD;};Protocol.prototype.on=function(evt,handler){return this._emitter.on(evt,handler);};Protocol.prototype.once=function(evt,handler){return this._emitter.once(evt,handler);};Protocol.prototype.removeListener=function(evt,handler){return this._emitter.removeListener(evt,handler);};/**
	 * ProtocolError type
	 */var ProtocolError=exports.ProtocolError=function(msg){Error.apply(this,Array.prototype.splice.call(arguments));Error.captureStackTrace(this,this.constructor);this.message=msg;this.name='ProtocolError';};ProtocolError.prototype=Object.create(Error.prototype);exports.Factory=Factory;exports.Protocol=Protocol;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{},require("buffer").Buffer);},{"../log.js":7,"../serializer.js":16,"../util.js":21,"buffer":27,"events":74,"net":25}],20:[function(require,module,exports){(function(global){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var util=require('../util.js');var log=require('../log.js');var serializer=require('../serializer.js');function Factory(options){var self=this;util.assert(options.url!==undefined,"options.url missing");util.assert(typeof options.url==="string","options.url must be a string");if(!options.serializers){options.serializers=[new serializer.JSONSerializer()];if(serializer.MsgpackSerializer){options.serializers.push(new serializer.MsgpackSerializer());}}else{util.assert(Array.isArray(options.serializers),"options.serializers must be an array");}if(!options.protocols){options.protocols=[];options.serializers.forEach(function(ser){options.protocols.push("wamp.2."+ser.SERIALIZER_ID);});}else{util.assert(Array.isArray(options.protocols),"options.protocols must be an array");}self._options=options;}Factory.prototype.type="websocket";Factory.prototype.create=function(){var self=this;// the WAMP transport we create
	var transport={};// these will get defined further below
	transport.protocol=undefined;transport.serializer=undefined;transport.send=undefined;transport.close=undefined;// these will get overridden by the WAMP session using this transport
	transport.onmessage=function(){};transport.onopen=function(){};transport.onclose=function(){};transport.info={type:'websocket',url:self._options.url,protocol:null};// Test below used to be via the 'window' object in the browser.
	// This fails when running in a Web worker.
	//
	// running in Node.js
	//
	if(global.process&&global.process.versions.node){(function(){var WebSocket=require('ws');// https://github.com/einaros/ws
	var websocket;var protocols;if(self._options.protocols){protocols=self._options.protocols;if(Array.isArray(protocols)){protocols=protocols.join(',');}websocket=new WebSocket(self._options.url,{protocol:protocols});}else{websocket=new WebSocket(self._options.url);}transport.send=function(msg){var payload=transport.serializer.serialize(msg);websocket.send(payload,{binary:transport.serializer.BINARY});};transport.close=function(code,reason){websocket.close();};websocket.on('open',function(){var serializer_part=websocket.protocol.split('.')[2];for(var index in self._options.serializers){var serializer=self._options.serializers[index];if(serializer.SERIALIZER_ID==serializer_part){transport.serializer=serializer;break;}}transport.info.protocol=websocket.protocol;transport.onopen();});websocket.on('message',function(data,flags){var msg=transport.serializer.unserialize(data);transport.onmessage(msg);});// FIXME: improve mapping to WS API for the following
	// https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Close_codes
	//
	websocket.on('close',function(code,message){var details={code:code,reason:message,wasClean:code===1000};transport.onclose(details);});websocket.on('error',function(error){var details={code:1006,reason:'',wasClean:false};transport.onclose(details);});})();//
	// running in the browser
	//
	}else{(function(){var websocket;// Chrome, MSIE, newer Firefox
	if("WebSocket"in global){if(self._options.protocols){websocket=new global.WebSocket(self._options.url,self._options.protocols);}else{websocket=new global.WebSocket(self._options.url);}websocket.binaryType='arraybuffer';// older versions of Firefox prefix the WebSocket object
	}else if("MozWebSocket"in global){if(self._options.protocols){websocket=new global.MozWebSocket(self._options.url,self._options.protocols);}else{websocket=new global.MozWebSocket(self._options.url);}}else{throw"browser does not support WebSocket or WebSocket in Web workers";}websocket.onmessage=function(evt){log.debug("WebSocket transport receive",evt.data);var msg=transport.serializer.unserialize(evt.data);transport.onmessage(msg);};websocket.onopen=function(){var serializer_part=websocket.protocol.split('.')[2];for(var index in self._options.serializers){var serializer=self._options.serializers[index];if(serializer.SERIALIZER_ID==serializer_part){transport.serializer=serializer;break;}}transport.info.protocol=websocket.protocol;transport.onopen();};websocket.onclose=function(evt){var details={code:evt.code,reason:evt.message,wasClean:evt.wasClean};transport.onclose(details);};// do NOT do the following, since that will make
	// transport.onclose() fire twice (browsers already fire
	// websocket.onclose() for errors also)
	//websocket.onerror = websocket.onclose;
	transport.send=function(msg){var payload=transport.serializer.serialize(msg);log.debug("WebSocket transport send",payload);websocket.send(payload);};transport.close=function(code,reason){websocket.close(code,reason);};})();}return transport;};exports.Factory=Factory;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{"../log.js":7,"../serializer.js":16,"../util.js":21,"ws":24}],21:[function(require,module,exports){(function(global){///////////////////////////////////////////////////////////////////////////////
	//
	//  AutobahnJS - http://autobahn.ws, http://wamp.ws
	//
	//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
	//
	//  Copyright (c) Crossbar.io Technologies GmbH and contributors
	//
	//  Licensed under the MIT License.
	//  http://www.opensource.org/licenses/mit-license.php
	//
	///////////////////////////////////////////////////////////////////////////////
	var log=require('./log.js');var when=require('when');/// Convert base64 string to array of bytes.
	function _atob(s){if(s){return new Uint8Array(atob(s).split("").map(function(c){return c.charCodeAt(0);}));}else{return null;}}exports.atob=_atob;/// Convert array of bytes to base64 string.
	function _btoa(b){if(b){return btoa(String.fromCharCode.apply(null,b));}else{return null;}}exports.btoa=_btoa;/// Convert array of bytes to hex string.
	function _btoh(bytes){if(bytes){var res='';for(var i=0;i<bytes.length;++i){res+=('0'+(bytes[i]&0xFF).toString(16)).slice(-2);}return res;}else{return null;}}exports.btoh=_btoh;/// Convert hex string to array of bytes.
	function _htob(hex){if(hex){if(typeof hex!=='string'){throw new TypeError('Expected input to be a string');}if(hex.length%2!==0){throw new RangeError('Expected string to be an even number of characters');}var view=new Uint8Array(hex.length/2);for(var i=0;i<hex.length;i+=2){view[i/2]=parseInt(hex.substring(i,i+2),16);}return view;}else{return null;}}exports.htob=_htob;var rand_normal=function rand_normal(mean,sd){// Derive a Gaussian from Uniform random variables
	// http://en.wikipedia.org/wiki/Box%E2%80%93Muller_transform
	var x1,x2,rad;do{x1=2*Math.random()-1;x2=2*Math.random()-1;rad=x1*x1+x2*x2;}while(rad>=1||rad==0);var c=Math.sqrt(-2*Math.log(rad)/rad);return(mean||0)+x1*c*(sd||1);};var assert=function assert(cond,text){if(cond){return;}if(assert.useDebugger||'AUTOBAHN_DEBUG'in global&&AUTOBAHN_DEBUG){debugger;}throw new Error(text||"Assertion failed!");};// Helper to do HTTP/POST requests returning deferreds. This function is
	// supposed to work on IE8, IE9 and old Android WebKit browsers. We don't care
	// if it works with other browsers.
	//
	var http_post=function http_post(url,data,timeout){log.debug("new http_post request",url,data,timeout);var d=when.defer();var req=new XMLHttpRequest();req.withCredentials=true;// pass along cookies
	req.onreadystatechange=function(){if(req.readyState===4){// Normalize IE's response to HTTP 204 when Win error 1223.
	// http://stackoverflow.com/a/10047236/884770
	//
	var status=req.status===1223?204:req.status;if(status===200){// response with content
	//
	d.resolve(req.responseText);}if(status===204){// empty response
	//
	d.resolve();}else{// anything else is a fail
	//
	var statusText=null;try{statusText=req.statusText;}catch(e){// IE8 fucks up on this
	}d.reject({code:status,text:statusText});}}};req.open("POST",url,true);req.setRequestHeader("Content-type","application/json; charset=utf-8");if(timeout>0){req.timeout=timeout;// request timeout in ms
	req.ontimeout=function(){d.reject({code:501,text:"request timeout"});};}if(data){req.send(data);}else{req.send();}if(d.promise.then){// whenjs has the actual user promise in an attribute
	return d.promise;}else{return d;}};/**
	 * Merge a list of objects from left to right
	 *
	 * For each object passed to the function, add to the previous object the keys
	 *     that are present in the former but not the latter. If the last argument
	 *     is a boolean, it sets whether or not to recursively merge objects.
	 *
	 * This function mutates the first passed object. To avopid this, you can pass
	 *     a new empty object as the first arg:
	 *
	 *     defaults({}, obj1, obj2, ...)
	 *
	 * @example
	 *     defaults({ a: 1 }, { a: 2, b: 2 }, { b: 3, c: 3 })
	 *     // { a: 1, b: 2, c: 3 }
	 *
	 *     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
	 *     // { a: { k1: 1 } }
	 *
	 *     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
	 *     // { a: { k1: 1 } }
	 *
	 * @param {Object} base The object to merge defaults to
	 * @param {Object} source[, ...] The default values source
	 * @param {Boolean} [recursive] Whether to recurse fro object values*
	 *     (default: false)
	 * @returns {Object} The mutated `base` object
	 */var defaults=function defaults(){// Return an empty object if no arguments are passed
	if(arguments.length===0)return{};var base=arguments[0];var recursive=false;var len=arguments.length;// Check for recursive mode param
	if(typeof arguments[len-1]==='boolean'){recursive=arguments[len-1];len-=1;// Ignore the last arg
	}// Merging function used by Array#forEach()
	var do_merge=function do_merge(key){var val=obj[key];// Set if unset
	if(!(key in base)){base[key]=val;// If the value is an object and we use recursive mode, use defaults on
	// the value
	}else if(recursive&&(typeof val==="undefined"?"undefined":_typeof(val))==='object'&&_typeof(base[key])==='object'){defaults(base[key],val);}// Otherwise ignore the value
	};// Iterate over source objects
	for(var i=1;i<len;i++){var obj=arguments[i];// Ignore falsy values
	if(!obj)continue;// Require object
	if((typeof obj==="undefined"?"undefined":_typeof(obj))!=='object'){throw new Error('Expected argument at index '+i+' to be an object');}// Merge keys
	Object.keys(obj).forEach(do_merge);}// Return the mutated base object
	return base;};exports.rand_normal=rand_normal;exports.assert=assert;exports.http_post=http_post;exports.defaults=defaults;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{"./log.js":7,"when":161}],22:[function(require,module,exports){'use strict';exports.byteLength=byteLength;exports.toByteArray=toByteArray;exports.fromByteArray=fromByteArray;var lookup=[];var revLookup=[];var Arr=typeof Uint8Array!=='undefined'?Uint8Array:Array;var code='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';for(var i=0,len=code.length;i<len;++i){lookup[i]=code[i];revLookup[code.charCodeAt(i)]=i;}revLookup['-'.charCodeAt(0)]=62;revLookup['_'.charCodeAt(0)]=63;function placeHoldersCount(b64){var len=b64.length;if(len%4>0){throw new Error('Invalid string. Length must be a multiple of 4');}// the number of equal signs (place holders)
	// if there are two placeholders, than the two characters before it
	// represent one byte
	// if there is only one, then the three characters before it represent 2 bytes
	// this is just a cheap hack to not do indexOf twice
	return b64[len-2]==='='?2:b64[len-1]==='='?1:0;}function byteLength(b64){// base64 is 4/3 + up to two characters of the original data
	return b64.length*3/4-placeHoldersCount(b64);}function toByteArray(b64){var i,j,l,tmp,placeHolders,arr;var len=b64.length;placeHolders=placeHoldersCount(b64);arr=new Arr(len*3/4-placeHolders);// if there are placeholders, only get up to the last complete 4 chars
	l=placeHolders>0?len-4:len;var L=0;for(i=0,j=0;i<l;i+=4,j+=3){tmp=revLookup[b64.charCodeAt(i)]<<18|revLookup[b64.charCodeAt(i+1)]<<12|revLookup[b64.charCodeAt(i+2)]<<6|revLookup[b64.charCodeAt(i+3)];arr[L++]=tmp>>16&0xFF;arr[L++]=tmp>>8&0xFF;arr[L++]=tmp&0xFF;}if(placeHolders===2){tmp=revLookup[b64.charCodeAt(i)]<<2|revLookup[b64.charCodeAt(i+1)]>>4;arr[L++]=tmp&0xFF;}else if(placeHolders===1){tmp=revLookup[b64.charCodeAt(i)]<<10|revLookup[b64.charCodeAt(i+1)]<<4|revLookup[b64.charCodeAt(i+2)]>>2;arr[L++]=tmp>>8&0xFF;arr[L++]=tmp&0xFF;}return arr;}function tripletToBase64(num){return lookup[num>>18&0x3F]+lookup[num>>12&0x3F]+lookup[num>>6&0x3F]+lookup[num&0x3F];}function encodeChunk(uint8,start,end){var tmp;var output=[];for(var i=start;i<end;i+=3){tmp=(uint8[i]<<16)+(uint8[i+1]<<8)+uint8[i+2];output.push(tripletToBase64(tmp));}return output.join('');}function fromByteArray(uint8){var tmp;var len=uint8.length;var extraBytes=len%3;// if we have 1 byte left, pad 2 bytes
	var output='';var parts=[];var maxChunkLength=16383;// must be multiple of 3
	// go through the array every three bytes, we'll deal with trailing stuff later
	for(var i=0,len2=len-extraBytes;i<len2;i+=maxChunkLength){parts.push(encodeChunk(uint8,i,i+maxChunkLength>len2?len2:i+maxChunkLength));}// pad the end with zeros, but make sure to not forget the extra bytes
	if(extraBytes===1){tmp=uint8[len-1];output+=lookup[tmp>>2];output+=lookup[tmp<<4&0x3F];output+='==';}else if(extraBytes===2){tmp=(uint8[len-2]<<8)+uint8[len-1];output+=lookup[tmp>>10];output+=lookup[tmp>>4&0x3F];output+=lookup[tmp<<2&0x3F];output+='=';}parts.push(output);return parts.join('');}},{}],23:[function(require,module,exports){/*! bignumber.js v3.0.1 https://github.com/MikeMcl/bignumber.js/LICENCE */;(function(globalObj){'use strict';/*
	      bignumber.js v3.0.1
	      A JavaScript library for arbitrary-precision arithmetic.
	      https://github.com/MikeMcl/bignumber.js
	      Copyright (c) 2016 Michael Mclaughlin <M8ch88l@gmail.com>
	      MIT Expat Licence
	    */var BigNumber,parseNumeric,isNumeric=/^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,mathceil=Math.ceil,mathfloor=Math.floor,notBool=' not a boolean or binary digit',roundingMode='rounding mode',tooManyDigits='number type has more than 15 significant digits',ALPHABET='0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_',BASE=1e14,LOG_BASE=14,MAX_SAFE_INTEGER=0x1fffffffffffff,// 2^53 - 1
	// MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
	POWS_TEN=[1,10,100,1e3,1e4,1e5,1e6,1e7,1e8,1e9,1e10,1e11,1e12,1e13],SQRT_BASE=1e7,/*
	         * The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
	         * the arguments to toExponential, toFixed, toFormat, and toPrecision, beyond which an
	         * exception is thrown (if ERRORS is true).
	         */MAX=1E9;// 0 to MAX_INT32
	/*
	     * Create and return a BigNumber constructor.
	     */function constructorFactory(configObj){var div,// id tracks the caller function, so its name can be included in error messages.
	id=0,P=BigNumber.prototype,ONE=new BigNumber(1),/********************************* EDITABLE DEFAULTS **********************************//*
	             * The default values below must be integers within the inclusive ranges stated.
	             * The values can also be changed at run-time using BigNumber.config.
	             */// The maximum number of decimal places for operations involving division.
	DECIMAL_PLACES=20,// 0 to MAX
	/*
	             * The rounding mode used when rounding to the above decimal places, and when using
	             * toExponential, toFixed, toFormat and toPrecision, and round (default value).
	             * UP         0 Away from zero.
	             * DOWN       1 Towards zero.
	             * CEIL       2 Towards +Infinity.
	             * FLOOR      3 Towards -Infinity.
	             * HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	             * HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	             * HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	             * HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	             * HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	             */ROUNDING_MODE=4,// 0 to 8
	// EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
	// The exponent value at and beneath which toString returns exponential notation.
	// Number type: -7
	TO_EXP_NEG=-7,// 0 to -MAX
	// The exponent value at and above which toString returns exponential notation.
	// Number type: 21
	TO_EXP_POS=21,// 0 to MAX
	// RANGE : [MIN_EXP, MAX_EXP]
	// The minimum exponent value, beneath which underflow to zero occurs.
	// Number type: -324  (5e-324)
	MIN_EXP=-1e7,// -1 to -MAX
	// The maximum exponent value, above which overflow to Infinity occurs.
	// Number type:  308  (1.7976931348623157e+308)
	// For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
	MAX_EXP=1e7,// 1 to MAX
	// Whether BigNumber Errors are ever thrown.
	ERRORS=true,// true or false
	// Change to intValidatorNoErrors if ERRORS is false.
	isValidInt=intValidatorWithErrors,// intValidatorWithErrors/intValidatorNoErrors
	// Whether to use cryptographically-secure random number generation, if available.
	CRYPTO=false,// true or false
	/*
	             * The modulo mode used when calculating the modulus: a mod n.
	             * The quotient (q = a / n) is calculated according to the corresponding rounding mode.
	             * The remainder (r) is calculated as: r = a - n * q.
	             *
	             * UP        0 The remainder is positive if the dividend is negative, else is negative.
	             * DOWN      1 The remainder has the same sign as the dividend.
	             *             This modulo mode is commonly known as 'truncated division' and is
	             *             equivalent to (a % n) in JavaScript.
	             * FLOOR     3 The remainder has the same sign as the divisor (Python %).
	             * HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
	             * EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
	             *             The remainder is always positive.
	             *
	             * The truncated division, floored division, Euclidian division and IEEE 754 remainder
	             * modes are commonly used for the modulus operation.
	             * Although the other rounding modes can also be used, they may not give useful results.
	             */MODULO_MODE=1,// 0 to 9
	// The maximum number of significant digits of the result of the toPower operation.
	// If POW_PRECISION is 0, there will be unlimited significant digits.
	POW_PRECISION=0,// 0 to MAX
	// The format specification used by the BigNumber.prototype.toFormat method.
	FORMAT={decimalSeparator:'.',groupSeparator:',',groupSize:3,secondaryGroupSize:0,fractionGroupSeparator:'\xA0',// non-breaking space
	fractionGroupSize:0};/******************************************************************************************/// CONSTRUCTOR
	/*
	         * The BigNumber constructor and exported function.
	         * Create and return a new instance of a BigNumber object.
	         *
	         * n {number|string|BigNumber} A numeric value.
	         * [b] {number} The base of n. Integer, 2 to 64 inclusive.
	         */function BigNumber(n,b){var c,e,i,num,len,str,x=this;// Enable constructor usage without new.
	if(!(x instanceof BigNumber)){// 'BigNumber() constructor call without new: {n}'
	if(ERRORS)raise(26,'constructor call without new',n);return new BigNumber(n,b);}// 'new BigNumber() base not an integer: {b}'
	// 'new BigNumber() base out of range: {b}'
	if(b==null||!isValidInt(b,2,64,id,'base')){// Duplicate.
	if(n instanceof BigNumber){x.s=n.s;x.e=n.e;x.c=(n=n.c)?n.slice():n;id=0;return;}if((num=typeof n=='number')&&n*0==0){x.s=1/n<0?(n=-n,-1):1;// Fast path for integers.
	if(n===~~n){for(e=0,i=n;i>=10;i/=10,e++){}x.e=e;x.c=[n];id=0;return;}str=n+'';}else{if(!isNumeric.test(str=n+''))return parseNumeric(x,str,num);x.s=str.charCodeAt(0)===45?(str=str.slice(1),-1):1;}}else{b=b|0;str=n+'';// Ensure return value is rounded to DECIMAL_PLACES as with other bases.
	// Allow exponential notation to be used with base 10 argument.
	if(b==10){x=new BigNumber(n instanceof BigNumber?n:str);return round(x,DECIMAL_PLACES+x.e+1,ROUNDING_MODE);}// Avoid potential interpretation of Infinity and NaN as base 44+ values.
	// Any number in exponential form will fail due to the [Ee][+-].
	if((num=typeof n=='number')&&n*0!=0||!new RegExp('^-?'+(c='['+ALPHABET.slice(0,b)+']+')+'(?:\\.'+c+')?$',b<37?'i':'').test(str)){return parseNumeric(x,str,num,b);}if(num){x.s=1/n<0?(str=str.slice(1),-1):1;if(ERRORS&&str.replace(/^0\.0*|\./,'').length>15){// 'new BigNumber() number type has more than 15 significant digits: {n}'
	raise(id,tooManyDigits,n);}// Prevent later check for length on converted number.
	num=false;}else{x.s=str.charCodeAt(0)===45?(str=str.slice(1),-1):1;}str=convertBase(str,10,b,x.s);}// Decimal point?
	if((e=str.indexOf('.'))>-1)str=str.replace('.','');// Exponential form?
	if((i=str.search(/e/i))>0){// Determine exponent.
	if(e<0)e=i;e+=+str.slice(i+1);str=str.substring(0,i);}else if(e<0){// Integer.
	e=str.length;}// Determine leading zeros.
	for(i=0;str.charCodeAt(i)===48;i++){}// Determine trailing zeros.
	for(len=str.length;str.charCodeAt(--len)===48;){}str=str.slice(i,len+1);if(str){len=str.length;// Disallow numbers with over 15 significant digits if number type.
	// 'new BigNumber() number type has more than 15 significant digits: {n}'
	if(num&&ERRORS&&len>15&&(n>MAX_SAFE_INTEGER||n!==mathfloor(n))){raise(id,tooManyDigits,x.s*n);}e=e-i-1;// Overflow?
	if(e>MAX_EXP){// Infinity.
	x.c=x.e=null;// Underflow?
	}else if(e<MIN_EXP){// Zero.
	x.c=[x.e=0];}else{x.e=e;x.c=[];// Transform base
	// e is the base 10 exponent.
	// i is where to slice str to get the first element of the coefficient array.
	i=(e+1)%LOG_BASE;if(e<0)i+=LOG_BASE;if(i<len){if(i)x.c.push(+str.slice(0,i));for(len-=LOG_BASE;i<len;){x.c.push(+str.slice(i,i+=LOG_BASE));}str=str.slice(i);i=LOG_BASE-str.length;}else{i-=len;}for(;i--;str+='0'){}x.c.push(+str);}}else{// Zero.
	x.c=[x.e=0];}id=0;}// CONSTRUCTOR PROPERTIES
	BigNumber.another=constructorFactory;BigNumber.ROUND_UP=0;BigNumber.ROUND_DOWN=1;BigNumber.ROUND_CEIL=2;BigNumber.ROUND_FLOOR=3;BigNumber.ROUND_HALF_UP=4;BigNumber.ROUND_HALF_DOWN=5;BigNumber.ROUND_HALF_EVEN=6;BigNumber.ROUND_HALF_CEIL=7;BigNumber.ROUND_HALF_FLOOR=8;BigNumber.EUCLID=9;/*
	         * Configure infrequently-changing library-wide settings.
	         *
	         * Accept an object or an argument list, with one or many of the following properties or
	         * parameters respectively:
	         *
	         *   DECIMAL_PLACES  {number}  Integer, 0 to MAX inclusive
	         *   ROUNDING_MODE   {number}  Integer, 0 to 8 inclusive
	         *   EXPONENTIAL_AT  {number|number[]}  Integer, -MAX to MAX inclusive or
	         *                                      [integer -MAX to 0 incl., 0 to MAX incl.]
	         *   RANGE           {number|number[]}  Non-zero integer, -MAX to MAX inclusive or
	         *                                      [integer -MAX to -1 incl., integer 1 to MAX incl.]
	         *   ERRORS          {boolean|number}   true, false, 1 or 0
	         *   CRYPTO          {boolean|number}   true, false, 1 or 0
	         *   MODULO_MODE     {number}           0 to 9 inclusive
	         *   POW_PRECISION   {number}           0 to MAX inclusive
	         *   FORMAT          {object}           See BigNumber.prototype.toFormat
	         *      decimalSeparator       {string}
	         *      groupSeparator         {string}
	         *      groupSize              {number}
	         *      secondaryGroupSize     {number}
	         *      fractionGroupSeparator {string}
	         *      fractionGroupSize      {number}
	         *
	         * (The values assigned to the above FORMAT object properties are not checked for validity.)
	         *
	         * E.g.
	         * BigNumber.config(20, 4) is equivalent to
	         * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
	         *
	         * Ignore properties/parameters set to null or undefined.
	         * Return an object with the properties current values.
	         */BigNumber.config=BigNumber.set=function(){var v,p,i=0,r={},a=arguments,o=a[0],has=o&&(typeof o==="undefined"?"undefined":_typeof(o))=='object'?function(){if(o.hasOwnProperty(p))return(v=o[p])!=null;}:function(){if(a.length>i)return(v=a[i++])!=null;};// DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
	// 'config() DECIMAL_PLACES not an integer: {v}'
	// 'config() DECIMAL_PLACES out of range: {v}'
	if(has(p='DECIMAL_PLACES')&&isValidInt(v,0,MAX,2,p)){DECIMAL_PLACES=v|0;}r[p]=DECIMAL_PLACES;// ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
	// 'config() ROUNDING_MODE not an integer: {v}'
	// 'config() ROUNDING_MODE out of range: {v}'
	if(has(p='ROUNDING_MODE')&&isValidInt(v,0,8,2,p)){ROUNDING_MODE=v|0;}r[p]=ROUNDING_MODE;// EXPONENTIAL_AT {number|number[]}
	// Integer, -MAX to MAX inclusive or [integer -MAX to 0 inclusive, 0 to MAX inclusive].
	// 'config() EXPONENTIAL_AT not an integer: {v}'
	// 'config() EXPONENTIAL_AT out of range: {v}'
	if(has(p='EXPONENTIAL_AT')){if(isArray(v)){if(isValidInt(v[0],-MAX,0,2,p)&&isValidInt(v[1],0,MAX,2,p)){TO_EXP_NEG=v[0]|0;TO_EXP_POS=v[1]|0;}}else if(isValidInt(v,-MAX,MAX,2,p)){TO_EXP_NEG=-(TO_EXP_POS=(v<0?-v:v)|0);}}r[p]=[TO_EXP_NEG,TO_EXP_POS];// RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
	// [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
	// 'config() RANGE not an integer: {v}'
	// 'config() RANGE cannot be zero: {v}'
	// 'config() RANGE out of range: {v}'
	if(has(p='RANGE')){if(isArray(v)){if(isValidInt(v[0],-MAX,-1,2,p)&&isValidInt(v[1],1,MAX,2,p)){MIN_EXP=v[0]|0;MAX_EXP=v[1]|0;}}else if(isValidInt(v,-MAX,MAX,2,p)){if(v|0)MIN_EXP=-(MAX_EXP=(v<0?-v:v)|0);else if(ERRORS)raise(2,p+' cannot be zero',v);}}r[p]=[MIN_EXP,MAX_EXP];// ERRORS {boolean|number} true, false, 1 or 0.
	// 'config() ERRORS not a boolean or binary digit: {v}'
	if(has(p='ERRORS')){if(v===!!v||v===1||v===0){id=0;isValidInt=(ERRORS=!!v)?intValidatorWithErrors:intValidatorNoErrors;}else if(ERRORS){raise(2,p+notBool,v);}}r[p]=ERRORS;// CRYPTO {boolean|number} true, false, 1 or 0.
	// 'config() CRYPTO not a boolean or binary digit: {v}'
	// 'config() crypto unavailable: {crypto}'
	if(has(p='CRYPTO')){if(v===true||v===false||v===1||v===0){if(v){v=typeof crypto=='undefined';if(!v&&crypto&&(crypto.getRandomValues||crypto.randomBytes)){CRYPTO=true;}else if(ERRORS){raise(2,'crypto unavailable',v?void 0:crypto);}else{CRYPTO=false;}}else{CRYPTO=false;}}else if(ERRORS){raise(2,p+notBool,v);}}r[p]=CRYPTO;// MODULO_MODE {number} Integer, 0 to 9 inclusive.
	// 'config() MODULO_MODE not an integer: {v}'
	// 'config() MODULO_MODE out of range: {v}'
	if(has(p='MODULO_MODE')&&isValidInt(v,0,9,2,p)){MODULO_MODE=v|0;}r[p]=MODULO_MODE;// POW_PRECISION {number} Integer, 0 to MAX inclusive.
	// 'config() POW_PRECISION not an integer: {v}'
	// 'config() POW_PRECISION out of range: {v}'
	if(has(p='POW_PRECISION')&&isValidInt(v,0,MAX,2,p)){POW_PRECISION=v|0;}r[p]=POW_PRECISION;// FORMAT {object}
	// 'config() FORMAT not an object: {v}'
	if(has(p='FORMAT')){if((typeof v==="undefined"?"undefined":_typeof(v))=='object'){FORMAT=v;}else if(ERRORS){raise(2,p+' not an object',v);}}r[p]=FORMAT;return r;};/*
	         * Return a new BigNumber whose value is the maximum of the arguments.
	         *
	         * arguments {number|string|BigNumber}
	         */BigNumber.max=function(){return maxOrMin(arguments,P.lt);};/*
	         * Return a new BigNumber whose value is the minimum of the arguments.
	         *
	         * arguments {number|string|BigNumber}
	         */BigNumber.min=function(){return maxOrMin(arguments,P.gt);};/*
	         * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
	         * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
	         * zeros are produced).
	         *
	         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
	         *
	         * 'random() decimal places not an integer: {dp}'
	         * 'random() decimal places out of range: {dp}'
	         * 'random() crypto unavailable: {crypto}'
	         */BigNumber.random=function(){var pow2_53=0x20000000000000;// Return a 53 bit integer n, where 0 <= n < 9007199254740992.
	// Check if Math.random() produces more than 32 bits of randomness.
	// If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
	// 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
	var random53bitInt=Math.random()*pow2_53&0x1fffff?function(){return mathfloor(Math.random()*pow2_53);}:function(){return(Math.random()*0x40000000|0)*0x800000+(Math.random()*0x800000|0);};return function(dp){var a,b,e,k,v,i=0,c=[],rand=new BigNumber(ONE);dp=dp==null||!isValidInt(dp,0,MAX,14)?DECIMAL_PLACES:dp|0;k=mathceil(dp/LOG_BASE);if(CRYPTO){// Browsers supporting crypto.getRandomValues.
	if(crypto.getRandomValues){a=crypto.getRandomValues(new Uint32Array(k*=2));for(;i<k;){// 53 bits:
	// ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
	// 11111 11111111 11111111 11111111 11100000 00000000 00000000
	// ((Math.pow(2, 32) - 1) >>> 11).toString(2)
	//                                     11111 11111111 11111111
	// 0x20000 is 2^21.
	v=a[i]*0x20000+(a[i+1]>>>11);// Rejection sampling:
	// 0 <= v < 9007199254740992
	// Probability that v >= 9e15, is
	// 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
	if(v>=9e15){b=crypto.getRandomValues(new Uint32Array(2));a[i]=b[0];a[i+1]=b[1];}else{// 0 <= v <= 8999999999999999
	// 0 <= (v % 1e14) <= 99999999999999
	c.push(v%1e14);i+=2;}}i=k/2;// Node.js supporting crypto.randomBytes.
	}else if(crypto.randomBytes){// buffer
	a=crypto.randomBytes(k*=7);for(;i<k;){// 0x1000000000000 is 2^48, 0x10000000000 is 2^40
	// 0x100000000 is 2^32, 0x1000000 is 2^24
	// 11111 11111111 11111111 11111111 11111111 11111111 11111111
	// 0 <= v < 9007199254740992
	v=(a[i]&31)*0x1000000000000+a[i+1]*0x10000000000+a[i+2]*0x100000000+a[i+3]*0x1000000+(a[i+4]<<16)+(a[i+5]<<8)+a[i+6];if(v>=9e15){crypto.randomBytes(7).copy(a,i);}else{// 0 <= (v % 1e14) <= 99999999999999
	c.push(v%1e14);i+=7;}}i=k/7;}else{CRYPTO=false;if(ERRORS)raise(14,'crypto unavailable',crypto);}}// Use Math.random.
	if(!CRYPTO){for(;i<k;){v=random53bitInt();if(v<9e15)c[i++]=v%1e14;}}k=c[--i];dp%=LOG_BASE;// Convert trailing digits to zeros according to dp.
	if(k&&dp){v=POWS_TEN[LOG_BASE-dp];c[i]=mathfloor(k/v)*v;}// Remove trailing elements which are zero.
	for(;c[i]===0;c.pop(),i--){}// Zero?
	if(i<0){c=[e=0];}else{// Remove leading elements which are zero and adjust exponent accordingly.
	for(e=-1;c[0]===0;c.shift(),e-=LOG_BASE){}// Count the digits of the first element of c to determine leading zeros, and...
	for(i=1,v=c[0];v>=10;v/=10,i++){}// adjust the exponent accordingly.
	if(i<LOG_BASE)e-=LOG_BASE-i;}rand.e=e;rand.c=c;return rand;};}();// PRIVATE FUNCTIONS
	// Convert a numeric string of baseIn to a numeric string of baseOut.
	function convertBase(str,baseOut,baseIn,sign){var d,e,k,r,x,xc,y,i=str.indexOf('.'),dp=DECIMAL_PLACES,rm=ROUNDING_MODE;if(baseIn<37)str=str.toLowerCase();// Non-integer.
	if(i>=0){k=POW_PRECISION;// Unlimited precision.
	POW_PRECISION=0;str=str.replace('.','');y=new BigNumber(baseIn);x=y.pow(str.length-i);POW_PRECISION=k;// Convert str as if an integer, then restore the fraction part by dividing the
	// result by its base raised to a power.
	y.c=toBaseOut(toFixedPoint(coeffToString(x.c),x.e),10,baseOut);y.e=y.c.length;}// Convert the number as integer.
	xc=toBaseOut(str,baseIn,baseOut);e=k=xc.length;// Remove trailing zeros.
	for(;xc[--k]==0;xc.pop()){}if(!xc[0])return'0';if(i<0){--e;}else{x.c=xc;x.e=e;// sign is needed for correct rounding.
	x.s=sign;x=div(x,y,dp,rm,baseOut);xc=x.c;r=x.r;e=x.e;}d=e+dp+1;// The rounding digit, i.e. the digit to the right of the digit that may be rounded up.
	i=xc[d];k=baseOut/2;r=r||d<0||xc[d+1]!=null;r=rm<4?(i!=null||r)&&(rm==0||rm==(x.s<0?3:2)):i>k||i==k&&(rm==4||r||rm==6&&xc[d-1]&1||rm==(x.s<0?8:7));if(d<1||!xc[0]){// 1^-dp or 0.
	str=r?toFixedPoint('1',-dp):'0';}else{xc.length=d;if(r){// Rounding up may mean the previous digit has to be rounded up and so on.
	for(--baseOut;++xc[--d]>baseOut;){xc[d]=0;if(!d){++e;xc.unshift(1);}}}// Determine trailing zeros.
	for(k=xc.length;!xc[--k];){}// E.g. [4, 11, 15] becomes 4bf.
	for(i=0,str='';i<=k;str+=ALPHABET.charAt(xc[i++])){}str=toFixedPoint(str,e);}// The caller will add the sign.
	return str;}// Perform division in the specified base. Called by div and convertBase.
	div=function(){// Assume non-zero x and k.
	function multiply(x,k,base){var m,temp,xlo,xhi,carry=0,i=x.length,klo=k%SQRT_BASE,khi=k/SQRT_BASE|0;for(x=x.slice();i--;){xlo=x[i]%SQRT_BASE;xhi=x[i]/SQRT_BASE|0;m=khi*xlo+xhi*klo;temp=klo*xlo+m%SQRT_BASE*SQRT_BASE+carry;carry=(temp/base|0)+(m/SQRT_BASE|0)+khi*xhi;x[i]=temp%base;}if(carry)x.unshift(carry);return x;}function compare(a,b,aL,bL){var i,cmp;if(aL!=bL){cmp=aL>bL?1:-1;}else{for(i=cmp=0;i<aL;i++){if(a[i]!=b[i]){cmp=a[i]>b[i]?1:-1;break;}}}return cmp;}function subtract(a,b,aL,base){var i=0;// Subtract b from a.
	for(;aL--;){a[aL]-=i;i=a[aL]<b[aL]?1:0;a[aL]=i*base+a[aL]-b[aL];}// Remove leading zeros.
	for(;!a[0]&&a.length>1;a.shift()){}}// x: dividend, y: divisor.
	return function(x,y,dp,rm,base){var cmp,e,i,more,n,prod,prodL,q,qc,rem,remL,rem0,xi,xL,yc0,yL,yz,s=x.s==y.s?1:-1,xc=x.c,yc=y.c;// Either NaN, Infinity or 0?
	if(!xc||!xc[0]||!yc||!yc[0]){return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
	!x.s||!y.s||(xc?yc&&xc[0]==yc[0]:!yc)?NaN:// Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
	xc&&xc[0]==0||!yc?s*0:s/0);}q=new BigNumber(s);qc=q.c=[];e=x.e-y.e;s=dp+e+1;if(!base){base=BASE;e=bitFloor(x.e/LOG_BASE)-bitFloor(y.e/LOG_BASE);s=s/LOG_BASE|0;}// Result exponent may be one less then the current value of e.
	// The coefficients of the BigNumbers from convertBase may have trailing zeros.
	for(i=0;yc[i]==(xc[i]||0);i++){}if(yc[i]>(xc[i]||0))e--;if(s<0){qc.push(1);more=true;}else{xL=xc.length;yL=yc.length;i=0;s+=2;// Normalise xc and yc so highest order digit of yc is >= base / 2.
	n=mathfloor(base/(yc[0]+1));// Not necessary, but to handle odd bases where yc[0] == ( base / 2 ) - 1.
	// if ( n > 1 || n++ == 1 && yc[0] < base / 2 ) {
	if(n>1){yc=multiply(yc,n,base);xc=multiply(xc,n,base);yL=yc.length;xL=xc.length;}xi=yL;rem=xc.slice(0,yL);remL=rem.length;// Add zeros to make remainder as long as divisor.
	for(;remL<yL;rem[remL++]=0){}yz=yc.slice();yz.unshift(0);yc0=yc[0];if(yc[1]>=base/2)yc0++;// Not necessary, but to prevent trial digit n > base, when using base 3.
	// else if ( base == 3 && yc0 == 1 ) yc0 = 1 + 1e-15;
	do{n=0;// Compare divisor and remainder.
	cmp=compare(yc,rem,yL,remL);// If divisor < remainder.
	if(cmp<0){// Calculate trial digit, n.
	rem0=rem[0];if(yL!=remL)rem0=rem0*base+(rem[1]||0);// n is how many times the divisor goes into the current remainder.
	n=mathfloor(rem0/yc0);//  Algorithm:
	//  1. product = divisor * trial digit (n)
	//  2. if product > remainder: product -= divisor, n--
	//  3. remainder -= product
	//  4. if product was < remainder at 2:
	//    5. compare new remainder and divisor
	//    6. If remainder > divisor: remainder -= divisor, n++
	if(n>1){// n may be > base only when base is 3.
	if(n>=base)n=base-1;// product = divisor * trial digit.
	prod=multiply(yc,n,base);prodL=prod.length;remL=rem.length;// Compare product and remainder.
	// If product > remainder.
	// Trial digit n too high.
	// n is 1 too high about 5% of the time, and is not known to have
	// ever been more than 1 too high.
	while(compare(prod,rem,prodL,remL)==1){n--;// Subtract divisor from product.
	subtract(prod,yL<prodL?yz:yc,prodL,base);prodL=prod.length;cmp=1;}}else{// n is 0 or 1, cmp is -1.
	// If n is 0, there is no need to compare yc and rem again below,
	// so change cmp to 1 to avoid it.
	// If n is 1, leave cmp as -1, so yc and rem are compared again.
	if(n==0){// divisor < remainder, so n must be at least 1.
	cmp=n=1;}// product = divisor
	prod=yc.slice();prodL=prod.length;}if(prodL<remL)prod.unshift(0);// Subtract product from remainder.
	subtract(rem,prod,remL,base);remL=rem.length;// If product was < remainder.
	if(cmp==-1){// Compare divisor and new remainder.
	// If divisor < new remainder, subtract divisor from remainder.
	// Trial digit n too low.
	// n is 1 too low about 5% of the time, and very rarely 2 too low.
	while(compare(yc,rem,yL,remL)<1){n++;// Subtract divisor from remainder.
	subtract(rem,yL<remL?yz:yc,remL,base);remL=rem.length;}}}else if(cmp===0){n++;rem=[0];}// else cmp === 1 and n will be 0
	// Add the next digit, n, to the result array.
	qc[i++]=n;// Update the remainder.
	if(rem[0]){rem[remL++]=xc[xi]||0;}else{rem=[xc[xi]];remL=1;}}while((xi++<xL||rem[0]!=null)&&s--);more=rem[0]!=null;// Leading zero?
	if(!qc[0])qc.shift();}if(base==BASE){// To calculate q.e, first get the number of digits of qc[0].
	for(i=1,s=qc[0];s>=10;s/=10,i++){}round(q,dp+(q.e=i+e*LOG_BASE-1)+1,rm,more);// Caller is convertBase.
	}else{q.e=e;q.r=+more;}return q;};}();/*
	         * Return a string representing the value of BigNumber n in fixed-point or exponential
	         * notation rounded to the specified decimal places or significant digits.
	         *
	         * n is a BigNumber.
	         * i is the index of the last digit required (i.e. the digit that may be rounded up).
	         * rm is the rounding mode.
	         * caller is caller id: toExponential 19, toFixed 20, toFormat 21, toPrecision 24.
	         */function format(n,i,rm,caller){var c0,e,ne,len,str;rm=rm!=null&&isValidInt(rm,0,8,caller,roundingMode)?rm|0:ROUNDING_MODE;if(!n.c)return n.toString();c0=n.c[0];ne=n.e;if(i==null){str=coeffToString(n.c);str=caller==19||caller==24&&ne<=TO_EXP_NEG?toExponential(str,ne):toFixedPoint(str,ne);}else{n=round(new BigNumber(n),i,rm);// n.e may have changed if the value was rounded up.
	e=n.e;str=coeffToString(n.c);len=str.length;// toPrecision returns exponential notation if the number of significant digits
	// specified is less than the number of digits necessary to represent the integer
	// part of the value in fixed-point notation.
	// Exponential notation.
	if(caller==19||caller==24&&(i<=e||e<=TO_EXP_NEG)){// Append zeros?
	for(;len<i;str+='0',len++){}str=toExponential(str,e);// Fixed-point notation.
	}else{i-=ne;str=toFixedPoint(str,e);// Append zeros?
	if(e+1>len){if(--i>0)for(str+='.';i--;str+='0'){}}else{i+=e-len;if(i>0){if(e+1==len)str+='.';for(;i--;str+='0'){}}}}}return n.s<0&&c0?'-'+str:str;}// Handle BigNumber.max and BigNumber.min.
	function maxOrMin(args,method){var m,n,i=0;if(isArray(args[0]))args=args[0];m=new BigNumber(args[0]);for(;++i<args.length;){n=new BigNumber(args[i]);// If any number is NaN, return NaN.
	if(!n.s){m=n;break;}else if(method.call(m,n)){m=n;}}return m;}/*
	         * Return true if n is an integer in range, otherwise throw.
	         * Use for argument validation when ERRORS is true.
	         */function intValidatorWithErrors(n,min,max,caller,name){if(n<min||n>max||n!=truncate(n)){raise(caller,(name||'decimal places')+(n<min||n>max?' out of range':' not an integer'),n);}return true;}/*
	         * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
	         * Called by minus, plus and times.
	         */function normalise(n,c,e){var i=1,j=c.length;// Remove trailing zeros.
	for(;!c[--j];c.pop()){}// Calculate the base 10 exponent. First get the number of digits of c[0].
	for(j=c[0];j>=10;j/=10,i++){}// Overflow?
	if((e=i+e*LOG_BASE-1)>MAX_EXP){// Infinity.
	n.c=n.e=null;// Underflow?
	}else if(e<MIN_EXP){// Zero.
	n.c=[n.e=0];}else{n.e=e;n.c=c;}return n;}// Handle values that fail the validity test in BigNumber.
	parseNumeric=function(){var basePrefix=/^(-?)0([xbo])(?=\w[\w.]*$)/i,dotAfter=/^([^.]+)\.$/,dotBefore=/^\.([^.]+)$/,isInfinityOrNaN=/^-?(Infinity|NaN)$/,whitespaceOrPlus=/^\s*\+(?=[\w.])|^\s+|\s+$/g;return function(x,str,num,b){var base,s=num?str:str.replace(whitespaceOrPlus,'');// No exception on ±Infinity or NaN.
	if(isInfinityOrNaN.test(s)){x.s=isNaN(s)?null:s<0?-1:1;}else{if(!num){// basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
	s=s.replace(basePrefix,function(m,p1,p2){base=(p2=p2.toLowerCase())=='x'?16:p2=='b'?2:8;return!b||b==base?p1:m;});if(b){base=b;// E.g. '1.' to '1', '.1' to '0.1'
	s=s.replace(dotAfter,'$1').replace(dotBefore,'0.$1');}if(str!=s)return new BigNumber(s,base);}// 'new BigNumber() not a number: {n}'
	// 'new BigNumber() not a base {b} number: {n}'
	if(ERRORS)raise(id,'not a'+(b?' base '+b:'')+' number',str);x.s=null;}x.c=x.e=null;id=0;};}();// Throw a BigNumber Error.
	function raise(caller,msg,val){var error=new Error(['new BigNumber',// 0
	'cmp',// 1
	'config',// 2
	'div',// 3
	'divToInt',// 4
	'eq',// 5
	'gt',// 6
	'gte',// 7
	'lt',// 8
	'lte',// 9
	'minus',// 10
	'mod',// 11
	'plus',// 12
	'precision',// 13
	'random',// 14
	'round',// 15
	'shift',// 16
	'times',// 17
	'toDigits',// 18
	'toExponential',// 19
	'toFixed',// 20
	'toFormat',// 21
	'toFraction',// 22
	'pow',// 23
	'toPrecision',// 24
	'toString',// 25
	'BigNumber'// 26
	][caller]+'() '+msg+': '+val);error.name='BigNumber Error';id=0;throw error;}/*
	         * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
	         * If r is truthy, it is known that there are more digits after the rounding digit.
	         */function round(x,sd,rm,r){var d,i,j,k,n,ni,rd,xc=x.c,pows10=POWS_TEN;// if x is not Infinity or NaN...
	if(xc){// rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
	// n is a base 1e14 number, the value of the element of array x.c containing rd.
	// ni is the index of n within x.c.
	// d is the number of digits of n.
	// i is the index of rd within n including leading zeros.
	// j is the actual index of rd within n (if < 0, rd is a leading zero).
	out:{// Get the number of digits of the first element of xc.
	for(d=1,k=xc[0];k>=10;k/=10,d++){}i=sd-d;// If the rounding digit is in the first element of xc...
	if(i<0){i+=LOG_BASE;j=sd;n=xc[ni=0];// Get the rounding digit at index j of n.
	rd=n/pows10[d-j-1]%10|0;}else{ni=mathceil((i+1)/LOG_BASE);if(ni>=xc.length){if(r){// Needed by sqrt.
	for(;xc.length<=ni;xc.push(0)){}n=rd=0;d=1;i%=LOG_BASE;j=i-LOG_BASE+1;}else{break out;}}else{n=k=xc[ni];// Get the number of digits of n.
	for(d=1;k>=10;k/=10,d++){}// Get the index of rd within n.
	i%=LOG_BASE;// Get the index of rd within n, adjusted for leading zeros.
	// The number of leading zeros of n is given by LOG_BASE - d.
	j=i-LOG_BASE+d;// Get the rounding digit at index j of n.
	rd=j<0?0:n/pows10[d-j-1]%10|0;}}r=r||sd<0||// Are there any non-zero digits after the rounding digit?
	// The expression  n % pows10[ d - j - 1 ]  returns all digits of n to the right
	// of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
	xc[ni+1]!=null||(j<0?n:n%pows10[d-j-1]);r=rm<4?(rd||r)&&(rm==0||rm==(x.s<0?3:2)):rd>5||rd==5&&(rm==4||r||rm==6&&// Check whether the digit to the left of the rounding digit is odd.
	(i>0?j>0?n/pows10[d-j]:0:xc[ni-1])%10&1||rm==(x.s<0?8:7));if(sd<1||!xc[0]){xc.length=0;if(r){// Convert sd to decimal places.
	sd-=x.e+1;// 1, 0.1, 0.01, 0.001, 0.0001 etc.
	xc[0]=pows10[(LOG_BASE-sd%LOG_BASE)%LOG_BASE];x.e=-sd||0;}else{// Zero.
	xc[0]=x.e=0;}return x;}// Remove excess digits.
	if(i==0){xc.length=ni;k=1;ni--;}else{xc.length=ni+1;k=pows10[LOG_BASE-i];// E.g. 56700 becomes 56000 if 7 is the rounding digit.
	// j > 0 means i > number of leading zeros of n.
	xc[ni]=j>0?mathfloor(n/pows10[d-j]%pows10[j])*k:0;}// Round up?
	if(r){for(;;){// If the digit to be rounded up is in the first element of xc...
	if(ni==0){// i will be the length of xc[0] before k is added.
	for(i=1,j=xc[0];j>=10;j/=10,i++){}j=xc[0]+=k;for(k=1;j>=10;j/=10,k++){}// if i != k the length has increased.
	if(i!=k){x.e++;if(xc[0]==BASE)xc[0]=1;}break;}else{xc[ni]+=k;if(xc[ni]!=BASE)break;xc[ni--]=0;k=1;}}}// Remove trailing zeros.
	for(i=xc.length;xc[--i]===0;xc.pop()){}}// Overflow? Infinity.
	if(x.e>MAX_EXP){x.c=x.e=null;// Underflow? Zero.
	}else if(x.e<MIN_EXP){x.c=[x.e=0];}}return x;}// PROTOTYPE/INSTANCE METHODS
	/*
	         * Return a new BigNumber whose value is the absolute value of this BigNumber.
	         */P.absoluteValue=P.abs=function(){var x=new BigNumber(this);if(x.s<0)x.s=1;return x;};/*
	         * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
	         * number in the direction of Infinity.
	         */P.ceil=function(){return round(new BigNumber(this),this.e+1,2);};/*
	         * Return
	         * 1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
	         * -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
	         * 0 if they have the same value,
	         * or null if the value of either is NaN.
	         */P.comparedTo=P.cmp=function(y,b){id=1;return compare(this,new BigNumber(y,b));};/*
	         * Return the number of decimal places of the value of this BigNumber, or null if the value
	         * of this BigNumber is ±Infinity or NaN.
	         */P.decimalPlaces=P.dp=function(){var n,v,c=this.c;if(!c)return null;n=((v=c.length-1)-bitFloor(this.e/LOG_BASE))*LOG_BASE;// Subtract the number of trailing zeros of the last number.
	if(v=c[v])for(;v%10==0;v/=10,n--){}if(n<0)n=0;return n;};/*
	         *  n / 0 = I
	         *  n / N = N
	         *  n / I = 0
	         *  0 / n = 0
	         *  0 / 0 = N
	         *  0 / N = N
	         *  0 / I = 0
	         *  N / n = N
	         *  N / 0 = N
	         *  N / N = N
	         *  N / I = N
	         *  I / n = I
	         *  I / 0 = I
	         *  I / N = N
	         *  I / I = N
	         *
	         * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
	         * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
	         */P.dividedBy=P.div=function(y,b){id=3;return div(this,new BigNumber(y,b),DECIMAL_PLACES,ROUNDING_MODE);};/*
	         * Return a new BigNumber whose value is the integer part of dividing the value of this
	         * BigNumber by the value of BigNumber(y, b).
	         */P.dividedToIntegerBy=P.divToInt=function(y,b){id=4;return div(this,new BigNumber(y,b),0,1);};/*
	         * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
	         * otherwise returns false.
	         */P.equals=P.eq=function(y,b){id=5;return compare(this,new BigNumber(y,b))===0;};/*
	         * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
	         * number in the direction of -Infinity.
	         */P.floor=function(){return round(new BigNumber(this),this.e+1,3);};/*
	         * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
	         * otherwise returns false.
	         */P.greaterThan=P.gt=function(y,b){id=6;return compare(this,new BigNumber(y,b))>0;};/*
	         * Return true if the value of this BigNumber is greater than or equal to the value of
	         * BigNumber(y, b), otherwise returns false.
	         */P.greaterThanOrEqualTo=P.gte=function(y,b){id=7;return(b=compare(this,new BigNumber(y,b)))===1||b===0;};/*
	         * Return true if the value of this BigNumber is a finite number, otherwise returns false.
	         */P.isFinite=function(){return!!this.c;};/*
	         * Return true if the value of this BigNumber is an integer, otherwise return false.
	         */P.isInteger=P.isInt=function(){return!!this.c&&bitFloor(this.e/LOG_BASE)>this.c.length-2;};/*
	         * Return true if the value of this BigNumber is NaN, otherwise returns false.
	         */P.isNaN=function(){return!this.s;};/*
	         * Return true if the value of this BigNumber is negative, otherwise returns false.
	         */P.isNegative=P.isNeg=function(){return this.s<0;};/*
	         * Return true if the value of this BigNumber is 0 or -0, otherwise returns false.
	         */P.isZero=function(){return!!this.c&&this.c[0]==0;};/*
	         * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
	         * otherwise returns false.
	         */P.lessThan=P.lt=function(y,b){id=8;return compare(this,new BigNumber(y,b))<0;};/*
	         * Return true if the value of this BigNumber is less than or equal to the value of
	         * BigNumber(y, b), otherwise returns false.
	         */P.lessThanOrEqualTo=P.lte=function(y,b){id=9;return(b=compare(this,new BigNumber(y,b)))===-1||b===0;};/*
	         *  n - 0 = n
	         *  n - N = N
	         *  n - I = -I
	         *  0 - n = -n
	         *  0 - 0 = 0
	         *  0 - N = N
	         *  0 - I = -I
	         *  N - n = N
	         *  N - 0 = N
	         *  N - N = N
	         *  N - I = N
	         *  I - n = I
	         *  I - 0 = I
	         *  I - N = N
	         *  I - I = N
	         *
	         * Return a new BigNumber whose value is the value of this BigNumber minus the value of
	         * BigNumber(y, b).
	         */P.minus=P.sub=function(y,b){var i,j,t,xLTy,x=this,a=x.s;id=10;y=new BigNumber(y,b);b=y.s;// Either NaN?
	if(!a||!b)return new BigNumber(NaN);// Signs differ?
	if(a!=b){y.s=-b;return x.plus(y);}var xe=x.e/LOG_BASE,ye=y.e/LOG_BASE,xc=x.c,yc=y.c;if(!xe||!ye){// Either Infinity?
	if(!xc||!yc)return xc?(y.s=-b,y):new BigNumber(yc?x:NaN);// Either zero?
	if(!xc[0]||!yc[0]){// Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
	return yc[0]?(y.s=-b,y):new BigNumber(xc[0]?x:// IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
	ROUNDING_MODE==3?-0:0);}}xe=bitFloor(xe);ye=bitFloor(ye);xc=xc.slice();// Determine which is the bigger number.
	if(a=xe-ye){if(xLTy=a<0){a=-a;t=xc;}else{ye=xe;t=yc;}t.reverse();// Prepend zeros to equalise exponents.
	for(b=a;b--;t.push(0)){}t.reverse();}else{// Exponents equal. Check digit by digit.
	j=(xLTy=(a=xc.length)<(b=yc.length))?a:b;for(a=b=0;b<j;b++){if(xc[b]!=yc[b]){xLTy=xc[b]<yc[b];break;}}}// x < y? Point xc to the array of the bigger number.
	if(xLTy)t=xc,xc=yc,yc=t,y.s=-y.s;b=(j=yc.length)-(i=xc.length);// Append zeros to xc if shorter.
	// No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
	if(b>0)for(;b--;xc[i++]=0){}b=BASE-1;// Subtract yc from xc.
	for(;j>a;){if(xc[--j]<yc[j]){for(i=j;i&&!xc[--i];xc[i]=b){}--xc[i];xc[j]+=BASE;}xc[j]-=yc[j];}// Remove leading zeros and adjust exponent accordingly.
	for(;xc[0]==0;xc.shift(),--ye){}// Zero?
	if(!xc[0]){// Following IEEE 754 (2008) 6.3,
	// n - n = +0  but  n - n = -0  when rounding towards -Infinity.
	y.s=ROUNDING_MODE==3?-1:1;y.c=[y.e=0];return y;}// No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
	// for finite x and y.
	return normalise(y,xc,ye);};/*
	         *   n % 0 =  N
	         *   n % N =  N
	         *   n % I =  n
	         *   0 % n =  0
	         *  -0 % n = -0
	         *   0 % 0 =  N
	         *   0 % N =  N
	         *   0 % I =  0
	         *   N % n =  N
	         *   N % 0 =  N
	         *   N % N =  N
	         *   N % I =  N
	         *   I % n =  N
	         *   I % 0 =  N
	         *   I % N =  N
	         *   I % I =  N
	         *
	         * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
	         * BigNumber(y, b). The result depends on the value of MODULO_MODE.
	         */P.modulo=P.mod=function(y,b){var q,s,x=this;id=11;y=new BigNumber(y,b);// Return NaN if x is Infinity or NaN, or y is NaN or zero.
	if(!x.c||!y.s||y.c&&!y.c[0]){return new BigNumber(NaN);// Return x if y is Infinity or x is zero.
	}else if(!y.c||x.c&&!x.c[0]){return new BigNumber(x);}if(MODULO_MODE==9){// Euclidian division: q = sign(y) * floor(x / abs(y))
	// r = x - qy    where  0 <= r < abs(y)
	s=y.s;y.s=1;q=div(x,y,0,3);y.s=s;q.s*=s;}else{q=div(x,y,0,MODULO_MODE);}return x.minus(q.times(y));};/*
	         * Return a new BigNumber whose value is the value of this BigNumber negated,
	         * i.e. multiplied by -1.
	         */P.negated=P.neg=function(){var x=new BigNumber(this);x.s=-x.s||null;return x;};/*
	         *  n + 0 = n
	         *  n + N = N
	         *  n + I = I
	         *  0 + n = n
	         *  0 + 0 = 0
	         *  0 + N = N
	         *  0 + I = I
	         *  N + n = N
	         *  N + 0 = N
	         *  N + N = N
	         *  N + I = N
	         *  I + n = I
	         *  I + 0 = I
	         *  I + N = N
	         *  I + I = I
	         *
	         * Return a new BigNumber whose value is the value of this BigNumber plus the value of
	         * BigNumber(y, b).
	         */P.plus=P.add=function(y,b){var t,x=this,a=x.s;id=12;y=new BigNumber(y,b);b=y.s;// Either NaN?
	if(!a||!b)return new BigNumber(NaN);// Signs differ?
	if(a!=b){y.s=-b;return x.minus(y);}var xe=x.e/LOG_BASE,ye=y.e/LOG_BASE,xc=x.c,yc=y.c;if(!xe||!ye){// Return ±Infinity if either ±Infinity.
	if(!xc||!yc)return new BigNumber(a/0);// Either zero?
	// Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
	if(!xc[0]||!yc[0])return yc[0]?y:new BigNumber(xc[0]?x:a*0);}xe=bitFloor(xe);ye=bitFloor(ye);xc=xc.slice();// Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
	if(a=xe-ye){if(a>0){ye=xe;t=yc;}else{a=-a;t=xc;}t.reverse();for(;a--;t.push(0)){}t.reverse();}a=xc.length;b=yc.length;// Point xc to the longer array, and b to the shorter length.
	if(a-b<0)t=yc,yc=xc,xc=t,b=a;// Only start adding at yc.length - 1 as the further digits of xc can be ignored.
	for(a=0;b;){a=(xc[--b]=xc[b]+yc[b]+a)/BASE|0;xc[b]=BASE===xc[b]?0:xc[b]%BASE;}if(a){xc.unshift(a);++ye;}// No need to check for zero, as +x + +y != 0 && -x + -y != 0
	// ye = MAX_EXP + 1 possible
	return normalise(y,xc,ye);};/*
	         * Return the number of significant digits of the value of this BigNumber.
	         *
	         * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	         */P.precision=P.sd=function(z){var n,v,x=this,c=x.c;// 'precision() argument not a boolean or binary digit: {z}'
	if(z!=null&&z!==!!z&&z!==1&&z!==0){if(ERRORS)raise(13,'argument'+notBool,z);if(z!=!!z)z=null;}if(!c)return null;v=c.length-1;n=v*LOG_BASE+1;if(v=c[v]){// Subtract the number of trailing zeros of the last element.
	for(;v%10==0;v/=10,n--){}// Add the number of digits of the first element.
	for(v=c[0];v>=10;v/=10,n++){}}if(z&&x.e+1>n)n=x.e+1;return n;};/*
	         * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
	         * dp decimal places using rounding mode rm, or to 0 and ROUNDING_MODE respectively if
	         * omitted.
	         *
	         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
	         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	         *
	         * 'round() decimal places out of range: {dp}'
	         * 'round() decimal places not an integer: {dp}'
	         * 'round() rounding mode not an integer: {rm}'
	         * 'round() rounding mode out of range: {rm}'
	         */P.round=function(dp,rm){var n=new BigNumber(this);if(dp==null||isValidInt(dp,0,MAX,15)){round(n,~~dp+this.e+1,rm==null||!isValidInt(rm,0,8,15,roundingMode)?ROUNDING_MODE:rm|0);}return n;};/*
	         * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
	         * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
	         *
	         * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
	         *
	         * If k is out of range and ERRORS is false, the result will be ±0 if k < 0, or ±Infinity
	         * otherwise.
	         *
	         * 'shift() argument not an integer: {k}'
	         * 'shift() argument out of range: {k}'
	         */P.shift=function(k){var n=this;return isValidInt(k,-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER,16,'argument')// k < 1e+21, or truncate(k) will produce exponential notation.
	?n.times('1e'+truncate(k)):new BigNumber(n.c&&n.c[0]&&(k<-MAX_SAFE_INTEGER||k>MAX_SAFE_INTEGER)?n.s*(k<0?0:1/0):n);};/*
	         *  sqrt(-n) =  N
	         *  sqrt( N) =  N
	         *  sqrt(-I) =  N
	         *  sqrt( I) =  I
	         *  sqrt( 0) =  0
	         *  sqrt(-0) = -0
	         *
	         * Return a new BigNumber whose value is the square root of the value of this BigNumber,
	         * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
	         */P.squareRoot=P.sqrt=function(){var m,n,r,rep,t,x=this,c=x.c,s=x.s,e=x.e,dp=DECIMAL_PLACES+4,half=new BigNumber('0.5');// Negative/NaN/Infinity/zero?
	if(s!==1||!c||!c[0]){return new BigNumber(!s||s<0&&(!c||c[0])?NaN:c?x:1/0);}// Initial estimate.
	s=Math.sqrt(+x);// Math.sqrt underflow/overflow?
	// Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	if(s==0||s==1/0){n=coeffToString(c);if((n.length+e)%2==0)n+='0';s=Math.sqrt(n);e=bitFloor((e+1)/2)-(e<0||e%2);if(s==1/0){n='1e'+e;}else{n=s.toExponential();n=n.slice(0,n.indexOf('e')+1)+e;}r=new BigNumber(n);}else{r=new BigNumber(s+'');}// Check for zero.
	// r could be zero if MIN_EXP is changed after the this value was created.
	// This would cause a division by zero (x/t) and hence Infinity below, which would cause
	// coeffToString to throw.
	if(r.c[0]){e=r.e;s=e+dp;if(s<3)s=0;// Newton-Raphson iteration.
	for(;;){t=r;r=half.times(t.plus(div(x,t,dp,1)));if(coeffToString(t.c).slice(0,s)===(n=coeffToString(r.c)).slice(0,s)){// The exponent of r may here be one less than the final result exponent,
	// e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
	// are indexed correctly.
	if(r.e<e)--s;n=n.slice(s-3,s+1);// The 4th rounding digit may be in error by -1 so if the 4 rounding digits
	// are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
	// iteration.
	if(n=='9999'||!rep&&n=='4999'){// On the first iteration only, check to see if rounding up gives the
	// exact result as the nines may infinitely repeat.
	if(!rep){round(t,t.e+DECIMAL_PLACES+2,0);if(t.times(t).eq(x)){r=t;break;}}dp+=4;s+=4;rep=1;}else{// If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
	// result. If not, then there are further digits and m will be truthy.
	if(!+n||!+n.slice(1)&&n.charAt(0)=='5'){// Truncate to the first rounding digit.
	round(r,r.e+DECIMAL_PLACES+2,1);m=!r.times(r).eq(x);}break;}}}}return round(r,r.e+DECIMAL_PLACES+1,ROUNDING_MODE,m);};/*
	         *  n * 0 = 0
	         *  n * N = N
	         *  n * I = I
	         *  0 * n = 0
	         *  0 * 0 = 0
	         *  0 * N = N
	         *  0 * I = N
	         *  N * n = N
	         *  N * 0 = N
	         *  N * N = N
	         *  N * I = N
	         *  I * n = I
	         *  I * 0 = N
	         *  I * N = N
	         *  I * I = I
	         *
	         * Return a new BigNumber whose value is the value of this BigNumber times the value of
	         * BigNumber(y, b).
	         */P.times=P.mul=function(y,b){var c,e,i,j,k,m,xcL,xlo,xhi,ycL,ylo,yhi,zc,base,sqrtBase,x=this,xc=x.c,yc=(id=17,y=new BigNumber(y,b)).c;// Either NaN, ±Infinity or ±0?
	if(!xc||!yc||!xc[0]||!yc[0]){// Return NaN if either is NaN, or one is 0 and the other is Infinity.
	if(!x.s||!y.s||xc&&!xc[0]&&!yc||yc&&!yc[0]&&!xc){y.c=y.e=y.s=null;}else{y.s*=x.s;// Return ±Infinity if either is ±Infinity.
	if(!xc||!yc){y.c=y.e=null;// Return ±0 if either is ±0.
	}else{y.c=[0];y.e=0;}}return y;}e=bitFloor(x.e/LOG_BASE)+bitFloor(y.e/LOG_BASE);y.s*=x.s;xcL=xc.length;ycL=yc.length;// Ensure xc points to longer array and xcL to its length.
	if(xcL<ycL)zc=xc,xc=yc,yc=zc,i=xcL,xcL=ycL,ycL=i;// Initialise the result array with zeros.
	for(i=xcL+ycL,zc=[];i--;zc.push(0)){}base=BASE;sqrtBase=SQRT_BASE;for(i=ycL;--i>=0;){c=0;ylo=yc[i]%sqrtBase;yhi=yc[i]/sqrtBase|0;for(k=xcL,j=i+k;j>i;){xlo=xc[--k]%sqrtBase;xhi=xc[k]/sqrtBase|0;m=yhi*xlo+xhi*ylo;xlo=ylo*xlo+m%sqrtBase*sqrtBase+zc[j]+c;c=(xlo/base|0)+(m/sqrtBase|0)+yhi*xhi;zc[j--]=xlo%base;}zc[j]=c;}if(c){++e;}else{zc.shift();}return normalise(y,zc,e);};/*
	         * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
	         * sd significant digits using rounding mode rm, or ROUNDING_MODE if rm is omitted.
	         *
	         * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
	         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	         *
	         * 'toDigits() precision out of range: {sd}'
	         * 'toDigits() precision not an integer: {sd}'
	         * 'toDigits() rounding mode not an integer: {rm}'
	         * 'toDigits() rounding mode out of range: {rm}'
	         */P.toDigits=function(sd,rm){var n=new BigNumber(this);sd=sd==null||!isValidInt(sd,1,MAX,18,'precision')?null:sd|0;rm=rm==null||!isValidInt(rm,0,8,18,roundingMode)?ROUNDING_MODE:rm|0;return sd?round(n,sd,rm):n;};/*
	         * Return a string representing the value of this BigNumber in exponential notation and
	         * rounded using ROUNDING_MODE to dp fixed decimal places.
	         *
	         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
	         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	         *
	         * 'toExponential() decimal places not an integer: {dp}'
	         * 'toExponential() decimal places out of range: {dp}'
	         * 'toExponential() rounding mode not an integer: {rm}'
	         * 'toExponential() rounding mode out of range: {rm}'
	         */P.toExponential=function(dp,rm){return format(this,dp!=null&&isValidInt(dp,0,MAX,19)?~~dp+1:null,rm,19);};/*
	         * Return a string representing the value of this BigNumber in fixed-point notation rounding
	         * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
	         *
	         * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
	         * but e.g. (-0.00001).toFixed(0) is '-0'.
	         *
	         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
	         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	         *
	         * 'toFixed() decimal places not an integer: {dp}'
	         * 'toFixed() decimal places out of range: {dp}'
	         * 'toFixed() rounding mode not an integer: {rm}'
	         * 'toFixed() rounding mode out of range: {rm}'
	         */P.toFixed=function(dp,rm){return format(this,dp!=null&&isValidInt(dp,0,MAX,20)?~~dp+this.e+1:null,rm,20);};/*
	         * Return a string representing the value of this BigNumber in fixed-point notation rounded
	         * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
	         * of the FORMAT object (see BigNumber.config).
	         *
	         * FORMAT = {
	         *      decimalSeparator : '.',
	         *      groupSeparator : ',',
	         *      groupSize : 3,
	         *      secondaryGroupSize : 0,
	         *      fractionGroupSeparator : '\xA0',    // non-breaking space
	         *      fractionGroupSize : 0
	         * };
	         *
	         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
	         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	         *
	         * 'toFormat() decimal places not an integer: {dp}'
	         * 'toFormat() decimal places out of range: {dp}'
	         * 'toFormat() rounding mode not an integer: {rm}'
	         * 'toFormat() rounding mode out of range: {rm}'
	         */P.toFormat=function(dp,rm){var str=format(this,dp!=null&&isValidInt(dp,0,MAX,21)?~~dp+this.e+1:null,rm,21);if(this.c){var i,arr=str.split('.'),g1=+FORMAT.groupSize,g2=+FORMAT.secondaryGroupSize,groupSeparator=FORMAT.groupSeparator,intPart=arr[0],fractionPart=arr[1],isNeg=this.s<0,intDigits=isNeg?intPart.slice(1):intPart,len=intDigits.length;if(g2)i=g1,g1=g2,g2=i,len-=i;if(g1>0&&len>0){i=len%g1||g1;intPart=intDigits.substr(0,i);for(;i<len;i+=g1){intPart+=groupSeparator+intDigits.substr(i,g1);}if(g2>0)intPart+=groupSeparator+intDigits.slice(i);if(isNeg)intPart='-'+intPart;}str=fractionPart?intPart+FORMAT.decimalSeparator+((g2=+FORMAT.fractionGroupSize)?fractionPart.replace(new RegExp('\\d{'+g2+'}\\B','g'),'$&'+FORMAT.fractionGroupSeparator):fractionPart):intPart;}return str;};/*
	         * Return a string array representing the value of this BigNumber as a simple fraction with
	         * an integer numerator and an integer denominator. The denominator will be a positive
	         * non-zero value less than or equal to the specified maximum denominator. If a maximum
	         * denominator is not specified, the denominator will be the lowest value necessary to
	         * represent the number exactly.
	         *
	         * [md] {number|string|BigNumber} Integer >= 1 and < Infinity. The maximum denominator.
	         *
	         * 'toFraction() max denominator not an integer: {md}'
	         * 'toFraction() max denominator out of range: {md}'
	         */P.toFraction=function(md){var arr,d0,d2,e,exp,n,n0,q,s,k=ERRORS,x=this,xc=x.c,d=new BigNumber(ONE),n1=d0=new BigNumber(ONE),d1=n0=new BigNumber(ONE);if(md!=null){ERRORS=false;n=new BigNumber(md);ERRORS=k;if(!(k=n.isInt())||n.lt(ONE)){if(ERRORS){raise(22,'max denominator '+(k?'out of range':'not an integer'),md);}// ERRORS is false:
	// If md is a finite non-integer >= 1, round it to an integer and use it.
	md=!k&&n.c&&round(n,n.e+1,1).gte(ONE)?n:null;}}if(!xc)return x.toString();s=coeffToString(xc);// Determine initial denominator.
	// d is a power of 10 and the minimum max denominator that specifies the value exactly.
	e=d.e=s.length-x.e-1;d.c[0]=POWS_TEN[(exp=e%LOG_BASE)<0?LOG_BASE+exp:exp];md=!md||n.cmp(d)>0?e>0?d:n1:n;exp=MAX_EXP;MAX_EXP=1/0;n=new BigNumber(s);// n0 = d1 = 0
	n0.c[0]=0;for(;;){q=div(n,d,0,1);d2=d0.plus(q.times(d1));if(d2.cmp(md)==1)break;d0=d1;d1=d2;n1=n0.plus(q.times(d2=n1));n0=d2;d=n.minus(q.times(d2=d));n=d2;}d2=div(md.minus(d0),d1,0,1);n0=n0.plus(d2.times(n1));d0=d0.plus(d2.times(d1));n0.s=n1.s=x.s;e*=2;// Determine which fraction is closer to x, n0/d0 or n1/d1
	arr=div(n1,d1,e,ROUNDING_MODE).minus(x).abs().cmp(div(n0,d0,e,ROUNDING_MODE).minus(x).abs())<1?[n1.toString(),d1.toString()]:[n0.toString(),d0.toString()];MAX_EXP=exp;return arr;};/*
	         * Return the value of this BigNumber converted to a number primitive.
	         */P.toNumber=function(){return+this;};/*
	         * Return a BigNumber whose value is the value of this BigNumber raised to the power n.
	         * If m is present, return the result modulo m.
	         * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
	         * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using
	         * ROUNDING_MODE.
	         *
	         * The modular power operation works efficiently when x, n, and m are positive integers,
	         * otherwise it is equivalent to calculating x.toPower(n).modulo(m) (with POW_PRECISION 0).
	         *
	         * n {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
	         * [m] {number|string|BigNumber} The modulus.
	         *
	         * 'pow() exponent not an integer: {n}'
	         * 'pow() exponent out of range: {n}'
	         *
	         * Performs 54 loop iterations for n of 9007199254740991.
	         */P.toPower=P.pow=function(n,m){var k,y,z,i=mathfloor(n<0?-n:+n),x=this;if(m!=null){id=23;m=new BigNumber(m);}// Pass ±Infinity to Math.pow if exponent is out of range.
	if(!isValidInt(n,-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER,23,'exponent')&&(!isFinite(n)||i>MAX_SAFE_INTEGER&&(n/=0)||parseFloat(n)!=n&&!(n=NaN))||n==0){k=Math.pow(+x,n);return new BigNumber(m?k%m:k);}if(m){if(n>1&&x.gt(ONE)&&x.isInt()&&m.gt(ONE)&&m.isInt()){x=x.mod(m);}else{z=m;// Nullify m so only a single mod operation is performed at the end.
	m=null;}}else if(POW_PRECISION){// Truncating each coefficient array to a length of k after each multiplication
	// equates to truncating significant digits to POW_PRECISION + [28, 41],
	// i.e. there will be a minimum of 28 guard digits retained.
	// (Using + 1.5 would give [9, 21] guard digits.)
	k=mathceil(POW_PRECISION/LOG_BASE+2);}y=new BigNumber(ONE);for(;;){if(i%2){y=y.times(x);if(!y.c)break;if(k){if(y.c.length>k)y.c.length=k;}else if(m){y=y.mod(m);}}i=mathfloor(i/2);if(!i)break;x=x.times(x);if(k){if(x.c&&x.c.length>k)x.c.length=k;}else if(m){x=x.mod(m);}}if(m)return y;if(n<0)y=ONE.div(y);return z?y.mod(z):k?round(y,POW_PRECISION,ROUNDING_MODE):y;};/*
	         * Return a string representing the value of this BigNumber rounded to sd significant digits
	         * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
	         * necessary to represent the integer part of the value in fixed-point notation, then use
	         * exponential notation.
	         *
	         * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
	         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	         *
	         * 'toPrecision() precision not an integer: {sd}'
	         * 'toPrecision() precision out of range: {sd}'
	         * 'toPrecision() rounding mode not an integer: {rm}'
	         * 'toPrecision() rounding mode out of range: {rm}'
	         */P.toPrecision=function(sd,rm){return format(this,sd!=null&&isValidInt(sd,1,MAX,24,'precision')?sd|0:null,rm,24);};/*
	         * Return a string representing the value of this BigNumber in base b, or base 10 if b is
	         * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
	         * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
	         * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
	         * TO_EXP_NEG, return exponential notation.
	         *
	         * [b] {number} Integer, 2 to 64 inclusive.
	         *
	         * 'toString() base not an integer: {b}'
	         * 'toString() base out of range: {b}'
	         */P.toString=function(b){var str,n=this,s=n.s,e=n.e;// Infinity or NaN?
	if(e===null){if(s){str='Infinity';if(s<0)str='-'+str;}else{str='NaN';}}else{str=coeffToString(n.c);if(b==null||!isValidInt(b,2,64,25,'base')){str=e<=TO_EXP_NEG||e>=TO_EXP_POS?toExponential(str,e):toFixedPoint(str,e);}else{str=convertBase(toFixedPoint(str,e),b|0,10,s);}if(s<0&&n.c[0])str='-'+str;}return str;};/*
	         * Return a new BigNumber whose value is the value of this BigNumber truncated to a whole
	         * number.
	         */P.truncated=P.trunc=function(){return round(new BigNumber(this),this.e+1,1);};/*
	         * Return as toString, but do not accept a base argument, and include the minus sign for
	         * negative zero.
	         */P.valueOf=P.toJSON=function(){var str,n=this,e=n.e;if(e===null)return n.toString();str=coeffToString(n.c);str=e<=TO_EXP_NEG||e>=TO_EXP_POS?toExponential(str,e):toFixedPoint(str,e);return n.s<0?'-'+str:str;};// Aliases for BigDecimal methods.
	//P.add = P.plus;         // P.add included above
	//P.subtract = P.minus;   // P.sub included above
	//P.multiply = P.times;   // P.mul included above
	//P.divide = P.div;
	//P.remainder = P.mod;
	//P.compareTo = P.cmp;
	//P.negate = P.neg;
	if(configObj!=null)BigNumber.config(configObj);return BigNumber;}// PRIVATE HELPER FUNCTIONS
	function bitFloor(n){var i=n|0;return n>0||n===i?i:i-1;}// Return a coefficient array as a string of base 10 digits.
	function coeffToString(a){var s,z,i=1,j=a.length,r=a[0]+'';for(;i<j;){s=a[i++]+'';z=LOG_BASE-s.length;for(;z--;s='0'+s){}r+=s;}// Determine trailing zeros.
	for(j=r.length;r.charCodeAt(--j)===48;){}return r.slice(0,j+1||1);}// Compare the value of BigNumbers x and y.
	function compare(x,y){var a,b,xc=x.c,yc=y.c,i=x.s,j=y.s,k=x.e,l=y.e;// Either NaN?
	if(!i||!j)return null;a=xc&&!xc[0];b=yc&&!yc[0];// Either zero?
	if(a||b)return a?b?0:-j:i;// Signs differ?
	if(i!=j)return i;a=i<0;b=k==l;// Either Infinity?
	if(!xc||!yc)return b?0:!xc^a?1:-1;// Compare exponents.
	if(!b)return k>l^a?1:-1;j=(k=xc.length)<(l=yc.length)?k:l;// Compare digit by digit.
	for(i=0;i<j;i++){if(xc[i]!=yc[i])return xc[i]>yc[i]^a?1:-1;}// Compare lengths.
	return k==l?0:k>l^a?1:-1;}/*
	     * Return true if n is a valid number in range, otherwise false.
	     * Use for argument validation when ERRORS is false.
	     * Note: parseInt('1e+1') == 1 but parseFloat('1e+1') == 10.
	     */function intValidatorNoErrors(n,min,max){return(n=truncate(n))>=min&&n<=max;}function isArray(obj){return Object.prototype.toString.call(obj)=='[object Array]';}/*
	     * Convert string of baseIn to an array of numbers of baseOut.
	     * Eg. convertBase('255', 10, 16) returns [15, 15].
	     * Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
	     */function toBaseOut(str,baseIn,baseOut){var j,arr=[0],arrL,i=0,len=str.length;for(;i<len;){for(arrL=arr.length;arrL--;arr[arrL]*=baseIn){}arr[j=0]+=ALPHABET.indexOf(str.charAt(i++));for(;j<arr.length;j++){if(arr[j]>baseOut-1){if(arr[j+1]==null)arr[j+1]=0;arr[j+1]+=arr[j]/baseOut|0;arr[j]%=baseOut;}}}return arr.reverse();}function toExponential(str,e){return(str.length>1?str.charAt(0)+'.'+str.slice(1):str)+(e<0?'e':'e+')+e;}function toFixedPoint(str,e){var len,z;// Negative exponent?
	if(e<0){// Prepend zeros.
	for(z='0.';++e;z+='0'){}str=z+str;// Positive exponent
	}else{len=str.length;// Append zeros.
	if(++e>len){for(z='0',e-=len;--e;z+='0'){}str+=z;}else if(e<len){str=str.slice(0,e)+'.'+str.slice(e);}}return str;}function truncate(n){n=parseFloat(n);return n<0?mathceil(n):mathfloor(n);}// EXPORT
	BigNumber=constructorFactory();BigNumber.default=BigNumber.BigNumber=BigNumber;// AMD.
	if(typeof define=='function'&&define.amd){define(function(){return BigNumber;});// Node.js and other environments that support module.exports.
	}else if(typeof module!='undefined'&&module.exports){module.exports=BigNumber;// Browser.
	}else{if(!globalObj)globalObj=typeof self!='undefined'?self:Function('return this')();globalObj.BigNumber=BigNumber;}})(this);},{}],24:[function(require,module,exports){},{}],25:[function(require,module,exports){arguments[4][24][0].apply(exports,arguments);},{"dup":24}],26:[function(require,module,exports){(function(global){'use strict';var buffer=require('buffer');var Buffer=buffer.Buffer;var SlowBuffer=buffer.SlowBuffer;var MAX_LEN=buffer.kMaxLength||2147483647;exports.alloc=function alloc(size,fill,encoding){if(typeof Buffer.alloc==='function'){return Buffer.alloc(size,fill,encoding);}if(typeof encoding==='number'){throw new TypeError('encoding must not be number');}if(typeof size!=='number'){throw new TypeError('size must be a number');}if(size>MAX_LEN){throw new RangeError('size is too large');}var enc=encoding;var _fill=fill;if(_fill===undefined){enc=undefined;_fill=0;}var buf=new Buffer(size);if(typeof _fill==='string'){var fillBuf=new Buffer(_fill,enc);var flen=fillBuf.length;var i=-1;while(++i<size){buf[i]=fillBuf[i%flen];}}else{buf.fill(_fill);}return buf;};exports.allocUnsafe=function allocUnsafe(size){if(typeof Buffer.allocUnsafe==='function'){return Buffer.allocUnsafe(size);}if(typeof size!=='number'){throw new TypeError('size must be a number');}if(size>MAX_LEN){throw new RangeError('size is too large');}return new Buffer(size);};exports.from=function from(value,encodingOrOffset,length){if(typeof Buffer.from==='function'&&(!global.Uint8Array||Uint8Array.from!==Buffer.from)){return Buffer.from(value,encodingOrOffset,length);}if(typeof value==='number'){throw new TypeError('"value" argument must not be a number');}if(typeof value==='string'){return new Buffer(value,encodingOrOffset);}if(typeof ArrayBuffer!=='undefined'&&value instanceof ArrayBuffer){var offset=encodingOrOffset;if(arguments.length===1){return new Buffer(value);}if(typeof offset==='undefined'){offset=0;}var len=length;if(typeof len==='undefined'){len=value.byteLength-offset;}if(offset>=value.byteLength){throw new RangeError('\'offset\' is out of bounds');}if(len>value.byteLength-offset){throw new RangeError('\'length\' is out of bounds');}return new Buffer(value.slice(offset,offset+len));}if(Buffer.isBuffer(value)){var out=new Buffer(value.length);value.copy(out,0,0,value.length);return out;}if(value){if(Array.isArray(value)||typeof ArrayBuffer!=='undefined'&&value.buffer instanceof ArrayBuffer||'length'in value){return new Buffer(value);}if(value.type==='Buffer'&&Array.isArray(value.data)){return new Buffer(value.data);}}throw new TypeError('First argument must be a string, Buffer, '+'ArrayBuffer, Array, or array-like object.');};exports.allocUnsafeSlow=function allocUnsafeSlow(size){if(typeof Buffer.allocUnsafeSlow==='function'){return Buffer.allocUnsafeSlow(size);}if(typeof size!=='number'){throw new TypeError('size must be a number');}if(size>=MAX_LEN){throw new RangeError('size is too large');}return new SlowBuffer(size);};}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{"buffer":27}],27:[function(require,module,exports){/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 *//* eslint-disable no-proto */'use strict';var base64=require('base64-js');var ieee754=require('ieee754');exports.Buffer=Buffer;exports.SlowBuffer=SlowBuffer;exports.INSPECT_MAX_BYTES=50;var K_MAX_LENGTH=0x7fffffff;exports.kMaxLength=K_MAX_LENGTH;/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=='undefined'&&typeof console.error==='function'){console.error('This browser lacks typed array (Uint8Array) support which is required by '+'`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');}function typedArraySupport(){// Can typed array instances can be augmented?
	try{var arr=new Uint8Array(1);arr.__proto__={__proto__:Uint8Array.prototype,foo:function foo(){return 42;}};return arr.foo()===42;}catch(e){return false;}}function createBuffer(length){if(length>K_MAX_LENGTH){throw new RangeError('Invalid typed array length');}// Return an augmented `Uint8Array` instance
	var buf=new Uint8Array(length);buf.__proto__=Buffer.prototype;return buf;}/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */function Buffer(arg,encodingOrOffset,length){// Common case.
	if(typeof arg==='number'){if(typeof encodingOrOffset==='string'){throw new Error('If encoding is specified then the first argument must be a string');}return allocUnsafe(arg);}return from(arg,encodingOrOffset,length);}// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	if(typeof Symbol!=='undefined'&&Symbol.species&&Buffer[Symbol.species]===Buffer){Object.defineProperty(Buffer,Symbol.species,{value:null,configurable:true,enumerable:false,writable:false});}Buffer.poolSize=8192;// not used by this implementation
	function from(value,encodingOrOffset,length){if(typeof value==='number'){throw new TypeError('"value" argument must not be a number');}if(value instanceof ArrayBuffer){return fromArrayBuffer(value,encodingOrOffset,length);}if(typeof value==='string'){return fromString(value,encodingOrOffset);}return fromObject(value);}/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/Buffer.from=function(value,encodingOrOffset,length){return from(value,encodingOrOffset,length);};// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Buffer.prototype.__proto__=Uint8Array.prototype;Buffer.__proto__=Uint8Array;function assertSize(size){if(typeof size!=='number'){throw new TypeError('"size" argument must be a number');}else if(size<0){throw new RangeError('"size" argument must not be negative');}}function alloc(size,fill,encoding){assertSize(size);if(size<=0){return createBuffer(size);}if(fill!==undefined){// Only pay attention to encoding if it's a string. This
	// prevents accidentally sending in a number that would
	// be interpretted as a start offset.
	return typeof encoding==='string'?createBuffer(size).fill(fill,encoding):createBuffer(size).fill(fill);}return createBuffer(size);}/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/Buffer.alloc=function(size,fill,encoding){return alloc(size,fill,encoding);};function allocUnsafe(size){assertSize(size);return createBuffer(size<0?0:checked(size)|0);}/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */Buffer.allocUnsafe=function(size){return allocUnsafe(size);};/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */Buffer.allocUnsafeSlow=function(size){return allocUnsafe(size);};function fromString(string,encoding){if(typeof encoding!=='string'||encoding===''){encoding='utf8';}if(!Buffer.isEncoding(encoding)){throw new TypeError('"encoding" must be a valid string encoding');}var length=byteLength(string,encoding)|0;var buf=createBuffer(length);var actual=buf.write(string,encoding);if(actual!==length){// Writing a hex string, for example, that contains invalid characters will
	// cause everything after the first invalid character to be ignored. (e.g.
	// 'abxxcd' will be treated as 'ab')
	buf=buf.slice(0,actual);}return buf;}function fromArrayLike(array){var length=array.length<0?0:checked(array.length)|0;var buf=createBuffer(length);for(var i=0;i<length;i+=1){buf[i]=array[i]&255;}return buf;}function fromArrayBuffer(array,byteOffset,length){if(byteOffset<0||array.byteLength<byteOffset){throw new RangeError('\'offset\' is out of bounds');}if(array.byteLength<byteOffset+(length||0)){throw new RangeError('\'length\' is out of bounds');}var buf;if(byteOffset===undefined&&length===undefined){buf=new Uint8Array(array);}else if(length===undefined){buf=new Uint8Array(array,byteOffset);}else{buf=new Uint8Array(array,byteOffset,length);}// Return an augmented `Uint8Array` instance
	buf.__proto__=Buffer.prototype;return buf;}function fromObject(obj){if(Buffer.isBuffer(obj)){var len=checked(obj.length)|0;var buf=createBuffer(len);if(buf.length===0){return buf;}obj.copy(buf,0,0,len);return buf;}if(obj){if(isArrayBufferView(obj)||'length'in obj){if(typeof obj.length!=='number'||numberIsNaN(obj.length)){return createBuffer(0);}return fromArrayLike(obj);}if(obj.type==='Buffer'&&Array.isArray(obj.data)){return fromArrayLike(obj.data);}}throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');}function checked(length){// Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	// length is NaN (which is otherwise coerced to zero.)
	if(length>=K_MAX_LENGTH){throw new RangeError('Attempt to allocate Buffer larger than maximum '+'size: 0x'+K_MAX_LENGTH.toString(16)+' bytes');}return length|0;}function SlowBuffer(length){if(+length!=length){// eslint-disable-line eqeqeq
	length=0;}return Buffer.alloc(+length);}Buffer.isBuffer=function isBuffer(b){return b!=null&&b._isBuffer===true;};Buffer.compare=function compare(a,b){if(!Buffer.isBuffer(a)||!Buffer.isBuffer(b)){throw new TypeError('Arguments must be Buffers');}if(a===b)return 0;var x=a.length;var y=b.length;for(var i=0,len=Math.min(x,y);i<len;++i){if(a[i]!==b[i]){x=a[i];y=b[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};Buffer.isEncoding=function isEncoding(encoding){switch(String(encoding).toLowerCase()){case'hex':case'utf8':case'utf-8':case'ascii':case'latin1':case'binary':case'base64':case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return true;default:return false;}};Buffer.concat=function concat(list,length){if(!Array.isArray(list)){throw new TypeError('"list" argument must be an Array of Buffers');}if(list.length===0){return Buffer.alloc(0);}var i;if(length===undefined){length=0;for(i=0;i<list.length;++i){length+=list[i].length;}}var buffer=Buffer.allocUnsafe(length);var pos=0;for(i=0;i<list.length;++i){var buf=list[i];if(!Buffer.isBuffer(buf)){throw new TypeError('"list" argument must be an Array of Buffers');}buf.copy(buffer,pos);pos+=buf.length;}return buffer;};function byteLength(string,encoding){if(Buffer.isBuffer(string)){return string.length;}if(isArrayBufferView(string)||string instanceof ArrayBuffer){return string.byteLength;}if(typeof string!=='string'){string=''+string;}var len=string.length;if(len===0)return 0;// Use a for loop to avoid recursion
	var loweredCase=false;for(;;){switch(encoding){case'ascii':case'latin1':case'binary':return len;case'utf8':case'utf-8':case undefined:return utf8ToBytes(string).length;case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return len*2;case'hex':return len>>>1;case'base64':return base64ToBytes(string).length;default:if(loweredCase)return utf8ToBytes(string).length;// assume utf8
	encoding=(''+encoding).toLowerCase();loweredCase=true;}}}Buffer.byteLength=byteLength;function slowToString(encoding,start,end){var loweredCase=false;// No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	// property of a typed array.
	// This behaves neither like String nor Uint8Array in that we set start/end
	// to their upper/lower bounds if the value passed is out of range.
	// undefined is handled specially as per ECMA-262 6th Edition,
	// Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	if(start===undefined||start<0){start=0;}// Return early if start > this.length. Done here to prevent potential uint32
	// coercion fail below.
	if(start>this.length){return'';}if(end===undefined||end>this.length){end=this.length;}if(end<=0){return'';}// Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	end>>>=0;start>>>=0;if(end<=start){return'';}if(!encoding)encoding='utf8';while(true){switch(encoding){case'hex':return hexSlice(this,start,end);case'utf8':case'utf-8':return utf8Slice(this,start,end);case'ascii':return asciiSlice(this,start,end);case'latin1':case'binary':return latin1Slice(this,start,end);case'base64':return base64Slice(this,start,end);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return utf16leSlice(this,start,end);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(encoding+'').toLowerCase();loweredCase=true;}}}// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer=true;function swap(b,n,m){var i=b[n];b[n]=b[m];b[m]=i;}Buffer.prototype.swap16=function swap16(){var len=this.length;if(len%2!==0){throw new RangeError('Buffer size must be a multiple of 16-bits');}for(var i=0;i<len;i+=2){swap(this,i,i+1);}return this;};Buffer.prototype.swap32=function swap32(){var len=this.length;if(len%4!==0){throw new RangeError('Buffer size must be a multiple of 32-bits');}for(var i=0;i<len;i+=4){swap(this,i,i+3);swap(this,i+1,i+2);}return this;};Buffer.prototype.swap64=function swap64(){var len=this.length;if(len%8!==0){throw new RangeError('Buffer size must be a multiple of 64-bits');}for(var i=0;i<len;i+=8){swap(this,i,i+7);swap(this,i+1,i+6);swap(this,i+2,i+5);swap(this,i+3,i+4);}return this;};Buffer.prototype.toString=function toString(){var length=this.length;if(length===0)return'';if(arguments.length===0)return utf8Slice(this,0,length);return slowToString.apply(this,arguments);};Buffer.prototype.equals=function equals(b){if(!Buffer.isBuffer(b))throw new TypeError('Argument must be a Buffer');if(this===b)return true;return Buffer.compare(this,b)===0;};Buffer.prototype.inspect=function inspect(){var str='';var max=exports.INSPECT_MAX_BYTES;if(this.length>0){str=this.toString('hex',0,max).match(/.{2}/g).join(' ');if(this.length>max)str+=' ... ';}return'<Buffer '+str+'>';};Buffer.prototype.compare=function compare(target,start,end,thisStart,thisEnd){if(!Buffer.isBuffer(target)){throw new TypeError('Argument must be a Buffer');}if(start===undefined){start=0;}if(end===undefined){end=target?target.length:0;}if(thisStart===undefined){thisStart=0;}if(thisEnd===undefined){thisEnd=this.length;}if(start<0||end>target.length||thisStart<0||thisEnd>this.length){throw new RangeError('out of range index');}if(thisStart>=thisEnd&&start>=end){return 0;}if(thisStart>=thisEnd){return-1;}if(start>=end){return 1;}start>>>=0;end>>>=0;thisStart>>>=0;thisEnd>>>=0;if(this===target)return 0;var x=thisEnd-thisStart;var y=end-start;var len=Math.min(x,y);var thisCopy=this.slice(thisStart,thisEnd);var targetCopy=target.slice(start,end);for(var i=0;i<len;++i){if(thisCopy[i]!==targetCopy[i]){x=thisCopy[i];y=targetCopy[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer,val,byteOffset,encoding,dir){// Empty buffer means no match
	if(buffer.length===0)return-1;// Normalize byteOffset
	if(typeof byteOffset==='string'){encoding=byteOffset;byteOffset=0;}else if(byteOffset>0x7fffffff){byteOffset=0x7fffffff;}else if(byteOffset<-0x80000000){byteOffset=-0x80000000;}byteOffset=+byteOffset;// Coerce to Number.
	if(numberIsNaN(byteOffset)){// byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	byteOffset=dir?0:buffer.length-1;}// Normalize byteOffset: negative offsets start from the end of the buffer
	if(byteOffset<0)byteOffset=buffer.length+byteOffset;if(byteOffset>=buffer.length){if(dir)return-1;else byteOffset=buffer.length-1;}else if(byteOffset<0){if(dir)byteOffset=0;else return-1;}// Normalize val
	if(typeof val==='string'){val=Buffer.from(val,encoding);}// Finally, search either indexOf (if dir is true) or lastIndexOf
	if(Buffer.isBuffer(val)){// Special case: looking for empty string/buffer always fails
	if(val.length===0){return-1;}return arrayIndexOf(buffer,val,byteOffset,encoding,dir);}else if(typeof val==='number'){val=val&0xFF;// Search for a byte value [0-255]
	if(typeof Uint8Array.prototype.indexOf==='function'){if(dir){return Uint8Array.prototype.indexOf.call(buffer,val,byteOffset);}else{return Uint8Array.prototype.lastIndexOf.call(buffer,val,byteOffset);}}return arrayIndexOf(buffer,[val],byteOffset,encoding,dir);}throw new TypeError('val must be string, number or Buffer');}function arrayIndexOf(arr,val,byteOffset,encoding,dir){var indexSize=1;var arrLength=arr.length;var valLength=val.length;if(encoding!==undefined){encoding=String(encoding).toLowerCase();if(encoding==='ucs2'||encoding==='ucs-2'||encoding==='utf16le'||encoding==='utf-16le'){if(arr.length<2||val.length<2){return-1;}indexSize=2;arrLength/=2;valLength/=2;byteOffset/=2;}}function read(buf,i){if(indexSize===1){return buf[i];}else{return buf.readUInt16BE(i*indexSize);}}var i;if(dir){var foundIndex=-1;for(i=byteOffset;i<arrLength;i++){if(read(arr,i)===read(val,foundIndex===-1?0:i-foundIndex)){if(foundIndex===-1)foundIndex=i;if(i-foundIndex+1===valLength)return foundIndex*indexSize;}else{if(foundIndex!==-1)i-=i-foundIndex;foundIndex=-1;}}}else{if(byteOffset+valLength>arrLength)byteOffset=arrLength-valLength;for(i=byteOffset;i>=0;i--){var found=true;for(var j=0;j<valLength;j++){if(read(arr,i+j)!==read(val,j)){found=false;break;}}if(found)return i;}}return-1;}Buffer.prototype.includes=function includes(val,byteOffset,encoding){return this.indexOf(val,byteOffset,encoding)!==-1;};Buffer.prototype.indexOf=function indexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,true);};Buffer.prototype.lastIndexOf=function lastIndexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,false);};function hexWrite(buf,string,offset,length){offset=Number(offset)||0;var remaining=buf.length-offset;if(!length){length=remaining;}else{length=Number(length);if(length>remaining){length=remaining;}}// must be an even number of digits
	var strLen=string.length;if(strLen%2!==0)throw new TypeError('Invalid hex string');if(length>strLen/2){length=strLen/2;}for(var i=0;i<length;++i){var parsed=parseInt(string.substr(i*2,2),16);if(numberIsNaN(parsed))return i;buf[offset+i]=parsed;}return i;}function utf8Write(buf,string,offset,length){return blitBuffer(utf8ToBytes(string,buf.length-offset),buf,offset,length);}function asciiWrite(buf,string,offset,length){return blitBuffer(asciiToBytes(string),buf,offset,length);}function latin1Write(buf,string,offset,length){return asciiWrite(buf,string,offset,length);}function base64Write(buf,string,offset,length){return blitBuffer(base64ToBytes(string),buf,offset,length);}function ucs2Write(buf,string,offset,length){return blitBuffer(utf16leToBytes(string,buf.length-offset),buf,offset,length);}Buffer.prototype.write=function write(string,offset,length,encoding){// Buffer#write(string)
	if(offset===undefined){encoding='utf8';length=this.length;offset=0;// Buffer#write(string, encoding)
	}else if(length===undefined&&typeof offset==='string'){encoding=offset;length=this.length;offset=0;// Buffer#write(string, offset[, length][, encoding])
	}else if(isFinite(offset)){offset=offset>>>0;if(isFinite(length)){length=length>>>0;if(encoding===undefined)encoding='utf8';}else{encoding=length;length=undefined;}}else{throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');}var remaining=this.length-offset;if(length===undefined||length>remaining)length=remaining;if(string.length>0&&(length<0||offset<0)||offset>this.length){throw new RangeError('Attempt to write outside buffer bounds');}if(!encoding)encoding='utf8';var loweredCase=false;for(;;){switch(encoding){case'hex':return hexWrite(this,string,offset,length);case'utf8':case'utf-8':return utf8Write(this,string,offset,length);case'ascii':return asciiWrite(this,string,offset,length);case'latin1':case'binary':return latin1Write(this,string,offset,length);case'base64':// Warning: maxLength not taken into account in base64Write
	return base64Write(this,string,offset,length);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return ucs2Write(this,string,offset,length);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(''+encoding).toLowerCase();loweredCase=true;}}};Buffer.prototype.toJSON=function toJSON(){return{type:'Buffer',data:Array.prototype.slice.call(this._arr||this,0)};};function base64Slice(buf,start,end){if(start===0&&end===buf.length){return base64.fromByteArray(buf);}else{return base64.fromByteArray(buf.slice(start,end));}}function utf8Slice(buf,start,end){end=Math.min(buf.length,end);var res=[];var i=start;while(i<end){var firstByte=buf[i];var codePoint=null;var bytesPerSequence=firstByte>0xEF?4:firstByte>0xDF?3:firstByte>0xBF?2:1;if(i+bytesPerSequence<=end){var secondByte,thirdByte,fourthByte,tempCodePoint;switch(bytesPerSequence){case 1:if(firstByte<0x80){codePoint=firstByte;}break;case 2:secondByte=buf[i+1];if((secondByte&0xC0)===0x80){tempCodePoint=(firstByte&0x1F)<<0x6|secondByte&0x3F;if(tempCodePoint>0x7F){codePoint=tempCodePoint;}}break;case 3:secondByte=buf[i+1];thirdByte=buf[i+2];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0xC|(secondByte&0x3F)<<0x6|thirdByte&0x3F;if(tempCodePoint>0x7FF&&(tempCodePoint<0xD800||tempCodePoint>0xDFFF)){codePoint=tempCodePoint;}}break;case 4:secondByte=buf[i+1];thirdByte=buf[i+2];fourthByte=buf[i+3];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80&&(fourthByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0x12|(secondByte&0x3F)<<0xC|(thirdByte&0x3F)<<0x6|fourthByte&0x3F;if(tempCodePoint>0xFFFF&&tempCodePoint<0x110000){codePoint=tempCodePoint;}}}}if(codePoint===null){// we did not generate a valid codePoint so insert a
	// replacement char (U+FFFD) and advance only 1 byte
	codePoint=0xFFFD;bytesPerSequence=1;}else if(codePoint>0xFFFF){// encode to utf16 (surrogate pair dance)
	codePoint-=0x10000;res.push(codePoint>>>10&0x3FF|0xD800);codePoint=0xDC00|codePoint&0x3FF;}res.push(codePoint);i+=bytesPerSequence;}return decodeCodePointsArray(res);}// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH=0x1000;function decodeCodePointsArray(codePoints){var len=codePoints.length;if(len<=MAX_ARGUMENTS_LENGTH){return String.fromCharCode.apply(String,codePoints);// avoid extra slice()
	}// Decode in chunks to avoid "call stack size exceeded".
	var res='';var i=0;while(i<len){res+=String.fromCharCode.apply(String,codePoints.slice(i,i+=MAX_ARGUMENTS_LENGTH));}return res;}function asciiSlice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]&0x7F);}return ret;}function latin1Slice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]);}return ret;}function hexSlice(buf,start,end){var len=buf.length;if(!start||start<0)start=0;if(!end||end<0||end>len)end=len;var out='';for(var i=start;i<end;++i){out+=toHex(buf[i]);}return out;}function utf16leSlice(buf,start,end){var bytes=buf.slice(start,end);var res='';for(var i=0;i<bytes.length;i+=2){res+=String.fromCharCode(bytes[i]+bytes[i+1]*256);}return res;}Buffer.prototype.slice=function slice(start,end){var len=this.length;start=~~start;end=end===undefined?len:~~end;if(start<0){start+=len;if(start<0)start=0;}else if(start>len){start=len;}if(end<0){end+=len;if(end<0)end=0;}else if(end>len){end=len;}if(end<start)end=start;var newBuf=this.subarray(start,end);// Return an augmented `Uint8Array` instance
	newBuf.__proto__=Buffer.prototype;return newBuf;};/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */function checkOffset(offset,ext,length){if(offset%1!==0||offset<0)throw new RangeError('offset is not uint');if(offset+ext>length)throw new RangeError('Trying to access beyond buffer length');}Buffer.prototype.readUIntLE=function readUIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}return val;};Buffer.prototype.readUIntBE=function readUIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){checkOffset(offset,byteLength,this.length);}var val=this[offset+--byteLength];var mul=1;while(byteLength>0&&(mul*=0x100)){val+=this[offset+--byteLength]*mul;}return val;};Buffer.prototype.readUInt8=function readUInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);return this[offset];};Buffer.prototype.readUInt16LE=function readUInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]|this[offset+1]<<8;};Buffer.prototype.readUInt16BE=function readUInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]<<8|this[offset+1];};Buffer.prototype.readUInt32LE=function readUInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return(this[offset]|this[offset+1]<<8|this[offset+2]<<16)+this[offset+3]*0x1000000;};Buffer.prototype.readUInt32BE=function readUInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]*0x1000000+(this[offset+1]<<16|this[offset+2]<<8|this[offset+3]);};Buffer.prototype.readIntLE=function readIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readIntBE=function readIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var i=byteLength;var mul=1;var val=this[offset+--i];while(i>0&&(mul*=0x100)){val+=this[offset+--i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readInt8=function readInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);if(!(this[offset]&0x80))return this[offset];return(0xff-this[offset]+1)*-1;};Buffer.prototype.readInt16LE=function readInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset]|this[offset+1]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt16BE=function readInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset+1]|this[offset]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt32LE=function readInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]|this[offset+1]<<8|this[offset+2]<<16|this[offset+3]<<24;};Buffer.prototype.readInt32BE=function readInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]<<24|this[offset+1]<<16|this[offset+2]<<8|this[offset+3];};Buffer.prototype.readFloatLE=function readFloatLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,true,23,4);};Buffer.prototype.readFloatBE=function readFloatBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,false,23,4);};Buffer.prototype.readDoubleLE=function readDoubleLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,true,52,8);};Buffer.prototype.readDoubleBE=function readDoubleBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,false,52,8);};function checkInt(buf,value,offset,ext,max,min){if(!Buffer.isBuffer(buf))throw new TypeError('"buffer" argument must be a Buffer instance');if(value>max||value<min)throw new RangeError('"value" argument is out of bounds');if(offset+ext>buf.length)throw new RangeError('Index out of range');}Buffer.prototype.writeUIntLE=function writeUIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var mul=1;var i=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUIntBE=function writeUIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var i=byteLength-1;var mul=1;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUInt8=function writeUInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0xff,0);this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeUInt16LE=function writeUInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeUInt16BE=function writeUInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeUInt32LE=function writeUInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset+3]=value>>>24;this[offset+2]=value>>>16;this[offset+1]=value>>>8;this[offset]=value&0xff;return offset+4;};Buffer.prototype.writeUInt32BE=function writeUInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};Buffer.prototype.writeIntLE=function writeIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=0;var mul=1;var sub=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i-1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeIntBE=function writeIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=byteLength-1;var mul=1;var sub=0;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i+1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeInt8=function writeInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0x7f,-0x80);if(value<0)value=0xff+value+1;this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeInt16LE=function writeInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeInt16BE=function writeInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeInt32LE=function writeInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);this[offset]=value&0xff;this[offset+1]=value>>>8;this[offset+2]=value>>>16;this[offset+3]=value>>>24;return offset+4;};Buffer.prototype.writeInt32BE=function writeInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);if(value<0)value=0xffffffff+value+1;this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};function checkIEEE754(buf,value,offset,ext,max,min){if(offset+ext>buf.length)throw new RangeError('Index out of range');if(offset<0)throw new RangeError('Index out of range');}function writeFloat(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,4,3.4028234663852886e+38,-3.4028234663852886e+38);}ieee754.write(buf,value,offset,littleEndian,23,4);return offset+4;}Buffer.prototype.writeFloatLE=function writeFloatLE(value,offset,noAssert){return writeFloat(this,value,offset,true,noAssert);};Buffer.prototype.writeFloatBE=function writeFloatBE(value,offset,noAssert){return writeFloat(this,value,offset,false,noAssert);};function writeDouble(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,8,1.7976931348623157E+308,-1.7976931348623157E+308);}ieee754.write(buf,value,offset,littleEndian,52,8);return offset+8;}Buffer.prototype.writeDoubleLE=function writeDoubleLE(value,offset,noAssert){return writeDouble(this,value,offset,true,noAssert);};Buffer.prototype.writeDoubleBE=function writeDoubleBE(value,offset,noAssert){return writeDouble(this,value,offset,false,noAssert);};// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy=function copy(target,targetStart,start,end){if(!start)start=0;if(!end&&end!==0)end=this.length;if(targetStart>=target.length)targetStart=target.length;if(!targetStart)targetStart=0;if(end>0&&end<start)end=start;// Copy 0 bytes; we're done
	if(end===start)return 0;if(target.length===0||this.length===0)return 0;// Fatal error conditions
	if(targetStart<0){throw new RangeError('targetStart out of bounds');}if(start<0||start>=this.length)throw new RangeError('sourceStart out of bounds');if(end<0)throw new RangeError('sourceEnd out of bounds');// Are we oob?
	if(end>this.length)end=this.length;if(target.length-targetStart<end-start){end=target.length-targetStart+start;}var len=end-start;var i;if(this===target&&start<targetStart&&targetStart<end){// descending copy from end
	for(i=len-1;i>=0;--i){target[i+targetStart]=this[i+start];}}else if(len<1000){// ascending copy from start
	for(i=0;i<len;++i){target[i+targetStart]=this[i+start];}}else{Uint8Array.prototype.set.call(target,this.subarray(start,start+len),targetStart);}return len;};// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill=function fill(val,start,end,encoding){// Handle string cases:
	if(typeof val==='string'){if(typeof start==='string'){encoding=start;start=0;end=this.length;}else if(typeof end==='string'){encoding=end;end=this.length;}if(val.length===1){var code=val.charCodeAt(0);if(code<256){val=code;}}if(encoding!==undefined&&typeof encoding!=='string'){throw new TypeError('encoding must be a string');}if(typeof encoding==='string'&&!Buffer.isEncoding(encoding)){throw new TypeError('Unknown encoding: '+encoding);}}else if(typeof val==='number'){val=val&255;}// Invalid ranges are not set to a default, so can range check early.
	if(start<0||this.length<start||this.length<end){throw new RangeError('Out of range index');}if(end<=start){return this;}start=start>>>0;end=end===undefined?this.length:end>>>0;if(!val)val=0;var i;if(typeof val==='number'){for(i=start;i<end;++i){this[i]=val;}}else{var bytes=Buffer.isBuffer(val)?val:new Buffer(val,encoding);var len=bytes.length;for(i=0;i<end-start;++i){this[i+start]=bytes[i%len];}}return this;};// HELPER FUNCTIONS
	// ================
	var INVALID_BASE64_RE=/[^+/0-9A-Za-z-_]/g;function base64clean(str){// Node strips out invalid characters like \n and \t from the string, base64-js does not
	str=str.trim().replace(INVALID_BASE64_RE,'');// Node converts strings with length < 2 to ''
	if(str.length<2)return'';// Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	while(str.length%4!==0){str=str+'=';}return str;}function toHex(n){if(n<16)return'0'+n.toString(16);return n.toString(16);}function utf8ToBytes(string,units){units=units||Infinity;var codePoint;var length=string.length;var leadSurrogate=null;var bytes=[];for(var i=0;i<length;++i){codePoint=string.charCodeAt(i);// is surrogate component
	if(codePoint>0xD7FF&&codePoint<0xE000){// last char was a lead
	if(!leadSurrogate){// no lead yet
	if(codePoint>0xDBFF){// unexpected trail
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}else if(i+1===length){// unpaired lead
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}// valid lead
	leadSurrogate=codePoint;continue;}// 2 leads in a row
	if(codePoint<0xDC00){if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);leadSurrogate=codePoint;continue;}// valid surrogate pair
	codePoint=(leadSurrogate-0xD800<<10|codePoint-0xDC00)+0x10000;}else if(leadSurrogate){// valid bmp char, but last char was a lead
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);}leadSurrogate=null;// encode utf8
	if(codePoint<0x80){if((units-=1)<0)break;bytes.push(codePoint);}else if(codePoint<0x800){if((units-=2)<0)break;bytes.push(codePoint>>0x6|0xC0,codePoint&0x3F|0x80);}else if(codePoint<0x10000){if((units-=3)<0)break;bytes.push(codePoint>>0xC|0xE0,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else if(codePoint<0x110000){if((units-=4)<0)break;bytes.push(codePoint>>0x12|0xF0,codePoint>>0xC&0x3F|0x80,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else{throw new Error('Invalid code point');}}return bytes;}function asciiToBytes(str){var byteArray=[];for(var i=0;i<str.length;++i){// Node's code seems to be doing this and not & 0x7F..
	byteArray.push(str.charCodeAt(i)&0xFF);}return byteArray;}function utf16leToBytes(str,units){var c,hi,lo;var byteArray=[];for(var i=0;i<str.length;++i){if((units-=2)<0)break;c=str.charCodeAt(i);hi=c>>8;lo=c%256;byteArray.push(lo);byteArray.push(hi);}return byteArray;}function base64ToBytes(str){return base64.toByteArray(base64clean(str));}function blitBuffer(src,dst,offset,length){for(var i=0;i<length;++i){if(i+offset>=dst.length||i>=src.length)break;dst[i+offset]=src[i];}return i;}// Node 0.10 supports `ArrayBuffer` but lacks `ArrayBuffer.isView`
	function isArrayBufferView(obj){return typeof ArrayBuffer.isView==='function'&&ArrayBuffer.isView(obj);}function numberIsNaN(obj){return obj!==obj;// eslint-disable-line no-self-compare
	}},{"base64-js":22,"ieee754":75}],28:[function(require,module,exports){'use strict';exports.Commented=require('./commented');exports.Diagnose=require('./diagnose');exports.Decoder=require('./decoder');exports.Encoder=require('./encoder');exports.Simple=require('./simple');exports.Tagged=require('./tagged');exports.comment=exports.Commented.comment;exports.decodeAll=exports.Decoder.decodeAll;exports.decodeFirst=exports.Decoder.decodeFirst;exports.decodeAllSync=exports.Decoder.decodeAllSync;exports.decodeFirstSync=exports.Decoder.decodeFirstSync;exports.diagnose=exports.Diagnose.diagnose;exports.encode=exports.Encoder.encode;exports.decode=exports.Decoder.decodeFirstSync;exports.leveldb={decode:exports.Decoder.decodeAllSync,encode:exports.Encoder.encode,buffer:true,name:'cbor'};},{"./commented":29,"./decoder":31,"./diagnose":32,"./encoder":33,"./simple":34,"./tagged":35}],29:[function(require,module,exports){(function(Buffer){'use strict';var stream=require('stream');var util=require('util');var utils=require('./utils');var Simple=require('./simple');var Decoder=require('./decoder');var constants=require('./constants');var bignumber=require('bignumber.js');var NoFilter=require('nofilter');var MT=constants.MT,NUMBYTES=constants.NUMBYTES,SYMS=constants.SYMS;function plural(c){if(c>1){return's';}else{return'';}}/**
	 * Generate the expanded format of RFC 7049, section 2.2.1
	 *
	 * @extends {stream.Transform}
	 */var Commented=function(_stream$Transform){_inherits(Commented,_stream$Transform);/**
	   * Create a CBOR commenter.
	   *
	   * @param {any} [options={}] - Stream options
	   * @param {bool} [options.max_depth=10] - how many times to indent the dashes
	   */function Commented(options){_classCallCheck(this,Commented);options=options||{};options.readableObjectMode=false;options.writableObjectMode=false;var max_depth=options.max_depth!=null?options.max_depth:10;delete options.max_depth;var _this2=_possibleConstructorReturn(this,(Commented.__proto__||Object.getPrototypeOf(Commented)).call(this,options));_this2.depth=1;_this2.max_depth=max_depth;_this2.all=new NoFilter();_this2.parser=new Decoder(options);_this2.parser.on('value',_this2._on_value.bind(_this2));_this2.parser.on('start',_this2._on_start.bind(_this2));_this2.parser.on('start-string',_this2._on_start_string.bind(_this2));_this2.parser.on('stop',_this2._on_stop.bind(_this2));_this2.parser.on('more-bytes',_this2._on_more.bind(_this2));_this2.parser.on('error',_this2._on_error.bind(_this2));_this2.parser.on('data',_this2._on_data.bind(_this2));_this2.parser.bs.on('read',_this2._on_read.bind(_this2));return _this2;}/**
	   * @private
	   */_createClass(Commented,[{key:"_transform",value:function _transform(fresh,encoding,cb){this.parser.write(fresh,encoding,function(er){cb(er);});}/**
	   * @private
	   */},{key:"_flush",value:function _flush(cb){// TODO: find the test that covers this, and look at the return value
	return this.parser._flush(cb);}/**
	   * @callback commentCallback
	   * @param {Error} error - if one was generated
	   * @param {string} commented - the comment string
	   *//**
	   * Comment on an input Buffer or string, creating a string passed to the
	   * callback.  If callback not specified, a promise is returned.
	   *
	   * @static
	   * @param {(string|Buffer|NoFilter)} input
	   * @param {(string|object|function)} options
	   * @param {number} [options.max_depth=10] - how many times to indent the dashes
	   * @param {commentCallback=} cb
	   * @returns {Promise} if cb not specified
	   */},{key:"_on_error",/**
	   * @private
	   */value:function _on_error(er){return this.push('ERROR: ')&&this.push(er.toString())&&this.push('\n');}/**
	   * @private
	   */},{key:"_on_read",value:function _on_read(buf){this.all.write(buf);var hex=buf.toString('hex');this.push(new Array(this.depth+1).join('  '));this.push(hex);var ind=(this.max_depth-this.depth)*2;ind-=hex.length;if(ind<1){ind=1;}this.push(new Array(ind+1).join(' '));return this.push('-- ');}/**
	   * @private
	   */},{key:"_on_more",value:function _on_more(mt,len,parent_mt,pos){this.depth++;var desc='';switch(mt){case MT.POS_INT:desc='Positive number,';break;case MT.NEG_INT:desc='Negative number,';break;case MT.ARRAY:desc='Array, length';break;case MT.MAP:desc='Map, count';break;case MT.BYTE_STRING:desc='Bytes, length';break;case MT.UTF8_STRING:desc='String, length';break;case MT.SIMPLE_FLOAT:if(len===1){desc='Simple value,';}else{desc='Float,';}break;}return this.push(desc+' next '+len+' byte'+plural(len)+'\n');}/**
	   * @private
	   */},{key:"_on_start_string",value:function _on_start_string(mt,tag,parent_mt,pos){this.depth++;var desc='';switch(mt){case MT.BYTE_STRING:desc='Bytes, length: '+tag;break;case MT.UTF8_STRING:desc='String, length: '+tag.toString();break;}return this.push(desc+'\n');}/**
	   * @private
	   */},{key:"_on_start",value:function _on_start(mt,tag,parent_mt,pos){this.depth++;if(tag!==SYMS.BREAK){this.push(function(){switch(parent_mt){case MT.ARRAY:return'['+pos+'], ';case MT.MAP:if(pos%2){return'{Val:'+Math.floor(pos/2)+'}, ';}else{return'{Key:'+Math.floor(pos/2)+'}, ';}}}());}this.push(function(){switch(mt){case MT.TAG:return'Tag #'+tag;case MT.ARRAY:if(tag===SYMS.STREAM){return'Array (streaming)';}else{return'Array, '+tag+' item'+plural(tag);}case MT.MAP:if(tag===SYMS.STREAM){return'Map (streaming)';}else{return'Map, '+tag+' pair'+plural(tag);}case MT.BYTE_STRING:return'Bytes (streaming)';case MT.UTF8_STRING:return'String (streaming)';}}());return this.push('\n');}/**
	   * @private
	   */},{key:"_on_stop",value:function _on_stop(mt){return this.depth--;}/**
	   * @private
	   */},{key:"_on_value",value:function _on_value(val,parent_mt,pos,ai){if(val!==SYMS.BREAK){this.push(function(){switch(parent_mt){case MT.ARRAY:return'['+pos+'], ';case MT.MAP:if(pos%2){return'{Val:'+Math.floor(pos/2)+'}, ';}else{return'{Key:'+Math.floor(pos/2)+'}, ';}}}());}if(val===SYMS.BREAK){this.push('BREAK\n');}else if(val===SYMS.NULL){this.push('null\n');}else if(val===SYMS.UNDEFINED){this.push('undefined\n');}else if(typeof val==='string'){this.depth--;if(val.length>0){this.push(JSON.stringify(val));this.push('\n');}}else if(Buffer.isBuffer(val)){this.depth--;if(val.length>0){this.push(val.toString('hex'));this.push('\n');}}else if(val instanceof bignumber){this.push(val.toString());this.push('\n');}else{this.push(util.inspect(val));this.push('\n');}switch(ai){case NUMBYTES.ONE:case NUMBYTES.TWO:case NUMBYTES.FOUR:case NUMBYTES.EIGHT:this.depth--;}}/**
	   * @private
	   */},{key:"_on_data",value:function _on_data(){this.push('0x');this.push(this.all.read().toString('hex'));return this.push('\n');}}],[{key:"comment",value:function comment(input,options,cb){if(input==null){throw new Error('input required');}var encoding=typeof input==='string'?'hex':void 0;var max_depth=10;switch(typeof options==="undefined"?"undefined":_typeof(options)){case'function':cb=options;break;case'string':encoding=options;break;case'number':max_depth=options;break;case'object':var ref1=void 0,ref2=void 0;encoding=(ref1=options.encoding)!=null?ref1:encoding;max_depth=(ref2=options.max_depth)!=null?ref2:max_depth;break;case'undefined':break;default:throw new Error('Unknown option type');}var bs=new NoFilter();var d=new Commented({max_depth:max_depth});var p=null;if(typeof cb==='function'){d.on('end',function(){return cb(null,bs.toString('utf8'));});d.on('error',cb);}else{p=new Promise(function(resolve,reject){d.on('end',function(){return resolve(bs.toString('utf8'));});return d.on('error',reject);});}d.pipe(bs);d.end(input,encoding);return p;}}]);return Commented;}(stream.Transform);module.exports=Commented;}).call(this,{"isBuffer":require("../../is-buffer/index.js")});},{"../../is-buffer/index.js":78,"./constants":30,"./decoder":31,"./simple":34,"./utils":36,"bignumber.js":23,"nofilter":108,"stream":128,"util":136}],30:[function(require,module,exports){'use strict';exports.MT={POS_INT:0,NEG_INT:1,BYTE_STRING:2,UTF8_STRING:3,ARRAY:4,MAP:5,TAG:6,SIMPLE_FLOAT:7};exports.TAG={DATE_STRING:0,DATE_EPOCH:1,POS_BIGINT:2,NEG_BIGINT:3,DECIMAL_FRAC:4,BIGFLOAT:5,BASE64URL_EXPECTED:21,BASE64_EXPECTED:22,BASE16_EXPECTED:23,CBOR:24,URI:32,BASE64URL:33,BASE64:34,REGEXP:35,MIME:36};exports.NUMBYTES={ZERO:0,ONE:24,TWO:25,FOUR:26,EIGHT:27,INDEFINITE:31};exports.SIMPLE={FALSE:20,TRUE:21,NULL:22,UNDEFINED:23};exports.SYMS={NULL:Symbol('null'),UNDEFINED:Symbol('undef'),PARENT:Symbol('parent'),BREAK:Symbol('break'),STREAM:Symbol('stream')};exports.SHIFT32=Math.pow(2,32);},{}],31:[function(require,module,exports){(function(Buffer){'use strict';var BinaryParseStream=require('../vendor/binary-parse-stream');var Tagged=require('./tagged');var Simple=require('./simple');var utils=require('./utils');var bignumber=require('bignumber.js');var NoFilter=require('nofilter');var constants=require('./constants');var MT=constants.MT,NUMBYTES=constants.NUMBYTES,SIMPLE=constants.SIMPLE,SYMS=constants.SYMS;var NEG_ONE=new bignumber(-1);var NEG_MAX=NEG_ONE.sub(new bignumber(Number.MAX_SAFE_INTEGER.toString(16),16));var COUNT=Symbol('count');var PENDING_KEY=Symbol('pending_key');var MAJOR=Symbol('major type');var ERROR=Symbol('error');var NOT_FOUND=Symbol('not found');function parentArray(parent,typ,count){var a=[];a[COUNT]=count;a[SYMS.PARENT]=parent;a[MAJOR]=typ;return a;}function parentBufferStream(parent,typ){var b=new NoFilter();b[SYMS.PARENT]=parent;b[MAJOR]=typ;return b;}/**
	 * Decode a stream of CBOR bytes by transforming them into equivalent
	 * JavaScript data.  Because of the limitations of Node object streams,
	 * special symbols are emitted instead of NULL or UNDEFINED.  Fix those
	 * up by calling {@link Decoder.nullcheck}.
	 *
	 * @extends {BinaryParseStream}
	 */var Decoder=function(_BinaryParseStream){_inherits(Decoder,_BinaryParseStream);/**
	   * Create a parsing stream.
	   *
	   * @param {object} [options={}]
	   * @param {number} [options.max_depth=-1] - the maximum depth to parse.  Use -1 for
	   *   "until you run out of memory".  Set this to a finite positive number for
	   *   un-trusted inputs.  Most standard inputs won't nest more than
	   *   100 or so levels; I've tested into the millions before running out of
	   *   memory.
	   * @param {object=} options.tags - mapping from tag number to function(v),
	   *   where v is the decoded value that comes after the tag, and where the
	   *   function returns the correctly-created value for that tag.
	   */function Decoder(options){_classCallCheck(this,Decoder);options=options||{};var tags=options.tags;delete options.tags;var max_depth=options.max_depth!=null?options.max_depth:-1;delete options.max_depth;var _this3=_possibleConstructorReturn(this,(Decoder.__proto__||Object.getPrototypeOf(Decoder)).call(this,options));_this3.running=true;_this3.max_depth=max_depth;_this3.tags=tags;return _this3;}/**
	   * Check the given value for a symbol encoding a NULL or UNDEFINED value in
	   * the CBOR stream.
	   *
	   * @static
	   * @param {any} val - the value to check
	   * @returns {any} the corrected value
	   *
	   * @example
	   * myDecoder.on('data', function(val) {
	   *   val = Decoder.nullcheck(val);
	   *   ...
	   * });
	   */_createClass(Decoder,[{key:"close",/**
	   * Stop processing
	   */value:function close(){this.running=false;this.__fresh=true;}},{key:"_parse",value:/*#__PURE__*/regeneratorRuntime.mark(function _parse(){var parent,depth,val,octet,mt,ai,parent_major,parent_length,numbytes,buf,again,pm,allstrings,i,len,_i,_len,_i2,_len2,t;return regeneratorRuntime.wrap(function _parse$(_context){while(1){switch(_context.prev=_context.next){case 0:parent=null;depth=0;val=null;case 3:if(false){_context.next=131;break;}if(!(this.max_depth>=0&&depth>this.max_depth)){_context.next=6;break;}throw new Error('Maximum depth '+this.max_depth+' exceeded');case 6:_context.next=8;return 1;case 8:octet=_context.sent[0];if(this.running){_context.next=11;break;}throw new Error('Unexpected data: 0x'+octet.toString(16));case 11:mt=octet>>5;ai=octet&0x1f;parent_major=parent!=null?parent[MAJOR]:undefined;parent_length=parent!=null?parent.length:undefined;_context.t0=ai;_context.next=_context.t0===NUMBYTES.ONE?18:_context.t0===NUMBYTES.TWO?23:_context.t0===NUMBYTES.FOUR?23:_context.t0===NUMBYTES.EIGHT?23:_context.t0===28?30:_context.t0===29?30:_context.t0===30?30:_context.t0===NUMBYTES.INDEFINITE?32:34;break;case 18:this.emit('more-bytes',mt,1,parent_major,parent_length);_context.next=21;return 1;case 21:val=_context.sent[0];return _context.abrupt("break",35);case 23:numbytes=1<<ai-24;this.emit('more-bytes',mt,numbytes,parent_major,parent_length);_context.next=27;return numbytes;case 27:buf=_context.sent;val=mt===MT.SIMPLE_FLOAT?buf:utils.parseCBORint(ai,buf);return _context.abrupt("break",35);case 30:this.running=false;throw new Error('Additional info not implemented: '+ai);case 32:val=-1;return _context.abrupt("break",35);case 34:val=ai;case 35:_context.t1=mt;_context.next=_context.t1===MT.POS_INT?38:_context.t1===MT.NEG_INT?39:_context.t1===MT.BYTE_STRING?41:_context.t1===MT.UTF8_STRING?41:_context.t1===MT.ARRAY?57:_context.t1===MT.MAP?57:_context.t1===MT.TAG?72:_context.t1===MT.SIMPLE_FLOAT?77:78;break;case 38:return _context.abrupt("break",78);case 39:if(val===Number.MAX_SAFE_INTEGER){val=NEG_MAX;}else if(val instanceof bignumber){val=NEG_ONE.sub(val);}else{val=-1-val;}return _context.abrupt("break",78);case 41:_context.t2=val;_context.next=_context.t2===0?44:_context.t2===-1?47:51;break;case 44:this.emit('start-string',mt,val,parent_major,parent_length);val=mt===MT.BYTE_STRING?new Buffer(0):'';return _context.abrupt("break",56);case 47:this.emit('start',mt,SYMS.STREAM,parent_major,parent_length);parent=parentBufferStream(parent,mt);depth++;return _context.abrupt("continue",3);case 51:this.emit('start-string',mt,val,parent_major,parent_length);_context.next=54;return val;case 54:val=_context.sent;if(mt===MT.UTF8_STRING){val=val.toString('utf-8');}case 56:return _context.abrupt("break",78);case 57:_context.t3=val;_context.next=_context.t3===0?60:_context.t3===-1?63:67;break;case 60:val=mt===MT.MAP?{}:[];val[SYMS.PARENT]=parent;return _context.abrupt("break",71);case 63:this.emit('start',mt,SYMS.STREAM,parent_major,parent_length);parent=parentArray(parent,mt,-1);depth++;return _context.abrupt("continue",3);case 67:this.emit('start',mt,val,parent_major,parent_length);parent=parentArray(parent,mt,val*(mt-3));depth++;return _context.abrupt("continue",3);case 71:return _context.abrupt("break",78);case 72:this.emit('start',mt,val,parent_major,parent_length);parent=parentArray(parent,mt,1);parent.push(val);depth++;return _context.abrupt("continue",3);case 77:if(typeof val==='number'){val=Simple.decode(val,parent!=null);}else{val=utils.parseCBORfloat(val);}case 78:this.emit('value',val,parent_major,parent_length,ai);again=false;case 80:if(!(parent!=null)){_context.next=127;break;}_context.t4=false;_context.next=_context.t4===(val!==SYMS.BREAK)?84:_context.t4===!Array.isArray(parent)?86:_context.t4===!(parent instanceof NoFilter)?88:93;break;case 84:parent[COUNT]=1;return _context.abrupt("break",93);case 86:parent.push(val);return _context.abrupt("break",93);case 88:pm=parent[MAJOR];if(!(pm!=null&&pm!==mt)){_context.next=92;break;}this.running=false;throw new Error('Invalid major type in indefinite encoding');case 92:parent.write(val);case 93:if(!(--parent[COUNT]!==0)){_context.next=96;break;}again=true;return _context.abrupt("break",127);case 96:--depth;delete parent[COUNT];this.emit('stop',parent[MAJOR]);if(!Array.isArray(parent)){_context.next=123;break;}_context.t5=parent[MAJOR];_context.next=_context.t5===MT.ARRAY?103:_context.t5===MT.MAP?105:_context.t5===MT.TAG?118:121;break;case 103:val=parent;return _context.abrupt("break",121);case 105:allstrings=true;if(!(parent.length%2!==0)){_context.next=108;break;}throw new Error('Invalid map length: '+parent.length);case 108:i=0,len=parent.length;case 109:if(!(i<len)){_context.next=116;break;}if(!(typeof parent[i]!=='string')){_context.next=113;break;}allstrings=false;return _context.abrupt("break",116);case 113:i+=2;_context.next=109;break;case 116:if(allstrings){val={};for(_i=0,_len=parent.length;_i<_len;_i+=2){val[parent[_i]]=parent[_i+1];}}else{val=new Map();for(_i2=0,_len2=parent.length;_i2<_len2;_i2+=2){val.set(parent[_i2],parent[_i2+1]);}}return _context.abrupt("break",121);case 118:t=new Tagged(parent[0],parent[1]);val=t.convert(this.tags);return _context.abrupt("break",121);case 121:_context.next=124;break;case 123:if(parent instanceof NoFilter){switch(parent[MAJOR]){case MT.BYTE_STRING:val=parent.slice();case MT.UTF8_STRING:val=parent.toString('utf-8');}}case 124:parent=parent[SYMS.PARENT];_context.next=80;break;case 127:if(again){_context.next=129;break;}return _context.abrupt("return",val);case 129:_context.next=3;break;case 131:case"end":return _context.stop();}}},_parse,this);})}],[{key:"nullcheck",value:function nullcheck(val){switch(val){case SYMS.NULL:return null;case SYMS.UNDEFINED:return undefined;case NOT_FOUND:throw new Error('Value not found');default:return val;}}/**
	   * Decode the first CBOR item in the input, synchronously.  This will throw an
	   * exception if the input is not valid CBOR.
	   *
	   * @static
	   * @param {(string|Buffer)} input
	   * @param {object} [options={encoding: 'hex'}]
	   * @param {string} [options.encoding: 'hex'] - The encoding of the input.
	   *   Ignored if input is a Buffer.
	   * @returns {any} - the decoded value
	   */},{key:"decodeFirstSync",value:function decodeFirstSync(input,options){options=options||{encoding:'hex'};var opts={};var encod=void 0;switch(typeof options==="undefined"?"undefined":_typeof(options)){case'string':encod=options;break;case'object':opts=utils.extend({},options);encod=opts.encoding;delete opts.encoding;break;}var c=new Decoder(opts);var s=new NoFilter(input,encod!=null?encod:utils.guessEncoding(input));var parser=c._parse();var state=parser.next();while(!state.done){var b=s.read(state.value);if(b==null||b.length!==state.value){throw new Error('Insufficient data');}state=parser.next(b);}return Decoder.nullcheck(state.value);}/**
	   * Decode all of the CBOR items in the input into an array.  This will throw
	   * an exception if the input is not valid CBOR; a zero-length input will
	   * return an empty array.
	   *
	   * @static
	   * @param {(string|Buffer)} input
	   * @param {(string|Object)} [options={encoding: 'hex'}]
	   * @param {string} [options.encoding: 'hex'] - The encoding of the input.
	   *   Ignored if input is a Buffer.
	   * @returns {Array} - Array of all found items
	   */},{key:"decodeAllSync",value:function decodeAllSync(input,options){options=options||{encoding:'hex'};var opts={};var encod=void 0;switch(typeof options==="undefined"?"undefined":_typeof(options)){case'string':encod=options;break;case'object':opts=utils.extend({},options);encod=opts.encoding;delete opts.encoding;}var c=new Decoder(opts);var s=new NoFilter(input,encod!=null?encod:utils.guessEncoding(input));var res=[];while(s.length>0){var parser=c._parse();var state=parser.next();while(!state.done){var b=s.read(state.value);if(b==null||b.length!==state.value){throw new Error('Insufficient data');}state=parser.next(b);}res.push(Decoder.nullcheck(state.value));}return res;}/**
	   * @callback decodeCallback
	   * @param {Error} error - if one was generated
	   * @param {any} value - the decoded value
	   *//**
	   * Decode the first CBOR item in the input.  This will error if there are more
	   * bytes left over at the end, and optionally if there were no valid CBOR
	   * bytes in the input.  Emits the {Decoder.NOT_FOUND} Symbol in the callback
	   * if no data was found and the `required` option is false.
	   *
	   * @static
	   * @param {(string|Buffer)} input - the input to parse
	   * @param {(function|string|Object)} options
	   * @param {string} [options.encoding: 'hex'] - The encoding of the input.
	   *   Ignored if input is a Buffer.
	   * @param {decodeCallback} cb
	   * @returns {Promise} if no cb specified
	   */},{key:"decodeFirst",value:function decodeFirst(input,options,cb){var opts={};var required=false;var encod='hex';switch(typeof options==="undefined"?"undefined":_typeof(options)){case'function':cb=options;encod=utils.guessEncoding(input);break;case'string':encod=options;break;case'object':opts=utils.extend({},options);encod=opts.encoding!=null?opts.encoding:utils.guessEncoding(input);delete opts.encoding;required=opts.required!=null?opts.required:false;delete opts.required;}var c=new Decoder(opts);var p=void 0;var v=NOT_FOUND;c.on('data',function(val){v=Decoder.nullcheck(val);c.close();});if(typeof cb==='function'){c.once('error',function(er){var u=v;v=ERROR;c.close();return cb(er,u);});c.once('end',function(){switch(v){case NOT_FOUND:if(required){return cb(new Error('No CBOR found'));}else{return cb(null,v);}case ERROR:return void 0;default:return cb(null,v);}});}else{p=new Promise(function(resolve,reject){c.once('error',function(er){v=ERROR;c.close();return reject(er);});return c.once('end',function(){switch(v){case NOT_FOUND:if(required){return reject(new Error('No CBOR found'));}else{return resolve(v);}case ERROR:return void 0;default:return resolve(v);}});});}c.end(input,encod);return p;}/**
	   * @callback decodeAllCallback
	   * @param {Error} error - if one was generated
	   * @param {Array} value - all of the decoded values, wrapped in an Array
	   *//**
	   * Decode all of the CBOR items in the input.  This will error if there are
	   * more bytes left over at the end.
	   *
	   * @static
	   * @param {(string|Buffer)} input - the input to parse
	   * @param {(string|Object)} options - Decoding options.
	   *   If string, the input encoding.
	   * @param {decodeAllCallback} cb
	   * @returns {Promise} if no callback
	   */},{key:"decodeAll",value:function decodeAll(input,options,cb){var opts={};var encod='hex';switch(typeof options==="undefined"?"undefined":_typeof(options)){case'function':cb=options;encod=utils.guessEncoding(input);break;case'string':encod=options;break;case'object':opts=utils.extend({},options);encod=opts.encoding!=null?opts.encoding:utils.guessEncoding(input);delete opts.encoding;}var c=new Decoder(opts);var p=void 0;var vals=[];c.on('data',function(val){return vals.push(Decoder.nullcheck(val));});if(typeof cb==='function'){c.on('error',function(er){return cb(er);});c.on('end',function(){return cb(null,vals);});}else{p=new Promise(function(resolve,reject){c.on('error',function(er){return reject(er);});return c.on('end',function(){return resolve(vals);});});}c.end(input,encod);return p;}}]);return Decoder;}(BinaryParseStream);Decoder.NOT_FOUND=NOT_FOUND;module.exports=Decoder;}).call(this,require("buffer").Buffer);},{"../vendor/binary-parse-stream":37,"./constants":30,"./simple":34,"./tagged":35,"./utils":36,"bignumber.js":23,"buffer":27,"nofilter":108}],32:[function(require,module,exports){(function(Buffer){'use strict';var stream=require('stream');var util=require('util');var Decoder=require('./decoder');var Simple=require('./simple');var utils=require('./utils');var constants=require('./constants');var bignumber=require('bignumber.js');var NoFilter=require('nofilter');var MT=constants.MT,SYMS=constants.SYMS;/**
	 * Output the diagnostic format from a stream of CBOR bytes.
	 *
	 * @extends {stream.Transform}
	 */var Diagnose=function(_stream$Transform2){_inherits(Diagnose,_stream$Transform2);/**
	   * Creates an instance of Diagnose.
	   *
	   * @param {Object} [options={}] - options for creation
	   * @param {string} [options.separator='\n'] - output between detected objects
	   * @param {bool} [options.stream_errors=false] - put error info into the
	   *   output stream
	   * @param {number} [options.max_depth=-1] - -1 for "until you run out of
	   *   memory".  Set this to a finite positive number for un-trusted inputs.  Most
	   *   standard inputs won't nest more than 100 or so levels; I've tested into the
	   *   millions before running out of memory.
	   */function Diagnose(options){_classCallCheck(this,Diagnose);options=options||{};var separator=options.separator!=null?options.separator:'\n';delete options.separator;var stream_errors=options.stream_errors!=null?options.stream_errors:false;delete options.stream_errors;options.readableObjectMode=false;options.writableObjectMode=false;var _this4=_possibleConstructorReturn(this,(Diagnose.__proto__||Object.getPrototypeOf(Diagnose)).call(this,options));_this4.float_bytes=-1;_this4.separator=separator;_this4.stream_errors=stream_errors;_this4.parser=new Decoder(options);_this4.parser.on('more-bytes',_this4._on_more.bind(_this4));_this4.parser.on('value',_this4._on_value.bind(_this4));_this4.parser.on('start',_this4._on_start.bind(_this4));_this4.parser.on('stop',_this4._on_stop.bind(_this4));_this4.parser.on('data',_this4._on_data.bind(_this4));_this4.parser.on('error',_this4._on_error.bind(_this4));return _this4;}_createClass(Diagnose,[{key:"_transform",value:function _transform(fresh,encoding,cb){return this.parser.write(fresh,encoding,cb);}},{key:"_flush",value:function _flush(cb){var _this5=this;return this.parser._flush(function(er){if(_this5.stream_errors){_this5._on_error(er);return cb();}else{return cb(er);}});}/**
	   * Convenience function to return a string in diagnostic format.
	   *
	   * @param {(Buffer|string)} input - the CBOR bytes to format
	   * @param {string} [encoding='hex'] - the encoding of input, ignored if input is Buffer
	   * @param {commentCallback} cb - callback
	   * @returns {Promise} if callback not specified
	   */},{key:"_on_error",value:function _on_error(er){if(this.stream_errors){return this.push(er.toString());}else{return this.emit('error',er);}}},{key:"_on_more",value:function _on_more(mt,len,parent_mt,pos){if(mt===MT.SIMPLE_FLOAT){return this.float_bytes=function(){switch(len){case 2:return 1;case 4:return 2;case 8:return 3;}}();}}},{key:"_fore",value:function _fore(parent_mt,pos){switch(parent_mt){case MT.BYTE_STRING:case MT.UTF8_STRING:case MT.ARRAY:if(pos>0){return this.push(', ');}break;case MT.MAP:if(pos>0){if(pos%2){return this.push(': ');}else{return this.push(', ');}}}}},{key:"_on_value",value:function _on_value(val,parent_mt,pos){if(val===SYMS.BREAK){return;}this._fore(parent_mt,pos);return this.push(function(){switch(false){case val!==SYMS.NULL:return'null';case val!==SYMS.UNDEFINED:return'undefined';case typeof val!=='string':return JSON.stringify(val);case!(this.float_bytes>0):var fb=this.float_bytes;this.float_bytes=-1;return util.inspect(val)+'_'+fb;case!Buffer.isBuffer(val):return"h'"+val.toString('hex')+"'";case!(val instanceof bignumber):return val.toString();default:return util.inspect(val);}}.call(this));}},{key:"_on_start",value:function _on_start(mt,tag,parent_mt,pos){this._fore(parent_mt,pos);this.push(function(){switch(mt){case MT.TAG:return tag+'(';case MT.ARRAY:return'[';case MT.MAP:return'{';case MT.BYTE_STRING:case MT.UTF8_STRING:return'(';default:// istanbul ignore next
	throw new Error('Unknown diagnostic type: '+mt);}}());if(tag===SYMS.STREAM){return this.push('_ ');}}},{key:"_on_stop",value:function _on_stop(mt){return this.push(function(){switch(mt){case MT.TAG:return')';case MT.ARRAY:return']';case MT.MAP:return'}';case MT.BYTE_STRING:case MT.UTF8_STRING:return')';default:// istanbul ignore next
	throw new Error('Unknown diagnostic type: '+mt);}}());}},{key:"_on_data",value:function _on_data(){return this.push(this.separator);}}],[{key:"diagnose",value:function diagnose(input,encoding,cb){if(input==null){throw new Error('input required');}var opts={};var encod='hex';switch(typeof encoding==="undefined"?"undefined":_typeof(encoding)){case'function':cb=encoding;encod=utils.guessEncoding(input);break;case'object':opts=utils.extend({},encoding);encod=opts.encoding!=null?opts.encoding:utils.guessEncoding(input);delete opts.encoding;break;default:encod=encoding!=null?encoding:'hex';}var bs=new NoFilter();var d=new Diagnose(opts);var p=null;if(typeof cb==='function'){d.on('end',function(){return cb(null,bs.toString('utf8'));});d.on('error',cb);}else{p=new Promise(function(resolve,reject){d.on('end',function(){return resolve(bs.toString('utf8'));});return d.on('error',reject);});}d.pipe(bs);d.end(input,encod);return p;}}]);return Diagnose;}(stream.Transform);module.exports=Diagnose;}).call(this,{"isBuffer":require("../../is-buffer/index.js")});},{"../../is-buffer/index.js":78,"./constants":30,"./decoder":31,"./simple":34,"./utils":36,"bignumber.js":23,"nofilter":108,"stream":128,"util":136}],33:[function(require,module,exports){(function(Buffer){'use strict';var stream=require('stream');var url=require('url');var bignumber=require('bignumber.js');var NoFilter=require('nofilter');var Tagged=require('./tagged');var Simple=require('./simple');var utils=require('./utils');var constants=require('./constants');var MT=constants.MT,NUMBYTES=constants.NUMBYTES,SHIFT32=constants.SHIFT32,SYMS=constants.SYMS,TAG=constants.TAG;var HALF=constants.MT.SIMPLE_FLOAT<<5|constants.NUMBYTES.TWO;var FLOAT=constants.MT.SIMPLE_FLOAT<<5|constants.NUMBYTES.FOUR;var DOUBLE=constants.MT.SIMPLE_FLOAT<<5|constants.NUMBYTES.EIGHT;var TRUE=constants.MT.SIMPLE_FLOAT<<5|constants.SIMPLE.TRUE;var FALSE=constants.MT.SIMPLE_FLOAT<<5|constants.SIMPLE.FALSE;var UNDEFINED=constants.MT.SIMPLE_FLOAT<<5|constants.SIMPLE.UNDEFINED;var NULL=constants.MT.SIMPLE_FLOAT<<5|constants.SIMPLE.NULL;var MAXINT_BN=new bignumber('0x20000000000000');var BUF_NAN=new Buffer('f97e00','hex');var BUF_INF_NEG=new Buffer('f9fc00','hex');var BUF_INF_POS=new Buffer('f97c00','hex');/**
	 * Transform JavaScript values into CBOR bytes.  The `Writable` side of
	 * the stream is in object mode.
	 *
	 * @extends {stream.Transform}
	 */var Encoder=function(_stream$Transform3){_inherits(Encoder,_stream$Transform3);/**
	   * Creates an instance of Encoder.
	   *
	   * @param {Object} [options={}] - options for the encoder
	   * @param {any[]} [options.genTypes=[]] - array of pairs of `type`,
	   *   `function(Encoder)` for semantic types to be encoded.  Not needed
	   *   for Array, Date, Buffer, Map, RegExp, Set, Url, or bignumber.
	   * @param {boolean} [options.canonical=false] - should the output be
	   *   canonicalized
	   */function Encoder(options){_classCallCheck(this,Encoder);options=options||{};options.readableObjectMode=false;options.writableObjectMode=true;var _this6=_possibleConstructorReturn(this,(Encoder.__proto__||Object.getPrototypeOf(Encoder)).call(this,options));_this6.canonical=options.canonical;_this6.semanticTypes=[Array,_this6._pushArray,Date,_this6._pushDate,Buffer,_this6._pushBuffer,Map,_this6._pushMap,NoFilter,_this6._pushNoFilter,RegExp,_this6._pushRegexp,Set,_this6._pushSet,url.Url,_this6._pushUrl,bignumber,_this6._pushBigNumber];var addTypes=options.genTypes||[];for(var i=0,len=addTypes.length;i<len;i+=2){_this6.addSemanticType(addTypes[i],addTypes[i+1]);}return _this6;}_createClass(Encoder,[{key:"_transform",value:function _transform(fresh,encoding,cb){var ret=this.pushAny(fresh);// Old transformers might not return bool.  undefined !== false
	return cb(ret===false?new Error('Push Error'):undefined);}},{key:"_flush",value:function _flush(cb){return cb();}/**
	   * @callback encodeFunction
	   * @param {Encoder} encoder - the encoder to serialize into.  Call "write"
	   *   on the encoder as needed.
	   * @return {bool} - true on success, else false
	   *//**
	   * Add an encoding function to the list of supported semantic types.  This is
	   * useful for objects for which you can't add an encodeCBOR method
	   *
	   * @param {any} type
	   * @param {any} fun
	   * @returns {encodeFunction}
	   */},{key:"addSemanticType",value:function addSemanticType(type,fun){for(var i=0,len=this.semanticTypes.length;i<len;i+=2){var typ=this.semanticTypes[i];if(typ===type){var old=this.semanticTypes[i+1];this.semanticTypes[i+1]=fun;return old;}}this.semanticTypes.push(type,fun);return null;}},{key:"_pushUInt8",value:function _pushUInt8(val){var b=new Buffer(1);b.writeUInt8(val);return this.push(b);}},{key:"_pushUInt16BE",value:function _pushUInt16BE(val){var b=new Buffer(2);b.writeUInt16BE(val);return this.push(b);}},{key:"_pushUInt32BE",value:function _pushUInt32BE(val){var b=new Buffer(4);b.writeUInt32BE(val);return this.push(b);}},{key:"_pushDoubleBE",value:function _pushDoubleBE(val){var b=new Buffer(8);b.writeDoubleBE(val);return this.push(b);}},{key:"_pushNaN",value:function _pushNaN(){return this.push(BUF_NAN);}},{key:"_pushInfinity",value:function _pushInfinity(obj){var half=obj<0?BUF_INF_NEG:BUF_INF_POS;return this.push(half);}},{key:"_pushFloat",value:function _pushFloat(obj){if(this.canonical){// TODO: is this enough slower to hide behind canonical?
	// It's certainly enough of a hack (see utils.parseHalf)
	// From section 3.9:
	// If a protocol allows for IEEE floats, then additional canonicalization
	// rules might need to be added.  One example rule might be to have all
	// floats start as a 64-bit float, then do a test conversion to a 32-bit
	// float; if the result is the same numeric value, use the shorter value
	// and repeat the process with a test conversion to a 16-bit float.  (This
	// rule selects 16-bit float for positive and negative Infinity as well.)
	// which seems pretty much backwards to me.
	var b2=new Buffer(2);if(utils.writeHalf(b2,obj)){if(utils.parseHalf(b2)===obj){return this._pushUInt8(HALF)&&this.push(b2);}}var b4=new Buffer(4);b4.writeFloatBE(obj);if(b4.readFloatBE()===obj){return this._pushUInt8(FLOAT)&&this.push(b4);}}return this._pushUInt8(DOUBLE)&&this._pushDoubleBE(obj);}},{key:"_pushInt",value:function _pushInt(obj,mt,orig){var m=mt<<5;switch(false){case!(obj<24):return this._pushUInt8(m|obj);case!(obj<=0xff):return this._pushUInt8(m|NUMBYTES.ONE)&&this._pushUInt8(obj);case!(obj<=0xffff):return this._pushUInt8(m|NUMBYTES.TWO)&&this._pushUInt16BE(obj);case!(obj<=0xffffffff):return this._pushUInt8(m|NUMBYTES.FOUR)&&this._pushUInt32BE(obj);case!(obj<=Number.MAX_SAFE_INTEGER):return this._pushUInt8(m|NUMBYTES.EIGHT)&&this._pushUInt32BE(Math.floor(obj/SHIFT32))&&this._pushUInt32BE(obj%SHIFT32);default:if(mt===MT.NEG_INT){return this._pushFloat(orig);}else{return this._pushFloat(obj);}}}},{key:"_pushIntNum",value:function _pushIntNum(obj){if(obj<0){return this._pushInt(-obj-1,MT.NEG_INT,obj);}else{return this._pushInt(obj,MT.POS_INT);}}},{key:"_pushNumber",value:function _pushNumber(obj){switch(false){case!isNaN(obj):return this._pushNaN(obj);case isFinite(obj):return this._pushInfinity(obj);case Math.round(obj)!==obj:return this._pushIntNum(obj);default:return this._pushFloat(obj);}}},{key:"_pushString",value:function _pushString(obj){var len=Buffer.byteLength(obj,'utf8');return this._pushInt(len,MT.UTF8_STRING)&&this.push(obj,'utf8');}},{key:"_pushBoolean",value:function _pushBoolean(obj){return this._pushUInt8(obj?TRUE:FALSE);}},{key:"_pushUndefined",value:function _pushUndefined(obj){return this._pushUInt8(UNDEFINED);}},{key:"_pushNull",value:function _pushNull(obj){return this._pushUInt8(NULL);}},{key:"_pushArray",value:function _pushArray(gen,obj){var len=obj.length;if(!gen._pushInt(len,MT.ARRAY)){return false;}for(var j=0;j<len;j++){if(!gen.pushAny(obj[j])){return false;}}return true;}},{key:"_pushTag",value:function _pushTag(tag){return this._pushInt(tag,MT.TAG);}},{key:"_pushDate",value:function _pushDate(gen,obj){return gen._pushTag(TAG.DATE_EPOCH)&&gen.pushAny(obj/1000);}},{key:"_pushBuffer",value:function _pushBuffer(gen,obj){return gen._pushInt(obj.length,MT.BYTE_STRING)&&gen.push(obj);}},{key:"_pushNoFilter",value:function _pushNoFilter(gen,obj){return gen._pushBuffer(gen,obj.slice());}},{key:"_pushRegexp",value:function _pushRegexp(gen,obj){return gen._pushTag(TAG.REGEXP)&&gen.pushAny(obj.source);}},{key:"_pushSet",value:function _pushSet(gen,obj){if(!gen._pushInt(obj.size,MT.ARRAY)){return false;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=obj[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var x=_step.value;if(!gen.pushAny(x)){return false;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return true;}},{key:"_pushUrl",value:function _pushUrl(gen,obj){return gen._pushTag(TAG.URI)&&gen.pushAny(obj.format());}},{key:"_pushBigint",value:function _pushBigint(obj){var tag=TAG.POS_BIGINT;if(obj.isNegative()){obj=obj.negated().minus(1);tag=TAG.NEG_BIGINT;}var str=obj.toString(16);if(str.length%2){str='0'+str;}var buf=new Buffer(str,'hex');return this._pushTag(tag)&&this._pushBuffer(this,buf);}},{key:"_pushBigNumber",value:function _pushBigNumber(gen,obj){if(obj.isNaN()){return gen._pushNaN();}if(!obj.isFinite()){return gen._pushInfinity(obj.isNegative()?-Infinity:Infinity);}if(obj.isInteger()){return gen._pushBigint(obj);}if(!(gen._pushTag(TAG.DECIMAL_FRAC)&&gen._pushInt(2,MT.ARRAY))){return false;}var dec=obj.decimalPlaces();var slide=obj.mul(new bignumber(10).pow(dec));if(!gen._pushIntNum(-dec)){return false;}if(slide.abs().lessThan(MAXINT_BN)){return gen._pushIntNum(slide.toNumber());}else{return gen._pushBigint(slide);}}},{key:"_pushMap",value:function _pushMap(gen,obj){if(!gen._pushInt(obj.size,MT.MAP)){return false;}// memoizing the cbor only helps in certain cases, and hurts in most
	// others.  Just avoid it.
	if(gen.canonical){// keep the key/value pairs together, so we don't have to do odd
	// gets with object keys later
	var entries=[];// iterator.  If we drop support for node4, use ...
	var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=obj.entries()[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var e=_step2.value;entries.push(e);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}entries.sort(function(a,b){// a, b are both entries of [key, value]
	var a_cbor=Encoder.encode(a[0]);var b_cbor=Encoder.encode(b[0]);return a_cbor.compare(b_cbor);});var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=entries[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var kv=_step3.value;if(!(gen.pushAny(kv[0])&&gen.pushAny(kv[1]))){return false;}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}else{var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=obj[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var _kv=_step4.value;if(!(gen.pushAny(_kv[0])&&gen.pushAny(_kv[1]))){return false;}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}return true;}},{key:"_pushObject",value:function _pushObject(obj){if(!obj){return this._pushNull(obj);}for(var i=0,len1=this.semanticTypes.length;i<len1;i+=2){var typ=this.semanticTypes[i];if(obj instanceof typ){return this.semanticTypes[i+1].call(obj,this,obj);}}var f=obj.encodeCBOR;if(typeof f==='function'){return f.call(obj,this);}var keys=Object.keys(obj);var cbor_keys={};if(this.canonical){// note: this can't be a normal sort, because 'b' needs to sort before
	// 'aa'
	keys.sort(function(a,b){// Always strings, so don't bother to pass options.
	// hold on to the cbor versions, since there's no need
	// to encode more than once
	var a_cbor=cbor_keys[a]||(cbor_keys[a]=Encoder.encode(a));var b_cbor=cbor_keys[b]||(cbor_keys[b]=Encoder.encode(b));return a_cbor.compare(b_cbor);});}if(!this._pushInt(keys.length,MT.MAP)){return false;}var ck=void 0;for(var j=0,len2=keys.length;j<len2;j++){var k=keys[j];if(this.canonical&&(ck=cbor_keys[k])){if(!this.push(ck)){// already a Buffer
	return false;}}else{if(!this._pushString(k)){return false;}}if(!this.pushAny(obj[k])){return false;}}return true;}/**
	   * Push any supported type onto the encoded stream
	   *
	   * @param {any} obj
	   * @returns {boolean} true on success
	   */},{key:"pushAny",value:function pushAny(obj){switch(typeof obj==="undefined"?"undefined":_typeof(obj)){case'number':return this._pushNumber(obj);case'string':return this._pushString(obj);case'boolean':return this._pushBoolean(obj);case'undefined':return this._pushUndefined(obj);case'object':return this._pushObject(obj);case'symbol':switch(obj){case SYMS.NULL:return this._pushNull(null);case SYMS.UNDEFINED:return this._pushUndefined(void 0);// TODO: Add pluggable support for other symbols
	default:throw new Error('Unknown symbol: '+obj.toString());}default:throw new Error('Unknown type: '+(typeof obj==="undefined"?"undefined":_typeof(obj))+', '+(!!obj?obj.toString():''));}}/* backwards-compat wrapper */},{key:"_pushAny",value:function _pushAny(obj){// TODO: write deprecation warning
	return this.pushAny(obj);}/**
	   * Encode one or more JavaScript objects, and return a Buffer containing the
	   * CBOR bytes.
	   *
	   * @param {...any} objs - the objects to encode
	   * @returns {Buffer} - the encoded objects
	   */}],[{key:"encode",value:function encode(){var objs=Array.prototype.slice.apply(arguments);var enc=new Encoder();var bs=new NoFilter();enc.pipe(bs);var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=objs[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var o=_step5.value;if(typeof o==='undefined'){enc._pushUndefined();}else if(o===null){enc._pushNull(null);}else{enc.write(o);}}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}enc.end();return bs.read();}}]);return Encoder;}(stream.Transform);module.exports=Encoder;}).call(this,require("buffer").Buffer);},{"./constants":30,"./simple":34,"./tagged":35,"./utils":36,"bignumber.js":23,"buffer":27,"nofilter":108,"stream":128,"url":131}],34:[function(require,module,exports){'use strict';var constants=require('./constants');var MT=constants.MT,SIMPLE=constants.SIMPLE,SYMS=constants.SYMS;/**
	 * A CBOR Simple Value that does not map onto a known constant.
	 */var Simple=function(){/**
	   * Creates an instance of Simple.
	   *
	   * @param {integer} value - the simple value's integer value
	   */function Simple(value){_classCallCheck(this,Simple);if(typeof value!=='number'){throw new Error('Invalid Simple type: '+(typeof value==="undefined"?"undefined":_typeof(value)));}if(value<0||value>255||(value|0)!==value){throw new Error('value must be a small positive integer: '+value);}this.value=value;}/**
	   * Debug string for simple value
	   *
	   * @returns {string} simple(value)
	   */_createClass(Simple,[{key:"toString",value:function toString(){return'simple('+this.value+')';}/**
	   * Debug string for simple value
	   *
	   * @returns {string} simple(value)
	   */},{key:"inspect",value:function inspect(depth,opts){return'simple('+this.value+')';}/**
	   * Push the simple value onto the CBOR stream
	   *
	   * @param {cbor.Encoder} gen The generator to push onto
	   */},{key:"encodeCBOR",value:function encodeCBOR(gen){return gen._pushInt(this.value,MT.SIMPLE_FLOAT);}/**
	   * Is the given object a Simple?
	   *
	   * @param {any} obj - object to test
	   * @returns {bool} - is it Simple?
	   */}],[{key:"isSimple",value:function isSimple(obj){return obj instanceof Simple;}/**
	   * Decode from the CBOR additional information into a JavaScript value.
	   * If the CBOR item has no parent, return a "safe" symbol instead of
	   * `null` or `undefined`, so that the value can be passed through a
	   * stream in object mode.
	   *
	   * @param {Number} val - the CBOR additional info to convert
	   * @param {bool} has_parent - Does the CBOR item have a parent?
	   * @returns {(null|undefined|Boolean|Symbol)} - the decoded value
	   */},{key:"decode",value:function decode(val,has_parent){if(has_parent==null){has_parent=true;}switch(val){case SIMPLE.FALSE:return false;case SIMPLE.TRUE:return true;case SIMPLE.NULL:if(has_parent){return null;}else{return SYMS.NULL;}case SIMPLE.UNDEFINED:if(has_parent){return void 0;}else{return SYMS.UNDEFINED;}case-1:if(!has_parent){throw new Error('Invalid BREAK');}return SYMS.BREAK;default:return new Simple(val);}}}]);return Simple;}();module.exports=Simple;},{"./constants":30}],35:[function(require,module,exports){'use strict';var bignumber=require('bignumber.js');var utils=require('./utils');var url=require('url');var MINUS_ONE=new bignumber(-1);var TEN=new bignumber(10);var TWO=new bignumber(2);/**
	 * A CBOR tagged item, where the tag does not have semantics specified at the
	 * moment, or those semantics threw an error during parsing. Typically this will
	 * be an extension point you're not yet expecting.
	 */var Tagged=function(){/**
	   * Creates an instance of Tagged.
	   *
	   * @param {Number} tag - the number of the tag
	   * @param {any} value - the value inside the tag
	   * @param {Error} err - the error that was thrown parsing the tag, or null
	   */function Tagged(tag,value,err){_classCallCheck(this,Tagged);this.tag=tag;this.value=value;this.err=err;if(typeof this.tag!=='number'){throw new Error('Invalid tag type ('+_typeof(this.tag)+')');}if(this.tag<0||(this.tag|0)!==this.tag){throw new Error('Tag must be a positive integer: '+this.tag);}}/**
	   * Convert to a String
	   *
	   * @returns {String} string of the form '1(2)'
	   */_createClass(Tagged,[{key:"toString",value:function toString(){return this.tag+"("+JSON.stringify(this.value)+")";}/**
	   * Push the simple value onto the CBOR stream
	   *
	   * @param {cbor.Encoder} gen The generator to push onto
	   */},{key:"encodeCBOR",value:function encodeCBOR(gen){gen._pushTag(this.tag);return gen.pushAny(this.value);}/**
	   * If we have a converter for this type, do the conversion.  Some converters
	   * are built-in.  Additional ones can be passed in.  If you want to remove
	   * a built-in converter, pass a converter in whose value is 'null' instead
	   * of a function.
	   *
	   * @param {Object} converters - keys in the object are a tag number, the value
	   *   is a function that takes the decoded CBOR and returns a JavaScript value
	   *   of the appropriate type.  Throw an exception in the function on errors.
	   * @returns {any} - the converted item
	   */},{key:"convert",value:function convert(converters){var er,f;f=converters!=null?converters[this.tag]:void 0;if(typeof f!=='function'){f=Tagged['_tag_'+this.tag];if(typeof f!=='function'){return this;}}try{return f.call(Tagged,this.value);}catch(error){er=error;this.err=er;return this;}}}],[{key:"_tag_0",value:function _tag_0(v){return new Date(v);}},{key:"_tag_1",value:function _tag_1(v){return new Date(v*1000);}},{key:"_tag_2",value:function _tag_2(v){return utils.bufferToBignumber(v);}},{key:"_tag_3",value:function _tag_3(v){return MINUS_ONE.minus(utils.bufferToBignumber(v));}},{key:"_tag_4",value:function _tag_4(v){return TEN.pow(v[0]).times(v[1]);}},{key:"_tag_5",value:function _tag_5(v){return TWO.pow(v[0]).times(v[1]);}},{key:"_tag_32",value:function _tag_32(v){return url.parse(v);}},{key:"_tag_35",value:function _tag_35(v){return new RegExp(v);}}]);return Tagged;}();module.exports=Tagged;},{"./utils":36,"bignumber.js":23,"url":131}],36:[function(require,module,exports){(function(process,Buffer){'use strict';var fs=require('fs');var stream=require('stream');var bignumber=require('bignumber.js');var constants=require('./constants');var NUMBYTES=constants.NUMBYTES,SHIFT32=constants.SHIFT32;var MAX_SAFE_HIGH=0x1fffff;exports.parseCBORint=function(ai,buf){var f,g;switch(ai){case NUMBYTES.ONE:return buf.readUInt8(0,true);case NUMBYTES.TWO:return buf.readUInt16BE(0,true);case NUMBYTES.FOUR:return buf.readUInt32BE(0,true);case NUMBYTES.EIGHT:f=buf.readUInt32BE(0);g=buf.readUInt32BE(4);if(f>MAX_SAFE_HIGH){return new bignumber(f).times(SHIFT32).plus(g);}else{return f*SHIFT32+g;}default:throw new Error('Invalid additional info for int: '+ai);}};exports.writeHalf=function writeHalf(buf,half){// assume 0, -0, NaN, Infinity, and -Infinity have already been caught
	// HACK: everyone settle in.  This isn't going to be pretty.
	// Translate cn-cbor's C code (from Carsten Borman):
	// uint32_t be32;
	// uint16_t be16, u16;
	// union {
	//   float f;
	//   uint32_t u;
	// } u32;
	// u32.f = float_val;
	var u32=new Buffer(4);u32.writeFloatBE(half);var u=u32.readUInt32BE();// if ((u32.u & 0x1FFF) == 0) { /* worth trying half */
	// hildjj: If the lower 13 bits are 0, we won't lose anything in the conversion
	if((u&0x1FFF)!==0){return false;}//   int s16 = (u32.u >> 16) & 0x8000;
	//   int exp = (u32.u >> 23) & 0xff;
	//   int mant = u32.u & 0x7fffff;
	var s16=u>>16&0x8000;// top bit is sign
	var exp=u>>23&0xff;// then 5 bits of exponent
	var mant=u&0x7fffff;//   if (exp == 0 && mant == 0)
	//     ;              /* 0.0, -0.0 */
	// hildjj: zeros already handled.  Assert if you don't believe me.
	//   else if (exp >= 113 && exp <= 142) /* normalized */
	//     s16 += ((exp - 112) << 10) + (mant >> 13);
	if(exp>=113&&exp<=142){s16+=(exp-112<<10)+(mant>>13);}//   else if (exp >= 103 && exp < 113) { /* denorm, exp16 = 0 */
	//     if (mant & ((1 << (126 - exp)) - 1))
	//       goto float32;         /* loss of precision */
	//     s16 += ((mant + 0x800000) >> (126 - exp));
	else if(exp>=103&&exp<113){if(mant&(1<<126-exp)-1){return false;}s16+=mant+0x800000>>126-exp;}//   } else if (exp == 255 && mant == 0) { /* Inf */
	//     s16 += 0x7c00;
	// hildjj: Infinity already handled
	//   } else
	//     goto float32;           /* loss of range */
	else{return false;}//   ensure_writable(3);
	//   u16 = s16;
	//   be16 = hton16p((const uint8_t*)&u16);
	buf.writeUInt16BE(s16);return true;};exports.parseHalf=function parseHalf(buf){var exp,mant,sign;sign=buf[0]&0x80?-1:1;exp=(buf[0]&0x7C)>>2;mant=(buf[0]&0x03)<<8|buf[1];if(!exp){return sign*5.9604644775390625e-8*mant;}else if(exp===0x1f){return sign*(mant?0/0:2e308);}else{return sign*Math.pow(2,exp-25)*(1024+mant);}};exports.parseCBORfloat=function(buf){switch(buf.length){case 2:return exports.parseHalf(buf);case 4:return buf.readFloatBE(0,true);case 8:return buf.readDoubleBE(0,true);default:throw new Error('Invalid float size: '+buf.length);}};exports.hex=function(s){return new Buffer(s.replace(/^0x/,''),'hex');};exports.bin=function(s){var chunks,end,start;s=s.replace(/\s/g,'');start=0;end=s.length%8||8;chunks=[];while(end<=s.length){chunks.push(parseInt(s.slice(start,end),2));start=end;end+=8;}return new Buffer(chunks);};exports.extend=function(){var a,adds,j,k,len,old,v;old=arguments[0],adds=2<=arguments.length?Array.prototype.slice.call(arguments,1):[];if(old==null){old={};}for(j=0,len=adds.length;j<len;j++){a=adds[j];for(k in a){v=a[k];old[k]=v;}}return old;};exports.arrayEqual=function(a,b){if(a==null&&b==null){return true;}if(a==null||b==null){return false;}return a.length===b.length&&a.every(function(elem,i){return elem===b[i];});};exports.bufferEqual=function(a,b){var byte,i,j,len,ret;if(a==null&&b==null){return true;}if(a==null||b==null){return false;}if(!(Buffer.isBuffer(a)&&Buffer.isBuffer(b)&&a.length===b.length)){return false;}ret=true;for(i=j=0,len=a.length;j<len;i=++j){byte=a[i];ret&=b[i]===byte;}return!!ret;};exports.bufferToBignumber=function(buf){return new bignumber(buf.toString('hex'),16);};exports.DeHexStream=function(_stream$Readable){_inherits(DeHexStream,_stream$Readable);function DeHexStream(hex){_classCallCheck(this,DeHexStream);var _this7=_possibleConstructorReturn(this,(DeHexStream.__proto__||Object.getPrototypeOf(DeHexStream)).call(this));hex=hex.replace(/^0x/,'');if(hex){_this7.push(new Buffer(hex,'hex'));}_this7.push(null);return _this7;}return DeHexStream;}(stream.Readable);exports.HexStream=function(_stream$Transform4){_inherits(HexStream,_stream$Transform4);function HexStream(options){_classCallCheck(this,HexStream);return _possibleConstructorReturn(this,(HexStream.__proto__||Object.getPrototypeOf(HexStream)).call(this,options));}_createClass(HexStream,[{key:"_transform",value:function _transform(fresh,encoding,cb){this.push(fresh.toString('hex'));return cb();}}]);return HexStream;}(stream.Transform);function printError(er){if(er!=null){return console.log(er);}}exports.streamFiles=function(files,streamFunc,cb){if(cb==null){cb=printError;}var f=files.shift();if(!f){return cb();}var sf=streamFunc();sf.on('end',function(){return exports.streamFiles(files,streamFunc,cb);});sf.on('error',cb);var s=f==='-'?process.stdin:f instanceof stream.Stream?f:fs.createReadStream(f);s.on('error',cb);return s.pipe(sf);};exports.guessEncoding=function(input){switch(false){case typeof input!=='string':return'hex';case!Buffer.isBuffer(input):return undefined;default:throw new Error('Unknown input type');}};}).call(this,require('_process'),require("buffer").Buffer);},{"./constants":30,"_process":110,"bignumber.js":23,"buffer":27,"fs":24,"stream":128}],37:[function(require,module,exports){// Tweaked version of nathan7's binary-parse-stream
	// (see https://github.com/nathan7/binary-parse-stream)
	// Uses NoFilter instead of the readable in the original.  Removes
	// the ability to read -1, which was odd and un-needed.
	// License for binary-parse-stream: MIT
	'use strict';exports=module.exports=BinaryParseStream;var Stream=require('stream'),TransformStream=Stream.Transform,inherits=require('util').inherits,NoFilter=require('nofilter');exports.One=-1;inherits(BinaryParseStream,TransformStream);function BinaryParseStream(options){TransformStream.call(this,options);this._writableState.objectMode=false;this._readableState.objectMode=true;this.bs=new NoFilter();this.__restart();}BinaryParseStream.prototype._transform=function(fresh,encoding,cb){var self=this;this.bs.write(fresh);while(this.bs.length>=this.__needed){var ret,chunk=this.__needed===null?undefined:this.bs.read(this.__needed);try{ret=this.__parser.next(chunk);}catch(e){return cb(e);}if(this.__needed)this.__fresh=false;if(!ret.done)this.__needed=ret.value|0;else{this.push(ret.value);this.__restart();}}return cb();};BinaryParseStream.prototype.__restart=function(){this.__needed=null;this.__parser=this._parse();this.__fresh=true;};BinaryParseStream.prototype._flush=function(cb){cb(this.__fresh?null:new Error('unexpected end of input'));};},{"nofilter":108,"stream":128,"util":136}],38:[function(require,module,exports){(function(Buffer){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(arg){if(Array.isArray){return Array.isArray(arg);}return objectToString(arg)==='[object Array]';}exports.isArray=isArray;function isBoolean(arg){return typeof arg==='boolean';}exports.isBoolean=isBoolean;function isNull(arg){return arg===null;}exports.isNull=isNull;function isNullOrUndefined(arg){return arg==null;}exports.isNullOrUndefined=isNullOrUndefined;function isNumber(arg){return typeof arg==='number';}exports.isNumber=isNumber;function isString(arg){return typeof arg==='string';}exports.isString=isString;function isSymbol(arg){return(typeof arg==="undefined"?"undefined":_typeof(arg))==='symbol';}exports.isSymbol=isSymbol;function isUndefined(arg){return arg===void 0;}exports.isUndefined=isUndefined;function isRegExp(re){return objectToString(re)==='[object RegExp]';}exports.isRegExp=isRegExp;function isObject(arg){return(typeof arg==="undefined"?"undefined":_typeof(arg))==='object'&&arg!==null;}exports.isObject=isObject;function isDate(d){return objectToString(d)==='[object Date]';}exports.isDate=isDate;function isError(e){return objectToString(e)==='[object Error]'||e instanceof Error;}exports.isError=isError;function isFunction(arg){return typeof arg==='function';}exports.isFunction=isFunction;function isPrimitive(arg){return arg===null||typeof arg==='boolean'||typeof arg==='number'||typeof arg==='string'||(typeof arg==="undefined"?"undefined":_typeof(arg))==='symbol'||// ES6 symbol
	typeof arg==='undefined';}exports.isPrimitive=isPrimitive;exports.isBuffer=Buffer.isBuffer;function objectToString(o){return Object.prototype.toString.call(o);}}).call(this,{"isBuffer":require("../../is-buffer/index.js")});},{"../../is-buffer/index.js":78}],39:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./enc-base64"),require("./md5"),require("./evpkdf"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./enc-base64","./md5","./evpkdf","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var BlockCipher=C_lib.BlockCipher;var C_algo=C.algo;// Lookup tables
	var SBOX=[];var INV_SBOX=[];var SUB_MIX_0=[];var SUB_MIX_1=[];var SUB_MIX_2=[];var SUB_MIX_3=[];var INV_SUB_MIX_0=[];var INV_SUB_MIX_1=[];var INV_SUB_MIX_2=[];var INV_SUB_MIX_3=[];// Compute lookup tables
	(function(){// Compute double table
	var d=[];for(var i=0;i<256;i++){if(i<128){d[i]=i<<1;}else{d[i]=i<<1^0x11b;}}// Walk GF(2^8)
	var x=0;var xi=0;for(var i=0;i<256;i++){// Compute sbox
	var sx=xi^xi<<1^xi<<2^xi<<3^xi<<4;sx=sx>>>8^sx&0xff^0x63;SBOX[x]=sx;INV_SBOX[sx]=x;// Compute multiplication
	var x2=d[x];var x4=d[x2];var x8=d[x4];// Compute sub bytes, mix columns tables
	var t=d[sx]*0x101^sx*0x1010100;SUB_MIX_0[x]=t<<24|t>>>8;SUB_MIX_1[x]=t<<16|t>>>16;SUB_MIX_2[x]=t<<8|t>>>24;SUB_MIX_3[x]=t;// Compute inv sub bytes, inv mix columns tables
	var t=x8*0x1010101^x4*0x10001^x2*0x101^x*0x1010100;INV_SUB_MIX_0[sx]=t<<24|t>>>8;INV_SUB_MIX_1[sx]=t<<16|t>>>16;INV_SUB_MIX_2[sx]=t<<8|t>>>24;INV_SUB_MIX_3[sx]=t;// Compute next counter
	if(!x){x=xi=1;}else{x=x2^d[d[d[x8^x2]]];xi^=d[d[xi]];}}})();// Precomputed Rcon lookup
	var RCON=[0x00,0x01,0x02,0x04,0x08,0x10,0x20,0x40,0x80,0x1b,0x36];/**
		     * AES block cipher algorithm.
		     */var AES=C_algo.AES=BlockCipher.extend({_doReset:function _doReset(){// Skip reset of nRounds has been set before and key did not change
	if(this._nRounds&&this._keyPriorReset===this._key){return;}// Shortcuts
	var key=this._keyPriorReset=this._key;var keyWords=key.words;var keySize=key.sigBytes/4;// Compute number of rounds
	var nRounds=this._nRounds=keySize+6;// Compute number of key schedule rows
	var ksRows=(nRounds+1)*4;// Compute key schedule
	var keySchedule=this._keySchedule=[];for(var ksRow=0;ksRow<ksRows;ksRow++){if(ksRow<keySize){keySchedule[ksRow]=keyWords[ksRow];}else{var t=keySchedule[ksRow-1];if(!(ksRow%keySize)){// Rot word
	t=t<<8|t>>>24;// Sub word
	t=SBOX[t>>>24]<<24|SBOX[t>>>16&0xff]<<16|SBOX[t>>>8&0xff]<<8|SBOX[t&0xff];// Mix Rcon
	t^=RCON[ksRow/keySize|0]<<24;}else if(keySize>6&&ksRow%keySize==4){// Sub word
	t=SBOX[t>>>24]<<24|SBOX[t>>>16&0xff]<<16|SBOX[t>>>8&0xff]<<8|SBOX[t&0xff];}keySchedule[ksRow]=keySchedule[ksRow-keySize]^t;}}// Compute inv key schedule
	var invKeySchedule=this._invKeySchedule=[];for(var invKsRow=0;invKsRow<ksRows;invKsRow++){var ksRow=ksRows-invKsRow;if(invKsRow%4){var t=keySchedule[ksRow];}else{var t=keySchedule[ksRow-4];}if(invKsRow<4||ksRow<=4){invKeySchedule[invKsRow]=t;}else{invKeySchedule[invKsRow]=INV_SUB_MIX_0[SBOX[t>>>24]]^INV_SUB_MIX_1[SBOX[t>>>16&0xff]]^INV_SUB_MIX_2[SBOX[t>>>8&0xff]]^INV_SUB_MIX_3[SBOX[t&0xff]];}}},encryptBlock:function encryptBlock(M,offset){this._doCryptBlock(M,offset,this._keySchedule,SUB_MIX_0,SUB_MIX_1,SUB_MIX_2,SUB_MIX_3,SBOX);},decryptBlock:function decryptBlock(M,offset){// Swap 2nd and 4th rows
	var t=M[offset+1];M[offset+1]=M[offset+3];M[offset+3]=t;this._doCryptBlock(M,offset,this._invKeySchedule,INV_SUB_MIX_0,INV_SUB_MIX_1,INV_SUB_MIX_2,INV_SUB_MIX_3,INV_SBOX);// Inv swap 2nd and 4th rows
	var t=M[offset+1];M[offset+1]=M[offset+3];M[offset+3]=t;},_doCryptBlock:function _doCryptBlock(M,offset,keySchedule,SUB_MIX_0,SUB_MIX_1,SUB_MIX_2,SUB_MIX_3,SBOX){// Shortcut
	var nRounds=this._nRounds;// Get input, add round key
	var s0=M[offset]^keySchedule[0];var s1=M[offset+1]^keySchedule[1];var s2=M[offset+2]^keySchedule[2];var s3=M[offset+3]^keySchedule[3];// Key schedule row counter
	var ksRow=4;// Rounds
	for(var round=1;round<nRounds;round++){// Shift rows, sub bytes, mix columns, add round key
	var t0=SUB_MIX_0[s0>>>24]^SUB_MIX_1[s1>>>16&0xff]^SUB_MIX_2[s2>>>8&0xff]^SUB_MIX_3[s3&0xff]^keySchedule[ksRow++];var t1=SUB_MIX_0[s1>>>24]^SUB_MIX_1[s2>>>16&0xff]^SUB_MIX_2[s3>>>8&0xff]^SUB_MIX_3[s0&0xff]^keySchedule[ksRow++];var t2=SUB_MIX_0[s2>>>24]^SUB_MIX_1[s3>>>16&0xff]^SUB_MIX_2[s0>>>8&0xff]^SUB_MIX_3[s1&0xff]^keySchedule[ksRow++];var t3=SUB_MIX_0[s3>>>24]^SUB_MIX_1[s0>>>16&0xff]^SUB_MIX_2[s1>>>8&0xff]^SUB_MIX_3[s2&0xff]^keySchedule[ksRow++];// Update state
	s0=t0;s1=t1;s2=t2;s3=t3;}// Shift rows, sub bytes, add round key
	var t0=(SBOX[s0>>>24]<<24|SBOX[s1>>>16&0xff]<<16|SBOX[s2>>>8&0xff]<<8|SBOX[s3&0xff])^keySchedule[ksRow++];var t1=(SBOX[s1>>>24]<<24|SBOX[s2>>>16&0xff]<<16|SBOX[s3>>>8&0xff]<<8|SBOX[s0&0xff])^keySchedule[ksRow++];var t2=(SBOX[s2>>>24]<<24|SBOX[s3>>>16&0xff]<<16|SBOX[s0>>>8&0xff]<<8|SBOX[s1&0xff])^keySchedule[ksRow++];var t3=(SBOX[s3>>>24]<<24|SBOX[s0>>>16&0xff]<<16|SBOX[s1>>>8&0xff]<<8|SBOX[s2&0xff])^keySchedule[ksRow++];// Set output
	M[offset]=t0;M[offset+1]=t1;M[offset+2]=t2;M[offset+3]=t3;},keySize:256/32});/**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
		     */C.AES=BlockCipher._createHelper(AES);})();return CryptoJS.AES;});},{"./cipher-core":40,"./core":41,"./enc-base64":42,"./evpkdf":44,"./md5":49}],40:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * Cipher core components.
		 */CryptoJS.lib.Cipher||function(undefined){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var Base=C_lib.Base;var WordArray=C_lib.WordArray;var BufferedBlockAlgorithm=C_lib.BufferedBlockAlgorithm;var C_enc=C.enc;var Utf8=C_enc.Utf8;var Base64=C_enc.Base64;var C_algo=C.algo;var EvpKDF=C_algo.EvpKDF;/**
		     * Abstract base cipher template.
		     *
		     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
		     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
		     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
		     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
		     */var Cipher=C_lib.Cipher=BufferedBlockAlgorithm.extend({/**
		         * Configuration options.
		         *
		         * @property {WordArray} iv The IV to use for this operation.
		         */cfg:Base.extend(),/**
		         * Creates this cipher in encryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
		         */createEncryptor:function createEncryptor(key,cfg){return this.create(this._ENC_XFORM_MODE,key,cfg);},/**
		         * Creates this cipher in decryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
		         */createDecryptor:function createDecryptor(key,cfg){return this.create(this._DEC_XFORM_MODE,key,cfg);},/**
		         * Initializes a newly created cipher.
		         *
		         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
		         */init:function init(xformMode,key,cfg){// Apply config defaults
	this.cfg=this.cfg.extend(cfg);// Store transform mode and key
	this._xformMode=xformMode;this._key=key;// Set initial values
	this.reset();},/**
		         * Resets this cipher to its initial state.
		         *
		         * @example
		         *
		         *     cipher.reset();
		         */reset:function reset(){// Reset data buffer
	BufferedBlockAlgorithm.reset.call(this);// Perform concrete-cipher logic
	this._doReset();},/**
		         * Adds data to be encrypted or decrypted.
		         *
		         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.process('data');
		         *     var encrypted = cipher.process(wordArray);
		         */process:function process(dataUpdate){// Append
	this._append(dataUpdate);// Process available blocks
	return this._process();},/**
		         * Finalizes the encryption or decryption process.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after final processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.finalize();
		         *     var encrypted = cipher.finalize('data');
		         *     var encrypted = cipher.finalize(wordArray);
		         */finalize:function finalize(dataUpdate){// Final data update
	if(dataUpdate){this._append(dataUpdate);}// Perform concrete-cipher logic
	var finalProcessedData=this._doFinalize();return finalProcessedData;},keySize:128/32,ivSize:128/32,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,/**
		         * Creates shortcut functions to a cipher's object interface.
		         *
		         * @param {Cipher} cipher The cipher to create a helper for.
		         *
		         * @return {Object} An object with encrypt and decrypt shortcut functions.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
		         */_createHelper:function(){function selectCipherStrategy(key){if(typeof key=='string'){return PasswordBasedCipher;}else{return SerializableCipher;}}return function(cipher){return{encrypt:function encrypt(message,key,cfg){return selectCipherStrategy(key).encrypt(cipher,message,key,cfg);},decrypt:function decrypt(ciphertext,key,cfg){return selectCipherStrategy(key).decrypt(cipher,ciphertext,key,cfg);}};};}()});/**
		     * Abstract base stream cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
		     */var StreamCipher=C_lib.StreamCipher=Cipher.extend({_doFinalize:function _doFinalize(){// Process partial blocks
	var finalProcessedBlocks=this._process(!!'flush');return finalProcessedBlocks;},blockSize:1});/**
		     * Mode namespace.
		     */var C_mode=C.mode={};/**
		     * Abstract base block cipher mode template.
		     */var BlockCipherMode=C_lib.BlockCipherMode=Base.extend({/**
		         * Creates this mode for encryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
		         */createEncryptor:function createEncryptor(cipher,iv){return this.Encryptor.create(cipher,iv);},/**
		         * Creates this mode for decryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
		         */createDecryptor:function createDecryptor(cipher,iv){return this.Decryptor.create(cipher,iv);},/**
		         * Initializes a newly created mode.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
		         */init:function init(cipher,iv){this._cipher=cipher;this._iv=iv;}});/**
		     * Cipher Block Chaining mode.
		     */var CBC=C_mode.CBC=function(){/**
		         * Abstract base CBC mode.
		         */var CBC=BlockCipherMode.extend();/**
		         * CBC encryptor.
		         */CBC.Encryptor=CBC.extend({/**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */processBlock:function processBlock(words,offset){// Shortcuts
	var cipher=this._cipher;var blockSize=cipher.blockSize;// XOR and encrypt
	xorBlock.call(this,words,offset,blockSize);cipher.encryptBlock(words,offset);// Remember this block to use with next block
	this._prevBlock=words.slice(offset,offset+blockSize);}});/**
		         * CBC decryptor.
		         */CBC.Decryptor=CBC.extend({/**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */processBlock:function processBlock(words,offset){// Shortcuts
	var cipher=this._cipher;var blockSize=cipher.blockSize;// Remember this block to use with next block
	var thisBlock=words.slice(offset,offset+blockSize);// Decrypt and XOR
	cipher.decryptBlock(words,offset);xorBlock.call(this,words,offset,blockSize);// This block becomes the previous block
	this._prevBlock=thisBlock;}});function xorBlock(words,offset,blockSize){// Shortcut
	var iv=this._iv;// Choose mixing block
	if(iv){var block=iv;// Remove IV for subsequent blocks
	this._iv=undefined;}else{var block=this._prevBlock;}// XOR blocks
	for(var i=0;i<blockSize;i++){words[offset+i]^=block[i];}}return CBC;}();/**
		     * Padding namespace.
		     */var C_pad=C.pad={};/**
		     * PKCS #5/7 padding strategy.
		     */var Pkcs7=C_pad.Pkcs7={/**
		         * Pads data using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to pad.
		         * @param {number} blockSize The multiple that the data should be padded to.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
		         */pad:function pad(data,blockSize){// Shortcut
	var blockSizeBytes=blockSize*4;// Count padding bytes
	var nPaddingBytes=blockSizeBytes-data.sigBytes%blockSizeBytes;// Create padding word
	var paddingWord=nPaddingBytes<<24|nPaddingBytes<<16|nPaddingBytes<<8|nPaddingBytes;// Create padding
	var paddingWords=[];for(var i=0;i<nPaddingBytes;i+=4){paddingWords.push(paddingWord);}var padding=WordArray.create(paddingWords,nPaddingBytes);// Add padding
	data.concat(padding);},/**
		         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to unpad.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
		         */unpad:function unpad(data){// Get number of padding bytes from last byte
	var nPaddingBytes=data.words[data.sigBytes-1>>>2]&0xff;// Remove padding
	data.sigBytes-=nPaddingBytes;}};/**
		     * Abstract base block cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
		     */var BlockCipher=C_lib.BlockCipher=Cipher.extend({/**
		         * Configuration options.
		         *
		         * @property {Mode} mode The block mode to use. Default: CBC
		         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
		         */cfg:Cipher.cfg.extend({mode:CBC,padding:Pkcs7}),reset:function reset(){// Reset cipher
	Cipher.reset.call(this);// Shortcuts
	var cfg=this.cfg;var iv=cfg.iv;var mode=cfg.mode;// Reset block mode
	if(this._xformMode==this._ENC_XFORM_MODE){var modeCreator=mode.createEncryptor;}else/* if (this._xformMode == this._DEC_XFORM_MODE) */{var modeCreator=mode.createDecryptor;// Keep at least one block in the buffer for unpadding
	this._minBufferSize=1;}this._mode=modeCreator.call(mode,this,iv&&iv.words);},_doProcessBlock:function _doProcessBlock(words,offset){this._mode.processBlock(words,offset);},_doFinalize:function _doFinalize(){// Shortcut
	var padding=this.cfg.padding;// Finalize
	if(this._xformMode==this._ENC_XFORM_MODE){// Pad data
	padding.pad(this._data,this.blockSize);// Process final blocks
	var finalProcessedBlocks=this._process(!!'flush');}else/* if (this._xformMode == this._DEC_XFORM_MODE) */{// Process final blocks
	var finalProcessedBlocks=this._process(!!'flush');// Unpad data
	padding.unpad(finalProcessedBlocks);}return finalProcessedBlocks;},blockSize:128/32});/**
		     * A collection of cipher parameters.
		     *
		     * @property {WordArray} ciphertext The raw ciphertext.
		     * @property {WordArray} key The key to this ciphertext.
		     * @property {WordArray} iv The IV used in the ciphering operation.
		     * @property {WordArray} salt The salt used with a key derivation function.
		     * @property {Cipher} algorithm The cipher algorithm.
		     * @property {Mode} mode The block mode used in the ciphering operation.
		     * @property {Padding} padding The padding scheme used in the ciphering operation.
		     * @property {number} blockSize The block size of the cipher.
		     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
		     */var CipherParams=C_lib.CipherParams=Base.extend({/**
		         * Initializes a newly created cipher params object.
		         *
		         * @param {Object} cipherParams An object with any of the possible cipher parameters.
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.lib.CipherParams.create({
		         *         ciphertext: ciphertextWordArray,
		         *         key: keyWordArray,
		         *         iv: ivWordArray,
		         *         salt: saltWordArray,
		         *         algorithm: CryptoJS.algo.AES,
		         *         mode: CryptoJS.mode.CBC,
		         *         padding: CryptoJS.pad.PKCS7,
		         *         blockSize: 4,
		         *         formatter: CryptoJS.format.OpenSSL
		         *     });
		         */init:function init(cipherParams){this.mixIn(cipherParams);},/**
		         * Converts this cipher params object to a string.
		         *
		         * @param {Format} formatter (Optional) The formatting strategy to use.
		         *
		         * @return {string} The stringified cipher params.
		         *
		         * @throws Error If neither the formatter nor the default formatter is set.
		         *
		         * @example
		         *
		         *     var string = cipherParams + '';
		         *     var string = cipherParams.toString();
		         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
		         */toString:function toString(formatter){return(formatter||this.formatter).stringify(this);}});/**
		     * Format namespace.
		     */var C_format=C.format={};/**
		     * OpenSSL formatting strategy.
		     */var OpenSSLFormatter=C_format.OpenSSL={/**
		         * Converts a cipher params object to an OpenSSL-compatible string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The OpenSSL-compatible string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
		         */stringify:function stringify(cipherParams){// Shortcuts
	var ciphertext=cipherParams.ciphertext;var salt=cipherParams.salt;// Format
	if(salt){var wordArray=WordArray.create([0x53616c74,0x65645f5f]).concat(salt).concat(ciphertext);}else{var wordArray=ciphertext;}return wordArray.toString(Base64);},/**
		         * Converts an OpenSSL-compatible string to a cipher params object.
		         *
		         * @param {string} openSSLStr The OpenSSL-compatible string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
		         */parse:function parse(openSSLStr){// Parse base64
	var ciphertext=Base64.parse(openSSLStr);// Shortcut
	var ciphertextWords=ciphertext.words;// Test for salt
	if(ciphertextWords[0]==0x53616c74&&ciphertextWords[1]==0x65645f5f){// Extract salt
	var salt=WordArray.create(ciphertextWords.slice(2,4));// Remove salt from ciphertext
	ciphertextWords.splice(0,4);ciphertext.sigBytes-=16;}return CipherParams.create({ciphertext:ciphertext,salt:salt});}};/**
		     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
		     */var SerializableCipher=C_lib.SerializableCipher=Base.extend({/**
		         * Configuration options.
		         *
		         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
		         */cfg:Base.extend({format:OpenSSLFormatter}),/**
		         * Encrypts a message.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */encrypt:function encrypt(cipher,message,key,cfg){// Apply config defaults
	cfg=this.cfg.extend(cfg);// Encrypt
	var encryptor=cipher.createEncryptor(key,cfg);var ciphertext=encryptor.finalize(message);// Shortcut
	var cipherCfg=encryptor.cfg;// Create and return serializable cipher params
	return CipherParams.create({ciphertext:ciphertext,key:key,iv:cipherCfg.iv,algorithm:cipher,mode:cipherCfg.mode,padding:cipherCfg.padding,blockSize:cipher.blockSize,formatter:cfg.format});},/**
		         * Decrypts serialized ciphertext.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */decrypt:function decrypt(cipher,ciphertext,key,cfg){// Apply config defaults
	cfg=this.cfg.extend(cfg);// Convert string to CipherParams
	ciphertext=this._parse(ciphertext,cfg.format);// Decrypt
	var plaintext=cipher.createDecryptor(key,cfg).finalize(ciphertext.ciphertext);return plaintext;},/**
		         * Converts serialized ciphertext to CipherParams,
		         * else assumed CipherParams already and returns ciphertext unchanged.
		         *
		         * @param {CipherParams|string} ciphertext The ciphertext.
		         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
		         *
		         * @return {CipherParams} The unserialized ciphertext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
		         */_parse:function _parse(ciphertext,format){if(typeof ciphertext=='string'){return format.parse(ciphertext,this);}else{return ciphertext;}}});/**
		     * Key derivation function namespace.
		     */var C_kdf=C.kdf={};/**
		     * OpenSSL key derivation function.
		     */var OpenSSLKdf=C_kdf.OpenSSL={/**
		         * Derives a key and IV from a password.
		         *
		         * @param {string} password The password to derive from.
		         * @param {number} keySize The size in words of the key to generate.
		         * @param {number} ivSize The size in words of the IV to generate.
		         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
		         *
		         * @return {CipherParams} A cipher params object with the key, IV, and salt.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
		         */execute:function execute(password,keySize,ivSize,salt){// Generate random salt
	if(!salt){salt=WordArray.random(64/8);}// Derive key and IV
	var key=EvpKDF.create({keySize:keySize+ivSize}).compute(password,salt);// Separate key and IV
	var iv=WordArray.create(key.words.slice(keySize),ivSize*4);key.sigBytes=keySize*4;// Return params
	return CipherParams.create({key:key,iv:iv,salt:salt});}};/**
		     * A serializable cipher wrapper that derives the key from a password,
		     * and returns ciphertext as a serializable cipher params object.
		     */var PasswordBasedCipher=C_lib.PasswordBasedCipher=SerializableCipher.extend({/**
		         * Configuration options.
		         *
		         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
		         */cfg:SerializableCipher.cfg.extend({kdf:OpenSSLKdf}),/**
		         * Encrypts a message using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
		         */encrypt:function encrypt(cipher,message,password,cfg){// Apply config defaults
	cfg=this.cfg.extend(cfg);// Derive key and other params
	var derivedParams=cfg.kdf.execute(password,cipher.keySize,cipher.ivSize);// Add IV to config
	cfg.iv=derivedParams.iv;// Encrypt
	var ciphertext=SerializableCipher.encrypt.call(this,cipher,message,derivedParams.key,cfg);// Mix in derived params
	ciphertext.mixIn(derivedParams);return ciphertext;},/**
		         * Decrypts serialized ciphertext using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
		         */decrypt:function decrypt(cipher,ciphertext,password,cfg){// Apply config defaults
	cfg=this.cfg.extend(cfg);// Convert string to CipherParams
	ciphertext=this._parse(ciphertext,cfg.format);// Derive key and other params
	var derivedParams=cfg.kdf.execute(password,cipher.keySize,cipher.ivSize,ciphertext.salt);// Add IV to config
	cfg.iv=derivedParams.iv;// Decrypt
	var plaintext=SerializableCipher.decrypt.call(this,cipher,ciphertext,derivedParams.key,cfg);return plaintext;}});}();});},{"./core":41}],41:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory();}else if(typeof define==="function"&&define.amd){// AMD
	define([],factory);}else{// Global (browser)
	root.CryptoJS=factory();}})(this,function(){/**
		 * CryptoJS core components.
		 */var CryptoJS=CryptoJS||function(Math,undefined){/*
		     * Local polyfil of Object.create
		     */var create=Object.create||function(){function F(){};return function(obj){var subtype;F.prototype=obj;subtype=new F();F.prototype=null;return subtype;};}();/**
		     * CryptoJS namespace.
		     */var C={};/**
		     * Library namespace.
		     */var C_lib=C.lib={};/**
		     * Base object for prototypal inheritance.
		     */var Base=C_lib.Base=function(){return{/**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */extend:function extend(overrides){// Spawn
	var subtype=create(this);// Augment
	if(overrides){subtype.mixIn(overrides);}// Create default initializer
	if(!subtype.hasOwnProperty('init')||this.init===subtype.init){subtype.init=function(){subtype.$super.init.apply(this,arguments);};}// Initializer's prototype is the subtype object
	subtype.init.prototype=subtype;// Reference supertype
	subtype.$super=this;return subtype;},/**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */create:function create(){var instance=this.extend();instance.init.apply(instance,arguments);return instance;},/**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */init:function init(){},/**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */mixIn:function mixIn(properties){for(var propertyName in properties){if(properties.hasOwnProperty(propertyName)){this[propertyName]=properties[propertyName];}}// IE won't copy toString using the loop above
	if(properties.hasOwnProperty('toString')){this.toString=properties.toString;}},/**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */clone:function clone(){return this.init.prototype.extend(this);}};}();/**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */var WordArray=C_lib.WordArray=Base.extend({/**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */init:function init(words,sigBytes){words=this.words=words||[];if(sigBytes!=undefined){this.sigBytes=sigBytes;}else{this.sigBytes=words.length*4;}},/**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */toString:function toString(encoder){return(encoder||Hex).stringify(this);},/**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */concat:function concat(wordArray){// Shortcuts
	var thisWords=this.words;var thatWords=wordArray.words;var thisSigBytes=this.sigBytes;var thatSigBytes=wordArray.sigBytes;// Clamp excess bits
	this.clamp();// Concat
	if(thisSigBytes%4){// Copy one byte at a time
	for(var i=0;i<thatSigBytes;i++){var thatByte=thatWords[i>>>2]>>>24-i%4*8&0xff;thisWords[thisSigBytes+i>>>2]|=thatByte<<24-(thisSigBytes+i)%4*8;}}else{// Copy one word at a time
	for(var i=0;i<thatSigBytes;i+=4){thisWords[thisSigBytes+i>>>2]=thatWords[i>>>2];}}this.sigBytes+=thatSigBytes;// Chainable
	return this;},/**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */clamp:function clamp(){// Shortcuts
	var words=this.words;var sigBytes=this.sigBytes;// Clamp
	words[sigBytes>>>2]&=0xffffffff<<32-sigBytes%4*8;words.length=Math.ceil(sigBytes/4);},/**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */clone:function clone(){var clone=Base.clone.call(this);clone.words=this.words.slice(0);return clone;},/**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */random:function random(nBytes){var words=[];var r=function r(m_w){var m_w=m_w;var m_z=0x3ade68b1;var mask=0xffffffff;return function(){m_z=0x9069*(m_z&0xFFFF)+(m_z>>0x10)&mask;m_w=0x4650*(m_w&0xFFFF)+(m_w>>0x10)&mask;var result=(m_z<<0x10)+m_w&mask;result/=0x100000000;result+=0.5;return result*(Math.random()>.5?1:-1);};};for(var i=0,rcache;i<nBytes;i+=4){var _r=r((rcache||Math.random())*0x100000000);rcache=_r()*0x3ade67b7;words.push(_r()*0x100000000|0);}return new WordArray.init(words,nBytes);}});/**
		     * Encoder namespace.
		     */var C_enc=C.enc={};/**
		     * Hex encoding strategy.
		     */var Hex=C_enc.Hex={/**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */stringify:function stringify(wordArray){// Shortcuts
	var words=wordArray.words;var sigBytes=wordArray.sigBytes;// Convert
	var hexChars=[];for(var i=0;i<sigBytes;i++){var bite=words[i>>>2]>>>24-i%4*8&0xff;hexChars.push((bite>>>4).toString(16));hexChars.push((bite&0x0f).toString(16));}return hexChars.join('');},/**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */parse:function parse(hexStr){// Shortcut
	var hexStrLength=hexStr.length;// Convert
	var words=[];for(var i=0;i<hexStrLength;i+=2){words[i>>>3]|=parseInt(hexStr.substr(i,2),16)<<24-i%8*4;}return new WordArray.init(words,hexStrLength/2);}};/**
		     * Latin1 encoding strategy.
		     */var Latin1=C_enc.Latin1={/**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */stringify:function stringify(wordArray){// Shortcuts
	var words=wordArray.words;var sigBytes=wordArray.sigBytes;// Convert
	var latin1Chars=[];for(var i=0;i<sigBytes;i++){var bite=words[i>>>2]>>>24-i%4*8&0xff;latin1Chars.push(String.fromCharCode(bite));}return latin1Chars.join('');},/**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */parse:function parse(latin1Str){// Shortcut
	var latin1StrLength=latin1Str.length;// Convert
	var words=[];for(var i=0;i<latin1StrLength;i++){words[i>>>2]|=(latin1Str.charCodeAt(i)&0xff)<<24-i%4*8;}return new WordArray.init(words,latin1StrLength);}};/**
		     * UTF-8 encoding strategy.
		     */var Utf8=C_enc.Utf8={/**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */stringify:function stringify(wordArray){try{return decodeURIComponent(escape(Latin1.stringify(wordArray)));}catch(e){throw new Error('Malformed UTF-8 data');}},/**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */parse:function parse(utf8Str){return Latin1.parse(unescape(encodeURIComponent(utf8Str)));}};/**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */var BufferedBlockAlgorithm=C_lib.BufferedBlockAlgorithm=Base.extend({/**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */reset:function reset(){// Initial values
	this._data=new WordArray.init();this._nDataBytes=0;},/**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */_append:function _append(data){// Convert string to WordArray, else assume WordArray already
	if(typeof data=='string'){data=Utf8.parse(data);}// Append
	this._data.concat(data);this._nDataBytes+=data.sigBytes;},/**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */_process:function _process(doFlush){// Shortcuts
	var data=this._data;var dataWords=data.words;var dataSigBytes=data.sigBytes;var blockSize=this.blockSize;var blockSizeBytes=blockSize*4;// Count blocks ready
	var nBlocksReady=dataSigBytes/blockSizeBytes;if(doFlush){// Round up to include partial blocks
	nBlocksReady=Math.ceil(nBlocksReady);}else{// Round down to include only full blocks,
	// less the number of blocks that must remain in the buffer
	nBlocksReady=Math.max((nBlocksReady|0)-this._minBufferSize,0);}// Count words ready
	var nWordsReady=nBlocksReady*blockSize;// Count bytes ready
	var nBytesReady=Math.min(nWordsReady*4,dataSigBytes);// Process blocks
	if(nWordsReady){for(var offset=0;offset<nWordsReady;offset+=blockSize){// Perform concrete-algorithm logic
	this._doProcessBlock(dataWords,offset);}// Remove processed words
	var processedWords=dataWords.splice(0,nWordsReady);data.sigBytes-=nBytesReady;}// Return processed words
	return new WordArray.init(processedWords,nBytesReady);},/**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */clone:function clone(){var clone=Base.clone.call(this);clone._data=this._data.clone();return clone;},_minBufferSize:0});/**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */var Hasher=C_lib.Hasher=BufferedBlockAlgorithm.extend({/**
		         * Configuration options.
		         */cfg:Base.extend(),/**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */init:function init(cfg){// Apply config defaults
	this.cfg=this.cfg.extend(cfg);// Set initial values
	this.reset();},/**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */reset:function reset(){// Reset data buffer
	BufferedBlockAlgorithm.reset.call(this);// Perform concrete-hasher logic
	this._doReset();},/**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */update:function update(messageUpdate){// Append
	this._append(messageUpdate);// Update the hash
	this._process();// Chainable
	return this;},/**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */finalize:function finalize(messageUpdate){// Final message update
	if(messageUpdate){this._append(messageUpdate);}// Perform concrete-hasher logic
	var hash=this._doFinalize();return hash;},blockSize:512/32,/**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */_createHelper:function _createHelper(hasher){return function(message,cfg){return new hasher.init(cfg).finalize(message);};},/**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */_createHmacHelper:function _createHmacHelper(hasher){return function(message,key){return new C_algo.HMAC.init(hasher,key).finalize(message);};}});/**
		     * Algorithm namespace.
		     */var C_algo=C.algo={};return C;}(Math);return CryptoJS;});},{}],42:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var C_enc=C.enc;/**
		     * Base64 encoding strategy.
		     */var Base64=C_enc.Base64={/**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */stringify:function stringify(wordArray){// Shortcuts
	var words=wordArray.words;var sigBytes=wordArray.sigBytes;var map=this._map;// Clamp excess bits
	wordArray.clamp();// Convert
	var base64Chars=[];for(var i=0;i<sigBytes;i+=3){var byte1=words[i>>>2]>>>24-i%4*8&0xff;var byte2=words[i+1>>>2]>>>24-(i+1)%4*8&0xff;var byte3=words[i+2>>>2]>>>24-(i+2)%4*8&0xff;var triplet=byte1<<16|byte2<<8|byte3;for(var j=0;j<4&&i+j*0.75<sigBytes;j++){base64Chars.push(map.charAt(triplet>>>6*(3-j)&0x3f));}}// Add padding
	var paddingChar=map.charAt(64);if(paddingChar){while(base64Chars.length%4){base64Chars.push(paddingChar);}}return base64Chars.join('');},/**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */parse:function parse(base64Str){// Shortcuts
	var base64StrLength=base64Str.length;var map=this._map;var reverseMap=this._reverseMap;if(!reverseMap){reverseMap=this._reverseMap=[];for(var j=0;j<map.length;j++){reverseMap[map.charCodeAt(j)]=j;}}// Ignore padding
	var paddingChar=map.charAt(64);if(paddingChar){var paddingIndex=base64Str.indexOf(paddingChar);if(paddingIndex!==-1){base64StrLength=paddingIndex;}}// Convert
	return parseLoop(base64Str,base64StrLength,reverseMap);},_map:'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='};function parseLoop(base64Str,base64StrLength,reverseMap){var words=[];var nBytes=0;for(var i=0;i<base64StrLength;i++){if(i%4){var bits1=reverseMap[base64Str.charCodeAt(i-1)]<<i%4*2;var bits2=reverseMap[base64Str.charCodeAt(i)]>>>6-i%4*2;words[nBytes>>>2]|=(bits1|bits2)<<24-nBytes%4*8;nBytes++;}}return WordArray.create(words,nBytes);}})();return CryptoJS.enc.Base64;});},{"./core":41}],43:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var C_enc=C.enc;/**
		     * UTF-16 BE encoding strategy.
		     */var Utf16BE=C_enc.Utf16=C_enc.Utf16BE={/**
		         * Converts a word array to a UTF-16 BE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 BE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
		         */stringify:function stringify(wordArray){// Shortcuts
	var words=wordArray.words;var sigBytes=wordArray.sigBytes;// Convert
	var utf16Chars=[];for(var i=0;i<sigBytes;i+=2){var codePoint=words[i>>>2]>>>16-i%4*8&0xffff;utf16Chars.push(String.fromCharCode(codePoint));}return utf16Chars.join('');},/**
		         * Converts a UTF-16 BE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 BE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
		         */parse:function parse(utf16Str){// Shortcut
	var utf16StrLength=utf16Str.length;// Convert
	var words=[];for(var i=0;i<utf16StrLength;i++){words[i>>>1]|=utf16Str.charCodeAt(i)<<16-i%2*16;}return WordArray.create(words,utf16StrLength*2);}};/**
		     * UTF-16 LE encoding strategy.
		     */C_enc.Utf16LE={/**
		         * Converts a word array to a UTF-16 LE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 LE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
		         */stringify:function stringify(wordArray){// Shortcuts
	var words=wordArray.words;var sigBytes=wordArray.sigBytes;// Convert
	var utf16Chars=[];for(var i=0;i<sigBytes;i+=2){var codePoint=swapEndian(words[i>>>2]>>>16-i%4*8&0xffff);utf16Chars.push(String.fromCharCode(codePoint));}return utf16Chars.join('');},/**
		         * Converts a UTF-16 LE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 LE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
		         */parse:function parse(utf16Str){// Shortcut
	var utf16StrLength=utf16Str.length;// Convert
	var words=[];for(var i=0;i<utf16StrLength;i++){words[i>>>1]|=swapEndian(utf16Str.charCodeAt(i)<<16-i%2*16);}return WordArray.create(words,utf16StrLength*2);}};function swapEndian(word){return word<<8&0xff00ff00|word>>>8&0x00ff00ff;}})();return CryptoJS.enc.Utf16;});},{"./core":41}],44:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./sha1"),require("./hmac"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./sha1","./hmac"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var Base=C_lib.Base;var WordArray=C_lib.WordArray;var C_algo=C.algo;var MD5=C_algo.MD5;/**
		     * This key derivation function is meant to conform with EVP_BytesToKey.
		     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
		     */var EvpKDF=C_algo.EvpKDF=Base.extend({/**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */cfg:Base.extend({keySize:128/32,hasher:MD5,iterations:1}),/**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.EvpKDF.create();
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
		         */init:function init(cfg){this.cfg=this.cfg.extend(cfg);},/**
		         * Derives a key from a password.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */compute:function compute(password,salt){// Shortcut
	var cfg=this.cfg;// Init hasher
	var hasher=cfg.hasher.create();// Initial values
	var derivedKey=WordArray.create();// Shortcuts
	var derivedKeyWords=derivedKey.words;var keySize=cfg.keySize;var iterations=cfg.iterations;// Generate key
	while(derivedKeyWords.length<keySize){if(block){hasher.update(block);}var block=hasher.update(password).finalize(salt);hasher.reset();// Iterations
	for(var i=1;i<iterations;i++){block=hasher.finalize(block);hasher.reset();}derivedKey.concat(block);}derivedKey.sigBytes=keySize*4;return derivedKey;}});/**
		     * Derives a key from a password.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.EvpKDF(password, salt);
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
		     */C.EvpKDF=function(password,salt,cfg){return EvpKDF.create(cfg).compute(password,salt);};})();return CryptoJS.EvpKDF;});},{"./core":41,"./hmac":46,"./sha1":65}],45:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(undefined){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var CipherParams=C_lib.CipherParams;var C_enc=C.enc;var Hex=C_enc.Hex;var C_format=C.format;var HexFormatter=C_format.Hex={/**
		         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The hexadecimally encoded string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
		         */stringify:function stringify(cipherParams){return cipherParams.ciphertext.toString(Hex);},/**
		         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
		         *
		         * @param {string} input The hexadecimally encoded string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
		         */parse:function parse(input){var ciphertext=Hex.parse(input);return CipherParams.create({ciphertext:ciphertext});}};})();return CryptoJS.format.Hex;});},{"./cipher-core":40,"./core":41}],46:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var Base=C_lib.Base;var C_enc=C.enc;var Utf8=C_enc.Utf8;var C_algo=C.algo;/**
		     * HMAC algorithm.
		     */var HMAC=C_algo.HMAC=Base.extend({/**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */init:function init(hasher,key){// Init hasher
	hasher=this._hasher=new hasher.init();// Convert string to WordArray, else assume WordArray already
	if(typeof key=='string'){key=Utf8.parse(key);}// Shortcuts
	var hasherBlockSize=hasher.blockSize;var hasherBlockSizeBytes=hasherBlockSize*4;// Allow arbitrary length keys
	if(key.sigBytes>hasherBlockSizeBytes){key=hasher.finalize(key);}// Clamp excess bits
	key.clamp();// Clone key for inner and outer pads
	var oKey=this._oKey=key.clone();var iKey=this._iKey=key.clone();// Shortcuts
	var oKeyWords=oKey.words;var iKeyWords=iKey.words;// XOR keys with pad constants
	for(var i=0;i<hasherBlockSize;i++){oKeyWords[i]^=0x5c5c5c5c;iKeyWords[i]^=0x36363636;}oKey.sigBytes=iKey.sigBytes=hasherBlockSizeBytes;// Set initial values
	this.reset();},/**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */reset:function reset(){// Shortcut
	var hasher=this._hasher;// Reset
	hasher.reset();hasher.update(this._iKey);},/**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */update:function update(messageUpdate){this._hasher.update(messageUpdate);// Chainable
	return this;},/**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */finalize:function finalize(messageUpdate){// Shortcut
	var hasher=this._hasher;// Compute HMAC
	var innerHash=hasher.finalize(messageUpdate);hasher.reset();var hmac=hasher.finalize(this._oKey.clone().concat(innerHash));return hmac;}});})();});},{"./core":41}],47:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./x64-core"),require("./lib-typedarrays"),require("./enc-utf16"),require("./enc-base64"),require("./md5"),require("./sha1"),require("./sha256"),require("./sha224"),require("./sha512"),require("./sha384"),require("./sha3"),require("./ripemd160"),require("./hmac"),require("./pbkdf2"),require("./evpkdf"),require("./cipher-core"),require("./mode-cfb"),require("./mode-ctr"),require("./mode-ctr-gladman"),require("./mode-ofb"),require("./mode-ecb"),require("./pad-ansix923"),require("./pad-iso10126"),require("./pad-iso97971"),require("./pad-zeropadding"),require("./pad-nopadding"),require("./format-hex"),require("./aes"),require("./tripledes"),require("./rc4"),require("./rabbit"),require("./rabbit-legacy"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./x64-core","./lib-typedarrays","./enc-utf16","./enc-base64","./md5","./sha1","./sha256","./sha224","./sha512","./sha384","./sha3","./ripemd160","./hmac","./pbkdf2","./evpkdf","./cipher-core","./mode-cfb","./mode-ctr","./mode-ctr-gladman","./mode-ofb","./mode-ecb","./pad-ansix923","./pad-iso10126","./pad-iso97971","./pad-zeropadding","./pad-nopadding","./format-hex","./aes","./tripledes","./rc4","./rabbit","./rabbit-legacy"],factory);}else{// Global (browser)
	root.CryptoJS=factory(root.CryptoJS);}})(this,function(CryptoJS){return CryptoJS;});},{"./aes":39,"./cipher-core":40,"./core":41,"./enc-base64":42,"./enc-utf16":43,"./evpkdf":44,"./format-hex":45,"./hmac":46,"./lib-typedarrays":48,"./md5":49,"./mode-cfb":50,"./mode-ctr":52,"./mode-ctr-gladman":51,"./mode-ecb":53,"./mode-ofb":54,"./pad-ansix923":55,"./pad-iso10126":56,"./pad-iso97971":57,"./pad-nopadding":58,"./pad-zeropadding":59,"./pbkdf2":60,"./rabbit":62,"./rabbit-legacy":61,"./rc4":63,"./ripemd160":64,"./sha1":65,"./sha224":66,"./sha256":67,"./sha3":68,"./sha384":69,"./sha512":70,"./tripledes":71,"./x64-core":72}],48:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Check if typed arrays are supported
	if(typeof ArrayBuffer!='function'){return;}// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;// Reference original init
	var superInit=WordArray.init;// Augment WordArray.init to handle typed arrays
	var subInit=WordArray.init=function(typedArray){// Convert buffers to uint8
	if(typedArray instanceof ArrayBuffer){typedArray=new Uint8Array(typedArray);}// Convert other array views to uint8
	if(typedArray instanceof Int8Array||typeof Uint8ClampedArray!=="undefined"&&typedArray instanceof Uint8ClampedArray||typedArray instanceof Int16Array||typedArray instanceof Uint16Array||typedArray instanceof Int32Array||typedArray instanceof Uint32Array||typedArray instanceof Float32Array||typedArray instanceof Float64Array){typedArray=new Uint8Array(typedArray.buffer,typedArray.byteOffset,typedArray.byteLength);}// Handle Uint8Array
	if(typedArray instanceof Uint8Array){// Shortcut
	var typedArrayByteLength=typedArray.byteLength;// Extract bytes
	var words=[];for(var i=0;i<typedArrayByteLength;i++){words[i>>>2]|=typedArray[i]<<24-i%4*8;}// Initialize this word array
	superInit.call(this,words,typedArrayByteLength);}else{// Else call normal init
	superInit.apply(this,arguments);}};subInit.prototype=WordArray;})();return CryptoJS.lib.WordArray;});},{"./core":41}],49:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(Math){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var Hasher=C_lib.Hasher;var C_algo=C.algo;// Constants table
	var T=[];// Compute constants
	(function(){for(var i=0;i<64;i++){T[i]=Math.abs(Math.sin(i+1))*0x100000000|0;}})();/**
		     * MD5 hash algorithm.
		     */var MD5=C_algo.MD5=Hasher.extend({_doReset:function _doReset(){this._hash=new WordArray.init([0x67452301,0xefcdab89,0x98badcfe,0x10325476]);},_doProcessBlock:function _doProcessBlock(M,offset){// Swap endian
	for(var i=0;i<16;i++){// Shortcuts
	var offset_i=offset+i;var M_offset_i=M[offset_i];M[offset_i]=(M_offset_i<<8|M_offset_i>>>24)&0x00ff00ff|(M_offset_i<<24|M_offset_i>>>8)&0xff00ff00;}// Shortcuts
	var H=this._hash.words;var M_offset_0=M[offset+0];var M_offset_1=M[offset+1];var M_offset_2=M[offset+2];var M_offset_3=M[offset+3];var M_offset_4=M[offset+4];var M_offset_5=M[offset+5];var M_offset_6=M[offset+6];var M_offset_7=M[offset+7];var M_offset_8=M[offset+8];var M_offset_9=M[offset+9];var M_offset_10=M[offset+10];var M_offset_11=M[offset+11];var M_offset_12=M[offset+12];var M_offset_13=M[offset+13];var M_offset_14=M[offset+14];var M_offset_15=M[offset+15];// Working varialbes
	var a=H[0];var b=H[1];var c=H[2];var d=H[3];// Computation
	a=FF(a,b,c,d,M_offset_0,7,T[0]);d=FF(d,a,b,c,M_offset_1,12,T[1]);c=FF(c,d,a,b,M_offset_2,17,T[2]);b=FF(b,c,d,a,M_offset_3,22,T[3]);a=FF(a,b,c,d,M_offset_4,7,T[4]);d=FF(d,a,b,c,M_offset_5,12,T[5]);c=FF(c,d,a,b,M_offset_6,17,T[6]);b=FF(b,c,d,a,M_offset_7,22,T[7]);a=FF(a,b,c,d,M_offset_8,7,T[8]);d=FF(d,a,b,c,M_offset_9,12,T[9]);c=FF(c,d,a,b,M_offset_10,17,T[10]);b=FF(b,c,d,a,M_offset_11,22,T[11]);a=FF(a,b,c,d,M_offset_12,7,T[12]);d=FF(d,a,b,c,M_offset_13,12,T[13]);c=FF(c,d,a,b,M_offset_14,17,T[14]);b=FF(b,c,d,a,M_offset_15,22,T[15]);a=GG(a,b,c,d,M_offset_1,5,T[16]);d=GG(d,a,b,c,M_offset_6,9,T[17]);c=GG(c,d,a,b,M_offset_11,14,T[18]);b=GG(b,c,d,a,M_offset_0,20,T[19]);a=GG(a,b,c,d,M_offset_5,5,T[20]);d=GG(d,a,b,c,M_offset_10,9,T[21]);c=GG(c,d,a,b,M_offset_15,14,T[22]);b=GG(b,c,d,a,M_offset_4,20,T[23]);a=GG(a,b,c,d,M_offset_9,5,T[24]);d=GG(d,a,b,c,M_offset_14,9,T[25]);c=GG(c,d,a,b,M_offset_3,14,T[26]);b=GG(b,c,d,a,M_offset_8,20,T[27]);a=GG(a,b,c,d,M_offset_13,5,T[28]);d=GG(d,a,b,c,M_offset_2,9,T[29]);c=GG(c,d,a,b,M_offset_7,14,T[30]);b=GG(b,c,d,a,M_offset_12,20,T[31]);a=HH(a,b,c,d,M_offset_5,4,T[32]);d=HH(d,a,b,c,M_offset_8,11,T[33]);c=HH(c,d,a,b,M_offset_11,16,T[34]);b=HH(b,c,d,a,M_offset_14,23,T[35]);a=HH(a,b,c,d,M_offset_1,4,T[36]);d=HH(d,a,b,c,M_offset_4,11,T[37]);c=HH(c,d,a,b,M_offset_7,16,T[38]);b=HH(b,c,d,a,M_offset_10,23,T[39]);a=HH(a,b,c,d,M_offset_13,4,T[40]);d=HH(d,a,b,c,M_offset_0,11,T[41]);c=HH(c,d,a,b,M_offset_3,16,T[42]);b=HH(b,c,d,a,M_offset_6,23,T[43]);a=HH(a,b,c,d,M_offset_9,4,T[44]);d=HH(d,a,b,c,M_offset_12,11,T[45]);c=HH(c,d,a,b,M_offset_15,16,T[46]);b=HH(b,c,d,a,M_offset_2,23,T[47]);a=II(a,b,c,d,M_offset_0,6,T[48]);d=II(d,a,b,c,M_offset_7,10,T[49]);c=II(c,d,a,b,M_offset_14,15,T[50]);b=II(b,c,d,a,M_offset_5,21,T[51]);a=II(a,b,c,d,M_offset_12,6,T[52]);d=II(d,a,b,c,M_offset_3,10,T[53]);c=II(c,d,a,b,M_offset_10,15,T[54]);b=II(b,c,d,a,M_offset_1,21,T[55]);a=II(a,b,c,d,M_offset_8,6,T[56]);d=II(d,a,b,c,M_offset_15,10,T[57]);c=II(c,d,a,b,M_offset_6,15,T[58]);b=II(b,c,d,a,M_offset_13,21,T[59]);a=II(a,b,c,d,M_offset_4,6,T[60]);d=II(d,a,b,c,M_offset_11,10,T[61]);c=II(c,d,a,b,M_offset_2,15,T[62]);b=II(b,c,d,a,M_offset_9,21,T[63]);// Intermediate hash value
	H[0]=H[0]+a|0;H[1]=H[1]+b|0;H[2]=H[2]+c|0;H[3]=H[3]+d|0;},_doFinalize:function _doFinalize(){// Shortcuts
	var data=this._data;var dataWords=data.words;var nBitsTotal=this._nDataBytes*8;var nBitsLeft=data.sigBytes*8;// Add padding
	dataWords[nBitsLeft>>>5]|=0x80<<24-nBitsLeft%32;var nBitsTotalH=Math.floor(nBitsTotal/0x100000000);var nBitsTotalL=nBitsTotal;dataWords[(nBitsLeft+64>>>9<<4)+15]=(nBitsTotalH<<8|nBitsTotalH>>>24)&0x00ff00ff|(nBitsTotalH<<24|nBitsTotalH>>>8)&0xff00ff00;dataWords[(nBitsLeft+64>>>9<<4)+14]=(nBitsTotalL<<8|nBitsTotalL>>>24)&0x00ff00ff|(nBitsTotalL<<24|nBitsTotalL>>>8)&0xff00ff00;data.sigBytes=(dataWords.length+1)*4;// Hash final blocks
	this._process();// Shortcuts
	var hash=this._hash;var H=hash.words;// Swap endian
	for(var i=0;i<4;i++){// Shortcut
	var H_i=H[i];H[i]=(H_i<<8|H_i>>>24)&0x00ff00ff|(H_i<<24|H_i>>>8)&0xff00ff00;}// Return final computed hash
	return hash;},clone:function clone(){var clone=Hasher.clone.call(this);clone._hash=this._hash.clone();return clone;}});function FF(a,b,c,d,x,s,t){var n=a+(b&c|~b&d)+x+t;return(n<<s|n>>>32-s)+b;}function GG(a,b,c,d,x,s,t){var n=a+(b&d|c&~d)+x+t;return(n<<s|n>>>32-s)+b;}function HH(a,b,c,d,x,s,t){var n=a+(b^c^d)+x+t;return(n<<s|n>>>32-s)+b;}function II(a,b,c,d,x,s,t){var n=a+(c^(b|~d))+x+t;return(n<<s|n>>>32-s)+b;}/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */C.MD5=Hasher._createHelper(MD5);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */C.HmacMD5=Hasher._createHmacHelper(MD5);})(Math);return CryptoJS.MD5;});},{"./core":41}],50:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * Cipher Feedback block mode.
		 */CryptoJS.mode.CFB=function(){var CFB=CryptoJS.lib.BlockCipherMode.extend();CFB.Encryptor=CFB.extend({processBlock:function processBlock(words,offset){// Shortcuts
	var cipher=this._cipher;var blockSize=cipher.blockSize;generateKeystreamAndEncrypt.call(this,words,offset,blockSize,cipher);// Remember this block to use with next block
	this._prevBlock=words.slice(offset,offset+blockSize);}});CFB.Decryptor=CFB.extend({processBlock:function processBlock(words,offset){// Shortcuts
	var cipher=this._cipher;var blockSize=cipher.blockSize;// Remember this block to use with next block
	var thisBlock=words.slice(offset,offset+blockSize);generateKeystreamAndEncrypt.call(this,words,offset,blockSize,cipher);// This block becomes the previous block
	this._prevBlock=thisBlock;}});function generateKeystreamAndEncrypt(words,offset,blockSize,cipher){// Shortcut
	var iv=this._iv;// Generate keystream
	if(iv){var keystream=iv.slice(0);// Remove IV for subsequent blocks
	this._iv=undefined;}else{var keystream=this._prevBlock;}cipher.encryptBlock(keystream,0);// Encrypt
	for(var i=0;i<blockSize;i++){words[offset+i]^=keystream[i];}}return CFB;}();return CryptoJS.mode.CFB;});},{"./cipher-core":40,"./core":41}],51:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/** @preserve
		 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
		 * derived from CryptoJS.mode.CTR
		 * Jan Hruby jhruby.web@gmail.com
		 */CryptoJS.mode.CTRGladman=function(){var CTRGladman=CryptoJS.lib.BlockCipherMode.extend();function incWord(word){if((word>>24&0xff)===0xff){//overflow
	var b1=word>>16&0xff;var b2=word>>8&0xff;var b3=word&0xff;if(b1===0xff)// overflow b1
	{b1=0;if(b2===0xff){b2=0;if(b3===0xff){b3=0;}else{++b3;}}else{++b2;}}else{++b1;}word=0;word+=b1<<16;word+=b2<<8;word+=b3;}else{word+=0x01<<24;}return word;}function incCounter(counter){if((counter[0]=incWord(counter[0]))===0){// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
	counter[1]=incWord(counter[1]);}return counter;}var Encryptor=CTRGladman.Encryptor=CTRGladman.extend({processBlock:function processBlock(words,offset){// Shortcuts
	var cipher=this._cipher;var blockSize=cipher.blockSize;var iv=this._iv;var counter=this._counter;// Generate keystream
	if(iv){counter=this._counter=iv.slice(0);// Remove IV for subsequent blocks
	this._iv=undefined;}incCounter(counter);var keystream=counter.slice(0);cipher.encryptBlock(keystream,0);// Encrypt
	for(var i=0;i<blockSize;i++){words[offset+i]^=keystream[i];}}});CTRGladman.Decryptor=Encryptor;return CTRGladman;}();return CryptoJS.mode.CTRGladman;});},{"./cipher-core":40,"./core":41}],52:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * Counter block mode.
		 */CryptoJS.mode.CTR=function(){var CTR=CryptoJS.lib.BlockCipherMode.extend();var Encryptor=CTR.Encryptor=CTR.extend({processBlock:function processBlock(words,offset){// Shortcuts
	var cipher=this._cipher;var blockSize=cipher.blockSize;var iv=this._iv;var counter=this._counter;// Generate keystream
	if(iv){counter=this._counter=iv.slice(0);// Remove IV for subsequent blocks
	this._iv=undefined;}var keystream=counter.slice(0);cipher.encryptBlock(keystream,0);// Increment counter
	counter[blockSize-1]=counter[blockSize-1]+1|0;// Encrypt
	for(var i=0;i<blockSize;i++){words[offset+i]^=keystream[i];}}});CTR.Decryptor=Encryptor;return CTR;}();return CryptoJS.mode.CTR;});},{"./cipher-core":40,"./core":41}],53:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * Electronic Codebook block mode.
		 */CryptoJS.mode.ECB=function(){var ECB=CryptoJS.lib.BlockCipherMode.extend();ECB.Encryptor=ECB.extend({processBlock:function processBlock(words,offset){this._cipher.encryptBlock(words,offset);}});ECB.Decryptor=ECB.extend({processBlock:function processBlock(words,offset){this._cipher.decryptBlock(words,offset);}});return ECB;}();return CryptoJS.mode.ECB;});},{"./cipher-core":40,"./core":41}],54:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * Output Feedback block mode.
		 */CryptoJS.mode.OFB=function(){var OFB=CryptoJS.lib.BlockCipherMode.extend();var Encryptor=OFB.Encryptor=OFB.extend({processBlock:function processBlock(words,offset){// Shortcuts
	var cipher=this._cipher;var blockSize=cipher.blockSize;var iv=this._iv;var keystream=this._keystream;// Generate keystream
	if(iv){keystream=this._keystream=iv.slice(0);// Remove IV for subsequent blocks
	this._iv=undefined;}cipher.encryptBlock(keystream,0);// Encrypt
	for(var i=0;i<blockSize;i++){words[offset+i]^=keystream[i];}}});OFB.Decryptor=Encryptor;return OFB;}();return CryptoJS.mode.OFB;});},{"./cipher-core":40,"./core":41}],55:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * ANSI X.923 padding strategy.
		 */CryptoJS.pad.AnsiX923={pad:function pad(data,blockSize){// Shortcuts
	var dataSigBytes=data.sigBytes;var blockSizeBytes=blockSize*4;// Count padding bytes
	var nPaddingBytes=blockSizeBytes-dataSigBytes%blockSizeBytes;// Compute last byte position
	var lastBytePos=dataSigBytes+nPaddingBytes-1;// Pad
	data.clamp();data.words[lastBytePos>>>2]|=nPaddingBytes<<24-lastBytePos%4*8;data.sigBytes+=nPaddingBytes;},unpad:function unpad(data){// Get number of padding bytes from last byte
	var nPaddingBytes=data.words[data.sigBytes-1>>>2]&0xff;// Remove padding
	data.sigBytes-=nPaddingBytes;}};return CryptoJS.pad.Ansix923;});},{"./cipher-core":40,"./core":41}],56:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * ISO 10126 padding strategy.
		 */CryptoJS.pad.Iso10126={pad:function pad(data,blockSize){// Shortcut
	var blockSizeBytes=blockSize*4;// Count padding bytes
	var nPaddingBytes=blockSizeBytes-data.sigBytes%blockSizeBytes;// Pad
	data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes-1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes<<24],1));},unpad:function unpad(data){// Get number of padding bytes from last byte
	var nPaddingBytes=data.words[data.sigBytes-1>>>2]&0xff;// Remove padding
	data.sigBytes-=nPaddingBytes;}};return CryptoJS.pad.Iso10126;});},{"./cipher-core":40,"./core":41}],57:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * ISO/IEC 9797-1 Padding Method 2.
		 */CryptoJS.pad.Iso97971={pad:function pad(data,blockSize){// Add 0x80 byte
	data.concat(CryptoJS.lib.WordArray.create([0x80000000],1));// Zero pad the rest
	CryptoJS.pad.ZeroPadding.pad(data,blockSize);},unpad:function unpad(data){// Remove zero padding
	CryptoJS.pad.ZeroPadding.unpad(data);// Remove one more byte -- the 0x80 byte
	data.sigBytes--;}};return CryptoJS.pad.Iso97971;});},{"./cipher-core":40,"./core":41}],58:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * A noop padding strategy.
		 */CryptoJS.pad.NoPadding={pad:function pad(){},unpad:function unpad(){}};return CryptoJS.pad.NoPadding;});},{"./cipher-core":40,"./core":41}],59:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/**
		 * Zero padding strategy.
		 */CryptoJS.pad.ZeroPadding={pad:function pad(data,blockSize){// Shortcut
	var blockSizeBytes=blockSize*4;// Pad
	data.clamp();data.sigBytes+=blockSizeBytes-(data.sigBytes%blockSizeBytes||blockSizeBytes);},unpad:function unpad(data){// Shortcut
	var dataWords=data.words;// Unpad
	var i=data.sigBytes-1;while(!(dataWords[i>>>2]>>>24-i%4*8&0xff)){i--;}data.sigBytes=i+1;}};return CryptoJS.pad.ZeroPadding;});},{"./cipher-core":40,"./core":41}],60:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./sha1"),require("./hmac"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./sha1","./hmac"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var Base=C_lib.Base;var WordArray=C_lib.WordArray;var C_algo=C.algo;var SHA1=C_algo.SHA1;var HMAC=C_algo.HMAC;/**
		     * Password-Based Key Derivation Function 2 algorithm.
		     */var PBKDF2=C_algo.PBKDF2=Base.extend({/**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hasher to use. Default: SHA1
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */cfg:Base.extend({keySize:128/32,hasher:SHA1,iterations:1}),/**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.PBKDF2.create();
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
		         */init:function init(cfg){this.cfg=this.cfg.extend(cfg);},/**
		         * Computes the Password-Based Key Derivation Function 2.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */compute:function compute(password,salt){// Shortcut
	var cfg=this.cfg;// Init HMAC
	var hmac=HMAC.create(cfg.hasher,password);// Initial values
	var derivedKey=WordArray.create();var blockIndex=WordArray.create([0x00000001]);// Shortcuts
	var derivedKeyWords=derivedKey.words;var blockIndexWords=blockIndex.words;var keySize=cfg.keySize;var iterations=cfg.iterations;// Generate key
	while(derivedKeyWords.length<keySize){var block=hmac.update(salt).finalize(blockIndex);hmac.reset();// Shortcuts
	var blockWords=block.words;var blockWordsLength=blockWords.length;// Iterations
	var intermediate=block;for(var i=1;i<iterations;i++){intermediate=hmac.finalize(intermediate);hmac.reset();// Shortcut
	var intermediateWords=intermediate.words;// XOR intermediate with block
	for(var j=0;j<blockWordsLength;j++){blockWords[j]^=intermediateWords[j];}}derivedKey.concat(block);blockIndexWords[0]++;}derivedKey.sigBytes=keySize*4;return derivedKey;}});/**
		     * Computes the Password-Based Key Derivation Function 2.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.PBKDF2(password, salt);
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
		     */C.PBKDF2=function(password,salt,cfg){return PBKDF2.create(cfg).compute(password,salt);};})();return CryptoJS.PBKDF2;});},{"./core":41,"./hmac":46,"./sha1":65}],61:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./enc-base64"),require("./md5"),require("./evpkdf"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./enc-base64","./md5","./evpkdf","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var StreamCipher=C_lib.StreamCipher;var C_algo=C.algo;// Reusable objects
	var S=[];var C_=[];var G=[];/**
		     * Rabbit stream cipher algorithm.
		     *
		     * This is a legacy version that neglected to convert the key to little-endian.
		     * This error doesn't affect the cipher's security,
		     * but it does affect its compatibility with other implementations.
		     */var RabbitLegacy=C_algo.RabbitLegacy=StreamCipher.extend({_doReset:function _doReset(){// Shortcuts
	var K=this._key.words;var iv=this.cfg.iv;// Generate initial state values
	var X=this._X=[K[0],K[3]<<16|K[2]>>>16,K[1],K[0]<<16|K[3]>>>16,K[2],K[1]<<16|K[0]>>>16,K[3],K[2]<<16|K[1]>>>16];// Generate initial counter values
	var C=this._C=[K[2]<<16|K[2]>>>16,K[0]&0xffff0000|K[1]&0x0000ffff,K[3]<<16|K[3]>>>16,K[1]&0xffff0000|K[2]&0x0000ffff,K[0]<<16|K[0]>>>16,K[2]&0xffff0000|K[3]&0x0000ffff,K[1]<<16|K[1]>>>16,K[3]&0xffff0000|K[0]&0x0000ffff];// Carry bit
	this._b=0;// Iterate the system four times
	for(var i=0;i<4;i++){nextState.call(this);}// Modify the counters
	for(var i=0;i<8;i++){C[i]^=X[i+4&7];}// IV setup
	if(iv){// Shortcuts
	var IV=iv.words;var IV_0=IV[0];var IV_1=IV[1];// Generate four subvectors
	var i0=(IV_0<<8|IV_0>>>24)&0x00ff00ff|(IV_0<<24|IV_0>>>8)&0xff00ff00;var i2=(IV_1<<8|IV_1>>>24)&0x00ff00ff|(IV_1<<24|IV_1>>>8)&0xff00ff00;var i1=i0>>>16|i2&0xffff0000;var i3=i2<<16|i0&0x0000ffff;// Modify counter values
	C[0]^=i0;C[1]^=i1;C[2]^=i2;C[3]^=i3;C[4]^=i0;C[5]^=i1;C[6]^=i2;C[7]^=i3;// Iterate the system four times
	for(var i=0;i<4;i++){nextState.call(this);}}},_doProcessBlock:function _doProcessBlock(M,offset){// Shortcut
	var X=this._X;// Iterate the system
	nextState.call(this);// Generate four keystream words
	S[0]=X[0]^X[5]>>>16^X[3]<<16;S[1]=X[2]^X[7]>>>16^X[5]<<16;S[2]=X[4]^X[1]>>>16^X[7]<<16;S[3]=X[6]^X[3]>>>16^X[1]<<16;for(var i=0;i<4;i++){// Swap endian
	S[i]=(S[i]<<8|S[i]>>>24)&0x00ff00ff|(S[i]<<24|S[i]>>>8)&0xff00ff00;// Encrypt
	M[offset+i]^=S[i];}},blockSize:128/32,ivSize:64/32});function nextState(){// Shortcuts
	var X=this._X;var C=this._C;// Save old counter values
	for(var i=0;i<8;i++){C_[i]=C[i];}// Calculate new counter values
	C[0]=C[0]+0x4d34d34d+this._b|0;C[1]=C[1]+0xd34d34d3+(C[0]>>>0<C_[0]>>>0?1:0)|0;C[2]=C[2]+0x34d34d34+(C[1]>>>0<C_[1]>>>0?1:0)|0;C[3]=C[3]+0x4d34d34d+(C[2]>>>0<C_[2]>>>0?1:0)|0;C[4]=C[4]+0xd34d34d3+(C[3]>>>0<C_[3]>>>0?1:0)|0;C[5]=C[5]+0x34d34d34+(C[4]>>>0<C_[4]>>>0?1:0)|0;C[6]=C[6]+0x4d34d34d+(C[5]>>>0<C_[5]>>>0?1:0)|0;C[7]=C[7]+0xd34d34d3+(C[6]>>>0<C_[6]>>>0?1:0)|0;this._b=C[7]>>>0<C_[7]>>>0?1:0;// Calculate the g-values
	for(var i=0;i<8;i++){var gx=X[i]+C[i];// Construct high and low argument for squaring
	var ga=gx&0xffff;var gb=gx>>>16;// Calculate high and low result of squaring
	var gh=((ga*ga>>>17)+ga*gb>>>15)+gb*gb;var gl=((gx&0xffff0000)*gx|0)+((gx&0x0000ffff)*gx|0);// High XOR low
	G[i]=gh^gl;}// Calculate new state values
	X[0]=G[0]+(G[7]<<16|G[7]>>>16)+(G[6]<<16|G[6]>>>16)|0;X[1]=G[1]+(G[0]<<8|G[0]>>>24)+G[7]|0;X[2]=G[2]+(G[1]<<16|G[1]>>>16)+(G[0]<<16|G[0]>>>16)|0;X[3]=G[3]+(G[2]<<8|G[2]>>>24)+G[1]|0;X[4]=G[4]+(G[3]<<16|G[3]>>>16)+(G[2]<<16|G[2]>>>16)|0;X[5]=G[5]+(G[4]<<8|G[4]>>>24)+G[3]|0;X[6]=G[6]+(G[5]<<16|G[5]>>>16)+(G[4]<<16|G[4]>>>16)|0;X[7]=G[7]+(G[6]<<8|G[6]>>>24)+G[5]|0;}/**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
		     */C.RabbitLegacy=StreamCipher._createHelper(RabbitLegacy);})();return CryptoJS.RabbitLegacy;});},{"./cipher-core":40,"./core":41,"./enc-base64":42,"./evpkdf":44,"./md5":49}],62:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./enc-base64"),require("./md5"),require("./evpkdf"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./enc-base64","./md5","./evpkdf","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var StreamCipher=C_lib.StreamCipher;var C_algo=C.algo;// Reusable objects
	var S=[];var C_=[];var G=[];/**
		     * Rabbit stream cipher algorithm
		     */var Rabbit=C_algo.Rabbit=StreamCipher.extend({_doReset:function _doReset(){// Shortcuts
	var K=this._key.words;var iv=this.cfg.iv;// Swap endian
	for(var i=0;i<4;i++){K[i]=(K[i]<<8|K[i]>>>24)&0x00ff00ff|(K[i]<<24|K[i]>>>8)&0xff00ff00;}// Generate initial state values
	var X=this._X=[K[0],K[3]<<16|K[2]>>>16,K[1],K[0]<<16|K[3]>>>16,K[2],K[1]<<16|K[0]>>>16,K[3],K[2]<<16|K[1]>>>16];// Generate initial counter values
	var C=this._C=[K[2]<<16|K[2]>>>16,K[0]&0xffff0000|K[1]&0x0000ffff,K[3]<<16|K[3]>>>16,K[1]&0xffff0000|K[2]&0x0000ffff,K[0]<<16|K[0]>>>16,K[2]&0xffff0000|K[3]&0x0000ffff,K[1]<<16|K[1]>>>16,K[3]&0xffff0000|K[0]&0x0000ffff];// Carry bit
	this._b=0;// Iterate the system four times
	for(var i=0;i<4;i++){nextState.call(this);}// Modify the counters
	for(var i=0;i<8;i++){C[i]^=X[i+4&7];}// IV setup
	if(iv){// Shortcuts
	var IV=iv.words;var IV_0=IV[0];var IV_1=IV[1];// Generate four subvectors
	var i0=(IV_0<<8|IV_0>>>24)&0x00ff00ff|(IV_0<<24|IV_0>>>8)&0xff00ff00;var i2=(IV_1<<8|IV_1>>>24)&0x00ff00ff|(IV_1<<24|IV_1>>>8)&0xff00ff00;var i1=i0>>>16|i2&0xffff0000;var i3=i2<<16|i0&0x0000ffff;// Modify counter values
	C[0]^=i0;C[1]^=i1;C[2]^=i2;C[3]^=i3;C[4]^=i0;C[5]^=i1;C[6]^=i2;C[7]^=i3;// Iterate the system four times
	for(var i=0;i<4;i++){nextState.call(this);}}},_doProcessBlock:function _doProcessBlock(M,offset){// Shortcut
	var X=this._X;// Iterate the system
	nextState.call(this);// Generate four keystream words
	S[0]=X[0]^X[5]>>>16^X[3]<<16;S[1]=X[2]^X[7]>>>16^X[5]<<16;S[2]=X[4]^X[1]>>>16^X[7]<<16;S[3]=X[6]^X[3]>>>16^X[1]<<16;for(var i=0;i<4;i++){// Swap endian
	S[i]=(S[i]<<8|S[i]>>>24)&0x00ff00ff|(S[i]<<24|S[i]>>>8)&0xff00ff00;// Encrypt
	M[offset+i]^=S[i];}},blockSize:128/32,ivSize:64/32});function nextState(){// Shortcuts
	var X=this._X;var C=this._C;// Save old counter values
	for(var i=0;i<8;i++){C_[i]=C[i];}// Calculate new counter values
	C[0]=C[0]+0x4d34d34d+this._b|0;C[1]=C[1]+0xd34d34d3+(C[0]>>>0<C_[0]>>>0?1:0)|0;C[2]=C[2]+0x34d34d34+(C[1]>>>0<C_[1]>>>0?1:0)|0;C[3]=C[3]+0x4d34d34d+(C[2]>>>0<C_[2]>>>0?1:0)|0;C[4]=C[4]+0xd34d34d3+(C[3]>>>0<C_[3]>>>0?1:0)|0;C[5]=C[5]+0x34d34d34+(C[4]>>>0<C_[4]>>>0?1:0)|0;C[6]=C[6]+0x4d34d34d+(C[5]>>>0<C_[5]>>>0?1:0)|0;C[7]=C[7]+0xd34d34d3+(C[6]>>>0<C_[6]>>>0?1:0)|0;this._b=C[7]>>>0<C_[7]>>>0?1:0;// Calculate the g-values
	for(var i=0;i<8;i++){var gx=X[i]+C[i];// Construct high and low argument for squaring
	var ga=gx&0xffff;var gb=gx>>>16;// Calculate high and low result of squaring
	var gh=((ga*ga>>>17)+ga*gb>>>15)+gb*gb;var gl=((gx&0xffff0000)*gx|0)+((gx&0x0000ffff)*gx|0);// High XOR low
	G[i]=gh^gl;}// Calculate new state values
	X[0]=G[0]+(G[7]<<16|G[7]>>>16)+(G[6]<<16|G[6]>>>16)|0;X[1]=G[1]+(G[0]<<8|G[0]>>>24)+G[7]|0;X[2]=G[2]+(G[1]<<16|G[1]>>>16)+(G[0]<<16|G[0]>>>16)|0;X[3]=G[3]+(G[2]<<8|G[2]>>>24)+G[1]|0;X[4]=G[4]+(G[3]<<16|G[3]>>>16)+(G[2]<<16|G[2]>>>16)|0;X[5]=G[5]+(G[4]<<8|G[4]>>>24)+G[3]|0;X[6]=G[6]+(G[5]<<16|G[5]>>>16)+(G[4]<<16|G[4]>>>16)|0;X[7]=G[7]+(G[6]<<8|G[6]>>>24)+G[5]|0;}/**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
		     */C.Rabbit=StreamCipher._createHelper(Rabbit);})();return CryptoJS.Rabbit;});},{"./cipher-core":40,"./core":41,"./enc-base64":42,"./evpkdf":44,"./md5":49}],63:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./enc-base64"),require("./md5"),require("./evpkdf"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./enc-base64","./md5","./evpkdf","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var StreamCipher=C_lib.StreamCipher;var C_algo=C.algo;/**
		     * RC4 stream cipher algorithm.
		     */var RC4=C_algo.RC4=StreamCipher.extend({_doReset:function _doReset(){// Shortcuts
	var key=this._key;var keyWords=key.words;var keySigBytes=key.sigBytes;// Init sbox
	var S=this._S=[];for(var i=0;i<256;i++){S[i]=i;}// Key setup
	for(var i=0,j=0;i<256;i++){var keyByteIndex=i%keySigBytes;var keyByte=keyWords[keyByteIndex>>>2]>>>24-keyByteIndex%4*8&0xff;j=(j+S[i]+keyByte)%256;// Swap
	var t=S[i];S[i]=S[j];S[j]=t;}// Counters
	this._i=this._j=0;},_doProcessBlock:function _doProcessBlock(M,offset){M[offset]^=generateKeystreamWord.call(this);},keySize:256/32,ivSize:0});function generateKeystreamWord(){// Shortcuts
	var S=this._S;var i=this._i;var j=this._j;// Generate keystream word
	var keystreamWord=0;for(var n=0;n<4;n++){i=(i+1)%256;j=(j+S[i])%256;// Swap
	var t=S[i];S[i]=S[j];S[j]=t;keystreamWord|=S[(S[i]+S[j])%256]<<24-n*8;}// Update counters
	this._i=i;this._j=j;return keystreamWord;}/**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
		     */C.RC4=StreamCipher._createHelper(RC4);/**
		     * Modified RC4 stream cipher algorithm.
		     */var RC4Drop=C_algo.RC4Drop=RC4.extend({/**
		         * Configuration options.
		         *
		         * @property {number} drop The number of keystream words to drop. Default 192
		         */cfg:RC4.cfg.extend({drop:192}),_doReset:function _doReset(){RC4._doReset.call(this);// Drop
	for(var i=this.cfg.drop;i>0;i--){generateKeystreamWord.call(this);}}});/**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
		     */C.RC4Drop=StreamCipher._createHelper(RC4Drop);})();return CryptoJS.RC4;});},{"./cipher-core":40,"./core":41,"./enc-base64":42,"./evpkdf":44,"./md5":49}],64:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
	
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/(function(Math){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var Hasher=C_lib.Hasher;var C_algo=C.algo;// Constants table
	var _zl=WordArray.create([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13]);var _zr=WordArray.create([5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11]);var _sl=WordArray.create([11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6]);var _sr=WordArray.create([8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]);var _hl=WordArray.create([0x00000000,0x5A827999,0x6ED9EBA1,0x8F1BBCDC,0xA953FD4E]);var _hr=WordArray.create([0x50A28BE6,0x5C4DD124,0x6D703EF3,0x7A6D76E9,0x00000000]);/**
		     * RIPEMD160 hash algorithm.
		     */var RIPEMD160=C_algo.RIPEMD160=Hasher.extend({_doReset:function _doReset(){this._hash=WordArray.create([0x67452301,0xEFCDAB89,0x98BADCFE,0x10325476,0xC3D2E1F0]);},_doProcessBlock:function _doProcessBlock(M,offset){// Swap endian
	for(var i=0;i<16;i++){// Shortcuts
	var offset_i=offset+i;var M_offset_i=M[offset_i];// Swap
	M[offset_i]=(M_offset_i<<8|M_offset_i>>>24)&0x00ff00ff|(M_offset_i<<24|M_offset_i>>>8)&0xff00ff00;}// Shortcut
	var H=this._hash.words;var hl=_hl.words;var hr=_hr.words;var zl=_zl.words;var zr=_zr.words;var sl=_sl.words;var sr=_sr.words;// Working variables
	var al,bl,cl,dl,el;var ar,br,cr,dr,er;ar=al=H[0];br=bl=H[1];cr=cl=H[2];dr=dl=H[3];er=el=H[4];// Computation
	var t;for(var i=0;i<80;i+=1){t=al+M[offset+zl[i]]|0;if(i<16){t+=f1(bl,cl,dl)+hl[0];}else if(i<32){t+=f2(bl,cl,dl)+hl[1];}else if(i<48){t+=f3(bl,cl,dl)+hl[2];}else if(i<64){t+=f4(bl,cl,dl)+hl[3];}else{// if (i<80) {
	t+=f5(bl,cl,dl)+hl[4];}t=t|0;t=rotl(t,sl[i]);t=t+el|0;al=el;el=dl;dl=rotl(cl,10);cl=bl;bl=t;t=ar+M[offset+zr[i]]|0;if(i<16){t+=f5(br,cr,dr)+hr[0];}else if(i<32){t+=f4(br,cr,dr)+hr[1];}else if(i<48){t+=f3(br,cr,dr)+hr[2];}else if(i<64){t+=f2(br,cr,dr)+hr[3];}else{// if (i<80) {
	t+=f1(br,cr,dr)+hr[4];}t=t|0;t=rotl(t,sr[i]);t=t+er|0;ar=er;er=dr;dr=rotl(cr,10);cr=br;br=t;}// Intermediate hash value
	t=H[1]+cl+dr|0;H[1]=H[2]+dl+er|0;H[2]=H[3]+el+ar|0;H[3]=H[4]+al+br|0;H[4]=H[0]+bl+cr|0;H[0]=t;},_doFinalize:function _doFinalize(){// Shortcuts
	var data=this._data;var dataWords=data.words;var nBitsTotal=this._nDataBytes*8;var nBitsLeft=data.sigBytes*8;// Add padding
	dataWords[nBitsLeft>>>5]|=0x80<<24-nBitsLeft%32;dataWords[(nBitsLeft+64>>>9<<4)+14]=(nBitsTotal<<8|nBitsTotal>>>24)&0x00ff00ff|(nBitsTotal<<24|nBitsTotal>>>8)&0xff00ff00;data.sigBytes=(dataWords.length+1)*4;// Hash final blocks
	this._process();// Shortcuts
	var hash=this._hash;var H=hash.words;// Swap endian
	for(var i=0;i<5;i++){// Shortcut
	var H_i=H[i];// Swap
	H[i]=(H_i<<8|H_i>>>24)&0x00ff00ff|(H_i<<24|H_i>>>8)&0xff00ff00;}// Return final computed hash
	return hash;},clone:function clone(){var clone=Hasher.clone.call(this);clone._hash=this._hash.clone();return clone;}});function f1(x,y,z){return x^y^z;}function f2(x,y,z){return x&y|~x&z;}function f3(x,y,z){return(x|~y)^z;}function f4(x,y,z){return x&z|y&~z;}function f5(x,y,z){return x^(y|~z);}function rotl(x,n){return x<<n|x>>>32-n;}/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.RIPEMD160('message');
		     *     var hash = CryptoJS.RIPEMD160(wordArray);
		     */C.RIPEMD160=Hasher._createHelper(RIPEMD160);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
		     */C.HmacRIPEMD160=Hasher._createHmacHelper(RIPEMD160);})(Math);return CryptoJS.RIPEMD160;});},{"./core":41}],65:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var Hasher=C_lib.Hasher;var C_algo=C.algo;// Reusable object
	var W=[];/**
		     * SHA-1 hash algorithm.
		     */var SHA1=C_algo.SHA1=Hasher.extend({_doReset:function _doReset(){this._hash=new WordArray.init([0x67452301,0xefcdab89,0x98badcfe,0x10325476,0xc3d2e1f0]);},_doProcessBlock:function _doProcessBlock(M,offset){// Shortcut
	var H=this._hash.words;// Working variables
	var a=H[0];var b=H[1];var c=H[2];var d=H[3];var e=H[4];// Computation
	for(var i=0;i<80;i++){if(i<16){W[i]=M[offset+i]|0;}else{var n=W[i-3]^W[i-8]^W[i-14]^W[i-16];W[i]=n<<1|n>>>31;}var t=(a<<5|a>>>27)+e+W[i];if(i<20){t+=(b&c|~b&d)+0x5a827999;}else if(i<40){t+=(b^c^d)+0x6ed9eba1;}else if(i<60){t+=(b&c|b&d|c&d)-0x70e44324;}else/* if (i < 80) */{t+=(b^c^d)-0x359d3e2a;}e=d;d=c;c=b<<30|b>>>2;b=a;a=t;}// Intermediate hash value
	H[0]=H[0]+a|0;H[1]=H[1]+b|0;H[2]=H[2]+c|0;H[3]=H[3]+d|0;H[4]=H[4]+e|0;},_doFinalize:function _doFinalize(){// Shortcuts
	var data=this._data;var dataWords=data.words;var nBitsTotal=this._nDataBytes*8;var nBitsLeft=data.sigBytes*8;// Add padding
	dataWords[nBitsLeft>>>5]|=0x80<<24-nBitsLeft%32;dataWords[(nBitsLeft+64>>>9<<4)+14]=Math.floor(nBitsTotal/0x100000000);dataWords[(nBitsLeft+64>>>9<<4)+15]=nBitsTotal;data.sigBytes=dataWords.length*4;// Hash final blocks
	this._process();// Return final computed hash
	return this._hash;},clone:function clone(){var clone=Hasher.clone.call(this);clone._hash=this._hash.clone();return clone;}});/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA1('message');
		     *     var hash = CryptoJS.SHA1(wordArray);
		     */C.SHA1=Hasher._createHelper(SHA1);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA1(message, key);
		     */C.HmacSHA1=Hasher._createHmacHelper(SHA1);})();return CryptoJS.SHA1;});},{"./core":41}],66:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./sha256"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./sha256"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var C_algo=C.algo;var SHA256=C_algo.SHA256;/**
		     * SHA-224 hash algorithm.
		     */var SHA224=C_algo.SHA224=SHA256.extend({_doReset:function _doReset(){this._hash=new WordArray.init([0xc1059ed8,0x367cd507,0x3070dd17,0xf70e5939,0xffc00b31,0x68581511,0x64f98fa7,0xbefa4fa4]);},_doFinalize:function _doFinalize(){var hash=SHA256._doFinalize.call(this);hash.sigBytes-=4;return hash;}});/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA224('message');
		     *     var hash = CryptoJS.SHA224(wordArray);
		     */C.SHA224=SHA256._createHelper(SHA224);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA224(message, key);
		     */C.HmacSHA224=SHA256._createHmacHelper(SHA224);})();return CryptoJS.SHA224;});},{"./core":41,"./sha256":67}],67:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(Math){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var Hasher=C_lib.Hasher;var C_algo=C.algo;// Initialization and round constants tables
	var H=[];var K=[];// Compute constants
	(function(){function isPrime(n){var sqrtN=Math.sqrt(n);for(var factor=2;factor<=sqrtN;factor++){if(!(n%factor)){return false;}}return true;}function getFractionalBits(n){return(n-(n|0))*0x100000000|0;}var n=2;var nPrime=0;while(nPrime<64){if(isPrime(n)){if(nPrime<8){H[nPrime]=getFractionalBits(Math.pow(n,1/2));}K[nPrime]=getFractionalBits(Math.pow(n,1/3));nPrime++;}n++;}})();// Reusable object
	var W=[];/**
		     * SHA-256 hash algorithm.
		     */var SHA256=C_algo.SHA256=Hasher.extend({_doReset:function _doReset(){this._hash=new WordArray.init(H.slice(0));},_doProcessBlock:function _doProcessBlock(M,offset){// Shortcut
	var H=this._hash.words;// Working variables
	var a=H[0];var b=H[1];var c=H[2];var d=H[3];var e=H[4];var f=H[5];var g=H[6];var h=H[7];// Computation
	for(var i=0;i<64;i++){if(i<16){W[i]=M[offset+i]|0;}else{var gamma0x=W[i-15];var gamma0=(gamma0x<<25|gamma0x>>>7)^(gamma0x<<14|gamma0x>>>18)^gamma0x>>>3;var gamma1x=W[i-2];var gamma1=(gamma1x<<15|gamma1x>>>17)^(gamma1x<<13|gamma1x>>>19)^gamma1x>>>10;W[i]=gamma0+W[i-7]+gamma1+W[i-16];}var ch=e&f^~e&g;var maj=a&b^a&c^b&c;var sigma0=(a<<30|a>>>2)^(a<<19|a>>>13)^(a<<10|a>>>22);var sigma1=(e<<26|e>>>6)^(e<<21|e>>>11)^(e<<7|e>>>25);var t1=h+sigma1+ch+K[i]+W[i];var t2=sigma0+maj;h=g;g=f;f=e;e=d+t1|0;d=c;c=b;b=a;a=t1+t2|0;}// Intermediate hash value
	H[0]=H[0]+a|0;H[1]=H[1]+b|0;H[2]=H[2]+c|0;H[3]=H[3]+d|0;H[4]=H[4]+e|0;H[5]=H[5]+f|0;H[6]=H[6]+g|0;H[7]=H[7]+h|0;},_doFinalize:function _doFinalize(){// Shortcuts
	var data=this._data;var dataWords=data.words;var nBitsTotal=this._nDataBytes*8;var nBitsLeft=data.sigBytes*8;// Add padding
	dataWords[nBitsLeft>>>5]|=0x80<<24-nBitsLeft%32;dataWords[(nBitsLeft+64>>>9<<4)+14]=Math.floor(nBitsTotal/0x100000000);dataWords[(nBitsLeft+64>>>9<<4)+15]=nBitsTotal;data.sigBytes=dataWords.length*4;// Hash final blocks
	this._process();// Return final computed hash
	return this._hash;},clone:function clone(){var clone=Hasher.clone.call(this);clone._hash=this._hash.clone();return clone;}});/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */C.SHA256=Hasher._createHelper(SHA256);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */C.HmacSHA256=Hasher._createHmacHelper(SHA256);})(Math);return CryptoJS.SHA256;});},{"./core":41}],68:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./x64-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./x64-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(Math){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var Hasher=C_lib.Hasher;var C_x64=C.x64;var X64Word=C_x64.Word;var C_algo=C.algo;// Constants tables
	var RHO_OFFSETS=[];var PI_INDEXES=[];var ROUND_CONSTANTS=[];// Compute Constants
	(function(){// Compute rho offset constants
	var x=1,y=0;for(var t=0;t<24;t++){RHO_OFFSETS[x+5*y]=(t+1)*(t+2)/2%64;var newX=y%5;var newY=(2*x+3*y)%5;x=newX;y=newY;}// Compute pi index constants
	for(var x=0;x<5;x++){for(var y=0;y<5;y++){PI_INDEXES[x+5*y]=y+(2*x+3*y)%5*5;}}// Compute round constants
	var LFSR=0x01;for(var i=0;i<24;i++){var roundConstantMsw=0;var roundConstantLsw=0;for(var j=0;j<7;j++){if(LFSR&0x01){var bitPosition=(1<<j)-1;if(bitPosition<32){roundConstantLsw^=1<<bitPosition;}else/* if (bitPosition >= 32) */{roundConstantMsw^=1<<bitPosition-32;}}// Compute next LFSR
	if(LFSR&0x80){// Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	LFSR=LFSR<<1^0x71;}else{LFSR<<=1;}}ROUND_CONSTANTS[i]=X64Word.create(roundConstantMsw,roundConstantLsw);}})();// Reusable objects for temporary values
	var T=[];(function(){for(var i=0;i<25;i++){T[i]=X64Word.create();}})();/**
		     * SHA-3 hash algorithm.
		     */var SHA3=C_algo.SHA3=Hasher.extend({/**
		         * Configuration options.
		         *
		         * @property {number} outputLength
		         *   The desired number of bits in the output hash.
		         *   Only values permitted are: 224, 256, 384, 512.
		         *   Default: 512
		         */cfg:Hasher.cfg.extend({outputLength:512}),_doReset:function _doReset(){var state=this._state=[];for(var i=0;i<25;i++){state[i]=new X64Word.init();}this.blockSize=(1600-2*this.cfg.outputLength)/32;},_doProcessBlock:function _doProcessBlock(M,offset){// Shortcuts
	var state=this._state;var nBlockSizeLanes=this.blockSize/2;// Absorb
	for(var i=0;i<nBlockSizeLanes;i++){// Shortcuts
	var M2i=M[offset+2*i];var M2i1=M[offset+2*i+1];// Swap endian
	M2i=(M2i<<8|M2i>>>24)&0x00ff00ff|(M2i<<24|M2i>>>8)&0xff00ff00;M2i1=(M2i1<<8|M2i1>>>24)&0x00ff00ff|(M2i1<<24|M2i1>>>8)&0xff00ff00;// Absorb message into state
	var lane=state[i];lane.high^=M2i1;lane.low^=M2i;}// Rounds
	for(var round=0;round<24;round++){// Theta
	for(var x=0;x<5;x++){// Mix column lanes
	var tMsw=0,tLsw=0;for(var y=0;y<5;y++){var lane=state[x+5*y];tMsw^=lane.high;tLsw^=lane.low;}// Temporary values
	var Tx=T[x];Tx.high=tMsw;Tx.low=tLsw;}for(var x=0;x<5;x++){// Shortcuts
	var Tx4=T[(x+4)%5];var Tx1=T[(x+1)%5];var Tx1Msw=Tx1.high;var Tx1Lsw=Tx1.low;// Mix surrounding columns
	var tMsw=Tx4.high^(Tx1Msw<<1|Tx1Lsw>>>31);var tLsw=Tx4.low^(Tx1Lsw<<1|Tx1Msw>>>31);for(var y=0;y<5;y++){var lane=state[x+5*y];lane.high^=tMsw;lane.low^=tLsw;}}// Rho Pi
	for(var laneIndex=1;laneIndex<25;laneIndex++){// Shortcuts
	var lane=state[laneIndex];var laneMsw=lane.high;var laneLsw=lane.low;var rhoOffset=RHO_OFFSETS[laneIndex];// Rotate lanes
	if(rhoOffset<32){var tMsw=laneMsw<<rhoOffset|laneLsw>>>32-rhoOffset;var tLsw=laneLsw<<rhoOffset|laneMsw>>>32-rhoOffset;}else/* if (rhoOffset >= 32) */{var tMsw=laneLsw<<rhoOffset-32|laneMsw>>>64-rhoOffset;var tLsw=laneMsw<<rhoOffset-32|laneLsw>>>64-rhoOffset;}// Transpose lanes
	var TPiLane=T[PI_INDEXES[laneIndex]];TPiLane.high=tMsw;TPiLane.low=tLsw;}// Rho pi at x = y = 0
	var T0=T[0];var state0=state[0];T0.high=state0.high;T0.low=state0.low;// Chi
	for(var x=0;x<5;x++){for(var y=0;y<5;y++){// Shortcuts
	var laneIndex=x+5*y;var lane=state[laneIndex];var TLane=T[laneIndex];var Tx1Lane=T[(x+1)%5+5*y];var Tx2Lane=T[(x+2)%5+5*y];// Mix rows
	lane.high=TLane.high^~Tx1Lane.high&Tx2Lane.high;lane.low=TLane.low^~Tx1Lane.low&Tx2Lane.low;}}// Iota
	var lane=state[0];var roundConstant=ROUND_CONSTANTS[round];lane.high^=roundConstant.high;lane.low^=roundConstant.low;;}},_doFinalize:function _doFinalize(){// Shortcuts
	var data=this._data;var dataWords=data.words;var nBitsTotal=this._nDataBytes*8;var nBitsLeft=data.sigBytes*8;var blockSizeBits=this.blockSize*32;// Add padding
	dataWords[nBitsLeft>>>5]|=0x1<<24-nBitsLeft%32;dataWords[(Math.ceil((nBitsLeft+1)/blockSizeBits)*blockSizeBits>>>5)-1]|=0x80;data.sigBytes=dataWords.length*4;// Hash final blocks
	this._process();// Shortcuts
	var state=this._state;var outputLengthBytes=this.cfg.outputLength/8;var outputLengthLanes=outputLengthBytes/8;// Squeeze
	var hashWords=[];for(var i=0;i<outputLengthLanes;i++){// Shortcuts
	var lane=state[i];var laneMsw=lane.high;var laneLsw=lane.low;// Swap endian
	laneMsw=(laneMsw<<8|laneMsw>>>24)&0x00ff00ff|(laneMsw<<24|laneMsw>>>8)&0xff00ff00;laneLsw=(laneLsw<<8|laneLsw>>>24)&0x00ff00ff|(laneLsw<<24|laneLsw>>>8)&0xff00ff00;// Squeeze state to retrieve hash
	hashWords.push(laneLsw);hashWords.push(laneMsw);}// Return final computed hash
	return new WordArray.init(hashWords,outputLengthBytes);},clone:function clone(){var clone=Hasher.clone.call(this);var state=clone._state=this._state.slice(0);for(var i=0;i<25;i++){state[i]=state[i].clone();}return clone;}});/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA3('message');
		     *     var hash = CryptoJS.SHA3(wordArray);
		     */C.SHA3=Hasher._createHelper(SHA3);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA3(message, key);
		     */C.HmacSHA3=Hasher._createHmacHelper(SHA3);})(Math);return CryptoJS.SHA3;});},{"./core":41,"./x64-core":72}],69:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./x64-core"),require("./sha512"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./x64-core","./sha512"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_x64=C.x64;var X64Word=C_x64.Word;var X64WordArray=C_x64.WordArray;var C_algo=C.algo;var SHA512=C_algo.SHA512;/**
		     * SHA-384 hash algorithm.
		     */var SHA384=C_algo.SHA384=SHA512.extend({_doReset:function _doReset(){this._hash=new X64WordArray.init([new X64Word.init(0xcbbb9d5d,0xc1059ed8),new X64Word.init(0x629a292a,0x367cd507),new X64Word.init(0x9159015a,0x3070dd17),new X64Word.init(0x152fecd8,0xf70e5939),new X64Word.init(0x67332667,0xffc00b31),new X64Word.init(0x8eb44a87,0x68581511),new X64Word.init(0xdb0c2e0d,0x64f98fa7),new X64Word.init(0x47b5481d,0xbefa4fa4)]);},_doFinalize:function _doFinalize(){var hash=SHA512._doFinalize.call(this);hash.sigBytes-=16;return hash;}});/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA384('message');
		     *     var hash = CryptoJS.SHA384(wordArray);
		     */C.SHA384=SHA512._createHelper(SHA384);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA384(message, key);
		     */C.HmacSHA384=SHA512._createHmacHelper(SHA384);})();return CryptoJS.SHA384;});},{"./core":41,"./sha512":70,"./x64-core":72}],70:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./x64-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./x64-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var Hasher=C_lib.Hasher;var C_x64=C.x64;var X64Word=C_x64.Word;var X64WordArray=C_x64.WordArray;var C_algo=C.algo;function X64Word_create(){return X64Word.create.apply(X64Word,arguments);}// Constants
	var K=[X64Word_create(0x428a2f98,0xd728ae22),X64Word_create(0x71374491,0x23ef65cd),X64Word_create(0xb5c0fbcf,0xec4d3b2f),X64Word_create(0xe9b5dba5,0x8189dbbc),X64Word_create(0x3956c25b,0xf348b538),X64Word_create(0x59f111f1,0xb605d019),X64Word_create(0x923f82a4,0xaf194f9b),X64Word_create(0xab1c5ed5,0xda6d8118),X64Word_create(0xd807aa98,0xa3030242),X64Word_create(0x12835b01,0x45706fbe),X64Word_create(0x243185be,0x4ee4b28c),X64Word_create(0x550c7dc3,0xd5ffb4e2),X64Word_create(0x72be5d74,0xf27b896f),X64Word_create(0x80deb1fe,0x3b1696b1),X64Word_create(0x9bdc06a7,0x25c71235),X64Word_create(0xc19bf174,0xcf692694),X64Word_create(0xe49b69c1,0x9ef14ad2),X64Word_create(0xefbe4786,0x384f25e3),X64Word_create(0x0fc19dc6,0x8b8cd5b5),X64Word_create(0x240ca1cc,0x77ac9c65),X64Word_create(0x2de92c6f,0x592b0275),X64Word_create(0x4a7484aa,0x6ea6e483),X64Word_create(0x5cb0a9dc,0xbd41fbd4),X64Word_create(0x76f988da,0x831153b5),X64Word_create(0x983e5152,0xee66dfab),X64Word_create(0xa831c66d,0x2db43210),X64Word_create(0xb00327c8,0x98fb213f),X64Word_create(0xbf597fc7,0xbeef0ee4),X64Word_create(0xc6e00bf3,0x3da88fc2),X64Word_create(0xd5a79147,0x930aa725),X64Word_create(0x06ca6351,0xe003826f),X64Word_create(0x14292967,0x0a0e6e70),X64Word_create(0x27b70a85,0x46d22ffc),X64Word_create(0x2e1b2138,0x5c26c926),X64Word_create(0x4d2c6dfc,0x5ac42aed),X64Word_create(0x53380d13,0x9d95b3df),X64Word_create(0x650a7354,0x8baf63de),X64Word_create(0x766a0abb,0x3c77b2a8),X64Word_create(0x81c2c92e,0x47edaee6),X64Word_create(0x92722c85,0x1482353b),X64Word_create(0xa2bfe8a1,0x4cf10364),X64Word_create(0xa81a664b,0xbc423001),X64Word_create(0xc24b8b70,0xd0f89791),X64Word_create(0xc76c51a3,0x0654be30),X64Word_create(0xd192e819,0xd6ef5218),X64Word_create(0xd6990624,0x5565a910),X64Word_create(0xf40e3585,0x5771202a),X64Word_create(0x106aa070,0x32bbd1b8),X64Word_create(0x19a4c116,0xb8d2d0c8),X64Word_create(0x1e376c08,0x5141ab53),X64Word_create(0x2748774c,0xdf8eeb99),X64Word_create(0x34b0bcb5,0xe19b48a8),X64Word_create(0x391c0cb3,0xc5c95a63),X64Word_create(0x4ed8aa4a,0xe3418acb),X64Word_create(0x5b9cca4f,0x7763e373),X64Word_create(0x682e6ff3,0xd6b2b8a3),X64Word_create(0x748f82ee,0x5defb2fc),X64Word_create(0x78a5636f,0x43172f60),X64Word_create(0x84c87814,0xa1f0ab72),X64Word_create(0x8cc70208,0x1a6439ec),X64Word_create(0x90befffa,0x23631e28),X64Word_create(0xa4506ceb,0xde82bde9),X64Word_create(0xbef9a3f7,0xb2c67915),X64Word_create(0xc67178f2,0xe372532b),X64Word_create(0xca273ece,0xea26619c),X64Word_create(0xd186b8c7,0x21c0c207),X64Word_create(0xeada7dd6,0xcde0eb1e),X64Word_create(0xf57d4f7f,0xee6ed178),X64Word_create(0x06f067aa,0x72176fba),X64Word_create(0x0a637dc5,0xa2c898a6),X64Word_create(0x113f9804,0xbef90dae),X64Word_create(0x1b710b35,0x131c471b),X64Word_create(0x28db77f5,0x23047d84),X64Word_create(0x32caab7b,0x40c72493),X64Word_create(0x3c9ebe0a,0x15c9bebc),X64Word_create(0x431d67c4,0x9c100d4c),X64Word_create(0x4cc5d4be,0xcb3e42b6),X64Word_create(0x597f299c,0xfc657e2a),X64Word_create(0x5fcb6fab,0x3ad6faec),X64Word_create(0x6c44198c,0x4a475817)];// Reusable objects
	var W=[];(function(){for(var i=0;i<80;i++){W[i]=X64Word_create();}})();/**
		     * SHA-512 hash algorithm.
		     */var SHA512=C_algo.SHA512=Hasher.extend({_doReset:function _doReset(){this._hash=new X64WordArray.init([new X64Word.init(0x6a09e667,0xf3bcc908),new X64Word.init(0xbb67ae85,0x84caa73b),new X64Word.init(0x3c6ef372,0xfe94f82b),new X64Word.init(0xa54ff53a,0x5f1d36f1),new X64Word.init(0x510e527f,0xade682d1),new X64Word.init(0x9b05688c,0x2b3e6c1f),new X64Word.init(0x1f83d9ab,0xfb41bd6b),new X64Word.init(0x5be0cd19,0x137e2179)]);},_doProcessBlock:function _doProcessBlock(M,offset){// Shortcuts
	var H=this._hash.words;var H0=H[0];var H1=H[1];var H2=H[2];var H3=H[3];var H4=H[4];var H5=H[5];var H6=H[6];var H7=H[7];var H0h=H0.high;var H0l=H0.low;var H1h=H1.high;var H1l=H1.low;var H2h=H2.high;var H2l=H2.low;var H3h=H3.high;var H3l=H3.low;var H4h=H4.high;var H4l=H4.low;var H5h=H5.high;var H5l=H5.low;var H6h=H6.high;var H6l=H6.low;var H7h=H7.high;var H7l=H7.low;// Working variables
	var ah=H0h;var al=H0l;var bh=H1h;var bl=H1l;var ch=H2h;var cl=H2l;var dh=H3h;var dl=H3l;var eh=H4h;var el=H4l;var fh=H5h;var fl=H5l;var gh=H6h;var gl=H6l;var hh=H7h;var hl=H7l;// Rounds
	for(var i=0;i<80;i++){// Shortcut
	var Wi=W[i];// Extend message
	if(i<16){var Wih=Wi.high=M[offset+i*2]|0;var Wil=Wi.low=M[offset+i*2+1]|0;}else{// Gamma0
	var gamma0x=W[i-15];var gamma0xh=gamma0x.high;var gamma0xl=gamma0x.low;var gamma0h=(gamma0xh>>>1|gamma0xl<<31)^(gamma0xh>>>8|gamma0xl<<24)^gamma0xh>>>7;var gamma0l=(gamma0xl>>>1|gamma0xh<<31)^(gamma0xl>>>8|gamma0xh<<24)^(gamma0xl>>>7|gamma0xh<<25);// Gamma1
	var gamma1x=W[i-2];var gamma1xh=gamma1x.high;var gamma1xl=gamma1x.low;var gamma1h=(gamma1xh>>>19|gamma1xl<<13)^(gamma1xh<<3|gamma1xl>>>29)^gamma1xh>>>6;var gamma1l=(gamma1xl>>>19|gamma1xh<<13)^(gamma1xl<<3|gamma1xh>>>29)^(gamma1xl>>>6|gamma1xh<<26);// W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	var Wi7=W[i-7];var Wi7h=Wi7.high;var Wi7l=Wi7.low;var Wi16=W[i-16];var Wi16h=Wi16.high;var Wi16l=Wi16.low;var Wil=gamma0l+Wi7l;var Wih=gamma0h+Wi7h+(Wil>>>0<gamma0l>>>0?1:0);var Wil=Wil+gamma1l;var Wih=Wih+gamma1h+(Wil>>>0<gamma1l>>>0?1:0);var Wil=Wil+Wi16l;var Wih=Wih+Wi16h+(Wil>>>0<Wi16l>>>0?1:0);Wi.high=Wih;Wi.low=Wil;}var chh=eh&fh^~eh&gh;var chl=el&fl^~el&gl;var majh=ah&bh^ah&ch^bh&ch;var majl=al&bl^al&cl^bl&cl;var sigma0h=(ah>>>28|al<<4)^(ah<<30|al>>>2)^(ah<<25|al>>>7);var sigma0l=(al>>>28|ah<<4)^(al<<30|ah>>>2)^(al<<25|ah>>>7);var sigma1h=(eh>>>14|el<<18)^(eh>>>18|el<<14)^(eh<<23|el>>>9);var sigma1l=(el>>>14|eh<<18)^(el>>>18|eh<<14)^(el<<23|eh>>>9);// t1 = h + sigma1 + ch + K[i] + W[i]
	var Ki=K[i];var Kih=Ki.high;var Kil=Ki.low;var t1l=hl+sigma1l;var t1h=hh+sigma1h+(t1l>>>0<hl>>>0?1:0);var t1l=t1l+chl;var t1h=t1h+chh+(t1l>>>0<chl>>>0?1:0);var t1l=t1l+Kil;var t1h=t1h+Kih+(t1l>>>0<Kil>>>0?1:0);var t1l=t1l+Wil;var t1h=t1h+Wih+(t1l>>>0<Wil>>>0?1:0);// t2 = sigma0 + maj
	var t2l=sigma0l+majl;var t2h=sigma0h+majh+(t2l>>>0<sigma0l>>>0?1:0);// Update working variables
	hh=gh;hl=gl;gh=fh;gl=fl;fh=eh;fl=el;el=dl+t1l|0;eh=dh+t1h+(el>>>0<dl>>>0?1:0)|0;dh=ch;dl=cl;ch=bh;cl=bl;bh=ah;bl=al;al=t1l+t2l|0;ah=t1h+t2h+(al>>>0<t1l>>>0?1:0)|0;}// Intermediate hash value
	H0l=H0.low=H0l+al;H0.high=H0h+ah+(H0l>>>0<al>>>0?1:0);H1l=H1.low=H1l+bl;H1.high=H1h+bh+(H1l>>>0<bl>>>0?1:0);H2l=H2.low=H2l+cl;H2.high=H2h+ch+(H2l>>>0<cl>>>0?1:0);H3l=H3.low=H3l+dl;H3.high=H3h+dh+(H3l>>>0<dl>>>0?1:0);H4l=H4.low=H4l+el;H4.high=H4h+eh+(H4l>>>0<el>>>0?1:0);H5l=H5.low=H5l+fl;H5.high=H5h+fh+(H5l>>>0<fl>>>0?1:0);H6l=H6.low=H6l+gl;H6.high=H6h+gh+(H6l>>>0<gl>>>0?1:0);H7l=H7.low=H7l+hl;H7.high=H7h+hh+(H7l>>>0<hl>>>0?1:0);},_doFinalize:function _doFinalize(){// Shortcuts
	var data=this._data;var dataWords=data.words;var nBitsTotal=this._nDataBytes*8;var nBitsLeft=data.sigBytes*8;// Add padding
	dataWords[nBitsLeft>>>5]|=0x80<<24-nBitsLeft%32;dataWords[(nBitsLeft+128>>>10<<5)+30]=Math.floor(nBitsTotal/0x100000000);dataWords[(nBitsLeft+128>>>10<<5)+31]=nBitsTotal;data.sigBytes=dataWords.length*4;// Hash final blocks
	this._process();// Convert hash to 32-bit word array before returning
	var hash=this._hash.toX32();// Return final computed hash
	return hash;},clone:function clone(){var clone=Hasher.clone.call(this);clone._hash=this._hash.clone();return clone;},blockSize:1024/32});/**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA512('message');
		     *     var hash = CryptoJS.SHA512(wordArray);
		     */C.SHA512=Hasher._createHelper(SHA512);/**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA512(message, key);
		     */C.HmacSHA512=Hasher._createHmacHelper(SHA512);})();return CryptoJS.SHA512;});},{"./core":41,"./x64-core":72}],71:[function(require,module,exports){;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"),require("./enc-base64"),require("./md5"),require("./evpkdf"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core","./enc-base64","./md5","./evpkdf","./cipher-core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var WordArray=C_lib.WordArray;var BlockCipher=C_lib.BlockCipher;var C_algo=C.algo;// Permuted Choice 1 constants
	var PC1=[57,49,41,33,25,17,9,1,58,50,42,34,26,18,10,2,59,51,43,35,27,19,11,3,60,52,44,36,63,55,47,39,31,23,15,7,62,54,46,38,30,22,14,6,61,53,45,37,29,21,13,5,28,20,12,4];// Permuted Choice 2 constants
	var PC2=[14,17,11,24,1,5,3,28,15,6,21,10,23,19,12,4,26,8,16,7,27,20,13,2,41,52,31,37,47,55,30,40,51,45,33,48,44,49,39,56,34,53,46,42,50,36,29,32];// Cumulative bit shift constants
	var BIT_SHIFTS=[1,2,4,6,8,10,12,14,15,17,19,21,23,25,27,28];// SBOXes and round permutation constants
	var SBOX_P=[{0x0:0x808200,0x10000000:0x8000,0x20000000:0x808002,0x30000000:0x2,0x40000000:0x200,0x50000000:0x808202,0x60000000:0x800202,0x70000000:0x800000,0x80000000:0x202,0x90000000:0x800200,0xa0000000:0x8200,0xb0000000:0x808000,0xc0000000:0x8002,0xd0000000:0x800002,0xe0000000:0x0,0xf0000000:0x8202,0x8000000:0x0,0x18000000:0x808202,0x28000000:0x8202,0x38000000:0x8000,0x48000000:0x808200,0x58000000:0x200,0x68000000:0x808002,0x78000000:0x2,0x88000000:0x800200,0x98000000:0x8200,0xa8000000:0x808000,0xb8000000:0x800202,0xc8000000:0x800002,0xd8000000:0x8002,0xe8000000:0x202,0xf8000000:0x800000,0x1:0x8000,0x10000001:0x2,0x20000001:0x808200,0x30000001:0x800000,0x40000001:0x808002,0x50000001:0x8200,0x60000001:0x200,0x70000001:0x800202,0x80000001:0x808202,0x90000001:0x808000,0xa0000001:0x800002,0xb0000001:0x8202,0xc0000001:0x202,0xd0000001:0x800200,0xe0000001:0x8002,0xf0000001:0x0,0x8000001:0x808202,0x18000001:0x808000,0x28000001:0x800000,0x38000001:0x200,0x48000001:0x8000,0x58000001:0x800002,0x68000001:0x2,0x78000001:0x8202,0x88000001:0x8002,0x98000001:0x800202,0xa8000001:0x202,0xb8000001:0x808200,0xc8000001:0x800200,0xd8000001:0x0,0xe8000001:0x8200,0xf8000001:0x808002},{0x0:0x40084010,0x1000000:0x4000,0x2000000:0x80000,0x3000000:0x40080010,0x4000000:0x40000010,0x5000000:0x40084000,0x6000000:0x40004000,0x7000000:0x10,0x8000000:0x84000,0x9000000:0x40004010,0xa000000:0x40000000,0xb000000:0x84010,0xc000000:0x80010,0xd000000:0x0,0xe000000:0x4010,0xf000000:0x40080000,0x800000:0x40004000,0x1800000:0x84010,0x2800000:0x10,0x3800000:0x40004010,0x4800000:0x40084010,0x5800000:0x40000000,0x6800000:0x80000,0x7800000:0x40080010,0x8800000:0x80010,0x9800000:0x0,0xa800000:0x4000,0xb800000:0x40080000,0xc800000:0x40000010,0xd800000:0x84000,0xe800000:0x40084000,0xf800000:0x4010,0x10000000:0x0,0x11000000:0x40080010,0x12000000:0x40004010,0x13000000:0x40084000,0x14000000:0x40080000,0x15000000:0x10,0x16000000:0x84010,0x17000000:0x4000,0x18000000:0x4010,0x19000000:0x80000,0x1a000000:0x80010,0x1b000000:0x40000010,0x1c000000:0x84000,0x1d000000:0x40004000,0x1e000000:0x40000000,0x1f000000:0x40084010,0x10800000:0x84010,0x11800000:0x80000,0x12800000:0x40080000,0x13800000:0x4000,0x14800000:0x40004000,0x15800000:0x40084010,0x16800000:0x10,0x17800000:0x40000000,0x18800000:0x40084000,0x19800000:0x40000010,0x1a800000:0x40004010,0x1b800000:0x80010,0x1c800000:0x0,0x1d800000:0x4010,0x1e800000:0x40080010,0x1f800000:0x84000},{0x0:0x104,0x100000:0x0,0x200000:0x4000100,0x300000:0x10104,0x400000:0x10004,0x500000:0x4000004,0x600000:0x4010104,0x700000:0x4010000,0x800000:0x4000000,0x900000:0x4010100,0xa00000:0x10100,0xb00000:0x4010004,0xc00000:0x4000104,0xd00000:0x10000,0xe00000:0x4,0xf00000:0x100,0x80000:0x4010100,0x180000:0x4010004,0x280000:0x0,0x380000:0x4000100,0x480000:0x4000004,0x580000:0x10000,0x680000:0x10004,0x780000:0x104,0x880000:0x4,0x980000:0x100,0xa80000:0x4010000,0xb80000:0x10104,0xc80000:0x10100,0xd80000:0x4000104,0xe80000:0x4010104,0xf80000:0x4000000,0x1000000:0x4010100,0x1100000:0x10004,0x1200000:0x10000,0x1300000:0x4000100,0x1400000:0x100,0x1500000:0x4010104,0x1600000:0x4000004,0x1700000:0x0,0x1800000:0x4000104,0x1900000:0x4000000,0x1a00000:0x4,0x1b00000:0x10100,0x1c00000:0x4010000,0x1d00000:0x104,0x1e00000:0x10104,0x1f00000:0x4010004,0x1080000:0x4000000,0x1180000:0x104,0x1280000:0x4010100,0x1380000:0x0,0x1480000:0x10004,0x1580000:0x4000100,0x1680000:0x100,0x1780000:0x4010004,0x1880000:0x10000,0x1980000:0x4010104,0x1a80000:0x10104,0x1b80000:0x4000004,0x1c80000:0x4000104,0x1d80000:0x4010000,0x1e80000:0x4,0x1f80000:0x10100},{0x0:0x80401000,0x10000:0x80001040,0x20000:0x401040,0x30000:0x80400000,0x40000:0x0,0x50000:0x401000,0x60000:0x80000040,0x70000:0x400040,0x80000:0x80000000,0x90000:0x400000,0xa0000:0x40,0xb0000:0x80001000,0xc0000:0x80400040,0xd0000:0x1040,0xe0000:0x1000,0xf0000:0x80401040,0x8000:0x80001040,0x18000:0x40,0x28000:0x80400040,0x38000:0x80001000,0x48000:0x401000,0x58000:0x80401040,0x68000:0x0,0x78000:0x80400000,0x88000:0x1000,0x98000:0x80401000,0xa8000:0x400000,0xb8000:0x1040,0xc8000:0x80000000,0xd8000:0x400040,0xe8000:0x401040,0xf8000:0x80000040,0x100000:0x400040,0x110000:0x401000,0x120000:0x80000040,0x130000:0x0,0x140000:0x1040,0x150000:0x80400040,0x160000:0x80401000,0x170000:0x80001040,0x180000:0x80401040,0x190000:0x80000000,0x1a0000:0x80400000,0x1b0000:0x401040,0x1c0000:0x80001000,0x1d0000:0x400000,0x1e0000:0x40,0x1f0000:0x1000,0x108000:0x80400000,0x118000:0x80401040,0x128000:0x0,0x138000:0x401000,0x148000:0x400040,0x158000:0x80000000,0x168000:0x80001040,0x178000:0x40,0x188000:0x80000040,0x198000:0x1000,0x1a8000:0x80001000,0x1b8000:0x80400040,0x1c8000:0x1040,0x1d8000:0x80401000,0x1e8000:0x400000,0x1f8000:0x401040},{0x0:0x80,0x1000:0x1040000,0x2000:0x40000,0x3000:0x20000000,0x4000:0x20040080,0x5000:0x1000080,0x6000:0x21000080,0x7000:0x40080,0x8000:0x1000000,0x9000:0x20040000,0xa000:0x20000080,0xb000:0x21040080,0xc000:0x21040000,0xd000:0x0,0xe000:0x1040080,0xf000:0x21000000,0x800:0x1040080,0x1800:0x21000080,0x2800:0x80,0x3800:0x1040000,0x4800:0x40000,0x5800:0x20040080,0x6800:0x21040000,0x7800:0x20000000,0x8800:0x20040000,0x9800:0x0,0xa800:0x21040080,0xb800:0x1000080,0xc800:0x20000080,0xd800:0x21000000,0xe800:0x1000000,0xf800:0x40080,0x10000:0x40000,0x11000:0x80,0x12000:0x20000000,0x13000:0x21000080,0x14000:0x1000080,0x15000:0x21040000,0x16000:0x20040080,0x17000:0x1000000,0x18000:0x21040080,0x19000:0x21000000,0x1a000:0x1040000,0x1b000:0x20040000,0x1c000:0x40080,0x1d000:0x20000080,0x1e000:0x0,0x1f000:0x1040080,0x10800:0x21000080,0x11800:0x1000000,0x12800:0x1040000,0x13800:0x20040080,0x14800:0x20000000,0x15800:0x1040080,0x16800:0x80,0x17800:0x21040000,0x18800:0x40080,0x19800:0x21040080,0x1a800:0x0,0x1b800:0x21000000,0x1c800:0x1000080,0x1d800:0x40000,0x1e800:0x20040000,0x1f800:0x20000080},{0x0:0x10000008,0x100:0x2000,0x200:0x10200000,0x300:0x10202008,0x400:0x10002000,0x500:0x200000,0x600:0x200008,0x700:0x10000000,0x800:0x0,0x900:0x10002008,0xa00:0x202000,0xb00:0x8,0xc00:0x10200008,0xd00:0x202008,0xe00:0x2008,0xf00:0x10202000,0x80:0x10200000,0x180:0x10202008,0x280:0x8,0x380:0x200000,0x480:0x202008,0x580:0x10000008,0x680:0x10002000,0x780:0x2008,0x880:0x200008,0x980:0x2000,0xa80:0x10002008,0xb80:0x10200008,0xc80:0x0,0xd80:0x10202000,0xe80:0x202000,0xf80:0x10000000,0x1000:0x10002000,0x1100:0x10200008,0x1200:0x10202008,0x1300:0x2008,0x1400:0x200000,0x1500:0x10000000,0x1600:0x10000008,0x1700:0x202000,0x1800:0x202008,0x1900:0x0,0x1a00:0x8,0x1b00:0x10200000,0x1c00:0x2000,0x1d00:0x10002008,0x1e00:0x10202000,0x1f00:0x200008,0x1080:0x8,0x1180:0x202000,0x1280:0x200000,0x1380:0x10000008,0x1480:0x10002000,0x1580:0x2008,0x1680:0x10202008,0x1780:0x10200000,0x1880:0x10202000,0x1980:0x10200008,0x1a80:0x2000,0x1b80:0x202008,0x1c80:0x200008,0x1d80:0x0,0x1e80:0x10000000,0x1f80:0x10002008},{0x0:0x100000,0x10:0x2000401,0x20:0x400,0x30:0x100401,0x40:0x2100401,0x50:0x0,0x60:0x1,0x70:0x2100001,0x80:0x2000400,0x90:0x100001,0xa0:0x2000001,0xb0:0x2100400,0xc0:0x2100000,0xd0:0x401,0xe0:0x100400,0xf0:0x2000000,0x8:0x2100001,0x18:0x0,0x28:0x2000401,0x38:0x2100400,0x48:0x100000,0x58:0x2000001,0x68:0x2000000,0x78:0x401,0x88:0x100401,0x98:0x2000400,0xa8:0x2100000,0xb8:0x100001,0xc8:0x400,0xd8:0x2100401,0xe8:0x1,0xf8:0x100400,0x100:0x2000000,0x110:0x100000,0x120:0x2000401,0x130:0x2100001,0x140:0x100001,0x150:0x2000400,0x160:0x2100400,0x170:0x100401,0x180:0x401,0x190:0x2100401,0x1a0:0x100400,0x1b0:0x1,0x1c0:0x0,0x1d0:0x2100000,0x1e0:0x2000001,0x1f0:0x400,0x108:0x100400,0x118:0x2000401,0x128:0x2100001,0x138:0x1,0x148:0x2000000,0x158:0x100000,0x168:0x401,0x178:0x2100400,0x188:0x2000001,0x198:0x2100000,0x1a8:0x0,0x1b8:0x2100401,0x1c8:0x100401,0x1d8:0x400,0x1e8:0x2000400,0x1f8:0x100001},{0x0:0x8000820,0x1:0x20000,0x2:0x8000000,0x3:0x20,0x4:0x20020,0x5:0x8020820,0x6:0x8020800,0x7:0x800,0x8:0x8020000,0x9:0x8000800,0xa:0x20800,0xb:0x8020020,0xc:0x820,0xd:0x0,0xe:0x8000020,0xf:0x20820,0x80000000:0x800,0x80000001:0x8020820,0x80000002:0x8000820,0x80000003:0x8000000,0x80000004:0x8020000,0x80000005:0x20800,0x80000006:0x20820,0x80000007:0x20,0x80000008:0x8000020,0x80000009:0x820,0x8000000a:0x20020,0x8000000b:0x8020800,0x8000000c:0x0,0x8000000d:0x8020020,0x8000000e:0x8000800,0x8000000f:0x20000,0x10:0x20820,0x11:0x8020800,0x12:0x20,0x13:0x800,0x14:0x8000800,0x15:0x8000020,0x16:0x8020020,0x17:0x20000,0x18:0x0,0x19:0x20020,0x1a:0x8020000,0x1b:0x8000820,0x1c:0x8020820,0x1d:0x20800,0x1e:0x820,0x1f:0x8000000,0x80000010:0x20000,0x80000011:0x800,0x80000012:0x8020020,0x80000013:0x20820,0x80000014:0x20,0x80000015:0x8020000,0x80000016:0x8000000,0x80000017:0x8000820,0x80000018:0x8020820,0x80000019:0x8000020,0x8000001a:0x8000800,0x8000001b:0x0,0x8000001c:0x20800,0x8000001d:0x820,0x8000001e:0x20020,0x8000001f:0x8020800}];// Masks that select the SBOX input
	var SBOX_MASK=[0xf8000001,0x1f800000,0x01f80000,0x001f8000,0x0001f800,0x00001f80,0x000001f8,0x8000001f];/**
		     * DES block cipher algorithm.
		     */var DES=C_algo.DES=BlockCipher.extend({_doReset:function _doReset(){// Shortcuts
	var key=this._key;var keyWords=key.words;// Select 56 bits according to PC1
	var keyBits=[];for(var i=0;i<56;i++){var keyBitPos=PC1[i]-1;keyBits[i]=keyWords[keyBitPos>>>5]>>>31-keyBitPos%32&1;}// Assemble 16 subkeys
	var subKeys=this._subKeys=[];for(var nSubKey=0;nSubKey<16;nSubKey++){// Create subkey
	var subKey=subKeys[nSubKey]=[];// Shortcut
	var bitShift=BIT_SHIFTS[nSubKey];// Select 48 bits according to PC2
	for(var i=0;i<24;i++){// Select from the left 28 key bits
	subKey[i/6|0]|=keyBits[(PC2[i]-1+bitShift)%28]<<31-i%6;// Select from the right 28 key bits
	subKey[4+(i/6|0)]|=keyBits[28+(PC2[i+24]-1+bitShift)%28]<<31-i%6;}// Since each subkey is applied to an expanded 32-bit input,
	// the subkey can be broken into 8 values scaled to 32-bits,
	// which allows the key to be used without expansion
	subKey[0]=subKey[0]<<1|subKey[0]>>>31;for(var i=1;i<7;i++){subKey[i]=subKey[i]>>>(i-1)*4+3;}subKey[7]=subKey[7]<<5|subKey[7]>>>27;}// Compute inverse subkeys
	var invSubKeys=this._invSubKeys=[];for(var i=0;i<16;i++){invSubKeys[i]=subKeys[15-i];}},encryptBlock:function encryptBlock(M,offset){this._doCryptBlock(M,offset,this._subKeys);},decryptBlock:function decryptBlock(M,offset){this._doCryptBlock(M,offset,this._invSubKeys);},_doCryptBlock:function _doCryptBlock(M,offset,subKeys){// Get input
	this._lBlock=M[offset];this._rBlock=M[offset+1];// Initial permutation
	exchangeLR.call(this,4,0x0f0f0f0f);exchangeLR.call(this,16,0x0000ffff);exchangeRL.call(this,2,0x33333333);exchangeRL.call(this,8,0x00ff00ff);exchangeLR.call(this,1,0x55555555);// Rounds
	for(var round=0;round<16;round++){// Shortcuts
	var subKey=subKeys[round];var lBlock=this._lBlock;var rBlock=this._rBlock;// Feistel function
	var f=0;for(var i=0;i<8;i++){f|=SBOX_P[i][((rBlock^subKey[i])&SBOX_MASK[i])>>>0];}this._lBlock=rBlock;this._rBlock=lBlock^f;}// Undo swap from last round
	var t=this._lBlock;this._lBlock=this._rBlock;this._rBlock=t;// Final permutation
	exchangeLR.call(this,1,0x55555555);exchangeRL.call(this,8,0x00ff00ff);exchangeRL.call(this,2,0x33333333);exchangeLR.call(this,16,0x0000ffff);exchangeLR.call(this,4,0x0f0f0f0f);// Set output
	M[offset]=this._lBlock;M[offset+1]=this._rBlock;},keySize:64/32,ivSize:64/32,blockSize:64/32});// Swap bits across the left and right words
	function exchangeLR(offset,mask){var t=(this._lBlock>>>offset^this._rBlock)&mask;this._rBlock^=t;this._lBlock^=t<<offset;}function exchangeRL(offset,mask){var t=(this._rBlock>>>offset^this._lBlock)&mask;this._lBlock^=t;this._rBlock^=t<<offset;}/**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
		     */C.DES=BlockCipher._createHelper(DES);/**
		     * Triple-DES block cipher algorithm.
		     */var TripleDES=C_algo.TripleDES=BlockCipher.extend({_doReset:function _doReset(){// Shortcuts
	var key=this._key;var keyWords=key.words;// Create DES instances
	this._des1=DES.createEncryptor(WordArray.create(keyWords.slice(0,2)));this._des2=DES.createEncryptor(WordArray.create(keyWords.slice(2,4)));this._des3=DES.createEncryptor(WordArray.create(keyWords.slice(4,6)));},encryptBlock:function encryptBlock(M,offset){this._des1.encryptBlock(M,offset);this._des2.decryptBlock(M,offset);this._des3.encryptBlock(M,offset);},decryptBlock:function decryptBlock(M,offset){this._des3.decryptBlock(M,offset);this._des2.encryptBlock(M,offset);this._des1.decryptBlock(M,offset);},keySize:192/32,ivSize:64/32,blockSize:64/32});/**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
		     */C.TripleDES=BlockCipher._createHelper(TripleDES);})();return CryptoJS.TripleDES;});},{"./cipher-core":40,"./core":41,"./enc-base64":42,"./evpkdf":44,"./md5":49}],72:[function(require,module,exports){;(function(root,factory){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
	module.exports=exports=factory(require("./core"));}else if(typeof define==="function"&&define.amd){// AMD
	define(["./core"],factory);}else{// Global (browser)
	factory(root.CryptoJS);}})(this,function(CryptoJS){(function(undefined){// Shortcuts
	var C=CryptoJS;var C_lib=C.lib;var Base=C_lib.Base;var X32WordArray=C_lib.WordArray;/**
		     * x64 namespace.
		     */var C_x64=C.x64={};/**
		     * A 64-bit word.
		     */var X64Word=C_x64.Word=Base.extend({/**
		         * Initializes a newly created 64-bit word.
		         *
		         * @param {number} high The high 32 bits.
		         * @param {number} low The low 32 bits.
		         *
		         * @example
		         *
		         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
		         */init:function init(high,low){this.high=high;this.low=low;}/**
		         * Bitwise NOTs this word.
		         *
		         * @return {X64Word} A new x64-Word object after negating.
		         *
		         * @example
		         *
		         *     var negated = x64Word.not();
		         */// not: function () {
	// var high = ~this.high;
	// var low = ~this.low;
	// return X64Word.create(high, low);
	// },
	/**
		         * Bitwise ANDs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to AND with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ANDing.
		         *
		         * @example
		         *
		         *     var anded = x64Word.and(anotherX64Word);
		         */// and: function (word) {
	// var high = this.high & word.high;
	// var low = this.low & word.low;
	// return X64Word.create(high, low);
	// },
	/**
		         * Bitwise ORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to OR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ORing.
		         *
		         * @example
		         *
		         *     var ored = x64Word.or(anotherX64Word);
		         */// or: function (word) {
	// var high = this.high | word.high;
	// var low = this.low | word.low;
	// return X64Word.create(high, low);
	// },
	/**
		         * Bitwise XORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to XOR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after XORing.
		         *
		         * @example
		         *
		         *     var xored = x64Word.xor(anotherX64Word);
		         */// xor: function (word) {
	// var high = this.high ^ word.high;
	// var low = this.low ^ word.low;
	// return X64Word.create(high, low);
	// },
	/**
		         * Shifts this word n bits to the left.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftL(25);
		         */// shiftL: function (n) {
	// if (n < 32) {
	// var high = (this.high << n) | (this.low >>> (32 - n));
	// var low = this.low << n;
	// } else {
	// var high = this.low << (n - 32);
	// var low = 0;
	// }
	// return X64Word.create(high, low);
	// },
	/**
		         * Shifts this word n bits to the right.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftR(7);
		         */// shiftR: function (n) {
	// if (n < 32) {
	// var low = (this.low >>> n) | (this.high << (32 - n));
	// var high = this.high >>> n;
	// } else {
	// var low = this.high >>> (n - 32);
	// var high = 0;
	// }
	// return X64Word.create(high, low);
	// },
	/**
		         * Rotates this word n bits to the left.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotL(25);
		         */// rotL: function (n) {
	// return this.shiftL(n).or(this.shiftR(64 - n));
	// },
	/**
		         * Rotates this word n bits to the right.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotR(7);
		         */// rotR: function (n) {
	// return this.shiftR(n).or(this.shiftL(64 - n));
	// },
	/**
		         * Adds this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to add with this word.
		         *
		         * @return {X64Word} A new x64-Word object after adding.
		         *
		         * @example
		         *
		         *     var added = x64Word.add(anotherX64Word);
		         */// add: function (word) {
	// var low = (this.low + word.low) | 0;
	// var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	// var high = (this.high + word.high + carry) | 0;
	// return X64Word.create(high, low);
	// }
	});/**
		     * An array of 64-bit words.
		     *
		     * @property {Array} words The array of CryptoJS.x64.Word objects.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */var X64WordArray=C_x64.WordArray=Base.extend({/**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create();
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ]);
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ], 10);
		         */init:function init(words,sigBytes){words=this.words=words||[];if(sigBytes!=undefined){this.sigBytes=sigBytes;}else{this.sigBytes=words.length*8;}},/**
		         * Converts this 64-bit word array to a 32-bit word array.
		         *
		         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
		         *
		         * @example
		         *
		         *     var x32WordArray = x64WordArray.toX32();
		         */toX32:function toX32(){// Shortcuts
	var x64Words=this.words;var x64WordsLength=x64Words.length;// Convert
	var x32Words=[];for(var i=0;i<x64WordsLength;i++){var x64Word=x64Words[i];x32Words.push(x64Word.high);x32Words.push(x64Word.low);}return X32WordArray.create(x32Words,this.sigBytes);},/**
		         * Creates a copy of this word array.
		         *
		         * @return {X64WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = x64WordArray.clone();
		         */clone:function clone(){var clone=Base.clone.call(this);// Clone "words" array
	var words=clone.words=this.words.slice(0);// Clone each X64Word object
	var wordsLength=words.length;for(var i=0;i<wordsLength;i++){words[i]=words[i].clone();}return clone;}});})();return CryptoJS;});},{"./core":41}],73:[function(require,module,exports){/**
	 * event-lite.js - Light-weight EventEmitter (less than 1KB when gzipped)
	 *
	 * @copyright Yusuke Kawasaki
	 * @license MIT
	 * @constructor
	 * @see https://github.com/kawanet/event-lite
	 * @see http://kawanet.github.io/event-lite/EventLite.html
	 * @example
	 * var EventLite = require("event-lite");
	 *
	 * function MyClass() {...}             // your class
	 *
	 * EventLite.mixin(MyClass.prototype);  // import event methods
	 *
	 * var obj = new MyClass();
	 * obj.on("foo", function() {...});     // add event listener
	 * obj.once("bar", function() {...});   // add one-time event listener
	 * obj.emit("foo");                     // dispatch event
	 * obj.emit("bar");                     // dispatch another event
	 * obj.off("foo");                      // remove event listener
	 */function EventLite(){if(!(this instanceof EventLite))return new EventLite();}(function(EventLite){// export the class for node.js
	if("undefined"!==typeof module)module.exports=EventLite;// property name to hold listeners
	var LISTENERS="listeners";// methods to export
	var methods={on:on,once:once,off:off,emit:emit};// mixin to self
	mixin(EventLite.prototype);// export mixin function
	EventLite.mixin=mixin;/**
	   * Import on(), once(), off() and emit() methods into target object.
	   *
	   * @function EventLite.mixin
	   * @param target {Prototype}
	   */function mixin(target){for(var key in methods){target[key]=methods[key];}return target;}/**
	   * Add an event listener.
	   *
	   * @function EventLite.prototype.on
	   * @param type {string}
	   * @param func {Function}
	   * @returns {EventLite} Self for method chaining
	   */function on(type,func){getListeners(this,type).push(func);return this;}/**
	   * Add one-time event listener.
	   *
	   * @function EventLite.prototype.once
	   * @param type {string}
	   * @param func {Function}
	   * @returns {EventLite} Self for method chaining
	   */function once(type,func){var that=this;wrap.originalListener=func;getListeners(that,type).push(wrap);return that;function wrap(){off.call(that,type,wrap);func.apply(this,arguments);}}/**
	   * Remove an event listener.
	   *
	   * @function EventLite.prototype.off
	   * @param [type] {string}
	   * @param [func] {Function}
	   * @returns {EventLite} Self for method chaining
	   */function off(type,func){var that=this;var listners;if(!arguments.length){delete that[LISTENERS];}else if(!func){listners=that[LISTENERS];if(listners){delete listners[type];if(!Object.keys(listners).length)return off.call(that);}}else{listners=getListeners(that,type,true);if(listners){listners=listners.filter(ne);if(!listners.length)return off.call(that,type);that[LISTENERS][type]=listners;}}return that;function ne(test){return test!==func&&test.originalListener!==func;}}/**
	   * Dispatch (trigger) an event.
	   *
	   * @function EventLite.prototype.emit
	   * @param type {string}
	   * @param [value] {*}
	   * @returns {boolean} True when a listener received the event
	   */function emit(type,value){var that=this;var listeners=getListeners(that,type,true);if(!listeners)return false;var arglen=arguments.length;if(arglen===1){listeners.forEach(zeroarg);}else if(arglen===2){listeners.forEach(onearg);}else{var args=Array.prototype.slice.call(arguments,1);listeners.forEach(moreargs);}return!!listeners.length;function zeroarg(func){func.call(that);}function onearg(func){func.call(that,value);}function moreargs(func){func.apply(that,args);}}/**
	   * @ignore
	   */function getListeners(that,type,readonly){if(readonly&&!that[LISTENERS])return;var listeners=that[LISTENERS]||(that[LISTENERS]={});return listeners[type]||(listeners[type]=[]);}})(EventLite);},{}],74:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	function EventEmitter(){this._events=this._events||{};this._maxListeners=this._maxListeners||undefined;}module.exports=EventEmitter;// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._maxListeners=undefined;// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners=10;// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||n<0||isNaN(n))throw TypeError('n must be a positive number');this._maxListeners=n;return this;};EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(!this._events)this._events={};// If there is no 'error' event listener then throw.
	if(type==='error'){if(!this._events.error||isObject(this._events.error)&&!this._events.error.length){er=arguments[1];if(er instanceof Error){throw er;// Unhandled 'error' event
	}else{// At least give some kind of context to the user
	var err=new Error('Uncaught, unspecified "error" event. ('+er+')');err.context=er;throw err;}}}handler=this._events[type];if(isUndefined(handler))return false;if(isFunction(handler)){switch(arguments.length){// fast cases
	case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;// slower
	default:args=Array.prototype.slice.call(arguments,1);handler.apply(this,args);}}else if(isObject(handler)){args=Array.prototype.slice.call(arguments,1);listeners=handler.slice();len=listeners.length;for(i=0;i<len;i++){listeners[i].apply(this,args);}}return true;};EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError('listener must be a function');if(!this._events)this._events={};// To avoid recursion in the case that type === "newListener"! Before
	// adding it to the listeners, first emit "newListener".
	if(this._events.newListener)this.emit('newListener',type,isFunction(listener.listener)?listener.listener:listener);if(!this._events[type])// Optimize the case of one listener. Don't need the extra array object.
	this._events[type]=listener;else if(isObject(this._events[type]))// If we've already got an array, just append.
	this._events[type].push(listener);else// Adding the second element, need to change to array.
	this._events[type]=[this._events[type],listener];// Check for listener leak
	if(isObject(this._events[type])&&!this._events[type].warned){if(!isUndefined(this._maxListeners)){m=this._maxListeners;}else{m=EventEmitter.defaultMaxListeners;}if(m&&m>0&&this._events[type].length>m){this._events[type].warned=true;console.error('(node) warning: possible EventEmitter memory '+'leak detected. %d listeners added. '+'Use emitter.setMaxListeners() to increase limit.',this._events[type].length);if(typeof console.trace==='function'){// not supported in IE 10
	console.trace();}}}return this;};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.once=function(type,listener){if(!isFunction(listener))throw TypeError('listener must be a function');var fired=false;function g(){this.removeListener(type,g);if(!fired){fired=true;listener.apply(this,arguments);}}g.listener=listener;this.on(type,g);return this;};// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError('listener must be a function');if(!this._events||!this._events[type])return this;list=this._events[type];length=list.length;position=-1;if(list===listener||isFunction(list.listener)&&list.listener===listener){delete this._events[type];if(this._events.removeListener)this.emit('removeListener',type,listener);}else if(isObject(list)){for(i=length;i-->0;){if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break;}}if(position<0)return this;if(list.length===1){list.length=0;delete this._events[type];}else{list.splice(position,1);}if(this._events.removeListener)this.emit('removeListener',type,listener);}return this;};EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;// not listening for removeListener, no need to emit
	if(!this._events.removeListener){if(arguments.length===0)this._events={};else if(this._events[type])delete this._events[type];return this;}// emit removeListener for all listeners on all events
	if(arguments.length===0){for(key in this._events){if(key==='removeListener')continue;this.removeAllListeners(key);}this.removeAllListeners('removeListener');this._events={};return this;}listeners=this._events[type];if(isFunction(listeners)){this.removeListener(type,listeners);}else if(listeners){// LIFO order
	while(listeners.length){this.removeListener(type,listeners[listeners.length-1]);}}delete this._events[type];return this;};EventEmitter.prototype.listeners=function(type){var ret;if(!this._events||!this._events[type])ret=[];else if(isFunction(this._events[type]))ret=[this._events[type]];else ret=this._events[type].slice();return ret;};EventEmitter.prototype.listenerCount=function(type){if(this._events){var evlistener=this._events[type];if(isFunction(evlistener))return 1;else if(evlistener)return evlistener.length;}return 0;};EventEmitter.listenerCount=function(emitter,type){return emitter.listenerCount(type);};function isFunction(arg){return typeof arg==='function';}function isNumber(arg){return typeof arg==='number';}function isObject(arg){return(typeof arg==="undefined"?"undefined":_typeof(arg))==='object'&&arg!==null;}function isUndefined(arg){return arg===void 0;}},{}],75:[function(require,module,exports){exports.read=function(buffer,offset,isLE,mLen,nBytes){var e,m;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var nBits=-7;var i=isLE?nBytes-1:0;var d=isLE?-1:1;var s=buffer[offset+i];i+=d;e=s&(1<<-nBits)-1;s>>=-nBits;nBits+=eLen;for(;nBits>0;e=e*256+buffer[offset+i],i+=d,nBits-=8){}m=e&(1<<-nBits)-1;e>>=-nBits;nBits+=mLen;for(;nBits>0;m=m*256+buffer[offset+i],i+=d,nBits-=8){}if(e===0){e=1-eBias;}else if(e===eMax){return m?NaN:(s?-1:1)*Infinity;}else{m=m+Math.pow(2,mLen);e=e-eBias;}return(s?-1:1)*m*Math.pow(2,e-mLen);};exports.write=function(buffer,value,offset,isLE,mLen,nBytes){var e,m,c;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var rt=mLen===23?Math.pow(2,-24)-Math.pow(2,-77):0;var i=isLE?0:nBytes-1;var d=isLE?1:-1;var s=value<0||value===0&&1/value<0?1:0;value=Math.abs(value);if(isNaN(value)||value===Infinity){m=isNaN(value)?1:0;e=eMax;}else{e=Math.floor(Math.log(value)/Math.LN2);if(value*(c=Math.pow(2,-e))<1){e--;c*=2;}if(e+eBias>=1){value+=rt/c;}else{value+=rt*Math.pow(2,1-eBias);}if(value*c>=2){e++;c/=2;}if(e+eBias>=eMax){m=0;e=eMax;}else if(e+eBias>=1){m=(value*c-1)*Math.pow(2,mLen);e=e+eBias;}else{m=value*Math.pow(2,eBias-1)*Math.pow(2,mLen);e=0;}}for(;mLen>=8;buffer[offset+i]=m&0xff,i+=d,m/=256,mLen-=8){}e=e<<mLen|m;eLen+=mLen;for(;eLen>0;buffer[offset+i]=e&0xff,i+=d,e/=256,eLen-=8){}buffer[offset+i-d]|=s*128;};},{}],76:[function(require,module,exports){if(typeof Object.create==='function'){// implementation from standard node.js 'util' module
	module.exports=function inherits(ctor,superCtor){ctor.super_=superCtor;ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:false,writable:true,configurable:true}});};}else{// old school shim for old browsers
	module.exports=function inherits(ctor,superCtor){ctor.super_=superCtor;var TempCtor=function TempCtor(){};TempCtor.prototype=superCtor.prototype;ctor.prototype=new TempCtor();ctor.prototype.constructor=ctor;};}},{}],77:[function(require,module,exports){(function(Buffer){// int64-buffer.js
	/*jshint -W018 */// Confusing use of '!'.
	/*jshint -W030 */// Expected an assignment or function call and instead saw an expression.
	/*jshint -W093 */// Did you mean to return a conditional instead of an assignment?
	var Uint64BE,Int64BE,Uint64LE,Int64LE;!function(exports){// constants
	var UNDEFINED="undefined";var BUFFER=UNDEFINED!==(typeof Buffer==="undefined"?"undefined":_typeof(Buffer))&&Buffer;var UINT8ARRAY=UNDEFINED!==(typeof Uint8Array==="undefined"?"undefined":_typeof(Uint8Array))&&Uint8Array;var ARRAYBUFFER=UNDEFINED!==(typeof ArrayBuffer==="undefined"?"undefined":_typeof(ArrayBuffer))&&ArrayBuffer;var ZERO=[0,0,0,0,0,0,0,0];var isArray=Array.isArray||_isArray;var BIT32=4294967296;var BIT24=16777216;// storage class
	var storage;// Array;
	// generate classes
	Uint64BE=factory("Uint64BE",true,true);Int64BE=factory("Int64BE",true,false);Uint64LE=factory("Uint64LE",false,true);Int64LE=factory("Int64LE",false,false);// class factory
	function factory(name,bigendian,unsigned){var posH=bigendian?0:4;var posL=bigendian?4:0;var pos0=bigendian?0:3;var pos1=bigendian?1:2;var pos2=bigendian?2:1;var pos3=bigendian?3:0;var fromPositive=bigendian?fromPositiveBE:fromPositiveLE;var fromNegative=bigendian?fromNegativeBE:fromNegativeLE;var proto=Int64.prototype;var isName="is"+name;var _isInt64="_"+isName;// properties
	proto.buffer=void 0;proto.offset=0;proto[_isInt64]=true;// methods
	proto.toNumber=toNumber;proto.toString=toString;proto.toJSON=toNumber;proto.toArray=toArray;// add .toBuffer() method only when Buffer available
	if(BUFFER)proto.toBuffer=toBuffer;// add .toArrayBuffer() method only when Uint8Array available
	if(UINT8ARRAY)proto.toArrayBuffer=toArrayBuffer;// isUint64BE, isInt64BE
	Int64[isName]=isInt64;// CommonJS
	exports[name]=Int64;return Int64;// constructor
	function Int64(buffer,offset,value,raddix){if(!(this instanceof Int64))return new Int64(buffer,offset,value,raddix);return init(this,buffer,offset,value,raddix);}// isUint64BE, isInt64BE
	function isInt64(b){return!!(b&&b[_isInt64]);}// initializer
	function init(that,buffer,offset,value,raddix){if(UINT8ARRAY&&ARRAYBUFFER){if(buffer instanceof ARRAYBUFFER)buffer=new UINT8ARRAY(buffer);if(value instanceof ARRAYBUFFER)value=new UINT8ARRAY(value);}// Int64BE() style
	if(!buffer&&!offset&&!value&&!storage){// shortcut to initialize with zero
	that.buffer=newArray(ZERO,0);return;}// Int64BE(value, raddix) style
	if(!isValidBuffer(buffer,offset)){var _storage=storage||Array;raddix=offset;value=buffer;offset=0;buffer=new _storage(8);}that.buffer=buffer;that.offset=offset|=0;// Int64BE(buffer, offset) style
	if(UNDEFINED===(typeof value==="undefined"?"undefined":_typeof(value)))return;// Int64BE(buffer, offset, value, raddix) style
	if("string"===typeof value){fromString(buffer,offset,value,raddix||10);}else if(isValidBuffer(value,raddix)){fromArray(buffer,offset,value,raddix);}else if("number"===typeof raddix){writeInt32(buffer,offset+posH,value);// high
	writeInt32(buffer,offset+posL,raddix);// low
	}else if(value>0){fromPositive(buffer,offset,value);// positive
	}else if(value<0){fromNegative(buffer,offset,value);// negative
	}else{fromArray(buffer,offset,ZERO,0);// zero, NaN and others
	}}function fromString(buffer,offset,str,raddix){var pos=0;var len=str.length;var high=0;var low=0;if(str[0]==="-")pos++;var sign=pos;while(pos<len){var chr=parseInt(str[pos++],raddix);if(!(chr>=0))break;// NaN
	low=low*raddix+chr;high=high*raddix+Math.floor(low/BIT32);low%=BIT32;}if(sign){high=~high;if(low){low=BIT32-low;}else{high++;}}writeInt32(buffer,offset+posH,high);writeInt32(buffer,offset+posL,low);}function toNumber(){var buffer=this.buffer;var offset=this.offset;var high=readInt32(buffer,offset+posH);var low=readInt32(buffer,offset+posL);if(!unsigned)high|=0;// a trick to get signed
	return high?high*BIT32+low:low;}function toString(radix){var buffer=this.buffer;var offset=this.offset;var high=readInt32(buffer,offset+posH);var low=readInt32(buffer,offset+posL);var str="";var sign=!unsigned&&high&0x80000000;if(sign){high=~high;low=BIT32-low;}radix=radix||10;while(1){var mod=high%radix*BIT32+low;high=Math.floor(high/radix);low=Math.floor(mod/radix);str=(mod%radix).toString(radix)+str;if(!high&&!low)break;}if(sign){str="-"+str;}return str;}function writeInt32(buffer,offset,value){buffer[offset+pos3]=value&255;value=value>>8;buffer[offset+pos2]=value&255;value=value>>8;buffer[offset+pos1]=value&255;value=value>>8;buffer[offset+pos0]=value&255;}function readInt32(buffer,offset){return buffer[offset+pos0]*BIT24+(buffer[offset+pos1]<<16)+(buffer[offset+pos2]<<8)+buffer[offset+pos3];}}function toArray(raw){var buffer=this.buffer;var offset=this.offset;storage=null;// Array
	if(raw!==false&&offset===0&&buffer.length===8&&isArray(buffer))return buffer;return newArray(buffer,offset);}function toBuffer(raw){var buffer=this.buffer;var offset=this.offset;storage=BUFFER;if(raw!==false&&offset===0&&buffer.length===8&&Buffer.isBuffer(buffer))return buffer;var dest=new BUFFER(8);fromArray(dest,0,buffer,offset);return dest;}function toArrayBuffer(raw){var buffer=this.buffer;var offset=this.offset;var arrbuf=buffer.buffer;storage=UINT8ARRAY;if(raw!==false&&offset===0&&arrbuf instanceof ARRAYBUFFER&&arrbuf.byteLength===8)return arrbuf;var dest=new UINT8ARRAY(8);fromArray(dest,0,buffer,offset);return dest.buffer;}function isValidBuffer(buffer,offset){var len=buffer&&buffer.length;offset|=0;return len&&offset+8<=len&&"string"!==typeof buffer[offset];}function fromArray(destbuf,destoff,srcbuf,srcoff){destoff|=0;srcoff|=0;for(var i=0;i<8;i++){destbuf[destoff++]=srcbuf[srcoff++]&255;}}function newArray(buffer,offset){return Array.prototype.slice.call(buffer,offset,offset+8);}function fromPositiveBE(buffer,offset,value){var pos=offset+8;while(pos>offset){buffer[--pos]=value&255;value/=256;}}function fromNegativeBE(buffer,offset,value){var pos=offset+8;value++;while(pos>offset){buffer[--pos]=-value&255^255;value/=256;}}function fromPositiveLE(buffer,offset,value){var end=offset+8;while(offset<end){buffer[offset++]=value&255;value/=256;}}function fromNegativeLE(buffer,offset,value){var end=offset+8;value++;while(offset<end){buffer[offset++]=-value&255^255;value/=256;}}// https://github.com/retrofox/is-array
	function _isArray(val){return!!val&&"[object Array]"==Object.prototype.toString.call(val);}}((typeof exports==="undefined"?"undefined":_typeof(exports))==='object'&&typeof exports.nodeName!=='string'?exports:this||{});}).call(this,require("buffer").Buffer);},{"buffer":27}],78:[function(require,module,exports){/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports=function(obj){return obj!=null&&(isBuffer(obj)||isSlowBuffer(obj)||!!obj._isBuffer);};function isBuffer(obj){return!!obj.constructor&&typeof obj.constructor.isBuffer==='function'&&obj.constructor.isBuffer(obj);}// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer(obj){return typeof obj.readFloatLE==='function'&&typeof obj.slice==='function'&&isBuffer(obj.slice(0,0));}},{}],79:[function(require,module,exports){var toString={}.toString;module.exports=Array.isArray||function(arr){return toString.call(arr)=='[object Array]';};},{}],80:[function(require,module,exports){// browser.js
	exports.encode=require("./encode").encode;exports.decode=require("./decode").decode;exports.Encoder=require("./encoder").Encoder;exports.Decoder=require("./decoder").Decoder;exports.createCodec=require("./ext").createCodec;exports.codec=require("./codec").codec;},{"./codec":89,"./decode":91,"./decoder":92,"./encode":94,"./encoder":95,"./ext":99}],81:[function(require,module,exports){(function(Buffer){/* globals Buffer */module.exports=c("undefined"!==typeof Buffer&&Buffer)||c(this.Buffer)||c("undefined"!==typeof window&&window.Buffer)||this.Buffer;function c(B){return B&&B.isBuffer&&B;}}).call(this,require("buffer").Buffer);},{"buffer":27}],82:[function(require,module,exports){// buffer-lite.js
	var MAXBUFLEN=8192;exports.copy=copy;exports.toString=toString;exports.write=write;/**
	 * Buffer.prototype.write()
	 *
	 * @param string {String}
	 * @param [offset] {Number}
	 * @returns {Number}
	 */function write(string,offset){var buffer=this;var index=offset||(offset|=0);var length=string.length;var chr=0;var i=0;while(i<length){chr=string.charCodeAt(i++);if(chr<128){buffer[index++]=chr;}else if(chr<0x800){// 2 bytes
	buffer[index++]=0xC0|chr>>>6;buffer[index++]=0x80|chr&0x3F;}else if(chr<0xD800||chr>0xDFFF){// 3 bytes
	buffer[index++]=0xE0|chr>>>12;buffer[index++]=0x80|chr>>>6&0x3F;buffer[index++]=0x80|chr&0x3F;}else{// 4 bytes - surrogate pair
	chr=(chr-0xD800<<10|string.charCodeAt(i++)-0xDC00)+0x10000;buffer[index++]=0xF0|chr>>>18;buffer[index++]=0x80|chr>>>12&0x3F;buffer[index++]=0x80|chr>>>6&0x3F;buffer[index++]=0x80|chr&0x3F;}}return index-offset;}/**
	 * Buffer.prototype.toString()
	 *
	 * @param [encoding] {String} ignored
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {String}
	 */function toString(encoding,start,end){var buffer=this;var index=start|0;if(!end)end=buffer.length;var string='';var chr=0;while(index<end){chr=buffer[index++];if(chr<128){string+=String.fromCharCode(chr);continue;}if((chr&0xE0)===0xC0){// 2 bytes
	chr=(chr&0x1F)<<6|buffer[index++]&0x3F;}else if((chr&0xF0)===0xE0){// 3 bytes
	chr=(chr&0x0F)<<12|(buffer[index++]&0x3F)<<6|buffer[index++]&0x3F;}else if((chr&0xF8)===0xF0){// 4 bytes
	chr=(chr&0x07)<<18|(buffer[index++]&0x3F)<<12|(buffer[index++]&0x3F)<<6|buffer[index++]&0x3F;}if(chr>=0x010000){// A surrogate pair
	chr-=0x010000;string+=String.fromCharCode((chr>>>10)+0xD800,(chr&0x3FF)+0xDC00);}else{string+=String.fromCharCode(chr);}}return string;}/**
	 * Buffer.prototype.copy()
	 *
	 * @param target {Buffer}
	 * @param [targetStart] {Number}
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {number}
	 */function copy(target,targetStart,start,end){var i;if(!start)start=0;if(!end&&end!==0)end=this.length;if(!targetStart)targetStart=0;var len=end-start;if(target===this&&start<targetStart&&targetStart<end){// descending
	for(i=len-1;i>=0;i--){target[i+targetStart]=this[i+start];}}else{// ascending
	for(i=0;i<len;i++){target[i+targetStart]=this[i+start];}}return len;}},{}],83:[function(require,module,exports){// bufferish-array.js
	var Bufferish=require("./bufferish");var exports=module.exports=alloc(0);exports.alloc=alloc;exports.concat=Bufferish.concat;exports.from=from;/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */function alloc(size){return new Array(size);}/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Array}
	 */function from(value){if(!Bufferish.isBuffer(value)&&Bufferish.isView(value)){// TypedArray to Uint8Array
	value=Bufferish.Uint8Array.from(value);}else if(Bufferish.isArrayBuffer(value)){// ArrayBuffer to Uint8Array
	value=new Uint8Array(value);}else if(typeof value==="string"){// String to Array
	return Bufferish.from.call(exports,value);}else if(typeof value==="number"){throw new TypeError('"value" argument must not be a number');}// Array-like to Array
	return Array.prototype.slice.call(value);}},{"./bufferish":87}],84:[function(require,module,exports){// bufferish-buffer.js
	var Bufferish=require("./bufferish");var Buffer=Bufferish.global;var exports=module.exports=Bufferish.hasBuffer?alloc(0):[];exports.alloc=Bufferish.hasBuffer&&Buffer.alloc||alloc;exports.concat=Bufferish.concat;exports.from=from;/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */function alloc(size){return new Buffer(size);}/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Buffer}
	 */function from(value){if(!Bufferish.isBuffer(value)&&Bufferish.isView(value)){// TypedArray to Uint8Array
	value=Bufferish.Uint8Array.from(value);}else if(Bufferish.isArrayBuffer(value)){// ArrayBuffer to Uint8Array
	value=new Uint8Array(value);}else if(typeof value==="string"){// String to Buffer
	return Bufferish.from.call(exports,value);}else if(typeof value==="number"){throw new TypeError('"value" argument must not be a number');}// Array-like to Buffer
	if(Buffer.from&&Buffer.from.length!==1){return Buffer.from(value);// node v6+
	}else{return new Buffer(value);// node v4
	}}},{"./bufferish":87}],85:[function(require,module,exports){// bufferish-proto.js
	/* jshint eqnull:true */var BufferLite=require("./buffer-lite");exports.copy=copy;exports.slice=slice;exports.toString=toString;exports.write=gen("write");var Bufferish=require("./bufferish");var Buffer=Bufferish.global;var isBufferShim=Bufferish.hasBuffer&&"TYPED_ARRAY_SUPPORT"in Buffer;var brokenTypedArray=isBufferShim&&!Buffer.TYPED_ARRAY_SUPPORT;/**
	 * @param target {Buffer|Uint8Array|Array}
	 * @param [targetStart] {Number}
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */function copy(target,targetStart,start,end){var thisIsBuffer=Bufferish.isBuffer(this);var targetIsBuffer=Bufferish.isBuffer(target);if(thisIsBuffer&&targetIsBuffer){// Buffer to Buffer
	return this.copy(target,targetStart,start,end);}else if(!brokenTypedArray&&!thisIsBuffer&&!targetIsBuffer&&Bufferish.isView(this)&&Bufferish.isView(target)){// Uint8Array to Uint8Array (except for minor some browsers)
	var buffer=start||end!=null?slice.call(this,start,end):this;target.set(buffer,targetStart);return buffer.length;}else{// other cases
	return BufferLite.copy.call(this,target,targetStart,start,end);}}/**
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */function slice(start,end){// for Buffer, Uint8Array (except for minor some browsers) and Array
	var f=this.slice||!brokenTypedArray&&this.subarray;if(f)return f.call(this,start,end);// Uint8Array (for minor some browsers)
	var target=Bufferish.alloc.call(this,end-start);copy.call(this,target,0,start,end);return target;}/**
	 * Buffer.prototype.toString()
	 *
	 * @param [encoding] {String} ignored
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {String}
	 */function toString(encoding,start,end){var f=!isBufferShim&&Bufferish.isBuffer(this)?this.toString:BufferLite.toString;return f.apply(this,arguments);}/**
	 * @private
	 */function gen(method){return wrap;function wrap(){var f=this[method]||BufferLite[method];return f.apply(this,arguments);}}},{"./buffer-lite":82,"./bufferish":87}],86:[function(require,module,exports){// bufferish-uint8array.js
	var Bufferish=require("./bufferish");var exports=module.exports=Bufferish.hasArrayBuffer?alloc(0):[];exports.alloc=alloc;exports.concat=Bufferish.concat;exports.from=from;/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */function alloc(size){return new Uint8Array(size);}/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Uint8Array}
	 */function from(value){if(Bufferish.isView(value)){// TypedArray to ArrayBuffer
	var byteOffset=value.byteOffset;var byteLength=value.byteLength;value=value.buffer;if(value.byteLength!==byteLength){if(value.slice){value=value.slice(byteOffset,byteOffset+byteLength);}else{// Android 4.1 does not have ArrayBuffer.prototype.slice
	value=new Uint8Array(value);if(value.byteLength!==byteLength){// TypedArray to ArrayBuffer to Uint8Array to Array
	value=Array.prototype.slice.call(value,byteOffset,byteOffset+byteLength);}}}}else if(typeof value==="string"){// String to Uint8Array
	return Bufferish.from.call(exports,value);}else if(typeof value==="number"){throw new TypeError('"value" argument must not be a number');}return new Uint8Array(value);}},{"./bufferish":87}],87:[function(require,module,exports){// bufferish.js
	var Buffer=exports.global=require("./buffer-global");var hasBuffer=exports.hasBuffer=Buffer&&!!Buffer.isBuffer;var hasArrayBuffer=exports.hasArrayBuffer="undefined"!==typeof ArrayBuffer;var isArray=exports.isArray=require("isarray");exports.isArrayBuffer=hasArrayBuffer?isArrayBuffer:_false;var isBuffer=exports.isBuffer=hasBuffer?Buffer.isBuffer:_false;var isView=exports.isView=hasArrayBuffer?ArrayBuffer.isView||_is("ArrayBuffer","buffer"):_false;exports.alloc=alloc;exports.concat=concat;exports.from=from;var BufferArray=exports.Array=require("./bufferish-array");var BufferBuffer=exports.Buffer=require("./bufferish-buffer");var BufferUint8Array=exports.Uint8Array=require("./bufferish-uint8array");var BufferProto=exports.prototype=require("./bufferish-proto");/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Buffer|Uint8Array|Array}
	 */function from(value){if(typeof value==="string"){return fromString.call(this,value);}else{return auto(this).from(value);}}/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */function alloc(size){return auto(this).alloc(size);}/**
	 * @param list {Array} array of (Buffer|Uint8Array|Array)s
	 * @param [length]
	 * @returns {Buffer|Uint8Array|Array}
	 */function concat(list,length){if(!length){length=0;Array.prototype.forEach.call(list,dryrun);}var ref=this!==exports&&this||list[0];var result=alloc.call(ref,length);var offset=0;Array.prototype.forEach.call(list,append);return result;function dryrun(buffer){length+=buffer.length;}function append(buffer){offset+=BufferProto.copy.call(buffer,result,offset);}}var _isArrayBuffer=_is("ArrayBuffer");function isArrayBuffer(value){return value instanceof ArrayBuffer||_isArrayBuffer(value);}/**
	 * @private
	 */function fromString(value){var expected=value.length*3;var that=alloc.call(this,expected);var actual=BufferProto.write.call(that,value);if(expected!==actual){that=BufferProto.slice.call(that,0,actual);}return that;}function auto(that){return isBuffer(that)?BufferBuffer:isView(that)?BufferUint8Array:isArray(that)?BufferArray:hasBuffer?BufferBuffer:hasArrayBuffer?BufferUint8Array:BufferArray;}function _false(){return false;}function _is(name,key){/* jshint eqnull:true */name="[object "+name+"]";return function(value){return value!=null&&{}.toString.call(key?value[key]:value)===name;};}},{"./buffer-global":81,"./bufferish-array":83,"./bufferish-buffer":84,"./bufferish-proto":85,"./bufferish-uint8array":86,"isarray":79}],88:[function(require,module,exports){// codec-base.js
	var IS_ARRAY=require("isarray");exports.createCodec=createCodec;exports.install=install;exports.filter=filter;var Bufferish=require("./bufferish");function Codec(options){if(!(this instanceof Codec))return new Codec(options);this.options=options;this.init();}Codec.prototype.init=function(){var options=this.options;if(options&&options.uint8array){this.bufferish=Bufferish.Uint8Array;}return this;};function install(props){for(var key in props){Codec.prototype[key]=add(Codec.prototype[key],props[key]);}}function add(a,b){return a&&b?ab:a||b;function ab(){a.apply(this,arguments);return b.apply(this,arguments);}}function join(filters){filters=filters.slice();return function(value){return filters.reduce(iterator,value);};function iterator(value,filter){return filter(value);}}function filter(filter){return IS_ARRAY(filter)?join(filter):filter;}// @public
	// msgpack.createCodec()
	function createCodec(options){return new Codec(options);}// default shared codec
	exports.preset=createCodec({preset:true});},{"./bufferish":87,"isarray":79}],89:[function(require,module,exports){// codec.js
	// load both interfaces
	require("./read-core");require("./write-core");// @public
	// msgpack.codec.preset
	exports.codec={preset:require("./codec-base").preset};},{"./codec-base":88,"./read-core":101,"./write-core":104}],90:[function(require,module,exports){// decode-buffer.js
	exports.DecodeBuffer=DecodeBuffer;var preset=require("./read-core").preset;var FlexDecoder=require("./flex-buffer").FlexDecoder;FlexDecoder.mixin(DecodeBuffer.prototype);function DecodeBuffer(options){if(!(this instanceof DecodeBuffer))return new DecodeBuffer(options);if(options){this.options=options;if(options.codec){var codec=this.codec=options.codec;if(codec.bufferish)this.bufferish=codec.bufferish;}}}DecodeBuffer.prototype.codec=preset;DecodeBuffer.prototype.fetch=function(){return this.codec.decode(this);};},{"./flex-buffer":100,"./read-core":101}],91:[function(require,module,exports){// decode.js
	exports.decode=decode;var DecodeBuffer=require("./decode-buffer").DecodeBuffer;function decode(input,options){var decoder=new DecodeBuffer(options);decoder.write(input);return decoder.read();}},{"./decode-buffer":90}],92:[function(require,module,exports){// decoder.js
	exports.Decoder=Decoder;var EventLite=require("event-lite");var DecodeBuffer=require("./decode-buffer").DecodeBuffer;function Decoder(options){if(!(this instanceof Decoder))return new Decoder(options);DecodeBuffer.call(this,options);}Decoder.prototype=new DecodeBuffer();EventLite.mixin(Decoder.prototype);Decoder.prototype.decode=function(chunk){if(arguments.length)this.write(chunk);this.flush();};Decoder.prototype.push=function(chunk){this.emit("data",chunk);};Decoder.prototype.end=function(chunk){this.decode(chunk);this.emit("end");};},{"./decode-buffer":90,"event-lite":73}],93:[function(require,module,exports){// encode-buffer.js
	exports.EncodeBuffer=EncodeBuffer;var preset=require("./write-core").preset;var FlexEncoder=require("./flex-buffer").FlexEncoder;FlexEncoder.mixin(EncodeBuffer.prototype);function EncodeBuffer(options){if(!(this instanceof EncodeBuffer))return new EncodeBuffer(options);if(options){this.options=options;if(options.codec){var codec=this.codec=options.codec;if(codec.bufferish)this.bufferish=codec.bufferish;}}}EncodeBuffer.prototype.codec=preset;EncodeBuffer.prototype.write=function(input){this.codec.encode(this,input);};},{"./flex-buffer":100,"./write-core":104}],94:[function(require,module,exports){// encode.js
	exports.encode=encode;var EncodeBuffer=require("./encode-buffer").EncodeBuffer;function encode(input,options){var encoder=new EncodeBuffer(options);encoder.write(input);return encoder.read();}},{"./encode-buffer":93}],95:[function(require,module,exports){// encoder.js
	exports.Encoder=Encoder;var EventLite=require("event-lite");var EncodeBuffer=require("./encode-buffer").EncodeBuffer;function Encoder(options){if(!(this instanceof Encoder))return new Encoder(options);EncodeBuffer.call(this,options);}Encoder.prototype=new EncodeBuffer();EventLite.mixin(Encoder.prototype);Encoder.prototype.encode=function(chunk){this.write(chunk);this.emit("data",this.read());};Encoder.prototype.end=function(chunk){if(arguments.length)this.encode(chunk);this.flush();this.emit("end");};},{"./encode-buffer":93,"event-lite":73}],96:[function(require,module,exports){// ext-buffer.js
	exports.ExtBuffer=ExtBuffer;var Bufferish=require("./bufferish");function ExtBuffer(buffer,type){if(!(this instanceof ExtBuffer))return new ExtBuffer(buffer,type);this.buffer=Bufferish.from(buffer);this.type=type;}},{"./bufferish":87}],97:[function(require,module,exports){// ext-packer.js
	exports.setExtPackers=setExtPackers;var Bufferish=require("./bufferish");var Buffer=Bufferish.global;var packTypedArray=Bufferish.Uint8Array.from;var _encode;var ERROR_COLUMNS={name:1,message:1,stack:1,columnNumber:1,fileName:1,lineNumber:1};function setExtPackers(codec){codec.addExtPacker(0x0E,Error,[packError,encode]);codec.addExtPacker(0x01,EvalError,[packError,encode]);codec.addExtPacker(0x02,RangeError,[packError,encode]);codec.addExtPacker(0x03,ReferenceError,[packError,encode]);codec.addExtPacker(0x04,SyntaxError,[packError,encode]);codec.addExtPacker(0x05,TypeError,[packError,encode]);codec.addExtPacker(0x06,URIError,[packError,encode]);codec.addExtPacker(0x0A,RegExp,[packRegExp,encode]);codec.addExtPacker(0x0B,Boolean,[packValueOf,encode]);codec.addExtPacker(0x0C,String,[packValueOf,encode]);codec.addExtPacker(0x0D,Date,[Number,encode]);codec.addExtPacker(0x0F,Number,[packValueOf,encode]);if("undefined"!==typeof Uint8Array){codec.addExtPacker(0x11,Int8Array,packTypedArray);codec.addExtPacker(0x12,Uint8Array,packTypedArray);codec.addExtPacker(0x13,Int16Array,packTypedArray);codec.addExtPacker(0x14,Uint16Array,packTypedArray);codec.addExtPacker(0x15,Int32Array,packTypedArray);codec.addExtPacker(0x16,Uint32Array,packTypedArray);codec.addExtPacker(0x17,Float32Array,packTypedArray);// PhantomJS/1.9.7 doesn't have Float64Array
	if("undefined"!==typeof Float64Array){codec.addExtPacker(0x18,Float64Array,packTypedArray);}// IE10 doesn't have Uint8ClampedArray
	if("undefined"!==typeof Uint8ClampedArray){codec.addExtPacker(0x19,Uint8ClampedArray,packTypedArray);}codec.addExtPacker(0x1A,ArrayBuffer,packTypedArray);codec.addExtPacker(0x1D,DataView,packTypedArray);}if(Bufferish.hasBuffer){codec.addExtPacker(0x1B,Buffer,Bufferish.from);}}function encode(input){if(!_encode)_encode=require("./encode").encode;// lazy load
	return _encode(input);}function packValueOf(value){return value.valueOf();}function packRegExp(value){value=RegExp.prototype.toString.call(value).split("/");value.shift();var out=[value.pop()];out.unshift(value.join("/"));return out;}function packError(value){var out={};for(var key in ERROR_COLUMNS){out[key]=value[key];}return out;}},{"./bufferish":87,"./encode":94}],98:[function(require,module,exports){// ext-unpacker.js
	exports.setExtUnpackers=setExtUnpackers;var Bufferish=require("./bufferish");var Buffer=Bufferish.global;var _decode;var ERROR_COLUMNS={name:1,message:1,stack:1,columnNumber:1,fileName:1,lineNumber:1};function setExtUnpackers(codec){codec.addExtUnpacker(0x0E,[decode,unpackError(Error)]);codec.addExtUnpacker(0x01,[decode,unpackError(EvalError)]);codec.addExtUnpacker(0x02,[decode,unpackError(RangeError)]);codec.addExtUnpacker(0x03,[decode,unpackError(ReferenceError)]);codec.addExtUnpacker(0x04,[decode,unpackError(SyntaxError)]);codec.addExtUnpacker(0x05,[decode,unpackError(TypeError)]);codec.addExtUnpacker(0x06,[decode,unpackError(URIError)]);codec.addExtUnpacker(0x0A,[decode,unpackRegExp]);codec.addExtUnpacker(0x0B,[decode,unpackClass(Boolean)]);codec.addExtUnpacker(0x0C,[decode,unpackClass(String)]);codec.addExtUnpacker(0x0D,[decode,unpackClass(Date)]);codec.addExtUnpacker(0x0F,[decode,unpackClass(Number)]);if("undefined"!==typeof Uint8Array){codec.addExtUnpacker(0x11,unpackClass(Int8Array));codec.addExtUnpacker(0x12,unpackClass(Uint8Array));codec.addExtUnpacker(0x13,[unpackArrayBuffer,unpackClass(Int16Array)]);codec.addExtUnpacker(0x14,[unpackArrayBuffer,unpackClass(Uint16Array)]);codec.addExtUnpacker(0x15,[unpackArrayBuffer,unpackClass(Int32Array)]);codec.addExtUnpacker(0x16,[unpackArrayBuffer,unpackClass(Uint32Array)]);codec.addExtUnpacker(0x17,[unpackArrayBuffer,unpackClass(Float32Array)]);// PhantomJS/1.9.7 doesn't have Float64Array
	if("undefined"!==typeof Float64Array){codec.addExtUnpacker(0x18,[unpackArrayBuffer,unpackClass(Float64Array)]);}// IE10 doesn't have Uint8ClampedArray
	if("undefined"!==typeof Uint8ClampedArray){codec.addExtUnpacker(0x19,unpackClass(Uint8ClampedArray));}codec.addExtUnpacker(0x1A,unpackArrayBuffer);codec.addExtUnpacker(0x1D,[unpackArrayBuffer,unpackClass(DataView)]);}if(Bufferish.hasBuffer){codec.addExtUnpacker(0x1B,unpackClass(Buffer));}}function decode(input){if(!_decode)_decode=require("./decode").decode;// lazy load
	return _decode(input);}function unpackRegExp(value){return RegExp.apply(null,value);}function unpackError(Class){return function(value){var out=new Class();for(var key in ERROR_COLUMNS){out[key]=value[key];}return out;};}function unpackClass(Class){return function(value){return new Class(value);};}function unpackArrayBuffer(value){return new Uint8Array(value).buffer;}},{"./bufferish":87,"./decode":91}],99:[function(require,module,exports){// ext.js
	// load both interfaces
	require("./read-core");require("./write-core");exports.createCodec=require("./codec-base").createCodec;},{"./codec-base":88,"./read-core":101,"./write-core":104}],100:[function(require,module,exports){// flex-buffer.js
	exports.FlexDecoder=FlexDecoder;exports.FlexEncoder=FlexEncoder;var Bufferish=require("./bufferish");var MIN_BUFFER_SIZE=2048;var MAX_BUFFER_SIZE=65536;var BUFFER_SHORTAGE="BUFFER_SHORTAGE";function FlexDecoder(){if(!(this instanceof FlexDecoder))return new FlexDecoder();}function FlexEncoder(){if(!(this instanceof FlexEncoder))return new FlexEncoder();}FlexDecoder.mixin=mixinFactory(getDecoderMethods());FlexDecoder.mixin(FlexDecoder.prototype);FlexEncoder.mixin=mixinFactory(getEncoderMethods());FlexEncoder.mixin(FlexEncoder.prototype);function getDecoderMethods(){return{bufferish:Bufferish,write:write,fetch:fetch,flush:flush,push:push,pull:pull,read:read,reserve:reserve,offset:0};function write(chunk){var prev=this.offset?Bufferish.prototype.slice.call(this.buffer,this.offset):this.buffer;this.buffer=prev?chunk?this.bufferish.concat([prev,chunk]):prev:chunk;this.offset=0;}function flush(){while(this.offset<this.buffer.length){var start=this.offset;var value;try{value=this.fetch();}catch(e){if(e&&e.message!=BUFFER_SHORTAGE)throw e;// rollback
	this.offset=start;break;}this.push(value);}}function reserve(length){var start=this.offset;var end=start+length;if(end>this.buffer.length)throw new Error(BUFFER_SHORTAGE);this.offset=end;return start;}}function getEncoderMethods(){return{bufferish:Bufferish,write:write,fetch:fetch,flush:flush,push:push,pull:pull,read:read,reserve:reserve,send:send,maxBufferSize:MAX_BUFFER_SIZE,minBufferSize:MIN_BUFFER_SIZE,offset:0,start:0};function fetch(){var start=this.start;if(start<this.offset){var end=this.start=this.offset;return Bufferish.prototype.slice.call(this.buffer,start,end);}}function flush(){while(this.start<this.offset){var value=this.fetch();if(value)this.push(value);}}function pull(){var buffers=this.buffers||(this.buffers=[]);var chunk=buffers.length>1?this.bufferish.concat(buffers):buffers[0];buffers.length=0;// buffer exhausted
	return chunk;}function reserve(length){var req=length|0;if(this.buffer){var size=this.buffer.length;var start=this.offset|0;var end=start+req;// is it long enough?
	if(end<size){this.offset=end;return start;}// flush current buffer
	this.flush();// resize it to 2x current length
	length=Math.max(length,Math.min(size*2,this.maxBufferSize));}// minimum buffer size
	length=Math.max(length,this.minBufferSize);// allocate new buffer
	this.buffer=this.bufferish.alloc(length);this.start=0;this.offset=req;return 0;}function send(buffer){var length=buffer.length;if(length>this.minBufferSize){this.flush();this.push(buffer);}else{var offset=this.reserve(length);Bufferish.prototype.copy.call(buffer,this.buffer,offset);}}}// common methods
	function write(){throw new Error("method not implemented: write()");}function fetch(){throw new Error("method not implemented: fetch()");}function read(){var length=this.buffers&&this.buffers.length;// fetch the first result
	if(!length)return this.fetch();// flush current buffer
	this.flush();// read from the results
	return this.pull();}function push(chunk){var buffers=this.buffers||(this.buffers=[]);buffers.push(chunk);}function pull(){var buffers=this.buffers||(this.buffers=[]);return buffers.shift();}function mixinFactory(source){return mixin;function mixin(target){for(var key in source){target[key]=source[key];}return target;}}},{"./bufferish":87}],101:[function(require,module,exports){// read-core.js
	var ExtBuffer=require("./ext-buffer").ExtBuffer;var ExtUnpacker=require("./ext-unpacker");var readUint8=require("./read-format").readUint8;var ReadToken=require("./read-token");var CodecBase=require("./codec-base");CodecBase.install({addExtUnpacker:addExtUnpacker,getExtUnpacker:getExtUnpacker,init:init});exports.preset=init.call(CodecBase.preset);function getDecoder(options){var readToken=ReadToken.getReadToken(options);return decode;function decode(decoder){var type=readUint8(decoder);var func=readToken[type];if(!func)throw new Error("Invalid type: "+(type?"0x"+type.toString(16):type));return func(decoder);}}function init(){var options=this.options;this.decode=getDecoder(options);if(options&&options.preset){ExtUnpacker.setExtUnpackers(this);}return this;}function addExtUnpacker(etype,unpacker){var unpackers=this.extUnpackers||(this.extUnpackers=[]);unpackers[etype]=CodecBase.filter(unpacker);}function getExtUnpacker(type){var unpackers=this.extUnpackers||(this.extUnpackers=[]);return unpackers[type]||extUnpacker;function extUnpacker(buffer){return new ExtBuffer(buffer,type);}}},{"./codec-base":88,"./ext-buffer":96,"./ext-unpacker":98,"./read-format":102,"./read-token":103}],102:[function(require,module,exports){// read-format.js
	var ieee754=require("ieee754");var Int64Buffer=require("int64-buffer");var Uint64BE=Int64Buffer.Uint64BE;var Int64BE=Int64Buffer.Int64BE;exports.getReadFormat=getReadFormat;exports.readUint8=uint8;var Bufferish=require("./bufferish");var BufferProto=require("./bufferish-proto");var HAS_MAP="undefined"!==typeof Map;var NO_ASSERT=true;function getReadFormat(options){var binarraybuffer=Bufferish.hasArrayBuffer&&options&&options.binarraybuffer;var int64=options&&options.int64;var usemap=HAS_MAP&&options&&options.usemap;var readFormat={map:usemap?map_to_map:map_to_obj,array:array,str:str,bin:binarraybuffer?bin_arraybuffer:bin_buffer,ext:ext,uint8:uint8,uint16:uint16,uint32:uint32,uint64:read(8,int64?readUInt64BE_int64:readUInt64BE),int8:int8,int16:int16,int32:int32,int64:read(8,int64?readInt64BE_int64:readInt64BE),float32:read(4,readFloatBE),float64:read(8,readDoubleBE)};return readFormat;}function map_to_obj(decoder,len){var value={};var i;var k=new Array(len);var v=new Array(len);var decode=decoder.codec.decode;for(i=0;i<len;i++){k[i]=decode(decoder);v[i]=decode(decoder);}for(i=0;i<len;i++){value[k[i]]=v[i];}return value;}function map_to_map(decoder,len){var value=new Map();var i;var k=new Array(len);var v=new Array(len);var decode=decoder.codec.decode;for(i=0;i<len;i++){k[i]=decode(decoder);v[i]=decode(decoder);}for(i=0;i<len;i++){value.set(k[i],v[i]);}return value;}function array(decoder,len){var value=new Array(len);var decode=decoder.codec.decode;for(var i=0;i<len;i++){value[i]=decode(decoder);}return value;}function str(decoder,len){var start=decoder.reserve(len);var end=start+len;return BufferProto.toString.call(decoder.buffer,"utf-8",start,end);}function bin_buffer(decoder,len){var start=decoder.reserve(len);var end=start+len;var buf=BufferProto.slice.call(decoder.buffer,start,end);return Bufferish.from(buf);}function bin_arraybuffer(decoder,len){var start=decoder.reserve(len);var end=start+len;var buf=BufferProto.slice.call(decoder.buffer,start,end);return Bufferish.Uint8Array.from(buf).buffer;}function ext(decoder,len){var start=decoder.reserve(len+1);var type=decoder.buffer[start++];var end=start+len;var unpack=decoder.codec.getExtUnpacker(type);if(!unpack)throw new Error("Invalid ext type: "+(type?"0x"+type.toString(16):type));var buf=BufferProto.slice.call(decoder.buffer,start,end);return unpack(buf);}function uint8(decoder){var start=decoder.reserve(1);return decoder.buffer[start];}function int8(decoder){var start=decoder.reserve(1);var value=decoder.buffer[start];return value&0x80?value-0x100:value;}function uint16(decoder){var start=decoder.reserve(2);var buffer=decoder.buffer;return buffer[start++]<<8|buffer[start];}function int16(decoder){var start=decoder.reserve(2);var buffer=decoder.buffer;var value=buffer[start++]<<8|buffer[start];return value&0x8000?value-0x10000:value;}function uint32(decoder){var start=decoder.reserve(4);var buffer=decoder.buffer;return buffer[start++]*16777216+(buffer[start++]<<16)+(buffer[start++]<<8)+buffer[start];}function int32(decoder){var start=decoder.reserve(4);var buffer=decoder.buffer;return buffer[start++]<<24|buffer[start++]<<16|buffer[start++]<<8|buffer[start];}function read(len,method){return function(decoder){var start=decoder.reserve(len);return method.call(decoder.buffer,start,NO_ASSERT);};}function readUInt64BE(start){return new Uint64BE(this,start).toNumber();}function readInt64BE(start){return new Int64BE(this,start).toNumber();}function readUInt64BE_int64(start){return new Uint64BE(this,start);}function readInt64BE_int64(start){return new Int64BE(this,start);}function readFloatBE(start){return ieee754.read(this,start,false,23,4);}function readDoubleBE(start){return ieee754.read(this,start,false,52,8);}},{"./bufferish":87,"./bufferish-proto":85,"ieee754":75,"int64-buffer":77}],103:[function(require,module,exports){// read-token.js
	var ReadFormat=require("./read-format");exports.getReadToken=getReadToken;function getReadToken(options){var format=ReadFormat.getReadFormat(options);if(options&&options.useraw){return init_useraw(format);}else{return init_token(format);}}function init_token(format){var i;var token=new Array(256);// positive fixint -- 0x00 - 0x7f
	for(i=0x00;i<=0x7f;i++){token[i]=constant(i);}// fixmap -- 0x80 - 0x8f
	for(i=0x80;i<=0x8f;i++){token[i]=fix(i-0x80,format.map);}// fixarray -- 0x90 - 0x9f
	for(i=0x90;i<=0x9f;i++){token[i]=fix(i-0x90,format.array);}// fixstr -- 0xa0 - 0xbf
	for(i=0xa0;i<=0xbf;i++){token[i]=fix(i-0xa0,format.str);}// nil -- 0xc0
	token[0xc0]=constant(null);// (never used) -- 0xc1
	token[0xc1]=null;// false -- 0xc2
	// true -- 0xc3
	token[0xc2]=constant(false);token[0xc3]=constant(true);// bin 8 -- 0xc4
	// bin 16 -- 0xc5
	// bin 32 -- 0xc6
	token[0xc4]=flex(format.uint8,format.bin);token[0xc5]=flex(format.uint16,format.bin);token[0xc6]=flex(format.uint32,format.bin);// ext 8 -- 0xc7
	// ext 16 -- 0xc8
	// ext 32 -- 0xc9
	token[0xc7]=flex(format.uint8,format.ext);token[0xc8]=flex(format.uint16,format.ext);token[0xc9]=flex(format.uint32,format.ext);// float 32 -- 0xca
	// float 64 -- 0xcb
	token[0xca]=format.float32;token[0xcb]=format.float64;// uint 8 -- 0xcc
	// uint 16 -- 0xcd
	// uint 32 -- 0xce
	// uint 64 -- 0xcf
	token[0xcc]=format.uint8;token[0xcd]=format.uint16;token[0xce]=format.uint32;token[0xcf]=format.uint64;// int 8 -- 0xd0
	// int 16 -- 0xd1
	// int 32 -- 0xd2
	// int 64 -- 0xd3
	token[0xd0]=format.int8;token[0xd1]=format.int16;token[0xd2]=format.int32;token[0xd3]=format.int64;// fixext 1 -- 0xd4
	// fixext 2 -- 0xd5
	// fixext 4 -- 0xd6
	// fixext 8 -- 0xd7
	// fixext 16 -- 0xd8
	token[0xd4]=fix(1,format.ext);token[0xd5]=fix(2,format.ext);token[0xd6]=fix(4,format.ext);token[0xd7]=fix(8,format.ext);token[0xd8]=fix(16,format.ext);// str 8 -- 0xd9
	// str 16 -- 0xda
	// str 32 -- 0xdb
	token[0xd9]=flex(format.uint8,format.str);token[0xda]=flex(format.uint16,format.str);token[0xdb]=flex(format.uint32,format.str);// array 16 -- 0xdc
	// array 32 -- 0xdd
	token[0xdc]=flex(format.uint16,format.array);token[0xdd]=flex(format.uint32,format.array);// map 16 -- 0xde
	// map 32 -- 0xdf
	token[0xde]=flex(format.uint16,format.map);token[0xdf]=flex(format.uint32,format.map);// negative fixint -- 0xe0 - 0xff
	for(i=0xe0;i<=0xff;i++){token[i]=constant(i-0x100);}return token;}function init_useraw(format){var i;var token=init_token(format).slice();// raw 8 -- 0xd9
	// raw 16 -- 0xda
	// raw 32 -- 0xdb
	token[0xd9]=token[0xc4];token[0xda]=token[0xc5];token[0xdb]=token[0xc6];// fixraw -- 0xa0 - 0xbf
	for(i=0xa0;i<=0xbf;i++){token[i]=fix(i-0xa0,format.bin);}return token;}function constant(value){return function(){return value;};}function flex(lenFunc,decodeFunc){return function(decoder){var len=lenFunc(decoder);return decodeFunc(decoder,len);};}function fix(len,method){return function(decoder){return method(decoder,len);};}},{"./read-format":102}],104:[function(require,module,exports){// write-core.js
	var ExtBuffer=require("./ext-buffer").ExtBuffer;var ExtPacker=require("./ext-packer");var WriteType=require("./write-type");var CodecBase=require("./codec-base");CodecBase.install({addExtPacker:addExtPacker,getExtPacker:getExtPacker,init:init});exports.preset=init.call(CodecBase.preset);function getEncoder(options){var writeType=WriteType.getWriteType(options);return encode;function encode(encoder,value){var func=writeType[typeof value==="undefined"?"undefined":_typeof(value)];if(!func)throw new Error("Unsupported type \""+(typeof value==="undefined"?"undefined":_typeof(value))+"\": "+value);func(encoder,value);}}function init(){var options=this.options;this.encode=getEncoder(options);if(options&&options.preset){ExtPacker.setExtPackers(this);}return this;}function addExtPacker(etype,Class,packer){packer=CodecBase.filter(packer);var name=Class.name;if(name&&name!=="Object"){var packers=this.extPackers||(this.extPackers={});packers[name]=extPacker;}else{// fallback for IE
	var list=this.extEncoderList||(this.extEncoderList=[]);list.unshift([Class,extPacker]);}function extPacker(value){if(packer)value=packer(value);return new ExtBuffer(value,etype);}}function getExtPacker(value){var packers=this.extPackers||(this.extPackers={});var c=value.constructor;var e=c&&c.name&&packers[c.name];if(e)return e;// fallback for IE
	var list=this.extEncoderList||(this.extEncoderList=[]);var len=list.length;for(var i=0;i<len;i++){var pair=list[i];if(c===pair[0])return pair[1];}}},{"./codec-base":88,"./ext-buffer":96,"./ext-packer":97,"./write-type":106}],105:[function(require,module,exports){// write-token.js
	var ieee754=require("ieee754");var Int64Buffer=require("int64-buffer");var Uint64BE=Int64Buffer.Uint64BE;var Int64BE=Int64Buffer.Int64BE;var uint8=require("./write-uint8").uint8;var Bufferish=require("./bufferish");var Buffer=Bufferish.global;var IS_BUFFER_SHIM=Bufferish.hasBuffer&&"TYPED_ARRAY_SUPPORT"in Buffer;var NO_TYPED_ARRAY=IS_BUFFER_SHIM&&!Buffer.TYPED_ARRAY_SUPPORT;var Buffer_prototype=Bufferish.hasBuffer&&Buffer.prototype||{};exports.getWriteToken=getWriteToken;function getWriteToken(options){if(options&&options.uint8array){return init_uint8array();}else if(NO_TYPED_ARRAY||Bufferish.hasBuffer&&options&&options.safe){return init_safe();}else{return init_token();}}function init_uint8array(){var token=init_token();// float 32 -- 0xca
	// float 64 -- 0xcb
	token[0xca]=writeN(0xca,4,writeFloatBE);token[0xcb]=writeN(0xcb,8,writeDoubleBE);return token;}// Node.js and browsers with TypedArray
	function init_token(){// (immediate values)
	// positive fixint -- 0x00 - 0x7f
	// nil -- 0xc0
	// false -- 0xc2
	// true -- 0xc3
	// negative fixint -- 0xe0 - 0xff
	var token=uint8.slice();// bin 8 -- 0xc4
	// bin 16 -- 0xc5
	// bin 32 -- 0xc6
	token[0xc4]=write1(0xc4);token[0xc5]=write2(0xc5);token[0xc6]=write4(0xc6);// ext 8 -- 0xc7
	// ext 16 -- 0xc8
	// ext 32 -- 0xc9
	token[0xc7]=write1(0xc7);token[0xc8]=write2(0xc8);token[0xc9]=write4(0xc9);// float 32 -- 0xca
	// float 64 -- 0xcb
	token[0xca]=writeN(0xca,4,Buffer_prototype.writeFloatBE||writeFloatBE,true);token[0xcb]=writeN(0xcb,8,Buffer_prototype.writeDoubleBE||writeDoubleBE,true);// uint 8 -- 0xcc
	// uint 16 -- 0xcd
	// uint 32 -- 0xce
	// uint 64 -- 0xcf
	token[0xcc]=write1(0xcc);token[0xcd]=write2(0xcd);token[0xce]=write4(0xce);token[0xcf]=writeN(0xcf,8,writeUInt64BE);// int 8 -- 0xd0
	// int 16 -- 0xd1
	// int 32 -- 0xd2
	// int 64 -- 0xd3
	token[0xd0]=write1(0xd0);token[0xd1]=write2(0xd1);token[0xd2]=write4(0xd2);token[0xd3]=writeN(0xd3,8,writeInt64BE);// str 8 -- 0xd9
	// str 16 -- 0xda
	// str 32 -- 0xdb
	token[0xd9]=write1(0xd9);token[0xda]=write2(0xda);token[0xdb]=write4(0xdb);// array 16 -- 0xdc
	// array 32 -- 0xdd
	token[0xdc]=write2(0xdc);token[0xdd]=write4(0xdd);// map 16 -- 0xde
	// map 32 -- 0xdf
	token[0xde]=write2(0xde);token[0xdf]=write4(0xdf);return token;}// safe mode: for old browsers and who needs asserts
	function init_safe(){// (immediate values)
	// positive fixint -- 0x00 - 0x7f
	// nil -- 0xc0
	// false -- 0xc2
	// true -- 0xc3
	// negative fixint -- 0xe0 - 0xff
	var token=uint8.slice();// bin 8 -- 0xc4
	// bin 16 -- 0xc5
	// bin 32 -- 0xc6
	token[0xc4]=writeN(0xc4,1,Buffer.prototype.writeUInt8);token[0xc5]=writeN(0xc5,2,Buffer.prototype.writeUInt16BE);token[0xc6]=writeN(0xc6,4,Buffer.prototype.writeUInt32BE);// ext 8 -- 0xc7
	// ext 16 -- 0xc8
	// ext 32 -- 0xc9
	token[0xc7]=writeN(0xc7,1,Buffer.prototype.writeUInt8);token[0xc8]=writeN(0xc8,2,Buffer.prototype.writeUInt16BE);token[0xc9]=writeN(0xc9,4,Buffer.prototype.writeUInt32BE);// float 32 -- 0xca
	// float 64 -- 0xcb
	token[0xca]=writeN(0xca,4,Buffer.prototype.writeFloatBE);token[0xcb]=writeN(0xcb,8,Buffer.prototype.writeDoubleBE);// uint 8 -- 0xcc
	// uint 16 -- 0xcd
	// uint 32 -- 0xce
	// uint 64 -- 0xcf
	token[0xcc]=writeN(0xcc,1,Buffer.prototype.writeUInt8);token[0xcd]=writeN(0xcd,2,Buffer.prototype.writeUInt16BE);token[0xce]=writeN(0xce,4,Buffer.prototype.writeUInt32BE);token[0xcf]=writeN(0xcf,8,writeUInt64BE);// int 8 -- 0xd0
	// int 16 -- 0xd1
	// int 32 -- 0xd2
	// int 64 -- 0xd3
	token[0xd0]=writeN(0xd0,1,Buffer.prototype.writeInt8);token[0xd1]=writeN(0xd1,2,Buffer.prototype.writeInt16BE);token[0xd2]=writeN(0xd2,4,Buffer.prototype.writeInt32BE);token[0xd3]=writeN(0xd3,8,writeInt64BE);// str 8 -- 0xd9
	// str 16 -- 0xda
	// str 32 -- 0xdb
	token[0xd9]=writeN(0xd9,1,Buffer.prototype.writeUInt8);token[0xda]=writeN(0xda,2,Buffer.prototype.writeUInt16BE);token[0xdb]=writeN(0xdb,4,Buffer.prototype.writeUInt32BE);// array 16 -- 0xdc
	// array 32 -- 0xdd
	token[0xdc]=writeN(0xdc,2,Buffer.prototype.writeUInt16BE);token[0xdd]=writeN(0xdd,4,Buffer.prototype.writeUInt32BE);// map 16 -- 0xde
	// map 32 -- 0xdf
	token[0xde]=writeN(0xde,2,Buffer.prototype.writeUInt16BE);token[0xdf]=writeN(0xdf,4,Buffer.prototype.writeUInt32BE);return token;}function write1(type){return function(encoder,value){var offset=encoder.reserve(2);var buffer=encoder.buffer;buffer[offset++]=type;buffer[offset]=value;};}function write2(type){return function(encoder,value){var offset=encoder.reserve(3);var buffer=encoder.buffer;buffer[offset++]=type;buffer[offset++]=value>>>8;buffer[offset]=value;};}function write4(type){return function(encoder,value){var offset=encoder.reserve(5);var buffer=encoder.buffer;buffer[offset++]=type;buffer[offset++]=value>>>24;buffer[offset++]=value>>>16;buffer[offset++]=value>>>8;buffer[offset]=value;};}function writeN(type,len,method,noAssert){return function(encoder,value){var offset=encoder.reserve(len+1);encoder.buffer[offset++]=type;method.call(encoder.buffer,value,offset,noAssert);};}function writeUInt64BE(value,offset){new Uint64BE(this,offset,value);}function writeInt64BE(value,offset){new Int64BE(this,offset,value);}function writeFloatBE(value,offset){ieee754.write(this,value,offset,false,23,4);}function writeDoubleBE(value,offset){ieee754.write(this,value,offset,false,52,8);}},{"./bufferish":87,"./write-uint8":107,"ieee754":75,"int64-buffer":77}],106:[function(require,module,exports){// write-type.js
	var IS_ARRAY=require("isarray");var Int64Buffer=require("int64-buffer");var Uint64BE=Int64Buffer.Uint64BE;var Int64BE=Int64Buffer.Int64BE;var Bufferish=require("./bufferish");var BufferProto=require("./bufferish-proto");var WriteToken=require("./write-token");var uint8=require("./write-uint8").uint8;var ExtBuffer=require("./ext-buffer").ExtBuffer;var HAS_UINT8ARRAY="undefined"!==typeof Uint8Array;var HAS_MAP="undefined"!==typeof Map;var extmap=[];extmap[1]=0xd4;extmap[2]=0xd5;extmap[4]=0xd6;extmap[8]=0xd7;extmap[16]=0xd8;exports.getWriteType=getWriteType;function getWriteType(options){var token=WriteToken.getWriteToken(options);var useraw=options&&options.useraw;var binarraybuffer=HAS_UINT8ARRAY&&options&&options.binarraybuffer;var isBuffer=binarraybuffer?Bufferish.isArrayBuffer:Bufferish.isBuffer;var bin=binarraybuffer?bin_arraybuffer:bin_buffer;var usemap=HAS_MAP&&options&&options.usemap;var map=usemap?map_to_map:obj_to_map;var writeType={"boolean":bool,"function":nil,"number":number,"object":useraw?object_raw:object,"string":_string(useraw?raw_head_size:str_head_size),"symbol":nil,"undefined":nil};return writeType;// false -- 0xc2
	// true -- 0xc3
	function bool(encoder,value){var type=value?0xc3:0xc2;token[type](encoder,value);}function number(encoder,value){var ivalue=value|0;var type;if(value!==ivalue){// float 64 -- 0xcb
	type=0xcb;token[type](encoder,value);return;}else if(-0x20<=ivalue&&ivalue<=0x7F){// positive fixint -- 0x00 - 0x7f
	// negative fixint -- 0xe0 - 0xff
	type=ivalue&0xFF;}else if(0<=ivalue){// uint 8 -- 0xcc
	// uint 16 -- 0xcd
	// uint 32 -- 0xce
	type=ivalue<=0xFF?0xcc:ivalue<=0xFFFF?0xcd:0xce;}else{// int 8 -- 0xd0
	// int 16 -- 0xd1
	// int 32 -- 0xd2
	type=-0x80<=ivalue?0xd0:-0x8000<=ivalue?0xd1:0xd2;}token[type](encoder,ivalue);}// uint 64 -- 0xcf
	function uint64(encoder,value){var type=0xcf;token[type](encoder,value.toArray());}// int 64 -- 0xd3
	function int64(encoder,value){var type=0xd3;token[type](encoder,value.toArray());}// str 8 -- 0xd9
	// str 16 -- 0xda
	// str 32 -- 0xdb
	// fixstr -- 0xa0 - 0xbf
	function str_head_size(length){return length<32?1:length<=0xFF?2:length<=0xFFFF?3:5;}// raw 16 -- 0xda
	// raw 32 -- 0xdb
	// fixraw -- 0xa0 - 0xbf
	function raw_head_size(length){return length<32?1:length<=0xFFFF?3:5;}function _string(head_size){return string;function string(encoder,value){// prepare buffer
	var length=value.length;var maxsize=5+length*3;encoder.offset=encoder.reserve(maxsize);var buffer=encoder.buffer;// expected header size
	var expected=head_size(length);// expected start point
	var start=encoder.offset+expected;// write string
	length=BufferProto.write.call(buffer,value,start);// actual header size
	var actual=head_size(length);// move content when needed
	if(expected!==actual){var targetStart=start+actual-expected;var end=start+length;BufferProto.copy.call(buffer,buffer,targetStart,start,end);}// write header
	var type=actual===1?0xa0+length:actual<=3?0xd7+actual:0xdb;token[type](encoder,length);// move cursor
	encoder.offset+=length;}}function object(encoder,value){// null
	if(value===null)return nil(encoder,value);// Buffer
	if(isBuffer(value))return bin(encoder,value);// Array
	if(IS_ARRAY(value))return array(encoder,value);// int64-buffer objects
	if(Uint64BE.isUint64BE(value))return uint64(encoder,value);if(Int64BE.isInt64BE(value))return int64(encoder,value);// ext formats
	var packer=encoder.codec.getExtPacker(value);if(packer)value=packer(value);if(value instanceof ExtBuffer)return ext(encoder,value);// plain old Objects or Map
	map(encoder,value);}function object_raw(encoder,value){// Buffer
	if(isBuffer(value))return raw(encoder,value);// others
	object(encoder,value);}// nil -- 0xc0
	function nil(encoder,value){var type=0xc0;token[type](encoder,value);}// fixarray -- 0x90 - 0x9f
	// array 16 -- 0xdc
	// array 32 -- 0xdd
	function array(encoder,value){var length=value.length;var type=length<16?0x90+length:length<=0xFFFF?0xdc:0xdd;token[type](encoder,length);var encode=encoder.codec.encode;for(var i=0;i<length;i++){encode(encoder,value[i]);}}// bin 8 -- 0xc4
	// bin 16 -- 0xc5
	// bin 32 -- 0xc6
	function bin_buffer(encoder,value){var length=value.length;var type=length<0xFF?0xc4:length<=0xFFFF?0xc5:0xc6;token[type](encoder,length);encoder.send(value);}function bin_arraybuffer(encoder,value){bin_buffer(encoder,new Uint8Array(value));}// fixext 1 -- 0xd4
	// fixext 2 -- 0xd5
	// fixext 4 -- 0xd6
	// fixext 8 -- 0xd7
	// fixext 16 -- 0xd8
	// ext 8 -- 0xc7
	// ext 16 -- 0xc8
	// ext 32 -- 0xc9
	function ext(encoder,value){var buffer=value.buffer;var length=buffer.length;var type=extmap[length]||(length<0xFF?0xc7:length<=0xFFFF?0xc8:0xc9);token[type](encoder,length);uint8[value.type](encoder);encoder.send(buffer);}// fixmap -- 0x80 - 0x8f
	// map 16 -- 0xde
	// map 32 -- 0xdf
	function obj_to_map(encoder,value){var keys=Object.keys(value);var length=keys.length;var type=length<16?0x80+length:length<=0xFFFF?0xde:0xdf;token[type](encoder,length);var encode=encoder.codec.encode;keys.forEach(function(key){encode(encoder,key);encode(encoder,value[key]);});}// fixmap -- 0x80 - 0x8f
	// map 16 -- 0xde
	// map 32 -- 0xdf
	function map_to_map(encoder,value){if(!(value instanceof Map))return obj_to_map(encoder,value);var length=value.size;var type=length<16?0x80+length:length<=0xFFFF?0xde:0xdf;token[type](encoder,length);var encode=encoder.codec.encode;value.forEach(function(val,key,m){encode(encoder,key);encode(encoder,val);});}// raw 16 -- 0xda
	// raw 32 -- 0xdb
	// fixraw -- 0xa0 - 0xbf
	function raw(encoder,value){var length=value.length;var type=length<32?0xa0+length:length<=0xFFFF?0xda:0xdb;token[type](encoder,length);encoder.send(value);}}},{"./bufferish":87,"./bufferish-proto":85,"./ext-buffer":96,"./write-token":105,"./write-uint8":107,"int64-buffer":77,"isarray":79}],107:[function(require,module,exports){// write-unit8.js
	var constant=exports.uint8=new Array(256);for(var i=0x00;i<=0xFF;i++){constant[i]=write0(i);}function write0(type){return function(encoder){var offset=encoder.reserve(1);encoder.buffer[offset]=type;};}},{}],108:[function(require,module,exports){(function(Buffer){// Generated by CoffeeScript 1.10.0
	(function(){var NoFilter,stream,util,extend=function extend(child,parent){for(var key in parent){if(hasProp.call(parent,key))child[key]=parent[key];}function ctor(){this.constructor=child;}ctor.prototype=parent.prototype;child.prototype=new ctor();child.__super__=parent.prototype;return child;},hasProp={}.hasOwnProperty;stream=require('stream');util=require('util');module.exports=NoFilter=function(superClass){var _read_gen,_write_gen,get;extend(NoFilter,superClass);function NoFilter(input,inputEncoding,options){var inp,inpE,ref,watchPipe;if(options==null){options={};}inp=void 0;inpE=void 0;switch(typeof input==="undefined"?"undefined":_typeof(input)){case'object':if(Buffer.isBuffer(input)){inp=input;if(inputEncoding!=null&&(typeof inputEncoding==="undefined"?"undefined":_typeof(inputEncoding))==='object'){options=inputEncoding;}}else{options=input;}break;case'string':inp=input;if(inputEncoding!=null&&(typeof inputEncoding==="undefined"?"undefined":_typeof(inputEncoding))==='object'){options=inputEncoding;}else{inpE=inputEncoding;}}if(options==null){options={};}if(inp==null){inp=options.input;}if(inpE==null){inpE=options.inputEncoding;}delete options.input;delete options.inputEncoding;watchPipe=(ref=options.watchPipe)!=null?ref:true;delete options.watchPipe;NoFilter.__super__.constructor.call(this,options);if(watchPipe){this.on('pipe',function(_this){return function(readable){var om;om=readable._readableState.objectMode;if(_this.length>0&&om!==_this._readableState.objectMode){throw new Error('Do not switch objectMode in the middle of the stream');}_this._readableState.objectMode=om;return _this._writableState.objectMode=om;};}(this));}if(inp!=null){this.end(inp,inpE);}}NoFilter.isNoFilter=function(obj){return obj instanceof this;};NoFilter.compare=function(nf1,nf2){if(!(nf1 instanceof this)){throw new TypeError('Arguments must be NoFilters');}if(nf1===nf2){return 0;}else{return nf1.compare(nf2);}};NoFilter.concat=function(list,length){var bufs;if(!Array.isArray(list)){throw new TypeError('list argument must be an Array of NoFilters');}if(list.length===0||length===0){return new Buffer(0);}if(length==null){length=list.reduce(function(tot,nf){if(!(nf instanceof NoFilter)){throw new TypeError('list argument must be an Array of NoFilters');}return tot+nf.length;},0);}bufs=list.map(function(nf){if(!(nf instanceof NoFilter)){throw new TypeError('list argument must be an Array of NoFilters');}if(nf._readableState.objectMode){throw new Error('NoFilter may not be in object mode for concat');}return nf.slice();});return Buffer.concat(bufs,length);};NoFilter.prototype._transform=function(chunk,encoding,callback){if(!this._readableState.objectMode&&!Buffer.isBuffer(chunk)){chunk=new Buffer(chunk,encoding);}this.push(chunk);return callback();};NoFilter.prototype._bufArray=function(){var b,bufs;bufs=this._readableState.buffer;if(!Array.isArray(bufs)){b=bufs.head;bufs=[];while(b!=null){bufs.push(b.data);b=b.next;}}return bufs;};NoFilter.prototype.read=function(size){var buf;buf=NoFilter.__super__.read.call(this,size);if(buf!=null){this.emit('read',buf);}return buf;};NoFilter.prototype.promise=function(cb){var done;done=false;return new Promise(function(_this){return function(resolve,reject){_this.on('finish',function(){var data;data=_this.read();if(cb!=null&&!done){done=true;cb(null,data);}return resolve(data);});return _this.on('error',function(er){if(cb!=null&&!done){done=true;cb(er);}return reject(er);});};}(this));};NoFilter.prototype.compare=function(other){if(!(other instanceof NoFilter)){throw new TypeError('Arguments must be NoFilters');}if(this._readableState.objectMode||other._readableState.objectMode){throw new Error('Must not be in object mode to compare');}if(this===other){return 0;}else{return this.slice().compare(other.slice());}};NoFilter.prototype.equals=function(other){return this.compare(other)===0;};NoFilter.prototype.slice=function(start,end){var b,bufs;if(this._readableState.objectMode){return this._bufArray().slice(start,end);}else{bufs=this._bufArray();switch(bufs.length){case 0:return new Buffer(0);case 1:return bufs[0].slice(start,end);default:b=Buffer.concat(bufs);return b.slice(start,end);}}};NoFilter.prototype.get=function(index){return this.slice()[index];};NoFilter.prototype.toJSON=function(){var b;b=this.slice();if(Buffer.isBuffer(b)){return b.toJSON();}else{return b;}};NoFilter.prototype.toString=function(encoding,start,end){return this.slice().toString(encoding,start,end);};NoFilter.prototype.inspect=function(depth,options){var bufs,hex;bufs=this._bufArray();hex=bufs.map(function(b){if(Buffer.isBuffer(b)){if(options!=null?options.stylize:void 0){return options.stylize(b.toString('hex'),'string');}else{return b.toString('hex');}}else{return util.inspect(b,options);}}).join(', ');return this.constructor.name+" ["+hex+"]";};_read_gen=function _read_gen(meth,len){return function(val){var b;b=this.read(len);if(!Buffer.isBuffer(b)){return null;}return b[meth].call(b,0,true);};};_write_gen=function _write_gen(meth,len){return function(val){var b;b=new Buffer(len);b[meth].call(b,val,0,true);return this.push(b);};};NoFilter.prototype.writeUInt8=_write_gen('writeUInt8',1);NoFilter.prototype.writeUInt16LE=_write_gen('writeUInt16LE',2);NoFilter.prototype.writeUInt16BE=_write_gen('writeUInt16BE',2);NoFilter.prototype.writeUInt32LE=_write_gen('writeUInt32LE',4);NoFilter.prototype.writeUInt32BE=_write_gen('writeUInt32BE',4);NoFilter.prototype.writeInt8=_write_gen('writeInt8',1);NoFilter.prototype.writeInt16LE=_write_gen('writeInt16LE',2);NoFilter.prototype.writeInt16BE=_write_gen('writeInt16BE',2);NoFilter.prototype.writeInt32LE=_write_gen('writeInt32LE',4);NoFilter.prototype.writeInt32BE=_write_gen('writeInt32BE',4);NoFilter.prototype.writeFloatLE=_write_gen('writeFloatLE',4);NoFilter.prototype.writeFloatBE=_write_gen('writeFloatBE',4);NoFilter.prototype.writeDoubleLE=_write_gen('writeDoubleLE',8);NoFilter.prototype.writeDoubleBE=_write_gen('writeDoubleBE',8);NoFilter.prototype.readUInt8=_read_gen('readUInt8',1);NoFilter.prototype.readUInt16LE=_read_gen('readUInt16LE',2);NoFilter.prototype.readUInt16BE=_read_gen('readUInt16BE',2);NoFilter.prototype.readUInt32LE=_read_gen('readUInt32LE',4);NoFilter.prototype.readUInt32BE=_read_gen('readUInt32BE',4);NoFilter.prototype.readInt8=_read_gen('readInt8',1);NoFilter.prototype.readInt16LE=_read_gen('readInt16LE',2);NoFilter.prototype.readInt16BE=_read_gen('readInt16BE',2);NoFilter.prototype.readInt32LE=_read_gen('readInt32LE',4);NoFilter.prototype.readInt32BE=_read_gen('readInt32BE',4);NoFilter.prototype.readFloatLE=_read_gen('readFloatLE',4);NoFilter.prototype.readFloatBE=_read_gen('readFloatBE',4);NoFilter.prototype.readDoubleLE=_read_gen('readDoubleLE',8);NoFilter.prototype.readDoubleBE=_read_gen('readDoubleBE',8);get=function get(props){var getter,name,results;results=[];for(name in props){getter=props[name];results.push(NoFilter.prototype.__defineGetter__(name,getter));}return results;};get({length:function length(){return this._readableState.length;}});return NoFilter;}(stream.Transform);}).call(this);}).call(this,require("buffer").Buffer);},{"buffer":27,"stream":128,"util":136}],109:[function(require,module,exports){(function(process){'use strict';if(!process.version||process.version.indexOf('v0.')===0||process.version.indexOf('v1.')===0&&process.version.indexOf('v1.8.')!==0){module.exports=nextTick;}else{module.exports=process.nextTick;}function nextTick(fn,arg1,arg2,arg3){if(typeof fn!=='function'){throw new TypeError('"callback" argument must be a function');}var len=arguments.length;var args,i;switch(len){case 0:case 1:return process.nextTick(fn);case 2:return process.nextTick(function afterTickOne(){fn.call(null,arg1);});case 3:return process.nextTick(function afterTickTwo(){fn.call(null,arg1,arg2);});case 4:return process.nextTick(function afterTickThree(){fn.call(null,arg1,arg2,arg3);});default:args=new Array(len-1);i=0;while(i<args.length){args[i++]=arguments[i];}return process.nextTick(function afterTick(){fn.apply(null,args);});}}}).call(this,require('_process'));},{"_process":110}],110:[function(require,module,exports){// shim for using process in browser
	var process=module.exports={};// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	var cachedSetTimeout;var cachedClearTimeout;function defaultSetTimout(){throw new Error('setTimeout has not been defined');}function defaultClearTimeout(){throw new Error('clearTimeout has not been defined');}(function(){try{if(typeof setTimeout==='function'){cachedSetTimeout=setTimeout;}else{cachedSetTimeout=defaultSetTimout;}}catch(e){cachedSetTimeout=defaultSetTimout;}try{if(typeof clearTimeout==='function'){cachedClearTimeout=clearTimeout;}else{cachedClearTimeout=defaultClearTimeout;}}catch(e){cachedClearTimeout=defaultClearTimeout;}})();function runTimeout(fun){if(cachedSetTimeout===setTimeout){//normal enviroments in sane situations
	return setTimeout(fun,0);}// if setTimeout wasn't available but was latter defined
	if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout){cachedSetTimeout=setTimeout;return setTimeout(fun,0);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
	return cachedSetTimeout(fun,0);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	return cachedSetTimeout.call(null,fun,0);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	return cachedSetTimeout.call(this,fun,0);}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout){//normal enviroments in sane situations
	return clearTimeout(marker);}// if clearTimeout wasn't available but was latter defined
	if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout){cachedClearTimeout=clearTimeout;return clearTimeout(marker);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
	return cachedClearTimeout(marker);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	return cachedClearTimeout.call(null,marker);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	// Some versions of I.E. have different rules for clearTimeout vs setTimeout
	return cachedClearTimeout.call(this,marker);}}}var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){if(!draining||!currentQueue){return;}draining=false;if(currentQueue.length){queue=currentQueue.concat(queue);}else{queueIndex=-1;}if(queue.length){drainQueue();}}function drainQueue(){if(draining){return;}var timeout=runTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run();}}queueIndex=-1;len=queue.length;}currentQueue=null;draining=false;runClearTimeout(timeout);}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){runTimeout(drainQueue);}};// v8 likes predictible objects
	function Item(fun,array){this.fun=fun;this.array=array;}Item.prototype.run=function(){this.fun.apply(null,this.array);};process.title='browser';process.browser=true;process.env={};process.argv=[];process.version='';// empty string to avoid regexp issues
	process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.prependListener=noop;process.prependOnceListener=noop;process.listeners=function(name){return[];};process.binding=function(name){throw new Error('process.binding is not supported');};process.cwd=function(){return'/';};process.chdir=function(dir){throw new Error('process.chdir is not supported');};process.umask=function(){return 0;};},{}],111:[function(require,module,exports){(function(global){/*! https://mths.be/punycode v1.4.1 by @mathias */;(function(root){/** Detect free variables */var freeExports=(typeof exports==="undefined"?"undefined":_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;var freeModule=(typeof module==="undefined"?"undefined":_typeof(module))=='object'&&module&&!module.nodeType&&module;var freeGlobal=(typeof global==="undefined"?"undefined":_typeof(global))=='object'&&global;if(freeGlobal.global===freeGlobal||freeGlobal.window===freeGlobal||freeGlobal.self===freeGlobal){root=freeGlobal;}/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */var punycode,/** Highest positive signed 32-bit float value */maxInt=2147483647,// aka. 0x7FFFFFFF or 2^31-1
	/** Bootstring parameters */base=36,tMin=1,tMax=26,skew=38,damp=700,initialBias=72,initialN=128,// 0x80
	delimiter='-',// '\x2D'
	/** Regular expressions */regexPunycode=/^xn--/,regexNonASCII=/[^\x20-\x7E]/,// unprintable ASCII chars + non-ASCII chars
	regexSeparators=/[\x2E\u3002\uFF0E\uFF61]/g,// RFC 3490 separators
	/** Error messages */errors={'overflow':'Overflow: input needs wider integers to process','not-basic':'Illegal input >= 0x80 (not a basic code point)','invalid-input':'Invalid input'},/** Convenience shortcuts */baseMinusTMin=base-tMin,floor=Math.floor,stringFromCharCode=String.fromCharCode,/** Temporary variable */key;/*--------------------------------------------------------------------------*//**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */function error(type){throw new RangeError(errors[type]);}/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */function map(array,fn){var length=array.length;var result=[];while(length--){result[length]=fn(array[length]);}return result;}/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */function mapDomain(string,fn){var parts=string.split('@');var result='';if(parts.length>1){// In email addresses, only the domain name should be punycoded. Leave
	// the local part (i.e. everything up to `@`) intact.
	result=parts[0]+'@';string=parts[1];}// Avoid `split(regex)` for IE8 compatibility. See #17.
	string=string.replace(regexSeparators,'\x2E');var labels=string.split('.');var encoded=map(labels,fn).join('.');return result+encoded;}/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */function ucs2decode(string){var output=[],counter=0,length=string.length,value,extra;while(counter<length){value=string.charCodeAt(counter++);if(value>=0xD800&&value<=0xDBFF&&counter<length){// high surrogate, and there is a next character
	extra=string.charCodeAt(counter++);if((extra&0xFC00)==0xDC00){// low surrogate
	output.push(((value&0x3FF)<<10)+(extra&0x3FF)+0x10000);}else{// unmatched surrogate; only append this code unit, in case the next
	// code unit is the high surrogate of a surrogate pair
	output.push(value);counter--;}}else{output.push(value);}}return output;}/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */function ucs2encode(array){return map(array,function(value){var output='';if(value>0xFFFF){value-=0x10000;output+=stringFromCharCode(value>>>10&0x3FF|0xD800);value=0xDC00|value&0x3FF;}output+=stringFromCharCode(value);return output;}).join('');}/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */function basicToDigit(codePoint){if(codePoint-48<10){return codePoint-22;}if(codePoint-65<26){return codePoint-65;}if(codePoint-97<26){return codePoint-97;}return base;}/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */function digitToBasic(digit,flag){//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit+22+75*(digit<26)-((flag!=0)<<5);}/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */function adapt(delta,numPoints,firstTime){var k=0;delta=firstTime?floor(delta/damp):delta>>1;delta+=floor(delta/numPoints);for(;/* no initialization */delta>baseMinusTMin*tMax>>1;k+=base){delta=floor(delta/baseMinusTMin);}return floor(k+(baseMinusTMin+1)*delta/(delta+skew));}/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */function decode(input){// Don't use UCS-2
	var output=[],inputLength=input.length,out,i=0,n=initialN,bias=initialBias,basic,j,index,oldi,w,k,digit,t,/** Cached calculation results */baseMinusT;// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.
	basic=input.lastIndexOf(delimiter);if(basic<0){basic=0;}for(j=0;j<basic;++j){// if it's not a basic code point
	if(input.charCodeAt(j)>=0x80){error('not-basic');}output.push(input.charCodeAt(j));}// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.
	for(index=basic>0?basic+1:0;index<inputLength;)/* no final expression */{// `index` is the index of the next character to be consumed.
	// Decode a generalized variable-length integer into `delta`,
	// which gets added to `i`. The overflow checking is easier
	// if we increase `i` as we go, then subtract off its starting
	// value at the end to obtain `delta`.
	for(oldi=i,w=1,k=base;;/* no condition */k+=base){if(index>=inputLength){error('invalid-input');}digit=basicToDigit(input.charCodeAt(index++));if(digit>=base||digit>floor((maxInt-i)/w)){error('overflow');}i+=digit*w;t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(digit<t){break;}baseMinusT=base-t;if(w>floor(maxInt/baseMinusT)){error('overflow');}w*=baseMinusT;}out=output.length+1;bias=adapt(i-oldi,out,oldi==0);// `i` was supposed to wrap around from `out` to `0`,
	// incrementing `n` each time, so we'll fix that now:
	if(floor(i/out)>maxInt-n){error('overflow');}n+=floor(i/out);i%=out;// Insert `n` at position `i` of the output
	output.splice(i++,0,n);}return ucs2encode(output);}/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */function encode(input){var n,delta,handledCPCount,basicLength,bias,j,m,q,k,t,currentValue,output=[],/** `inputLength` will hold the number of code points in `input`. */inputLength,/** Cached calculation results */handledCPCountPlusOne,baseMinusT,qMinusT;// Convert the input in UCS-2 to Unicode
	input=ucs2decode(input);// Cache the length
	inputLength=input.length;// Initialize the state
	n=initialN;delta=0;bias=initialBias;// Handle the basic code points
	for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<0x80){output.push(stringFromCharCode(currentValue));}}handledCPCount=basicLength=output.length;// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.
	// Finish the basic string - if it is not empty - with a delimiter
	if(basicLength){output.push(delimiter);}// Main encoding loop:
	while(handledCPCount<inputLength){// All non-basic code points < n have been handled already. Find the next
	// larger one:
	for(m=maxInt,j=0;j<inputLength;++j){currentValue=input[j];if(currentValue>=n&&currentValue<m){m=currentValue;}}// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
	// but guard against overflow
	handledCPCountPlusOne=handledCPCount+1;if(m-n>floor((maxInt-delta)/handledCPCountPlusOne)){error('overflow');}delta+=(m-n)*handledCPCountPlusOne;n=m;for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<n&&++delta>maxInt){error('overflow');}if(currentValue==n){// Represent delta as a generalized variable-length integer
	for(q=delta,k=base;;/* no condition */k+=base){t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(q<t){break;}qMinusT=q-t;baseMinusT=base-t;output.push(stringFromCharCode(digitToBasic(t+qMinusT%baseMinusT,0)));q=floor(qMinusT/baseMinusT);}output.push(stringFromCharCode(digitToBasic(q,0)));bias=adapt(delta,handledCPCountPlusOne,handledCPCount==basicLength);delta=0;++handledCPCount;}}++delta;++n;}return output.join('');}/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */function toUnicode(input){return mapDomain(input,function(string){return regexPunycode.test(string)?decode(string.slice(4).toLowerCase()):string;});}/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */function toASCII(input){return mapDomain(input,function(string){return regexNonASCII.test(string)?'xn--'+encode(string):string;});}/*--------------------------------------------------------------------------*//** Define the public API */punycode={/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */'version':'1.4.1',/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */'ucs2':{'decode':ucs2decode,'encode':ucs2encode},'decode':decode,'encode':encode,'toASCII':toASCII,'toUnicode':toUnicode};/** Expose `punycode` */// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if(typeof define=='function'&&_typeof(define.amd)=='object'&&define.amd){define('punycode',function(){return punycode;});}else if(freeExports&&freeModule){if(module.exports==freeExports){// in Node.js, io.js, or RingoJS v0.8.0+
	freeModule.exports=punycode;}else{// in Narwhal or RingoJS v0.7.0-
	for(key in punycode){punycode.hasOwnProperty(key)&&(freeExports[key]=punycode[key]);}}}else{// in Rhino or a web browser
	root.punycode=punycode;}})(this);}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],112:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop);}module.exports=function(qs,sep,eq,options){sep=sep||'&';eq=eq||'=';var obj={};if(typeof qs!=='string'||qs.length===0){return obj;}var regexp=/\+/g;qs=qs.split(sep);var maxKeys=1000;if(options&&typeof options.maxKeys==='number'){maxKeys=options.maxKeys;}var len=qs.length;// maxKeys <= 0 means that we should not limit keys count
	if(maxKeys>0&&len>maxKeys){len=maxKeys;}for(var i=0;i<len;++i){var x=qs[i].replace(regexp,'%20'),idx=x.indexOf(eq),kstr,vstr,k,v;if(idx>=0){kstr=x.substr(0,idx);vstr=x.substr(idx+1);}else{kstr=x;vstr='';}k=decodeURIComponent(kstr);v=decodeURIComponent(vstr);if(!hasOwnProperty(obj,k)){obj[k]=v;}else if(isArray(obj[k])){obj[k].push(v);}else{obj[k]=[obj[k],v];}}return obj;};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};},{}],113:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';var stringifyPrimitive=function stringifyPrimitive(v){switch(typeof v==="undefined"?"undefined":_typeof(v)){case'string':return v;case'boolean':return v?'true':'false';case'number':return isFinite(v)?v:'';default:return'';}};module.exports=function(obj,sep,eq,name){sep=sep||'&';eq=eq||'=';if(obj===null){obj=undefined;}if((typeof obj==="undefined"?"undefined":_typeof(obj))==='object'){return map(objectKeys(obj),function(k){var ks=encodeURIComponent(stringifyPrimitive(k))+eq;if(isArray(obj[k])){return map(obj[k],function(v){return ks+encodeURIComponent(stringifyPrimitive(v));}).join(sep);}else{return ks+encodeURIComponent(stringifyPrimitive(obj[k]));}}).join(sep);}if(!name)return'';return encodeURIComponent(stringifyPrimitive(name))+eq+encodeURIComponent(stringifyPrimitive(obj));};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};function map(xs,f){if(xs.map)return xs.map(f);var res=[];for(var i=0;i<xs.length;i++){res.push(f(xs[i],i));}return res;}var objectKeys=Object.keys||function(obj){var res=[];for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))res.push(key);}return res;};},{}],114:[function(require,module,exports){'use strict';exports.decode=exports.parse=require('./decode');exports.encode=exports.stringify=require('./encode');},{"./decode":112,"./encode":113}],115:[function(require,module,exports){module.exports=require('./lib/_stream_duplex.js');},{"./lib/_stream_duplex.js":116}],116:[function(require,module,exports){// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	'use strict';/*<replacement>*/var objectKeys=Object.keys||function(obj){var keys=[];for(var key in obj){keys.push(key);}return keys;};/*</replacement>*/module.exports=Duplex;/*<replacement>*/var processNextTick=require('process-nextick-args');/*</replacement>*//*<replacement>*/var util=require('core-util-is');util.inherits=require('inherits');/*</replacement>*/var Readable=require('./_stream_readable');var Writable=require('./_stream_writable');util.inherits(Duplex,Readable);var keys=objectKeys(Writable.prototype);for(var v=0;v<keys.length;v++){var method=keys[v];if(!Duplex.prototype[method])Duplex.prototype[method]=Writable.prototype[method];}function Duplex(options){if(!(this instanceof Duplex))return new Duplex(options);Readable.call(this,options);Writable.call(this,options);if(options&&options.readable===false)this.readable=false;if(options&&options.writable===false)this.writable=false;this.allowHalfOpen=true;if(options&&options.allowHalfOpen===false)this.allowHalfOpen=false;this.once('end',onend);}// the no-half-open enforcer
	function onend(){// if we allow half-open state, or if the writable side ended,
	// then we're ok.
	if(this.allowHalfOpen||this._writableState.ended)return;// no more data can be written.
	// But allow more writes to happen in this tick.
	processNextTick(onEndNT,this);}function onEndNT(self){self.end();}function forEach(xs,f){for(var i=0,l=xs.length;i<l;i++){f(xs[i],i);}}},{"./_stream_readable":118,"./_stream_writable":120,"core-util-is":38,"inherits":76,"process-nextick-args":109}],117:[function(require,module,exports){// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	'use strict';module.exports=PassThrough;var Transform=require('./_stream_transform');/*<replacement>*/var util=require('core-util-is');util.inherits=require('inherits');/*</replacement>*/util.inherits(PassThrough,Transform);function PassThrough(options){if(!(this instanceof PassThrough))return new PassThrough(options);Transform.call(this,options);}PassThrough.prototype._transform=function(chunk,encoding,cb){cb(null,chunk);};},{"./_stream_transform":119,"core-util-is":38,"inherits":76}],118:[function(require,module,exports){(function(process){'use strict';module.exports=Readable;/*<replacement>*/var processNextTick=require('process-nextick-args');/*</replacement>*//*<replacement>*/var isArray=require('isarray');/*</replacement>*//*<replacement>*/var Duplex;/*</replacement>*/Readable.ReadableState=ReadableState;/*<replacement>*/var EE=require('events').EventEmitter;var EElistenerCount=function EElistenerCount(emitter,type){return emitter.listeners(type).length;};/*</replacement>*//*<replacement>*/var Stream=require('./internal/streams/stream');/*</replacement>*/var Buffer=require('buffer').Buffer;/*<replacement>*/var bufferShim=require('buffer-shims');/*</replacement>*//*<replacement>*/var util=require('core-util-is');util.inherits=require('inherits');/*</replacement>*//*<replacement>*/var debugUtil=require('util');var debug=void 0;if(debugUtil&&debugUtil.debuglog){debug=debugUtil.debuglog('stream');}else{debug=function debug(){};}/*</replacement>*/var BufferList=require('./internal/streams/BufferList');var StringDecoder;util.inherits(Readable,Stream);var kProxyEvents=['error','close','destroy','pause','resume'];function prependListener(emitter,event,fn){// Sadly this is not cacheable as some libraries bundle their own
	// event emitter implementation with them.
	if(typeof emitter.prependListener==='function'){return emitter.prependListener(event,fn);}else{// This is a hack to make sure that our error handler is attached before any
	// userland ones.  NEVER DO THIS. This is here only because this code needs
	// to continue to work with older versions of Node.js that do not include
	// the prependListener() method. The goal is to eventually remove this hack.
	if(!emitter._events||!emitter._events[event])emitter.on(event,fn);else if(isArray(emitter._events[event]))emitter._events[event].unshift(fn);else emitter._events[event]=[fn,emitter._events[event]];}}function ReadableState(options,stream){Duplex=Duplex||require('./_stream_duplex');options=options||{};// object stream flag. Used to make read(n) ignore n and to
	// make all the buffer merging and length checks go away
	this.objectMode=!!options.objectMode;if(stream instanceof Duplex)this.objectMode=this.objectMode||!!options.readableObjectMode;// the point at which it stops calling _read() to fill the buffer
	// Note: 0 is a valid value, means "don't call _read preemptively ever"
	var hwm=options.highWaterMark;var defaultHwm=this.objectMode?16:16*1024;this.highWaterMark=hwm||hwm===0?hwm:defaultHwm;// cast to ints.
	this.highWaterMark=~~this.highWaterMark;// A linked list is used to store data chunks instead of an array because the
	// linked list can remove elements from the beginning faster than
	// array.shift()
	this.buffer=new BufferList();this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;// a flag to be able to tell if the onwrite cb is called immediately,
	// or on a later tick.  We set this to true at first, because any
	// actions that shouldn't happen until "later" should generally also
	// not happen before the first write call.
	this.sync=true;// whenever we return null, then we set a flag to say
	// that we're awaiting a 'readable' event emission.
	this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;// Crypto is kind of old and crusty.  Historically, its default string
	// encoding is 'binary' so we have to make this configurable.
	// Everything else in the universe uses 'utf8', though.
	this.defaultEncoding=options.defaultEncoding||'utf8';// when piping, we only care about 'readable' events that happen
	// after read()ing all the bytes and not getting any pushback.
	this.ranOut=false;// the number of writers that are awaiting a drain event in .pipe()s
	this.awaitDrain=0;// if true, a maybeReadMore has been scheduled
	this.readingMore=false;this.decoder=null;this.encoding=null;if(options.encoding){if(!StringDecoder)StringDecoder=require('string_decoder/').StringDecoder;this.decoder=new StringDecoder(options.encoding);this.encoding=options.encoding;}}function Readable(options){Duplex=Duplex||require('./_stream_duplex');if(!(this instanceof Readable))return new Readable(options);this._readableState=new ReadableState(options,this);// legacy
	this.readable=true;if(options&&typeof options.read==='function')this._read=options.read;Stream.call(this);}// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push=function(chunk,encoding){var state=this._readableState;if(!state.objectMode&&typeof chunk==='string'){encoding=encoding||state.defaultEncoding;if(encoding!==state.encoding){chunk=bufferShim.from(chunk,encoding);encoding='';}}return readableAddChunk(this,state,chunk,encoding,false);};// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift=function(chunk){var state=this._readableState;return readableAddChunk(this,state,chunk,'',true);};Readable.prototype.isPaused=function(){return this._readableState.flowing===false;};function readableAddChunk(stream,state,chunk,encoding,addToFront){var er=chunkInvalid(state,chunk);if(er){stream.emit('error',er);}else if(chunk===null){state.reading=false;onEofChunk(stream,state);}else if(state.objectMode||chunk&&chunk.length>0){if(state.ended&&!addToFront){var e=new Error('stream.push() after EOF');stream.emit('error',e);}else if(state.endEmitted&&addToFront){var _e=new Error('stream.unshift() after end event');stream.emit('error',_e);}else{var skipAdd;if(state.decoder&&!addToFront&&!encoding){chunk=state.decoder.write(chunk);skipAdd=!state.objectMode&&chunk.length===0;}if(!addToFront)state.reading=false;// Don't add to the buffer if we've decoded to an empty string chunk and
	// we're not in object mode
	if(!skipAdd){// if we want the data now, just emit it.
	if(state.flowing&&state.length===0&&!state.sync){stream.emit('data',chunk);stream.read(0);}else{// update the buffer info.
	state.length+=state.objectMode?1:chunk.length;if(addToFront)state.buffer.unshift(chunk);else state.buffer.push(chunk);if(state.needReadable)emitReadable(stream);}}maybeReadMore(stream,state);}}else if(!addToFront){state.reading=false;}return needMoreData(state);}// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state){return!state.ended&&(state.needReadable||state.length<state.highWaterMark||state.length===0);}// backwards compatibility.
	Readable.prototype.setEncoding=function(enc){if(!StringDecoder)StringDecoder=require('string_decoder/').StringDecoder;this._readableState.decoder=new StringDecoder(enc);this._readableState.encoding=enc;return this;};// Don't raise the hwm > 8MB
	var MAX_HWM=0x800000;function computeNewHighWaterMark(n){if(n>=MAX_HWM){n=MAX_HWM;}else{// Get the next highest power of 2 to prevent increasing hwm excessively in
	// tiny amounts
	n--;n|=n>>>1;n|=n>>>2;n|=n>>>4;n|=n>>>8;n|=n>>>16;n++;}return n;}// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n,state){if(n<=0||state.length===0&&state.ended)return 0;if(state.objectMode)return 1;if(n!==n){// Only flow one buffer at a time
	if(state.flowing&&state.length)return state.buffer.head.data.length;else return state.length;}// If we're asking for more than the current hwm, then raise the hwm.
	if(n>state.highWaterMark)state.highWaterMark=computeNewHighWaterMark(n);if(n<=state.length)return n;// Don't have enough
	if(!state.ended){state.needReadable=true;return 0;}return state.length;}// you can override either this method, or the async _read(n) below.
	Readable.prototype.read=function(n){debug('read',n);n=parseInt(n,10);var state=this._readableState;var nOrig=n;if(n!==0)state.emittedReadable=false;// if we're doing read(0) to trigger a readable event, but we
	// already have a bunch of data in the buffer, then just trigger
	// the 'readable' event and move on.
	if(n===0&&state.needReadable&&(state.length>=state.highWaterMark||state.ended)){debug('read: emitReadable',state.length,state.ended);if(state.length===0&&state.ended)endReadable(this);else emitReadable(this);return null;}n=howMuchToRead(n,state);// if we've ended, and we're now clear, then finish it up.
	if(n===0&&state.ended){if(state.length===0)endReadable(this);return null;}// All the actual chunk generation logic needs to be
	// *below* the call to _read.  The reason is that in certain
	// synthetic stream cases, such as passthrough streams, _read
	// may be a completely synchronous operation which may change
	// the state of the read buffer, providing enough data when
	// before there was *not* enough.
	//
	// So, the steps are:
	// 1. Figure out what the state of things will be after we do
	// a read from the buffer.
	//
	// 2. If that resulting state will trigger a _read, then call _read.
	// Note that this may be asynchronous, or synchronous.  Yes, it is
	// deeply ugly to write APIs this way, but that still doesn't mean
	// that the Readable class should behave improperly, as streams are
	// designed to be sync/async agnostic.
	// Take note if the _read call is sync or async (ie, if the read call
	// has returned yet), so that we know whether or not it's safe to emit
	// 'readable' etc.
	//
	// 3. Actually pull the requested chunks out of the buffer and return.
	// if we need a readable event, then we need to do some reading.
	var doRead=state.needReadable;debug('need readable',doRead);// if we currently have less than the highWaterMark, then also read some
	if(state.length===0||state.length-n<state.highWaterMark){doRead=true;debug('length less than watermark',doRead);}// however, if we've ended, then there's no point, and if we're already
	// reading, then it's unnecessary.
	if(state.ended||state.reading){doRead=false;debug('reading or ended',doRead);}else if(doRead){debug('do read');state.reading=true;state.sync=true;// if the length is currently zero, then we *need* a readable event.
	if(state.length===0)state.needReadable=true;// call internal read method
	this._read(state.highWaterMark);state.sync=false;// If _read pushed data synchronously, then `reading` will be false,
	// and we need to re-evaluate how much data we can return to the user.
	if(!state.reading)n=howMuchToRead(nOrig,state);}var ret;if(n>0)ret=fromList(n,state);else ret=null;if(ret===null){state.needReadable=true;n=0;}else{state.length-=n;}if(state.length===0){// If we have nothing in the buffer, then we want to know
	// as soon as we *do* get something into the buffer.
	if(!state.ended)state.needReadable=true;// If we tried to read() past the EOF, then emit end on the next tick.
	if(nOrig!==n&&state.ended)endReadable(this);}if(ret!==null)this.emit('data',ret);return ret;};function chunkInvalid(state,chunk){var er=null;if(!Buffer.isBuffer(chunk)&&typeof chunk!=='string'&&chunk!==null&&chunk!==undefined&&!state.objectMode){er=new TypeError('Invalid non-string/buffer chunk');}return er;}function onEofChunk(stream,state){if(state.ended)return;if(state.decoder){var chunk=state.decoder.end();if(chunk&&chunk.length){state.buffer.push(chunk);state.length+=state.objectMode?1:chunk.length;}}state.ended=true;// emit 'readable' now to make sure it gets picked up.
	emitReadable(stream);}// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream){var state=stream._readableState;state.needReadable=false;if(!state.emittedReadable){debug('emitReadable',state.flowing);state.emittedReadable=true;if(state.sync)processNextTick(emitReadable_,stream);else emitReadable_(stream);}}function emitReadable_(stream){debug('emit readable');stream.emit('readable');flow(stream);}// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream,state){if(!state.readingMore){state.readingMore=true;processNextTick(maybeReadMore_,stream,state);}}function maybeReadMore_(stream,state){var len=state.length;while(!state.reading&&!state.flowing&&!state.ended&&state.length<state.highWaterMark){debug('maybeReadMore read 0');stream.read(0);if(len===state.length)// didn't get any data, stop spinning.
	break;else len=state.length;}state.readingMore=false;}// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read=function(n){this.emit('error',new Error('_read() is not implemented'));};Readable.prototype.pipe=function(dest,pipeOpts){var src=this;var state=this._readableState;switch(state.pipesCount){case 0:state.pipes=dest;break;case 1:state.pipes=[state.pipes,dest];break;default:state.pipes.push(dest);break;}state.pipesCount+=1;debug('pipe count=%d opts=%j',state.pipesCount,pipeOpts);var doEnd=(!pipeOpts||pipeOpts.end!==false)&&dest!==process.stdout&&dest!==process.stderr;var endFn=doEnd?onend:cleanup;if(state.endEmitted)processNextTick(endFn);else src.once('end',endFn);dest.on('unpipe',onunpipe);function onunpipe(readable){debug('onunpipe');if(readable===src){cleanup();}}function onend(){debug('onend');dest.end();}// when the dest drains, it reduces the awaitDrain counter
	// on the source.  This would be more elegant with a .once()
	// handler in flow(), but adding and removing repeatedly is
	// too slow.
	var ondrain=pipeOnDrain(src);dest.on('drain',ondrain);var cleanedUp=false;function cleanup(){debug('cleanup');// cleanup event handlers once the pipe is broken
	dest.removeListener('close',onclose);dest.removeListener('finish',onfinish);dest.removeListener('drain',ondrain);dest.removeListener('error',onerror);dest.removeListener('unpipe',onunpipe);src.removeListener('end',onend);src.removeListener('end',cleanup);src.removeListener('data',ondata);cleanedUp=true;// if the reader is waiting for a drain event from this
	// specific writer, then it would cause it to never start
	// flowing again.
	// So, if this is awaiting a drain, then we just call it now.
	// If we don't know, then assume that we are waiting for one.
	if(state.awaitDrain&&(!dest._writableState||dest._writableState.needDrain))ondrain();}// If the user pushes more data while we're writing to dest then we'll end up
	// in ondata again. However, we only want to increase awaitDrain once because
	// dest will only emit one 'drain' event for the multiple writes.
	// => Introduce a guard on increasing awaitDrain.
	var increasedAwaitDrain=false;src.on('data',ondata);function ondata(chunk){debug('ondata');increasedAwaitDrain=false;var ret=dest.write(chunk);if(false===ret&&!increasedAwaitDrain){// If the user unpiped during `dest.write()`, it is possible
	// to get stuck in a permanently paused state if that write
	// also returned false.
	// => Check whether `dest` is still a piping destination.
	if((state.pipesCount===1&&state.pipes===dest||state.pipesCount>1&&indexOf(state.pipes,dest)!==-1)&&!cleanedUp){debug('false write response, pause',src._readableState.awaitDrain);src._readableState.awaitDrain++;increasedAwaitDrain=true;}src.pause();}}// if the dest has an error, then stop piping into it.
	// however, don't suppress the throwing behavior for this.
	function onerror(er){debug('onerror',er);unpipe();dest.removeListener('error',onerror);if(EElistenerCount(dest,'error')===0)dest.emit('error',er);}// Make sure our error handler is attached before userland ones.
	prependListener(dest,'error',onerror);// Both close and finish should trigger unpipe, but only once.
	function onclose(){dest.removeListener('finish',onfinish);unpipe();}dest.once('close',onclose);function onfinish(){debug('onfinish');dest.removeListener('close',onclose);unpipe();}dest.once('finish',onfinish);function unpipe(){debug('unpipe');src.unpipe(dest);}// tell the dest that it's being piped to
	dest.emit('pipe',src);// start the flow if it hasn't been started already.
	if(!state.flowing){debug('pipe resume');src.resume();}return dest;};function pipeOnDrain(src){return function(){var state=src._readableState;debug('pipeOnDrain',state.awaitDrain);if(state.awaitDrain)state.awaitDrain--;if(state.awaitDrain===0&&EElistenerCount(src,'data')){state.flowing=true;flow(src);}};}Readable.prototype.unpipe=function(dest){var state=this._readableState;// if we're not piping anywhere, then do nothing.
	if(state.pipesCount===0)return this;// just one destination.  most common case.
	if(state.pipesCount===1){// passed in one, but it's not the right one.
	if(dest&&dest!==state.pipes)return this;if(!dest)dest=state.pipes;// got a match.
	state.pipes=null;state.pipesCount=0;state.flowing=false;if(dest)dest.emit('unpipe',this);return this;}// slow case. multiple pipe destinations.
	if(!dest){// remove all.
	var dests=state.pipes;var len=state.pipesCount;state.pipes=null;state.pipesCount=0;state.flowing=false;for(var i=0;i<len;i++){dests[i].emit('unpipe',this);}return this;}// try to find the right one.
	var index=indexOf(state.pipes,dest);if(index===-1)return this;state.pipes.splice(index,1);state.pipesCount-=1;if(state.pipesCount===1)state.pipes=state.pipes[0];dest.emit('unpipe',this);return this;};// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on=function(ev,fn){var res=Stream.prototype.on.call(this,ev,fn);if(ev==='data'){// Start flowing on next tick if stream isn't explicitly paused
	if(this._readableState.flowing!==false)this.resume();}else if(ev==='readable'){var state=this._readableState;if(!state.endEmitted&&!state.readableListening){state.readableListening=state.needReadable=true;state.emittedReadable=false;if(!state.reading){processNextTick(nReadingNextTick,this);}else if(state.length){emitReadable(this,state);}}}return res;};Readable.prototype.addListener=Readable.prototype.on;function nReadingNextTick(self){debug('readable nexttick read 0');self.read(0);}// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume=function(){var state=this._readableState;if(!state.flowing){debug('resume');state.flowing=true;resume(this,state);}return this;};function resume(stream,state){if(!state.resumeScheduled){state.resumeScheduled=true;processNextTick(resume_,stream,state);}}function resume_(stream,state){if(!state.reading){debug('resume read 0');stream.read(0);}state.resumeScheduled=false;state.awaitDrain=0;stream.emit('resume');flow(stream);if(state.flowing&&!state.reading)stream.read(0);}Readable.prototype.pause=function(){debug('call pause flowing=%j',this._readableState.flowing);if(false!==this._readableState.flowing){debug('pause');this._readableState.flowing=false;this.emit('pause');}return this;};function flow(stream){var state=stream._readableState;debug('flow',state.flowing);while(state.flowing&&stream.read()!==null){}}// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap=function(stream){var state=this._readableState;var paused=false;var self=this;stream.on('end',function(){debug('wrapped end');if(state.decoder&&!state.ended){var chunk=state.decoder.end();if(chunk&&chunk.length)self.push(chunk);}self.push(null);});stream.on('data',function(chunk){debug('wrapped data');if(state.decoder)chunk=state.decoder.write(chunk);// don't skip over falsy values in objectMode
	if(state.objectMode&&(chunk===null||chunk===undefined))return;else if(!state.objectMode&&(!chunk||!chunk.length))return;var ret=self.push(chunk);if(!ret){paused=true;stream.pause();}});// proxy all the other methods.
	// important when wrapping filters and duplexes.
	for(var i in stream){if(this[i]===undefined&&typeof stream[i]==='function'){this[i]=function(method){return function(){return stream[method].apply(stream,arguments);};}(i);}}// proxy certain important events.
	for(var n=0;n<kProxyEvents.length;n++){stream.on(kProxyEvents[n],self.emit.bind(self,kProxyEvents[n]));}// when we try to consume some more bytes, simply unpause the
	// underlying stream.
	self._read=function(n){debug('wrapped _read',n);if(paused){paused=false;stream.resume();}};return self;};// exposed for testing purposes only.
	Readable._fromList=fromList;// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n,state){// nothing buffered
	if(state.length===0)return null;var ret;if(state.objectMode)ret=state.buffer.shift();else if(!n||n>=state.length){// read it all, truncate the list
	if(state.decoder)ret=state.buffer.join('');else if(state.buffer.length===1)ret=state.buffer.head.data;else ret=state.buffer.concat(state.length);state.buffer.clear();}else{// read part of list
	ret=fromListPartial(n,state.buffer,state.decoder);}return ret;}// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n,list,hasStrings){var ret;if(n<list.head.data.length){// slice is the same for buffers and strings
	ret=list.head.data.slice(0,n);list.head.data=list.head.data.slice(n);}else if(n===list.head.data.length){// first chunk is a perfect match
	ret=list.shift();}else{// result spans more than one buffer
	ret=hasStrings?copyFromBufferString(n,list):copyFromBuffer(n,list);}return ret;}// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n,list){var p=list.head;var c=1;var ret=p.data;n-=ret.length;while(p=p.next){var str=p.data;var nb=n>str.length?str.length:n;if(nb===str.length)ret+=str;else ret+=str.slice(0,n);n-=nb;if(n===0){if(nb===str.length){++c;if(p.next)list.head=p.next;else list.head=list.tail=null;}else{list.head=p;p.data=str.slice(nb);}break;}++c;}list.length-=c;return ret;}// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n,list){var ret=bufferShim.allocUnsafe(n);var p=list.head;var c=1;p.data.copy(ret);n-=p.data.length;while(p=p.next){var buf=p.data;var nb=n>buf.length?buf.length:n;buf.copy(ret,ret.length-n,0,nb);n-=nb;if(n===0){if(nb===buf.length){++c;if(p.next)list.head=p.next;else list.head=list.tail=null;}else{list.head=p;p.data=buf.slice(nb);}break;}++c;}list.length-=c;return ret;}function endReadable(stream){var state=stream._readableState;// If we get here before consuming all the bytes, then that is a
	// bug in node.  Should never happen.
	if(state.length>0)throw new Error('"endReadable()" called on non-empty stream');if(!state.endEmitted){state.ended=true;processNextTick(endReadableNT,state,stream);}}function endReadableNT(state,stream){// Check that we didn't get one last unshift.
	if(!state.endEmitted&&state.length===0){state.endEmitted=true;stream.readable=false;stream.emit('end');}}function forEach(xs,f){for(var i=0,l=xs.length;i<l;i++){f(xs[i],i);}}function indexOf(xs,x){for(var i=0,l=xs.length;i<l;i++){if(xs[i]===x)return i;}return-1;}}).call(this,require('_process'));},{"./_stream_duplex":116,"./internal/streams/BufferList":121,"./internal/streams/stream":122,"_process":110,"buffer":27,"buffer-shims":26,"core-util-is":38,"events":74,"inherits":76,"isarray":79,"process-nextick-args":109,"string_decoder/":129,"util":24}],119:[function(require,module,exports){// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	'use strict';module.exports=Transform;var Duplex=require('./_stream_duplex');/*<replacement>*/var util=require('core-util-is');util.inherits=require('inherits');/*</replacement>*/util.inherits(Transform,Duplex);function TransformState(stream){this.afterTransform=function(er,data){return afterTransform(stream,er,data);};this.needTransform=false;this.transforming=false;this.writecb=null;this.writechunk=null;this.writeencoding=null;}function afterTransform(stream,er,data){var ts=stream._transformState;ts.transforming=false;var cb=ts.writecb;if(!cb)return stream.emit('error',new Error('no writecb in Transform class'));ts.writechunk=null;ts.writecb=null;if(data!==null&&data!==undefined)stream.push(data);cb(er);var rs=stream._readableState;rs.reading=false;if(rs.needReadable||rs.length<rs.highWaterMark){stream._read(rs.highWaterMark);}}function Transform(options){if(!(this instanceof Transform))return new Transform(options);Duplex.call(this,options);this._transformState=new TransformState(this);var stream=this;// start out asking for a readable event once data is transformed.
	this._readableState.needReadable=true;// we have implemented the _read method, and done the other things
	// that Readable wants before the first _read call, so unset the
	// sync guard flag.
	this._readableState.sync=false;if(options){if(typeof options.transform==='function')this._transform=options.transform;if(typeof options.flush==='function')this._flush=options.flush;}// When the writable side finishes, then flush out anything remaining.
	this.once('prefinish',function(){if(typeof this._flush==='function')this._flush(function(er,data){done(stream,er,data);});else done(stream);});}Transform.prototype.push=function(chunk,encoding){this._transformState.needTransform=false;return Duplex.prototype.push.call(this,chunk,encoding);};// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform=function(chunk,encoding,cb){throw new Error('_transform() is not implemented');};Transform.prototype._write=function(chunk,encoding,cb){var ts=this._transformState;ts.writecb=cb;ts.writechunk=chunk;ts.writeencoding=encoding;if(!ts.transforming){var rs=this._readableState;if(ts.needTransform||rs.needReadable||rs.length<rs.highWaterMark)this._read(rs.highWaterMark);}};// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read=function(n){var ts=this._transformState;if(ts.writechunk!==null&&ts.writecb&&!ts.transforming){ts.transforming=true;this._transform(ts.writechunk,ts.writeencoding,ts.afterTransform);}else{// mark that we need a transform, so that any data that comes in
	// will get processed, now that we've asked for it.
	ts.needTransform=true;}};function done(stream,er,data){if(er)return stream.emit('error',er);if(data!==null&&data!==undefined)stream.push(data);// if there's nothing in the write buffer, then that means
	// that nothing more will ever be provided
	var ws=stream._writableState;var ts=stream._transformState;if(ws.length)throw new Error('Calling transform done when ws.length != 0');if(ts.transforming)throw new Error('Calling transform done when still transforming');return stream.push(null);}},{"./_stream_duplex":116,"core-util-is":38,"inherits":76}],120:[function(require,module,exports){(function(process){// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	'use strict';module.exports=Writable;/*<replacement>*/var processNextTick=require('process-nextick-args');/*</replacement>*//*<replacement>*/var asyncWrite=!process.browser&&['v0.10','v0.9.'].indexOf(process.version.slice(0,5))>-1?setImmediate:processNextTick;/*</replacement>*//*<replacement>*/var Duplex;/*</replacement>*/Writable.WritableState=WritableState;/*<replacement>*/var util=require('core-util-is');util.inherits=require('inherits');/*</replacement>*//*<replacement>*/var internalUtil={deprecate:require('util-deprecate')};/*</replacement>*//*<replacement>*/var Stream=require('./internal/streams/stream');/*</replacement>*/var Buffer=require('buffer').Buffer;/*<replacement>*/var bufferShim=require('buffer-shims');/*</replacement>*/util.inherits(Writable,Stream);function nop(){}function WriteReq(chunk,encoding,cb){this.chunk=chunk;this.encoding=encoding;this.callback=cb;this.next=null;}function WritableState(options,stream){Duplex=Duplex||require('./_stream_duplex');options=options||{};// object stream flag to indicate whether or not this stream
	// contains buffers or objects.
	this.objectMode=!!options.objectMode;if(stream instanceof Duplex)this.objectMode=this.objectMode||!!options.writableObjectMode;// the point at which write() starts returning false
	// Note: 0 is a valid value, means that we always return false if
	// the entire buffer is not flushed immediately on write()
	var hwm=options.highWaterMark;var defaultHwm=this.objectMode?16:16*1024;this.highWaterMark=hwm||hwm===0?hwm:defaultHwm;// cast to ints.
	this.highWaterMark=~~this.highWaterMark;// drain event flag.
	this.needDrain=false;// at the start of calling end()
	this.ending=false;// when end() has been called, and returned
	this.ended=false;// when 'finish' is emitted
	this.finished=false;// should we decode strings into buffers before passing to _write?
	// this is here so that some node-core streams can optimize string
	// handling at a lower level.
	var noDecode=options.decodeStrings===false;this.decodeStrings=!noDecode;// Crypto is kind of old and crusty.  Historically, its default string
	// encoding is 'binary' so we have to make this configurable.
	// Everything else in the universe uses 'utf8', though.
	this.defaultEncoding=options.defaultEncoding||'utf8';// not an actual buffer we keep track of, but a measurement
	// of how much we're waiting to get pushed to some underlying
	// socket or file.
	this.length=0;// a flag to see when we're in the middle of a write.
	this.writing=false;// when true all writes will be buffered until .uncork() call
	this.corked=0;// a flag to be able to tell if the onwrite cb is called immediately,
	// or on a later tick.  We set this to true at first, because any
	// actions that shouldn't happen until "later" should generally also
	// not happen before the first write call.
	this.sync=true;// a flag to know if we're processing previously buffered items, which
	// may call the _write() callback in the same tick, so that we don't
	// end up in an overlapped onwrite situation.
	this.bufferProcessing=false;// the callback that's passed to _write(chunk,cb)
	this.onwrite=function(er){onwrite(stream,er);};// the callback that the user supplies to write(chunk,encoding,cb)
	this.writecb=null;// the amount that is being written when _write is called.
	this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;// number of pending user-supplied write callbacks
	// this must be 0 before 'finish' can be emitted
	this.pendingcb=0;// emit prefinish if the only thing we're waiting for is _write cbs
	// This is relevant for synchronous Transform streams
	this.prefinished=false;// True if the error was already emitted and should not be thrown again
	this.errorEmitted=false;// count buffered requests
	this.bufferedRequestCount=0;// allocate the first CorkedRequest, there is always
	// one allocated and free to use, and we maintain at most two
	this.corkedRequestsFree=new CorkedRequest(this);}WritableState.prototype.getBuffer=function getBuffer(){var current=this.bufferedRequest;var out=[];while(current){out.push(current);current=current.next;}return out;};(function(){try{Object.defineProperty(WritableState.prototype,'buffer',{get:internalUtil.deprecate(function(){return this.getBuffer();},'_writableState.buffer is deprecated. Use _writableState.getBuffer '+'instead.')});}catch(_){}})();// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;if(typeof Symbol==='function'&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==='function'){realHasInstance=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(object){if(realHasInstance.call(this,object))return true;return object&&object._writableState instanceof WritableState;}});}else{realHasInstance=function realHasInstance(object){return object instanceof this;};}function Writable(options){Duplex=Duplex||require('./_stream_duplex');// Writable ctor is applied to Duplexes, too.
	// `realHasInstance` is necessary because using plain `instanceof`
	// would return false, as no `_writableState` property is attached.
	// Trying to use the custom `instanceof` for Writable here will also break the
	// Node.js LazyTransform implementation, which has a non-trivial getter for
	// `_writableState` that would lead to infinite recursion.
	if(!realHasInstance.call(Writable,this)&&!(this instanceof Duplex)){return new Writable(options);}this._writableState=new WritableState(options,this);// legacy.
	this.writable=true;if(options){if(typeof options.write==='function')this._write=options.write;if(typeof options.writev==='function')this._writev=options.writev;}Stream.call(this);}// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe=function(){this.emit('error',new Error('Cannot pipe, not readable'));};function writeAfterEnd(stream,cb){var er=new Error('write after end');// TODO: defer error events consistently everywhere, not just the cb
	stream.emit('error',er);processNextTick(cb,er);}// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream,state,chunk,cb){var valid=true;var er=false;if(chunk===null){er=new TypeError('May not write null values to stream');}else if(typeof chunk!=='string'&&chunk!==undefined&&!state.objectMode){er=new TypeError('Invalid non-string/buffer chunk');}if(er){stream.emit('error',er);processNextTick(cb,er);valid=false;}return valid;}Writable.prototype.write=function(chunk,encoding,cb){var state=this._writableState;var ret=false;var isBuf=Buffer.isBuffer(chunk);if(typeof encoding==='function'){cb=encoding;encoding=null;}if(isBuf)encoding='buffer';else if(!encoding)encoding=state.defaultEncoding;if(typeof cb!=='function')cb=nop;if(state.ended)writeAfterEnd(this,cb);else if(isBuf||validChunk(this,state,chunk,cb)){state.pendingcb++;ret=writeOrBuffer(this,state,isBuf,chunk,encoding,cb);}return ret;};Writable.prototype.cork=function(){var state=this._writableState;state.corked++;};Writable.prototype.uncork=function(){var state=this._writableState;if(state.corked){state.corked--;if(!state.writing&&!state.corked&&!state.finished&&!state.bufferProcessing&&state.bufferedRequest)clearBuffer(this,state);}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(encoding){// node::ParseEncoding() requires lower case.
	if(typeof encoding==='string')encoding=encoding.toLowerCase();if(!(['hex','utf8','utf-8','ascii','binary','base64','ucs2','ucs-2','utf16le','utf-16le','raw'].indexOf((encoding+'').toLowerCase())>-1))throw new TypeError('Unknown encoding: '+encoding);this._writableState.defaultEncoding=encoding;return this;};function decodeChunk(state,chunk,encoding){if(!state.objectMode&&state.decodeStrings!==false&&typeof chunk==='string'){chunk=bufferShim.from(chunk,encoding);}return chunk;}// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream,state,isBuf,chunk,encoding,cb){if(!isBuf){chunk=decodeChunk(state,chunk,encoding);if(Buffer.isBuffer(chunk))encoding='buffer';}var len=state.objectMode?1:chunk.length;state.length+=len;var ret=state.length<state.highWaterMark;// we must ensure that previous needDrain will not be reset to false.
	if(!ret)state.needDrain=true;if(state.writing||state.corked){var last=state.lastBufferedRequest;state.lastBufferedRequest=new WriteReq(chunk,encoding,cb);if(last){last.next=state.lastBufferedRequest;}else{state.bufferedRequest=state.lastBufferedRequest;}state.bufferedRequestCount+=1;}else{doWrite(stream,state,false,len,chunk,encoding,cb);}return ret;}function doWrite(stream,state,writev,len,chunk,encoding,cb){state.writelen=len;state.writecb=cb;state.writing=true;state.sync=true;if(writev)stream._writev(chunk,state.onwrite);else stream._write(chunk,encoding,state.onwrite);state.sync=false;}function onwriteError(stream,state,sync,er,cb){--state.pendingcb;if(sync)processNextTick(cb,er);else cb(er);stream._writableState.errorEmitted=true;stream.emit('error',er);}function onwriteStateUpdate(state){state.writing=false;state.writecb=null;state.length-=state.writelen;state.writelen=0;}function onwrite(stream,er){var state=stream._writableState;var sync=state.sync;var cb=state.writecb;onwriteStateUpdate(state);if(er)onwriteError(stream,state,sync,er,cb);else{// Check if we're actually ready to finish, but don't emit yet
	var finished=needFinish(state);if(!finished&&!state.corked&&!state.bufferProcessing&&state.bufferedRequest){clearBuffer(stream,state);}if(sync){/*<replacement>*/asyncWrite(afterWrite,stream,state,finished,cb);/*</replacement>*/}else{afterWrite(stream,state,finished,cb);}}}function afterWrite(stream,state,finished,cb){if(!finished)onwriteDrain(stream,state);state.pendingcb--;cb();finishMaybe(stream,state);}// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream,state){if(state.length===0&&state.needDrain){state.needDrain=false;stream.emit('drain');}}// if there's something in the buffer waiting, then process it
	function clearBuffer(stream,state){state.bufferProcessing=true;var entry=state.bufferedRequest;if(stream._writev&&entry&&entry.next){// Fast case, write everything using _writev()
	var l=state.bufferedRequestCount;var buffer=new Array(l);var holder=state.corkedRequestsFree;holder.entry=entry;var count=0;while(entry){buffer[count]=entry;entry=entry.next;count+=1;}doWrite(stream,state,true,state.length,buffer,'',holder.finish);// doWrite is almost always async, defer these to save a bit of time
	// as the hot path ends with doWrite
	state.pendingcb++;state.lastBufferedRequest=null;if(holder.next){state.corkedRequestsFree=holder.next;holder.next=null;}else{state.corkedRequestsFree=new CorkedRequest(state);}}else{// Slow case, write chunks one-by-one
	while(entry){var chunk=entry.chunk;var encoding=entry.encoding;var cb=entry.callback;var len=state.objectMode?1:chunk.length;doWrite(stream,state,false,len,chunk,encoding,cb);entry=entry.next;// if we didn't call the onwrite immediately, then
	// it means that we need to wait until it does.
	// also, that means that the chunk and cb are currently
	// being processed, so move the buffer counter past them.
	if(state.writing){break;}}if(entry===null)state.lastBufferedRequest=null;}state.bufferedRequestCount=0;state.bufferedRequest=entry;state.bufferProcessing=false;}Writable.prototype._write=function(chunk,encoding,cb){cb(new Error('_write() is not implemented'));};Writable.prototype._writev=null;Writable.prototype.end=function(chunk,encoding,cb){var state=this._writableState;if(typeof chunk==='function'){cb=chunk;chunk=null;encoding=null;}else if(typeof encoding==='function'){cb=encoding;encoding=null;}if(chunk!==null&&chunk!==undefined)this.write(chunk,encoding);// .end() fully uncorks
	if(state.corked){state.corked=1;this.uncork();}// ignore unnecessary end() calls.
	if(!state.ending&&!state.finished)endWritable(this,state,cb);};function needFinish(state){return state.ending&&state.length===0&&state.bufferedRequest===null&&!state.finished&&!state.writing;}function prefinish(stream,state){if(!state.prefinished){state.prefinished=true;stream.emit('prefinish');}}function finishMaybe(stream,state){var need=needFinish(state);if(need){if(state.pendingcb===0){prefinish(stream,state);state.finished=true;stream.emit('finish');}else{prefinish(stream,state);}}return need;}function endWritable(stream,state,cb){state.ending=true;finishMaybe(stream,state);if(cb){if(state.finished)processNextTick(cb);else stream.once('finish',cb);}state.ended=true;stream.writable=false;}// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state){var _this=this;this.next=null;this.entry=null;this.finish=function(err){var entry=_this.entry;_this.entry=null;while(entry){var cb=entry.callback;state.pendingcb--;cb(err);entry=entry.next;}if(state.corkedRequestsFree){state.corkedRequestsFree.next=_this;}else{state.corkedRequestsFree=_this;}};}}).call(this,require('_process'));},{"./_stream_duplex":116,"./internal/streams/stream":122,"_process":110,"buffer":27,"buffer-shims":26,"core-util-is":38,"inherits":76,"process-nextick-args":109,"util-deprecate":133}],121:[function(require,module,exports){'use strict';var Buffer=require('buffer').Buffer;/*<replacement>*/var bufferShim=require('buffer-shims');/*</replacement>*/module.exports=BufferList;function BufferList(){this.head=null;this.tail=null;this.length=0;}BufferList.prototype.push=function(v){var entry={data:v,next:null};if(this.length>0)this.tail.next=entry;else this.head=entry;this.tail=entry;++this.length;};BufferList.prototype.unshift=function(v){var entry={data:v,next:this.head};if(this.length===0)this.tail=entry;this.head=entry;++this.length;};BufferList.prototype.shift=function(){if(this.length===0)return;var ret=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return ret;};BufferList.prototype.clear=function(){this.head=this.tail=null;this.length=0;};BufferList.prototype.join=function(s){if(this.length===0)return'';var p=this.head;var ret=''+p.data;while(p=p.next){ret+=s+p.data;}return ret;};BufferList.prototype.concat=function(n){if(this.length===0)return bufferShim.alloc(0);if(this.length===1)return this.head.data;var ret=bufferShim.allocUnsafe(n>>>0);var p=this.head;var i=0;while(p){p.data.copy(ret,i);i+=p.data.length;p=p.next;}return ret;};},{"buffer":27,"buffer-shims":26}],122:[function(require,module,exports){module.exports=require('events').EventEmitter;},{"events":74}],123:[function(require,module,exports){module.exports=require('./readable').PassThrough;},{"./readable":124}],124:[function(require,module,exports){exports=module.exports=require('./lib/_stream_readable.js');exports.Stream=exports;exports.Readable=exports;exports.Writable=require('./lib/_stream_writable.js');exports.Duplex=require('./lib/_stream_duplex.js');exports.Transform=require('./lib/_stream_transform.js');exports.PassThrough=require('./lib/_stream_passthrough.js');},{"./lib/_stream_duplex.js":116,"./lib/_stream_passthrough.js":117,"./lib/_stream_readable.js":118,"./lib/_stream_transform.js":119,"./lib/_stream_writable.js":120}],125:[function(require,module,exports){module.exports=require('./readable').Transform;},{"./readable":124}],126:[function(require,module,exports){module.exports=require('./lib/_stream_writable.js');},{"./lib/_stream_writable.js":120}],127:[function(require,module,exports){module.exports=require('buffer');},{"buffer":27}],128:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	module.exports=Stream;var EE=require('events').EventEmitter;var inherits=require('inherits');inherits(Stream,EE);Stream.Readable=require('readable-stream/readable.js');Stream.Writable=require('readable-stream/writable.js');Stream.Duplex=require('readable-stream/duplex.js');Stream.Transform=require('readable-stream/transform.js');Stream.PassThrough=require('readable-stream/passthrough.js');// Backwards-compat with node 0.4.x
	Stream.Stream=Stream;// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	function Stream(){EE.call(this);}Stream.prototype.pipe=function(dest,options){var source=this;function ondata(chunk){if(dest.writable){if(false===dest.write(chunk)&&source.pause){source.pause();}}}source.on('data',ondata);function ondrain(){if(source.readable&&source.resume){source.resume();}}dest.on('drain',ondrain);// If the 'end' option is not supplied, dest.end() will be called when
	// source gets the 'end' or 'close' events.  Only dest.end() once.
	if(!dest._isStdio&&(!options||options.end!==false)){source.on('end',onend);source.on('close',onclose);}var didOnEnd=false;function onend(){if(didOnEnd)return;didOnEnd=true;dest.end();}function onclose(){if(didOnEnd)return;didOnEnd=true;if(typeof dest.destroy==='function')dest.destroy();}// don't leave dangling pipes when there are errors.
	function onerror(er){cleanup();if(EE.listenerCount(this,'error')===0){throw er;// Unhandled stream error in pipe.
	}}source.on('error',onerror);dest.on('error',onerror);// remove all the event listeners that were added.
	function cleanup(){source.removeListener('data',ondata);dest.removeListener('drain',ondrain);source.removeListener('end',onend);source.removeListener('close',onclose);source.removeListener('error',onerror);dest.removeListener('error',onerror);source.removeListener('end',cleanup);source.removeListener('close',cleanup);dest.removeListener('close',cleanup);}source.on('end',cleanup);source.on('close',cleanup);dest.on('close',cleanup);dest.emit('pipe',source);// Allow for unix-like usage: A.pipe(B).pipe(C)
	return dest;};},{"events":74,"inherits":76,"readable-stream/duplex.js":115,"readable-stream/passthrough.js":123,"readable-stream/readable.js":124,"readable-stream/transform.js":125,"readable-stream/writable.js":126}],129:[function(require,module,exports){'use strict';var Buffer=require('safe-buffer').Buffer;var isEncoding=Buffer.isEncoding||function(encoding){encoding=''+encoding;switch(encoding&&encoding.toLowerCase()){case'hex':case'utf8':case'utf-8':case'ascii':case'binary':case'base64':case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':case'raw':return true;default:return false;}};function _normalizeEncoding(enc){if(!enc)return'utf8';var retried;while(true){switch(enc){case'utf8':case'utf-8':return'utf8';case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return'utf16le';case'latin1':case'binary':return'latin1';case'base64':case'ascii':case'hex':return enc;default:if(retried)return;// undefined
	enc=(''+enc).toLowerCase();retried=true;}}};// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc){var nenc=_normalizeEncoding(enc);if(typeof nenc!=='string'&&(Buffer.isEncoding===isEncoding||!isEncoding(enc)))throw new Error('Unknown encoding: '+enc);return nenc||enc;}// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder=StringDecoder;function StringDecoder(encoding){this.encoding=normalizeEncoding(encoding);var nb;switch(this.encoding){case'utf16le':this.text=utf16Text;this.end=utf16End;nb=4;break;case'utf8':this.fillLast=utf8FillLast;nb=4;break;case'base64':this.text=base64Text;this.end=base64End;nb=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return;}this.lastNeed=0;this.lastTotal=0;this.lastChar=Buffer.allocUnsafe(nb);}StringDecoder.prototype.write=function(buf){if(buf.length===0)return'';var r;var i;if(this.lastNeed){r=this.fillLast(buf);if(r===undefined)return'';i=this.lastNeed;this.lastNeed=0;}else{i=0;}if(i<buf.length)return r?r+this.text(buf,i):this.text(buf,i);return r||'';};StringDecoder.prototype.end=utf8End;// Returns only complete characters in a Buffer
	StringDecoder.prototype.text=utf8Text;// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast=function(buf){if(this.lastNeed<=buf.length){buf.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal);}buf.copy(this.lastChar,this.lastTotal-this.lastNeed,0,buf.length);this.lastNeed-=buf.length;};// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte){if(byte<=0x7F)return 0;else if(byte>>5===0x06)return 2;else if(byte>>4===0x0E)return 3;else if(byte>>3===0x1E)return 4;return-1;}// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self,buf,i){var j=buf.length-1;if(j<i)return 0;var nb=utf8CheckByte(buf[j]);if(nb>=0){if(nb>0)self.lastNeed=nb-1;return nb;}if(--j<i)return 0;nb=utf8CheckByte(buf[j]);if(nb>=0){if(nb>0)self.lastNeed=nb-2;return nb;}if(--j<i)return 0;nb=utf8CheckByte(buf[j]);if(nb>=0){if(nb>0){if(nb===2)nb=0;else self.lastNeed=nb-3;}return nb;}return 0;}// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self,buf,p){if((buf[0]&0xC0)!==0x80){self.lastNeed=0;return"\uFFFD".repeat(p);}if(self.lastNeed>1&&buf.length>1){if((buf[1]&0xC0)!==0x80){self.lastNeed=1;return"\uFFFD".repeat(p+1);}if(self.lastNeed>2&&buf.length>2){if((buf[2]&0xC0)!==0x80){self.lastNeed=2;return"\uFFFD".repeat(p+2);}}}}// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf){var p=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,buf,p);if(r!==undefined)return r;if(this.lastNeed<=buf.length){buf.copy(this.lastChar,p,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal);}buf.copy(this.lastChar,p,0,buf.length);this.lastNeed-=buf.length;}// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf,i){var total=utf8CheckIncomplete(this,buf,i);if(!this.lastNeed)return buf.toString('utf8',i);this.lastTotal=total;var end=buf.length-(total-this.lastNeed);buf.copy(this.lastChar,0,end);return buf.toString('utf8',i,end);}// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf){var r=buf&&buf.length?this.write(buf):'';if(this.lastNeed)return r+"\uFFFD".repeat(this.lastTotal-this.lastNeed);return r;}// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf,i){if((buf.length-i)%2===0){var r=buf.toString('utf16le',i);if(r){var c=r.charCodeAt(r.length-1);if(c>=0xD800&&c<=0xDBFF){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=buf[buf.length-2];this.lastChar[1]=buf[buf.length-1];return r.slice(0,-1);}}return r;}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=buf[buf.length-1];return buf.toString('utf16le',i,buf.length-1);}// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf){var r=buf&&buf.length?this.write(buf):'';if(this.lastNeed){var end=this.lastTotal-this.lastNeed;return r+this.lastChar.toString('utf16le',0,end);}return r;}function base64Text(buf,i){var n=(buf.length-i)%3;if(n===0)return buf.toString('base64',i);this.lastNeed=3-n;this.lastTotal=3;if(n===1){this.lastChar[0]=buf[buf.length-1];}else{this.lastChar[0]=buf[buf.length-2];this.lastChar[1]=buf[buf.length-1];}return buf.toString('base64',i,buf.length-n);}function base64End(buf){var r=buf&&buf.length?this.write(buf):'';if(this.lastNeed)return r+this.lastChar.toString('base64',0,3-this.lastNeed);return r;}// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf){return buf.toString(this.encoding);}function simpleEnd(buf){return buf&&buf.length?this.write(buf):'';}},{"safe-buffer":127}],130:[function(require,module,exports){(function(nacl){'use strict';// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
	// Public domain.
	//
	// Implementation derived from TweetNaCl version 20140427.
	// See for details: http://tweetnacl.cr.yp.to/
	var gf=function gf(init){var i,r=new Float64Array(16);if(init)for(i=0;i<init.length;i++){r[i]=init[i];}return r;};//  Pluggable, initialized in high-level API below.
	var randombytes=function randombytes()/* x, n */{throw new Error('no PRNG');};var _0=new Uint8Array(16);var _9=new Uint8Array(32);_9[0]=9;var gf0=gf(),gf1=gf([1]),_121665=gf([0xdb41,1]),D=gf([0x78a3,0x1359,0x4dca,0x75eb,0xd8ab,0x4141,0x0a4d,0x0070,0xe898,0x7779,0x4079,0x8cc7,0xfe73,0x2b6f,0x6cee,0x5203]),D2=gf([0xf159,0x26b2,0x9b94,0xebd6,0xb156,0x8283,0x149a,0x00e0,0xd130,0xeef3,0x80f2,0x198e,0xfce7,0x56df,0xd9dc,0x2406]),X=gf([0xd51a,0x8f25,0x2d60,0xc956,0xa7b2,0x9525,0xc760,0x692c,0xdc5c,0xfdd6,0xe231,0xc0a4,0x53fe,0xcd6e,0x36d3,0x2169]),Y=gf([0x6658,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666,0x6666]),I=gf([0xa0b0,0x4a0e,0x1b27,0xc4ee,0xe478,0xad2f,0x1806,0x2f43,0xd7a7,0x3dfb,0x0099,0x2b4d,0xdf0b,0x4fc1,0x2480,0x2b83]);function ts64(x,i,h,l){x[i]=h>>24&0xff;x[i+1]=h>>16&0xff;x[i+2]=h>>8&0xff;x[i+3]=h&0xff;x[i+4]=l>>24&0xff;x[i+5]=l>>16&0xff;x[i+6]=l>>8&0xff;x[i+7]=l&0xff;}function vn(x,xi,y,yi,n){var i,d=0;for(i=0;i<n;i++){d|=x[xi+i]^y[yi+i];}return(1&d-1>>>8)-1;}function crypto_verify_16(x,xi,y,yi){return vn(x,xi,y,yi,16);}function crypto_verify_32(x,xi,y,yi){return vn(x,xi,y,yi,32);}function core_salsa20(o,p,k,c){var j0=c[0]&0xff|(c[1]&0xff)<<8|(c[2]&0xff)<<16|(c[3]&0xff)<<24,j1=k[0]&0xff|(k[1]&0xff)<<8|(k[2]&0xff)<<16|(k[3]&0xff)<<24,j2=k[4]&0xff|(k[5]&0xff)<<8|(k[6]&0xff)<<16|(k[7]&0xff)<<24,j3=k[8]&0xff|(k[9]&0xff)<<8|(k[10]&0xff)<<16|(k[11]&0xff)<<24,j4=k[12]&0xff|(k[13]&0xff)<<8|(k[14]&0xff)<<16|(k[15]&0xff)<<24,j5=c[4]&0xff|(c[5]&0xff)<<8|(c[6]&0xff)<<16|(c[7]&0xff)<<24,j6=p[0]&0xff|(p[1]&0xff)<<8|(p[2]&0xff)<<16|(p[3]&0xff)<<24,j7=p[4]&0xff|(p[5]&0xff)<<8|(p[6]&0xff)<<16|(p[7]&0xff)<<24,j8=p[8]&0xff|(p[9]&0xff)<<8|(p[10]&0xff)<<16|(p[11]&0xff)<<24,j9=p[12]&0xff|(p[13]&0xff)<<8|(p[14]&0xff)<<16|(p[15]&0xff)<<24,j10=c[8]&0xff|(c[9]&0xff)<<8|(c[10]&0xff)<<16|(c[11]&0xff)<<24,j11=k[16]&0xff|(k[17]&0xff)<<8|(k[18]&0xff)<<16|(k[19]&0xff)<<24,j12=k[20]&0xff|(k[21]&0xff)<<8|(k[22]&0xff)<<16|(k[23]&0xff)<<24,j13=k[24]&0xff|(k[25]&0xff)<<8|(k[26]&0xff)<<16|(k[27]&0xff)<<24,j14=k[28]&0xff|(k[29]&0xff)<<8|(k[30]&0xff)<<16|(k[31]&0xff)<<24,j15=c[12]&0xff|(c[13]&0xff)<<8|(c[14]&0xff)<<16|(c[15]&0xff)<<24;var x0=j0,x1=j1,x2=j2,x3=j3,x4=j4,x5=j5,x6=j6,x7=j7,x8=j8,x9=j9,x10=j10,x11=j11,x12=j12,x13=j13,x14=j14,x15=j15,u;for(var i=0;i<20;i+=2){u=x0+x12|0;x4^=u<<7|u>>>32-7;u=x4+x0|0;x8^=u<<9|u>>>32-9;u=x8+x4|0;x12^=u<<13|u>>>32-13;u=x12+x8|0;x0^=u<<18|u>>>32-18;u=x5+x1|0;x9^=u<<7|u>>>32-7;u=x9+x5|0;x13^=u<<9|u>>>32-9;u=x13+x9|0;x1^=u<<13|u>>>32-13;u=x1+x13|0;x5^=u<<18|u>>>32-18;u=x10+x6|0;x14^=u<<7|u>>>32-7;u=x14+x10|0;x2^=u<<9|u>>>32-9;u=x2+x14|0;x6^=u<<13|u>>>32-13;u=x6+x2|0;x10^=u<<18|u>>>32-18;u=x15+x11|0;x3^=u<<7|u>>>32-7;u=x3+x15|0;x7^=u<<9|u>>>32-9;u=x7+x3|0;x11^=u<<13|u>>>32-13;u=x11+x7|0;x15^=u<<18|u>>>32-18;u=x0+x3|0;x1^=u<<7|u>>>32-7;u=x1+x0|0;x2^=u<<9|u>>>32-9;u=x2+x1|0;x3^=u<<13|u>>>32-13;u=x3+x2|0;x0^=u<<18|u>>>32-18;u=x5+x4|0;x6^=u<<7|u>>>32-7;u=x6+x5|0;x7^=u<<9|u>>>32-9;u=x7+x6|0;x4^=u<<13|u>>>32-13;u=x4+x7|0;x5^=u<<18|u>>>32-18;u=x10+x9|0;x11^=u<<7|u>>>32-7;u=x11+x10|0;x8^=u<<9|u>>>32-9;u=x8+x11|0;x9^=u<<13|u>>>32-13;u=x9+x8|0;x10^=u<<18|u>>>32-18;u=x15+x14|0;x12^=u<<7|u>>>32-7;u=x12+x15|0;x13^=u<<9|u>>>32-9;u=x13+x12|0;x14^=u<<13|u>>>32-13;u=x14+x13|0;x15^=u<<18|u>>>32-18;}x0=x0+j0|0;x1=x1+j1|0;x2=x2+j2|0;x3=x3+j3|0;x4=x4+j4|0;x5=x5+j5|0;x6=x6+j6|0;x7=x7+j7|0;x8=x8+j8|0;x9=x9+j9|0;x10=x10+j10|0;x11=x11+j11|0;x12=x12+j12|0;x13=x13+j13|0;x14=x14+j14|0;x15=x15+j15|0;o[0]=x0>>>0&0xff;o[1]=x0>>>8&0xff;o[2]=x0>>>16&0xff;o[3]=x0>>>24&0xff;o[4]=x1>>>0&0xff;o[5]=x1>>>8&0xff;o[6]=x1>>>16&0xff;o[7]=x1>>>24&0xff;o[8]=x2>>>0&0xff;o[9]=x2>>>8&0xff;o[10]=x2>>>16&0xff;o[11]=x2>>>24&0xff;o[12]=x3>>>0&0xff;o[13]=x3>>>8&0xff;o[14]=x3>>>16&0xff;o[15]=x3>>>24&0xff;o[16]=x4>>>0&0xff;o[17]=x4>>>8&0xff;o[18]=x4>>>16&0xff;o[19]=x4>>>24&0xff;o[20]=x5>>>0&0xff;o[21]=x5>>>8&0xff;o[22]=x5>>>16&0xff;o[23]=x5>>>24&0xff;o[24]=x6>>>0&0xff;o[25]=x6>>>8&0xff;o[26]=x6>>>16&0xff;o[27]=x6>>>24&0xff;o[28]=x7>>>0&0xff;o[29]=x7>>>8&0xff;o[30]=x7>>>16&0xff;o[31]=x7>>>24&0xff;o[32]=x8>>>0&0xff;o[33]=x8>>>8&0xff;o[34]=x8>>>16&0xff;o[35]=x8>>>24&0xff;o[36]=x9>>>0&0xff;o[37]=x9>>>8&0xff;o[38]=x9>>>16&0xff;o[39]=x9>>>24&0xff;o[40]=x10>>>0&0xff;o[41]=x10>>>8&0xff;o[42]=x10>>>16&0xff;o[43]=x10>>>24&0xff;o[44]=x11>>>0&0xff;o[45]=x11>>>8&0xff;o[46]=x11>>>16&0xff;o[47]=x11>>>24&0xff;o[48]=x12>>>0&0xff;o[49]=x12>>>8&0xff;o[50]=x12>>>16&0xff;o[51]=x12>>>24&0xff;o[52]=x13>>>0&0xff;o[53]=x13>>>8&0xff;o[54]=x13>>>16&0xff;o[55]=x13>>>24&0xff;o[56]=x14>>>0&0xff;o[57]=x14>>>8&0xff;o[58]=x14>>>16&0xff;o[59]=x14>>>24&0xff;o[60]=x15>>>0&0xff;o[61]=x15>>>8&0xff;o[62]=x15>>>16&0xff;o[63]=x15>>>24&0xff;}function core_hsalsa20(o,p,k,c){var j0=c[0]&0xff|(c[1]&0xff)<<8|(c[2]&0xff)<<16|(c[3]&0xff)<<24,j1=k[0]&0xff|(k[1]&0xff)<<8|(k[2]&0xff)<<16|(k[3]&0xff)<<24,j2=k[4]&0xff|(k[5]&0xff)<<8|(k[6]&0xff)<<16|(k[7]&0xff)<<24,j3=k[8]&0xff|(k[9]&0xff)<<8|(k[10]&0xff)<<16|(k[11]&0xff)<<24,j4=k[12]&0xff|(k[13]&0xff)<<8|(k[14]&0xff)<<16|(k[15]&0xff)<<24,j5=c[4]&0xff|(c[5]&0xff)<<8|(c[6]&0xff)<<16|(c[7]&0xff)<<24,j6=p[0]&0xff|(p[1]&0xff)<<8|(p[2]&0xff)<<16|(p[3]&0xff)<<24,j7=p[4]&0xff|(p[5]&0xff)<<8|(p[6]&0xff)<<16|(p[7]&0xff)<<24,j8=p[8]&0xff|(p[9]&0xff)<<8|(p[10]&0xff)<<16|(p[11]&0xff)<<24,j9=p[12]&0xff|(p[13]&0xff)<<8|(p[14]&0xff)<<16|(p[15]&0xff)<<24,j10=c[8]&0xff|(c[9]&0xff)<<8|(c[10]&0xff)<<16|(c[11]&0xff)<<24,j11=k[16]&0xff|(k[17]&0xff)<<8|(k[18]&0xff)<<16|(k[19]&0xff)<<24,j12=k[20]&0xff|(k[21]&0xff)<<8|(k[22]&0xff)<<16|(k[23]&0xff)<<24,j13=k[24]&0xff|(k[25]&0xff)<<8|(k[26]&0xff)<<16|(k[27]&0xff)<<24,j14=k[28]&0xff|(k[29]&0xff)<<8|(k[30]&0xff)<<16|(k[31]&0xff)<<24,j15=c[12]&0xff|(c[13]&0xff)<<8|(c[14]&0xff)<<16|(c[15]&0xff)<<24;var x0=j0,x1=j1,x2=j2,x3=j3,x4=j4,x5=j5,x6=j6,x7=j7,x8=j8,x9=j9,x10=j10,x11=j11,x12=j12,x13=j13,x14=j14,x15=j15,u;for(var i=0;i<20;i+=2){u=x0+x12|0;x4^=u<<7|u>>>32-7;u=x4+x0|0;x8^=u<<9|u>>>32-9;u=x8+x4|0;x12^=u<<13|u>>>32-13;u=x12+x8|0;x0^=u<<18|u>>>32-18;u=x5+x1|0;x9^=u<<7|u>>>32-7;u=x9+x5|0;x13^=u<<9|u>>>32-9;u=x13+x9|0;x1^=u<<13|u>>>32-13;u=x1+x13|0;x5^=u<<18|u>>>32-18;u=x10+x6|0;x14^=u<<7|u>>>32-7;u=x14+x10|0;x2^=u<<9|u>>>32-9;u=x2+x14|0;x6^=u<<13|u>>>32-13;u=x6+x2|0;x10^=u<<18|u>>>32-18;u=x15+x11|0;x3^=u<<7|u>>>32-7;u=x3+x15|0;x7^=u<<9|u>>>32-9;u=x7+x3|0;x11^=u<<13|u>>>32-13;u=x11+x7|0;x15^=u<<18|u>>>32-18;u=x0+x3|0;x1^=u<<7|u>>>32-7;u=x1+x0|0;x2^=u<<9|u>>>32-9;u=x2+x1|0;x3^=u<<13|u>>>32-13;u=x3+x2|0;x0^=u<<18|u>>>32-18;u=x5+x4|0;x6^=u<<7|u>>>32-7;u=x6+x5|0;x7^=u<<9|u>>>32-9;u=x7+x6|0;x4^=u<<13|u>>>32-13;u=x4+x7|0;x5^=u<<18|u>>>32-18;u=x10+x9|0;x11^=u<<7|u>>>32-7;u=x11+x10|0;x8^=u<<9|u>>>32-9;u=x8+x11|0;x9^=u<<13|u>>>32-13;u=x9+x8|0;x10^=u<<18|u>>>32-18;u=x15+x14|0;x12^=u<<7|u>>>32-7;u=x12+x15|0;x13^=u<<9|u>>>32-9;u=x13+x12|0;x14^=u<<13|u>>>32-13;u=x14+x13|0;x15^=u<<18|u>>>32-18;}o[0]=x0>>>0&0xff;o[1]=x0>>>8&0xff;o[2]=x0>>>16&0xff;o[3]=x0>>>24&0xff;o[4]=x5>>>0&0xff;o[5]=x5>>>8&0xff;o[6]=x5>>>16&0xff;o[7]=x5>>>24&0xff;o[8]=x10>>>0&0xff;o[9]=x10>>>8&0xff;o[10]=x10>>>16&0xff;o[11]=x10>>>24&0xff;o[12]=x15>>>0&0xff;o[13]=x15>>>8&0xff;o[14]=x15>>>16&0xff;o[15]=x15>>>24&0xff;o[16]=x6>>>0&0xff;o[17]=x6>>>8&0xff;o[18]=x6>>>16&0xff;o[19]=x6>>>24&0xff;o[20]=x7>>>0&0xff;o[21]=x7>>>8&0xff;o[22]=x7>>>16&0xff;o[23]=x7>>>24&0xff;o[24]=x8>>>0&0xff;o[25]=x8>>>8&0xff;o[26]=x8>>>16&0xff;o[27]=x8>>>24&0xff;o[28]=x9>>>0&0xff;o[29]=x9>>>8&0xff;o[30]=x9>>>16&0xff;o[31]=x9>>>24&0xff;}function crypto_core_salsa20(out,inp,k,c){core_salsa20(out,inp,k,c);}function crypto_core_hsalsa20(out,inp,k,c){core_hsalsa20(out,inp,k,c);}var sigma=new Uint8Array([101,120,112,97,110,100,32,51,50,45,98,121,116,101,32,107]);// "expand 32-byte k"
	function crypto_stream_salsa20_xor(c,cpos,m,mpos,b,n,k){var z=new Uint8Array(16),x=new Uint8Array(64);var u,i;for(i=0;i<16;i++){z[i]=0;}for(i=0;i<8;i++){z[i]=n[i];}while(b>=64){crypto_core_salsa20(x,z,k,sigma);for(i=0;i<64;i++){c[cpos+i]=m[mpos+i]^x[i];}u=1;for(i=8;i<16;i++){u=u+(z[i]&0xff)|0;z[i]=u&0xff;u>>>=8;}b-=64;cpos+=64;mpos+=64;}if(b>0){crypto_core_salsa20(x,z,k,sigma);for(i=0;i<b;i++){c[cpos+i]=m[mpos+i]^x[i];}}return 0;}function crypto_stream_salsa20(c,cpos,b,n,k){var z=new Uint8Array(16),x=new Uint8Array(64);var u,i;for(i=0;i<16;i++){z[i]=0;}for(i=0;i<8;i++){z[i]=n[i];}while(b>=64){crypto_core_salsa20(x,z,k,sigma);for(i=0;i<64;i++){c[cpos+i]=x[i];}u=1;for(i=8;i<16;i++){u=u+(z[i]&0xff)|0;z[i]=u&0xff;u>>>=8;}b-=64;cpos+=64;}if(b>0){crypto_core_salsa20(x,z,k,sigma);for(i=0;i<b;i++){c[cpos+i]=x[i];}}return 0;}function crypto_stream(c,cpos,d,n,k){var s=new Uint8Array(32);crypto_core_hsalsa20(s,n,k,sigma);var sn=new Uint8Array(8);for(var i=0;i<8;i++){sn[i]=n[i+16];}return crypto_stream_salsa20(c,cpos,d,sn,s);}function crypto_stream_xor(c,cpos,m,mpos,d,n,k){var s=new Uint8Array(32);crypto_core_hsalsa20(s,n,k,sigma);var sn=new Uint8Array(8);for(var i=0;i<8;i++){sn[i]=n[i+16];}return crypto_stream_salsa20_xor(c,cpos,m,mpos,d,sn,s);}/*
	* Port of Andrew Moon's Poly1305-donna-16. Public domain.
	* https://github.com/floodyberry/poly1305-donna
	*/var poly1305=function poly1305(key){this.buffer=new Uint8Array(16);this.r=new Uint16Array(10);this.h=new Uint16Array(10);this.pad=new Uint16Array(8);this.leftover=0;this.fin=0;var t0,t1,t2,t3,t4,t5,t6,t7;t0=key[0]&0xff|(key[1]&0xff)<<8;this.r[0]=t0&0x1fff;t1=key[2]&0xff|(key[3]&0xff)<<8;this.r[1]=(t0>>>13|t1<<3)&0x1fff;t2=key[4]&0xff|(key[5]&0xff)<<8;this.r[2]=(t1>>>10|t2<<6)&0x1f03;t3=key[6]&0xff|(key[7]&0xff)<<8;this.r[3]=(t2>>>7|t3<<9)&0x1fff;t4=key[8]&0xff|(key[9]&0xff)<<8;this.r[4]=(t3>>>4|t4<<12)&0x00ff;this.r[5]=t4>>>1&0x1ffe;t5=key[10]&0xff|(key[11]&0xff)<<8;this.r[6]=(t4>>>14|t5<<2)&0x1fff;t6=key[12]&0xff|(key[13]&0xff)<<8;this.r[7]=(t5>>>11|t6<<5)&0x1f81;t7=key[14]&0xff|(key[15]&0xff)<<8;this.r[8]=(t6>>>8|t7<<8)&0x1fff;this.r[9]=t7>>>5&0x007f;this.pad[0]=key[16]&0xff|(key[17]&0xff)<<8;this.pad[1]=key[18]&0xff|(key[19]&0xff)<<8;this.pad[2]=key[20]&0xff|(key[21]&0xff)<<8;this.pad[3]=key[22]&0xff|(key[23]&0xff)<<8;this.pad[4]=key[24]&0xff|(key[25]&0xff)<<8;this.pad[5]=key[26]&0xff|(key[27]&0xff)<<8;this.pad[6]=key[28]&0xff|(key[29]&0xff)<<8;this.pad[7]=key[30]&0xff|(key[31]&0xff)<<8;};poly1305.prototype.blocks=function(m,mpos,bytes){var hibit=this.fin?0:1<<11;var t0,t1,t2,t3,t4,t5,t6,t7,c;var d0,d1,d2,d3,d4,d5,d6,d7,d8,d9;var h0=this.h[0],h1=this.h[1],h2=this.h[2],h3=this.h[3],h4=this.h[4],h5=this.h[5],h6=this.h[6],h7=this.h[7],h8=this.h[8],h9=this.h[9];var r0=this.r[0],r1=this.r[1],r2=this.r[2],r3=this.r[3],r4=this.r[4],r5=this.r[5],r6=this.r[6],r7=this.r[7],r8=this.r[8],r9=this.r[9];while(bytes>=16){t0=m[mpos+0]&0xff|(m[mpos+1]&0xff)<<8;h0+=t0&0x1fff;t1=m[mpos+2]&0xff|(m[mpos+3]&0xff)<<8;h1+=(t0>>>13|t1<<3)&0x1fff;t2=m[mpos+4]&0xff|(m[mpos+5]&0xff)<<8;h2+=(t1>>>10|t2<<6)&0x1fff;t3=m[mpos+6]&0xff|(m[mpos+7]&0xff)<<8;h3+=(t2>>>7|t3<<9)&0x1fff;t4=m[mpos+8]&0xff|(m[mpos+9]&0xff)<<8;h4+=(t3>>>4|t4<<12)&0x1fff;h5+=t4>>>1&0x1fff;t5=m[mpos+10]&0xff|(m[mpos+11]&0xff)<<8;h6+=(t4>>>14|t5<<2)&0x1fff;t6=m[mpos+12]&0xff|(m[mpos+13]&0xff)<<8;h7+=(t5>>>11|t6<<5)&0x1fff;t7=m[mpos+14]&0xff|(m[mpos+15]&0xff)<<8;h8+=(t6>>>8|t7<<8)&0x1fff;h9+=t7>>>5|hibit;c=0;d0=c;d0+=h0*r0;d0+=h1*(5*r9);d0+=h2*(5*r8);d0+=h3*(5*r7);d0+=h4*(5*r6);c=d0>>>13;d0&=0x1fff;d0+=h5*(5*r5);d0+=h6*(5*r4);d0+=h7*(5*r3);d0+=h8*(5*r2);d0+=h9*(5*r1);c+=d0>>>13;d0&=0x1fff;d1=c;d1+=h0*r1;d1+=h1*r0;d1+=h2*(5*r9);d1+=h3*(5*r8);d1+=h4*(5*r7);c=d1>>>13;d1&=0x1fff;d1+=h5*(5*r6);d1+=h6*(5*r5);d1+=h7*(5*r4);d1+=h8*(5*r3);d1+=h9*(5*r2);c+=d1>>>13;d1&=0x1fff;d2=c;d2+=h0*r2;d2+=h1*r1;d2+=h2*r0;d2+=h3*(5*r9);d2+=h4*(5*r8);c=d2>>>13;d2&=0x1fff;d2+=h5*(5*r7);d2+=h6*(5*r6);d2+=h7*(5*r5);d2+=h8*(5*r4);d2+=h9*(5*r3);c+=d2>>>13;d2&=0x1fff;d3=c;d3+=h0*r3;d3+=h1*r2;d3+=h2*r1;d3+=h3*r0;d3+=h4*(5*r9);c=d3>>>13;d3&=0x1fff;d3+=h5*(5*r8);d3+=h6*(5*r7);d3+=h7*(5*r6);d3+=h8*(5*r5);d3+=h9*(5*r4);c+=d3>>>13;d3&=0x1fff;d4=c;d4+=h0*r4;d4+=h1*r3;d4+=h2*r2;d4+=h3*r1;d4+=h4*r0;c=d4>>>13;d4&=0x1fff;d4+=h5*(5*r9);d4+=h6*(5*r8);d4+=h7*(5*r7);d4+=h8*(5*r6);d4+=h9*(5*r5);c+=d4>>>13;d4&=0x1fff;d5=c;d5+=h0*r5;d5+=h1*r4;d5+=h2*r3;d5+=h3*r2;d5+=h4*r1;c=d5>>>13;d5&=0x1fff;d5+=h5*r0;d5+=h6*(5*r9);d5+=h7*(5*r8);d5+=h8*(5*r7);d5+=h9*(5*r6);c+=d5>>>13;d5&=0x1fff;d6=c;d6+=h0*r6;d6+=h1*r5;d6+=h2*r4;d6+=h3*r3;d6+=h4*r2;c=d6>>>13;d6&=0x1fff;d6+=h5*r1;d6+=h6*r0;d6+=h7*(5*r9);d6+=h8*(5*r8);d6+=h9*(5*r7);c+=d6>>>13;d6&=0x1fff;d7=c;d7+=h0*r7;d7+=h1*r6;d7+=h2*r5;d7+=h3*r4;d7+=h4*r3;c=d7>>>13;d7&=0x1fff;d7+=h5*r2;d7+=h6*r1;d7+=h7*r0;d7+=h8*(5*r9);d7+=h9*(5*r8);c+=d7>>>13;d7&=0x1fff;d8=c;d8+=h0*r8;d8+=h1*r7;d8+=h2*r6;d8+=h3*r5;d8+=h4*r4;c=d8>>>13;d8&=0x1fff;d8+=h5*r3;d8+=h6*r2;d8+=h7*r1;d8+=h8*r0;d8+=h9*(5*r9);c+=d8>>>13;d8&=0x1fff;d9=c;d9+=h0*r9;d9+=h1*r8;d9+=h2*r7;d9+=h3*r6;d9+=h4*r5;c=d9>>>13;d9&=0x1fff;d9+=h5*r4;d9+=h6*r3;d9+=h7*r2;d9+=h8*r1;d9+=h9*r0;c+=d9>>>13;d9&=0x1fff;c=(c<<2)+c|0;c=c+d0|0;d0=c&0x1fff;c=c>>>13;d1+=c;h0=d0;h1=d1;h2=d2;h3=d3;h4=d4;h5=d5;h6=d6;h7=d7;h8=d8;h9=d9;mpos+=16;bytes-=16;}this.h[0]=h0;this.h[1]=h1;this.h[2]=h2;this.h[3]=h3;this.h[4]=h4;this.h[5]=h5;this.h[6]=h6;this.h[7]=h7;this.h[8]=h8;this.h[9]=h9;};poly1305.prototype.finish=function(mac,macpos){var g=new Uint16Array(10);var c,mask,f,i;if(this.leftover){i=this.leftover;this.buffer[i++]=1;for(;i<16;i++){this.buffer[i]=0;}this.fin=1;this.blocks(this.buffer,0,16);}c=this.h[1]>>>13;this.h[1]&=0x1fff;for(i=2;i<10;i++){this.h[i]+=c;c=this.h[i]>>>13;this.h[i]&=0x1fff;}this.h[0]+=c*5;c=this.h[0]>>>13;this.h[0]&=0x1fff;this.h[1]+=c;c=this.h[1]>>>13;this.h[1]&=0x1fff;this.h[2]+=c;g[0]=this.h[0]+5;c=g[0]>>>13;g[0]&=0x1fff;for(i=1;i<10;i++){g[i]=this.h[i]+c;c=g[i]>>>13;g[i]&=0x1fff;}g[9]-=1<<13;mask=(c^1)-1;for(i=0;i<10;i++){g[i]&=mask;}mask=~mask;for(i=0;i<10;i++){this.h[i]=this.h[i]&mask|g[i];}this.h[0]=(this.h[0]|this.h[1]<<13)&0xffff;this.h[1]=(this.h[1]>>>3|this.h[2]<<10)&0xffff;this.h[2]=(this.h[2]>>>6|this.h[3]<<7)&0xffff;this.h[3]=(this.h[3]>>>9|this.h[4]<<4)&0xffff;this.h[4]=(this.h[4]>>>12|this.h[5]<<1|this.h[6]<<14)&0xffff;this.h[5]=(this.h[6]>>>2|this.h[7]<<11)&0xffff;this.h[6]=(this.h[7]>>>5|this.h[8]<<8)&0xffff;this.h[7]=(this.h[8]>>>8|this.h[9]<<5)&0xffff;f=this.h[0]+this.pad[0];this.h[0]=f&0xffff;for(i=1;i<8;i++){f=(this.h[i]+this.pad[i]|0)+(f>>>16)|0;this.h[i]=f&0xffff;}mac[macpos+0]=this.h[0]>>>0&0xff;mac[macpos+1]=this.h[0]>>>8&0xff;mac[macpos+2]=this.h[1]>>>0&0xff;mac[macpos+3]=this.h[1]>>>8&0xff;mac[macpos+4]=this.h[2]>>>0&0xff;mac[macpos+5]=this.h[2]>>>8&0xff;mac[macpos+6]=this.h[3]>>>0&0xff;mac[macpos+7]=this.h[3]>>>8&0xff;mac[macpos+8]=this.h[4]>>>0&0xff;mac[macpos+9]=this.h[4]>>>8&0xff;mac[macpos+10]=this.h[5]>>>0&0xff;mac[macpos+11]=this.h[5]>>>8&0xff;mac[macpos+12]=this.h[6]>>>0&0xff;mac[macpos+13]=this.h[6]>>>8&0xff;mac[macpos+14]=this.h[7]>>>0&0xff;mac[macpos+15]=this.h[7]>>>8&0xff;};poly1305.prototype.update=function(m,mpos,bytes){var i,want;if(this.leftover){want=16-this.leftover;if(want>bytes)want=bytes;for(i=0;i<want;i++){this.buffer[this.leftover+i]=m[mpos+i];}bytes-=want;mpos+=want;this.leftover+=want;if(this.leftover<16)return;this.blocks(this.buffer,0,16);this.leftover=0;}if(bytes>=16){want=bytes-bytes%16;this.blocks(m,mpos,want);mpos+=want;bytes-=want;}if(bytes){for(i=0;i<bytes;i++){this.buffer[this.leftover+i]=m[mpos+i];}this.leftover+=bytes;}};function crypto_onetimeauth(out,outpos,m,mpos,n,k){var s=new poly1305(k);s.update(m,mpos,n);s.finish(out,outpos);return 0;}function crypto_onetimeauth_verify(h,hpos,m,mpos,n,k){var x=new Uint8Array(16);crypto_onetimeauth(x,0,m,mpos,n,k);return crypto_verify_16(h,hpos,x,0);}function crypto_secretbox(c,m,d,n,k){var i;if(d<32)return-1;crypto_stream_xor(c,0,m,0,d,n,k);crypto_onetimeauth(c,16,c,32,d-32,c);for(i=0;i<16;i++){c[i]=0;}return 0;}function crypto_secretbox_open(m,c,d,n,k){var i;var x=new Uint8Array(32);if(d<32)return-1;crypto_stream(x,0,32,n,k);if(crypto_onetimeauth_verify(c,16,c,32,d-32,x)!==0)return-1;crypto_stream_xor(m,0,c,0,d,n,k);for(i=0;i<32;i++){m[i]=0;}return 0;}function set25519(r,a){var i;for(i=0;i<16;i++){r[i]=a[i]|0;}}function car25519(o){var i,v,c=1;for(i=0;i<16;i++){v=o[i]+c+65535;c=Math.floor(v/65536);o[i]=v-c*65536;}o[0]+=c-1+37*(c-1);}function sel25519(p,q,b){var t,c=~(b-1);for(var i=0;i<16;i++){t=c&(p[i]^q[i]);p[i]^=t;q[i]^=t;}}function pack25519(o,n){var i,j,b;var m=gf(),t=gf();for(i=0;i<16;i++){t[i]=n[i];}car25519(t);car25519(t);car25519(t);for(j=0;j<2;j++){m[0]=t[0]-0xffed;for(i=1;i<15;i++){m[i]=t[i]-0xffff-(m[i-1]>>16&1);m[i-1]&=0xffff;}m[15]=t[15]-0x7fff-(m[14]>>16&1);b=m[15]>>16&1;m[14]&=0xffff;sel25519(t,m,1-b);}for(i=0;i<16;i++){o[2*i]=t[i]&0xff;o[2*i+1]=t[i]>>8;}}function neq25519(a,b){var c=new Uint8Array(32),d=new Uint8Array(32);pack25519(c,a);pack25519(d,b);return crypto_verify_32(c,0,d,0);}function par25519(a){var d=new Uint8Array(32);pack25519(d,a);return d[0]&1;}function unpack25519(o,n){var i;for(i=0;i<16;i++){o[i]=n[2*i]+(n[2*i+1]<<8);}o[15]&=0x7fff;}function A(o,a,b){for(var i=0;i<16;i++){o[i]=a[i]+b[i];}}function Z(o,a,b){for(var i=0;i<16;i++){o[i]=a[i]-b[i];}}function M(o,a,b){var v,c,t0=0,t1=0,t2=0,t3=0,t4=0,t5=0,t6=0,t7=0,t8=0,t9=0,t10=0,t11=0,t12=0,t13=0,t14=0,t15=0,t16=0,t17=0,t18=0,t19=0,t20=0,t21=0,t22=0,t23=0,t24=0,t25=0,t26=0,t27=0,t28=0,t29=0,t30=0,b0=b[0],b1=b[1],b2=b[2],b3=b[3],b4=b[4],b5=b[5],b6=b[6],b7=b[7],b8=b[8],b9=b[9],b10=b[10],b11=b[11],b12=b[12],b13=b[13],b14=b[14],b15=b[15];v=a[0];t0+=v*b0;t1+=v*b1;t2+=v*b2;t3+=v*b3;t4+=v*b4;t5+=v*b5;t6+=v*b6;t7+=v*b7;t8+=v*b8;t9+=v*b9;t10+=v*b10;t11+=v*b11;t12+=v*b12;t13+=v*b13;t14+=v*b14;t15+=v*b15;v=a[1];t1+=v*b0;t2+=v*b1;t3+=v*b2;t4+=v*b3;t5+=v*b4;t6+=v*b5;t7+=v*b6;t8+=v*b7;t9+=v*b8;t10+=v*b9;t11+=v*b10;t12+=v*b11;t13+=v*b12;t14+=v*b13;t15+=v*b14;t16+=v*b15;v=a[2];t2+=v*b0;t3+=v*b1;t4+=v*b2;t5+=v*b3;t6+=v*b4;t7+=v*b5;t8+=v*b6;t9+=v*b7;t10+=v*b8;t11+=v*b9;t12+=v*b10;t13+=v*b11;t14+=v*b12;t15+=v*b13;t16+=v*b14;t17+=v*b15;v=a[3];t3+=v*b0;t4+=v*b1;t5+=v*b2;t6+=v*b3;t7+=v*b4;t8+=v*b5;t9+=v*b6;t10+=v*b7;t11+=v*b8;t12+=v*b9;t13+=v*b10;t14+=v*b11;t15+=v*b12;t16+=v*b13;t17+=v*b14;t18+=v*b15;v=a[4];t4+=v*b0;t5+=v*b1;t6+=v*b2;t7+=v*b3;t8+=v*b4;t9+=v*b5;t10+=v*b6;t11+=v*b7;t12+=v*b8;t13+=v*b9;t14+=v*b10;t15+=v*b11;t16+=v*b12;t17+=v*b13;t18+=v*b14;t19+=v*b15;v=a[5];t5+=v*b0;t6+=v*b1;t7+=v*b2;t8+=v*b3;t9+=v*b4;t10+=v*b5;t11+=v*b6;t12+=v*b7;t13+=v*b8;t14+=v*b9;t15+=v*b10;t16+=v*b11;t17+=v*b12;t18+=v*b13;t19+=v*b14;t20+=v*b15;v=a[6];t6+=v*b0;t7+=v*b1;t8+=v*b2;t9+=v*b3;t10+=v*b4;t11+=v*b5;t12+=v*b6;t13+=v*b7;t14+=v*b8;t15+=v*b9;t16+=v*b10;t17+=v*b11;t18+=v*b12;t19+=v*b13;t20+=v*b14;t21+=v*b15;v=a[7];t7+=v*b0;t8+=v*b1;t9+=v*b2;t10+=v*b3;t11+=v*b4;t12+=v*b5;t13+=v*b6;t14+=v*b7;t15+=v*b8;t16+=v*b9;t17+=v*b10;t18+=v*b11;t19+=v*b12;t20+=v*b13;t21+=v*b14;t22+=v*b15;v=a[8];t8+=v*b0;t9+=v*b1;t10+=v*b2;t11+=v*b3;t12+=v*b4;t13+=v*b5;t14+=v*b6;t15+=v*b7;t16+=v*b8;t17+=v*b9;t18+=v*b10;t19+=v*b11;t20+=v*b12;t21+=v*b13;t22+=v*b14;t23+=v*b15;v=a[9];t9+=v*b0;t10+=v*b1;t11+=v*b2;t12+=v*b3;t13+=v*b4;t14+=v*b5;t15+=v*b6;t16+=v*b7;t17+=v*b8;t18+=v*b9;t19+=v*b10;t20+=v*b11;t21+=v*b12;t22+=v*b13;t23+=v*b14;t24+=v*b15;v=a[10];t10+=v*b0;t11+=v*b1;t12+=v*b2;t13+=v*b3;t14+=v*b4;t15+=v*b5;t16+=v*b6;t17+=v*b7;t18+=v*b8;t19+=v*b9;t20+=v*b10;t21+=v*b11;t22+=v*b12;t23+=v*b13;t24+=v*b14;t25+=v*b15;v=a[11];t11+=v*b0;t12+=v*b1;t13+=v*b2;t14+=v*b3;t15+=v*b4;t16+=v*b5;t17+=v*b6;t18+=v*b7;t19+=v*b8;t20+=v*b9;t21+=v*b10;t22+=v*b11;t23+=v*b12;t24+=v*b13;t25+=v*b14;t26+=v*b15;v=a[12];t12+=v*b0;t13+=v*b1;t14+=v*b2;t15+=v*b3;t16+=v*b4;t17+=v*b5;t18+=v*b6;t19+=v*b7;t20+=v*b8;t21+=v*b9;t22+=v*b10;t23+=v*b11;t24+=v*b12;t25+=v*b13;t26+=v*b14;t27+=v*b15;v=a[13];t13+=v*b0;t14+=v*b1;t15+=v*b2;t16+=v*b3;t17+=v*b4;t18+=v*b5;t19+=v*b6;t20+=v*b7;t21+=v*b8;t22+=v*b9;t23+=v*b10;t24+=v*b11;t25+=v*b12;t26+=v*b13;t27+=v*b14;t28+=v*b15;v=a[14];t14+=v*b0;t15+=v*b1;t16+=v*b2;t17+=v*b3;t18+=v*b4;t19+=v*b5;t20+=v*b6;t21+=v*b7;t22+=v*b8;t23+=v*b9;t24+=v*b10;t25+=v*b11;t26+=v*b12;t27+=v*b13;t28+=v*b14;t29+=v*b15;v=a[15];t15+=v*b0;t16+=v*b1;t17+=v*b2;t18+=v*b3;t19+=v*b4;t20+=v*b5;t21+=v*b6;t22+=v*b7;t23+=v*b8;t24+=v*b9;t25+=v*b10;t26+=v*b11;t27+=v*b12;t28+=v*b13;t29+=v*b14;t30+=v*b15;t0+=38*t16;t1+=38*t17;t2+=38*t18;t3+=38*t19;t4+=38*t20;t5+=38*t21;t6+=38*t22;t7+=38*t23;t8+=38*t24;t9+=38*t25;t10+=38*t26;t11+=38*t27;t12+=38*t28;t13+=38*t29;t14+=38*t30;// t15 left as is
	// first car
	c=1;v=t0+c+65535;c=Math.floor(v/65536);t0=v-c*65536;v=t1+c+65535;c=Math.floor(v/65536);t1=v-c*65536;v=t2+c+65535;c=Math.floor(v/65536);t2=v-c*65536;v=t3+c+65535;c=Math.floor(v/65536);t3=v-c*65536;v=t4+c+65535;c=Math.floor(v/65536);t4=v-c*65536;v=t5+c+65535;c=Math.floor(v/65536);t5=v-c*65536;v=t6+c+65535;c=Math.floor(v/65536);t6=v-c*65536;v=t7+c+65535;c=Math.floor(v/65536);t7=v-c*65536;v=t8+c+65535;c=Math.floor(v/65536);t8=v-c*65536;v=t9+c+65535;c=Math.floor(v/65536);t9=v-c*65536;v=t10+c+65535;c=Math.floor(v/65536);t10=v-c*65536;v=t11+c+65535;c=Math.floor(v/65536);t11=v-c*65536;v=t12+c+65535;c=Math.floor(v/65536);t12=v-c*65536;v=t13+c+65535;c=Math.floor(v/65536);t13=v-c*65536;v=t14+c+65535;c=Math.floor(v/65536);t14=v-c*65536;v=t15+c+65535;c=Math.floor(v/65536);t15=v-c*65536;t0+=c-1+37*(c-1);// second car
	c=1;v=t0+c+65535;c=Math.floor(v/65536);t0=v-c*65536;v=t1+c+65535;c=Math.floor(v/65536);t1=v-c*65536;v=t2+c+65535;c=Math.floor(v/65536);t2=v-c*65536;v=t3+c+65535;c=Math.floor(v/65536);t3=v-c*65536;v=t4+c+65535;c=Math.floor(v/65536);t4=v-c*65536;v=t5+c+65535;c=Math.floor(v/65536);t5=v-c*65536;v=t6+c+65535;c=Math.floor(v/65536);t6=v-c*65536;v=t7+c+65535;c=Math.floor(v/65536);t7=v-c*65536;v=t8+c+65535;c=Math.floor(v/65536);t8=v-c*65536;v=t9+c+65535;c=Math.floor(v/65536);t9=v-c*65536;v=t10+c+65535;c=Math.floor(v/65536);t10=v-c*65536;v=t11+c+65535;c=Math.floor(v/65536);t11=v-c*65536;v=t12+c+65535;c=Math.floor(v/65536);t12=v-c*65536;v=t13+c+65535;c=Math.floor(v/65536);t13=v-c*65536;v=t14+c+65535;c=Math.floor(v/65536);t14=v-c*65536;v=t15+c+65535;c=Math.floor(v/65536);t15=v-c*65536;t0+=c-1+37*(c-1);o[0]=t0;o[1]=t1;o[2]=t2;o[3]=t3;o[4]=t4;o[5]=t5;o[6]=t6;o[7]=t7;o[8]=t8;o[9]=t9;o[10]=t10;o[11]=t11;o[12]=t12;o[13]=t13;o[14]=t14;o[15]=t15;}function S(o,a){M(o,a,a);}function inv25519(o,i){var c=gf();var a;for(a=0;a<16;a++){c[a]=i[a];}for(a=253;a>=0;a--){S(c,c);if(a!==2&&a!==4)M(c,c,i);}for(a=0;a<16;a++){o[a]=c[a];}}function pow2523(o,i){var c=gf();var a;for(a=0;a<16;a++){c[a]=i[a];}for(a=250;a>=0;a--){S(c,c);if(a!==1)M(c,c,i);}for(a=0;a<16;a++){o[a]=c[a];}}function crypto_scalarmult(q,n,p){var z=new Uint8Array(32);var x=new Float64Array(80),r,i;var a=gf(),b=gf(),c=gf(),d=gf(),e=gf(),f=gf();for(i=0;i<31;i++){z[i]=n[i];}z[31]=n[31]&127|64;z[0]&=248;unpack25519(x,p);for(i=0;i<16;i++){b[i]=x[i];d[i]=a[i]=c[i]=0;}a[0]=d[0]=1;for(i=254;i>=0;--i){r=z[i>>>3]>>>(i&7)&1;sel25519(a,b,r);sel25519(c,d,r);A(e,a,c);Z(a,a,c);A(c,b,d);Z(b,b,d);S(d,e);S(f,a);M(a,c,a);M(c,b,e);A(e,a,c);Z(a,a,c);S(b,a);Z(c,d,f);M(a,c,_121665);A(a,a,d);M(c,c,a);M(a,d,f);M(d,b,x);S(b,e);sel25519(a,b,r);sel25519(c,d,r);}for(i=0;i<16;i++){x[i+16]=a[i];x[i+32]=c[i];x[i+48]=b[i];x[i+64]=d[i];}var x32=x.subarray(32);var x16=x.subarray(16);inv25519(x32,x32);M(x16,x16,x32);pack25519(q,x16);return 0;}function crypto_scalarmult_base(q,n){return crypto_scalarmult(q,n,_9);}function crypto_box_keypair(y,x){randombytes(x,32);return crypto_scalarmult_base(y,x);}function crypto_box_beforenm(k,y,x){var s=new Uint8Array(32);crypto_scalarmult(s,x,y);return crypto_core_hsalsa20(k,_0,s,sigma);}var crypto_box_afternm=crypto_secretbox;var crypto_box_open_afternm=crypto_secretbox_open;function crypto_box(c,m,d,n,y,x){var k=new Uint8Array(32);crypto_box_beforenm(k,y,x);return crypto_box_afternm(c,m,d,n,k);}function crypto_box_open(m,c,d,n,y,x){var k=new Uint8Array(32);crypto_box_beforenm(k,y,x);return crypto_box_open_afternm(m,c,d,n,k);}var K=[0x428a2f98,0xd728ae22,0x71374491,0x23ef65cd,0xb5c0fbcf,0xec4d3b2f,0xe9b5dba5,0x8189dbbc,0x3956c25b,0xf348b538,0x59f111f1,0xb605d019,0x923f82a4,0xaf194f9b,0xab1c5ed5,0xda6d8118,0xd807aa98,0xa3030242,0x12835b01,0x45706fbe,0x243185be,0x4ee4b28c,0x550c7dc3,0xd5ffb4e2,0x72be5d74,0xf27b896f,0x80deb1fe,0x3b1696b1,0x9bdc06a7,0x25c71235,0xc19bf174,0xcf692694,0xe49b69c1,0x9ef14ad2,0xefbe4786,0x384f25e3,0x0fc19dc6,0x8b8cd5b5,0x240ca1cc,0x77ac9c65,0x2de92c6f,0x592b0275,0x4a7484aa,0x6ea6e483,0x5cb0a9dc,0xbd41fbd4,0x76f988da,0x831153b5,0x983e5152,0xee66dfab,0xa831c66d,0x2db43210,0xb00327c8,0x98fb213f,0xbf597fc7,0xbeef0ee4,0xc6e00bf3,0x3da88fc2,0xd5a79147,0x930aa725,0x06ca6351,0xe003826f,0x14292967,0x0a0e6e70,0x27b70a85,0x46d22ffc,0x2e1b2138,0x5c26c926,0x4d2c6dfc,0x5ac42aed,0x53380d13,0x9d95b3df,0x650a7354,0x8baf63de,0x766a0abb,0x3c77b2a8,0x81c2c92e,0x47edaee6,0x92722c85,0x1482353b,0xa2bfe8a1,0x4cf10364,0xa81a664b,0xbc423001,0xc24b8b70,0xd0f89791,0xc76c51a3,0x0654be30,0xd192e819,0xd6ef5218,0xd6990624,0x5565a910,0xf40e3585,0x5771202a,0x106aa070,0x32bbd1b8,0x19a4c116,0xb8d2d0c8,0x1e376c08,0x5141ab53,0x2748774c,0xdf8eeb99,0x34b0bcb5,0xe19b48a8,0x391c0cb3,0xc5c95a63,0x4ed8aa4a,0xe3418acb,0x5b9cca4f,0x7763e373,0x682e6ff3,0xd6b2b8a3,0x748f82ee,0x5defb2fc,0x78a5636f,0x43172f60,0x84c87814,0xa1f0ab72,0x8cc70208,0x1a6439ec,0x90befffa,0x23631e28,0xa4506ceb,0xde82bde9,0xbef9a3f7,0xb2c67915,0xc67178f2,0xe372532b,0xca273ece,0xea26619c,0xd186b8c7,0x21c0c207,0xeada7dd6,0xcde0eb1e,0xf57d4f7f,0xee6ed178,0x06f067aa,0x72176fba,0x0a637dc5,0xa2c898a6,0x113f9804,0xbef90dae,0x1b710b35,0x131c471b,0x28db77f5,0x23047d84,0x32caab7b,0x40c72493,0x3c9ebe0a,0x15c9bebc,0x431d67c4,0x9c100d4c,0x4cc5d4be,0xcb3e42b6,0x597f299c,0xfc657e2a,0x5fcb6fab,0x3ad6faec,0x6c44198c,0x4a475817];function crypto_hashblocks_hl(hh,hl,m,n){var wh=new Int32Array(16),wl=new Int32Array(16),bh0,bh1,bh2,bh3,bh4,bh5,bh6,bh7,bl0,bl1,bl2,bl3,bl4,bl5,bl6,bl7,th,tl,i,j,h,l,a,b,c,d;var ah0=hh[0],ah1=hh[1],ah2=hh[2],ah3=hh[3],ah4=hh[4],ah5=hh[5],ah6=hh[6],ah7=hh[7],al0=hl[0],al1=hl[1],al2=hl[2],al3=hl[3],al4=hl[4],al5=hl[5],al6=hl[6],al7=hl[7];var pos=0;while(n>=128){for(i=0;i<16;i++){j=8*i+pos;wh[i]=m[j+0]<<24|m[j+1]<<16|m[j+2]<<8|m[j+3];wl[i]=m[j+4]<<24|m[j+5]<<16|m[j+6]<<8|m[j+7];}for(i=0;i<80;i++){bh0=ah0;bh1=ah1;bh2=ah2;bh3=ah3;bh4=ah4;bh5=ah5;bh6=ah6;bh7=ah7;bl0=al0;bl1=al1;bl2=al2;bl3=al3;bl4=al4;bl5=al5;bl6=al6;bl7=al7;// add
	h=ah7;l=al7;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;// Sigma1
	h=(ah4>>>14|al4<<32-14)^(ah4>>>18|al4<<32-18)^(al4>>>41-32|ah4<<32-(41-32));l=(al4>>>14|ah4<<32-14)^(al4>>>18|ah4<<32-18)^(ah4>>>41-32|al4<<32-(41-32));a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;// Ch
	h=ah4&ah5^~ah4&ah6;l=al4&al5^~al4&al6;a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;// K
	h=K[i*2];l=K[i*2+1];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;// w
	h=wh[i%16];l=wl[i%16];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;th=c&0xffff|d<<16;tl=a&0xffff|b<<16;// add
	h=th;l=tl;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;// Sigma0
	h=(ah0>>>28|al0<<32-28)^(al0>>>34-32|ah0<<32-(34-32))^(al0>>>39-32|ah0<<32-(39-32));l=(al0>>>28|ah0<<32-28)^(ah0>>>34-32|al0<<32-(34-32))^(ah0>>>39-32|al0<<32-(39-32));a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;// Maj
	h=ah0&ah1^ah0&ah2^ah1&ah2;l=al0&al1^al0&al2^al1&al2;a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;bh7=c&0xffff|d<<16;bl7=a&0xffff|b<<16;// add
	h=bh3;l=bl3;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=th;l=tl;a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;bh3=c&0xffff|d<<16;bl3=a&0xffff|b<<16;ah1=bh0;ah2=bh1;ah3=bh2;ah4=bh3;ah5=bh4;ah6=bh5;ah7=bh6;ah0=bh7;al1=bl0;al2=bl1;al3=bl2;al4=bl3;al5=bl4;al6=bl5;al7=bl6;al0=bl7;if(i%16===15){for(j=0;j<16;j++){// add
	h=wh[j];l=wl[j];a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=wh[(j+9)%16];l=wl[(j+9)%16];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;// sigma0
	th=wh[(j+1)%16];tl=wl[(j+1)%16];h=(th>>>1|tl<<32-1)^(th>>>8|tl<<32-8)^th>>>7;l=(tl>>>1|th<<32-1)^(tl>>>8|th<<32-8)^(tl>>>7|th<<32-7);a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;// sigma1
	th=wh[(j+14)%16];tl=wl[(j+14)%16];h=(th>>>19|tl<<32-19)^(tl>>>61-32|th<<32-(61-32))^th>>>6;l=(tl>>>19|th<<32-19)^(th>>>61-32|tl<<32-(61-32))^(tl>>>6|th<<32-6);a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;wh[j]=c&0xffff|d<<16;wl[j]=a&0xffff|b<<16;}}}// add
	h=ah0;l=al0;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[0];l=hl[0];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[0]=ah0=c&0xffff|d<<16;hl[0]=al0=a&0xffff|b<<16;h=ah1;l=al1;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[1];l=hl[1];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[1]=ah1=c&0xffff|d<<16;hl[1]=al1=a&0xffff|b<<16;h=ah2;l=al2;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[2];l=hl[2];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[2]=ah2=c&0xffff|d<<16;hl[2]=al2=a&0xffff|b<<16;h=ah3;l=al3;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[3];l=hl[3];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[3]=ah3=c&0xffff|d<<16;hl[3]=al3=a&0xffff|b<<16;h=ah4;l=al4;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[4];l=hl[4];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[4]=ah4=c&0xffff|d<<16;hl[4]=al4=a&0xffff|b<<16;h=ah5;l=al5;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[5];l=hl[5];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[5]=ah5=c&0xffff|d<<16;hl[5]=al5=a&0xffff|b<<16;h=ah6;l=al6;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[6];l=hl[6];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[6]=ah6=c&0xffff|d<<16;hl[6]=al6=a&0xffff|b<<16;h=ah7;l=al7;a=l&0xffff;b=l>>>16;c=h&0xffff;d=h>>>16;h=hh[7];l=hl[7];a+=l&0xffff;b+=l>>>16;c+=h&0xffff;d+=h>>>16;b+=a>>>16;c+=b>>>16;d+=c>>>16;hh[7]=ah7=c&0xffff|d<<16;hl[7]=al7=a&0xffff|b<<16;pos+=128;n-=128;}return n;}function crypto_hash(out,m,n){var hh=new Int32Array(8),hl=new Int32Array(8),x=new Uint8Array(256),i,b=n;hh[0]=0x6a09e667;hh[1]=0xbb67ae85;hh[2]=0x3c6ef372;hh[3]=0xa54ff53a;hh[4]=0x510e527f;hh[5]=0x9b05688c;hh[6]=0x1f83d9ab;hh[7]=0x5be0cd19;hl[0]=0xf3bcc908;hl[1]=0x84caa73b;hl[2]=0xfe94f82b;hl[3]=0x5f1d36f1;hl[4]=0xade682d1;hl[5]=0x2b3e6c1f;hl[6]=0xfb41bd6b;hl[7]=0x137e2179;crypto_hashblocks_hl(hh,hl,m,n);n%=128;for(i=0;i<n;i++){x[i]=m[b-n+i];}x[n]=128;n=256-128*(n<112?1:0);x[n-9]=0;ts64(x,n-8,b/0x20000000|0,b<<3);crypto_hashblocks_hl(hh,hl,x,n);for(i=0;i<8;i++){ts64(out,8*i,hh[i],hl[i]);}return 0;}function add(p,q){var a=gf(),b=gf(),c=gf(),d=gf(),e=gf(),f=gf(),g=gf(),h=gf(),t=gf();Z(a,p[1],p[0]);Z(t,q[1],q[0]);M(a,a,t);A(b,p[0],p[1]);A(t,q[0],q[1]);M(b,b,t);M(c,p[3],q[3]);M(c,c,D2);M(d,p[2],q[2]);A(d,d,d);Z(e,b,a);Z(f,d,c);A(g,d,c);A(h,b,a);M(p[0],e,f);M(p[1],h,g);M(p[2],g,f);M(p[3],e,h);}function cswap(p,q,b){var i;for(i=0;i<4;i++){sel25519(p[i],q[i],b);}}function pack(r,p){var tx=gf(),ty=gf(),zi=gf();inv25519(zi,p[2]);M(tx,p[0],zi);M(ty,p[1],zi);pack25519(r,ty);r[31]^=par25519(tx)<<7;}function scalarmult(p,q,s){var b,i;set25519(p[0],gf0);set25519(p[1],gf1);set25519(p[2],gf1);set25519(p[3],gf0);for(i=255;i>=0;--i){b=s[i/8|0]>>(i&7)&1;cswap(p,q,b);add(q,p);add(p,p);cswap(p,q,b);}}function scalarbase(p,s){var q=[gf(),gf(),gf(),gf()];set25519(q[0],X);set25519(q[1],Y);set25519(q[2],gf1);M(q[3],X,Y);scalarmult(p,q,s);}function crypto_sign_keypair(pk,sk,seeded){var d=new Uint8Array(64);var p=[gf(),gf(),gf(),gf()];var i;if(!seeded)randombytes(sk,32);crypto_hash(d,sk,32);d[0]&=248;d[31]&=127;d[31]|=64;scalarbase(p,d);pack(pk,p);for(i=0;i<32;i++){sk[i+32]=pk[i];}return 0;}var L=new Float64Array([0xed,0xd3,0xf5,0x5c,0x1a,0x63,0x12,0x58,0xd6,0x9c,0xf7,0xa2,0xde,0xf9,0xde,0x14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0x10]);function modL(r,x){var carry,i,j,k;for(i=63;i>=32;--i){carry=0;for(j=i-32,k=i-12;j<k;++j){x[j]+=carry-16*x[i]*L[j-(i-32)];carry=x[j]+128>>8;x[j]-=carry*256;}x[j]+=carry;x[i]=0;}carry=0;for(j=0;j<32;j++){x[j]+=carry-(x[31]>>4)*L[j];carry=x[j]>>8;x[j]&=255;}for(j=0;j<32;j++){x[j]-=carry*L[j];}for(i=0;i<32;i++){x[i+1]+=x[i]>>8;r[i]=x[i]&255;}}function reduce(r){var x=new Float64Array(64),i;for(i=0;i<64;i++){x[i]=r[i];}for(i=0;i<64;i++){r[i]=0;}modL(r,x);}// Note: difference from C - smlen returned, not passed as argument.
	function crypto_sign(sm,m,n,sk){var d=new Uint8Array(64),h=new Uint8Array(64),r=new Uint8Array(64);var i,j,x=new Float64Array(64);var p=[gf(),gf(),gf(),gf()];crypto_hash(d,sk,32);d[0]&=248;d[31]&=127;d[31]|=64;var smlen=n+64;for(i=0;i<n;i++){sm[64+i]=m[i];}for(i=0;i<32;i++){sm[32+i]=d[32+i];}crypto_hash(r,sm.subarray(32),n+32);reduce(r);scalarbase(p,r);pack(sm,p);for(i=32;i<64;i++){sm[i]=sk[i];}crypto_hash(h,sm,n+64);reduce(h);for(i=0;i<64;i++){x[i]=0;}for(i=0;i<32;i++){x[i]=r[i];}for(i=0;i<32;i++){for(j=0;j<32;j++){x[i+j]+=h[i]*d[j];}}modL(sm.subarray(32),x);return smlen;}function unpackneg(r,p){var t=gf(),chk=gf(),num=gf(),den=gf(),den2=gf(),den4=gf(),den6=gf();set25519(r[2],gf1);unpack25519(r[1],p);S(num,r[1]);M(den,num,D);Z(num,num,r[2]);A(den,r[2],den);S(den2,den);S(den4,den2);M(den6,den4,den2);M(t,den6,num);M(t,t,den);pow2523(t,t);M(t,t,num);M(t,t,den);M(t,t,den);M(r[0],t,den);S(chk,r[0]);M(chk,chk,den);if(neq25519(chk,num))M(r[0],r[0],I);S(chk,r[0]);M(chk,chk,den);if(neq25519(chk,num))return-1;if(par25519(r[0])===p[31]>>7)Z(r[0],gf0,r[0]);M(r[3],r[0],r[1]);return 0;}function crypto_sign_open(m,sm,n,pk){var i,mlen;var t=new Uint8Array(32),h=new Uint8Array(64);var p=[gf(),gf(),gf(),gf()],q=[gf(),gf(),gf(),gf()];mlen=-1;if(n<64)return-1;if(unpackneg(q,pk))return-1;for(i=0;i<n;i++){m[i]=sm[i];}for(i=0;i<32;i++){m[i+32]=pk[i];}crypto_hash(h,m,n);reduce(h);scalarmult(p,q,h);scalarbase(q,sm.subarray(32));add(p,q);pack(t,p);n-=64;if(crypto_verify_32(sm,0,t,0)){for(i=0;i<n;i++){m[i]=0;}return-1;}for(i=0;i<n;i++){m[i]=sm[i+64];}mlen=n;return mlen;}var crypto_secretbox_KEYBYTES=32,crypto_secretbox_NONCEBYTES=24,crypto_secretbox_ZEROBYTES=32,crypto_secretbox_BOXZEROBYTES=16,crypto_scalarmult_BYTES=32,crypto_scalarmult_SCALARBYTES=32,crypto_box_PUBLICKEYBYTES=32,crypto_box_SECRETKEYBYTES=32,crypto_box_BEFORENMBYTES=32,crypto_box_NONCEBYTES=crypto_secretbox_NONCEBYTES,crypto_box_ZEROBYTES=crypto_secretbox_ZEROBYTES,crypto_box_BOXZEROBYTES=crypto_secretbox_BOXZEROBYTES,crypto_sign_BYTES=64,crypto_sign_PUBLICKEYBYTES=32,crypto_sign_SECRETKEYBYTES=64,crypto_sign_SEEDBYTES=32,crypto_hash_BYTES=64;nacl.lowlevel={crypto_core_hsalsa20:crypto_core_hsalsa20,crypto_stream_xor:crypto_stream_xor,crypto_stream:crypto_stream,crypto_stream_salsa20_xor:crypto_stream_salsa20_xor,crypto_stream_salsa20:crypto_stream_salsa20,crypto_onetimeauth:crypto_onetimeauth,crypto_onetimeauth_verify:crypto_onetimeauth_verify,crypto_verify_16:crypto_verify_16,crypto_verify_32:crypto_verify_32,crypto_secretbox:crypto_secretbox,crypto_secretbox_open:crypto_secretbox_open,crypto_scalarmult:crypto_scalarmult,crypto_scalarmult_base:crypto_scalarmult_base,crypto_box_beforenm:crypto_box_beforenm,crypto_box_afternm:crypto_box_afternm,crypto_box:crypto_box,crypto_box_open:crypto_box_open,crypto_box_keypair:crypto_box_keypair,crypto_hash:crypto_hash,crypto_sign:crypto_sign,crypto_sign_keypair:crypto_sign_keypair,crypto_sign_open:crypto_sign_open,crypto_secretbox_KEYBYTES:crypto_secretbox_KEYBYTES,crypto_secretbox_NONCEBYTES:crypto_secretbox_NONCEBYTES,crypto_secretbox_ZEROBYTES:crypto_secretbox_ZEROBYTES,crypto_secretbox_BOXZEROBYTES:crypto_secretbox_BOXZEROBYTES,crypto_scalarmult_BYTES:crypto_scalarmult_BYTES,crypto_scalarmult_SCALARBYTES:crypto_scalarmult_SCALARBYTES,crypto_box_PUBLICKEYBYTES:crypto_box_PUBLICKEYBYTES,crypto_box_SECRETKEYBYTES:crypto_box_SECRETKEYBYTES,crypto_box_BEFORENMBYTES:crypto_box_BEFORENMBYTES,crypto_box_NONCEBYTES:crypto_box_NONCEBYTES,crypto_box_ZEROBYTES:crypto_box_ZEROBYTES,crypto_box_BOXZEROBYTES:crypto_box_BOXZEROBYTES,crypto_sign_BYTES:crypto_sign_BYTES,crypto_sign_PUBLICKEYBYTES:crypto_sign_PUBLICKEYBYTES,crypto_sign_SECRETKEYBYTES:crypto_sign_SECRETKEYBYTES,crypto_sign_SEEDBYTES:crypto_sign_SEEDBYTES,crypto_hash_BYTES:crypto_hash_BYTES};/* High-level API */function checkLengths(k,n){if(k.length!==crypto_secretbox_KEYBYTES)throw new Error('bad key size');if(n.length!==crypto_secretbox_NONCEBYTES)throw new Error('bad nonce size');}function checkBoxLengths(pk,sk){if(pk.length!==crypto_box_PUBLICKEYBYTES)throw new Error('bad public key size');if(sk.length!==crypto_box_SECRETKEYBYTES)throw new Error('bad secret key size');}function checkArrayTypes(){for(var i=0;i<arguments.length;i++){if(!(arguments[i]instanceof Uint8Array))throw new TypeError('unexpected type, use Uint8Array');}}function cleanup(arr){for(var i=0;i<arr.length;i++){arr[i]=0;}}nacl.randomBytes=function(n){var b=new Uint8Array(n);randombytes(b,n);return b;};nacl.secretbox=function(msg,nonce,key){checkArrayTypes(msg,nonce,key);checkLengths(key,nonce);var m=new Uint8Array(crypto_secretbox_ZEROBYTES+msg.length);var c=new Uint8Array(m.length);for(var i=0;i<msg.length;i++){m[i+crypto_secretbox_ZEROBYTES]=msg[i];}crypto_secretbox(c,m,m.length,nonce,key);return c.subarray(crypto_secretbox_BOXZEROBYTES);};nacl.secretbox.open=function(box,nonce,key){checkArrayTypes(box,nonce,key);checkLengths(key,nonce);var c=new Uint8Array(crypto_secretbox_BOXZEROBYTES+box.length);var m=new Uint8Array(c.length);for(var i=0;i<box.length;i++){c[i+crypto_secretbox_BOXZEROBYTES]=box[i];}if(c.length<32)return null;if(crypto_secretbox_open(m,c,c.length,nonce,key)!==0)return null;return m.subarray(crypto_secretbox_ZEROBYTES);};nacl.secretbox.keyLength=crypto_secretbox_KEYBYTES;nacl.secretbox.nonceLength=crypto_secretbox_NONCEBYTES;nacl.secretbox.overheadLength=crypto_secretbox_BOXZEROBYTES;nacl.scalarMult=function(n,p){checkArrayTypes(n,p);if(n.length!==crypto_scalarmult_SCALARBYTES)throw new Error('bad n size');if(p.length!==crypto_scalarmult_BYTES)throw new Error('bad p size');var q=new Uint8Array(crypto_scalarmult_BYTES);crypto_scalarmult(q,n,p);return q;};nacl.scalarMult.base=function(n){checkArrayTypes(n);if(n.length!==crypto_scalarmult_SCALARBYTES)throw new Error('bad n size');var q=new Uint8Array(crypto_scalarmult_BYTES);crypto_scalarmult_base(q,n);return q;};nacl.scalarMult.scalarLength=crypto_scalarmult_SCALARBYTES;nacl.scalarMult.groupElementLength=crypto_scalarmult_BYTES;nacl.box=function(msg,nonce,publicKey,secretKey){var k=nacl.box.before(publicKey,secretKey);return nacl.secretbox(msg,nonce,k);};nacl.box.before=function(publicKey,secretKey){checkArrayTypes(publicKey,secretKey);checkBoxLengths(publicKey,secretKey);var k=new Uint8Array(crypto_box_BEFORENMBYTES);crypto_box_beforenm(k,publicKey,secretKey);return k;};nacl.box.after=nacl.secretbox;nacl.box.open=function(msg,nonce,publicKey,secretKey){var k=nacl.box.before(publicKey,secretKey);return nacl.secretbox.open(msg,nonce,k);};nacl.box.open.after=nacl.secretbox.open;nacl.box.keyPair=function(){var pk=new Uint8Array(crypto_box_PUBLICKEYBYTES);var sk=new Uint8Array(crypto_box_SECRETKEYBYTES);crypto_box_keypair(pk,sk);return{publicKey:pk,secretKey:sk};};nacl.box.keyPair.fromSecretKey=function(secretKey){checkArrayTypes(secretKey);if(secretKey.length!==crypto_box_SECRETKEYBYTES)throw new Error('bad secret key size');var pk=new Uint8Array(crypto_box_PUBLICKEYBYTES);crypto_scalarmult_base(pk,secretKey);return{publicKey:pk,secretKey:new Uint8Array(secretKey)};};nacl.box.publicKeyLength=crypto_box_PUBLICKEYBYTES;nacl.box.secretKeyLength=crypto_box_SECRETKEYBYTES;nacl.box.sharedKeyLength=crypto_box_BEFORENMBYTES;nacl.box.nonceLength=crypto_box_NONCEBYTES;nacl.box.overheadLength=nacl.secretbox.overheadLength;nacl.sign=function(msg,secretKey){checkArrayTypes(msg,secretKey);if(secretKey.length!==crypto_sign_SECRETKEYBYTES)throw new Error('bad secret key size');var signedMsg=new Uint8Array(crypto_sign_BYTES+msg.length);crypto_sign(signedMsg,msg,msg.length,secretKey);return signedMsg;};nacl.sign.open=function(signedMsg,publicKey){checkArrayTypes(signedMsg,publicKey);if(publicKey.length!==crypto_sign_PUBLICKEYBYTES)throw new Error('bad public key size');var tmp=new Uint8Array(signedMsg.length);var mlen=crypto_sign_open(tmp,signedMsg,signedMsg.length,publicKey);if(mlen<0)return null;var m=new Uint8Array(mlen);for(var i=0;i<m.length;i++){m[i]=tmp[i];}return m;};nacl.sign.detached=function(msg,secretKey){var signedMsg=nacl.sign(msg,secretKey);var sig=new Uint8Array(crypto_sign_BYTES);for(var i=0;i<sig.length;i++){sig[i]=signedMsg[i];}return sig;};nacl.sign.detached.verify=function(msg,sig,publicKey){checkArrayTypes(msg,sig,publicKey);if(sig.length!==crypto_sign_BYTES)throw new Error('bad signature size');if(publicKey.length!==crypto_sign_PUBLICKEYBYTES)throw new Error('bad public key size');var sm=new Uint8Array(crypto_sign_BYTES+msg.length);var m=new Uint8Array(crypto_sign_BYTES+msg.length);var i;for(i=0;i<crypto_sign_BYTES;i++){sm[i]=sig[i];}for(i=0;i<msg.length;i++){sm[i+crypto_sign_BYTES]=msg[i];}return crypto_sign_open(m,sm,sm.length,publicKey)>=0;};nacl.sign.keyPair=function(){var pk=new Uint8Array(crypto_sign_PUBLICKEYBYTES);var sk=new Uint8Array(crypto_sign_SECRETKEYBYTES);crypto_sign_keypair(pk,sk);return{publicKey:pk,secretKey:sk};};nacl.sign.keyPair.fromSecretKey=function(secretKey){checkArrayTypes(secretKey);if(secretKey.length!==crypto_sign_SECRETKEYBYTES)throw new Error('bad secret key size');var pk=new Uint8Array(crypto_sign_PUBLICKEYBYTES);for(var i=0;i<pk.length;i++){pk[i]=secretKey[32+i];}return{publicKey:pk,secretKey:new Uint8Array(secretKey)};};nacl.sign.keyPair.fromSeed=function(seed){checkArrayTypes(seed);if(seed.length!==crypto_sign_SEEDBYTES)throw new Error('bad seed size');var pk=new Uint8Array(crypto_sign_PUBLICKEYBYTES);var sk=new Uint8Array(crypto_sign_SECRETKEYBYTES);for(var i=0;i<32;i++){sk[i]=seed[i];}crypto_sign_keypair(pk,sk,true);return{publicKey:pk,secretKey:sk};};nacl.sign.publicKeyLength=crypto_sign_PUBLICKEYBYTES;nacl.sign.secretKeyLength=crypto_sign_SECRETKEYBYTES;nacl.sign.seedLength=crypto_sign_SEEDBYTES;nacl.sign.signatureLength=crypto_sign_BYTES;nacl.hash=function(msg){checkArrayTypes(msg);var h=new Uint8Array(crypto_hash_BYTES);crypto_hash(h,msg,msg.length);return h;};nacl.hash.hashLength=crypto_hash_BYTES;nacl.verify=function(x,y){checkArrayTypes(x,y);// Zero length arguments are considered not equal.
	if(x.length===0||y.length===0)return false;if(x.length!==y.length)return false;return vn(x,0,y,0,x.length)===0?true:false;};nacl.setPRNG=function(fn){randombytes=fn;};(function(){// Initialize PRNG if environment provides CSPRNG.
	// If not, methods calling randombytes will throw.
	var crypto=typeof self!=='undefined'?self.crypto||self.msCrypto:null;if(crypto&&crypto.getRandomValues){// Browsers.
	var QUOTA=65536;nacl.setPRNG(function(x,n){var i,v=new Uint8Array(n);for(i=0;i<n;i+=QUOTA){crypto.getRandomValues(v.subarray(i,i+Math.min(n-i,QUOTA)));}for(i=0;i<n;i++){x[i]=v[i];}cleanup(v);});}else if(typeof require!=='undefined'){// Node.js.
	crypto=require('crypto');if(crypto&&crypto.randomBytes){nacl.setPRNG(function(x,n){var i,v=crypto.randomBytes(n);for(i=0;i<n;i++){x[i]=v[i];}cleanup(v);});}}})();})(typeof module!=='undefined'&&module.exports?module.exports:self.nacl=self.nacl||{});},{"crypto":24}],131:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';var punycode=require('punycode');var util=require('./util');exports.parse=urlParse;exports.resolve=urlResolve;exports.resolveObject=urlResolveObject;exports.format=urlFormat;exports.Url=Url;function Url(){this.protocol=null;this.slashes=null;this.auth=null;this.host=null;this.port=null;this.hostname=null;this.hash=null;this.search=null;this.query=null;this.pathname=null;this.path=null;this.href=null;}// Reference: RFC 3986, RFC 1808, RFC 2396
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern=/^([a-z0-9.+-]+:)/i,portPattern=/:[0-9]*$/,// Special case for a simple path URL
	simplePathPattern=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,// RFC 2396: characters reserved for delimiting URLs.
	// We actually just auto-escape these.
	delims=['<','>','"','`',' ','\r','\n','\t'],// RFC 2396: characters not allowed for various reasons.
	unwise=['{','}','|','\\','^','`'].concat(delims),// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	autoEscape=['\''].concat(unwise),// Characters that are never ever allowed in a hostname.
	// Note that any invalid chars are also handled, but these
	// are the ones that are *expected* to be seen, so we fast-path
	// them.
	nonHostChars=['%','/','?',';','#'].concat(autoEscape),hostEndingChars=['/','?','#'],hostnameMaxLen=255,hostnamePartPattern=/^[+a-z0-9A-Z_-]{0,63}$/,hostnamePartStart=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,// protocols that can allow "unsafe" and "unwise" chars.
	unsafeProtocol={'javascript':true,'javascript:':true},// protocols that never have a hostname.
	hostlessProtocol={'javascript':true,'javascript:':true},// protocols that always contain a // bit.
	slashedProtocol={'http':true,'https':true,'ftp':true,'gopher':true,'file':true,'http:':true,'https:':true,'ftp:':true,'gopher:':true,'file:':true},querystring=require('querystring');function urlParse(url,parseQueryString,slashesDenoteHost){if(url&&util.isObject(url)&&url instanceof Url)return url;var u=new Url();u.parse(url,parseQueryString,slashesDenoteHost);return u;}Url.prototype.parse=function(url,parseQueryString,slashesDenoteHost){if(!util.isString(url)){throw new TypeError("Parameter 'url' must be a string, not "+(typeof url==="undefined"?"undefined":_typeof(url)));}// Copy chrome, IE, opera backslash-handling behavior.
	// Back slashes before the query string get converted to forward slashes
	// See: https://code.google.com/p/chromium/issues/detail?id=25916
	var queryIndex=url.indexOf('?'),splitter=queryIndex!==-1&&queryIndex<url.indexOf('#')?'?':'#',uSplit=url.split(splitter),slashRegex=/\\/g;uSplit[0]=uSplit[0].replace(slashRegex,'/');url=uSplit.join(splitter);var rest=url;// trim before proceeding.
	// This is to support parse stuff like "  http://foo.com  \n"
	rest=rest.trim();if(!slashesDenoteHost&&url.split('#').length===1){// Try fast path regexp
	var simplePath=simplePathPattern.exec(rest);if(simplePath){this.path=rest;this.href=rest;this.pathname=simplePath[1];if(simplePath[2]){this.search=simplePath[2];if(parseQueryString){this.query=querystring.parse(this.search.substr(1));}else{this.query=this.search.substr(1);}}else if(parseQueryString){this.search='';this.query={};}return this;}}var proto=protocolPattern.exec(rest);if(proto){proto=proto[0];var lowerProto=proto.toLowerCase();this.protocol=lowerProto;rest=rest.substr(proto.length);}// figure out if it's got a host
	// user@server is *always* interpreted as a hostname, and url
	// resolution will treat //foo/bar as host=foo,path=bar because that's
	// how the browser resolves relative URLs.
	if(slashesDenoteHost||proto||rest.match(/^\/\/[^@\/]+@[^@\/]+/)){var slashes=rest.substr(0,2)==='//';if(slashes&&!(proto&&hostlessProtocol[proto])){rest=rest.substr(2);this.slashes=true;}}if(!hostlessProtocol[proto]&&(slashes||proto&&!slashedProtocol[proto])){// there's a hostname.
	// the first instance of /, ?, ;, or # ends the host.
	//
	// If there is an @ in the hostname, then non-host chars *are* allowed
	// to the left of the last @ sign, unless some host-ending character
	// comes *before* the @-sign.
	// URLs are obnoxious.
	//
	// ex:
	// http://a@b@c/ => user:a@b host:c
	// http://a@b?@c => user:a host:c path:/?@c
	// v0.12 TODO(isaacs): This is not quite how Chrome does things.
	// Review our test case against browsers more comprehensively.
	// find the first instance of any hostEndingChars
	var hostEnd=-1;for(var i=0;i<hostEndingChars.length;i++){var hec=rest.indexOf(hostEndingChars[i]);if(hec!==-1&&(hostEnd===-1||hec<hostEnd))hostEnd=hec;}// at this point, either we have an explicit point where the
	// auth portion cannot go past, or the last @ char is the decider.
	var auth,atSign;if(hostEnd===-1){// atSign can be anywhere.
	atSign=rest.lastIndexOf('@');}else{// atSign must be in auth portion.
	// http://a@b/c@d => host:b auth:a path:/c@d
	atSign=rest.lastIndexOf('@',hostEnd);}// Now we have a portion which is definitely the auth.
	// Pull that off.
	if(atSign!==-1){auth=rest.slice(0,atSign);rest=rest.slice(atSign+1);this.auth=decodeURIComponent(auth);}// the host is the remaining to the left of the first non-host char
	hostEnd=-1;for(var i=0;i<nonHostChars.length;i++){var hec=rest.indexOf(nonHostChars[i]);if(hec!==-1&&(hostEnd===-1||hec<hostEnd))hostEnd=hec;}// if we still have not hit it, then the entire thing is a host.
	if(hostEnd===-1)hostEnd=rest.length;this.host=rest.slice(0,hostEnd);rest=rest.slice(hostEnd);// pull out port.
	this.parseHost();// we've indicated that there is a hostname,
	// so even if it's empty, it has to be present.
	this.hostname=this.hostname||'';// if hostname begins with [ and ends with ]
	// assume that it's an IPv6 address.
	var ipv6Hostname=this.hostname[0]==='['&&this.hostname[this.hostname.length-1]===']';// validate a little.
	if(!ipv6Hostname){var hostparts=this.hostname.split(/\./);for(var i=0,l=hostparts.length;i<l;i++){var part=hostparts[i];if(!part)continue;if(!part.match(hostnamePartPattern)){var newpart='';for(var j=0,k=part.length;j<k;j++){if(part.charCodeAt(j)>127){// we replace non-ASCII char with a temporary placeholder
	// we need this to make sure size of hostname is not
	// broken by replacing non-ASCII by nothing
	newpart+='x';}else{newpart+=part[j];}}// we test again with ASCII char only
	if(!newpart.match(hostnamePartPattern)){var validParts=hostparts.slice(0,i);var notHost=hostparts.slice(i+1);var bit=part.match(hostnamePartStart);if(bit){validParts.push(bit[1]);notHost.unshift(bit[2]);}if(notHost.length){rest='/'+notHost.join('.')+rest;}this.hostname=validParts.join('.');break;}}}}if(this.hostname.length>hostnameMaxLen){this.hostname='';}else{// hostnames are always lower case.
	this.hostname=this.hostname.toLowerCase();}if(!ipv6Hostname){// IDNA Support: Returns a punycoded representation of "domain".
	// It only converts parts of the domain name that
	// have non-ASCII characters, i.e. it doesn't matter if
	// you call it with a domain that already is ASCII-only.
	this.hostname=punycode.toASCII(this.hostname);}var p=this.port?':'+this.port:'';var h=this.hostname||'';this.host=h+p;this.href+=this.host;// strip [ and ] from the hostname
	// the host field still retains them, though
	if(ipv6Hostname){this.hostname=this.hostname.substr(1,this.hostname.length-2);if(rest[0]!=='/'){rest='/'+rest;}}}// now rest is set to the post-host stuff.
	// chop off any delim chars.
	if(!unsafeProtocol[lowerProto]){// First, make 100% sure that any "autoEscape" chars get
	// escaped, even if encodeURIComponent doesn't think they
	// need to be.
	for(var i=0,l=autoEscape.length;i<l;i++){var ae=autoEscape[i];if(rest.indexOf(ae)===-1)continue;var esc=encodeURIComponent(ae);if(esc===ae){esc=escape(ae);}rest=rest.split(ae).join(esc);}}// chop off from the tail first.
	var hash=rest.indexOf('#');if(hash!==-1){// got a fragment string.
	this.hash=rest.substr(hash);rest=rest.slice(0,hash);}var qm=rest.indexOf('?');if(qm!==-1){this.search=rest.substr(qm);this.query=rest.substr(qm+1);if(parseQueryString){this.query=querystring.parse(this.query);}rest=rest.slice(0,qm);}else if(parseQueryString){// no query string, but parseQueryString still requested
	this.search='';this.query={};}if(rest)this.pathname=rest;if(slashedProtocol[lowerProto]&&this.hostname&&!this.pathname){this.pathname='/';}//to support http.request
	if(this.pathname||this.search){var p=this.pathname||'';var s=this.search||'';this.path=p+s;}// finally, reconstruct the href based on what has been validated.
	this.href=this.format();return this;};// format a parsed object into a url string
	function urlFormat(obj){// ensure it's an object, and not a string url.
	// If it's an obj, this is a no-op.
	// this way, you can call url_format() on strings
	// to clean up potentially wonky urls.
	if(util.isString(obj))obj=urlParse(obj);if(!(obj instanceof Url))return Url.prototype.format.call(obj);return obj.format();}Url.prototype.format=function(){var auth=this.auth||'';if(auth){auth=encodeURIComponent(auth);auth=auth.replace(/%3A/i,':');auth+='@';}var protocol=this.protocol||'',pathname=this.pathname||'',hash=this.hash||'',host=false,query='';if(this.host){host=auth+this.host;}else if(this.hostname){host=auth+(this.hostname.indexOf(':')===-1?this.hostname:'['+this.hostname+']');if(this.port){host+=':'+this.port;}}if(this.query&&util.isObject(this.query)&&Object.keys(this.query).length){query=querystring.stringify(this.query);}var search=this.search||query&&'?'+query||'';if(protocol&&protocol.substr(-1)!==':')protocol+=':';// only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	// unless they had them to begin with.
	if(this.slashes||(!protocol||slashedProtocol[protocol])&&host!==false){host='//'+(host||'');if(pathname&&pathname.charAt(0)!=='/')pathname='/'+pathname;}else if(!host){host='';}if(hash&&hash.charAt(0)!=='#')hash='#'+hash;if(search&&search.charAt(0)!=='?')search='?'+search;pathname=pathname.replace(/[?#]/g,function(match){return encodeURIComponent(match);});search=search.replace('#','%23');return protocol+host+pathname+search+hash;};function urlResolve(source,relative){return urlParse(source,false,true).resolve(relative);}Url.prototype.resolve=function(relative){return this.resolveObject(urlParse(relative,false,true)).format();};function urlResolveObject(source,relative){if(!source)return relative;return urlParse(source,false,true).resolveObject(relative);}Url.prototype.resolveObject=function(relative){if(util.isString(relative)){var rel=new Url();rel.parse(relative,false,true);relative=rel;}var result=new Url();var tkeys=Object.keys(this);for(var tk=0;tk<tkeys.length;tk++){var tkey=tkeys[tk];result[tkey]=this[tkey];}// hash is always overridden, no matter what.
	// even href="" will remove it.
	result.hash=relative.hash;// if the relative url is empty, then there's nothing left to do here.
	if(relative.href===''){result.href=result.format();return result;}// hrefs like //foo/bar always cut to the protocol.
	if(relative.slashes&&!relative.protocol){// take everything except the protocol from relative
	var rkeys=Object.keys(relative);for(var rk=0;rk<rkeys.length;rk++){var rkey=rkeys[rk];if(rkey!=='protocol')result[rkey]=relative[rkey];}//urlParse appends trailing / to urls like http://www.example.com
	if(slashedProtocol[result.protocol]&&result.hostname&&!result.pathname){result.path=result.pathname='/';}result.href=result.format();return result;}if(relative.protocol&&relative.protocol!==result.protocol){// if it's a known url protocol, then changing
	// the protocol does weird things
	// first, if it's not file:, then we MUST have a host,
	// and if there was a path
	// to begin with, then we MUST have a path.
	// if it is file:, then the host is dropped,
	// because that's known to be hostless.
	// anything else is assumed to be absolute.
	if(!slashedProtocol[relative.protocol]){var keys=Object.keys(relative);for(var v=0;v<keys.length;v++){var k=keys[v];result[k]=relative[k];}result.href=result.format();return result;}result.protocol=relative.protocol;if(!relative.host&&!hostlessProtocol[relative.protocol]){var relPath=(relative.pathname||'').split('/');while(relPath.length&&!(relative.host=relPath.shift())){}if(!relative.host)relative.host='';if(!relative.hostname)relative.hostname='';if(relPath[0]!=='')relPath.unshift('');if(relPath.length<2)relPath.unshift('');result.pathname=relPath.join('/');}else{result.pathname=relative.pathname;}result.search=relative.search;result.query=relative.query;result.host=relative.host||'';result.auth=relative.auth;result.hostname=relative.hostname||relative.host;result.port=relative.port;// to support http.request
	if(result.pathname||result.search){var p=result.pathname||'';var s=result.search||'';result.path=p+s;}result.slashes=result.slashes||relative.slashes;result.href=result.format();return result;}var isSourceAbs=result.pathname&&result.pathname.charAt(0)==='/',isRelAbs=relative.host||relative.pathname&&relative.pathname.charAt(0)==='/',mustEndAbs=isRelAbs||isSourceAbs||result.host&&relative.pathname,removeAllDots=mustEndAbs,srcPath=result.pathname&&result.pathname.split('/')||[],relPath=relative.pathname&&relative.pathname.split('/')||[],psychotic=result.protocol&&!slashedProtocol[result.protocol];// if the url is a non-slashed url, then relative
	// links like ../.. should be able
	// to crawl up to the hostname, as well.  This is strange.
	// result.protocol has already been set by now.
	// Later on, put the first path part into the host field.
	if(psychotic){result.hostname='';result.port=null;if(result.host){if(srcPath[0]==='')srcPath[0]=result.host;else srcPath.unshift(result.host);}result.host='';if(relative.protocol){relative.hostname=null;relative.port=null;if(relative.host){if(relPath[0]==='')relPath[0]=relative.host;else relPath.unshift(relative.host);}relative.host=null;}mustEndAbs=mustEndAbs&&(relPath[0]===''||srcPath[0]==='');}if(isRelAbs){// it's absolute.
	result.host=relative.host||relative.host===''?relative.host:result.host;result.hostname=relative.hostname||relative.hostname===''?relative.hostname:result.hostname;result.search=relative.search;result.query=relative.query;srcPath=relPath;// fall through to the dot-handling below.
	}else if(relPath.length){// it's relative
	// throw away the existing file, and take the new path instead.
	if(!srcPath)srcPath=[];srcPath.pop();srcPath=srcPath.concat(relPath);result.search=relative.search;result.query=relative.query;}else if(!util.isNullOrUndefined(relative.search)){// just pull out the search.
	// like href='?foo'.
	// Put this after the other two cases because it simplifies the booleans
	if(psychotic){result.hostname=result.host=srcPath.shift();//occationaly the auth can get stuck only in host
	//this especially happens in cases like
	//url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	var authInHost=result.host&&result.host.indexOf('@')>0?result.host.split('@'):false;if(authInHost){result.auth=authInHost.shift();result.host=result.hostname=authInHost.shift();}}result.search=relative.search;result.query=relative.query;//to support http.request
	if(!util.isNull(result.pathname)||!util.isNull(result.search)){result.path=(result.pathname?result.pathname:'')+(result.search?result.search:'');}result.href=result.format();return result;}if(!srcPath.length){// no path at all.  easy.
	// we've already handled the other stuff above.
	result.pathname=null;//to support http.request
	if(result.search){result.path='/'+result.search;}else{result.path=null;}result.href=result.format();return result;}// if a url ENDs in . or .., then it must get a trailing slash.
	// however, if it ends in anything else non-slashy,
	// then it must NOT get a trailing slash.
	var last=srcPath.slice(-1)[0];var hasTrailingSlash=(result.host||relative.host||srcPath.length>1)&&(last==='.'||last==='..')||last==='';// strip single dots, resolve double dots to parent dir
	// if the path tries to go above the root, `up` ends up > 0
	var up=0;for(var i=srcPath.length;i>=0;i--){last=srcPath[i];if(last==='.'){srcPath.splice(i,1);}else if(last==='..'){srcPath.splice(i,1);up++;}else if(up){srcPath.splice(i,1);up--;}}// if the path is allowed to go above the root, restore leading ..s
	if(!mustEndAbs&&!removeAllDots){for(;up--;up){srcPath.unshift('..');}}if(mustEndAbs&&srcPath[0]!==''&&(!srcPath[0]||srcPath[0].charAt(0)!=='/')){srcPath.unshift('');}if(hasTrailingSlash&&srcPath.join('/').substr(-1)!=='/'){srcPath.push('');}var isAbsolute=srcPath[0]===''||srcPath[0]&&srcPath[0].charAt(0)==='/';// put the host back
	if(psychotic){result.hostname=result.host=isAbsolute?'':srcPath.length?srcPath.shift():'';//occationaly the auth can get stuck only in host
	//this especially happens in cases like
	//url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	var authInHost=result.host&&result.host.indexOf('@')>0?result.host.split('@'):false;if(authInHost){result.auth=authInHost.shift();result.host=result.hostname=authInHost.shift();}}mustEndAbs=mustEndAbs||result.host&&srcPath.length;if(mustEndAbs&&!isAbsolute){srcPath.unshift('');}if(!srcPath.length){result.pathname=null;result.path=null;}else{result.pathname=srcPath.join('/');}//to support request.http
	if(!util.isNull(result.pathname)||!util.isNull(result.search)){result.path=(result.pathname?result.pathname:'')+(result.search?result.search:'');}result.auth=relative.auth||result.auth;result.slashes=result.slashes||relative.slashes;result.href=result.format();return result;};Url.prototype.parseHost=function(){var host=this.host;var port=portPattern.exec(host);if(port){port=port[0];if(port!==':'){this.port=port.substr(1);}host=host.substr(0,host.length-port.length);}if(host)this.hostname=host;};},{"./util":132,"punycode":111,"querystring":114}],132:[function(require,module,exports){'use strict';module.exports={isString:function isString(arg){return typeof arg==='string';},isObject:function isObject(arg){return(typeof arg==="undefined"?"undefined":_typeof(arg))==='object'&&arg!==null;},isNull:function isNull(arg){return arg===null;},isNullOrUndefined:function isNullOrUndefined(arg){return arg==null;}};},{}],133:[function(require,module,exports){(function(global){/**
	 * Module exports.
	 */module.exports=deprecate;/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */function deprecate(fn,msg){if(config('noDeprecation')){return fn;}var warned=false;function deprecated(){if(!warned){if(config('throwDeprecation')){throw new Error(msg);}else if(config('traceDeprecation')){console.trace(msg);}else{console.warn(msg);}warned=true;}return fn.apply(this,arguments);}return deprecated;}/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */function config(name){// accessing global.localStorage can trigger a DOMException in sandboxed iframes
	try{if(!global.localStorage)return false;}catch(_){return false;}var val=global.localStorage[name];if(null==val)return false;return String(val).toLowerCase()==='true';}}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],134:[function(require,module,exports){arguments[4][76][0].apply(exports,arguments);},{"dup":76}],135:[function(require,module,exports){module.exports=function isBuffer(arg){return arg&&(typeof arg==="undefined"?"undefined":_typeof(arg))==='object'&&typeof arg.copy==='function'&&typeof arg.fill==='function'&&typeof arg.readUInt8==='function';};},{}],136:[function(require,module,exports){(function(process,global){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	var formatRegExp=/%[sdj%]/g;exports.format=function(f){if(!isString(f)){var objects=[];for(var i=0;i<arguments.length;i++){objects.push(inspect(arguments[i]));}return objects.join(' ');}var i=1;var args=arguments;var len=args.length;var str=String(f).replace(formatRegExp,function(x){if(x==='%%')return'%';if(i>=len)return x;switch(x){case'%s':return String(args[i++]);case'%d':return Number(args[i++]);case'%j':try{return JSON.stringify(args[i++]);}catch(_){return'[Circular]';}default:return x;}});for(var x=args[i];i<len;x=args[++i]){if(isNull(x)||!isObject(x)){str+=' '+x;}else{str+=' '+inspect(x);}}return str;};// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate=function(fn,msg){// Allow for deprecating things in the process of starting up.
	if(isUndefined(global.process)){return function(){return exports.deprecate(fn,msg).apply(this,arguments);};}if(process.noDeprecation===true){return fn;}var warned=false;function deprecated(){if(!warned){if(process.throwDeprecation){throw new Error(msg);}else if(process.traceDeprecation){console.trace(msg);}else{console.error(msg);}warned=true;}return fn.apply(this,arguments);}return deprecated;};var debugs={};var debugEnviron;exports.debuglog=function(set){if(isUndefined(debugEnviron))debugEnviron=process.env.NODE_DEBUG||'';set=set.toUpperCase();if(!debugs[set]){if(new RegExp('\\b'+set+'\\b','i').test(debugEnviron)){var pid=process.pid;debugs[set]=function(){var msg=exports.format.apply(exports,arguments);console.error('%s %d: %s',set,pid,msg);};}else{debugs[set]=function(){};}}return debugs[set];};/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 *//* legacy: obj, showHidden, depth, colors*/function inspect(obj,opts){// default options
	var ctx={seen:[],stylize:stylizeNoColor};// legacy...
	if(arguments.length>=3)ctx.depth=arguments[2];if(arguments.length>=4)ctx.colors=arguments[3];if(isBoolean(opts)){// legacy...
	ctx.showHidden=opts;}else if(opts){// got an "options" object
	exports._extend(ctx,opts);}// set default options
	if(isUndefined(ctx.showHidden))ctx.showHidden=false;if(isUndefined(ctx.depth))ctx.depth=2;if(isUndefined(ctx.colors))ctx.colors=false;if(isUndefined(ctx.customInspect))ctx.customInspect=true;if(ctx.colors)ctx.stylize=stylizeWithColor;return formatValue(ctx,obj,ctx.depth);}exports.inspect=inspect;// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors={'bold':[1,22],'italic':[3,23],'underline':[4,24],'inverse':[7,27],'white':[37,39],'grey':[90,39],'black':[30,39],'blue':[34,39],'cyan':[36,39],'green':[32,39],'magenta':[35,39],'red':[31,39],'yellow':[33,39]};// Don't use 'blue' not visible on cmd.exe
	inspect.styles={'special':'cyan','number':'yellow','boolean':'yellow','undefined':'grey','null':'bold','string':'green','date':'magenta',// "name": intentionally not styling
	'regexp':'red'};function stylizeWithColor(str,styleType){var style=inspect.styles[styleType];if(style){return"\x1B["+inspect.colors[style][0]+'m'+str+"\x1B["+inspect.colors[style][1]+'m';}else{return str;}}function stylizeNoColor(str,styleType){return str;}function arrayToHash(array){var hash={};array.forEach(function(val,idx){hash[val]=true;});return hash;}function formatValue(ctx,value,recurseTimes){// Provide a hook for user-specified inspect functions.
	// Check that value is an object with an inspect function on it
	if(ctx.customInspect&&value&&isFunction(value.inspect)&&// Filter out the util module, it's inspect function is special
	value.inspect!==exports.inspect&&// Also filter out any prototype objects using the circular check.
	!(value.constructor&&value.constructor.prototype===value)){var ret=value.inspect(recurseTimes,ctx);if(!isString(ret)){ret=formatValue(ctx,ret,recurseTimes);}return ret;}// Primitive types cannot have properties
	var primitive=formatPrimitive(ctx,value);if(primitive){return primitive;}// Look up the keys of the object.
	var keys=Object.keys(value);var visibleKeys=arrayToHash(keys);if(ctx.showHidden){keys=Object.getOwnPropertyNames(value);}// IE doesn't make error fields non-enumerable
	// http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	if(isError(value)&&(keys.indexOf('message')>=0||keys.indexOf('description')>=0)){return formatError(value);}// Some type of object without properties can be shortcutted.
	if(keys.length===0){if(isFunction(value)){var name=value.name?': '+value.name:'';return ctx.stylize('[Function'+name+']','special');}if(isRegExp(value)){return ctx.stylize(RegExp.prototype.toString.call(value),'regexp');}if(isDate(value)){return ctx.stylize(Date.prototype.toString.call(value),'date');}if(isError(value)){return formatError(value);}}var base='',array=false,braces=['{','}'];// Make Array say that they are Array
	if(isArray(value)){array=true;braces=['[',']'];}// Make functions say that they are functions
	if(isFunction(value)){var n=value.name?': '+value.name:'';base=' [Function'+n+']';}// Make RegExps say that they are RegExps
	if(isRegExp(value)){base=' '+RegExp.prototype.toString.call(value);}// Make dates with properties first say the date
	if(isDate(value)){base=' '+Date.prototype.toUTCString.call(value);}// Make error with message first say the error
	if(isError(value)){base=' '+formatError(value);}if(keys.length===0&&(!array||value.length==0)){return braces[0]+base+braces[1];}if(recurseTimes<0){if(isRegExp(value)){return ctx.stylize(RegExp.prototype.toString.call(value),'regexp');}else{return ctx.stylize('[Object]','special');}}ctx.seen.push(value);var output;if(array){output=formatArray(ctx,value,recurseTimes,visibleKeys,keys);}else{output=keys.map(function(key){return formatProperty(ctx,value,recurseTimes,visibleKeys,key,array);});}ctx.seen.pop();return reduceToSingleString(output,base,braces);}function formatPrimitive(ctx,value){if(isUndefined(value))return ctx.stylize('undefined','undefined');if(isString(value)){var simple='\''+JSON.stringify(value).replace(/^"|"$/g,'').replace(/'/g,"\\'").replace(/\\"/g,'"')+'\'';return ctx.stylize(simple,'string');}if(isNumber(value))return ctx.stylize(''+value,'number');if(isBoolean(value))return ctx.stylize(''+value,'boolean');// For some reason typeof null is "object", so special case here.
	if(isNull(value))return ctx.stylize('null','null');}function formatError(value){return'['+Error.prototype.toString.call(value)+']';}function formatArray(ctx,value,recurseTimes,visibleKeys,keys){var output=[];for(var i=0,l=value.length;i<l;++i){if(hasOwnProperty(value,String(i))){output.push(formatProperty(ctx,value,recurseTimes,visibleKeys,String(i),true));}else{output.push('');}}keys.forEach(function(key){if(!key.match(/^\d+$/)){output.push(formatProperty(ctx,value,recurseTimes,visibleKeys,key,true));}});return output;}function formatProperty(ctx,value,recurseTimes,visibleKeys,key,array){var name,str,desc;desc=Object.getOwnPropertyDescriptor(value,key)||{value:value[key]};if(desc.get){if(desc.set){str=ctx.stylize('[Getter/Setter]','special');}else{str=ctx.stylize('[Getter]','special');}}else{if(desc.set){str=ctx.stylize('[Setter]','special');}}if(!hasOwnProperty(visibleKeys,key)){name='['+key+']';}if(!str){if(ctx.seen.indexOf(desc.value)<0){if(isNull(recurseTimes)){str=formatValue(ctx,desc.value,null);}else{str=formatValue(ctx,desc.value,recurseTimes-1);}if(str.indexOf('\n')>-1){if(array){str=str.split('\n').map(function(line){return'  '+line;}).join('\n').substr(2);}else{str='\n'+str.split('\n').map(function(line){return'   '+line;}).join('\n');}}}else{str=ctx.stylize('[Circular]','special');}}if(isUndefined(name)){if(array&&key.match(/^\d+$/)){return str;}name=JSON.stringify(''+key);if(name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)){name=name.substr(1,name.length-2);name=ctx.stylize(name,'name');}else{name=name.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'");name=ctx.stylize(name,'string');}}return name+': '+str;}function reduceToSingleString(output,base,braces){var numLinesEst=0;var length=output.reduce(function(prev,cur){numLinesEst++;if(cur.indexOf('\n')>=0)numLinesEst++;return prev+cur.replace(/\u001b\[\d\d?m/g,'').length+1;},0);if(length>60){return braces[0]+(base===''?'':base+'\n ')+' '+output.join(',\n  ')+' '+braces[1];}return braces[0]+base+' '+output.join(', ')+' '+braces[1];}// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar){return Array.isArray(ar);}exports.isArray=isArray;function isBoolean(arg){return typeof arg==='boolean';}exports.isBoolean=isBoolean;function isNull(arg){return arg===null;}exports.isNull=isNull;function isNullOrUndefined(arg){return arg==null;}exports.isNullOrUndefined=isNullOrUndefined;function isNumber(arg){return typeof arg==='number';}exports.isNumber=isNumber;function isString(arg){return typeof arg==='string';}exports.isString=isString;function isSymbol(arg){return(typeof arg==="undefined"?"undefined":_typeof(arg))==='symbol';}exports.isSymbol=isSymbol;function isUndefined(arg){return arg===void 0;}exports.isUndefined=isUndefined;function isRegExp(re){return isObject(re)&&objectToString(re)==='[object RegExp]';}exports.isRegExp=isRegExp;function isObject(arg){return(typeof arg==="undefined"?"undefined":_typeof(arg))==='object'&&arg!==null;}exports.isObject=isObject;function isDate(d){return isObject(d)&&objectToString(d)==='[object Date]';}exports.isDate=isDate;function isError(e){return isObject(e)&&(objectToString(e)==='[object Error]'||e instanceof Error);}exports.isError=isError;function isFunction(arg){return typeof arg==='function';}exports.isFunction=isFunction;function isPrimitive(arg){return arg===null||typeof arg==='boolean'||typeof arg==='number'||typeof arg==='string'||(typeof arg==="undefined"?"undefined":_typeof(arg))==='symbol'||// ES6 symbol
	typeof arg==='undefined';}exports.isPrimitive=isPrimitive;exports.isBuffer=require('./support/isBuffer');function objectToString(o){return Object.prototype.toString.call(o);}function pad(n){return n<10?'0'+n.toString(10):n.toString(10);}var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];// 26 Feb 16:19:34
	function timestamp(){var d=new Date();var time=[pad(d.getHours()),pad(d.getMinutes()),pad(d.getSeconds())].join(':');return[d.getDate(),months[d.getMonth()],time].join(' ');}// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log=function(){console.log('%s - %s',timestamp(),exports.format.apply(exports,arguments));};/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */exports.inherits=require('inherits');exports._extend=function(origin,add){// Don't do anything if add isn't an object
	if(!add||!isObject(add))return origin;var keys=Object.keys(add);var i=keys.length;while(i--){origin[keys[i]]=add[keys[i]];}return origin;};function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop);}}).call(this,require('_process'),typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{"./support/isBuffer":135,"_process":110,"inherits":134}],137:[function(require,module,exports){/** @license MIT License (c) copyright 2013-2014 original author or authors *//**
	 * Collection of helper functions for wrapping and executing 'traditional'
	 * synchronous functions in a promise interface.
	 *
	 * @author Brian Cavalier
	 * @contributor Renato Zannon
	 */(function(define){define(function(require){var when=require('./when');var attempt=when['try'];var _liftAll=require('./lib/liftAll');var _apply=require('./lib/apply')(when.Promise);var slice=Array.prototype.slice;return{lift:lift,liftAll:liftAll,call:attempt,apply:apply,compose:compose};/**
		 * Takes a function and an optional array of arguments (that might be promises),
		 * and calls the function. The return value is a promise whose resolution
		 * depends on the value returned by the function.
		 * @param {function} f function to be called
		 * @param {Array} [args] array of arguments to func
		 * @returns {Promise} promise for the return value of func
		 */function apply(f,args){// slice args just in case the caller passed an Arguments instance
	return _apply(f,this,args==null?[]:slice.call(args));}/**
		 * Takes a 'regular' function and returns a version of that function that
		 * returns a promise instead of a plain value, and handles thrown errors by
		 * returning a rejected promise. Also accepts a list of arguments to be
		 * prepended to the new function, as does Function.prototype.bind.
		 *
		 * The resulting function is promise-aware, in the sense that it accepts
		 * promise arguments, and waits for their resolution.
		 * @param {Function} f function to be bound
		 * @param {...*} [args] arguments to be prepended for the new function @deprecated
		 * @returns {Function} a promise-returning function
		 */function lift(f/*, args... */){var args=arguments.length>1?slice.call(arguments,1):[];return function(){return _apply(f,this,args.concat(slice.call(arguments)));};}/**
		 * Lift all the functions/methods on src
		 * @param {object|function} src source whose functions will be lifted
		 * @param {function?} combine optional function for customizing the lifting
		 *  process. It is passed dst, the lifted function, and the property name of
		 *  the original function on src.
		 * @param {(object|function)?} dst option destination host onto which to place lifted
		 *  functions. If not provided, liftAll returns a new object.
		 * @returns {*} If dst is provided, returns dst with lifted functions as
		 *  properties.  If dst not provided, returns a new object with lifted functions.
		 */function liftAll(src,combine,dst){return _liftAll(lift,combine,dst,src);}/**
		 * Composes multiple functions by piping their return values. It is
		 * transparent to whether the functions return 'regular' values or promises:
		 * the piped argument is always a resolved value. If one of the functions
		 * throws or returns a rejected promise, the composed promise will be also
		 * rejected.
		 *
		 * The arguments (or promises to arguments) given to the returned function (if
		 * any), are passed directly to the first function on the 'pipeline'.
		 * @param {Function} f the function to which the arguments will be passed
		 * @param {...Function} [funcs] functions that will be composed, in order
		 * @returns {Function} a promise-returning composition of the functions
		 */function compose(f/*, funcs... */){var funcs=slice.call(arguments,1);return function(){var thisArg=this;var args=slice.call(arguments);var firstPromise=attempt.apply(thisArg,[f].concat(args));return when.reduce(funcs,function(arg,func){return func.call(thisArg,arg);},firstPromise);};}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"./lib/apply":141,"./lib/liftAll":153,"./when":161}],138:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var makePromise=require('./makePromise');var Scheduler=require('./Scheduler');var async=require('./env').asap;return makePromise({scheduler:new Scheduler(async)});});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"./Scheduler":139,"./env":151,"./makePromise":154}],139:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){// Credit to Twisol (https://github.com/Twisol) for suggesting
	// this type of extensible queue + trampoline approach for next-tick conflation.
	/**
		 * Async task scheduler
		 * @param {function} async function to schedule a single async function
		 * @constructor
		 */function Scheduler(async){this._async=async;this._running=false;this._queue=this;this._queueLen=0;this._afterQueue={};this._afterQueueLen=0;var self=this;this.drain=function(){self._drain();};}/**
		 * Enqueue a task
		 * @param {{ run:function }} task
		 */Scheduler.prototype.enqueue=function(task){this._queue[this._queueLen++]=task;this.run();};/**
		 * Enqueue a task to run after the main task queue
		 * @param {{ run:function }} task
		 */Scheduler.prototype.afterQueue=function(task){this._afterQueue[this._afterQueueLen++]=task;this.run();};Scheduler.prototype.run=function(){if(!this._running){this._running=true;this._async(this.drain);}};/**
		 * Drain the handler queue entirely, and then the after queue
		 */Scheduler.prototype._drain=function(){var i=0;for(;i<this._queueLen;++i){this._queue[i].run();this._queue[i]=void 0;}this._queueLen=0;this._running=false;for(i=0;i<this._afterQueueLen;++i){this._afterQueue[i].run();this._afterQueue[i]=void 0;}this._afterQueueLen=0;};return Scheduler;});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],140:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){/**
		 * Custom error type for promises rejected by promise.timeout
		 * @param {string} message
		 * @constructor
		 */function TimeoutError(message){Error.call(this);this.message=message;this.name=TimeoutError.name;if(typeof Error.captureStackTrace==='function'){Error.captureStackTrace(this,TimeoutError);}}TimeoutError.prototype=Object.create(Error.prototype);TimeoutError.prototype.constructor=TimeoutError;return TimeoutError;});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],141:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){makeApply.tryCatchResolve=tryCatchResolve;return makeApply;function makeApply(Promise,call){if(arguments.length<2){call=tryCatchResolve;}return apply;function apply(f,thisArg,args){var p=Promise._defer();var l=args.length;var params=new Array(l);callAndResolve({f:f,thisArg:thisArg,args:args,params:params,i:l-1,call:call},p._handler);return p;}function callAndResolve(c,h){if(c.i<0){return call(c.f,c.thisArg,c.params,h);}var handler=Promise._handler(c.args[c.i]);handler.fold(callAndResolveNext,c,void 0,h);}function callAndResolveNext(c,x,h){c.params[c.i]=x;c.i-=1;callAndResolve(c,h);}}function tryCatchResolve(f,thisArg,args,resolver){try{resolver.resolve(f.apply(thisArg,args));}catch(e){resolver.reject(e);}}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],142:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var state=require('../state');var applier=require('../apply');return function array(Promise){var applyFold=applier(Promise);var toPromise=Promise.resolve;var all=Promise.all;var ar=Array.prototype.reduce;var arr=Array.prototype.reduceRight;var slice=Array.prototype.slice;// Additional array combinators
	Promise.any=any;Promise.some=some;Promise.settle=settle;Promise.map=map;Promise.filter=filter;Promise.reduce=reduce;Promise.reduceRight=reduceRight;/**
			 * When this promise fulfills with an array, do
			 * onFulfilled.apply(void 0, array)
			 * @param {function} onFulfilled function to apply
			 * @returns {Promise} promise for the result of applying onFulfilled
			 */Promise.prototype.spread=function(onFulfilled){return this.then(all).then(function(array){return onFulfilled.apply(this,array);});};return Promise;/**
			 * One-winner competitive race.
			 * Return a promise that will fulfill when one of the promises
			 * in the input array fulfills, or will reject when all promises
			 * have rejected.
			 * @param {array} promises
			 * @returns {Promise} promise for the first fulfilled value
			 */function any(promises){var p=Promise._defer();var resolver=p._handler;var l=promises.length>>>0;var pending=l;var errors=[];for(var h,x,i=0;i<l;++i){x=promises[i];if(x===void 0&&!(i in promises)){--pending;continue;}h=Promise._handler(x);if(h.state()>0){resolver.become(h);Promise._visitRemaining(promises,i,h);break;}else{h.visit(resolver,handleFulfill,handleReject);}}if(pending===0){resolver.reject(new RangeError('any(): array must not be empty'));}return p;function handleFulfill(x){/*jshint validthis:true*/errors=null;this.resolve(x);// this === resolver
	}function handleReject(e){/*jshint validthis:true*/if(this.resolved){// this === resolver
	return;}errors.push(e);if(--pending===0){this.reject(errors);}}}/**
			 * N-winner competitive race
			 * Return a promise that will fulfill when n input promises have
			 * fulfilled, or will reject when it becomes impossible for n
			 * input promises to fulfill (ie when promises.length - n + 1
			 * have rejected)
			 * @param {array} promises
			 * @param {number} n
			 * @returns {Promise} promise for the earliest n fulfillment values
			 *
			 * @deprecated
			 */function some(promises,n){/*jshint maxcomplexity:7*/var p=Promise._defer();var resolver=p._handler;var results=[];var errors=[];var l=promises.length>>>0;var nFulfill=0;var nReject;var x,i;// reused in both for() loops
	// First pass: count actual array items
	for(i=0;i<l;++i){x=promises[i];if(x===void 0&&!(i in promises)){continue;}++nFulfill;}// Compute actual goals
	n=Math.max(n,0);nReject=nFulfill-n+1;nFulfill=Math.min(n,nFulfill);if(n>nFulfill){resolver.reject(new RangeError('some(): array must contain at least '+n+' item(s), but had '+nFulfill));}else if(nFulfill===0){resolver.resolve(results);}// Second pass: observe each array item, make progress toward goals
	for(i=0;i<l;++i){x=promises[i];if(x===void 0&&!(i in promises)){continue;}Promise._handler(x).visit(resolver,fulfill,reject,resolver.notify);}return p;function fulfill(x){/*jshint validthis:true*/if(this.resolved){// this === resolver
	return;}results.push(x);if(--nFulfill===0){errors=null;this.resolve(results);}}function reject(e){/*jshint validthis:true*/if(this.resolved){// this === resolver
	return;}errors.push(e);if(--nReject===0){results=null;this.reject(errors);}}}/**
			 * Apply f to the value of each promise in a list of promises
			 * and return a new list containing the results.
			 * @param {array} promises
			 * @param {function(x:*, index:Number):*} f mapping function
			 * @returns {Promise}
			 */function map(promises,f){return Promise._traverse(f,promises);}/**
			 * Filter the provided array of promises using the provided predicate.  Input may
			 * contain promises and values
			 * @param {Array} promises array of promises and values
			 * @param {function(x:*, index:Number):boolean} predicate filtering predicate.
			 *  Must return truthy (or promise for truthy) for items to retain.
			 * @returns {Promise} promise that will fulfill with an array containing all items
			 *  for which predicate returned truthy.
			 */function filter(promises,predicate){var a=slice.call(promises);return Promise._traverse(predicate,a).then(function(keep){return filterSync(a,keep);});}function filterSync(promises,keep){// Safe because we know all promises have fulfilled if we've made it this far
	var l=keep.length;var filtered=new Array(l);for(var i=0,j=0;i<l;++i){if(keep[i]){filtered[j++]=Promise._handler(promises[i]).value;}}filtered.length=j;return filtered;}/**
			 * Return a promise that will always fulfill with an array containing
			 * the outcome states of all input promises.  The returned promise
			 * will never reject.
			 * @param {Array} promises
			 * @returns {Promise} promise for array of settled state descriptors
			 */function settle(promises){return all(promises.map(settleOne));}function settleOne(p){// Optimize the case where we get an already-resolved when.js promise
	//  by extracting its state:
	var handler;if(p instanceof Promise){// This is our own Promise type and we can reach its handler internals:
	handler=p._handler.join();}if(handler&&handler.state()===0||!handler){// Either still pending, or not a Promise at all:
	return toPromise(p).then(state.fulfilled,state.rejected);}// The promise is our own, but it is already resolved. Take a shortcut.
	// Since we're not actually handling the resolution, we need to disable
	// rejection reporting.
	handler._unreport();return state.inspect(handler);}/**
			 * Traditional reduce function, similar to `Array.prototype.reduce()`, but
			 * input may contain promises and/or values, and reduceFunc
			 * may return either a value or a promise, *and* initialValue may
			 * be a promise for the starting value.
			 * @param {Array|Promise} promises array or promise for an array of anything,
			 *      may contain a mix of promises and values.
			 * @param {function(accumulated:*, x:*, index:Number):*} f reduce function
			 * @returns {Promise} that will resolve to the final reduced value
			 */function reduce(promises,f/*, initialValue */){return arguments.length>2?ar.call(promises,liftCombine(f),arguments[2]):ar.call(promises,liftCombine(f));}/**
			 * Traditional reduce function, similar to `Array.prototype.reduceRight()`, but
			 * input may contain promises and/or values, and reduceFunc
			 * may return either a value or a promise, *and* initialValue may
			 * be a promise for the starting value.
			 * @param {Array|Promise} promises array or promise for an array of anything,
			 *      may contain a mix of promises and values.
			 * @param {function(accumulated:*, x:*, index:Number):*} f reduce function
			 * @returns {Promise} that will resolve to the final reduced value
			 */function reduceRight(promises,f/*, initialValue */){return arguments.length>2?arr.call(promises,liftCombine(f),arguments[2]):arr.call(promises,liftCombine(f));}function liftCombine(f){return function(z,x,i){return applyFold(f,void 0,[z,x,i]);};}};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"../apply":141,"../state":155}],143:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return function flow(Promise){var resolve=Promise.resolve;var reject=Promise.reject;var origCatch=Promise.prototype['catch'];/**
			 * Handle the ultimate fulfillment value or rejection reason, and assume
			 * responsibility for all errors.  If an error propagates out of result
			 * or handleFatalError, it will be rethrown to the host, resulting in a
			 * loud stack track on most platforms and a crash on some.
			 * @param {function?} onResult
			 * @param {function?} onError
			 * @returns {undefined}
			 */Promise.prototype.done=function(onResult,onError){this._handler.visit(this._handler.receiver,onResult,onError);};/**
			 * Add Error-type and predicate matching to catch.  Examples:
			 * promise.catch(TypeError, handleTypeError)
			 *   .catch(predicate, handleMatchedErrors)
			 *   .catch(handleRemainingErrors)
			 * @param onRejected
			 * @returns {*}
			 */Promise.prototype['catch']=Promise.prototype.otherwise=function(onRejected){if(arguments.length<2){return origCatch.call(this,onRejected);}if(typeof onRejected!=='function'){return this.ensure(rejectInvalidPredicate);}return origCatch.call(this,createCatchFilter(arguments[1],onRejected));};/**
			 * Wraps the provided catch handler, so that it will only be called
			 * if the predicate evaluates truthy
			 * @param {?function} handler
			 * @param {function} predicate
			 * @returns {function} conditional catch handler
			 */function createCatchFilter(handler,predicate){return function(e){return evaluatePredicate(e,predicate)?handler.call(this,e):reject(e);};}/**
			 * Ensures that onFulfilledOrRejected will be called regardless of whether
			 * this promise is fulfilled or rejected.  onFulfilledOrRejected WILL NOT
			 * receive the promises' value or reason.  Any returned value will be disregarded.
			 * onFulfilledOrRejected may throw or return a rejected promise to signal
			 * an additional error.
			 * @param {function} handler handler to be called regardless of
			 *  fulfillment or rejection
			 * @returns {Promise}
			 */Promise.prototype['finally']=Promise.prototype.ensure=function(handler){if(typeof handler!=='function'){return this;}return this.then(function(x){return runSideEffect(handler,this,identity,x);},function(e){return runSideEffect(handler,this,reject,e);});};function runSideEffect(handler,thisArg,propagate,value){var result=handler.call(thisArg);return maybeThenable(result)?propagateValue(result,propagate,value):propagate(value);}function propagateValue(result,propagate,x){return resolve(result).then(function(){return propagate(x);});}/**
			 * Recover from a failure by returning a defaultValue.  If defaultValue
			 * is a promise, it's fulfillment value will be used.  If defaultValue is
			 * a promise that rejects, the returned promise will reject with the
			 * same reason.
			 * @param {*} defaultValue
			 * @returns {Promise} new promise
			 */Promise.prototype['else']=Promise.prototype.orElse=function(defaultValue){return this.then(void 0,function(){return defaultValue;});};/**
			 * Shortcut for .then(function() { return value; })
			 * @param  {*} value
			 * @return {Promise} a promise that:
			 *  - is fulfilled if value is not a promise, or
			 *  - if value is a promise, will fulfill with its value, or reject
			 *    with its reason.
			 */Promise.prototype['yield']=function(value){return this.then(function(){return value;});};/**
			 * Runs a side effect when this promise fulfills, without changing the
			 * fulfillment value.
			 * @param {function} onFulfilledSideEffect
			 * @returns {Promise}
			 */Promise.prototype.tap=function(onFulfilledSideEffect){return this.then(onFulfilledSideEffect)['yield'](this);};return Promise;};function rejectInvalidPredicate(){throw new TypeError('catch predicate must be a function');}function evaluatePredicate(e,predicate){return isError(predicate)?e instanceof predicate:predicate(e);}function isError(predicate){return predicate===Error||predicate!=null&&predicate.prototype instanceof Error;}function maybeThenable(x){return((typeof x==="undefined"?"undefined":_typeof(x))==='object'||typeof x==='function')&&x!==null;}function identity(x){return x;}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],144:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann *//** @author Jeff Escalante */(function(define){'use strict';define(function(){return function fold(Promise){Promise.prototype.fold=function(f,z){var promise=this._beget();this._handler.fold(function(z,x,to){Promise._handler(z).fold(function(x,z,to){to.resolve(f.call(this,z,x));},x,this,to);},z,promise._handler.receiver,promise._handler);return promise;};return Promise;};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],145:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var inspect=require('../state').inspect;return function inspection(Promise){Promise.prototype.inspect=function(){return inspect(Promise._handler(this));};return Promise;};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"../state":155}],146:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return function generate(Promise){var resolve=Promise.resolve;Promise.iterate=iterate;Promise.unfold=unfold;return Promise;/**
			 * @deprecated Use github.com/cujojs/most streams and most.iterate
			 * Generate a (potentially infinite) stream of promised values:
			 * x, f(x), f(f(x)), etc. until condition(x) returns true
			 * @param {function} f function to generate a new x from the previous x
			 * @param {function} condition function that, given the current x, returns
			 *  truthy when the iterate should stop
			 * @param {function} handler function to handle the value produced by f
			 * @param {*|Promise} x starting value, may be a promise
			 * @return {Promise} the result of the last call to f before
			 *  condition returns true
			 */function iterate(f,condition,handler,x){return unfold(function(x){return[x,f(x)];},condition,handler,x);}/**
			 * @deprecated Use github.com/cujojs/most streams and most.unfold
			 * Generate a (potentially infinite) stream of promised values
			 * by applying handler(generator(seed)) iteratively until
			 * condition(seed) returns true.
			 * @param {function} unspool function that generates a [value, newSeed]
			 *  given a seed.
			 * @param {function} condition function that, given the current seed, returns
			 *  truthy when the unfold should stop
			 * @param {function} handler function to handle the value produced by unspool
			 * @param x {*|Promise} starting value, may be a promise
			 * @return {Promise} the result of the last value produced by unspool before
			 *  condition returns true
			 */function unfold(unspool,condition,handler,x){return resolve(x).then(function(seed){return resolve(condition(seed)).then(function(done){return done?seed:resolve(unspool(seed)).spread(next);});});function next(item,newSeed){return resolve(handler(item)).then(function(){return unfold(unspool,condition,handler,newSeed);});}}};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],147:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return function progress(Promise){/**
			 * @deprecated
			 * Register a progress handler for this promise
			 * @param {function} onProgress
			 * @returns {Promise}
			 */Promise.prototype.progress=function(onProgress){return this.then(void 0,void 0,onProgress);};return Promise;};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],148:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var env=require('../env');var TimeoutError=require('../TimeoutError');function setTimeout(f,ms,x,y){return env.setTimer(function(){f(x,y,ms);},ms);}return function timed(Promise){/**
			 * Return a new promise whose fulfillment value is revealed only
			 * after ms milliseconds
			 * @param {number} ms milliseconds
			 * @returns {Promise}
			 */Promise.prototype.delay=function(ms){var p=this._beget();this._handler.fold(handleDelay,ms,void 0,p._handler);return p;};function handleDelay(ms,x,h){setTimeout(resolveDelay,ms,x,h);}function resolveDelay(x,h){h.resolve(x);}/**
			 * Return a new promise that rejects after ms milliseconds unless
			 * this promise fulfills earlier, in which case the returned promise
			 * fulfills with the same value.
			 * @param {number} ms milliseconds
			 * @param {Error|*=} reason optional rejection reason to use, defaults
			 *   to a TimeoutError if not provided
			 * @returns {Promise}
			 */Promise.prototype.timeout=function(ms,reason){var p=this._beget();var h=p._handler;var t=setTimeout(onTimeout,ms,reason,p._handler);this._handler.visit(h,function onFulfill(x){env.clearTimer(t);this.resolve(x);// this = h
	},function onReject(x){env.clearTimer(t);this.reject(x);// this = h
	},h.notify);return p;};function onTimeout(reason,h,ms){var e=typeof reason==='undefined'?new TimeoutError('timed out after '+ms+'ms'):reason;h.reject(e);}return Promise;};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"../TimeoutError":140,"../env":151}],149:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var setTimer=require('../env').setTimer;var format=require('../format');return function unhandledRejection(Promise){var logError=noop;var logInfo=noop;var localConsole;if(typeof console!=='undefined'){// Alias console to prevent things like uglify's drop_console option from
	// removing console.log/error. Unhandled rejections fall into the same
	// category as uncaught exceptions, and build tools shouldn't silence them.
	localConsole=console;logError=typeof localConsole.error!=='undefined'?function(e){localConsole.error(e);}:function(e){localConsole.log(e);};logInfo=typeof localConsole.info!=='undefined'?function(e){localConsole.info(e);}:function(e){localConsole.log(e);};}Promise.onPotentiallyUnhandledRejection=function(rejection){enqueue(report,rejection);};Promise.onPotentiallyUnhandledRejectionHandled=function(rejection){enqueue(unreport,rejection);};Promise.onFatalRejection=function(rejection){enqueue(throwit,rejection.value);};var tasks=[];var reported=[];var running=null;function report(r){if(!r.handled){reported.push(r);logError('Potentially unhandled rejection ['+r.id+'] '+format.formatError(r.value));}}function unreport(r){var i=reported.indexOf(r);if(i>=0){reported.splice(i,1);logInfo('Handled previous rejection ['+r.id+'] '+format.formatObject(r.value));}}function enqueue(f,x){tasks.push(f,x);if(running===null){running=setTimer(flush,0);}}function flush(){running=null;while(tasks.length>0){tasks.shift()(tasks.shift());}}return Promise;};function throwit(e){throw e;}function noop(){}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"../env":151,"../format":152}],150:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return function addWith(Promise){/**
			 * Returns a promise whose handlers will be called with `this` set to
			 * the supplied receiver.  Subsequent promises derived from the
			 * returned promise will also have their handlers called with receiver
			 * as `this`. Calling `with` with undefined or no arguments will return
			 * a promise whose handlers will again be called in the usual Promises/A+
			 * way (no `this`) thus safely undoing any previous `with` in the
			 * promise chain.
			 *
			 * WARNING: Promises returned from `with`/`withThis` are NOT Promises/A+
			 * compliant, specifically violating 2.2.5 (http://promisesaplus.com/#point-41)
			 *
			 * @param {object} receiver `this` value for all handlers attached to
			 *  the returned promise.
			 * @returns {Promise}
			 */Promise.prototype['with']=Promise.prototype.withThis=function(receiver){var p=this._beget();var child=p._handler;child.receiver=receiver;this._handler.chain(child,receiver);return p;};return Promise;};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],151:[function(require,module,exports){(function(process){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann *//*global process,document,setTimeout,clearTimeout,MutationObserver,WebKitMutationObserver*/(function(define){'use strict';define(function(require){/*jshint maxcomplexity:6*/// Sniff "best" async scheduling option
	// Prefer process.nextTick or MutationObserver, then check for
	// setTimeout, and finally vertx, since its the only env that doesn't
	// have setTimeout
	var MutationObs;var capturedSetTimeout=typeof setTimeout!=='undefined'&&setTimeout;// Default env
	var setTimer=function setTimer(f,ms){return setTimeout(f,ms);};var clearTimer=function clearTimer(t){return clearTimeout(t);};var asap=function asap(f){return capturedSetTimeout(f,0);};// Detect specific env
	if(isNode()){// Node
	asap=function asap(f){return process.nextTick(f);};}else if(MutationObs=hasMutationObserver()){// Modern browser
	asap=initMutationObserver(MutationObs);}else if(!capturedSetTimeout){// vert.x
	var vertxRequire=require;var vertx=vertxRequire('vertx');setTimer=function setTimer(f,ms){return vertx.setTimer(ms,f);};clearTimer=vertx.cancelTimer;asap=vertx.runOnLoop||vertx.runOnContext;}return{setTimer:setTimer,clearTimer:clearTimer,asap:asap};function isNode(){return typeof process!=='undefined'&&Object.prototype.toString.call(process)==='[object process]';}function hasMutationObserver(){return typeof MutationObserver!=='undefined'&&MutationObserver||typeof WebKitMutationObserver!=='undefined'&&WebKitMutationObserver;}function initMutationObserver(MutationObserver){var scheduled;var node=document.createTextNode('');var o=new MutationObserver(run);o.observe(node,{characterData:true});function run(){var f=scheduled;scheduled=void 0;f();}var i=0;return function(f){scheduled=f;node.data=i^=1;};}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});}).call(this,require('_process'));},{"_process":110}],152:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return{formatError:formatError,formatObject:formatObject,tryStringify:tryStringify};/**
		 * Format an error into a string.  If e is an Error and has a stack property,
		 * it's returned.  Otherwise, e is formatted using formatObject, with a
		 * warning added about e not being a proper Error.
		 * @param {*} e
		 * @returns {String} formatted string, suitable for output to developers
		 */function formatError(e){var s=(typeof e==="undefined"?"undefined":_typeof(e))==='object'&&e!==null&&(e.stack||e.message)?e.stack||e.message:formatObject(e);return e instanceof Error?s:s+' (WARNING: non-Error used)';}/**
		 * Format an object, detecting "plain" objects and running them through
		 * JSON.stringify if possible.
		 * @param {Object} o
		 * @returns {string}
		 */function formatObject(o){var s=String(o);if(s==='[object Object]'&&typeof JSON!=='undefined'){s=tryStringify(o,s);}return s;}/**
		 * Try to return the result of JSON.stringify(x).  If that fails, return
		 * defaultValue
		 * @param {*} x
		 * @param {*} defaultValue
		 * @returns {String|*} JSON.stringify(x) or defaultValue
		 */function tryStringify(x,defaultValue){try{return JSON.stringify(x);}catch(e){return defaultValue;}}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],153:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return function liftAll(liftOne,combine,dst,src){if(typeof combine==='undefined'){combine=defaultCombine;}return Object.keys(src).reduce(function(dst,key){var f=src[key];return typeof f==='function'?combine(dst,liftOne(f),key):dst;},typeof dst==='undefined'?defaultDst(src):dst);};function defaultCombine(o,f,k){o[k]=f;return o;}function defaultDst(src){return typeof src==='function'?src.bind():Object.create(src);}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],154:[function(require,module,exports){(function(process){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return function makePromise(environment){var tasks=environment.scheduler;var emitRejection=initEmitRejection();var objectCreate=Object.create||function(proto){function Child(){}Child.prototype=proto;return new Child();};/**
			 * Create a promise whose fate is determined by resolver
			 * @constructor
			 * @returns {Promise} promise
			 * @name Promise
			 */function Promise(resolver,handler){this._handler=resolver===Handler?handler:init(resolver);}/**
			 * Run the supplied resolver
			 * @param resolver
			 * @returns {Pending}
			 */function init(resolver){var handler=new Pending();try{resolver(promiseResolve,promiseReject,promiseNotify);}catch(e){promiseReject(e);}return handler;/**
				 * Transition from pre-resolution state to post-resolution state, notifying
				 * all listeners of the ultimate fulfillment or rejection
				 * @param {*} x resolution value
				 */function promiseResolve(x){handler.resolve(x);}/**
				 * Reject this promise with reason, which will be used verbatim
				 * @param {Error|*} reason rejection reason, strongly suggested
				 *   to be an Error type
				 */function promiseReject(reason){handler.reject(reason);}/**
				 * @deprecated
				 * Issue a progress event, notifying all progress listeners
				 * @param {*} x progress event payload to pass to all listeners
				 */function promiseNotify(x){handler.notify(x);}}// Creation
	Promise.resolve=resolve;Promise.reject=reject;Promise.never=never;Promise._defer=defer;Promise._handler=getHandler;/**
			 * Returns a trusted promise. If x is already a trusted promise, it is
			 * returned, otherwise returns a new trusted Promise which follows x.
			 * @param  {*} x
			 * @return {Promise} promise
			 */function resolve(x){return isPromise(x)?x:new Promise(Handler,new Async(getHandler(x)));}/**
			 * Return a reject promise with x as its reason (x is used verbatim)
			 * @param {*} x
			 * @returns {Promise} rejected promise
			 */function reject(x){return new Promise(Handler,new Async(new Rejected(x)));}/**
			 * Return a promise that remains pending forever
			 * @returns {Promise} forever-pending promise.
			 */function never(){return foreverPendingPromise;// Should be frozen
	}/**
			 * Creates an internal {promise, resolver} pair
			 * @private
			 * @returns {Promise}
			 */function defer(){return new Promise(Handler,new Pending());}// Transformation and flow control
	/**
			 * Transform this promise's fulfillment value, returning a new Promise
			 * for the transformed result.  If the promise cannot be fulfilled, onRejected
			 * is called with the reason.  onProgress *may* be called with updates toward
			 * this promise's fulfillment.
			 * @param {function=} onFulfilled fulfillment handler
			 * @param {function=} onRejected rejection handler
			 * @param {function=} onProgress @deprecated progress handler
			 * @return {Promise} new promise
			 */Promise.prototype.then=function(onFulfilled,onRejected,onProgress){var parent=this._handler;var state=parent.join().state();if(typeof onFulfilled!=='function'&&state>0||typeof onRejected!=='function'&&state<0){// Short circuit: value will not change, simply share handler
	return new this.constructor(Handler,parent);}var p=this._beget();var child=p._handler;parent.chain(child,parent.receiver,onFulfilled,onRejected,onProgress);return p;};/**
			 * If this promise cannot be fulfilled due to an error, call onRejected to
			 * handle the error. Shortcut for .then(undefined, onRejected)
			 * @param {function?} onRejected
			 * @return {Promise}
			 */Promise.prototype['catch']=function(onRejected){return this.then(void 0,onRejected);};/**
			 * Creates a new, pending promise of the same type as this promise
			 * @private
			 * @returns {Promise}
			 */Promise.prototype._beget=function(){return begetFrom(this._handler,this.constructor);};function begetFrom(parent,Promise){var child=new Pending(parent.receiver,parent.join().context);return new Promise(Handler,child);}// Array combinators
	Promise.all=all;Promise.race=race;Promise._traverse=traverse;/**
			 * Return a promise that will fulfill when all promises in the
			 * input array have fulfilled, or will reject when one of the
			 * promises rejects.
			 * @param {array} promises array of promises
			 * @returns {Promise} promise for array of fulfillment values
			 */function all(promises){return traverseWith(snd,null,promises);}/**
			 * Array<Promise<X>> -> Promise<Array<f(X)>>
			 * @private
			 * @param {function} f function to apply to each promise's value
			 * @param {Array} promises array of promises
			 * @returns {Promise} promise for transformed values
			 */function traverse(f,promises){return traverseWith(tryCatch2,f,promises);}function traverseWith(tryMap,f,promises){var handler=typeof f==='function'?mapAt:settleAt;var resolver=new Pending();var pending=promises.length>>>0;var results=new Array(pending);for(var i=0,x;i<promises.length&&!resolver.resolved;++i){x=promises[i];if(x===void 0&&!(i in promises)){--pending;continue;}traverseAt(promises,handler,i,x,resolver);}if(pending===0){resolver.become(new Fulfilled(results));}return new Promise(Handler,resolver);function mapAt(i,x,resolver){if(!resolver.resolved){traverseAt(promises,settleAt,i,tryMap(f,x,i),resolver);}}function settleAt(i,x,resolver){results[i]=x;if(--pending===0){resolver.become(new Fulfilled(results));}}}function traverseAt(promises,handler,i,x,resolver){if(maybeThenable(x)){var h=getHandlerMaybeThenable(x);var s=h.state();if(s===0){h.fold(handler,i,void 0,resolver);}else if(s>0){handler(i,h.value,resolver);}else{resolver.become(h);visitRemaining(promises,i+1,h);}}else{handler(i,x,resolver);}}Promise._visitRemaining=visitRemaining;function visitRemaining(promises,start,handler){for(var i=start;i<promises.length;++i){markAsHandled(getHandler(promises[i]),handler);}}function markAsHandled(h,handler){if(h===handler){return;}var s=h.state();if(s===0){h.visit(h,void 0,h._unreport);}else if(s<0){h._unreport();}}/**
			 * Fulfill-reject competitive race. Return a promise that will settle
			 * to the same state as the earliest input promise to settle.
			 *
			 * WARNING: The ES6 Promise spec requires that race()ing an empty array
			 * must return a promise that is pending forever.  This implementation
			 * returns a singleton forever-pending promise, the same singleton that is
			 * returned by Promise.never(), thus can be checked with ===
			 *
			 * @param {array} promises array of promises to race
			 * @returns {Promise} if input is non-empty, a promise that will settle
			 * to the same outcome as the earliest input promise to settle. if empty
			 * is empty, returns a promise that will never settle.
			 */function race(promises){if((typeof promises==="undefined"?"undefined":_typeof(promises))!=='object'||promises===null){return reject(new TypeError('non-iterable passed to race()'));}// Sigh, race([]) is untestable unless we return *something*
	// that is recognizable without calling .then() on it.
	return promises.length===0?never():promises.length===1?resolve(promises[0]):runRace(promises);}function runRace(promises){var resolver=new Pending();var i,x,h;for(i=0;i<promises.length;++i){x=promises[i];if(x===void 0&&!(i in promises)){continue;}h=getHandler(x);if(h.state()!==0){resolver.become(h);visitRemaining(promises,i+1,h);break;}else{h.visit(resolver,resolver.resolve,resolver.reject);}}return new Promise(Handler,resolver);}// Promise internals
	// Below this, everything is @private
	/**
			 * Get an appropriate handler for x, without checking for cycles
			 * @param {*} x
			 * @returns {object} handler
			 */function getHandler(x){if(isPromise(x)){return x._handler.join();}return maybeThenable(x)?getHandlerUntrusted(x):new Fulfilled(x);}/**
			 * Get a handler for thenable x.
			 * NOTE: You must only call this if maybeThenable(x) == true
			 * @param {object|function|Promise} x
			 * @returns {object} handler
			 */function getHandlerMaybeThenable(x){return isPromise(x)?x._handler.join():getHandlerUntrusted(x);}/**
			 * Get a handler for potentially untrusted thenable x
			 * @param {*} x
			 * @returns {object} handler
			 */function getHandlerUntrusted(x){try{var untrustedThen=x.then;return typeof untrustedThen==='function'?new Thenable(untrustedThen,x):new Fulfilled(x);}catch(e){return new Rejected(e);}}/**
			 * Handler for a promise that is pending forever
			 * @constructor
			 */function Handler(){}Handler.prototype.when=Handler.prototype.become=Handler.prototype.notify// deprecated
	=Handler.prototype.fail=Handler.prototype._unreport=Handler.prototype._report=noop;Handler.prototype._state=0;Handler.prototype.state=function(){return this._state;};/**
			 * Recursively collapse handler chain to find the handler
			 * nearest to the fully resolved value.
			 * @returns {object} handler nearest the fully resolved value
			 */Handler.prototype.join=function(){var h=this;while(h.handler!==void 0){h=h.handler;}return h;};Handler.prototype.chain=function(to,receiver,fulfilled,rejected,progress){this.when({resolver:to,receiver:receiver,fulfilled:fulfilled,rejected:rejected,progress:progress});};Handler.prototype.visit=function(receiver,fulfilled,rejected,progress){this.chain(failIfRejected,receiver,fulfilled,rejected,progress);};Handler.prototype.fold=function(f,z,c,to){this.when(new Fold(f,z,c,to));};/**
			 * Handler that invokes fail() on any handler it becomes
			 * @constructor
			 */function FailIfRejected(){}inherit(Handler,FailIfRejected);FailIfRejected.prototype.become=function(h){h.fail();};var failIfRejected=new FailIfRejected();/**
			 * Handler that manages a queue of consumers waiting on a pending promise
			 * @constructor
			 */function Pending(receiver,inheritedContext){Promise.createContext(this,inheritedContext);this.consumers=void 0;this.receiver=receiver;this.handler=void 0;this.resolved=false;}inherit(Handler,Pending);Pending.prototype._state=0;Pending.prototype.resolve=function(x){this.become(getHandler(x));};Pending.prototype.reject=function(x){if(this.resolved){return;}this.become(new Rejected(x));};Pending.prototype.join=function(){if(!this.resolved){return this;}var h=this;while(h.handler!==void 0){h=h.handler;if(h===this){return this.handler=cycle();}}return h;};Pending.prototype.run=function(){var q=this.consumers;var handler=this.handler;this.handler=this.handler.join();this.consumers=void 0;for(var i=0;i<q.length;++i){handler.when(q[i]);}};Pending.prototype.become=function(handler){if(this.resolved){return;}this.resolved=true;this.handler=handler;if(this.consumers!==void 0){tasks.enqueue(this);}if(this.context!==void 0){handler._report(this.context);}};Pending.prototype.when=function(continuation){if(this.resolved){tasks.enqueue(new ContinuationTask(continuation,this.handler));}else{if(this.consumers===void 0){this.consumers=[continuation];}else{this.consumers.push(continuation);}}};/**
			 * @deprecated
			 */Pending.prototype.notify=function(x){if(!this.resolved){tasks.enqueue(new ProgressTask(x,this));}};Pending.prototype.fail=function(context){var c=typeof context==='undefined'?this.context:context;this.resolved&&this.handler.join().fail(c);};Pending.prototype._report=function(context){this.resolved&&this.handler.join()._report(context);};Pending.prototype._unreport=function(){this.resolved&&this.handler.join()._unreport();};/**
			 * Wrap another handler and force it into a future stack
			 * @param {object} handler
			 * @constructor
			 */function Async(handler){this.handler=handler;}inherit(Handler,Async);Async.prototype.when=function(continuation){tasks.enqueue(new ContinuationTask(continuation,this));};Async.prototype._report=function(context){this.join()._report(context);};Async.prototype._unreport=function(){this.join()._unreport();};/**
			 * Handler that wraps an untrusted thenable and assimilates it in a future stack
			 * @param {function} then
			 * @param {{then: function}} thenable
			 * @constructor
			 */function Thenable(then,thenable){Pending.call(this);tasks.enqueue(new AssimilateTask(then,thenable,this));}inherit(Pending,Thenable);/**
			 * Handler for a fulfilled promise
			 * @param {*} x fulfillment value
			 * @constructor
			 */function Fulfilled(x){Promise.createContext(this);this.value=x;}inherit(Handler,Fulfilled);Fulfilled.prototype._state=1;Fulfilled.prototype.fold=function(f,z,c,to){runContinuation3(f,z,this,c,to);};Fulfilled.prototype.when=function(cont){runContinuation1(cont.fulfilled,this,cont.receiver,cont.resolver);};var errorId=0;/**
			 * Handler for a rejected promise
			 * @param {*} x rejection reason
			 * @constructor
			 */function Rejected(x){Promise.createContext(this);this.id=++errorId;this.value=x;this.handled=false;this.reported=false;this._report();}inherit(Handler,Rejected);Rejected.prototype._state=-1;Rejected.prototype.fold=function(f,z,c,to){to.become(this);};Rejected.prototype.when=function(cont){if(typeof cont.rejected==='function'){this._unreport();}runContinuation1(cont.rejected,this,cont.receiver,cont.resolver);};Rejected.prototype._report=function(context){tasks.afterQueue(new ReportTask(this,context));};Rejected.prototype._unreport=function(){if(this.handled){return;}this.handled=true;tasks.afterQueue(new UnreportTask(this));};Rejected.prototype.fail=function(context){this.reported=true;emitRejection('unhandledRejection',this);Promise.onFatalRejection(this,context===void 0?this.context:context);};function ReportTask(rejection,context){this.rejection=rejection;this.context=context;}ReportTask.prototype.run=function(){if(!this.rejection.handled&&!this.rejection.reported){this.rejection.reported=true;emitRejection('unhandledRejection',this.rejection)||Promise.onPotentiallyUnhandledRejection(this.rejection,this.context);}};function UnreportTask(rejection){this.rejection=rejection;}UnreportTask.prototype.run=function(){if(this.rejection.reported){emitRejection('rejectionHandled',this.rejection)||Promise.onPotentiallyUnhandledRejectionHandled(this.rejection);}};// Unhandled rejection hooks
	// By default, everything is a noop
	Promise.createContext=Promise.enterContext=Promise.exitContext=Promise.onPotentiallyUnhandledRejection=Promise.onPotentiallyUnhandledRejectionHandled=Promise.onFatalRejection=noop;// Errors and singletons
	var foreverPendingHandler=new Handler();var foreverPendingPromise=new Promise(Handler,foreverPendingHandler);function cycle(){return new Rejected(new TypeError('Promise cycle'));}// Task runners
	/**
			 * Run a single consumer
			 * @constructor
			 */function ContinuationTask(continuation,handler){this.continuation=continuation;this.handler=handler;}ContinuationTask.prototype.run=function(){this.handler.join().when(this.continuation);};/**
			 * Run a queue of progress handlers
			 * @constructor
			 */function ProgressTask(value,handler){this.handler=handler;this.value=value;}ProgressTask.prototype.run=function(){var q=this.handler.consumers;if(q===void 0){return;}for(var c,i=0;i<q.length;++i){c=q[i];runNotify(c.progress,this.value,this.handler,c.receiver,c.resolver);}};/**
			 * Assimilate a thenable, sending it's value to resolver
			 * @param {function} then
			 * @param {object|function} thenable
			 * @param {object} resolver
			 * @constructor
			 */function AssimilateTask(then,thenable,resolver){this._then=then;this.thenable=thenable;this.resolver=resolver;}AssimilateTask.prototype.run=function(){var h=this.resolver;tryAssimilate(this._then,this.thenable,_resolve,_reject,_notify);function _resolve(x){h.resolve(x);}function _reject(x){h.reject(x);}function _notify(x){h.notify(x);}};function tryAssimilate(then,thenable,resolve,reject,notify){try{then.call(thenable,resolve,reject,notify);}catch(e){reject(e);}}/**
			 * Fold a handler value with z
			 * @constructor
			 */function Fold(f,z,c,to){this.f=f;this.z=z;this.c=c;this.to=to;this.resolver=failIfRejected;this.receiver=this;}Fold.prototype.fulfilled=function(x){this.f.call(this.c,this.z,x,this.to);};Fold.prototype.rejected=function(x){this.to.reject(x);};Fold.prototype.progress=function(x){this.to.notify(x);};// Other helpers
	/**
			 * @param {*} x
			 * @returns {boolean} true iff x is a trusted Promise
			 */function isPromise(x){return x instanceof Promise;}/**
			 * Test just enough to rule out primitives, in order to take faster
			 * paths in some code
			 * @param {*} x
			 * @returns {boolean} false iff x is guaranteed *not* to be a thenable
			 */function maybeThenable(x){return((typeof x==="undefined"?"undefined":_typeof(x))==='object'||typeof x==='function')&&x!==null;}function runContinuation1(f,h,receiver,next){if(typeof f!=='function'){return next.become(h);}Promise.enterContext(h);tryCatchReject(f,h.value,receiver,next);Promise.exitContext();}function runContinuation3(f,x,h,receiver,next){if(typeof f!=='function'){return next.become(h);}Promise.enterContext(h);tryCatchReject3(f,x,h.value,receiver,next);Promise.exitContext();}/**
			 * @deprecated
			 */function runNotify(f,x,h,receiver,next){if(typeof f!=='function'){return next.notify(x);}Promise.enterContext(h);tryCatchReturn(f,x,receiver,next);Promise.exitContext();}function tryCatch2(f,a,b){try{return f(a,b);}catch(e){return reject(e);}}/**
			 * Return f.call(thisArg, x), or if it throws return a rejected promise for
			 * the thrown exception
			 */function tryCatchReject(f,x,thisArg,next){try{next.become(getHandler(f.call(thisArg,x)));}catch(e){next.become(new Rejected(e));}}/**
			 * Same as above, but includes the extra argument parameter.
			 */function tryCatchReject3(f,x,y,thisArg,next){try{f.call(thisArg,x,y,next);}catch(e){next.become(new Rejected(e));}}/**
			 * @deprecated
			 * Return f.call(thisArg, x), or if it throws, *return* the exception
			 */function tryCatchReturn(f,x,thisArg,next){try{next.notify(f.call(thisArg,x));}catch(e){next.notify(e);}}function inherit(Parent,Child){Child.prototype=objectCreate(Parent.prototype);Child.prototype.constructor=Child;}function snd(x,y){return y;}function noop(){}function hasCustomEvent(){if(typeof CustomEvent==='function'){try{var ev=new CustomEvent('unhandledRejection');return ev instanceof CustomEvent;}catch(ignoredException){}}return false;}function hasInternetExplorerCustomEvent(){if(typeof document!=='undefined'&&typeof document.createEvent==='function'){try{// Try to create one event to make sure it's supported
	var ev=document.createEvent('CustomEvent');ev.initCustomEvent('eventType',false,true,{});return true;}catch(ignoredException){}}return false;}function initEmitRejection(){/*global process, self, CustomEvent*/if(typeof process!=='undefined'&&process!==null&&typeof process.emit==='function'){// Returning falsy here means to call the default
	// onPotentiallyUnhandledRejection API.  This is safe even in
	// browserify since process.emit always returns falsy in browserify:
	// https://github.com/defunctzombie/node-process/blob/master/browser.js#L40-L46
	return function(type,rejection){return type==='unhandledRejection'?process.emit(type,rejection.value,rejection):process.emit(type,rejection);};}else if(typeof self!=='undefined'&&hasCustomEvent()){return function(self,CustomEvent){return function(type,rejection){var ev=new CustomEvent(type,{detail:{reason:rejection.value,key:rejection},bubbles:false,cancelable:true});return!self.dispatchEvent(ev);};}(self,CustomEvent);}else if(typeof self!=='undefined'&&hasInternetExplorerCustomEvent()){return function(self,document){return function(type,rejection){var ev=document.createEvent('CustomEvent');ev.initCustomEvent(type,false,true,{reason:rejection.value,key:rejection});return!self.dispatchEvent(ev);};}(self,document);}return noop;}return Promise;};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});}).call(this,require('_process'));},{"_process":110}],155:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){return{pending:toPendingState,fulfilled:toFulfilledState,rejected:toRejectedState,inspect:inspect};function toPendingState(){return{state:'pending'};}function toRejectedState(e){return{state:'rejected',reason:e};}function toFulfilledState(x){return{state:'fulfilled',value:x};}function inspect(handler){var state=handler.state();return state===0?toPendingState():state>0?toFulfilledState(handler.value):toRejectedState(handler.value);}});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],156:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var PromiseMonitor=require('./monitor/PromiseMonitor');var ConsoleReporter=require('./monitor/ConsoleReporter');var promiseMonitor=new PromiseMonitor(new ConsoleReporter());return function(Promise){return promiseMonitor.monitor(Promise);};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"./monitor/ConsoleReporter":157,"./monitor/PromiseMonitor":158}],157:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var error=require('./error');var unhandledRejectionsMsg='[promises] Unhandled rejections: ';var allHandledMsg='[promises] All previously unhandled rejections have now been handled';function ConsoleReporter(){this._previouslyReported=false;}ConsoleReporter.prototype=initDefaultLogging();ConsoleReporter.prototype.log=function(traces){if(traces.length===0){if(this._previouslyReported){this._previouslyReported=false;this.msg(allHandledMsg);}return;}this._previouslyReported=true;this.groupStart(unhandledRejectionsMsg+traces.length);try{this._log(traces);}finally{this.groupEnd();}};ConsoleReporter.prototype._log=function(traces){for(var i=0;i<traces.length;++i){this.warn(error.format(traces[i]));}};function initDefaultLogging(){/*jshint maxcomplexity:7*/var log,warn,groupStart,groupEnd;if(typeof console==='undefined'){log=warn=consoleNotAvailable;}else{// Alias console to prevent things like uglify's drop_console option from
	// removing console.log/error. Unhandled rejections fall into the same
	// category as uncaught exceptions, and build tools shouldn't silence them.
	var localConsole=console;if(typeof localConsole.error==='function'&&typeof localConsole.dir==='function'){warn=function warn(s){localConsole.error(s);};log=function log(s){localConsole.log(s);};if(typeof localConsole.groupCollapsed==='function'){groupStart=function groupStart(s){localConsole.groupCollapsed(s);};groupEnd=function groupEnd(){localConsole.groupEnd();};}}else{// IE8 has console.log and JSON, so we can make a
	// reasonably useful warn() from those.
	// Credit to webpro (https://github.com/webpro) for this idea
	// typeof localConsole.log will return 'object' in IE8, so can't test it with === 'function'
	// Since this is more of a corner case for IE8, I'm ok to check it with !== 'undefined' to reduce complexity
	if(typeof localConsole.log!=='undefined'&&typeof JSON!=='undefined'){log=warn=function warn(x){if(typeof x!=='string'){try{x=JSON.stringify(x);}catch(e){}}localConsole.log(x);};}else{log=warn=consoleNotAvailable;}}}return{msg:log,warn:warn,groupStart:groupStart||warn,groupEnd:groupEnd||consoleNotAvailable};}function consoleNotAvailable(){}return ConsoleReporter;});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"./error":160}],158:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var defaultStackJumpSeparator='from execution context:';var defaultStackFilter=/[\s\(\/\\](node|module|timers)\.js:|when([\/\\]{1,2}(lib|monitor|es6-shim)[\/\\]{1,2}|\.js)|(new\sPromise)\b|(\b(PromiseMonitor|ConsoleReporter|Scheduler|RunHandlerTask|ProgressTask|Promise|.*Handler)\.[\w_]\w\w+\b)|\b(tryCatch\w+|getHandler\w*)\b/i;var setTimer=require('../lib/env').setTimer;var error=require('./error');var executionContext=[];function PromiseMonitor(reporter){this.logDelay=0;this.stackFilter=defaultStackFilter;this.stackJumpSeparator=defaultStackJumpSeparator;this.filterDuplicateFrames=true;this._reporter=reporter;if(typeof reporter.configurePromiseMonitor==='function'){reporter.configurePromiseMonitor(this);}this._traces=[];this._traceTask=0;var self=this;this._doLogTraces=function(){self._logTraces();};}PromiseMonitor.prototype.monitor=function(Promise){var self=this;Promise.createContext=function(p,context){p.context=self.createContext(p,context);};Promise.enterContext=function(p){executionContext.push(p.context);};Promise.exitContext=function(){executionContext.pop();};Promise.onPotentiallyUnhandledRejection=function(rejection,extraContext){return self.addTrace(rejection,extraContext);};Promise.onPotentiallyUnhandledRejectionHandled=function(rejection){return self.removeTrace(rejection);};Promise.onFatalRejection=function(rejection,extraContext){return self.fatal(rejection,extraContext);};return this;};PromiseMonitor.prototype.createContext=function(at,parentContext){var context={parent:parentContext||executionContext[executionContext.length-1],stack:void 0};error.captureStack(context,at.constructor);return context;};PromiseMonitor.prototype.addTrace=function(handler,extraContext){var t,i;for(i=this._traces.length-1;i>=0;--i){t=this._traces[i];if(t.handler===handler){break;}}if(i>=0){t.extraContext=extraContext;}else{this._traces.push({handler:handler,extraContext:extraContext});}this.logTraces();};PromiseMonitor.prototype.removeTrace=function()/*handler*/{this.logTraces();};PromiseMonitor.prototype.fatal=function(handler,extraContext){var err=new Error();err.stack=this._createLongTrace(handler.value,handler.context,extraContext).join('\n');setTimer(function(){throw err;},0);};PromiseMonitor.prototype.logTraces=function(){if(!this._traceTask){this._traceTask=setTimer(this._doLogTraces,this.logDelay);}};PromiseMonitor.prototype._logTraces=function(){this._traceTask=void 0;this._traces=this._traces.filter(filterHandled);this._reporter.log(this.formatTraces(this._traces));};PromiseMonitor.prototype.formatTraces=function(traces){return traces.map(function(t){return this._createLongTrace(t.handler.value,t.handler.context,t.extraContext);},this);};PromiseMonitor.prototype._createLongTrace=function(e,context,extraContext){var trace=error.parse(e)||[String(e)+' (WARNING: non-Error used)'];trace=filterFrames(this.stackFilter,trace,0);this._appendContext(trace,context);this._appendContext(trace,extraContext);return this.filterDuplicateFrames?this._removeDuplicates(trace):trace;};PromiseMonitor.prototype._removeDuplicates=function(trace){var seen={};var sep=this.stackJumpSeparator;var count=0;return trace.reduceRight(function(deduped,line,i){if(i===0){deduped.unshift(line);}else if(line===sep){if(count>0){deduped.unshift(line);count=0;}}else if(!seen[line]){seen[line]=true;deduped.unshift(line);++count;}return deduped;},[]);};PromiseMonitor.prototype._appendContext=function(trace,context){trace.push.apply(trace,this._createTrace(context));};PromiseMonitor.prototype._createTrace=function(traceChain){var trace=[];var stack;while(traceChain){stack=error.parse(traceChain);if(stack){stack=filterFrames(this.stackFilter,stack);appendStack(trace,stack,this.stackJumpSeparator);}traceChain=traceChain.parent;}return trace;};function appendStack(trace,stack,separator){if(stack.length>1){stack[0]=separator;trace.push.apply(trace,stack);}}function filterFrames(stackFilter,stack){return stack.filter(function(frame){return!stackFilter.test(frame);});}function filterHandled(t){return!t.handler.handled;}return PromiseMonitor;});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"../lib/env":151,"./error":160}],159:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(require){var monitor=require('../monitor');var Promise=require('../when').Promise;return monitor(Promise);});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"../monitor":156,"../when":161}],160:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//** @author Brian Cavalier *//** @author John Hann */(function(define){'use strict';define(function(){var parse,captureStack,format;if(Error.captureStackTrace){// Use Error.captureStackTrace if available
	parse=function parse(e){return e&&e.stack&&e.stack.split('\n');};format=formatAsString;captureStack=Error.captureStackTrace;}else{// Otherwise, do minimal feature detection to determine
	// how to capture and format reasonable stacks.
	parse=function parse(e){var stack=e&&e.stack&&e.stack.split('\n');if(stack&&e.message){stack.unshift(e.message);}return stack;};(function(){var e=new Error();if(typeof e.stack!=='string'){format=formatAsString;captureStack=captureSpiderMonkeyStack;}else{format=formatAsErrorWithStack;captureStack=useStackDirectly;}})();}function captureSpiderMonkeyStack(host){try{throw new Error();}catch(err){host.stack=err.stack;}}function useStackDirectly(host){host.stack=new Error().stack;}function formatAsString(longTrace){return join(longTrace);}function formatAsErrorWithStack(longTrace){var e=new Error();e.stack=formatAsString(longTrace);return e;}// About 5-10x faster than String.prototype.join o_O
	function join(a){var sep=false;var s='';for(var i=0;i<a.length;++i){if(sep){s+='\n'+a[i];}else{s+=a[i];sep=true;}}return s;}return{parse:parse,format:format,captureStack:captureStack};});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory();});},{}],161:[function(require,module,exports){/** @license MIT License (c) copyright 2010-2014 original author or authors *//**
	 * Promises/A+ and when() implementation
	 * when is part of the cujoJS family of libraries (http://cujojs.com/)
	 * @author Brian Cavalier
	 * @author John Hann
	 */(function(define){'use strict';define(function(require){var timed=require('./lib/decorators/timed');var array=require('./lib/decorators/array');var flow=require('./lib/decorators/flow');var fold=require('./lib/decorators/fold');var inspect=require('./lib/decorators/inspect');var generate=require('./lib/decorators/iterate');var progress=require('./lib/decorators/progress');var withThis=require('./lib/decorators/with');var unhandledRejection=require('./lib/decorators/unhandledRejection');var TimeoutError=require('./lib/TimeoutError');var Promise=[array,flow,fold,generate,progress,inspect,withThis,timed,unhandledRejection].reduce(function(Promise,feature){return feature(Promise);},require('./lib/Promise'));var apply=require('./lib/apply')(Promise);// Public API
	when.promise=promise;// Create a pending promise
	when.resolve=Promise.resolve;// Create a resolved promise
	when.reject=Promise.reject;// Create a rejected promise
	when.lift=lift;// lift a function to return promises
	when['try']=attempt;// call a function and return a promise
	when.attempt=attempt;// alias for when.try
	when.iterate=Promise.iterate;// DEPRECATED (use cujojs/most streams) Generate a stream of promises
	when.unfold=Promise.unfold;// DEPRECATED (use cujojs/most streams) Generate a stream of promises
	when.join=join;// Join 2 or more promises
	when.all=all;// Resolve a list of promises
	when.settle=settle;// Settle a list of promises
	when.any=lift(Promise.any);// One-winner race
	when.some=lift(Promise.some);// Multi-winner race
	when.race=lift(Promise.race);// First-to-settle race
	when.map=map;// Array.map() for promises
	when.filter=filter;// Array.filter() for promises
	when.reduce=lift(Promise.reduce);// Array.reduce() for promises
	when.reduceRight=lift(Promise.reduceRight);// Array.reduceRight() for promises
	when.isPromiseLike=isPromiseLike;// Is something promise-like, aka thenable
	when.Promise=Promise;// Promise constructor
	when.defer=defer;// Create a {promise, resolve, reject} tuple
	// Error types
	when.TimeoutError=TimeoutError;/**
		 * Get a trusted promise for x, or by transforming x with onFulfilled
		 *
		 * @param {*} x
		 * @param {function?} onFulfilled callback to be called when x is
		 *   successfully fulfilled.  If promiseOrValue is an immediate value, callback
		 *   will be invoked immediately.
		 * @param {function?} onRejected callback to be called when x is
		 *   rejected.
		 * @param {function?} onProgress callback to be called when progress updates
		 *   are issued for x. @deprecated
		 * @returns {Promise} a new promise that will fulfill with the return
		 *   value of callback or errback or the completion value of promiseOrValue if
		 *   callback and/or errback is not supplied.
		 */function when(x,onFulfilled,onRejected,onProgress){var p=Promise.resolve(x);if(arguments.length<2){return p;}return p.then(onFulfilled,onRejected,onProgress);}/**
		 * Creates a new promise whose fate is determined by resolver.
		 * @param {function} resolver function(resolve, reject, notify)
		 * @returns {Promise} promise whose fate is determine by resolver
		 */function promise(resolver){return new Promise(resolver);}/**
		 * Lift the supplied function, creating a version of f that returns
		 * promises, and accepts promises as arguments.
		 * @param {function} f
		 * @returns {Function} version of f that returns promises
		 */function lift(f){return function(){for(var i=0,l=arguments.length,a=new Array(l);i<l;++i){a[i]=arguments[i];}return apply(f,this,a);};}/**
		 * Call f in a future turn, with the supplied args, and return a promise
		 * for the result.
		 * @param {function} f
		 * @returns {Promise}
		 */function attempt(f/*, args... */){/*jshint validthis:true */for(var i=0,l=arguments.length-1,a=new Array(l);i<l;++i){a[i]=arguments[i+1];}return apply(f,this,a);}/**
		 * Creates a {promise, resolver} pair, either or both of which
		 * may be given out safely to consumers.
		 * @return {{promise: Promise, resolve: function, reject: function, notify: function}}
		 */function defer(){return new Deferred();}function Deferred(){var p=Promise._defer();function resolve(x){p._handler.resolve(x);}function reject(x){p._handler.reject(x);}function notify(x){p._handler.notify(x);}this.promise=p;this.resolve=resolve;this.reject=reject;this.notify=notify;this.resolver={resolve:resolve,reject:reject,notify:notify};}/**
		 * Determines if x is promise-like, i.e. a thenable object
		 * NOTE: Will return true for *any thenable object*, and isn't truly
		 * safe, since it may attempt to access the `then` property of x (i.e.
		 *  clever/malicious getters may do weird things)
		 * @param {*} x anything
		 * @returns {boolean} true if x is promise-like
		 */function isPromiseLike(x){return x&&typeof x.then==='function';}/**
		 * Return a promise that will resolve only once all the supplied arguments
		 * have resolved. The resolution value of the returned promise will be an array
		 * containing the resolution values of each of the arguments.
		 * @param {...*} arguments may be a mix of promises and values
		 * @returns {Promise}
		 */function join()/* ...promises */{return Promise.all(arguments);}/**
		 * Return a promise that will fulfill once all input promises have
		 * fulfilled, or reject when any one input promise rejects.
		 * @param {array|Promise} promises array (or promise for an array) of promises
		 * @returns {Promise}
		 */function all(promises){return when(promises,Promise.all);}/**
		 * Return a promise that will always fulfill with an array containing
		 * the outcome states of all input promises.  The returned promise
		 * will only reject if `promises` itself is a rejected promise.
		 * @param {array|Promise} promises array (or promise for an array) of promises
		 * @returns {Promise} promise for array of settled state descriptors
		 */function settle(promises){return when(promises,Promise.settle);}/**
		 * Promise-aware array map function, similar to `Array.prototype.map()`,
		 * but input array may contain promises or values.
		 * @param {Array|Promise} promises array of anything, may contain promises and values
		 * @param {function(x:*, index:Number):*} mapFunc map function which may
		 *  return a promise or value
		 * @returns {Promise} promise that will fulfill with an array of mapped values
		 *  or reject if any input promise rejects.
		 */function map(promises,mapFunc){return when(promises,function(promises){return Promise.map(promises,mapFunc);});}/**
		 * Filter the provided array of promises using the provided predicate.  Input may
		 * contain promises and values
		 * @param {Array|Promise} promises array of promises and values
		 * @param {function(x:*, index:Number):boolean} predicate filtering predicate.
		 *  Must return truthy (or promise for truthy) for items to retain.
		 * @returns {Promise} promise that will fulfill with an array containing all items
		 *  for which predicate returned truthy.
		 */function filter(promises,predicate){return when(promises,function(promises){return Promise.filter(promises,predicate);});}return when;});})(typeof define==='function'&&define.amd?define:function(factory){module.exports=factory(require);});},{"./lib/Promise":138,"./lib/TimeoutError":140,"./lib/apply":141,"./lib/decorators/array":142,"./lib/decorators/flow":143,"./lib/decorators/fold":144,"./lib/decorators/inspect":145,"./lib/decorators/iterate":146,"./lib/decorators/progress":147,"./lib/decorators/timed":148,"./lib/decorators/unhandledRejection":149,"./lib/decorators/with":150}],162:[function(require,module,exports){module.exports={"name":"autobahn","version":"17.5.2","description":"An implementation of The Web Application Messaging Protocol (WAMP).","main":"index.js","scripts":{"test":"nodeunit test/test.js"},"engines":{"node":">= 4.2.6"},"dependencies":{"crypto-js":">= 3.1.8","int64-buffer":">= 0.1.9","msgpack-lite":">= 0.1.26","cbor":">= 3.0.0","tweetnacl":">= 0.14.3","when":">= 3.7.7","ws":">= 1.1.4"},"optionalDependencies":{"bufferutil":">= 1.2.1","utf-8-validate":">= 1.2.1"},"devDependencies":{"browserify":">= 13.1.1","deep-equal":">= 1.0.1","google-closure-compiler":"^20170218.0.0","nodeunit":">= 0.10.2"},"browser":{"ws":false,"lib/transport/rawsocket.js":false},"repository":{"type":"git","url":"git://github.com/crossbario/autobahn-js.git"},"keywords":["WAMP","WebSocket","RPC","PubSub"],"author":"Crossbar.io Technologies GmbH","license":"MIT"};},{}]},{},[4])(4);});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(92).Buffer, __webpack_require__(725).setImmediate))

/***/ }),

/***/ 789:
/***/ (function(module, exports) {

	'use strict';
	
	// 🍂class Marker
	L.Marker.include({
	
	    _slideToUntil: undefined,
	    _slideToDuration: undefined,
	    _slideToLatLng: undefined,
	    _slideFromLatLng: undefined,
	
	    // 🍂method slideTo(latlng: LatLng, options: Slide Options): this
	    // Moves this marker until `latlng`, like `setLatLng()`, but with a smooth
	    // sliding animation. Fires `movestart` and `moveend` events.
	    slideTo: function slideTo(latlng, options) {
	        if (!this._map) return;
	        this._isZooming = false;
	        this._slideToDuration = options.duration;
	        this._slideToUntil = performance.now() + options.duration;
	        this._slideFromLatLng = this.getLatLng();
	        this._slideToLatLng = latlng;
	
	        this.fire('movestart');
	        this._slideTo();
	
	        return this;
	    },
	
	    // 🍂method slideCancel(): this
	    // Cancels the sliding animation from `slideTo`, if applicable.
	    slideCancel: function slideCancel() {
	        L.Util.cancelAnimFrame(this._slideFrame);
	    },
	
	    _slideTo: function _slideTo() {
	        if (!this._map) return;
	        if (this._isZooming) {
	            this._slideFrame = L.Util.requestAnimFrame(this._slideTo, this);
	            return;
	        };
	
	        this._remaining = this._slideToUntil - performance.now();
	
	        if (this._remaining < 0) {
	            this.setLatLng(this._slideToLatLng);
	            this.fire('moveend');
	
	            return this;
	        }
	
	        var startPoint = this._map.latLngToContainerPoint(this._slideFromLatLng);
	        var endPoint = this._map.latLngToContainerPoint(this._slideToLatLng);
	        var percentDone = (this._slideToDuration - this._remaining) / this._slideToDuration;
	
	        var currPoint = endPoint.multiplyBy(percentDone).add(startPoint.multiplyBy(1 - percentDone));
	        var currLatLng = this._map.containerPointToLatLng(currPoint);
	        this.setLatLng(currLatLng);
	
	        this.fire('move', { latlng: currLatLng });
	
	        this._slideFrame = L.Util.requestAnimFrame(this._slideTo, this);
	    },
	
	    onAdd: function onAdd(map) {
	        this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
	        if (this._zoomAnimated) {
	            map.on('zoomanim', this._animateZoom, this);
	        }
	
	        // Fix for skipping the marker calculation when zooming
	        map.on('zoomstart', this._onZoom, this);
	        map.on('zoomend reset moveend', this._offZoom, this);
	
	        this._initIcon();
	        this.update();
	    },
	
	    onRemove: function onRemove(map) {
	        if (this.dragging && this.dragging.enabled()) {
	            this.options.draggable = true;
	            this.dragging.removeHooks();
	        }
	
	        if (this._zoomAnimated) {
	            map.off('zoomanim', this._animateZoom, this);
	        }
	
	        map.off('zoomstart', this._onZoom);
	        map.off('zoomend reset moveend', this._offZoom);
	
	        this._removeIcon();
	        this._removeShadow();
	    },
	
	    _onZoom: function _onZoom() {
	        this._isZooming = true;
	    },
	
	    _offZoom: function _offZoom() {
	        this._isZooming = false;
	    }
	
	});
	
	L.Marker.addInitHook(function () {
	    this.on('move', this.slideCancel, this);
	});
	
	/*
	🍂miniclass Slide options (Marker)
	🍂section
	
	🍂option duration: Number = 1000
	Duration of the sliding animation, in milliseconds.
	
	🍂option keepAtCenter: Boolean = false
	Whether the map center should be the marker's position during the sliding animation.
	This disables the map dragging handler and touch zoom centering momentarily.
	
	*/
	
	// 🍂class CircleMarker
	L.CircleMarker.include({
	    // 🍂method slideTo(latlng: LatLng, options: Slide Options): this
	    // Moves this circle until `latlng`, like `setLatLng()`, but with a smooth
	    // sliding animation. Fires `movestart` and `moveend` events.
	    slideTo: L.Marker.prototype.slideTo,
	    // 🍂method slideCancel(): this
	    // Cancels the sliding animation from `slideTo`, if applicable.
	    slideCancel: L.Marker.prototype.slideCancel,
	    _slideTo: L.Marker.prototype._slideTo
	});
	
	L.CircleMarker.addInitHook(function () {
	    this.on('move', this.slideCancel, this);
	});

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _api = __webpack_require__(15);
	
	var _formats = __webpack_require__(22);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Autobahn = __webpack_require__(788);
	var _ = __webpack_require__(1271);
	var debug = __webpack_require__(1059);
	var $ = __webpack_require__(40);
	var log = debug('wsrpc');
	var moment = __webpack_require__(1);
	
	var WebSocketTransport = function () {
	    function WebSocketTransport(options) {
	        var _this = this;
	
	        _classCallCheck(this, WebSocketTransport);
	
	        this.__connection = new Autobahn.Connection(options.ws);
	
	        this.__cycle = null;
	        this.__session = null;
	        this.__subscriptions = [];
	        this.__subscriptionObjects = {};
	        this.__subscribed = [];
	        this.__unsubscribed = [];
	        this.__onEstablished = [];
	        this.__onLost = [];
	        this.__connectionEstablished = function () {};
	
	        this.setToken(options.token || null);
	
	        this.__connection.onopen = function (session, details) {
	            _this.__session = session;
	
	            _this.__subscribed = _.clone(_this.__unsubscribed);
	
	            _this.subscribe();
	
	            // engage promise
	            _this.connectionEstablished();
	
	            _.forEach(_this.__onEstablished, function (callback) {
	                callback();
	            });
	
	            log('WebSocket: Connection established');
	
	            if (!_this.__cycle) {
	                _this.__cycle = new _api.CycleFetch(function () {
	                    return _this.request('healthcheck', {}, {});
	                }, function () {}, 15000);
	                _this.__cycle.run();
	            }
	        };
	
	        this.__connection.onclose = function (reason, details) {
	            _this.__session = null;
	
	            for (var i in _.reverse(_this.__onLost)) {
	                _this.__onLost[i](reason);
	            }
	
	            // engage promise
	            _this.connectionEstablished();
	
	            log('WebSocket: Connection lost, reason:', reason);
	        };
	    }
	
	    _createClass(WebSocketTransport, [{
	        key: 'connectionEstablished',
	        value: function connectionEstablished() {
	            if (_.isFunction(this.__connectionEstablished)) {
	                this.__connectionEstablished();
	            }
	        }
	    }, {
	        key: 'onEstablished',
	        value: function onEstablished(callback) {
	            this.__onEstablished.push(callback);
	        }
	    }, {
	        key: 'onLost',
	        value: function onLost(callback) {
	            this.__onLost.push(callback);
	        }
	    }, {
	        key: 'setToken',
	        value: function setToken(token) {
	            this.__token = token;
	        }
	    }, {
	        key: 'subscribe',
	        value: function subscribe() {
	            var _this2 = this;
	
	            if (!this.__session) {
	                return;
	            }
	
	            _.forEach(this.__subscriptions, function () {
	                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(subscription, i) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    if (!(_.indexOf(_this2.__subscribed, i) > -1)) {
	                                        _context.next = 2;
	                                        break;
	                                    }
	
	                                    return _context.abrupt('return');
	
	                                case 2:
	
	                                    log('WebSocket: Subscribing', subscription.subject);
	
	                                    _context.next = 5;
	                                    return _this2.__session.subscribe(subscription.subject, function (args) {
	                                        subscription.handler(args[0]);
	                                    }, {
	                                        filter: subscription.filter,
	                                        token: _this2.__token
	                                    });
	
	                                case 5:
	                                    _this2.__subscriptionObjects[i] = _context.sent;
	
	
	                                    _this2.__subscribed.push(i);
	
	                                case 7:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x, _x2) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	        }
	    }, {
	        key: 'unsubscribe',
	        value: function unsubscribe(subject) {
	            var _this3 = this;
	
	            _.forEach(this.__subscriptions, function (subscription, i) {
	                if (subscription.subject === subject) {
	                    if (_.indexOf(_this3.__unsubscribed, i) > -1) {
	                        return;
	                    }
	                    _this3.__unsubscribed.push(i);
	                }
	            });
	            _.forEach(this.__session.subscriptions, function (subscriptions) {
	                _.forEach(subscriptions, function (subscription) {
	                    if (subscription.topic !== subject) {
	                        return;
	                    }
	
	                    if (subscription && subscription.active) {
	                        _this3.__session.unsubscribe(subscription);
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'connect',
	        value: function connect() {
	            var _this4 = this;
	
	            this.__connectPromise = new Promise(function (resolve) {
	                _this4.__connectionEstablished = resolve;
	                _this4.__connection.open();
	            });
	
	            return this.__connectPromise;
	        }
	    }, {
	        key: 'request',
	        value: function request(subject, headers, payload) {
	            log('WebSocket: Performing', subject, 'with', headers, payload);
	
	            if (this.__token) {
	                headers.token = this.__token;
	            }
	
	            headers.timestamp = moment().format(_formats2.default.DATETIME_API);
	
	            return this.__session.call('com.rnis.wsrpc.action.request', [JSON.stringify({
	                subject: subject,
	                body: JSON.stringify({
	                    headers: headers,
	                    payload: payload
	                })
	            })]).then(function (response) {
	                response = JSON.parse(response);
	                log('WebSocket: Request', subject, 'response:', response);
	
	                if (_.size(response.errors) > 0) {
	                    return Promise.reject(response);
	                } else {
	                    return Promise.resolve(response);
	                }
	            });
	        }
	    }, {
	        key: 'isAvailable',
	        value: function isAvailable() {
	            return this.__connection.isOpen;
	        }
	    }, {
	        key: 'subscriptions',
	        set: function set(subscriptions) {
	            this.__subscriptions = subscriptions;
	        }
	    }]);
	
	    return WebSocketTransport;
	}();
	
	var AjaxTransport = function () {
	    function AjaxTransport(options) {
	        _classCallCheck(this, AjaxTransport);
	
	        this.__xhrs = {};
	
	        this.__isEnabled = false;
	        this.__options = options;
	
	        this.setToken(options.token || null);
	    }
	
	    _createClass(AjaxTransport, [{
	        key: 'cancelRequests',
	        value: function cancelRequests(cancelConditionsArgument, xhr) {
	            if (this.__xhrs[cancelConditionsArgument]) {
	                this.__xhrs[cancelConditionsArgument].abort(); //abort request if conditions met
	            }
	            this.__xhrs[cancelConditionsArgument] = xhr; // add request to xhrs object
	        }
	    }, {
	        key: 'request',
	        value: function request(subject, headers, payload, cancelConditions) {
	            var _this5 = this;
	
	            return new Promise(function (resolve, reject) {
	                log('AJAX: Performing', subject);
	
	                if (_this5.__token) {
	                    headers.token = _this5.__token;
	                }
	
	                var xhr = $.ajax(_this5.__options.ajax.url + '/request?' + subject, {
	                    method: 'POST',
	                    headers: {
	                        'Subject': subject
	                    },
	                    data: JSON.stringify({
	                        headers: headers,
	                        payload: payload
	                    }),
	                    dataType: 'json',
	                    success: function success(response) {
	                        if (_.size(response.errors) > 0) {
	                            reject(response);
	                        } else {
	                            resolve(response);
	                        }
	                    }
	                });
	                if (cancelConditions) {
	                    if (!cancelConditions.argument) {
	                        console.error('You must set cancelConditions argument on subject ' + subject + ', to cancel repeating requests');
	                    }
	                    _this5.cancelRequests(cancelConditions.argument, xhr); // cancel requests on conditions
	                }
	            });
	        }
	    }, {
	        key: 'subscribe',
	        value: function subscribe(subscriptions) {
	            var _this6 = this;
	
	            // Seems like other transport is up, stop subscribing
	            if (this.__isEnabled === false) {
	                return;
	            }
	
	            subscriptions = _.groupBy(subscriptions, 'subject');
	
	            $.ajax(this.__options.ajax.url + '/subscribe', {
	                method: 'POST',
	                dataType: 'json',
	                headers: {
	                    'Subject': subjects
	                },
	                success: function success(event, status, xhr) {
	                    // In case of no content response
	                    // And also checking if other transport is up already
	                    if (xhr.status !== 204 && _this6.__isEnabled === true) {
	                        // Call specific handler
	                        var _subjects = _.get(subscriptions, event.subject, []);
	
	                        _.forEach(_subjects, function (subject) {
	                            subject.handler(event.body);
	                        });
	                    }
	                },
	                complete: function complete(xhr) {
	                    if (xhr.status !== 204 && xhr.status !== 200) {
	                        // Deny spam in case of error
	                        setTimeout(function () {
	                            _this6.subscribe(subscriptions);
	                        }, _this6.__options.ajax.retry_timeout * 1000);
	
	                        return;
	                    }
	
	                    _this6.subscribe(subscriptions);
	                }
	            });
	        }
	    }, {
	        key: 'fallbackSubscribes',
	        value: function fallbackSubscribes(subscriptions) {
	            // Deny cycling on connection retries
	            if (this.__isEnabled === true) {
	                return;
	            }
	
	            this.__isEnabled = true;
	
	            log('AJAX: Subscribing', Object.keys(subscriptions));
	
	            this.subscribe(subscriptions);
	        }
	    }, {
	        key: 'setToken',
	        value: function setToken(token) {
	            this.__token = token;
	        }
	    }, {
	        key: 'isEnabled',
	        set: function set(isEnabled) {
	            this.__isEnabled = isEnabled;
	        }
	    }]);
	
	    return AjaxTransport;
	}();
	
	var WsRpc = function () {
	    function WsRpc(options) {
	        var _this7 = this;
	
	        _classCallCheck(this, WsRpc);
	
	        this.__webSocket = new WebSocketTransport({
	            token: options.token,
	            ws: options.ws
	        });
	
	        this.__ajax = new AjaxTransport({
	            token: options.token,
	            ajax: options.ajax
	        });
	
	        this.__subscriptions = [];
	
	        this.onEstablished(function () {
	            _this7.__ajax.isEnabled = false;
	        });
	
	        this.onLost(function () {
	            log('Connection lost, reason:', reason);
	            _this7.__ajax.fallbackSubscribes(_this7.__subscriptions);
	        });
	    }
	
	    _createClass(WsRpc, [{
	        key: 'connect',
	        value: function connect() {
	            return this.__webSocket.connect();
	        }
	    }, {
	        key: 'subscribe',
	        value: function subscribe(subject, handler) {
	            var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            this.__subscriptions.push({
	                subject: subject, handler: handler, filter: filter
	            });
	
	            this.__webSocket.subscriptions = this.__subscriptions;
	
	            // Resubscribe immediately if possible,
	            // otherwise it is done on connection establishment
	            if (this.__webSocket.isAvailable()) {
	                this.__webSocket.subscribe();
	            }
	        }
	    }, {
	        key: 'unsubscribe',
	        value: function unsubscribe(subject) {
	            if (this.__webSocket.isAvailable()) {
	                this.__webSocket.unsubscribe(subject);
	            }
	        }
	    }, {
	        key: 'ajaxRequest',
	        value: function ajaxRequest(subject, payload) {
	            var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { meta: {} };
	
	            return this.__ajax.request(subject, headers, payload);
	        }
	    }, {
	        key: 'wsRequest',
	        value: function wsRequest(subject, payload) {
	            var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { meta: {} };
	
	            return this.__webSocket.request(subject, headers, payload);
	        }
	    }, {
	        key: 'request',
	        value: function request(subject) {
	            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { meta: {} };
	            var cancelConditions = arguments[3];
	
	            return this.__ajax.request(subject, headers, payload, cancelConditions);
	
	            if (this.__webSocket.isAvailable()) {
	                return this.__webSocket.request(subject, headers, payload);
	            } else {
	                return this.__ajax.request(subject, headers, payload);
	            }
	        }
	    }, {
	        key: 'setToken',
	        value: function setToken(token) {
	            this.__ajax.setToken(token);
	            this.__webSocket.setToken(token);
	        }
	    }, {
	        key: 'onEstablished',
	        value: function onEstablished(callback) {
	            this.__webSocket.onEstablished(callback);
	        }
	    }, {
	        key: 'onLost',
	        value: function onLost(callback) {
	            this.__webSocket.onLost(callback);
	        }
	    }]);
	
	    return WsRpc;
	}();
	
	exports.default = WsRpc;
	;

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(244);
	
	var _reducers = __webpack_require__(795);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxLogger = __webpack_require__(1479);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reduxThunk = __webpack_require__(1480);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	    var logger = (0, _reduxLogger2.default)();
	    var store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default, logger));
	
	    if (false) {
	        module.hot.accept('./reducers', function () {
	            var nextRootReducer = require('./reducers').default;
	            console.log('inject next root reducer', nextRootReducer);
	            store.replaceReducer(nextRootReducer);
	        });
	    }
	
	    return store;
	}

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCaptcha = exports.sendFeedback = undefined;
	exports.default = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var initialState = new _immutable.Map({});
	
	function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {}
	
	    return state;
	}
	
	var sendFeedback = exports.sendFeedback = function sendFeedback(data) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.portal.sendFeedback(data);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getCaptcha = exports.getCaptcha = function getCaptcha() {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.portal.getCaptcha();
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.portalScheduleRoute = exports.portalScheduleExtended = exports.portalSchedule = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var portalSchedule = exports.portalSchedule = function portalSchedule(number, date) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.geo.portalSchedule(number, date);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var portalScheduleExtended = exports.portalScheduleExtended = function portalScheduleExtended(number, date, from, to) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.geo.portalScheduleExtended(number, date, from, to);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x2) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var portalScheduleRoute = exports.portalScheduleRoute = function portalScheduleRoute(orderRunUuid) {
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _api.api.geo.portalScheduleRoute(orderRunUuid);
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](0);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.listUserGeoObjectsMO = exports.listUserGeoObjectsByLayers = exports.listLayers = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var listLayers = exports.listLayers = function listLayers() {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.geo.listLayers();
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var listUserGeoObjectsByLayers = exports.listUserGeoObjectsByLayers = function listUserGeoObjectsByLayers(layers) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.geo.listUserGeoObjectsByLayers(layers);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x2) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var listUserGeoObjectsMO = exports.listUserGeoObjectsMO = function listUserGeoObjectsMO(meta) {
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            console.log(meta);
	                            _context3.prev = 1;
	                            _context3.next = 4;
	                            return _api.api.geo.listUserGeoObjectsMO(meta);
	
	                        case 4:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 8:
	                            _context3.prev = 8;
	                            _context3.t0 = _context3['catch'](1);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 11:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[1, 8]]);
	        }));
	
	        return function (_x3) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(244);
	
	var _main = __webpack_require__(386);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _maps = __webpack_require__(387);
	
	var _maps2 = _interopRequireDefault(_maps);
	
	var _index = __webpack_require__(799);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _menu = __webpack_require__(388);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _news = __webpack_require__(99);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _pages = __webpack_require__(390);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _auth = __webpack_require__(383);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	    main: _main2.default,
	    maps: _maps2.default,
	    menu: _menu2.default,
	    auth: _auth2.default,
	    vehicles: _index2.default,
	    news: _news2.default,
	    pages: _pages2.default
	});

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTasksGuests = exports.getGeometryFromContract = exports.getTasks = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getTasks = exports.getTasks = function getTasks() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.kurs.getTasks(meta);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	
	var getGeometryFromContract = exports.getGeometryFromContract = function getGeometryFromContract() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var token = arguments[2];
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.kurs.getGeometryFromContract(meta, {}, token);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x5) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	var getTasksGuests = exports.getTasksGuests = function getTasksGuests() {
	    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var token = arguments[2];
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _api.api.kurs.getTasksGuests(meta, {}, token);
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](0);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x8) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loginRegisterRequest = exports.updateRegisterRequest = exports.getRegisterRequest = exports.createRegisterRequest = exports.checkRegisterRequestCreate = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var checkRegisterRequestCreate = exports.checkRegisterRequestCreate = function checkRegisterRequestCreate(data) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.portal.checkRegisterRequestCreate(data);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};
	var createRegisterRequest = exports.createRegisterRequest = function createRegisterRequest(data) {
	    return function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _api.api.portal.createRegisterRequest(data);
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2['catch'](0);
	                            return _context2.abrupt('return', (0, _response.error)(_context2.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }));
	
	        return function (_x2) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	var getRegisterRequest = exports.getRegisterRequest = function getRegisterRequest(uuid) {
	    return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _api.api.portal.getRegisterRequest(uuid);
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](0);
	                            return _context3.abrupt('return', (0, _response.error)(_context3.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x3) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};
	
	var updateRegisterRequest = exports.updateRegisterRequest = function updateRegisterRequest(data) {
	    return function () {
	        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	                            _context4.next = 3;
	                            return _api.api.portal.updateRegisterRequest(data);
	
	                        case 3:
	                            response = _context4.sent;
	                            return _context4.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context4.prev = 7;
	                            _context4.t0 = _context4['catch'](0);
	                            return _context4.abrupt('return', (0, _response.error)(_context4.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined, [[0, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	};
	
	var loginRegisterRequest = exports.loginRegisterRequest = function loginRegisterRequest(data) {
	    return function () {
	        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.prev = 0;
	                            _context5.next = 3;
	                            return _api.api.portal.loginRegisterRequest(data);
	
	                        case 3:
	                            response = _context5.sent;
	                            return _context5.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context5.prev = 7;
	                            _context5.t0 = _context5['catch'](0);
	                            return _context5.abrupt('return', (0, _response.error)(_context5.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined, [[0, 7]]);
	        }));
	
	        return function (_x5) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTabletWorkSummary = undefined;
	
	var _api = __webpack_require__(15);
	
	var _response = __webpack_require__(23);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getTabletWorkSummary = exports.getTabletWorkSummary = function getTabletWorkSummary(meta) {
	    return function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _api.api.reports.getTabletWorkSummary(meta);
	
	                        case 3:
	                            response = _context.sent;
	                            return _context.abrupt('return', (0, _response.success)(response));
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](0);
	                            return _context.abrupt('return', (0, _response.error)(_context.t0));
	
	                        case 10:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 7]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	};

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(244);
	
	var _vehicles = __webpack_require__(391);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	    vehicles: _vehicles2.default
	});

/***/ }),

/***/ 1071:
447,

/***/ 1072:
447,

/***/ 1073:
447,

/***/ 1074:
447,

/***/ 1075:
447,

/***/ 1076:
447,

/***/ 1077:
447,

/***/ 1078:
447,

/***/ 1079:
447,

/***/ 1080:
447,

/***/ 1081:
447,

/***/ 1082:
447,

/***/ 1083:
447,

/***/ 1084:
447,

/***/ 1085:
447,

/***/ 1086:
447,

/***/ 1087:
447,

/***/ 1088:
447,

/***/ 1089:
447,

/***/ 1090:
447,

/***/ 1091:
447,

/***/ 1092:
447,

/***/ 1093:
447,

/***/ 1094:
447,

/***/ 1095:
447,

/***/ 1096:
447,

/***/ 1097:
447,

/***/ 1098:
447,

/***/ 1099:
447,

/***/ 1100:
447,

/***/ 1101:
447,

/***/ 1102:
447,

/***/ 1103:
447,

/***/ 1104:
447,

/***/ 1105:
447,

/***/ 1106:
447,

/***/ 1107:
447,

/***/ 1108:
447,

/***/ 1109:
447,

/***/ 1110:
447,

/***/ 1111:
447,

/***/ 1112:
447,

/***/ 1113:
447,

/***/ 1499:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 1500:
1499

});


// WEBPACK FOOTER //
// static/bundle.main.d4dfbb0a7c680da78d04.js